(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._unmatchedHeader_qcj19_1{opacity:.55}._wrapper_1lmim_1{margin-bottom:var(--dixa-size-spacer-300)}._wrapperBox_1lmim_4{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._wrapperBoxErrorBorder_1lmim_9{border-color:var(--dixa-typography-color-error)}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { isRunningLocalPartnerApi as LI, getPartnerDevApiHeaders as VI, WidgetContextProvider as zI, makeExecuteQuery as UI, makeUseLazyQuery as MI, makeUseQuery as BI, makeUseMutation as qI, useWidgetSettingsMutations as hr, useWidgetSettingsQuery as yr, useRenderConditions as gr, PartnerSettingsWrapper as vr, handleWidgetSubmit as kr, MisconfigurationBanner as br, validateApiHostName as oy, PartnerHookFormSecretText as mi, WidgetSettingsFormFooter as xr, useTracking as In, useWidgetContext as bn, hasDownstreamApiForbiddenError as gl, hasDownstreamApiAuthorizationError as vl, DisplayErrors as Tn, settingsToFormValues as sy, useCopyWithDelay as Jt, defaultDateFormat as jt, displayAttributeValue as Pi, OAuthSettings as pi, useData as ly, isDownstreamApiNotFoundError as HI, isDownstreamApiAuthorizationError as ow, isDownstreamApiPermissionError as WI, capitalizeFirstCharacter as sw, humanizeKey as KI, hasDownstreamApiTooManyRequestsError as GI, hasDownstreamApiPermissionError as lw, PartnerHookFormBasicAuth as YI, hasDownstreamApiNotFoundError as ba, getCountryNameFromCountryCode as JI, parseBoolean as QI, parseString as XI, IntegrationModal as cw, useInboundOAuthContext as ZI, getWidgetConfigurationByIdQuery as eF, createWidgetConfigurationMutation as nF, updateWidgetConfigurationMutation as tF, trackRenderConditionsSaved as rF, deleteWidgetConfigurationMutation as iF } from "lib-integrations-partner-support";
export * from "lib-integrations-partner-support";
import qe, { useMemo as Xn, useState as ue, useEffect as Je, useRef as Ei, useCallback as ft, useReducer as aF, useLayoutEffect as oF, useContext as cy, isValidElement as uw, createContext as dw, createElement as sF, Fragment as lF } from "react";
import { FlexBox as b, Switch as Ks, FieldLabel as mw, FieldWrapper as We, InputText as mr, InputSelectionList as ei, FormGrid as tt, FormField as ie, Text as O, Spinner as hn, Icon as he, Tooltip as Ze, List as Qe, Badge as Mn, Button as et, IconButton as ir, Tag as Yn, NavigationButton as At, Select as Er, CollapseCard as pr, Box as lt, Modal as Ct, ModalHead as It, ModalBody as Ft, ModalFoot as Vt, Textarea as vh, TagsInput as kl, Image as xa, Banner as bl, FieldSwitch as xl, SelectionList as pt, Divider as uy, FieldText as tr, FieldTextarea as cF, CopyToClipboardButton as uF, getSelectionListContext as dF, Avatar as dy, Timestamp as mF, Attachment as pF, EmptyState as Gs, Table as ot, Checkbox as Gg, TextWithHighlight as fF, ErrorBoundaryContext as pw } from "@dixa/lib-shared-habla";
import ut from "classnames";
import { ApolloLink as my, Observable as fw, ApolloClient as hF, InMemoryCache as yF, createHttpLink as gF, ApolloProvider as vF, useApolloClient as kF, ApolloConsumer as bF, NetworkStatus as rr, isApolloError as hw, ApolloError as yw, gql as _l, useQuery as xF, useMutation as Yg } from "@apollo/client";
import _F from "cross-fetch";
import { config as Fo } from "lib-shared-backend-config";
import Jn from "moment";
import "moment-timezone";
import { __rest as SF, __assign as Gl } from "tslib";
import { useLocation as NF } from "react-router-dom";
function py(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Jo = { exports: {} }, Da = {};
var Jg;
function jF() {
  if (Jg) return Da;
  Jg = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Da.Fragment = r, Da.jsx = s, Da.jsxs = s, Da;
}
var Pa = {};
var Qg;
function wF() {
  return Qg || (Qg = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        P("error", t, m);
      }
    }
    function P(t, c, m) {
      {
        var y = x.ReactDebugCurrentFrame, F = y.getStackAddendum();
        F !== "" && (c += "%s", m = m.concat([F]));
        var T = m.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var E = !1, I = !1, w = !1, A = !1, H = !1, Y;
    Y = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ne(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || H || t === a || t === p || t === d || A || t === v || E || I || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function W(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var F = c.displayName || c.name || "";
      return F !== "" ? m + "(" + F + ")" : m;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function D(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var m = t;
            return B(m._context) + ".Provider";
          case u:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : D(t.type) || "Memo";
          case h: {
            var F = t, T = F._payload, S = F._init;
            try {
              return D(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var M = Object.assign, Z = 0, je, ge, ye, ke, q, _e, De;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function Ye() {
      {
        if (Z === 0) {
          je = console.log, ge = console.info, ye = console.warn, ke = console.error, q = console.group, _e = console.groupCollapsed, De = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function sn() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: M({}, t, {
              value: je
            }),
            info: M({}, t, {
              value: ge
            }),
            warn: M({}, t, {
              value: ye
            }),
            error: M({}, t, {
              value: ke
            }),
            group: M({}, t, {
              value: q
            }),
            groupCollapsed: M({}, t, {
              value: _e
            }),
            groupEnd: M({}, t, {
              value: De
            })
          });
        }
        Z < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = x.ReactCurrentDispatcher, Ue;
    function Pe(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (F) {
            var y = F.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Le;
    {
      var Xe = typeof WeakMap == "function" ? WeakMap : Map;
      Le = new Xe();
    }
    function Fe(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Le.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      Be = !0;
      var F = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ye();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (re) {
              y = re;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (re) {
              y = re;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            y = re;
          }
          t();
        }
      } catch (re) {
        if (re && y && typeof re.stack == "string") {
          for (var _ = re.stack.split(`
`), ee = y.stack.split(`
`), L = _.length - 1, U = ee.length - 1; L >= 1 && U >= 0 && _[L] !== ee[U]; )
            U--;
          for (; L >= 1 && U >= 0; L--, U--)
            if (_[L] !== ee[U]) {
              if (L !== 1 || U !== 1)
                do
                  if (L--, U--, U < 0 || _[L] !== ee[U]) {
                    var ce = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && ce.includes("<anonymous>") && (ce = ce.replace("<anonymous>", t.displayName)), typeof t == "function" && Le.set(t, ce), ce;
                  }
                while (L >= 1 && U >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = F;
      }
      var ze = t ? t.displayName || t.name : "", Oe = ze ? Pe(ze) : "";
      return typeof t == "function" && Le.set(t, Oe), Oe;
    }
    function Me(t, c, m) {
      return Fe(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Fe(t, nn(t));
      if (typeof t == "string")
        return Pe(t);
      switch (t) {
        case p:
          return Pe("Suspense");
        case d:
          return Pe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return Me(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, F = y._payload, T = y._init;
            try {
              return se(T(F), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Se = {}, Ae = x.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(m);
      } else
        Ae.setExtraStackFrame(null);
    }
    function yn(t, c, m, y, F) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + m + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              _ = t[S](c, S, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Re(F), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, S, typeof _), Re(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Re(F), g("Failed %s type: %s", m, _.message), Re(null));
          }
      }
    }
    var Q = Array.isArray;
    function $(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ae(t);
    }
    var J = x.ReactCurrentOwner, de = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, xe, $e;
    function tn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && J.current;
    }
    function pn(t, c) {
      {
        var m = function() {
          xe || (xe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function Fn(t, c) {
      {
        var m = function() {
          $e || ($e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, m, y, F, T, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: F
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, m, y, F) {
      {
        var T, S = {}, _ = null, ee = null;
        m !== void 0 && (V(m), _ = "" + m), gn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ee = c.ref, on(c, F));
        for (T in c)
          le.call(c, T) && !de.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (T in L)
            S[T] === void 0 && (S[T] = L[T]);
        }
        if (_ || ee) {
          var U = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, U), ee && Fn(S, U);
        }
        return xn(t, _, ee, F, y, J.current, S);
      }
    }
    var en = x.ReactCurrentOwner, vn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        vn.setExtraStackFrame(m);
      } else
        vn.setExtraStackFrame(null);
    }
    var un;
    un = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = D(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Nn = {};
    function Rn(t) {
      {
        var c = jn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function kn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Rn(c);
        if (Nn[m])
          return;
        Nn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + D(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Ve(null);
      }
    }
    function _n(t, c) {
      {
        if (typeof t != "object")
          return;
        if ($(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            dn(y) && kn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var F = N(t);
          if (typeof F == "function" && F !== t.entries)
            for (var T = F.call(t), S; !(S = T.next()).done; )
              dn(S.value) && kn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = D(c);
          yn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !un) {
          un = !0;
          var F = D(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", F || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, m, y, F, T) {
      {
        var S = ne(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = Bn();
          ee ? _ += ee : _ += jn();
          var L;
          t === null ? L = "null" : $(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (D(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var U = En(t, c, m, F, T);
        if (U == null)
          return U;
        if (S) {
          var ce = c.children;
          if (ce !== void 0)
            if (y)
              if ($(ce)) {
                for (var ze = 0; ze < ce.length; ze++)
                  _n(ce[ze], t);
                Object.freeze && Object.freeze(ce);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _n(ce, t);
        }
        if (le.call(c, "key")) {
          var Oe = D(t), re = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), mn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Oe + mn]) {
            var Dn = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Oe, Dn, Oe), Cn[Oe + mn] = !0;
          }
        }
        return t === i ? Ln(U) : An(U), U;
      }
    }
    function Vn(t, c, m) {
      return wn(t, c, m, !0);
    }
    function qn(t, c, m) {
      return wn(t, c, m, !1);
    }
    var zn = qn, Wn = Vn;
    Pa.Fragment = i, Pa.jsx = zn, Pa.jsxs = Wn;
  })()), Pa;
}
var Xg;
function CF() {
  return Xg || (Xg = 1, process.env.NODE_ENV === "production" ? Jo.exports = jF() : Jo.exports = wF()), Jo.exports;
}
var Ke = CF();
function gw(e, n) {
  return function() {
    return e.apply(n, arguments);
  };
}
const { toString: IF } = Object.prototype, { getPrototypeOf: fa } = Object, { iterator: Do, toStringTag: vw } = Symbol, Ys = (({ hasOwnProperty: e }) => (n, r) => e.call(n, r))(Object.prototype), Eo = (e, n) => {
  let r = e;
  const i = [];
  for (; r != null && r !== Object.prototype; ) {
    if (i.indexOf(r) !== -1)
      return !1;
    if (i.push(r), Ys(r, n))
      return !0;
    r = fa(r);
  }
  return !1;
}, FF = (e, n) => e != null && Eo(e, n) ? e[n] : void 0, fy = /* @__PURE__ */ ((e) => (n) => {
  const r = IF.call(n);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), $r = (e) => (e = e.toLowerCase(), (n) => fy(n) === e), Sl = (e) => (n) => typeof n === e, { isArray: Ri } = Array, ha = Sl("undefined");
function _a(e) {
  return e !== null && !ha(e) && e.constructor !== null && !ha(e.constructor) && er(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const kw = $r("ArrayBuffer");
function EF(e) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && kw(e.buffer), n;
}
const $F = Sl("string"), er = Sl("function"), bw = Sl("number"), Sa = (e) => e !== null && typeof e == "object", TF = (e) => e === !0 || e === !1, $s = (e) => {
  if (!Sa(e))
    return !1;
  const n = fa(e);
  return (n === null || n === Object.prototype || fa(n) === null) && // Treat any genuine (non-Object.prototype-polluted) Symbol.toStringTag or
  // Symbol.iterator as evidence the value is a tagged/iterable type rather
  // than a plain object, while ignoring keys injected onto Object.prototype.
  !Eo(e, vw) && !Eo(e, Do);
}, OF = (e) => {
  if (!Sa(e) || _a(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, DF = $r("Date"), PF = $r("File"), RF = (e) => !!(e && typeof e.uri < "u"), AF = (e) => e && typeof e.getParts < "u", LF = $r("Blob"), VF = $r("FileList"), zF = (e) => Sa(e) && er(e.pipe);
function UF() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const Zg = UF(), ev = typeof Zg.FormData < "u" ? Zg.FormData : void 0, MF = (e) => {
  if (!e) return !1;
  if (ev && e instanceof ev) return !0;
  const n = fa(e);
  if (!n || n === Object.prototype || !er(e.append)) return !1;
  const r = fy(e);
  return r === "formdata" || // detect form-data instance
  r === "object" && er(e.toString) && e.toString() === "[object FormData]";
}, BF = $r("URLSearchParams"), [qF, HF, WF, KF] = [
  "ReadableStream",
  "Request",
  "Response",
  "Headers"
].map($r), GF = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Po(e, n, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let i, a;
  if (typeof e != "object" && (e = [e]), Ri(e))
    for (i = 0, a = e.length; i < a; i++)
      n.call(null, e[i], i, e);
  else {
    if (_a(e))
      return;
    const o = r ? Object.getOwnPropertyNames(e) : Object.keys(e), s = o.length;
    let l;
    for (i = 0; i < s; i++)
      l = o[i], n.call(null, e[l], l, e);
  }
}
function xw(e, n) {
  if (_a(e))
    return null;
  n = n.toLowerCase();
  const r = Object.keys(e);
  let i = r.length, a;
  for (; i-- > 0; )
    if (a = r[i], n === a.toLowerCase())
      return a;
  return null;
}
const Ci = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, _w = (e) => !ha(e) && e !== Ci;
function kh(...e) {
  const { caseless: n, skipUndefined: r } = _w(this) && this || {}, i = {}, a = (o, s) => {
    if (s === "__proto__" || s === "constructor" || s === "prototype")
      return;
    const l = n && typeof s == "string" && xw(i, s) || s, u = Ys(i, l) ? i[l] : void 0;
    $s(u) && $s(o) ? i[l] = kh(u, o) : $s(o) ? i[l] = kh({}, o) : Ri(o) ? i[l] = o.slice() : (!r || !ha(o)) && (i[l] = o);
  };
  for (let o = 0, s = e.length; o < s; o++) {
    const l = e[o];
    if (!l || _a(l) || (Po(l, a), typeof l != "object" || Ri(l)))
      continue;
    const u = Object.getOwnPropertySymbols(l);
    for (let p = 0; p < u.length; p++) {
      const d = u[p];
      oE.call(l, d) && a(l[d], d);
    }
  }
  return i;
}
const YF = (e, n, r, { allOwnKeys: i } = {}) => (Po(
  n,
  (a, o) => {
    r && er(a) ? Object.defineProperty(e, o, {
      // Null-proto descriptor so a polluted Object.prototype.get cannot
      // hijack defineProperty's accessor-vs-data resolution.
      __proto__: null,
      value: gw(a, r),
      writable: !0,
      enumerable: !0,
      configurable: !0
    }) : Object.defineProperty(e, o, {
      __proto__: null,
      value: a,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  },
  { allOwnKeys: i }
), e), JF = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), QF = (e, n, r, i) => {
  e.prototype = Object.create(n.prototype, i), Object.defineProperty(e.prototype, "constructor", {
    __proto__: null,
    value: e,
    writable: !0,
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e, "super", {
    __proto__: null,
    value: n.prototype
  }), r && Object.assign(e.prototype, r);
}, XF = (e, n, r, i) => {
  let a, o, s;
  const l = {};
  if (n = n || {}, e == null) return n;
  do {
    for (a = Object.getOwnPropertyNames(e), o = a.length; o-- > 0; )
      s = a[o], (!i || i(s, e, n)) && !l[s] && (n[s] = e[s], l[s] = !0);
    e = r !== !1 && fa(e);
  } while (e && (!r || r(e, n)) && e !== Object.prototype);
  return n;
}, ZF = (e, n, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= n.length;
  const i = e.indexOf(n, r);
  return i !== -1 && i === r;
}, eE = (e) => {
  if (!e) return null;
  if (Ri(e)) return e;
  let n = e.length;
  if (!bw(n)) return null;
  const r = new Array(n);
  for (; n-- > 0; )
    r[n] = e[n];
  return r;
}, nE = /* @__PURE__ */ ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && fa(Uint8Array)), tE = (e, n) => {
  const i = (e && e[Do]).call(e);
  let a;
  for (; (a = i.next()) && !a.done; ) {
    const o = a.value;
    n.call(e, o[0], o[1]);
  }
}, rE = (e, n) => {
  let r;
  const i = [];
  for (; (r = e.exec(n)) !== null; )
    i.push(r);
  return i;
}, iE = $r("HTMLFormElement"), aE = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(r, i, a) {
  return i.toUpperCase() + a;
}), { propertyIsEnumerable: oE } = Object.prototype, sE = $r("RegExp"), Sw = (e, n) => {
  const r = Object.getOwnPropertyDescriptors(e), i = {};
  Po(r, (a, o) => {
    let s;
    (s = n(a, o, e)) !== !1 && (i[o] = s || a);
  }), Object.defineProperties(e, i);
}, lE = (e) => {
  Sw(e, (n, r) => {
    if (er(e) && ["arguments", "caller", "callee"].includes(r))
      return !1;
    const i = e[r];
    if (er(i)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, cE = (e, n) => {
  const r = {}, i = (a) => {
    a.forEach((o) => {
      r[o] = !0;
    });
  };
  return Ri(e) ? i(e) : i(String(e).split(n)), r;
}, uE = () => {
}, dE = (e, n) => e != null && Number.isFinite(e = +e) ? e : n;
function mE(e) {
  return !!(e && er(e.append) && e[vw] === "FormData" && e[Do]);
}
const pE = (e) => {
  const n = /* @__PURE__ */ new WeakSet(), r = (i) => {
    if (Sa(i)) {
      if (n.has(i))
        return;
      if (_a(i))
        return i;
      if (!("toJSON" in i)) {
        n.add(i);
        const a = Ri(i) ? [] : {};
        return Po(i, (o, s) => {
          const l = r(o);
          !ha(l) && (a[s] = l);
        }), n.delete(i), a;
      }
    }
    return i;
  };
  return r(e);
}, fE = $r("AsyncFunction"), hE = (e) => e && (Sa(e) || er(e)) && er(e.then) && er(e.catch), Nw = ((e, n) => e ? setImmediate : n ? ((r, i) => (Ci.addEventListener(
  "message",
  ({ source: a, data: o }) => {
    a === Ci && o === r && i.length && i.shift()();
  },
  !1
), (a) => {
  i.push(a), Ci.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(typeof setImmediate == "function", er(Ci.postMessage)), yE = typeof queueMicrotask < "u" ? queueMicrotask.bind(Ci) : typeof process < "u" && process.nextTick || Nw, jw = (e) => e != null && er(e[Do]), gE = (e) => e != null && Eo(e, Do) && jw(e), pe = {
  isArray: Ri,
  isArrayBuffer: kw,
  isBuffer: _a,
  isFormData: MF,
  isArrayBufferView: EF,
  isString: $F,
  isNumber: bw,
  isBoolean: TF,
  isObject: Sa,
  isPlainObject: $s,
  isEmptyObject: OF,
  isReadableStream: qF,
  isRequest: HF,
  isResponse: WF,
  isHeaders: KF,
  isUndefined: ha,
  isDate: DF,
  isFile: PF,
  isReactNativeBlob: RF,
  isReactNative: AF,
  isBlob: LF,
  isRegExp: sE,
  isFunction: er,
  isStream: zF,
  isURLSearchParams: BF,
  isTypedArray: nE,
  isFileList: VF,
  forEach: Po,
  merge: kh,
  extend: YF,
  trim: GF,
  stripBOM: JF,
  inherits: QF,
  toFlatObject: XF,
  kindOf: fy,
  kindOfTest: $r,
  endsWith: ZF,
  toArray: eE,
  forEachEntry: tE,
  matchAll: rE,
  isHTMLForm: iE,
  hasOwnProperty: Ys,
  hasOwnProp: Ys,
  // an alias to avoid ESLint no-prototype-builtins detection
  hasOwnInPrototypeChain: Eo,
  getSafeProp: FF,
  reduceDescriptors: Sw,
  freezeMethods: lE,
  toObjectSet: cE,
  toCamelCase: aE,
  noop: uE,
  toFiniteNumber: dE,
  findKey: xw,
  global: Ci,
  isContextDefined: _w,
  isSpecCompliantForm: mE,
  toJSONObject: pE,
  isAsyncFn: fE,
  isThenable: hE,
  setImmediate: Nw,
  asap: yE,
  isIterable: jw,
  isSafeIterable: gE
}, vE = pe.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), kE = (e) => {
  const n = {};
  let r, i, a;
  return e && e.split(`
`).forEach(function(s) {
    a = s.indexOf(":"), r = s.substring(0, a).trim().toLowerCase(), i = s.substring(a + 1).trim(), !(!r || n[r] && vE[r]) && (r === "set-cookie" ? n[r] ? n[r].push(i) : n[r] = [i] : n[r] = n[r] ? n[r] + ", " + i : i);
  }), n;
};
function bE(e) {
  let n = 0, r = e.length;
  for (; n < r; ) {
    const i = e.charCodeAt(n);
    if (i !== 9 && i !== 32)
      break;
    n += 1;
  }
  for (; r > n; ) {
    const i = e.charCodeAt(r - 1);
    if (i !== 9 && i !== 32)
      break;
    r -= 1;
  }
  return n === 0 && r === e.length ? e : e.slice(n, r);
}
const xE = new RegExp("[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+", "g"), _E = new RegExp("[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+", "g");
function hy(e, n) {
  return pe.isArray(e) ? e.map((r) => hy(r, n)) : bE(String(e).replace(n, ""));
}
const SE = (e) => hy(e, xE), NE = (e) => hy(e, _E);
function ww(e) {
  const n = /* @__PURE__ */ Object.create(null);
  return pe.forEach(e.toJSON(), (r, i) => {
    n[i] = NE(r);
  }), n;
}
const nv = /* @__PURE__ */ Symbol("internals");
function Ra(e) {
  return e && String(e).trim().toLowerCase();
}
function Ts(e) {
  return e === !1 || e == null ? e : pe.isArray(e) ? e.map(Ts) : SE(String(e));
}
function jE(e) {
  const n = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let i;
  for (; i = r.exec(e); )
    n[i[1]] = i[2];
  return n;
}
const wE = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Yl(e, n, r, i, a) {
  if (pe.isFunction(i))
    return i.call(this, n, r);
  if (a && (n = r), !!pe.isString(n)) {
    if (pe.isString(i))
      return n.indexOf(i) !== -1;
    if (pe.isRegExp(i))
      return i.test(n);
  }
}
function CE(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, r, i) => r.toUpperCase() + i);
}
function IE(e, n) {
  const r = pe.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((i) => {
    Object.defineProperty(e, i + r, {
      // Null-proto descriptor so a polluted Object.prototype.get cannot turn
      // this data descriptor into an accessor descriptor on the way in.
      __proto__: null,
      value: function(a, o, s) {
        return this[i].call(this, n, a, o, s);
      },
      configurable: !0
    });
  });
}
let Ut = class {
  constructor(n) {
    n && this.set(n);
  }
  set(n, r, i) {
    const a = this;
    function o(l, u, p) {
      const d = Ra(u);
      if (!d)
        return;
      const f = pe.findKey(a, d);
      (!f || a[f] === void 0 || p === !0 || p === void 0 && a[f] !== !1) && (a[f || u] = Ts(l));
    }
    const s = (l, u) => pe.forEach(l, (p, d) => o(p, d, u));
    if (pe.isPlainObject(n) || n instanceof this.constructor)
      s(n, r);
    else if (pe.isString(n) && (n = n.trim()) && !wE(n))
      s(kE(n), r);
    else if (pe.isObject(n) && pe.isSafeIterable(n)) {
      let l = /* @__PURE__ */ Object.create(null), u, p;
      for (const d of n) {
        if (!pe.isArray(d))
          throw new TypeError("Object iterator must return a key-value pair");
        p = d[0], pe.hasOwnProp(l, p) ? (u = l[p], l[p] = pe.isArray(u) ? [...u, d[1]] : [u, d[1]]) : l[p] = d[1];
      }
      s(l, r);
    } else
      n != null && o(r, n, i);
    return this;
  }
  get(n, r) {
    if (n = Ra(n), n) {
      const i = pe.findKey(this, n);
      if (i) {
        const a = this[i];
        if (!r)
          return a;
        if (r === !0)
          return jE(a);
        if (pe.isFunction(r))
          return r.call(this, a, i);
        if (pe.isRegExp(r))
          return r.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, r) {
    if (n = Ra(n), n) {
      const i = pe.findKey(this, n);
      return !!(i && this[i] !== void 0 && (!r || Yl(this, this[i], i, r)));
    }
    return !1;
  }
  delete(n, r) {
    const i = this;
    let a = !1;
    function o(s) {
      if (s = Ra(s), s) {
        const l = pe.findKey(i, s);
        l && (!r || Yl(i, i[l], l, r)) && (delete i[l], a = !0);
      }
    }
    return pe.isArray(n) ? n.forEach(o) : o(n), a;
  }
  clear(n) {
    const r = Object.keys(this);
    let i = r.length, a = !1;
    for (; i--; ) {
      const o = r[i];
      (!n || Yl(this, this[o], o, n, !0)) && (delete this[o], a = !0);
    }
    return a;
  }
  normalize(n) {
    const r = this, i = {};
    return pe.forEach(this, (a, o) => {
      const s = pe.findKey(i, o);
      if (s) {
        r[s] = Ts(a), delete r[o];
        return;
      }
      const l = n ? CE(o) : String(o).trim();
      l !== o && delete r[o], r[l] = Ts(a), i[l] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const r = /* @__PURE__ */ Object.create(null);
    return pe.forEach(this, (i, a) => {
      i != null && i !== !1 && (r[a] = n && pe.isArray(i) ? i.join(", ") : i);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, r]) => n + ": " + r).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...r) {
    const i = new this(n);
    return r.forEach((a) => i.set(a)), i;
  }
  static accessor(n) {
    const i = (this[nv] = this[nv] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function o(s) {
      const l = Ra(s);
      i[l] || (IE(a, s), i[l] = !0);
    }
    return pe.isArray(n) ? n.forEach(o) : o(n), this;
  }
};
Ut.accessor([
  "Content-Type",
  "Content-Length",
  "Accept",
  "Accept-Encoding",
  "User-Agent",
  "Authorization"
]);
pe.reduceDescriptors(Ut.prototype, ({ value: e }, n) => {
  let r = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => e,
    set(i) {
      this[r] = i;
    }
  };
});
pe.freezeMethods(Ut);
const FE = "[REDACTED ****]";
function EE(e) {
  if (pe.hasOwnProp(e, "toJSON"))
    return !0;
  let n = Object.getPrototypeOf(e);
  for (; n && n !== Object.prototype; ) {
    if (pe.hasOwnProp(n, "toJSON"))
      return !0;
    n = Object.getPrototypeOf(n);
  }
  return !1;
}
function $E(e, n) {
  const r = new Set(n.map((o) => String(o).toLowerCase())), i = [], a = (o) => {
    if (o === null || typeof o != "object" || pe.isBuffer(o)) return o;
    if (i.indexOf(o) !== -1) return;
    o instanceof Ut && (o = o.toJSON()), i.push(o);
    let s;
    if (pe.isArray(o))
      s = [], o.forEach((l, u) => {
        const p = a(l);
        pe.isUndefined(p) || (s[u] = p);
      });
    else {
      if (!pe.isPlainObject(o) && EE(o))
        return i.pop(), o;
      s = /* @__PURE__ */ Object.create(null);
      for (const [l, u] of Object.entries(o)) {
        const p = r.has(l.toLowerCase()) ? FE : a(u);
        pe.isUndefined(p) || (s[l] = p);
      }
    }
    return i.pop(), s;
  };
  return a(e);
}
let ln = class Cw extends Error {
  static from(n, r, i, a, o, s) {
    const l = new Cw(n.message, r || n.code, i, a, o);
    return l.cause = n, l.name = n.name, n.status != null && l.status == null && (l.status = n.status), s && Object.assign(l, s), l;
  }
  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */
  constructor(n, r, i, a, o) {
    super(n), Object.defineProperty(this, "message", {
      // Null-proto descriptor so a polluted Object.prototype.get cannot turn
      // this data descriptor into an accessor descriptor on the way in.
      __proto__: null,
      value: n,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }), this.name = "AxiosError", this.isAxiosError = !0, r && (this.code = r), i && (this.config = i), a && (this.request = a), o && (this.response = o, this.status = o.status);
  }
  toJSON() {
    const n = this.config, r = n && pe.hasOwnProp(n, "redact") ? n.redact : void 0, i = pe.isArray(r) && r.length > 0 ? $E(n, r) : pe.toJSONObject(n);
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: i,
      code: this.code,
      status: this.status
    };
  }
};
ln.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
ln.ERR_BAD_OPTION = "ERR_BAD_OPTION";
ln.ECONNABORTED = "ECONNABORTED";
ln.ETIMEDOUT = "ETIMEDOUT";
ln.ECONNREFUSED = "ECONNREFUSED";
ln.ERR_NETWORK = "ERR_NETWORK";
ln.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
ln.ERR_DEPRECATED = "ERR_DEPRECATED";
ln.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
ln.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
ln.ERR_CANCELED = "ERR_CANCELED";
ln.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
ln.ERR_INVALID_URL = "ERR_INVALID_URL";
ln.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
const TE = null, Iw = 100;
function bh(e) {
  return pe.isPlainObject(e) || pe.isArray(e);
}
function Fw(e) {
  return pe.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Jl(e, n, r) {
  return e ? e.concat(n).map(function(a, o) {
    return a = Fw(a), !r && o ? "[" + a + "]" : a;
  }).join(r ? "." : "") : n;
}
function OE(e) {
  return pe.isArray(e) && !e.some(bh);
}
const DE = pe.toFlatObject(pe, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function Nl(e, n, r) {
  if (!pe.isObject(e))
    throw new TypeError("target must be an object");
  n = n || new FormData(), r = pe.toFlatObject(
    r,
    {
      metaTokens: !0,
      dots: !1,
      indexes: !1
    },
    !1,
    function(g, P) {
      return !pe.isUndefined(P[g]);
    }
  );
  const i = r.metaTokens, a = r.visitor || C, o = r.dots, s = r.indexes, l = r.Blob || typeof Blob < "u" && Blob, u = r.maxDepth === void 0 ? Iw : r.maxDepth, p = l && pe.isSpecCompliantForm(n), d = [];
  if (!pe.isFunction(a))
    throw new TypeError("visitor must be a function");
  function f(x) {
    if (x === null) return "";
    if (pe.isDate(x))
      return x.toISOString();
    if (pe.isBoolean(x))
      return x.toString();
    if (!p && pe.isBlob(x))
      throw new ln("Blob is not supported. Use a Buffer instead.");
    return pe.isArrayBuffer(x) || pe.isTypedArray(x) ? p && typeof Blob == "function" ? new Blob([x]) : Buffer.from(x) : x;
  }
  function h(x) {
    if (x > u)
      throw new ln(
        "Object is too deeply nested (" + x + " levels). Max depth: " + u,
        ln.ERR_FORM_DATA_DEPTH_EXCEEDED
      );
  }
  function v(x, g) {
    if (u === 1 / 0)
      return JSON.stringify(x);
    const P = [];
    return JSON.stringify(x, function(I, w) {
      if (!pe.isObject(w))
        return w;
      for (; P.length && P[P.length - 1] !== this; )
        P.pop();
      return P.push(w), h(g + P.length - 1), w;
    });
  }
  function C(x, g, P) {
    let E = x;
    if (pe.isReactNative(n) && pe.isReactNativeBlob(x))
      return n.append(Jl(P, g, o), f(x)), !1;
    if (x && !P && typeof x == "object") {
      if (pe.endsWith(g, "{}"))
        g = i ? g : g.slice(0, -2), x = v(x, 1);
      else if (pe.isArray(x) && OE(x) || (pe.isFileList(x) || pe.endsWith(g, "[]")) && (E = pe.toArray(x)))
        return g = Fw(g), E.forEach(function(w, A) {
          !(pe.isUndefined(w) || w === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? Jl([g], A, o) : s === null ? g : g + "[]",
            f(w)
          );
        }), !1;
    }
    return bh(x) ? !0 : (n.append(Jl(P, g, o), f(x)), !1);
  }
  const j = Object.assign(DE, {
    defaultVisitor: C,
    convertValue: f,
    isVisitable: bh
  });
  function N(x, g, P = 0) {
    if (!pe.isUndefined(x)) {
      if (h(P), d.indexOf(x) !== -1)
        throw new Error("Circular reference detected in " + g.join("."));
      d.push(x), pe.forEach(x, function(I, w) {
        (!(pe.isUndefined(I) || I === null) && a.call(n, I, pe.isString(w) ? w.trim() : w, g, j)) === !0 && N(I, g ? g.concat(w) : [w], P + 1);
      }), d.pop();
    }
  }
  if (!pe.isObject(e))
    throw new TypeError("data must be an object");
  return N(e), n;
}
function tv(e) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20/g, function(i) {
    return n[i];
  });
}
function yy(e, n) {
  this._pairs = [], e && Nl(e, this, n);
}
const Ew = yy.prototype;
Ew.append = function(n, r) {
  this._pairs.push([n, r]);
};
Ew.toString = function(n) {
  const r = n ? function(i) {
    return n.call(this, i, tv);
  } : tv;
  return this._pairs.map(function(a) {
    return r(a[0]) + "=" + r(a[1]);
  }, "").join("&");
};
function PE(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function $w(e, n, r) {
  if (!n)
    return e;
  const i = pe.isFunction(r) ? {
    serialize: r
  } : r, a = pe.getSafeProp(i, "encode") || PE, o = pe.getSafeProp(i, "serialize");
  let s;
  if (o ? s = o(n, i) : s = pe.isURLSearchParams(n) ? n.toString() : new yy(n, i).toString(a), s) {
    const l = e.indexOf("#");
    l !== -1 && (e = e.slice(0, l)), e += (e.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return e;
}
class rv {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, r, i) {
    return this.handlers.push({
      fulfilled: n,
      rejected: r,
      synchronous: i ? i.synchronous : !1,
      runWhen: i ? i.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    pe.forEach(this.handlers, function(i) {
      i !== null && n(i);
    });
  }
}
const gy = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1,
  legacyInterceptorReqResOrdering: !0,
  advertiseZstdAcceptEncoding: !1,
  validateStatusUndefinedResolves: !0
}, RE = typeof URLSearchParams < "u" ? URLSearchParams : yy, AE = typeof FormData < "u" ? FormData : null, LE = typeof Blob < "u" ? Blob : null, VE = {
  isBrowser: !0,
  classes: {
    URLSearchParams: RE,
    FormData: AE,
    Blob: LE
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, vy = typeof window < "u" && typeof document < "u", xh = typeof navigator == "object" && navigator || void 0, zE = vy && (!xh || ["ReactNative", "NativeScript", "NS"].indexOf(xh.product) < 0), UE = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", ME = vy && window.location.href || "http://localhost", BE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: vy,
  hasStandardBrowserEnv: zE,
  hasStandardBrowserWebWorkerEnv: UE,
  navigator: xh,
  origin: ME
}, Symbol.toStringTag, { value: "Module" })), Pt = {
  ...BE,
  ...VE
};
function qE(e, n) {
  return Nl(e, new Pt.classes.URLSearchParams(), {
    visitor: function(r, i, a, o) {
      return Pt.isNode && pe.isBuffer(r) ? (this.append(i, r.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...n
  });
}
const iv = Iw;
function Tw(e) {
  if (e > iv)
    throw new ln(
      "FormData field is too deeply nested (" + e + " levels). Max depth: " + iv,
      ln.ERR_FORM_DATA_DEPTH_EXCEEDED
    );
}
function HE(e) {
  const n = [], r = /\w+|\[(\w*)]/g;
  let i;
  for (; (i = r.exec(e)) !== null; )
    Tw(n.length), n.push(i[0] === "[]" ? "" : i[1] || i[0]);
  return n;
}
function WE(e) {
  const n = {}, r = Object.keys(e);
  let i;
  const a = r.length;
  let o;
  for (i = 0; i < a; i++)
    o = r[i], n[o] = e[o];
  return n;
}
function Ow(e) {
  function n(r, i, a, o) {
    Tw(o);
    let s = r[o++];
    if (s === "__proto__") return !0;
    const l = Number.isFinite(+s), u = o >= r.length;
    return s = !s && pe.isArray(a) ? a.length : s, u ? (pe.hasOwnProp(a, s) ? a[s] = pe.isArray(a[s]) ? a[s].concat(i) : [a[s], i] : a[s] = i, !l) : ((!pe.hasOwnProp(a, s) || !pe.isObject(a[s])) && (a[s] = []), n(r, i, a[s], o) && pe.isArray(a[s]) && (a[s] = WE(a[s])), !l);
  }
  if (pe.isFormData(e) && pe.isFunction(e.entries)) {
    const r = {};
    return pe.forEachEntry(e, (i, a) => {
      n(HE(i), a, r, 0);
    }), r;
  }
  return null;
}
const Wi = (e, n) => e != null && pe.hasOwnProp(e, n) ? e[n] : void 0;
function KE(e, n, r) {
  if (pe.isString(e))
    try {
      return (n || JSON.parse)(e), pe.trim(e);
    } catch (i) {
      if (i.name !== "SyntaxError")
        throw i;
    }
  return (r || JSON.stringify)(e);
}
const Ro = {
  transitional: gy,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [
    function(n, r) {
      const i = r.getContentType() || "", a = i.indexOf("application/json") > -1, o = pe.isObject(n);
      if (o && pe.isHTMLForm(n) && (n = new FormData(n)), pe.isFormData(n))
        return a ? JSON.stringify(Ow(n)) : n;
      if (pe.isArrayBuffer(n) || pe.isBuffer(n) || pe.isStream(n) || pe.isFile(n) || pe.isBlob(n) || pe.isReadableStream(n))
        return n;
      if (pe.isArrayBufferView(n))
        return n.buffer;
      if (pe.isURLSearchParams(n))
        return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
      let l;
      if (o) {
        const u = Wi(this, "formSerializer");
        if (i.indexOf("application/x-www-form-urlencoded") > -1)
          return qE(n, u).toString();
        if ((l = pe.isFileList(n)) || i.indexOf("multipart/form-data") > -1) {
          const p = Wi(this, "env"), d = p && p.FormData;
          return Nl(
            l ? { "files[]": n } : n,
            d && new d(),
            u
          );
        }
      }
      return o || a ? (r.setContentType("application/json", !1), KE(n)) : n;
    }
  ],
  transformResponse: [
    function(n) {
      const r = Wi(this, "transitional") || Ro.transitional, i = r && r.forcedJSONParsing, a = Wi(this, "responseType"), o = a === "json";
      if (pe.isResponse(n) || pe.isReadableStream(n))
        return n;
      if (n && pe.isString(n) && (i && !a || o)) {
        const l = !(r && r.silentJSONParsing) && o;
        try {
          return JSON.parse(n, Wi(this, "parseReviver"));
        } catch (u) {
          if (l)
            throw u.name === "SyntaxError" ? ln.from(u, ln.ERR_BAD_RESPONSE, this, null, Wi(this, "response")) : u;
        }
      }
      return n;
    }
  ],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Pt.classes.FormData,
    Blob: Pt.classes.Blob
  },
  validateStatus: function(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
pe.forEach(["delete", "get", "head", "post", "put", "patch", "query"], (e) => {
  Ro.headers[e] = {};
});
function Ql(e, n) {
  const r = this || Ro, i = n || r, a = Ut.from(i.headers);
  let o = i.data;
  return pe.forEach(e, function(l) {
    o = l.call(r, o, a.normalize(), n ? n.status : void 0);
  }), a.normalize(), o;
}
function Dw(e) {
  return !!(e && e.__CANCEL__);
}
let Ao = class extends ln {
  /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */
  constructor(n, r, i) {
    super(n ?? "canceled", ln.ERR_CANCELED, r, i), this.name = "CanceledError", this.__CANCEL__ = !0;
  }
};
function Pw(e, n, r) {
  const i = r.config.validateStatus;
  !r.status || !i || i(r.status) ? e(r) : n(new ln(
    "Request failed with status code " + r.status,
    r.status >= 400 && r.status < 500 ? ln.ERR_BAD_REQUEST : ln.ERR_BAD_RESPONSE,
    r.config,
    r.request,
    r
  ));
}
function GE(e) {
  const n = /^([-+\w]{1,25}):(?:\/\/)?/.exec(e);
  return n && n[1] || "";
}
function YE(e, n) {
  e = e || 10;
  const r = new Array(e), i = new Array(e);
  let a = 0, o = 0, s;
  return n = n !== void 0 ? n : 1e3, function(u) {
    const p = Date.now(), d = i[o];
    s || (s = p), r[a] = u, i[a] = p;
    let f = o, h = 0;
    for (; f !== a; )
      h += r[f++], f = f % e;
    if (a = (a + 1) % e, a === o && (o = (o + 1) % e), p - s < n)
      return;
    const v = d && p - d;
    return v ? Math.round(h * 1e3 / v) : void 0;
  };
}
function JE(e, n) {
  let r = 0, i = 1e3 / n, a, o;
  const s = (p, d = Date.now()) => {
    r = d, a = null, o && (clearTimeout(o), o = null), e(...p);
  };
  return [(...p) => {
    const d = Date.now(), f = d - r;
    f >= i ? s(p, d) : (a = p, o || (o = setTimeout(() => {
      o = null, s(a);
    }, i - f)));
  }, () => a && s(a)];
}
const Js = (e, n, r = 3) => {
  let i = 0;
  const a = YE(50, 250);
  return JE((o) => {
    if (!o || typeof o.loaded != "number")
      return;
    const s = o.loaded, l = o.lengthComputable ? o.total : void 0, u = l != null ? Math.min(s, l) : s, p = Math.max(0, u - i), d = a(p);
    i = Math.max(i, u);
    const f = {
      loaded: u,
      total: l,
      progress: l ? u / l : void 0,
      bytes: p,
      rate: d || void 0,
      estimated: d && l ? (l - u) / d : void 0,
      event: o,
      lengthComputable: l != null,
      [n ? "download" : "upload"]: !0
    };
    e(f);
  }, r);
}, av = (e, n) => {
  const r = e != null;
  return [
    (i) => n[0]({
      lengthComputable: r,
      total: e,
      loaded: i
    }),
    n[1]
  ];
}, ov = (e) => (...n) => pe.asap(() => e(...n)), QE = Pt.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, n) => (r) => (r = new URL(r, Pt.origin), e.protocol === r.protocol && e.host === r.host && (n || e.port === r.port)))(
  new URL(Pt.origin),
  Pt.navigator && /(msie|trident)/i.test(Pt.navigator.userAgent)
) : () => !0, XE = Pt.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, n, r, i, a, o, s) {
      if (typeof document > "u") return;
      const l = [`${e}=${encodeURIComponent(n)}`];
      pe.isNumber(r) && l.push(`expires=${new Date(r).toUTCString()}`), pe.isString(i) && l.push(`path=${i}`), pe.isString(a) && l.push(`domain=${a}`), o === !0 && l.push("secure"), pe.isString(s) && l.push(`SameSite=${s}`), document.cookie = l.join("; ");
    },
    read(e) {
      if (typeof document > "u") return null;
      const n = document.cookie.split(";");
      for (let r = 0; r < n.length; r++) {
        const i = n[r].replace(/^\s+/, ""), a = i.indexOf("=");
        if (a !== -1 && i.slice(0, a) === e)
          return decodeURIComponent(i.slice(a + 1));
      }
      return null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function ZE(e) {
  return typeof e != "string" ? !1 : /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function e$(e, n) {
  return n ? e.replace(/\/?\/$/, "") + "/" + n.replace(/^\/+/, "") : e;
}
const n$ = /^https?:(?!\/\/)/i, t$ = /[\t\n\r]/g;
function r$(e) {
  let n = 0;
  for (; n < e.length && e.charCodeAt(n) <= 32; )
    n++;
  return e.slice(n);
}
function i$(e) {
  return r$(e).replace(t$, "");
}
function sv(e, n) {
  if (typeof e == "string" && n$.test(i$(e)))
    throw new ln(
      'Invalid URL: missing "//" after protocol',
      ln.ERR_INVALID_URL,
      n
    );
}
function Rw(e, n, r, i) {
  sv(n, i);
  let a = !ZE(n);
  return e && (a || r === !1) ? (sv(e, i), e$(e, n)) : n;
}
const lv = (e) => e instanceof Ut ? { ...e } : e;
function Ai(e, n) {
  n = n || {};
  const r = /* @__PURE__ */ Object.create(null);
  Object.defineProperty(r, "hasOwnProperty", {
    // Null-proto descriptor so a polluted Object.prototype.get cannot turn
    // this data descriptor into an accessor descriptor on the way in.
    __proto__: null,
    value: Object.prototype.hasOwnProperty,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
  function i(d, f, h, v) {
    return pe.isPlainObject(d) && pe.isPlainObject(f) ? pe.merge.call({ caseless: v }, d, f) : pe.isPlainObject(f) ? pe.merge({}, f) : pe.isArray(f) ? f.slice() : f;
  }
  function a(d, f, h, v) {
    if (pe.isUndefined(f)) {
      if (!pe.isUndefined(d))
        return i(void 0, d, h, v);
    } else return i(d, f, h, v);
  }
  function o(d, f) {
    if (!pe.isUndefined(f))
      return i(void 0, f);
  }
  function s(d, f) {
    if (pe.isUndefined(f)) {
      if (!pe.isUndefined(d))
        return i(void 0, d);
    } else return i(void 0, f);
  }
  function l(d) {
    const f = pe.hasOwnProp(n, "transitional") ? n.transitional : void 0;
    if (!pe.isUndefined(f))
      if (pe.isPlainObject(f)) {
        if (pe.hasOwnProp(f, d))
          return f[d];
      } else
        return;
    const h = pe.hasOwnProp(e, "transitional") ? e.transitional : void 0;
    if (pe.isPlainObject(h) && pe.hasOwnProp(h, d))
      return h[d];
  }
  function u(d, f, h) {
    if (pe.hasOwnProp(n, h))
      return i(d, f);
    if (pe.hasOwnProp(e, h))
      return i(void 0, d);
  }
  const p = {
    url: o,
    method: o,
    data: o,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    allowedSocketPaths: s,
    responseEncoding: s,
    validateStatus: u,
    headers: (d, f, h) => a(lv(d), lv(f), h, !0)
  };
  return pe.forEach(Object.keys({ ...e, ...n }), function(f) {
    if (f === "__proto__" || f === "constructor" || f === "prototype") return;
    const h = pe.hasOwnProp(p, f) ? p[f] : a, v = pe.hasOwnProp(e, f) ? e[f] : void 0, C = pe.hasOwnProp(n, f) ? n[f] : void 0, j = h(v, C, f);
    pe.isUndefined(j) && h !== u || (r[f] = j);
  }), pe.hasOwnProp(n, "validateStatus") && pe.isUndefined(n.validateStatus) && l("validateStatusUndefinedResolves") === !1 && (pe.hasOwnProp(e, "validateStatus") ? r.validateStatus = i(void 0, e.validateStatus) : delete r.validateStatus), r;
}
const a$ = ["content-type", "content-length"];
function o$(e, n, r) {
  if (r !== "content-only") {
    e.set(n);
    return;
  }
  Object.entries(n).forEach(([i, a]) => {
    a$.includes(i.toLowerCase()) && e.set(i, a);
  });
}
const s$ = (e) => encodeURIComponent(e).replace(
  /%([0-9A-F]{2})/gi,
  (n, r) => String.fromCharCode(parseInt(r, 16))
);
function Aw(e) {
  const n = Ai({}, e), r = (h) => pe.hasOwnProp(n, h) ? n[h] : void 0, i = r("data");
  let a = r("withXSRFToken");
  const o = r("xsrfHeaderName"), s = r("xsrfCookieName");
  let l = r("headers");
  const u = r("auth"), p = r("baseURL"), d = r("allowAbsoluteUrls"), f = r("url");
  if (n.headers = l = Ut.from(l), n.url = $w(
    Rw(p, f, d, n),
    r("params"),
    r("paramsSerializer")
  ), u) {
    const h = pe.getSafeProp(u, "username") || "", v = pe.getSafeProp(u, "password") || "";
    l.set(
      "Authorization",
      "Basic " + btoa(h + ":" + (v ? s$(v) : ""))
    );
  }
  if (pe.isFormData(i) && (Pt.hasStandardBrowserEnv || Pt.hasStandardBrowserWebWorkerEnv || pe.isReactNative(i) ? l.setContentType(void 0) : pe.isFunction(i.getHeaders) && o$(l, i.getHeaders(), r("formDataHeaderPolicy"))), Pt.hasStandardBrowserEnv && (pe.isFunction(a) && (a = a(n)), a === !0 || a == null && QE(n.url))) {
    const v = o && s && XE.read(s);
    v && l.set(o, v);
  }
  return n;
}
const l$ = typeof XMLHttpRequest < "u", c$ = l$ && function(e) {
  return new Promise(function(r, i) {
    const a = Aw(e);
    let o = a.data;
    const s = Ut.from(a.headers).normalize();
    let { responseType: l, onUploadProgress: u, onDownloadProgress: p } = a, d, f, h, v, C;
    function j() {
      v && v(), C && C(), a.cancelToken && a.cancelToken.unsubscribe(d), a.signal && a.signal.removeEventListener("abort", d);
    }
    let N = new XMLHttpRequest();
    N.open(a.method.toUpperCase(), a.url, !0), N.timeout = a.timeout;
    function x() {
      if (!N)
        return;
      const P = Ut.from(
        "getAllResponseHeaders" in N && N.getAllResponseHeaders()
      ), I = {
        data: !l || l === "text" || l === "json" ? N.responseText : N.response,
        status: N.status,
        statusText: N.statusText,
        headers: P,
        config: e,
        request: N
      };
      Pw(
        function(A) {
          r(A), j();
        },
        function(A) {
          i(A), j();
        },
        I
      ), N = null;
    }
    "onloadend" in N ? N.onloadend = x : N.onreadystatechange = function() {
      !N || N.readyState !== 4 || N.status === 0 && !(N.responseURL && N.responseURL.startsWith("file:")) || setTimeout(x);
    }, N.onabort = function() {
      N && (i(new ln("Request aborted", ln.ECONNABORTED, e, N)), j(), N = null);
    }, N.onerror = function(E) {
      const I = E && E.message ? E.message : "Network Error", w = new ln(I, ln.ERR_NETWORK, e, N);
      w.event = E || null, i(w), j(), N = null;
    }, N.ontimeout = function() {
      let E = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const I = a.transitional || gy;
      a.timeoutErrorMessage && (E = a.timeoutErrorMessage), i(
        new ln(
          E,
          I.clarifyTimeoutError ? ln.ETIMEDOUT : ln.ECONNABORTED,
          e,
          N
        )
      ), j(), N = null;
    }, o === void 0 && s.setContentType(null), "setRequestHeader" in N && pe.forEach(ww(s), function(E, I) {
      N.setRequestHeader(I, E);
    }), pe.isUndefined(a.withCredentials) || (N.withCredentials = !!a.withCredentials), l && l !== "json" && (N.responseType = a.responseType), p && ([h, C] = Js(p, !0), N.addEventListener("progress", h)), u && N.upload && ([f, v] = Js(u), N.upload.addEventListener("progress", f), N.upload.addEventListener("loadend", v)), (a.cancelToken || a.signal) && (d = (P) => {
      N && (i(!P || P.type ? new Ao(null, e, N) : P), N.abort(), j(), N = null);
    }, a.cancelToken && a.cancelToken.subscribe(d), a.signal && (a.signal.aborted ? d() : a.signal.addEventListener("abort", d)));
    const g = GE(a.url);
    if (g && !Pt.protocols.includes(g)) {
      i(
        new ln(
          "Unsupported protocol " + g + ":",
          ln.ERR_BAD_REQUEST,
          e
        )
      );
      return;
    }
    N.send(o || null);
  });
}, u$ = (e, n) => {
  if (e = e ? e.filter(Boolean) : [], !n && !e.length)
    return;
  const r = new AbortController();
  let i = !1;
  const a = function(u) {
    if (!i) {
      i = !0, s();
      const p = u instanceof Error ? u : this.reason;
      r.abort(
        p instanceof ln ? p : new Ao(p instanceof Error ? p.message : p)
      );
    }
  };
  let o = n && setTimeout(() => {
    o = null, a(new ln(`timeout of ${n}ms exceeded`, ln.ETIMEDOUT));
  }, n);
  const s = () => {
    e && (o && clearTimeout(o), o = null, e.forEach((u) => {
      u.unsubscribe ? u.unsubscribe(a) : u.removeEventListener("abort", a);
    }), e = null);
  };
  e.forEach((u) => u.addEventListener("abort", a));
  const { signal: l } = r;
  return l.unsubscribe = () => pe.asap(s), l;
}, d$ = function* (e, n) {
  let r = e.byteLength;
  if (r < n) {
    yield e;
    return;
  }
  let i = 0, a;
  for (; i < r; )
    a = i + n, yield e.slice(i, a), i = a;
}, m$ = async function* (e, n) {
  for await (const r of p$(e))
    yield* d$(r, n);
}, p$ = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const n = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: i } = await n.read();
      if (r)
        break;
      yield i;
    }
  } finally {
    await n.cancel();
  }
}, cv = (e, n, r, i) => {
  const a = m$(e, n);
  let o = 0, s, l = (u) => {
    s || (s = !0, i && i(u));
  };
  return new ReadableStream(
    {
      async pull(u) {
        try {
          const { done: p, value: d } = await a.next();
          if (p) {
            l(), u.close();
            return;
          }
          let f = d.byteLength;
          if (r) {
            let h = o += f;
            r(h);
          }
          u.enqueue(new Uint8Array(d));
        } catch (p) {
          throw l(p), p;
        }
      },
      cancel(u) {
        return l(u), a.return();
      }
    },
    {
      highWaterMark: 2
    }
  );
}, Qs = (e) => e >= 48 && e <= 57 || e >= 65 && e <= 70 || e >= 97 && e <= 102, f$ = (e, n, r) => n + 2 < r && Qs(e.charCodeAt(n + 1)) && Qs(e.charCodeAt(n + 2));
function h$(e) {
  if (!e || typeof e != "string" || !e.startsWith("data:")) return 0;
  const n = e.indexOf(",");
  if (n < 0) return 0;
  const r = e.slice(5, n), i = e.slice(n + 1);
  if (/;base64/i.test(r)) {
    let s = i.length;
    const l = i.length;
    for (let v = 0; v < l; v++)
      if (i.charCodeAt(v) === 37 && v + 2 < l) {
        const C = i.charCodeAt(v + 1), j = i.charCodeAt(v + 2);
        Qs(C) && Qs(j) && (s -= 2, v += 2);
      }
    let u = 0, p = l - 1;
    const d = (v) => v >= 2 && i.charCodeAt(v - 2) === 37 && // '%'
    i.charCodeAt(v - 1) === 51 && // '3'
    (i.charCodeAt(v) === 68 || i.charCodeAt(v) === 100);
    p >= 0 && (i.charCodeAt(p) === 61 ? (u++, p--) : d(p) && (u++, p -= 3)), u === 1 && p >= 0 && (i.charCodeAt(p) === 61 || d(p)) && u++;
    const h = Math.floor(s / 4) * 3 - (u || 0);
    return h > 0 ? h : 0;
  }
  let o = 0;
  for (let s = 0, l = i.length; s < l; s++) {
    const u = i.charCodeAt(s);
    if (u === 37 && f$(i, s, l))
      o += 1, s += 2;
    else if (u < 128)
      o += 1;
    else if (u < 2048)
      o += 2;
    else if (u >= 55296 && u <= 56319 && s + 1 < l) {
      const p = i.charCodeAt(s + 1);
      p >= 56320 && p <= 57343 ? (o += 4, s++) : o += 3;
    } else
      o += 3;
  }
  return o;
}
const ky = "1.18.0", uv = 64 * 1024, { isFunction: Qo } = pe, y$ = (e) => encodeURIComponent(e).replace(
  /%([0-9A-F]{2})/gi,
  (n, r) => String.fromCharCode(parseInt(r, 16))
), dv = (e) => {
  if (!pe.isString(e))
    return e;
  try {
    return decodeURIComponent(e);
  } catch {
    return e;
  }
}, mv = (e, ...n) => {
  try {
    return !!e(...n);
  } catch {
    return !1;
  }
}, g$ = (e) => {
  const n = e.indexOf("://");
  let r = e;
  return n !== -1 && (r = r.slice(n + 3)), r.includes("@") || r.includes(":");
}, v$ = (e) => {
  const n = pe.global !== void 0 && pe.global !== null ? pe.global : globalThis, { ReadableStream: r, TextEncoder: i } = n;
  e = pe.merge.call(
    {
      skipUndefined: !0
    },
    {
      Request: n.Request,
      Response: n.Response
    },
    e
  );
  const { fetch: a, Request: o, Response: s } = e, l = a ? Qo(a) : typeof fetch == "function", u = Qo(o), p = Qo(s);
  if (!l)
    return !1;
  const d = l && Qo(r), f = l && (typeof i == "function" ? /* @__PURE__ */ ((x) => (g) => x.encode(g))(new i()) : async (x) => new Uint8Array(await new o(x).arrayBuffer())), h = u && d && mv(() => {
    let x = !1;
    const g = new o(Pt.origin, {
      body: new r(),
      method: "POST",
      get duplex() {
        return x = !0, "half";
      }
    }), P = g.headers.has("Content-Type");
    return g.body != null && g.body.cancel(), x && !P;
  }), v = p && d && mv(() => pe.isReadableStream(new s("").body)), C = {
    stream: v && ((x) => x.body)
  };
  l && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((x) => {
    !C[x] && (C[x] = (g, P) => {
      let E = g && g[x];
      if (E)
        return E.call(g);
      throw new ln(
        `Response type '${x}' is not supported`,
        ln.ERR_NOT_SUPPORT,
        P
      );
    });
  });
  const j = async (x) => {
    if (x == null)
      return 0;
    if (pe.isBlob(x))
      return x.size;
    if (pe.isSpecCompliantForm(x))
      return (await new o(Pt.origin, {
        method: "POST",
        body: x
      }).arrayBuffer()).byteLength;
    if (pe.isArrayBufferView(x) || pe.isArrayBuffer(x))
      return x.byteLength;
    if (pe.isURLSearchParams(x) && (x = x + ""), pe.isString(x))
      return (await f(x)).byteLength;
  }, N = async (x, g) => {
    const P = pe.toFiniteNumber(x.getContentLength());
    return P ?? j(g);
  };
  return async (x) => {
    let {
      url: g,
      method: P,
      data: E,
      signal: I,
      cancelToken: w,
      timeout: A,
      onDownloadProgress: H,
      onUploadProgress: Y,
      responseType: ne,
      headers: W,
      withCredentials: B = "same-origin",
      fetchOptions: D,
      maxContentLength: M,
      maxBodyLength: Z
    } = Aw(x);
    const je = pe.isNumber(M) && M > -1, ge = pe.isNumber(Z) && Z > -1, ye = (Ie) => pe.hasOwnProp(x, Ie) ? x[Ie] : void 0;
    let ke = a || fetch;
    ne = ne ? (ne + "").toLowerCase() : "text";
    let q = u$(
      [I, w && w.toAbortSignal()],
      A
    ), _e = null;
    const De = q && q.unsubscribe && (() => {
      q.unsubscribe();
    });
    let G, Ye = null;
    const sn = () => new ln(
      "Request body larger than maxBodyLength limit",
      ln.ERR_BAD_REQUEST,
      x,
      _e
    );
    try {
      let Ie;
      const Ue = ye("auth");
      if (Ue) {
        const le = pe.getSafeProp(Ue, "username") || "", Se = pe.getSafeProp(Ue, "password") || "";
        Ie = {
          username: le,
          password: Se
        };
      }
      if (g$(g)) {
        const le = new URL(g, Pt.origin);
        if (!Ie && (le.username || le.password)) {
          const Se = dv(le.username), Ae = dv(le.password);
          Ie = {
            username: Se,
            password: Ae
          };
        }
        (le.username || le.password) && (le.username = "", le.password = "", g = le.href);
      }
      if (Ie && (W.delete("authorization"), W.set(
        "Authorization",
        "Basic " + btoa(y$((Ie.username || "") + ":" + (Ie.password || "")))
      )), je && typeof g == "string" && g.startsWith("data:") && h$(g) > M)
        throw new ln(
          "maxContentLength size of " + M + " exceeded",
          ln.ERR_BAD_RESPONSE,
          x,
          _e
        );
      if (ge && P !== "get" && P !== "head") {
        const le = await j(E);
        if (typeof le == "number" && isFinite(le) && (G = le, le > Z))
          throw sn();
      }
      const Pe = ge && (pe.isReadableStream(E) || pe.isStream(E)), Be = (le, Se, Ae) => cv(
        le,
        uv,
        (Re) => {
          if (ge && Re > Z)
            throw Ye = sn();
          Se && Se(Re);
        },
        Ae
      );
      if (h && P !== "get" && P !== "head" && (Y || Pe)) {
        if (G = G ?? await N(W, E), G !== 0 || Pe) {
          let le = new o(g, {
            method: "POST",
            body: E,
            duplex: "half"
          }), Se;
          if (pe.isFormData(E) && (Se = le.headers.get("content-type")) && W.setContentType(Se), le.body) {
            const [Ae, Re] = Y && av(
              G,
              Js(ov(Y))
            ) || [];
            E = Be(le.body, Ae, Re);
          }
        }
      } else if (Pe && !u && d && P !== "get" && P !== "head")
        E = Be(E);
      else if (Pe && u && !h && P !== "get" && P !== "head")
        throw new ln(
          "Stream request bodies are not supported by the current fetch implementation",
          ln.ERR_NOT_SUPPORT,
          x,
          _e
        );
      pe.isString(B) || (B = B ? "include" : "omit");
      const Le = u && "credentials" in o.prototype;
      if (pe.isFormData(E)) {
        const le = W.getContentType();
        le && /^multipart\/form-data/i.test(le) && !/boundary=/i.test(le) && W.delete("content-type");
      }
      W.set("User-Agent", "axios/" + ky, !1);
      const Xe = {
        ...D,
        signal: q,
        method: P.toUpperCase(),
        headers: ww(W.normalize()),
        body: E,
        duplex: "half",
        credentials: Le ? B : void 0
      };
      _e = u && new o(g, Xe);
      let Fe = await (u ? ke(_e, D) : ke(g, Xe));
      const Me = Ut.from(Fe.headers);
      if (je) {
        const le = pe.toFiniteNumber(Me.getContentLength());
        if (le != null && le > M)
          throw new ln(
            "maxContentLength size of " + M + " exceeded",
            ln.ERR_BAD_RESPONSE,
            x,
            _e
          );
      }
      const nn = v && (ne === "stream" || ne === "response");
      if (v && Fe.body && (H || je || nn && De)) {
        const le = {};
        ["status", "statusText", "headers"].forEach(($) => {
          le[$] = Fe[$];
        });
        const Se = pe.toFiniteNumber(Me.getContentLength()), [Ae, Re] = H && av(
          Se,
          Js(ov(H), !0)
        ) || [];
        let yn = 0;
        const Q = ($) => {
          if (je && (yn = $, yn > M))
            throw new ln(
              "maxContentLength size of " + M + " exceeded",
              ln.ERR_BAD_RESPONSE,
              x,
              _e
            );
          Ae && Ae($);
        };
        Fe = new s(
          cv(Fe.body, uv, Q, () => {
            Re && Re(), De && De();
          }),
          le
        );
      }
      ne = ne || "text";
      let se = await C[pe.findKey(C, ne) || "text"](
        Fe,
        x
      );
      if (je && !v && !nn) {
        let le;
        if (se != null && (typeof se.byteLength == "number" ? le = se.byteLength : typeof se.size == "number" ? le = se.size : typeof se == "string" && (le = typeof i == "function" ? new i().encode(se).byteLength : se.length)), typeof le == "number" && le > M)
          throw new ln(
            "maxContentLength size of " + M + " exceeded",
            ln.ERR_BAD_RESPONSE,
            x,
            _e
          );
      }
      return !nn && De && De(), await new Promise((le, Se) => {
        Pw(le, Se, {
          data: se,
          headers: Ut.from(Fe.headers),
          status: Fe.status,
          statusText: Fe.statusText,
          config: x,
          request: _e
        });
      });
    } catch (Ie) {
      if (De && De(), q && q.aborted && q.reason instanceof ln) {
        const Ue = q.reason;
        throw Ue.config = x, _e && (Ue.request = _e), Ie !== Ue && (Ue.cause = Ie), Ue;
      }
      throw Ye ? (_e && !Ye.request && (Ye.request = _e), Ye) : Ie instanceof ln ? (_e && !Ie.request && (Ie.request = _e), Ie) : Ie && Ie.name === "TypeError" && /Load failed|fetch/i.test(Ie.message) ? Object.assign(
        new ln(
          "Network Error",
          ln.ERR_NETWORK,
          x,
          _e,
          Ie && Ie.response
        ),
        {
          cause: Ie.cause || Ie
        }
      ) : ln.from(Ie, Ie && Ie.code, x, _e, Ie && Ie.response);
    }
  };
}, k$ = /* @__PURE__ */ new Map(), Lw = (e) => {
  let n = e && e.env || {};
  const { fetch: r, Request: i, Response: a } = n, o = [i, a, r];
  let s = o.length, l = s, u, p, d = k$;
  for (; l--; )
    u = o[l], p = d.get(u), p === void 0 && d.set(u, p = l ? /* @__PURE__ */ new Map() : v$(n)), d = p;
  return p;
};
Lw();
const by = {
  http: TE,
  xhr: c$,
  fetch: {
    get: Lw
  }
};
pe.forEach(by, (e, n) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { __proto__: null, value: n });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { __proto__: null, value: n });
  }
});
const pv = (e) => `- ${e}`, b$ = (e) => pe.isFunction(e) || e === null || e === !1;
function x$(e, n) {
  e = pe.isArray(e) ? e : [e];
  const { length: r } = e;
  let i, a;
  const o = {};
  for (let s = 0; s < r; s++) {
    i = e[s];
    let l;
    if (a = i, !b$(i) && (a = by[(l = String(i)).toLowerCase()], a === void 0))
      throw new ln(`Unknown adapter '${l}'`);
    if (a && (pe.isFunction(a) || (a = a.get(n))))
      break;
    o[l || "#" + s] = a;
  }
  if (!a) {
    const s = Object.entries(o).map(
      ([u, p]) => `adapter ${u} ` + (p === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let l = r ? s.length > 1 ? `since :
` + s.map(pv).join(`
`) : " " + pv(s[0]) : "as no adapter specified";
    throw new ln(
      "There is no suitable adapter to dispatch the request " + l,
      "ERR_NOT_SUPPORT"
    );
  }
  return a;
}
const Vw = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: x$,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: by
};
function Xl(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Ao(null, e);
}
function fv(e) {
  return Xl(e), e.headers = Ut.from(e.headers), e.data = Ql.call(e, e.transformRequest), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Vw.getAdapter(e.adapter || Ro.adapter, e)(e).then(
    function(i) {
      Xl(e), e.response = i;
      try {
        i.data = Ql.call(e, e.transformResponse, i);
      } finally {
        delete e.response;
      }
      return i.headers = Ut.from(i.headers), i;
    },
    function(i) {
      if (!Dw(i) && (Xl(e), i && i.response)) {
        e.response = i.response;
        try {
          i.response.data = Ql.call(
            e,
            e.transformResponse,
            i.response
          );
        } finally {
          delete e.response;
        }
        i.response.headers = Ut.from(i.response.headers);
      }
      return Promise.reject(i);
    }
  );
}
const jl = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
  jl[e] = function(i) {
    return typeof i === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
const hv = {};
jl.transitional = function(n, r, i) {
  function a(o, s) {
    return "[Axios v" + ky + "] Transitional option '" + o + "'" + s + (i ? ". " + i : "");
  }
  return (o, s, l) => {
    if (n === !1)
      throw new ln(
        a(s, " has been removed" + (r ? " in " + r : "")),
        ln.ERR_DEPRECATED
      );
    return r && !hv[s] && (hv[s] = !0, console.warn(
      a(
        s,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), n ? n(o, s, l) : !0;
  };
};
jl.spelling = function(n) {
  return (r, i) => (console.warn(`${i} is likely a misspelling of ${n}`), !0);
};
function _$(e, n, r) {
  if (typeof e != "object")
    throw new ln("options must be an object", ln.ERR_BAD_OPTION_VALUE);
  const i = Object.keys(e);
  let a = i.length;
  for (; a-- > 0; ) {
    const o = i[a], s = Object.prototype.hasOwnProperty.call(n, o) ? n[o] : void 0;
    if (s) {
      const l = e[o], u = l === void 0 || s(l, o, e);
      if (u !== !0)
        throw new ln(
          "option " + o + " must be " + u,
          ln.ERR_BAD_OPTION_VALUE
        );
      continue;
    }
    if (r !== !0)
      throw new ln("Unknown option " + o, ln.ERR_BAD_OPTION);
  }
}
const Os = {
  assertOptions: _$,
  validators: jl
}, zt = Os.validators;
let $i = class {
  constructor(n) {
    this.defaults = n || {}, this.interceptors = {
      request: new rv(),
      response: new rv()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(n, r) {
    try {
      return await this._request(n, r);
    } catch (i) {
      if (i instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const o = (() => {
          if (!a.stack)
            return "";
          const s = a.stack.indexOf(`
`);
          return s === -1 ? "" : a.stack.slice(s + 1);
        })();
        try {
          if (!i.stack)
            i.stack = o;
          else if (o) {
            const s = o.indexOf(`
`), l = s === -1 ? -1 : o.indexOf(`
`, s + 1), u = l === -1 ? "" : o.slice(l + 1);
            String(i.stack).endsWith(u) || (i.stack += `
` + o);
          }
        } catch {
        }
      }
      throw i;
    }
  }
  _request(n, r) {
    typeof n == "string" ? (r = r || {}, r.url = n) : r = n || {}, r = Ai(this.defaults, r);
    const { transitional: i, paramsSerializer: a, headers: o } = r;
    i !== void 0 && Os.assertOptions(
      i,
      {
        silentJSONParsing: zt.transitional(zt.boolean),
        forcedJSONParsing: zt.transitional(zt.boolean),
        clarifyTimeoutError: zt.transitional(zt.boolean),
        legacyInterceptorReqResOrdering: zt.transitional(zt.boolean),
        advertiseZstdAcceptEncoding: zt.transitional(zt.boolean),
        validateStatusUndefinedResolves: zt.transitional(zt.boolean)
      },
      !1
    ), a != null && (pe.isFunction(a) ? r.paramsSerializer = {
      serialize: a
    } : Os.assertOptions(
      a,
      {
        encode: zt.function,
        serialize: zt.function
      },
      !0
    )), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), Os.assertOptions(
      r,
      {
        baseUrl: zt.spelling("baseURL"),
        withXsrfToken: zt.spelling("withXSRFToken")
      },
      !0
    ), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let s = o && pe.merge(o.common, o[r.method]);
    o && pe.forEach(["delete", "get", "head", "post", "put", "patch", "query", "common"], (C) => {
      delete o[C];
    }), r.headers = Ut.concat(s, o);
    const l = [];
    let u = !0;
    this.interceptors.request.forEach(function(j) {
      if (typeof j.runWhen == "function" && j.runWhen(r) === !1)
        return;
      u = u && j.synchronous;
      const N = r.transitional || gy;
      N && N.legacyInterceptorReqResOrdering ? l.unshift(j.fulfilled, j.rejected) : l.push(j.fulfilled, j.rejected);
    });
    const p = [];
    this.interceptors.response.forEach(function(j) {
      p.push(j.fulfilled, j.rejected);
    });
    let d, f = 0, h;
    if (!u) {
      const C = [fv.bind(this), void 0];
      for (C.unshift(...l), C.push(...p), h = C.length, d = Promise.resolve(r); f < h; )
        d = d.then(C[f++], C[f++]);
      return d;
    }
    h = l.length;
    let v = r;
    for (; f < h; ) {
      const C = l[f++], j = l[f++];
      try {
        v = C(v);
      } catch (N) {
        j.call(this, N);
        break;
      }
    }
    try {
      d = fv.call(this, v);
    } catch (C) {
      return Promise.reject(C);
    }
    for (f = 0, h = p.length; f < h; )
      d = d.then(p[f++], p[f++]);
    return d;
  }
  getUri(n) {
    n = Ai(this.defaults, n);
    const r = Rw(n.baseURL, n.url, n.allowAbsoluteUrls, n);
    return $w(r, n.params, n.paramsSerializer);
  }
};
pe.forEach(["delete", "get", "head", "options"], function(n) {
  $i.prototype[n] = function(r, i) {
    return this.request(
      Ai(i || {}, {
        method: n,
        url: r,
        data: i && pe.hasOwnProp(i, "data") ? i.data : void 0
      })
    );
  };
});
pe.forEach(["post", "put", "patch", "query"], function(n) {
  function r(i) {
    return function(o, s, l) {
      return this.request(
        Ai(l || {}, {
          method: n,
          headers: i ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: o,
          data: s
        })
      );
    };
  }
  $i.prototype[n] = r(), n !== "query" && ($i.prototype[n + "Form"] = r(!0));
});
let S$ = class zw {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(o) {
      r = o;
    });
    const i = this;
    this.promise.then((a) => {
      if (!i._listeners) return;
      let o = i._listeners.length;
      for (; o-- > 0; )
        i._listeners[o](a);
      i._listeners = null;
    }), this.promise.then = (a) => {
      let o;
      const s = new Promise((l) => {
        i.subscribe(l), o = l;
      }).then(a);
      return s.cancel = function() {
        i.unsubscribe(o);
      }, s;
    }, n(function(o, s, l) {
      i.reason || (i.reason = new Ao(o, s, l), r(i.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(n);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const n = new AbortController(), r = (i) => {
      n.abort(i);
    };
    return this.subscribe(r), n.signal.unsubscribe = () => this.unsubscribe(r), n.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new zw(function(a) {
        n = a;
      }),
      cancel: n
    };
  }
};
function N$(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function j$(e) {
  return pe.isObject(e) && e.isAxiosError === !0;
}
const _h = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(_h).forEach(([e, n]) => {
  _h[n] = e;
});
function Uw(e) {
  const n = new $i(e), r = gw($i.prototype.request, n);
  return pe.extend(r, $i.prototype, n, { allOwnKeys: !0 }), pe.extend(r, n, null, { allOwnKeys: !0 }), r.create = function(a) {
    return Uw(Ai(e, a));
  }, r;
}
const kt = Uw(Ro);
kt.Axios = $i;
kt.CanceledError = Ao;
kt.CancelToken = S$;
kt.isCancel = Dw;
kt.VERSION = ky;
kt.toFormData = Nl;
kt.AxiosError = ln;
kt.Cancel = kt.CanceledError;
kt.all = function(n) {
  return Promise.all(n);
};
kt.spread = N$;
kt.isAxiosError = j$;
kt.mergeConfig = Ai;
kt.AxiosHeaders = Ut;
kt.formToJSON = (e) => Ow(pe.isHTMLForm(e) ? new FormData(e) : e);
kt.getAdapter = Vw.getAdapter;
kt.HttpStatusCode = _h;
kt.default = kt;
const {
  Axios: m8,
  AxiosError: p8,
  CanceledError: f8,
  isCancel: h8,
  CancelToken: y8,
  VERSION: g8,
  all: v8,
  Cancel: k8,
  isAxiosError: w$,
  spread: b8,
  toFormData: x8,
  AxiosHeaders: _8,
  HttpStatusCode: S8,
  formToJSON: N8,
  getAdapter: j8,
  mergeConfig: w8,
  create: C8
} = kt;
class C$ {
  /** Checks whether the app is running as an electron application. */
  isElectron() {
    return window.electron ? !!window.electron : !!process?.versions?.electron || /electron/i.test(navigator.userAgent);
  }
  /**
   * Gets the electron version.
   *
   * version 0.0.0 represents a unsupported version
   */
  async getVersion() {
    return window.electron ? (await window.electron.getVersion()).split("-")[0] : "0.0.0";
  }
  /** Checks if the running Electron build is a standalone (non auto-updating windows version) */
  async isStandaloneBuild() {
    return window.electron?.isStandaloneBuild ? await window.electron.isStandaloneBuild() : null;
  }
  /** Checks if the running Electron build is installed from an windows MSI installer */
  async isMsiBuild() {
    return window.electron?.isMsiBuild ? await window.electron.isMsiBuild() : null;
  }
}
const yv = new C$();
function I$(e, n) {
  return gv(e), gv(n), e.localeCompare(n, void 0, {
    numeric: !0
  });
}
function gv(e) {
  if (e.split(".").length !== 3)
    throw Error(`The version '${e}' must be in the format 'x.x.x'.`);
}
const F$ = Object.prototype.toString;
function E$(e, n) {
  return F$.call(e) === `[object ${n}]`;
}
function $$(e) {
  return E$(e, "Object");
}
function T$(e) {
  return !!(e && e.then && typeof e.then == "function");
}
const ko = "8.36.0", ti = globalThis;
function xy(e, n, r) {
  const i = r || ti, a = i.__SENTRY__ = i.__SENTRY__ || {}, o = a[ko] = a[ko] || {};
  return o[e] || (o[e] = n());
}
const Mw = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, O$ = "Sentry Logger ", vv = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], kv = {};
function Bw(e) {
  if (!("console" in ti))
    return e();
  const n = ti.console, r = {}, i = Object.keys(kv);
  i.forEach((a) => {
    const o = kv[a];
    r[a] = n[a], n[a] = o;
  });
  try {
    return e();
  } finally {
    i.forEach((a) => {
      n[a] = r[a];
    });
  }
}
function D$() {
  let e = !1;
  const n = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    },
    isEnabled: () => e
  };
  return Mw ? vv.forEach((r) => {
    n[r] = (...i) => {
      e && Bw(() => {
        ti.console[r](`${O$}[${r}]:`, ...i);
      });
    };
  }) : vv.forEach((r) => {
    n[r] = () => {
    };
  }), n;
}
const Ds = xy("logger", D$);
function P$(e, n, r) {
  try {
    Object.defineProperty(e, n, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: r,
      writable: !0,
      configurable: !0
    });
  } catch {
    Mw && Ds.log(`Failed to add non-enumerable property "${n}" to object`, e);
  }
}
const qw = 1e3;
function _y() {
  return Date.now() / qw;
}
function R$() {
  const { performance: e } = ti;
  if (!e || !e.now)
    return _y;
  const n = Date.now() - e.now(), r = e.timeOrigin == null ? n : e.timeOrigin;
  return () => (r + e.now()) / qw;
}
const A$ = R$();
(() => {
  const { performance: e } = ti;
  if (!e || !e.now)
    return;
  const n = 3600 * 1e3, r = e.now(), i = Date.now(), a = e.timeOrigin ? Math.abs(e.timeOrigin + r - i) : n, o = a < n, s = e.timing && e.timing.navigationStart, u = typeof s == "number" ? Math.abs(s + r - i) : n, p = u < n;
  return o || p ? a <= u ? e.timeOrigin : s : i;
})();
function sa() {
  const e = ti, n = e.crypto || e.msCrypto;
  let r = () => Math.random() * 16;
  try {
    if (n && n.randomUUID)
      return n.randomUUID().replace(/-/g, "");
    n && n.getRandomValues && (r = () => {
      const i = new Uint8Array(1);
      return n.getRandomValues(i), i[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (i) => (
      // eslint-disable-next-line no-bitwise
      (i ^ (r() & 15) >> i / 4).toString(16)
    )
  );
}
function bv() {
  return {
    traceId: sa(),
    spanId: sa().substring(16)
  };
}
function Sy() {
  return Ny(ti), ti;
}
function Ny(e) {
  const n = e.__SENTRY__ = e.__SENTRY__ || {};
  return n.version = n.version || ko, n[ko] = n[ko] || {};
}
function L$(e, n = {}) {
  if (n.user && (!e.ipAddress && n.user.ip_address && (e.ipAddress = n.user.ip_address), !e.did && !n.did && (e.did = n.user.id || n.user.email || n.user.username)), e.timestamp = n.timestamp || A$(), n.abnormal_mechanism && (e.abnormal_mechanism = n.abnormal_mechanism), n.ignoreDuration && (e.ignoreDuration = n.ignoreDuration), n.sid && (e.sid = n.sid.length === 32 ? n.sid : sa()), n.init !== void 0 && (e.init = n.init), !e.did && n.did && (e.did = `${n.did}`), typeof n.started == "number" && (e.started = n.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof n.duration == "number")
    e.duration = n.duration;
  else {
    const r = e.timestamp - e.started;
    e.duration = r >= 0 ? r : 0;
  }
  n.release && (e.release = n.release), n.environment && (e.environment = n.environment), !e.ipAddress && n.ipAddress && (e.ipAddress = n.ipAddress), !e.userAgent && n.userAgent && (e.userAgent = n.userAgent), typeof n.errors == "number" && (e.errors = n.errors), n.status && (e.status = n.status);
}
const Sh = "_sentrySpan";
function xv(e, n) {
  n ? P$(e, Sh, n) : delete e[Sh];
}
function _v(e) {
  return e[Sh];
}
const V$ = 100;
class jy {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = bv();
  }
  /**
   * @inheritDoc
   */
  clone() {
    const n = new jy();
    return n._breadcrumbs = [...this._breadcrumbs], n._tags = { ...this._tags }, n._extra = { ...this._extra }, n._contexts = { ...this._contexts }, n._user = this._user, n._level = this._level, n._session = this._session, n._transactionName = this._transactionName, n._fingerprint = this._fingerprint, n._eventProcessors = [...this._eventProcessors], n._requestSession = this._requestSession, n._attachments = [...this._attachments], n._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, n._propagationContext = { ...this._propagationContext }, n._client = this._client, n._lastEventId = this._lastEventId, xv(n, _v(this)), n;
  }
  /**
   * @inheritDoc
   */
  setClient(n) {
    this._client = n;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(n) {
    this._lastEventId = n;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(n) {
    this._scopeListeners.push(n);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(n) {
    return this._eventProcessors.push(n), this;
  }
  /**
   * @inheritDoc
   */
  setUser(n) {
    return this._user = n || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && L$(this._session, { user: n }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(n) {
    return this._requestSession = n, this;
  }
  /**
   * @inheritDoc
   */
  setTags(n) {
    return this._tags = {
      ...this._tags,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(n, r) {
    return this._tags = { ...this._tags, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(n) {
    return this._extra = {
      ...this._extra,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(n, r) {
    return this._extra = { ...this._extra, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(n) {
    return this._fingerprint = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(n) {
    return this._level = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(n) {
    return this._transactionName = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(n, r) {
    return r === null ? delete this._contexts[n] : this._contexts[n] = r, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(n) {
    return n ? this._session = n : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(n) {
    if (!n)
      return this;
    const r = typeof n == "function" ? n(this) : n, [i, a] = r instanceof ya ? [r.getScopeData(), r.getRequestSession()] : $$(r) ? [n, n.requestSession] : [], { tags: o, extra: s, user: l, contexts: u, level: p, fingerprint: d = [], propagationContext: f } = i || {};
    return this._tags = { ...this._tags, ...o }, this._extra = { ...this._extra, ...s }, this._contexts = { ...this._contexts, ...u }, l && Object.keys(l).length && (this._user = l), p && (this._level = p), d.length && (this._fingerprint = d), f && (this._propagationContext = f), a && (this._requestSession = a), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, xv(this, void 0), this._attachments = [], this._propagationContext = bv(), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(n, r) {
    const i = typeof r == "number" ? r : V$;
    if (i <= 0)
      return this;
    const a = {
      timestamp: _y(),
      ...n
    }, o = this._breadcrumbs;
    return o.push(a), this._breadcrumbs = o.length > i ? o.slice(-i) : o, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(n) {
    return this._attachments.push(n), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: _v(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(n) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...n }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(n) {
    return this._propagationContext = n, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(n, r) {
    const i = r && r.event_id ? r.event_id : sa();
    if (!this._client)
      return Ds.warn("No client configured on scope - will not capture exception!"), i;
    const a = new Error("Sentry syntheticException");
    return this._client.captureException(
      n,
      {
        originalException: n,
        syntheticException: a,
        ...r,
        event_id: i
      },
      this
    ), i;
  }
  /**
   * @inheritDoc
   */
  captureMessage(n, r, i) {
    const a = i && i.event_id ? i.event_id : sa();
    if (!this._client)
      return Ds.warn("No client configured on scope - will not capture message!"), a;
    const o = new Error(n);
    return this._client.captureMessage(
      n,
      r,
      {
        originalException: n,
        syntheticException: o,
        ...i,
        event_id: a
      },
      this
    ), a;
  }
  /**
   * @inheritDoc
   */
  captureEvent(n, r) {
    const i = r && r.event_id ? r.event_id : sa();
    return this._client ? (this._client.captureEvent(n, { ...r, event_id: i }, this), i) : (Ds.warn("No client configured on scope - will not capture event!"), i);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((n) => {
      n(this);
    }), this._notifyingListeners = !1);
  }
}
const ya = jy;
function z$() {
  return xy("defaultCurrentScope", () => new ya());
}
function U$() {
  return xy("defaultIsolationScope", () => new ya());
}
class M$ {
  constructor(n, r) {
    let i;
    n ? i = n : i = new ya();
    let a;
    r ? a = r : a = new ya(), this._stack = [{ scope: i }], this._isolationScope = a;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(n) {
    const r = this._pushScope();
    let i;
    try {
      i = n(r);
    } catch (a) {
      throw this._popScope(), a;
    }
    return T$(i) ? i.then(
      (a) => (this._popScope(), a),
      (a) => {
        throw this._popScope(), a;
      }
    ) : (this._popScope(), i);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const n = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: n
    }), n;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function ga() {
  const e = Sy(), n = Ny(e);
  return n.stack = n.stack || new M$(z$(), U$());
}
function B$(e) {
  return ga().withScope(e);
}
function q$(e, n) {
  const r = ga();
  return r.withScope(() => (r.getStackTop().scope = e, n(e)));
}
function Sv(e) {
  return ga().withScope(() => e(ga().getIsolationScope()));
}
function H$() {
  return {
    withIsolationScope: Sv,
    withScope: B$,
    withSetScope: q$,
    withSetIsolationScope: (e, n) => Sv(n),
    getCurrentScope: () => ga().getScope(),
    getIsolationScope: () => ga().getIsolationScope()
  };
}
function Hw(e) {
  const n = Ny(e);
  return n.acs ? n.acs : H$();
}
function wy() {
  const e = Sy();
  return Hw(e).getCurrentScope();
}
function Ww() {
  const e = Sy();
  return Hw(e).getIsolationScope();
}
function W$() {
  return wy().getClient();
}
function K$(e) {
  if (e)
    return G$(e) ? { captureContext: e } : J$(e) ? {
      captureContext: e
    } : e;
}
function G$(e) {
  return e instanceof ya || typeof e == "function";
}
const Y$ = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function J$(e) {
  return Object.keys(e).some((n) => Y$.includes(n));
}
function Nv(e, n) {
  return wy().captureException(e, K$(n));
}
function Q$(e, n) {
  const r = typeof n == "string" ? n : void 0, i = typeof n != "string" ? { captureContext: n } : void 0;
  return wy().captureMessage(e, r, i);
}
function X$(e, n) {
  Ww().setContext(e, n);
}
const Z$ = 100;
function Ni(e, n) {
  const r = W$(), i = Ww();
  if (!r) return;
  const { beforeBreadcrumb: a = null, maxBreadcrumbs: o = Z$ } = r.getOptions();
  if (o <= 0) return;
  const l = { timestamp: _y(), ...e }, u = a ? Bw(() => a(l, n)) : l;
  u !== null && (r.emit && r.emit("beforeAddBreadcrumb", u, n), i.addBreadcrumb(u, o));
}
var $o;
(function(e) {
  e.Unknown = "unknown", e.Core = "core", e.Routing = "routing-and-presence", e.Insights = "insights", e.Ecosystem = "ecosystem", e.Partners = "partners", e.Channels = "channels", e.Messaging = "messaging", e.Platform = "platform", e.AI = "ai", e.Conversations = "conversations", e.Automation = "automation";
})($o || ($o = {}));
function la(e) {
  const n = e.split(".")[1];
  if (!n)
    throw Error("Invalid token");
  const r = n.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(Buffer.from(r, "base64").toString());
  } catch (i) {
    throw Error(`Failed to parse the JSON Web Token with the following error: ${i}`);
  }
}
const eT = Fo.backendDomain ? {
  "backend-domain": Fo.backendDomain
} : void 0;
function Ps() {
  const e = new URLSearchParams({
    noToken: "true",
    ...eT
  }).toString();
  document.location.href = `${Fo.url.logIn}?${e}`;
}
const Zl = "authData", ec = 30, nT = 600, nc = 5;
class tT {
  authData = null;
  /** The (server) time when the access token expires, in seconds. */
  accessTokenExpiresAt = 0;
  /**
   * The difference between client- and server-time, in seconds. Negative if
   * client is ahead of server, positive if server is ahead of client
   */
  clientServerTimeDiff = 0;
  /**
   * Returns an estimated server time (unix epoch in seconds) by adding the
   * client-server time difference to the current client time.
   *
   * The time-diff is stored whenever a new access token is saved.
   *
   * @returns {number} The estimated server time in seconds.
   */
  estimatedServerTime() {
    const n = Date.now() / 1e3;
    return this.clientServerTimeDiff >= nc || this.clientServerTimeDiff <= -nc ? Math.ceil(n + this.clientServerTimeDiff) : Math.ceil(n);
  }
  /**
   * Sets the auth data in localStorage.
   *
   * @param authData The auth data.
   */
  setAuthData(n) {
    this.authData = n;
    const i = Math.ceil(Date.now() / 1e3) + nT, a = la(n.access_token).exp;
    if (this.clientServerTimeDiff = a - i, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > nc) {
      const o = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
      console.info(`Client time is ${o} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
    }
    this.accessTokenExpiresAt = a, localStorage.setItem(Zl, JSON.stringify(n));
  }
  /** Gets the auth data from memory or localStorage. */
  getAuthData() {
    if (this.authData)
      return this.authData;
    const n = localStorage.getItem(Zl), r = n ? JSON.parse(n) : null;
    return this.validateAuthDataComplete(r) && (this.authData = r), r;
  }
  /** Removes the auth data from localStorage. */
  removeAuthData() {
    this.authData = null, localStorage.removeItem(Zl);
  }
  getAccessToken() {
    return this.authData?.access_token || null;
  }
  getRefreshToken() {
    return this.authData?.refresh_token || null;
  }
  /**
   * Validates that the auth data is complete - i.e not fragmented.
   *
   * @param authData The auth data.
   */
  validateAuthDataComplete(n) {
    return n ? [
      "access_token",
      "refresh_token",
      "expires_in"
    ].every((i) => typeof n[i] < "u") : !1;
  }
  isAccessTokenExpired() {
    if (!this.getAccessToken())
      return !0;
    const r = this.accessTokenExpiresAt - ec;
    return this.estimatedServerTime() >= r;
  }
  isRefreshTokenExpired(n) {
    if (!n)
      return !0;
    const r = la(n), i = r.exp - ec;
    return !r || this.estimatedServerTime() >= i;
  }
  accessTokenExpiresInMs() {
    return (this.accessTokenExpiresAt - ec - this.estimatedServerTime()) * 1e3;
  }
}
const Et = new tT();
async function rT(e) {
  const n = window.location.origin.replace(/^https?:\/\//, ""), r = ["localhost:8080", "uptrends-monitor"];
  if (!(!e.response || r.some((i) => n.includes(i)))) {
    try {
      const i = e.response.config.headers.Authorization ?? "", a = i ? i.toString()?.split("Basic ")[1] : "", o = a ? atob(a).split("token:")[1] : "", s = o ? la(o).exp : "None", l = await wl.getAuthData({ localStorageOnly: !0 }), u = Math.floor(Date.now() / 1e3), p = l?.access_token, d = l?.refresh_token, f = p ? la(p).exp : "None", h = d ? la(d).exp : "None", v = typeof s == "number" ? u - s : "Unknown", C = typeof f == "number" ? u - f : "Unknown", j = typeof h == "number" ? u - h : "Unknown", N = e.response.headers["x-dixa-rid"];
      X$("Expires", {
        currentTimestamp: u,
        accessTokenFromHeader: s,
        accessTokenFromHeaderDiff: v,
        accessTokenFromLocalStorage: f,
        accessTokenFromLocalStorageDiff: C,
        refreshTokenFromLocalStorage: h,
        refreshTokenFromLocalStorageDiff: j,
        xDixaRid: N,
        navigatorOnline: navigator.onLine
      });
    } catch (i) {
      console.error("Error adding Sentry error context", i);
    }
    Q$("401 unauthorized interceptor", {
      level: "debug",
      tags: {
        team: $o.Platform,
        domain: n
      }
    });
  }
}
const tc = /* @__PURE__ */ new Map(), iT = 3;
function aT(e) {
  e.interceptors.response.use((n) => (tc.delete(n.config.url), n), (n) => {
    if (n.response) {
      const { status: r } = n.response;
      switch (r) {
        case Nh.Unauthorized:
          if (!wl.isRefreshTokenExpired() && n.config) {
            Ni({
              category: "errorInterceptor",
              message: "Access token expired after request",
              level: "debug"
            });
            const i = tc.get(n.config.url) ?? 0;
            if (console.log(`Retrying request (${i + 1}): ${n.config.url}`), i <= iT)
              return tc.set(n.config.url, i + 1), e(n.config);
          }
          rT(n), console.error("401 unauthorized interceptor"), Ps();
          break;
      }
    }
    return Promise.reject(n);
  });
}
const Kw = kt.create();
aT(Kw);
const Gr = console.log;
async function jv(e) {
  return new Promise((n) => setTimeout(n, e * 1e3));
}
class oT extends Error {
  constructor(n, r) {
    super(n, r);
  }
}
function sT(e = 0) {
  return Math.min(Math.round((Math.random() + 1) * Math.pow(1.5, e)), 30);
}
const lT = 5;
class cT {
  authDataPromise = null;
  retryCount = 0;
  async init(n) {
    const r = await this.refresh(n);
    if (r)
      Et.setAuthData(r);
    else {
      const i = Et.isRefreshTokenExpired(n) ? "expired" : "unknown";
      throw new oT("Failed to init refresh token", {
        cause: i
      });
    }
  }
  getDebugInfo() {
    const n = Et.getAccessToken();
    if (!n)
      return {};
    const r = la(n), { exp: i } = r;
    return {
      expire: i ? new Date(i * 1e3).toISOString() : null,
      now: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
  /**
   * Gets auth data from LocalStorage, or fetches new auth data if the current
   * token is expired or is about to expire.
   */
  async getAuthData({ localStorageOnly: n = !1 } = {}) {
    if (n)
      return Et.getAuthData();
    if (this.authDataPromise)
      return await this.authDataPromise;
    const r = Et.getAuthData();
    return r ? Et.isAccessTokenExpired() ? (Ni({
      category: "refreshToken",
      // Cannot include "token" in the message, as it will be redacted
      message: "expired or about to expire",
      level: "debug",
      data: this.getDebugInfo()
    }), this.authDataPromise = this.refresh(r.refresh_token).then((i) => (i && Et.setAuthData(i), this.authDataPromise = null, i)), await this.authDataPromise) : r : null;
  }
  removeAuthData() {
    return Et.removeAuthData();
  }
  validateAuthDataComplete(n) {
    return Et.validateAuthDataComplete(n);
  }
  isAccessTokenExpired() {
    return Et.isAccessTokenExpired();
  }
  isRefreshTokenExpired() {
    const n = Et.getAuthData();
    return n ? Et.isRefreshTokenExpired(n.refresh_token) : !0;
  }
  /** Checks whether refresh token is supported. */
  async isSupported() {
    if (!yv.isElectron())
      return !0;
    const n = await yv.getVersion();
    return I$(n, "3.7.0") === 1;
  }
  /**
   * Gets refreshed tokens from the API
   *
   * @param refreshToken The refresh token.
   * @param retriesLeft The number of retries left.
   */
  async refresh(n, r = lT) {
    try {
      return await Kw.post(`${Fo.url.rest}/v2/login/refresh`, {
        refreshToken: n
      }).then((i) => (this.retryCount = 0, i.data.data));
    } catch (i) {
      return await this.handleRefreshError(i, n, r);
    }
  }
  async waitUntilOnline() {
    const n = navigator.onLine === !1;
    for (n && (Gr("AUTH", "Network connection offline - waiting..."), Ni({
      category: "refreshToken",
      message: "Network connection offline - waiting...",
      level: "debug"
    })); navigator.onLine === !1; )
      await jv(5);
    n && (Gr("AUTH", "Network connection restored"), Ni({
      category: "refreshToken",
      message: "Network connection restored",
      level: "debug"
    }));
  }
  async retryRefresh(n, r) {
    await this.waitUntilOnline(), this.retryCount++;
    const i = sT(this.retryCount);
    return Gr("AUTH", `Retrying in ${i} seconds`), await jv(i), await this.refresh(n, r);
  }
  async handleRefreshError(n, r, i) {
    if (Et.isRefreshTokenExpired(r))
      return Gr("AUTH", "Refresh token expired"), Ni({
        category: "refreshToken",
        message: "Refresh token expired",
        level: "debug"
      }), Et.removeAuthData(), Ps(), null;
    if (w$(n)) {
      if (n.message === "timeout exceeded")
        return Gr("AUTH", "Timeout exceeded"), Ni({
          category: "refreshToken",
          message: "Timeout exceeded",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.message === "Network Error")
        return Gr("AUTH", "Network error"), Ni({
          category: "refreshToken",
          message: "Network error",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.response?.status === 401)
        return Gr("AUTH", "Refresh token invalid (401)"), Et.removeAuthData(), Ps(), null;
      Nv(n, {
        level: "error",
        tags: {
          team: $o.Platform,
          errorSource: "authManager.refresh"
        }
      });
    }
    return i <= 0 ? (Gr("AUTH", "Retries exhausted, logging out"), Nv(n, {
      level: "error",
      tags: {
        team: $o.Platform,
        errorSource: "authManager.refresh"
      }
    }), Et.removeAuthData(), Ps(), null) : (Gr("AUTH", `Retrying ${i} more times`), await this.retryRefresh(r, i - 1));
  }
  accessTokenExpiresInMs() {
    return Et.accessTokenExpiresInMs();
  }
}
const wl = new cT();
var Nh;
(function(e) {
  e[e.BadRequest = 400] = "BadRequest", e[e.Unauthorized = 401] = "Unauthorized", e[e.Forbidden = 403] = "Forbidden", e[e.NotFound = 404] = "NotFound", e[e.Conflict = 409] = "Conflict", e[e.InternalServerError = 500] = "InternalServerError", e[e.BadGateway = 502] = "BadGateway", e[e.ServiceUnavailable = 503] = "ServiceUnavailable";
})(Nh || (Nh = {}));
const uT = new my((e, n) => new fw((r) => {
  wl.getAuthData().then((i) => {
    const a = i?.access_token, o = e.getContext().headers;
    return e.setContext({
      ...o,
      headers: {
        Authorization: a ? `Bearer ${a}` : ""
      }
    }), n(e).subscribe(r);
  }).catch((i) => r.error(i));
})), dT = new my(
  (e, n) => new fw((r) => {
    const i = e.getContext(), { headers: a, widgetId: o, widgetType: s, operationName: l } = i;
    wl.getAuthData().then((u) => (e.setContext({
      ...i,
      headers: {
        ...a,
        ...o && { "x-integration-widget-id": o },
        ...s && { "x-integration-widget-type": s },
        ...l && {
          "x-integration-widget-operation": l
        },
        ...LI(Fo.url.partnerIntegrations) && u?.access_token && VI(u.access_token)
      }
    }), n(e).subscribe(r))).catch((u) => r.error(u));
  })
), mT = new AbortController(), Gw = (e) => new hF({
  queryDeduplication: !1,
  cache: new yF(),
  link: my.from([
    uT,
    dT,
    gF({
      uri: `${e}/graphql`,
      fetch: _F,
      fetchOptions: {
        mode: "cors",
        // The `AbortSignal` object instance is used to communicate with a
        // fetch request and abort it if desired via an `AbortController`.
        // This prevents abandoned abort errors spiral up to Sentry.
        signal: mT.signal
      }
    })
  ]),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    query: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    mutate: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    }
  }
}), pT = ({
  configuration: e,
  children: n
}) => {
  const r = Xn(
    () => Gw(e.baseUrl),
    [e.baseUrl]
  );
  return /* @__PURE__ */ Ke.jsx(vF, { client: r, children: n });
};
function fT() {
  try {
    return kF(), !0;
  } catch {
    return !1;
  }
}
const hT = ({
  configuration: e,
  children: n
}) => fT() ? n : /* @__PURE__ */ Ke.jsx(pT, { configuration: e, children: n }), yT = ({
  integrationId: e,
  type: n,
  showNotification: r,
  showModal: i,
  children: a
}) => /* @__PURE__ */ Ke.jsx(bF, { children: (o) => /* @__PURE__ */ Ke.jsx(
  zI,
  {
    value: {
      useMutation: qI(e, n),
      useQuery: BI(e, n),
      useLazyQuery: MI(e, n),
      executeQuery: UI(e, n, o),
      showNotification: r,
      showModal: i ?? (() => null)
    },
    children: a
  }
) }), Yw = ({
  integrationId: e,
  type: n,
  configuration: r,
  showNotification: i,
  showModal: a,
  children: o
}) => {
  const s = !!e && !!n;
  return /* @__PURE__ */ Ke.jsx(hT, { configuration: r, children: s ? /* @__PURE__ */ Ke.jsx(
    yT,
    {
      integrationId: e,
      type: n,
      showNotification: i,
      showModal: a,
      children: o
    }
  ) : o });
}, gT = "_unmatchedHeader_qcj19_1", vT = {
  unmatchedHeader: gT
};
var Lo = (e) => e.type === "checkbox", Ii = (e) => e instanceof Date, Gt = (e) => e == null;
const Jw = (e) => typeof e == "object";
var gt = (e) => !Gt(e) && !Array.isArray(e) && Jw(e) && !Ii(e), Qw = (e) => gt(e) && e.target ? Lo(e.target) ? e.target.checked : e.target.value : e, kT = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, Xw = (e, n) => e.has(kT(n)), bT = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return gt(n) && n.hasOwnProperty("isPrototypeOf");
}, Cy = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Ot(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Cy && (e instanceof Blob || i)) && (r || gt(e)))
    if (n = r ? [] : {}, !r && !bT(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = Ot(e[a]));
  else
    return e;
  return n;
}
var Cl = (e) => Array.isArray(e) ? e.filter(Boolean) : [], ht = (e) => e === void 0, rn = (e, n, r) => {
  if (!n || !gt(e))
    return r;
  const i = Cl(n.split(/[,[\].]+?/)).reduce((a, o) => Gt(a) ? a : a[o], e);
  return ht(i) || i === e ? ht(e[n]) ? r : e[n] : i;
}, or = (e) => typeof e == "boolean", Iy = (e) => /^\w*$/.test(e), Zw = (e) => Cl(e.replace(/["|']|\]/g, "").split(/\.|\[/)), it = (e, n, r) => {
  let i = -1;
  const a = Iy(n) ? [n] : Zw(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let u = r;
    if (i !== s) {
      const p = e[l];
      u = gt(p) || Array.isArray(p) ? p : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = u, e = e[l];
  }
};
const Xs = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, jr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Yr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, eC = qe.createContext(null), Br = () => qe.useContext(eC), Fy = (e) => {
  const { children: n, ...r } = e;
  return qe.createElement(eC.Provider, { value: r }, n);
};
var nC = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== jr.all && (n._proxyFormState[s] = !i || jr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function xT(e) {
  const n = Br(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = qe.useState(r._formState), u = qe.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), p = qe.useRef(a);
  return p.current = a, qe.useEffect(() => r._subscribe({
    name: p.current,
    formState: u.current,
    exact: o,
    callback: (d) => {
      !i && l({
        ...r._formState,
        ...d
      });
    }
  }), [r, i, o]), qe.useEffect(() => {
    u.current.isValid && r._setValid(!0);
  }, [r]), qe.useMemo(() => nC(s, r, u.current, !1), [s, r]);
}
var Vr = (e) => typeof e == "string", tC = (e, n, r, i, a) => Vr(e) ? (i && n.watch.add(e), rn(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), rn(r, o))) : (i && (n.watchAll = !0), r);
function ca(e) {
  const n = Br(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = qe.useRef(i), u = qe.useRef(a);
  l.current = i, qe.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && d(tC(l.current, r._names, f.values || r._formValues, !1, u.current))
  }), [r, o, s]);
  const [p, d] = qe.useState(r._getWatch(i, a));
  return qe.useEffect(() => r._removeUnmounted()), p;
}
function Ey(e) {
  const n = Br(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = Xw(a._names.array, r), l = ca({
    control: a,
    name: r,
    defaultValue: rn(a._formValues, r, rn(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), u = xT({
    control: a,
    name: r,
    exact: !0
  }), p = qe.useRef(e), d = qe.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...or(e.disabled) ? { disabled: e.disabled } : {}
  })), f = qe.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!rn(u.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!rn(u.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!rn(u.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!rn(u.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => rn(u.errors, r)
    }
  }), [u, r]), h = qe.useCallback((N) => d.current.onChange({
    target: {
      value: Qw(N),
      name: r
    },
    type: Xs.CHANGE
  }), [r]), v = qe.useCallback(() => d.current.onBlur({
    target: {
      value: rn(a._formValues, r),
      name: r
    },
    type: Xs.BLUR
  }), [r, a._formValues]), C = qe.useCallback((N) => {
    const x = rn(a._fields, r);
    x && N && (x._f.ref = {
      focus: () => N.focus(),
      select: () => N.select(),
      setCustomValidity: (g) => N.setCustomValidity(g),
      reportValidity: () => N.reportValidity()
    });
  }, [a._fields, r]), j = qe.useMemo(() => ({
    name: r,
    value: l,
    ...or(i) || u.disabled ? { disabled: u.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: C
  }), [r, i, u.disabled, h, v, C, l]);
  return qe.useEffect(() => {
    const N = a._options.shouldUnregister || o;
    a.register(r, {
      ...p.current.rules,
      ...or(p.current.disabled) ? { disabled: p.current.disabled } : {}
    });
    const x = (g, P) => {
      const E = rn(a._fields, g);
      E && E._f && (E._f.mount = P);
    };
    if (x(r, !0), N) {
      const g = Ot(rn(a._options.defaultValues, r));
      it(a._defaultValues, r, g), ht(rn(a._formValues, r)) && it(a._formValues, r, g);
    }
    return !s && a.register(r), () => {
      (s ? N && !a._state.action : N) ? a.unregister(r) : x(r, !1);
    };
  }, [r, a, s, o]), qe.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), qe.useMemo(() => ({
    field: j,
    formState: u,
    fieldState: f
  }), [j, u, f]);
}
const xt = (e) => e.render(Ey(e));
var _T = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, bo = (e) => Array.isArray(e) ? e : [e], wv = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (a) => {
      for (const o of e)
        o.next && o.next(a);
    },
    subscribe: (a) => (e.push(a), {
      unsubscribe: () => {
        e = e.filter((o) => o !== a);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, jh = (e) => Gt(e) || !Jw(e);
function ci(e, n) {
  if (jh(e) || jh(n))
    return e === n;
  if (Ii(e) && Ii(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (Ii(o) && Ii(s) || gt(o) && gt(s) || Array.isArray(o) && Array.isArray(s) ? !ci(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Wt = (e) => gt(e) && !Object.keys(e).length, $y = (e) => e.type === "file", wr = (e) => typeof e == "function", Zs = (e) => {
  if (!Cy)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, rC = (e) => e.type === "select-multiple", Ty = (e) => e.type === "radio", ST = (e) => Ty(e) || Lo(e), rc = (e) => Zs(e) && e.isConnected;
function NT(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = ht(e) ? i++ : e[n[i++]];
  return e;
}
function jT(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !ht(e[n]))
      return !1;
  return !0;
}
function St(e, n) {
  const r = Array.isArray(n) ? n : Iy(n) ? [n] : Zw(n), i = r.length === 1 ? e : NT(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (gt(i) && Wt(i) || Array.isArray(i) && jT(i)) && St(e, r.slice(0, -1)), e;
}
var iC = (e) => {
  for (const n in e)
    if (wr(e[n]))
      return !0;
  return !1;
};
function el(e, n = {}) {
  const r = Array.isArray(e);
  if (gt(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || gt(e[i]) && !iC(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, el(e[i], n[i])) : Gt(e[i]) || (n[i] = !0);
  return n;
}
function aC(e, n, r) {
  const i = Array.isArray(e);
  if (gt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || gt(e[a]) && !iC(e[a]) ? ht(n) || jh(r[a]) ? r[a] = Array.isArray(e[a]) ? el(e[a], []) : { ...el(e[a]) } : aC(e[a], Gt(n) ? {} : n[a], r[a]) : r[a] = !ci(e[a], n[a]);
  return r;
}
var Aa = (e, n) => aC(e, n, el(n));
const Cv = {
  value: !1,
  isValid: !1
}, Iv = { value: !0, isValid: !0 };
var oC = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !ht(e[0].attributes.value) ? ht(e[0].value) || e[0].value === "" ? Iv : { value: e[0].value, isValid: !0 } : Iv
    ) : Cv;
  }
  return Cv;
}, sC = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => ht(e) ? e : n ? e === "" ? NaN : e && +e : r && Vr(e) ? new Date(e) : i ? i(e) : e;
const Fv = {
  isValid: !1,
  value: null
};
var lC = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, Fv) : Fv;
function Ev(e) {
  const n = e.ref;
  return $y(n) ? n.files : Ty(n) ? lC(e.refs).value : rC(n) ? [...n.selectedOptions].map(({ value: r }) => r) : Lo(n) ? oC(e.refs).value : sC(ht(n.value) ? e.ref.value : n.value, e);
}
var wT = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = rn(n, o);
    s && it(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, nl = (e) => e instanceof RegExp, La = (e) => ht(e) ? e : nl(e) ? e.source : gt(e) ? nl(e.value) ? e.value.source : e.value : e, $v = (e) => ({
  isOnSubmit: !e || e === jr.onSubmit,
  isOnBlur: e === jr.onBlur,
  isOnChange: e === jr.onChange,
  isOnAll: e === jr.all,
  isOnTouch: e === jr.onTouched
});
const Tv = "AsyncFunction";
var CT = (e) => !!e && !!e.validate && !!(wr(e.validate) && e.validate.constructor.name === Tv || gt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === Tv)), IT = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), Ov = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const xo = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = rn(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i)
          return !0;
        if (s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (xo(l, n))
          break;
      } else if (gt(l) && xo(l, n))
        break;
    }
  }
};
function Dv(e, n, r) {
  const i = rn(e, r);
  if (i || Iy(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = rn(n, o), l = rn(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var FT = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Wt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || jr.all));
}, ET = (e, n, r) => !e || !n || e === n || bo(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), $T = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, TT = (e, n) => !Cl(rn(e, n)).length && St(e, n), OT = (e, n, r) => {
  const i = bo(rn(e, r));
  return it(i, "root", n[r]), it(e, r, i), e;
}, Rs = (e) => Vr(e);
function Pv(e, n, r = "validate") {
  if (Rs(e) || Array.isArray(e) && e.every(Rs) || or(e) && !e)
    return {
      type: r,
      message: Rs(e) ? e : "",
      ref: n
    };
}
var Ki = (e) => gt(e) && !nl(e) ? e : {
  value: e,
  message: ""
}, Rv = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: u, maxLength: p, minLength: d, min: f, max: h, pattern: v, validate: C, name: j, valueAsNumber: N, mount: x } = e._f, g = rn(r, j);
  if (!x || n.has(j))
    return {};
  const P = l ? l[0] : s, E = (B) => {
    a && P.reportValidity && (P.setCustomValidity(or(B) ? "" : B || ""), P.reportValidity());
  }, I = {}, w = Ty(s), A = Lo(s), H = w || A, Y = (N || $y(s)) && ht(s.value) && ht(g) || Zs(s) && s.value === "" || g === "" || Array.isArray(g) && !g.length, ne = _T.bind(null, j, i, I), W = (B, D, M, Z = Yr.maxLength, je = Yr.minLength) => {
    const ge = B ? D : M;
    I[j] = {
      type: B ? Z : je,
      message: ge,
      ref: s,
      ...ne(B ? Z : je, ge)
    };
  };
  if (o ? !Array.isArray(g) || !g.length : u && (!H && (Y || Gt(g)) || or(g) && !g || A && !oC(l).isValid || w && !lC(l).isValid)) {
    const { value: B, message: D } = Rs(u) ? { value: !!u, message: u } : Ki(u);
    if (B && (I[j] = {
      type: Yr.required,
      message: D,
      ref: P,
      ...ne(Yr.required, D)
    }, !i))
      return E(D), I;
  }
  if (!Y && (!Gt(f) || !Gt(h))) {
    let B, D;
    const M = Ki(h), Z = Ki(f);
    if (!Gt(g) && !isNaN(g)) {
      const je = s.valueAsNumber || g && +g;
      Gt(M.value) || (B = je > M.value), Gt(Z.value) || (D = je < Z.value);
    } else {
      const je = s.valueAsDate || new Date(g), ge = (q) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + q), ye = s.type == "time", ke = s.type == "week";
      Vr(M.value) && g && (B = ye ? ge(g) > ge(M.value) : ke ? g > M.value : je > new Date(M.value)), Vr(Z.value) && g && (D = ye ? ge(g) < ge(Z.value) : ke ? g < Z.value : je < new Date(Z.value));
    }
    if ((B || D) && (W(!!B, M.message, Z.message, Yr.max, Yr.min), !i))
      return E(I[j].message), I;
  }
  if ((p || d) && !Y && (Vr(g) || o && Array.isArray(g))) {
    const B = Ki(p), D = Ki(d), M = !Gt(B.value) && g.length > +B.value, Z = !Gt(D.value) && g.length < +D.value;
    if ((M || Z) && (W(M, B.message, D.message), !i))
      return E(I[j].message), I;
  }
  if (v && !Y && Vr(g)) {
    const { value: B, message: D } = Ki(v);
    if (nl(B) && !g.match(B) && (I[j] = {
      type: Yr.pattern,
      message: D,
      ref: s,
      ...ne(Yr.pattern, D)
    }, !i))
      return E(D), I;
  }
  if (C) {
    if (wr(C)) {
      const B = await C(g, r), D = Pv(B, P);
      if (D && (I[j] = {
        ...D,
        ...ne(Yr.validate, D.message)
      }, !i))
        return E(D.message), I;
    } else if (gt(C)) {
      let B = {};
      for (const D in C) {
        if (!Wt(B) && !i)
          break;
        const M = Pv(await C[D](g, r), P, D);
        M && (B = {
          ...M,
          ...ne(D, M.message)
        }, E(M.message), i && (I[j] = B));
      }
      if (!Wt(B) && (I[j] = {
        ref: P,
        ...B
      }, !i))
        return I;
    }
  }
  return E(!0), I;
};
const DT = {
  mode: jr.onSubmit,
  reValidateMode: jr.onChange,
  shouldFocusError: !0
};
function PT(e = {}) {
  let n = {
    ...DT,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: wr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = gt(n.defaultValues) || gt(n.values) ? Ot(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : Ot(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, u, p = 0;
  const d = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...d
  };
  const h = {
    array: wv(),
    state: wv()
  }, v = $v(n.mode), C = $v(n.reValidateMode), j = n.criteriaMode === jr.all, N = ($) => (z) => {
    clearTimeout(p), p = setTimeout($, z);
  }, x = async ($) => {
    if (!n.disabled && (d.isValid || f.isValid || $)) {
      const z = n.resolver ? Wt((await Y()).errors) : await W(i, !0);
      z !== r.isValid && h.state.next({
        isValid: z
      });
    }
  }, g = ($, z) => {
    !n.disabled && (d.isValidating || d.validatingFields || f.isValidating || f.validatingFields) && (($ || Array.from(l.mount)).forEach((X) => {
      X && (z ? it(r.validatingFields, X, z) : St(r.validatingFields, X));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Wt(r.validatingFields)
    }));
  }, P = ($, z = [], X, ae, V = !0, J = !0) => {
    if (ae && X && !n.disabled) {
      if (s.action = !0, J && Array.isArray(rn(i, $))) {
        const de = X(rn(i, $), ae.argA, ae.argB);
        V && it(i, $, de);
      }
      if (J && Array.isArray(rn(r.errors, $))) {
        const de = X(rn(r.errors, $), ae.argA, ae.argB);
        V && it(r.errors, $, de), TT(r.errors, $);
      }
      if ((d.touchedFields || f.touchedFields) && J && Array.isArray(rn(r.touchedFields, $))) {
        const de = X(rn(r.touchedFields, $), ae.argA, ae.argB);
        V && it(r.touchedFields, $, de);
      }
      (d.dirtyFields || f.dirtyFields) && (r.dirtyFields = Aa(a, o)), h.state.next({
        name: $,
        isDirty: D($, z),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      it(o, $, z);
  }, E = ($, z) => {
    it(r.errors, $, z), h.state.next({
      errors: r.errors
    });
  }, I = ($) => {
    r.errors = $, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, w = ($, z, X, ae) => {
    const V = rn(i, $);
    if (V) {
      const J = rn(o, $, ht(X) ? rn(a, $) : X);
      ht(J) || ae && ae.defaultChecked || z ? it(o, $, z ? J : Ev(V._f)) : je($, J), s.mount && x();
    }
  }, A = ($, z, X, ae, V) => {
    let J = !1, de = !1;
    const xe = {
      name: $
    };
    if (!n.disabled) {
      if (!X || ae) {
        (d.isDirty || f.isDirty) && (de = r.isDirty, r.isDirty = xe.isDirty = D(), J = de !== xe.isDirty);
        const $e = ci(rn(a, $), z);
        de = !!rn(r.dirtyFields, $), $e ? St(r.dirtyFields, $) : it(r.dirtyFields, $, !0), xe.dirtyFields = r.dirtyFields, J = J || (d.dirtyFields || f.dirtyFields) && de !== !$e;
      }
      if (X) {
        const $e = rn(r.touchedFields, $);
        $e || (it(r.touchedFields, $, X), xe.touchedFields = r.touchedFields, J = J || (d.touchedFields || f.touchedFields) && $e !== X);
      }
      J && V && h.state.next(xe);
    }
    return J ? xe : {};
  }, H = ($, z, X, ae) => {
    const V = rn(r.errors, $), J = (d.isValid || f.isValid) && or(z) && r.isValid !== z;
    if (n.delayError && X ? (u = N(() => E($, X)), u(n.delayError)) : (clearTimeout(p), u = null, X ? it(r.errors, $, X) : St(r.errors, $)), (X ? !ci(V, X) : V) || !Wt(ae) || J) {
      const de = {
        ...ae,
        ...J && or(z) ? { isValid: z } : {},
        errors: r.errors,
        name: $
      };
      r = {
        ...r,
        ...de
      }, h.state.next(de);
    }
  }, Y = async ($) => {
    g($, !0);
    const z = await n.resolver(o, n.context, wT($ || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return g($), z;
  }, ne = async ($) => {
    const { errors: z } = await Y($);
    if ($)
      for (const X of $) {
        const ae = rn(z, X);
        ae ? it(r.errors, X, ae) : St(r.errors, X);
      }
    else
      r.errors = z;
    return z;
  }, W = async ($, z, X = {
    valid: !0
  }) => {
    for (const ae in $) {
      const V = $[ae];
      if (V) {
        const { _f: J, ...de } = V;
        if (J) {
          const xe = l.array.has(J.name), $e = V._f && CT(V._f);
          $e && d.validatingFields && g([ae], !0);
          const tn = await Rv(V, l.disabled, o, j, n.shouldUseNativeValidation && !z, xe);
          if ($e && d.validatingFields && g([ae]), tn[J.name] && (X.valid = !1, z))
            break;
          !z && (rn(tn, J.name) ? xe ? OT(r.errors, tn, J.name) : it(r.errors, J.name, tn[J.name]) : St(r.errors, J.name));
        }
        !Wt(de) && await W(de, z, X);
      }
    }
    return X.valid;
  }, B = () => {
    for (const $ of l.unMount) {
      const z = rn(i, $);
      z && (z._f.refs ? z._f.refs.every((X) => !rc(X)) : !rc(z._f.ref)) && Be($);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, D = ($, z) => !n.disabled && ($ && z && it(o, $, z), !ci(De(), a)), M = ($, z, X) => tC($, l, {
    ...s.mount ? o : ht(z) ? a : Vr($) ? { [$]: z } : z
  }, X, z), Z = ($) => Cl(rn(s.mount ? o : a, $, n.shouldUnregister ? rn(a, $, []) : [])), je = ($, z, X = {}) => {
    const ae = rn(i, $);
    let V = z;
    if (ae) {
      const J = ae._f;
      J && (!J.disabled && it(o, $, sC(z, J)), V = Zs(J.ref) && Gt(z) ? "" : z, rC(J.ref) ? [...J.ref.options].forEach((de) => de.selected = V.includes(de.value)) : J.refs ? Lo(J.ref) ? J.refs.length > 1 ? J.refs.forEach((de) => (!de.defaultChecked || !de.disabled) && (de.checked = Array.isArray(V) ? !!V.find((xe) => xe === de.value) : V === de.value)) : J.refs[0] && (J.refs[0].checked = !!V) : J.refs.forEach((de) => de.checked = de.value === V) : $y(J.ref) ? J.ref.value = "" : (J.ref.value = V, J.ref.type || h.state.next({
        name: $,
        values: Ot(o)
      })));
    }
    (X.shouldDirty || X.shouldTouch) && A($, V, X.shouldTouch, X.shouldDirty, !0), X.shouldValidate && _e($);
  }, ge = ($, z, X) => {
    for (const ae in z) {
      const V = z[ae], J = `${$}.${ae}`, de = rn(i, J);
      (l.array.has($) || gt(V) || de && !de._f) && !Ii(V) ? ge(J, V, X) : je(J, V, X);
    }
  }, ye = ($, z, X = {}) => {
    const ae = rn(i, $), V = l.array.has($), J = Ot(z);
    it(o, $, J), V ? (h.array.next({
      name: $,
      values: Ot(o)
    }), (d.isDirty || d.dirtyFields || f.isDirty || f.dirtyFields) && X.shouldDirty && h.state.next({
      name: $,
      dirtyFields: Aa(a, o),
      isDirty: D($, J)
    })) : ae && !ae._f && !Gt(J) ? ge($, J, X) : je($, J, X), Ov($, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? $ : void 0,
      values: Ot(o)
    });
  }, ke = async ($) => {
    s.mount = !0;
    const z = $.target;
    let X = z.name, ae = !0;
    const V = rn(i, X), J = (de) => {
      ae = Number.isNaN(de) || Ii(de) && isNaN(de.getTime()) || ci(de, rn(o, X, de));
    };
    if (V) {
      let de, xe;
      const $e = z.type ? Ev(V._f) : Qw($), tn = $.type === Xs.BLUR || $.type === Xs.FOCUS_OUT, gn = !IT(V._f) && !n.resolver && !rn(r.errors, X) && !V._f.deps || $T(tn, rn(r.touchedFields, X), r.isSubmitted, C, v), on = Ov(X, l, tn);
      it(o, X, $e), tn ? (V._f.onBlur && V._f.onBlur($), u && u(0)) : V._f.onChange && V._f.onChange($);
      const pn = A(X, $e, tn), Fn = !Wt(pn) || on;
      if (!tn && h.state.next({
        name: X,
        type: $.type,
        values: Ot(o)
      }), gn)
        return (d.isValid || f.isValid) && (n.mode === "onBlur" ? tn && x() : tn || x()), Fn && h.state.next({ name: X, ...on ? {} : pn });
      if (!tn && on && h.state.next({ ...r }), n.resolver) {
        const { errors: xn } = await Y([X]);
        if (J($e), ae) {
          const En = Dv(r.errors, i, X), en = Dv(xn, i, En.name || X);
          de = en.error, X = en.name, xe = Wt(xn);
        }
      } else
        g([X], !0), de = (await Rv(V, l.disabled, o, j, n.shouldUseNativeValidation))[X], g([X]), J($e), ae && (de ? xe = !1 : (d.isValid || f.isValid) && (xe = await W(i, !0)));
      ae && (V._f.deps && _e(V._f.deps), H(X, xe, de, pn));
    }
  }, q = ($, z) => {
    if (rn(r.errors, z) && $.focus)
      return $.focus(), 1;
  }, _e = async ($, z = {}) => {
    let X, ae;
    const V = bo($);
    if (n.resolver) {
      const J = await ne(ht($) ? $ : V);
      X = Wt(J), ae = $ ? !V.some((de) => rn(J, de)) : X;
    } else $ ? (ae = (await Promise.all(V.map(async (J) => {
      const de = rn(i, J);
      return await W(de && de._f ? { [J]: de } : de);
    }))).every(Boolean), !(!ae && !r.isValid) && x()) : ae = X = await W(i);
    return h.state.next({
      ...!Vr($) || (d.isValid || f.isValid) && X !== r.isValid ? {} : { name: $ },
      ...n.resolver || !$ ? { isValid: X } : {},
      errors: r.errors
    }), z.shouldFocus && !ae && xo(i, q, $ ? V : l.mount), ae;
  }, De = ($) => {
    const z = {
      ...s.mount ? o : a
    };
    return ht($) ? z : Vr($) ? rn(z, $) : $.map((X) => rn(z, X));
  }, G = ($, z) => ({
    invalid: !!rn((z || r).errors, $),
    isDirty: !!rn((z || r).dirtyFields, $),
    error: rn((z || r).errors, $),
    isValidating: !!rn(r.validatingFields, $),
    isTouched: !!rn((z || r).touchedFields, $)
  }), Ye = ($) => {
    $ && bo($).forEach((z) => St(r.errors, z)), h.state.next({
      errors: $ ? r.errors : {}
    });
  }, sn = ($, z, X) => {
    const ae = (rn(i, $, { _f: {} })._f || {}).ref, V = rn(r.errors, $) || {}, { ref: J, message: de, type: xe, ...$e } = V;
    it(r.errors, $, {
      ...$e,
      ...z,
      ref: ae
    }), h.state.next({
      name: $,
      errors: r.errors,
      isValid: !1
    }), X && X.shouldFocus && ae && ae.focus && ae.focus();
  }, Ie = ($, z) => wr($) ? h.state.subscribe({
    next: (X) => $(M(void 0, z), X)
  }) : M($, z, !0), Ue = ($) => h.state.subscribe({
    next: (z) => {
      ET($.name, z.name, $.exact) && FT(z, $.formState || d, Re, $.reRenderRoot) && $.callback({
        values: { ...o },
        ...r,
        ...z
      });
    }
  }).unsubscribe, Pe = ($) => (s.mount = !0, f = {
    ...f,
    ...$.formState
  }, Ue({
    ...$,
    formState: f
  })), Be = ($, z = {}) => {
    for (const X of $ ? bo($) : l.mount)
      l.mount.delete(X), l.array.delete(X), z.keepValue || (St(i, X), St(o, X)), !z.keepError && St(r.errors, X), !z.keepDirty && St(r.dirtyFields, X), !z.keepTouched && St(r.touchedFields, X), !z.keepIsValidating && St(r.validatingFields, X), !n.shouldUnregister && !z.keepDefaultValue && St(a, X);
    h.state.next({
      values: Ot(o)
    }), h.state.next({
      ...r,
      ...z.keepDirty ? { isDirty: D() } : {}
    }), !z.keepIsValid && x();
  }, Le = ({ disabled: $, name: z }) => {
    (or($) && s.mount || $ || l.disabled.has(z)) && ($ ? l.disabled.add(z) : l.disabled.delete(z));
  }, Xe = ($, z = {}) => {
    let X = rn(i, $);
    const ae = or(z.disabled) || or(n.disabled);
    return it(i, $, {
      ...X || {},
      _f: {
        ...X && X._f ? X._f : { ref: { name: $ } },
        name: $,
        mount: !0,
        ...z
      }
    }), l.mount.add($), X ? Le({
      disabled: or(z.disabled) ? z.disabled : n.disabled,
      name: $
    }) : w($, !0, z.value), {
      ...ae ? { disabled: z.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!z.required,
        min: La(z.min),
        max: La(z.max),
        minLength: La(z.minLength),
        maxLength: La(z.maxLength),
        pattern: La(z.pattern)
      } : {},
      name: $,
      onChange: ke,
      onBlur: ke,
      ref: (V) => {
        if (V) {
          Xe($, z), X = rn(i, $);
          const J = ht(V.value) && V.querySelectorAll && V.querySelectorAll("input,select,textarea")[0] || V, de = ST(J), xe = X._f.refs || [];
          if (de ? xe.find(($e) => $e === J) : J === X._f.ref)
            return;
          it(i, $, {
            _f: {
              ...X._f,
              ...de ? {
                refs: [
                  ...xe.filter(rc),
                  J,
                  ...Array.isArray(rn(a, $)) ? [{}] : []
                ],
                ref: { type: J.type, name: $ }
              } : { ref: J }
            }
          }), w($, !1, void 0, J);
        } else
          X = rn(i, $, {}), X._f && (X._f.mount = !1), (n.shouldUnregister || z.shouldUnregister) && !(Xw(l.array, $) && s.action) && l.unMount.add($);
      }
    };
  }, Fe = () => n.shouldFocusError && xo(i, q, l.mount), Me = ($) => {
    or($) && (h.state.next({ disabled: $ }), xo(i, (z, X) => {
      const ae = rn(i, X);
      ae && (z.disabled = ae._f.disabled || $, Array.isArray(ae._f.refs) && ae._f.refs.forEach((V) => {
        V.disabled = ae._f.disabled || $;
      }));
    }, 0, !1));
  }, nn = ($, z) => async (X) => {
    let ae;
    X && (X.preventDefault && X.preventDefault(), X.persist && X.persist());
    let V = Ot(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: J, values: de } = await Y();
      r.errors = J, V = de;
    } else
      await W(i);
    if (l.disabled.size)
      for (const J of l.disabled)
        it(V, J, void 0);
    if (St(r.errors, "root"), Wt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await $(V, X);
      } catch (J) {
        ae = J;
      }
    } else
      z && await z({ ...r.errors }, X), Fe(), setTimeout(Fe);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Wt(r.errors) && !ae,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), ae)
      throw ae;
  }, se = ($, z = {}) => {
    rn(i, $) && (ht(z.defaultValue) ? ye($, Ot(rn(a, $))) : (ye($, z.defaultValue), it(a, $, Ot(z.defaultValue))), z.keepTouched || St(r.touchedFields, $), z.keepDirty || (St(r.dirtyFields, $), r.isDirty = z.defaultValue ? D($, Ot(rn(a, $))) : D()), z.keepError || (St(r.errors, $), d.isValid && x()), h.state.next({ ...r }));
  }, le = ($, z = {}) => {
    const X = $ ? Ot($) : a, ae = Ot(X), V = Wt($), J = V ? a : ae;
    if (z.keepDefaultValues || (a = X), !z.keepValues) {
      if (z.keepDirtyValues) {
        const de = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(Aa(a, o))
        ]);
        for (const xe of Array.from(de))
          rn(r.dirtyFields, xe) ? it(J, xe, rn(o, xe)) : ye(xe, rn(J, xe));
      } else {
        if (Cy && ht($))
          for (const de of l.mount) {
            const xe = rn(i, de);
            if (xe && xe._f) {
              const $e = Array.isArray(xe._f.refs) ? xe._f.refs[0] : xe._f.ref;
              if (Zs($e)) {
                const tn = $e.closest("form");
                if (tn) {
                  tn.reset();
                  break;
                }
              }
            }
          }
        for (const de of l.mount)
          ye(de, rn(J, de));
      }
      o = Ot(J), h.array.next({
        values: { ...J }
      }), h.state.next({
        values: { ...J }
      });
    }
    l = {
      mount: z.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !d.isValid || !!z.keepIsValid || !!z.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: z.keepSubmitCount ? r.submitCount : 0,
      isDirty: V ? !1 : z.keepDirty ? r.isDirty : !!(z.keepDefaultValues && !ci($, a)),
      isSubmitted: z.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: V ? {} : z.keepDirtyValues ? z.keepDefaultValues && o ? Aa(a, o) : r.dirtyFields : z.keepDefaultValues && $ ? Aa(a, $) : z.keepDirty ? r.dirtyFields : {},
      touchedFields: z.keepTouched ? r.touchedFields : {},
      errors: z.keepErrors ? r.errors : {},
      isSubmitSuccessful: z.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Se = ($, z) => le(wr($) ? $(o) : $, z), Ae = ($, z = {}) => {
    const X = rn(i, $), ae = X && X._f;
    if (ae) {
      const V = ae.refs ? ae.refs[0] : ae.ref;
      V.focus && (V.focus(), z.shouldSelect && wr(V.select) && V.select());
    }
  }, Re = ($) => {
    r = {
      ...r,
      ...$
    };
  }, Q = {
    control: {
      register: Xe,
      unregister: Be,
      getFieldState: G,
      handleSubmit: nn,
      setError: sn,
      _subscribe: Ue,
      _runSchema: Y,
      _getWatch: M,
      _getDirty: D,
      _setValid: x,
      _setFieldArray: P,
      _setDisabledField: Le,
      _setErrors: I,
      _getFieldArray: Z,
      _reset: le,
      _resetDefaultValues: () => wr(n.defaultValues) && n.defaultValues().then(($) => {
        Se($, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: B,
      _disableForm: Me,
      _subjects: h,
      _proxyFormState: d,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state($) {
        s = $;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names($) {
        l = $;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options($) {
        n = {
          ...n,
          ...$
        };
      }
    },
    subscribe: Pe,
    trigger: _e,
    register: Xe,
    handleSubmit: nn,
    watch: Ie,
    setValue: ye,
    getValues: De,
    reset: Se,
    resetField: se,
    clearErrors: Ye,
    unregister: Be,
    setError: sn,
    setFocus: Ae,
    getFieldState: G
  };
  return {
    ...Q,
    formControl: Q
  };
}
function dt(e = {}) {
  const n = qe.useRef(void 0), r = qe.useRef(void 0), [i, a] = qe.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: wr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: wr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : PT(e),
    formState: i
  }, e.formControl && e.defaultValues && !wr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, qe.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), qe.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), qe.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), qe.useEffect(() => {
    e.values && !ci(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), qe.useEffect(() => {
    e.errors && !Wt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), qe.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), qe.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = nC(i, o), n.current;
}
var Xo = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function cC(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ic = { exports: {} }, Va = {}, Av;
function RT() {
  if (Av) return Va;
  Av = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Va.Fragment = r, Va.jsx = s, Va.jsxs = s, Va;
}
var Zo = {}, Lv;
function AT() {
  return Lv || (Lv = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        P("error", t, m);
      }
    }
    function P(t, c, m) {
      {
        var y = x.ReactDebugCurrentFrame, F = y.getStackAddendum();
        F !== "" && (c += "%s", m = m.concat([F]));
        var T = m.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var E = !1, I = !1, w = !1, A = !1, H = !1, Y;
    Y = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ne(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || H || t === a || t === p || t === d || A || t === v || E || I || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function W(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var F = c.displayName || c.name || "";
      return F !== "" ? m + "(" + F + ")" : m;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function D(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var m = t;
            return B(m._context) + ".Provider";
          case u:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : D(t.type) || "Memo";
          case h: {
            var F = t, T = F._payload, S = F._init;
            try {
              return D(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var M = Object.assign, Z = 0, je, ge, ye, ke, q, _e, De;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function Ye() {
      {
        if (Z === 0) {
          je = console.log, ge = console.info, ye = console.warn, ke = console.error, q = console.group, _e = console.groupCollapsed, De = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function sn() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: M({}, t, {
              value: je
            }),
            info: M({}, t, {
              value: ge
            }),
            warn: M({}, t, {
              value: ye
            }),
            error: M({}, t, {
              value: ke
            }),
            group: M({}, t, {
              value: q
            }),
            groupCollapsed: M({}, t, {
              value: _e
            }),
            groupEnd: M({}, t, {
              value: De
            })
          });
        }
        Z < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = x.ReactCurrentDispatcher, Ue;
    function Pe(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (F) {
            var y = F.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Le;
    {
      var Xe = typeof WeakMap == "function" ? WeakMap : Map;
      Le = new Xe();
    }
    function Fe(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Le.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      Be = !0;
      var F = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ye();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (re) {
              y = re;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (re) {
              y = re;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            y = re;
          }
          t();
        }
      } catch (re) {
        if (re && y && typeof re.stack == "string") {
          for (var _ = re.stack.split(`
`), ee = y.stack.split(`
`), L = _.length - 1, U = ee.length - 1; L >= 1 && U >= 0 && _[L] !== ee[U]; )
            U--;
          for (; L >= 1 && U >= 0; L--, U--)
            if (_[L] !== ee[U]) {
              if (L !== 1 || U !== 1)
                do
                  if (L--, U--, U < 0 || _[L] !== ee[U]) {
                    var ce = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && ce.includes("<anonymous>") && (ce = ce.replace("<anonymous>", t.displayName)), typeof t == "function" && Le.set(t, ce), ce;
                  }
                while (L >= 1 && U >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = F;
      }
      var ze = t ? t.displayName || t.name : "", Oe = ze ? Pe(ze) : "";
      return typeof t == "function" && Le.set(t, Oe), Oe;
    }
    function Me(t, c, m) {
      return Fe(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Fe(t, nn(t));
      if (typeof t == "string")
        return Pe(t);
      switch (t) {
        case p:
          return Pe("Suspense");
        case d:
          return Pe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return Me(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, F = y._payload, T = y._init;
            try {
              return se(T(F), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Se = {}, Ae = x.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(m);
      } else
        Ae.setExtraStackFrame(null);
    }
    function yn(t, c, m, y, F) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + m + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              _ = t[S](c, S, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Re(F), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, S, typeof _), Re(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Re(F), g("Failed %s type: %s", m, _.message), Re(null));
          }
      }
    }
    var Q = Array.isArray;
    function $(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ae(t);
    }
    var J = x.ReactCurrentOwner, de = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, xe, $e;
    function tn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && J.current;
    }
    function pn(t, c) {
      {
        var m = function() {
          xe || (xe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function Fn(t, c) {
      {
        var m = function() {
          $e || ($e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, m, y, F, T, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: F
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, m, y, F) {
      {
        var T, S = {}, _ = null, ee = null;
        m !== void 0 && (V(m), _ = "" + m), gn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ee = c.ref, on(c));
        for (T in c)
          le.call(c, T) && !de.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (T in L)
            S[T] === void 0 && (S[T] = L[T]);
        }
        if (_ || ee) {
          var U = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, U), ee && Fn(S, U);
        }
        return xn(t, _, ee, F, y, J.current, S);
      }
    }
    var en = x.ReactCurrentOwner, vn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        vn.setExtraStackFrame(m);
      } else
        vn.setExtraStackFrame(null);
    }
    var un;
    un = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = D(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Nn = {};
    function Rn(t) {
      {
        var c = jn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function kn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Rn(c);
        if (Nn[m])
          return;
        Nn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + D(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Ve(null);
      }
    }
    function _n(t, c) {
      {
        if (typeof t != "object")
          return;
        if ($(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            dn(y) && kn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var F = N(t);
          if (typeof F == "function" && F !== t.entries)
            for (var T = F.call(t), S; !(S = T.next()).done; )
              dn(S.value) && kn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = D(c);
          yn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !un) {
          un = !0;
          var F = D(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", F || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, m, y, F, T) {
      {
        var S = ne(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = Bn();
          ee ? _ += ee : _ += jn();
          var L;
          t === null ? L = "null" : $(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (D(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var U = En(t, c, m, F, T);
        if (U == null)
          return U;
        if (S) {
          var ce = c.children;
          if (ce !== void 0)
            if (y)
              if ($(ce)) {
                for (var ze = 0; ze < ce.length; ze++)
                  _n(ce[ze], t);
                Object.freeze && Object.freeze(ce);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _n(ce, t);
        }
        if (le.call(c, "key")) {
          var Oe = D(t), re = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), mn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Oe + mn]) {
            var Dn = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Oe, Dn, Oe), Cn[Oe + mn] = !0;
          }
        }
        return t === i ? Ln(U) : An(U), U;
      }
    }
    function Vn(t, c, m) {
      return wn(t, c, m, !0);
    }
    function qn(t, c, m) {
      return wn(t, c, m, !1);
    }
    var zn = qn, Wn = Vn;
    Zo.Fragment = i, Zo.jsx = zn, Zo.jsxs = Wn;
  })()), Zo;
}
var Vv;
function LT() {
  return Vv || (Vv = 1, process.env.NODE_ENV === "production" ? ic.exports = RT() : ic.exports = AT()), ic.exports;
}
var Ti = LT();
function VT(e) {
  return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var ac, zv;
function fi() {
  if (zv) return ac;
  zv = 1;
  var e = Array.isArray;
  return ac = e, ac;
}
var oc, Uv;
function uC() {
  if (Uv) return oc;
  Uv = 1;
  var e = typeof Xo == "object" && Xo && Xo.Object === Object && Xo;
  return oc = e, oc;
}
var sc, Mv;
function qr() {
  if (Mv) return sc;
  Mv = 1;
  var e = uC(), n = typeof self == "object" && self && self.Object === Object && self, r = e || n || Function("return this")();
  return sc = r, sc;
}
var lc, Bv;
function Vo() {
  if (Bv) return lc;
  Bv = 1;
  var e = qr(), n = e.Symbol;
  return lc = n, lc;
}
var cc, qv;
function zT() {
  if (qv) return cc;
  qv = 1;
  var e = Vo(), n = Object.prototype, r = n.hasOwnProperty, i = n.toString, a = e ? e.toStringTag : void 0;
  function o(s) {
    var l = r.call(s, a), u = s[a];
    try {
      s[a] = void 0;
      var p = !0;
    } catch {
    }
    var d = i.call(s);
    return p && (l ? s[a] = u : delete s[a]), d;
  }
  return cc = o, cc;
}
var uc, Hv;
function UT() {
  if (Hv) return uc;
  Hv = 1;
  var e = Object.prototype, n = e.toString;
  function r(i) {
    return n.call(i);
  }
  return uc = r, uc;
}
var dc, Wv;
function Na() {
  if (Wv) return dc;
  Wv = 1;
  var e = Vo(), n = zT(), r = UT(), i = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(l) {
    return l == null ? l === void 0 ? a : i : o && o in Object(l) ? n(l) : r(l);
  }
  return dc = s, dc;
}
var mc, Kv;
function Li() {
  if (Kv) return mc;
  Kv = 1;
  function e(n) {
    return n != null && typeof n == "object";
  }
  return mc = e, mc;
}
var pc, Gv;
function Oy() {
  if (Gv) return pc;
  Gv = 1;
  var e = Na(), n = Li(), r = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || n(a) && e(a) == r;
  }
  return pc = i, pc;
}
var fc, Yv;
function MT() {
  if (Yv) return fc;
  Yv = 1;
  var e = fi(), n = Oy(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function a(o, s) {
    if (e(o))
      return !1;
    var l = typeof o;
    return l == "number" || l == "symbol" || l == "boolean" || o == null || n(o) ? !0 : i.test(o) || !r.test(o) || s != null && o in Object(s);
  }
  return fc = a, fc;
}
var hc, Jv;
function ja() {
  if (Jv) return hc;
  Jv = 1;
  function e(n) {
    var r = typeof n;
    return n != null && (r == "object" || r == "function");
  }
  return hc = e, hc;
}
var yc, Qv;
function dC() {
  if (Qv) return yc;
  Qv = 1;
  var e = Na(), n = ja(), r = "[object AsyncFunction]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(l) {
    if (!n(l))
      return !1;
    var u = e(l);
    return u == i || u == a || u == r || u == o;
  }
  return yc = s, yc;
}
var gc, Xv;
function BT() {
  if (Xv) return gc;
  Xv = 1;
  var e = qr(), n = e["__core-js_shared__"];
  return gc = n, gc;
}
var vc, Zv;
function qT() {
  if (Zv) return vc;
  Zv = 1;
  var e = BT(), n = (function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  })();
  function r(i) {
    return !!n && n in i;
  }
  return vc = r, vc;
}
var kc, ek;
function mC() {
  if (ek) return kc;
  ek = 1;
  var e = Function.prototype, n = e.toString;
  function r(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return kc = r, kc;
}
var bc, nk;
function HT() {
  if (nk) return bc;
  nk = 1;
  var e = dC(), n = qT(), r = ja(), i = mC(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, u = s.toString, p = l.hasOwnProperty, d = RegExp(
    "^" + u.call(p).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!r(h) || n(h))
      return !1;
    var v = e(h) ? d : o;
    return v.test(i(h));
  }
  return bc = f, bc;
}
var xc, tk;
function WT() {
  if (tk) return xc;
  tk = 1;
  function e(n, r) {
    return n?.[r];
  }
  return xc = e, xc;
}
var _c, rk;
function Vi() {
  if (rk) return _c;
  rk = 1;
  var e = HT(), n = WT();
  function r(i, a) {
    var o = n(i, a);
    return e(o) ? o : void 0;
  }
  return _c = r, _c;
}
var Sc, ik;
function Il() {
  if (ik) return Sc;
  ik = 1;
  var e = Vi(), n = e(Object, "create");
  return Sc = n, Sc;
}
var Nc, ak;
function KT() {
  if (ak) return Nc;
  ak = 1;
  var e = Il();
  function n() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Nc = n, Nc;
}
var jc, ok;
function GT() {
  if (ok) return jc;
  ok = 1;
  function e(n) {
    var r = this.has(n) && delete this.__data__[n];
    return this.size -= r ? 1 : 0, r;
  }
  return jc = e, jc;
}
var wc, sk;
function YT() {
  if (sk) return wc;
  sk = 1;
  var e = Il(), n = "__lodash_hash_undefined__", r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    var s = this.__data__;
    if (e) {
      var l = s[o];
      return l === n ? void 0 : l;
    }
    return i.call(s, o) ? s[o] : void 0;
  }
  return wc = a, wc;
}
var Cc, lk;
function JT() {
  if (lk) return Cc;
  lk = 1;
  var e = Il(), n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : r.call(o, a);
  }
  return Cc = i, Cc;
}
var Ic, ck;
function QT() {
  if (ck) return Ic;
  ck = 1;
  var e = Il(), n = "__lodash_hash_undefined__";
  function r(i, a) {
    var o = this.__data__;
    return this.size += this.has(i) ? 0 : 1, o[i] = e && a === void 0 ? n : a, this;
  }
  return Ic = r, Ic;
}
var Fc, uk;
function XT() {
  if (uk) return Fc;
  uk = 1;
  var e = KT(), n = GT(), r = YT(), i = JT(), a = QT();
  function o(s) {
    var l = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++l < u; ) {
      var p = s[l];
      this.set(p[0], p[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Fc = o, Fc;
}
var Ec, dk;
function ZT() {
  if (dk) return Ec;
  dk = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return Ec = e, Ec;
}
var $c, mk;
function pC() {
  if (mk) return $c;
  mk = 1;
  function e(n, r) {
    return n === r || n !== n && r !== r;
  }
  return $c = e, $c;
}
var Tc, pk;
function Fl() {
  if (pk) return Tc;
  pk = 1;
  var e = pC();
  function n(r, i) {
    for (var a = r.length; a--; )
      if (e(r[a][0], i))
        return a;
    return -1;
  }
  return Tc = n, Tc;
}
var Oc, fk;
function eO() {
  if (fk) return Oc;
  fk = 1;
  var e = Fl(), n = Array.prototype, r = n.splice;
  function i(a) {
    var o = this.__data__, s = e(o, a);
    if (s < 0)
      return !1;
    var l = o.length - 1;
    return s == l ? o.pop() : r.call(o, s, 1), --this.size, !0;
  }
  return Oc = i, Oc;
}
var Dc, hk;
function nO() {
  if (hk) return Dc;
  hk = 1;
  var e = Fl();
  function n(r) {
    var i = this.__data__, a = e(i, r);
    return a < 0 ? void 0 : i[a][1];
  }
  return Dc = n, Dc;
}
var Pc, yk;
function tO() {
  if (yk) return Pc;
  yk = 1;
  var e = Fl();
  function n(r) {
    return e(this.__data__, r) > -1;
  }
  return Pc = n, Pc;
}
var Rc, gk;
function rO() {
  if (gk) return Rc;
  gk = 1;
  var e = Fl();
  function n(r, i) {
    var a = this.__data__, o = e(a, r);
    return o < 0 ? (++this.size, a.push([r, i])) : a[o][1] = i, this;
  }
  return Rc = n, Rc;
}
var Ac, vk;
function El() {
  if (vk) return Ac;
  vk = 1;
  var e = ZT(), n = eO(), r = nO(), i = tO(), a = rO();
  function o(s) {
    var l = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++l < u; ) {
      var p = s[l];
      this.set(p[0], p[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Ac = o, Ac;
}
var Lc, kk;
function Dy() {
  if (kk) return Lc;
  kk = 1;
  var e = Vi(), n = qr(), r = e(n, "Map");
  return Lc = r, Lc;
}
var Vc, bk;
function iO() {
  if (bk) return Vc;
  bk = 1;
  var e = XT(), n = El(), r = Dy();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || n)(),
      string: new e()
    };
  }
  return Vc = i, Vc;
}
var zc, xk;
function aO() {
  if (xk) return zc;
  xk = 1;
  function e(n) {
    var r = typeof n;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? n !== "__proto__" : n === null;
  }
  return zc = e, zc;
}
var Uc, _k;
function $l() {
  if (_k) return Uc;
  _k = 1;
  var e = aO();
  function n(r, i) {
    var a = r.__data__;
    return e(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
  }
  return Uc = n, Uc;
}
var Mc, Sk;
function oO() {
  if (Sk) return Mc;
  Sk = 1;
  var e = $l();
  function n(r) {
    var i = e(this, r).delete(r);
    return this.size -= i ? 1 : 0, i;
  }
  return Mc = n, Mc;
}
var Bc, Nk;
function sO() {
  if (Nk) return Bc;
  Nk = 1;
  var e = $l();
  function n(r) {
    return e(this, r).get(r);
  }
  return Bc = n, Bc;
}
var qc, jk;
function lO() {
  if (jk) return qc;
  jk = 1;
  var e = $l();
  function n(r) {
    return e(this, r).has(r);
  }
  return qc = n, qc;
}
var Hc, wk;
function cO() {
  if (wk) return Hc;
  wk = 1;
  var e = $l();
  function n(r, i) {
    var a = e(this, r), o = a.size;
    return a.set(r, i), this.size += a.size == o ? 0 : 1, this;
  }
  return Hc = n, Hc;
}
var Wc, Ck;
function fC() {
  if (Ck) return Wc;
  Ck = 1;
  var e = iO(), n = oO(), r = sO(), i = lO(), a = cO();
  function o(s) {
    var l = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++l < u; ) {
      var p = s[l];
      this.set(p[0], p[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Wc = o, Wc;
}
var Kc, Ik;
function uO() {
  if (Ik) return Kc;
  Ik = 1;
  var e = fC(), n = "Expected a function";
  function r(i, a) {
    if (typeof i != "function" || a != null && typeof a != "function")
      throw new TypeError(n);
    var o = function() {
      var s = arguments, l = a ? a.apply(this, s) : s[0], u = o.cache;
      if (u.has(l))
        return u.get(l);
      var p = i.apply(this, s);
      return o.cache = u.set(l, p) || u, p;
    };
    return o.cache = new (r.Cache || e)(), o;
  }
  return r.Cache = e, Kc = r, Kc;
}
var Gc, Fk;
function dO() {
  if (Fk) return Gc;
  Fk = 1;
  var e = uO(), n = 500;
  function r(i) {
    var a = e(i, function(s) {
      return o.size === n && o.clear(), s;
    }), o = a.cache;
    return a;
  }
  return Gc = r, Gc;
}
var Yc, Ek;
function mO() {
  if (Ek) return Yc;
  Ek = 1;
  var e = dO(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, i = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(n, function(s, l, u, p) {
      o.push(u ? p.replace(r, "$1") : l || s);
    }), o;
  });
  return Yc = i, Yc;
}
var Jc, $k;
function hC() {
  if ($k) return Jc;
  $k = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = Array(a); ++i < a; )
      o[i] = r(n[i], i, n);
    return o;
  }
  return Jc = e, Jc;
}
var Qc, Tk;
function pO() {
  if (Tk) return Qc;
  Tk = 1;
  var e = Vo(), n = hC(), r = fi(), i = Oy(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function s(l) {
    if (typeof l == "string")
      return l;
    if (r(l))
      return n(l, s) + "";
    if (i(l))
      return o ? o.call(l) : "";
    var u = l + "";
    return u == "0" && 1 / l == -1 / 0 ? "-0" : u;
  }
  return Qc = s, Qc;
}
var Xc, Ok;
function fO() {
  if (Ok) return Xc;
  Ok = 1;
  var e = pO();
  function n(r) {
    return r == null ? "" : e(r);
  }
  return Xc = n, Xc;
}
var Zc, Dk;
function wa() {
  if (Dk) return Zc;
  Dk = 1;
  var e = fi(), n = MT(), r = mO(), i = fO();
  function a(o, s) {
    return e(o) ? o : n(o, s) ? [o] : r(i(o));
  }
  return Zc = a, Zc;
}
var eu, Pk;
function Tl() {
  if (Pk) return eu;
  Pk = 1;
  var e = Oy();
  function n(r) {
    if (typeof r == "string" || e(r))
      return r;
    var i = r + "";
    return i == "0" && 1 / r == -1 / 0 ? "-0" : i;
  }
  return eu = n, eu;
}
var nu, Rk;
function yC() {
  if (Rk) return nu;
  Rk = 1;
  var e = wa(), n = Tl();
  function r(i, a) {
    a = e(a, i);
    for (var o = 0, s = a.length; i != null && o < s; )
      i = i[n(a[o++])];
    return o && o == s ? i : void 0;
  }
  return nu = r, nu;
}
var tu, Ak;
function gC() {
  if (Ak) return tu;
  Ak = 1;
  var e = Vi(), n = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return tu = n, tu;
}
var ru, Lk;
function vC() {
  if (Lk) return ru;
  Lk = 1;
  var e = gC();
  function n(r, i, a) {
    i == "__proto__" && e ? e(r, i, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[i] = a;
  }
  return ru = n, ru;
}
var iu, Vk;
function Py() {
  if (Vk) return iu;
  Vk = 1;
  var e = vC(), n = pC(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o, s, l) {
    var u = o[s];
    (!(i.call(o, s) && n(u, l)) || l === void 0 && !(s in o)) && e(o, s, l);
  }
  return iu = a, iu;
}
var au, zk;
function Ry() {
  if (zk) return au;
  zk = 1;
  var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function r(i, a) {
    var o = typeof i;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < a;
  }
  return au = r, au;
}
var ou, Uk;
function hO() {
  if (Uk) return ou;
  Uk = 1;
  var e = Py(), n = wa(), r = Ry(), i = ja(), a = Tl();
  function o(s, l, u, p) {
    if (!i(s))
      return s;
    l = n(l, s);
    for (var d = -1, f = l.length, h = f - 1, v = s; v != null && ++d < f; ) {
      var C = a(l[d]), j = u;
      if (C === "__proto__" || C === "constructor" || C === "prototype")
        return s;
      if (d != h) {
        var N = v[C];
        j = p ? p(N, C, v) : void 0, j === void 0 && (j = i(N) ? N : r(l[d + 1]) ? [] : {});
      }
      e(v, C, j), v = v[C];
    }
    return s;
  }
  return ou = o, ou;
}
var su, Mk;
function yO() {
  if (Mk) return su;
  Mk = 1;
  var e = yC(), n = hO(), r = wa();
  function i(a, o, s) {
    for (var l = -1, u = o.length, p = {}; ++l < u; ) {
      var d = o[l], f = e(a, d);
      s(f, d) && n(p, r(d, a), f);
    }
    return p;
  }
  return su = i, su;
}
var lu, Bk;
function gO() {
  if (Bk) return lu;
  Bk = 1;
  function e(n, r) {
    return n != null && r in Object(n);
  }
  return lu = e, lu;
}
var cu, qk;
function vO() {
  if (qk) return cu;
  qk = 1;
  var e = Na(), n = Li(), r = "[object Arguments]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return cu = i, cu;
}
var uu, Hk;
function Ay() {
  if (Hk) return uu;
  Hk = 1;
  var e = vO(), n = Li(), r = Object.prototype, i = r.hasOwnProperty, a = r.propertyIsEnumerable, o = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return n(s) && i.call(s, "callee") && !a.call(s, "callee");
  };
  return uu = o, uu;
}
var du, Wk;
function Ly() {
  if (Wk) return du;
  Wk = 1;
  var e = 9007199254740991;
  function n(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return du = n, du;
}
var mu, Kk;
function kO() {
  if (Kk) return mu;
  Kk = 1;
  var e = wa(), n = Ay(), r = fi(), i = Ry(), a = Ly(), o = Tl();
  function s(l, u, p) {
    u = e(u, l);
    for (var d = -1, f = u.length, h = !1; ++d < f; ) {
      var v = o(u[d]);
      if (!(h = l != null && p(l, v)))
        break;
      l = l[v];
    }
    return h || ++d != f ? h : (f = l == null ? 0 : l.length, !!f && a(f) && i(v, f) && (r(l) || n(l)));
  }
  return mu = s, mu;
}
var pu, Gk;
function bO() {
  if (Gk) return pu;
  Gk = 1;
  var e = gO(), n = kO();
  function r(i, a) {
    return i != null && n(i, a, e);
  }
  return pu = r, pu;
}
var fu, Yk;
function xO() {
  if (Yk) return fu;
  Yk = 1;
  var e = yO(), n = bO();
  function r(i, a) {
    return e(i, a, function(o, s) {
      return n(i, s);
    });
  }
  return fu = r, fu;
}
var hu, Jk;
function Vy() {
  if (Jk) return hu;
  Jk = 1;
  function e(n, r) {
    for (var i = -1, a = r.length, o = n.length; ++i < a; )
      n[o + i] = r[i];
    return n;
  }
  return hu = e, hu;
}
var yu, Qk;
function _O() {
  if (Qk) return yu;
  Qk = 1;
  var e = Vo(), n = Ay(), r = fi(), i = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return r(o) || n(o) || !!(i && o && o[i]);
  }
  return yu = a, yu;
}
var gu, Xk;
function SO() {
  if (Xk) return gu;
  Xk = 1;
  var e = Vy(), n = _O();
  function r(i, a, o, s, l) {
    var u = -1, p = i.length;
    for (o || (o = n), l || (l = []); ++u < p; ) {
      var d = i[u];
      a > 0 && o(d) ? a > 1 ? r(d, a - 1, o, s, l) : e(l, d) : s || (l[l.length] = d);
    }
    return l;
  }
  return gu = r, gu;
}
var vu, Zk;
function NO() {
  if (Zk) return vu;
  Zk = 1;
  var e = SO();
  function n(r) {
    var i = r == null ? 0 : r.length;
    return i ? e(r, 1) : [];
  }
  return vu = n, vu;
}
var ku, eb;
function jO() {
  if (eb) return ku;
  eb = 1;
  function e(n, r, i) {
    switch (i.length) {
      case 0:
        return n.call(r);
      case 1:
        return n.call(r, i[0]);
      case 2:
        return n.call(r, i[0], i[1]);
      case 3:
        return n.call(r, i[0], i[1], i[2]);
    }
    return n.apply(r, i);
  }
  return ku = e, ku;
}
var bu, nb;
function wO() {
  if (nb) return bu;
  nb = 1;
  var e = jO(), n = Math.max;
  function r(i, a, o) {
    return a = n(a === void 0 ? i.length - 1 : a, 0), function() {
      for (var s = arguments, l = -1, u = n(s.length - a, 0), p = Array(u); ++l < u; )
        p[l] = s[a + l];
      l = -1;
      for (var d = Array(a + 1); ++l < a; )
        d[l] = s[l];
      return d[a] = o(p), e(i, this, d);
    };
  }
  return bu = r, bu;
}
var xu, tb;
function CO() {
  if (tb) return xu;
  tb = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  return xu = e, xu;
}
var _u, rb;
function kC() {
  if (rb) return _u;
  rb = 1;
  function e(n) {
    return n;
  }
  return _u = e, _u;
}
var Su, ib;
function IO() {
  if (ib) return Su;
  ib = 1;
  var e = CO(), n = gC(), r = kC(), i = n ? function(a, o) {
    return n(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : r;
  return Su = i, Su;
}
var Nu, ab;
function FO() {
  if (ab) return Nu;
  ab = 1;
  var e = 800, n = 16, r = Date.now;
  function i(a) {
    var o = 0, s = 0;
    return function() {
      var l = r(), u = n - (l - s);
      if (s = l, u > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return Nu = i, Nu;
}
var ju, ob;
function EO() {
  if (ob) return ju;
  ob = 1;
  var e = IO(), n = FO(), r = n(e);
  return ju = r, ju;
}
var wu, sb;
function bC() {
  if (sb) return wu;
  sb = 1;
  var e = NO(), n = wO(), r = EO();
  function i(a) {
    return r(n(a, void 0, e), a + "");
  }
  return wu = i, wu;
}
var Cu, lb;
function $O() {
  if (lb) return Cu;
  lb = 1;
  var e = xO(), n = bC(), r = n(function(i, a) {
    return i == null ? {} : e(i, a);
  });
  return Cu = r, Cu;
}
var TO = $O();
const xC = /* @__PURE__ */ cC(TO), OO = [
  "control",
  "defaultValue",
  "name",
  "rules",
  "shouldUnregister"
];
function _C(e) {
  const n = xC(e, OO);
  return {
    controller: Ey(n),
    controllerProps: n
  };
}
const DO = [
  "className",
  "description",
  "disabled",
  "helpIcon",
  "label",
  "noAlert",
  "noLabel",
  "style"
];
function SC(e) {
  const { controller: n, controllerProps: r } = _C(e), i = {
    ...xC(e, DO),
    required: VT(r.rules?.required),
    meta: {
      touched: n.fieldState.isTouched,
      error: n.fieldState.error?.message,
      success: e.meta?.success,
      warning: e.meta?.warning
    },
    labelFor: r.name,
    noLabel: e.noLabel,
    noAlert: e.noAlert
  };
  return {
    controller: n,
    controllerProps: r,
    fieldWrapperProps: i
  };
}
var Iu, cb;
function PO() {
  if (cb) return Iu;
  cb = 1;
  var e = El();
  function n() {
    this.__data__ = new e(), this.size = 0;
  }
  return Iu = n, Iu;
}
var Fu, ub;
function RO() {
  if (ub) return Fu;
  ub = 1;
  function e(n) {
    var r = this.__data__, i = r.delete(n);
    return this.size = r.size, i;
  }
  return Fu = e, Fu;
}
var Eu, db;
function AO() {
  if (db) return Eu;
  db = 1;
  function e(n) {
    return this.__data__.get(n);
  }
  return Eu = e, Eu;
}
var $u, mb;
function LO() {
  if (mb) return $u;
  mb = 1;
  function e(n) {
    return this.__data__.has(n);
  }
  return $u = e, $u;
}
var Tu, pb;
function VO() {
  if (pb) return Tu;
  pb = 1;
  var e = El(), n = Dy(), r = fC(), i = 200;
  function a(o, s) {
    var l = this.__data__;
    if (l instanceof e) {
      var u = l.__data__;
      if (!n || u.length < i - 1)
        return u.push([o, s]), this.size = ++l.size, this;
      l = this.__data__ = new r(u);
    }
    return l.set(o, s), this.size = l.size, this;
  }
  return Tu = a, Tu;
}
var Ou, fb;
function zO() {
  if (fb) return Ou;
  fb = 1;
  var e = El(), n = PO(), r = RO(), i = AO(), a = LO(), o = VO();
  function s(l) {
    var u = this.__data__ = new e(l);
    this.size = u.size;
  }
  return s.prototype.clear = n, s.prototype.delete = r, s.prototype.get = i, s.prototype.has = a, s.prototype.set = o, Ou = s, Ou;
}
var Du, hb;
function UO() {
  if (hb) return Du;
  hb = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length; ++i < a && r(n[i], i, n) !== !1; )
      ;
    return n;
  }
  return Du = e, Du;
}
var Pu, yb;
function zo() {
  if (yb) return Pu;
  yb = 1;
  var e = Py(), n = vC();
  function r(i, a, o, s) {
    var l = !o;
    o || (o = {});
    for (var u = -1, p = a.length; ++u < p; ) {
      var d = a[u], f = s ? s(o[d], i[d], d, o, i) : void 0;
      f === void 0 && (f = i[d]), l ? n(o, d, f) : e(o, d, f);
    }
    return o;
  }
  return Pu = r, Pu;
}
var Ru, gb;
function MO() {
  if (gb) return Ru;
  gb = 1;
  function e(n, r) {
    for (var i = -1, a = Array(n); ++i < n; )
      a[i] = r(i);
    return a;
  }
  return Ru = e, Ru;
}
var As = { exports: {} }, Au, vb;
function BO() {
  if (vb) return Au;
  vb = 1;
  function e() {
    return !1;
  }
  return Au = e, Au;
}
As.exports;
var kb;
function NC() {
  return kb || (kb = 1, (function(e, n) {
    var r = qr(), i = BO(), a = n && !n.nodeType && n, o = a && !0 && e && !e.nodeType && e, s = o && o.exports === a, l = s ? r.Buffer : void 0, u = l ? l.isBuffer : void 0, p = u || i;
    e.exports = p;
  })(As, As.exports)), As.exports;
}
var Lu, bb;
function qO() {
  if (bb) return Lu;
  bb = 1;
  var e = Na(), n = Ly(), r = Li(), i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", l = "[object Error]", u = "[object Function]", p = "[object Map]", d = "[object Number]", f = "[object Object]", h = "[object RegExp]", v = "[object Set]", C = "[object String]", j = "[object WeakMap]", N = "[object ArrayBuffer]", x = "[object DataView]", g = "[object Float32Array]", P = "[object Float64Array]", E = "[object Int8Array]", I = "[object Int16Array]", w = "[object Int32Array]", A = "[object Uint8Array]", H = "[object Uint8ClampedArray]", Y = "[object Uint16Array]", ne = "[object Uint32Array]", W = {};
  W[g] = W[P] = W[E] = W[I] = W[w] = W[A] = W[H] = W[Y] = W[ne] = !0, W[i] = W[a] = W[N] = W[o] = W[x] = W[s] = W[l] = W[u] = W[p] = W[d] = W[f] = W[h] = W[v] = W[C] = W[j] = !1;
  function B(D) {
    return r(D) && n(D.length) && !!W[e(D)];
  }
  return Lu = B, Lu;
}
var Vu, xb;
function zy() {
  if (xb) return Vu;
  xb = 1;
  function e(n) {
    return function(r) {
      return n(r);
    };
  }
  return Vu = e, Vu;
}
var Ls = { exports: {} };
Ls.exports;
var _b;
function Uy() {
  return _b || (_b = 1, (function(e, n) {
    var r = uC(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o && r.process, l = (function() {
      try {
        var u = a && a.require && a.require("util").types;
        return u || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = l;
  })(Ls, Ls.exports)), Ls.exports;
}
var zu, Sb;
function HO() {
  if (Sb) return zu;
  Sb = 1;
  var e = qO(), n = zy(), r = Uy(), i = r && r.isTypedArray, a = i ? n(i) : e;
  return zu = a, zu;
}
var Uu, Nb;
function jC() {
  if (Nb) return Uu;
  Nb = 1;
  var e = MO(), n = Ay(), r = fi(), i = NC(), a = Ry(), o = HO(), s = Object.prototype, l = s.hasOwnProperty;
  function u(p, d) {
    var f = r(p), h = !f && n(p), v = !f && !h && i(p), C = !f && !h && !v && o(p), j = f || h || v || C, N = j ? e(p.length, String) : [], x = N.length;
    for (var g in p)
      (d || l.call(p, g)) && !(j && // Safari 9 has enumerable `arguments.length` in strict mode.
      (g == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      v && (g == "offset" || g == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      C && (g == "buffer" || g == "byteLength" || g == "byteOffset") || // Skip index properties.
      a(g, x))) && N.push(g);
    return N;
  }
  return Uu = u, Uu;
}
var Mu, jb;
function My() {
  if (jb) return Mu;
  jb = 1;
  var e = Object.prototype;
  function n(r) {
    var i = r && r.constructor, a = typeof i == "function" && i.prototype || e;
    return r === a;
  }
  return Mu = n, Mu;
}
var Bu, wb;
function wC() {
  if (wb) return Bu;
  wb = 1;
  function e(n, r) {
    return function(i) {
      return n(r(i));
    };
  }
  return Bu = e, Bu;
}
var qu, Cb;
function WO() {
  if (Cb) return qu;
  Cb = 1;
  var e = wC(), n = e(Object.keys, Object);
  return qu = n, qu;
}
var Hu, Ib;
function KO() {
  if (Ib) return Hu;
  Ib = 1;
  var e = My(), n = WO(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return n(o);
    var s = [];
    for (var l in Object(o))
      i.call(o, l) && l != "constructor" && s.push(l);
    return s;
  }
  return Hu = a, Hu;
}
var Wu, Fb;
function CC() {
  if (Fb) return Wu;
  Fb = 1;
  var e = dC(), n = Ly();
  function r(i) {
    return i != null && n(i.length) && !e(i);
  }
  return Wu = r, Wu;
}
var Ku, Eb;
function By() {
  if (Eb) return Ku;
  Eb = 1;
  var e = jC(), n = KO(), r = CC();
  function i(a) {
    return r(a) ? e(a) : n(a);
  }
  return Ku = i, Ku;
}
var Gu, $b;
function GO() {
  if ($b) return Gu;
  $b = 1;
  var e = zo(), n = By();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return Gu = r, Gu;
}
var Yu, Tb;
function YO() {
  if (Tb) return Yu;
  Tb = 1;
  function e(n) {
    var r = [];
    if (n != null)
      for (var i in Object(n))
        r.push(i);
    return r;
  }
  return Yu = e, Yu;
}
var Ju, Ob;
function JO() {
  if (Ob) return Ju;
  Ob = 1;
  var e = ja(), n = My(), r = YO(), i = Object.prototype, a = i.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return r(s);
    var l = n(s), u = [];
    for (var p in s)
      p == "constructor" && (l || !a.call(s, p)) || u.push(p);
    return u;
  }
  return Ju = o, Ju;
}
var Qu, Db;
function qy() {
  if (Db) return Qu;
  Db = 1;
  var e = jC(), n = JO(), r = CC();
  function i(a) {
    return r(a) ? e(a, !0) : n(a);
  }
  return Qu = i, Qu;
}
var Xu, Pb;
function QO() {
  if (Pb) return Xu;
  Pb = 1;
  var e = zo(), n = qy();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return Xu = r, Xu;
}
var Vs = { exports: {} };
Vs.exports;
var Rb;
function XO() {
  return Rb || (Rb = 1, (function(e, n) {
    var r = qr(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? r.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
    function u(p, d) {
      if (d)
        return p.slice();
      var f = p.length, h = l ? l(f) : new p.constructor(f);
      return p.copy(h), h;
    }
    e.exports = u;
  })(Vs, Vs.exports)), Vs.exports;
}
var Zu, Ab;
function ZO() {
  if (Ab) return Zu;
  Ab = 1;
  function e(n, r) {
    var i = -1, a = n.length;
    for (r || (r = Array(a)); ++i < a; )
      r[i] = n[i];
    return r;
  }
  return Zu = e, Zu;
}
var ed, Lb;
function eD() {
  if (Lb) return ed;
  Lb = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = 0, s = []; ++i < a; ) {
      var l = n[i];
      r(l, i, n) && (s[o++] = l);
    }
    return s;
  }
  return ed = e, ed;
}
var nd, Vb;
function IC() {
  if (Vb) return nd;
  Vb = 1;
  function e() {
    return [];
  }
  return nd = e, nd;
}
var td, zb;
function Hy() {
  if (zb) return td;
  zb = 1;
  var e = eD(), n = IC(), r = Object.prototype, i = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(l) {
      return i.call(s, l);
    }));
  } : n;
  return td = o, td;
}
var rd, Ub;
function nD() {
  if (Ub) return rd;
  Ub = 1;
  var e = zo(), n = Hy();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return rd = r, rd;
}
var id, Mb;
function Wy() {
  if (Mb) return id;
  Mb = 1;
  var e = wC(), n = e(Object.getPrototypeOf, Object);
  return id = n, id;
}
var ad, Bb;
function FC() {
  if (Bb) return ad;
  Bb = 1;
  var e = Vy(), n = Wy(), r = Hy(), i = IC(), a = Object.getOwnPropertySymbols, o = a ? function(s) {
    for (var l = []; s; )
      e(l, r(s)), s = n(s);
    return l;
  } : i;
  return ad = o, ad;
}
var od, qb;
function tD() {
  if (qb) return od;
  qb = 1;
  var e = zo(), n = FC();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return od = r, od;
}
var sd, Hb;
function EC() {
  if (Hb) return sd;
  Hb = 1;
  var e = Vy(), n = fi();
  function r(i, a, o) {
    var s = a(i);
    return n(i) ? s : e(s, o(i));
  }
  return sd = r, sd;
}
var ld, Wb;
function rD() {
  if (Wb) return ld;
  Wb = 1;
  var e = EC(), n = Hy(), r = By();
  function i(a) {
    return e(a, r, n);
  }
  return ld = i, ld;
}
var cd, Kb;
function $C() {
  if (Kb) return cd;
  Kb = 1;
  var e = EC(), n = FC(), r = qy();
  function i(a) {
    return e(a, r, n);
  }
  return cd = i, cd;
}
var ud, Gb;
function iD() {
  if (Gb) return ud;
  Gb = 1;
  var e = Vi(), n = qr(), r = e(n, "DataView");
  return ud = r, ud;
}
var dd, Yb;
function aD() {
  if (Yb) return dd;
  Yb = 1;
  var e = Vi(), n = qr(), r = e(n, "Promise");
  return dd = r, dd;
}
var md, Jb;
function oD() {
  if (Jb) return md;
  Jb = 1;
  var e = Vi(), n = qr(), r = e(n, "Set");
  return md = r, md;
}
var pd, Qb;
function sD() {
  if (Qb) return pd;
  Qb = 1;
  var e = Vi(), n = qr(), r = e(n, "WeakMap");
  return pd = r, pd;
}
var fd, Xb;
function Ky() {
  if (Xb) return fd;
  Xb = 1;
  var e = iD(), n = Dy(), r = aD(), i = oD(), a = sD(), o = Na(), s = mC(), l = "[object Map]", u = "[object Object]", p = "[object Promise]", d = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", v = s(e), C = s(n), j = s(r), N = s(i), x = s(a), g = o;
  return (e && g(new e(new ArrayBuffer(1))) != h || n && g(new n()) != l || r && g(r.resolve()) != p || i && g(new i()) != d || a && g(new a()) != f) && (g = function(P) {
    var E = o(P), I = E == u ? P.constructor : void 0, w = I ? s(I) : "";
    if (w)
      switch (w) {
        case v:
          return h;
        case C:
          return l;
        case j:
          return p;
        case N:
          return d;
        case x:
          return f;
      }
    return E;
  }), fd = g, fd;
}
var hd, Zb;
function lD() {
  if (Zb) return hd;
  Zb = 1;
  var e = Object.prototype, n = e.hasOwnProperty;
  function r(i) {
    var a = i.length, o = new i.constructor(a);
    return a && typeof i[0] == "string" && n.call(i, "index") && (o.index = i.index, o.input = i.input), o;
  }
  return hd = r, hd;
}
var yd, ex;
function cD() {
  if (ex) return yd;
  ex = 1;
  var e = qr(), n = e.Uint8Array;
  return yd = n, yd;
}
var gd, nx;
function Gy() {
  if (nx) return gd;
  nx = 1;
  var e = cD();
  function n(r) {
    var i = new r.constructor(r.byteLength);
    return new e(i).set(new e(r)), i;
  }
  return gd = n, gd;
}
var vd, tx;
function uD() {
  if (tx) return vd;
  tx = 1;
  var e = Gy();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return vd = n, vd;
}
var kd, rx;
function dD() {
  if (rx) return kd;
  rx = 1;
  var e = /\w*$/;
  function n(r) {
    var i = new r.constructor(r.source, e.exec(r));
    return i.lastIndex = r.lastIndex, i;
  }
  return kd = n, kd;
}
var bd, ix;
function mD() {
  if (ix) return bd;
  ix = 1;
  var e = Vo(), n = e ? e.prototype : void 0, r = n ? n.valueOf : void 0;
  function i(a) {
    return r ? Object(r.call(a)) : {};
  }
  return bd = i, bd;
}
var xd, ax;
function pD() {
  if (ax) return xd;
  ax = 1;
  var e = Gy();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return xd = n, xd;
}
var _d, ox;
function fD() {
  if (ox) return _d;
  ox = 1;
  var e = Gy(), n = uD(), r = dD(), i = mD(), a = pD(), o = "[object Boolean]", s = "[object Date]", l = "[object Map]", u = "[object Number]", p = "[object RegExp]", d = "[object Set]", f = "[object String]", h = "[object Symbol]", v = "[object ArrayBuffer]", C = "[object DataView]", j = "[object Float32Array]", N = "[object Float64Array]", x = "[object Int8Array]", g = "[object Int16Array]", P = "[object Int32Array]", E = "[object Uint8Array]", I = "[object Uint8ClampedArray]", w = "[object Uint16Array]", A = "[object Uint32Array]";
  function H(Y, ne, W) {
    var B = Y.constructor;
    switch (ne) {
      case v:
        return e(Y);
      case o:
      case s:
        return new B(+Y);
      case C:
        return n(Y, W);
      case j:
      case N:
      case x:
      case g:
      case P:
      case E:
      case I:
      case w:
      case A:
        return a(Y, W);
      case l:
        return new B();
      case u:
      case f:
        return new B(Y);
      case p:
        return r(Y);
      case d:
        return new B();
      case h:
        return i(Y);
    }
  }
  return _d = H, _d;
}
var Sd, sx;
function hD() {
  if (sx) return Sd;
  sx = 1;
  var e = ja(), n = Object.create, r = /* @__PURE__ */ (function() {
    function i() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (n)
        return n(a);
      i.prototype = a;
      var o = new i();
      return i.prototype = void 0, o;
    };
  })();
  return Sd = r, Sd;
}
var Nd, lx;
function yD() {
  if (lx) return Nd;
  lx = 1;
  var e = hD(), n = Wy(), r = My();
  function i(a) {
    return typeof a.constructor == "function" && !r(a) ? e(n(a)) : {};
  }
  return Nd = i, Nd;
}
var jd, cx;
function gD() {
  if (cx) return jd;
  cx = 1;
  var e = Ky(), n = Li(), r = "[object Map]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return jd = i, jd;
}
var wd, ux;
function vD() {
  if (ux) return wd;
  ux = 1;
  var e = gD(), n = zy(), r = Uy(), i = r && r.isMap, a = i ? n(i) : e;
  return wd = a, wd;
}
var Cd, dx;
function kD() {
  if (dx) return Cd;
  dx = 1;
  var e = Ky(), n = Li(), r = "[object Set]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Cd = i, Cd;
}
var Id, mx;
function bD() {
  if (mx) return Id;
  mx = 1;
  var e = kD(), n = zy(), r = Uy(), i = r && r.isSet, a = i ? n(i) : e;
  return Id = a, Id;
}
var Fd, px;
function xD() {
  if (px) return Fd;
  px = 1;
  var e = zO(), n = UO(), r = Py(), i = GO(), a = QO(), o = XO(), s = ZO(), l = nD(), u = tD(), p = rD(), d = $C(), f = Ky(), h = lD(), v = fD(), C = yD(), j = fi(), N = NC(), x = vD(), g = ja(), P = bD(), E = By(), I = qy(), w = 1, A = 2, H = 4, Y = "[object Arguments]", ne = "[object Array]", W = "[object Boolean]", B = "[object Date]", D = "[object Error]", M = "[object Function]", Z = "[object GeneratorFunction]", je = "[object Map]", ge = "[object Number]", ye = "[object Object]", ke = "[object RegExp]", q = "[object Set]", _e = "[object String]", De = "[object Symbol]", G = "[object WeakMap]", Ye = "[object ArrayBuffer]", sn = "[object DataView]", Ie = "[object Float32Array]", Ue = "[object Float64Array]", Pe = "[object Int8Array]", Be = "[object Int16Array]", Le = "[object Int32Array]", Xe = "[object Uint8Array]", Fe = "[object Uint8ClampedArray]", Me = "[object Uint16Array]", nn = "[object Uint32Array]", se = {};
  se[Y] = se[ne] = se[Ye] = se[sn] = se[W] = se[B] = se[Ie] = se[Ue] = se[Pe] = se[Be] = se[Le] = se[je] = se[ge] = se[ye] = se[ke] = se[q] = se[_e] = se[De] = se[Xe] = se[Fe] = se[Me] = se[nn] = !0, se[D] = se[M] = se[G] = !1;
  function le(Se, Ae, Re, yn, Q, $) {
    var z, X = Ae & w, ae = Ae & A, V = Ae & H;
    if (Re && (z = Q ? Re(Se, yn, Q, $) : Re(Se)), z !== void 0)
      return z;
    if (!g(Se))
      return Se;
    var J = j(Se);
    if (J) {
      if (z = h(Se), !X)
        return s(Se, z);
    } else {
      var de = f(Se), xe = de == M || de == Z;
      if (N(Se))
        return o(Se, X);
      if (de == ye || de == Y || xe && !Q) {
        if (z = ae || xe ? {} : C(Se), !X)
          return ae ? u(Se, a(z, Se)) : l(Se, i(z, Se));
      } else {
        if (!se[de])
          return Q ? Se : {};
        z = v(Se, de, X);
      }
    }
    $ || ($ = new e());
    var $e = $.get(Se);
    if ($e)
      return $e;
    $.set(Se, z), P(Se) ? Se.forEach(function(on) {
      z.add(le(on, Ae, Re, on, Se, $));
    }) : x(Se) && Se.forEach(function(on, pn) {
      z.set(pn, le(on, Ae, Re, pn, Se, $));
    });
    var tn = V ? ae ? d : p : ae ? I : E, gn = J ? void 0 : tn(Se);
    return n(gn || Se, function(on, pn) {
      gn && (pn = on, on = Se[pn]), r(z, pn, le(on, Ae, Re, pn, Se, $));
    }), z;
  }
  return Fd = le, Fd;
}
var Ed, fx;
function _D() {
  if (fx) return Ed;
  fx = 1;
  function e(n) {
    var r = n == null ? 0 : n.length;
    return r ? n[r - 1] : void 0;
  }
  return Ed = e, Ed;
}
var $d, hx;
function SD() {
  if (hx) return $d;
  hx = 1;
  function e(n, r, i) {
    var a = -1, o = n.length;
    r < 0 && (r = -r > o ? 0 : o + r), i = i > o ? o : i, i < 0 && (i += o), o = r > i ? 0 : i - r >>> 0, r >>>= 0;
    for (var s = Array(o); ++a < o; )
      s[a] = n[a + r];
    return s;
  }
  return $d = e, $d;
}
var Td, yx;
function ND() {
  if (yx) return Td;
  yx = 1;
  var e = yC(), n = SD();
  function r(i, a) {
    return a.length < 2 ? i : e(i, n(a, 0, -1));
  }
  return Td = r, Td;
}
var Od, gx;
function jD() {
  if (gx) return Od;
  gx = 1;
  var e = wa(), n = _D(), r = ND(), i = Tl(), a = Object.prototype, o = a.hasOwnProperty;
  function s(l, u) {
    u = e(u, l);
    var p = -1, d = u.length;
    if (!d)
      return !0;
    for (; ++p < d; ) {
      var f = i(u[p]);
      if (f === "__proto__" && !o.call(l, "__proto__") || (f === "constructor" || f === "prototype") && p < d - 1)
        return !1;
    }
    var h = r(l, u);
    return h == null || delete h[i(n(u))];
  }
  return Od = s, Od;
}
var Dd, vx;
function wD() {
  if (vx) return Dd;
  vx = 1;
  var e = Na(), n = Wy(), r = Li(), i = "[object Object]", a = Function.prototype, o = Object.prototype, s = a.toString, l = o.hasOwnProperty, u = s.call(Object);
  function p(d) {
    if (!r(d) || e(d) != i)
      return !1;
    var f = n(d);
    if (f === null)
      return !0;
    var h = l.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && s.call(h) == u;
  }
  return Dd = p, Dd;
}
var Pd, kx;
function CD() {
  if (kx) return Pd;
  kx = 1;
  var e = wD();
  function n(r) {
    return e(r) ? void 0 : r;
  }
  return Pd = n, Pd;
}
var Rd, bx;
function ID() {
  if (bx) return Rd;
  bx = 1;
  var e = hC(), n = xD(), r = jD(), i = wa(), a = zo(), o = CD(), s = bC(), l = $C(), u = 1, p = 2, d = 4, f = s(function(h, v) {
    var C = {};
    if (h == null)
      return C;
    var j = !1;
    v = e(v, function(x) {
      return x = i(x, h), j || (j = x.length > 1), x;
    }), a(h, l(h), C), j && (C = n(C, u | p | d, o));
    for (var N = v.length; N--; )
      r(C, v[N]);
    return C;
  });
  return Rd = f, Rd;
}
ID();
const fr = ({
  children: e,
  ...n
}) => {
  const { controller: r, controllerProps: i, fieldWrapperProps: a } = SC(n), {
    name: o,
    onBlur: s,
    onChange: l,
    ...u
  } = r.field;
  return /* @__PURE__ */ Ti.jsx(We, { ...a, children: /* @__PURE__ */ Ti.jsx(
    ei,
    {
      ...n.componentProps,
      ...u,
      multiple: !1,
      value: u.value ? [u.value] : [],
      onBlur: (p) => {
        n.componentProps?.onBlur?.(p), s();
      },
      onChange: (p) => {
        n.componentProps?.onChange?.(p), l(p.selectedValues[0] ?? null);
      },
      id: i.name,
      "aria-disabled": a.disabled,
      disabled: a.disabled,
      "aria-required": a.required,
      required: a.required,
      status: We.getStatus(a.meta),
      children: e
    }
  ) });
};
var FD = kC();
const ED = /* @__PURE__ */ cC(FD), Sn = ({
  transformValue: e = ED,
  label: n,
  helpIcon: r,
  className: i,
  ...a
}) => {
  const {
    controller: { field: o },
    controllerProps: { name: s }
  } = _C(a);
  return /* @__PURE__ */ Ti.jsxs(b, { gap: "200", alignItems: "center", className: i, children: [
    /* @__PURE__ */ Ti.jsx(
      Ks,
      {
        ...o,
        id: s,
        checked: e(o.value),
        disabled: a.componentProps?.disabled,
        onChange: (l) => {
          a.componentProps?.onChange?.(l), o.onChange(e(l.target.checked));
        }
      }
    ),
    n && /* @__PURE__ */ Ti.jsx(mw, { htmlFor: s, helpIcon: r, children: n })
  ] });
}, Gn = (e) => {
  const { controller: n, controllerProps: r, fieldWrapperProps: i } = SC(e);
  return /* @__PURE__ */ Ti.jsx(We, { ...i, children: /* @__PURE__ */ Ti.jsx(
    mr,
    {
      ...e.componentProps,
      ...n.field,
      value: e.componentProps?.type === "number" && isNaN(n.field.value) ? "" : n.field.value ?? "",
      onBlur: (a) => {
        e.componentProps?.onBlur?.(a), n.field.onBlur();
      },
      onChange: (a) => {
        e.componentProps?.onChange?.(a), n.field.onChange(
          e.componentProps?.type === "number" ? a.target.valueAsNumber : a
        );
      },
      id: r.name,
      "aria-disabled": i.disabled,
      disabled: i.disabled,
      "aria-required": i.required,
      required: i.required,
      status: We.getStatus(i.meta)
    }
  ) });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._copyIcon_10dvk_54{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_10dvk_59{padding:0;max-height:250px;overflow-y:auto;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_10dvk_69{background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_10dvk_69:last-child:not(:only-child){border-bottom:none}._collapsible_10dvk_78{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._collapsible_10dvk_78:hover,._collapsibleIsOpen_10dvk_86{border-color:var(--dixa-color-neutral-400)}._collapsibleHeader_10dvk_89{cursor:pointer}._collapsibleIconTrue_10dvk_92{color:var(--dixa-color-green-500)}._collapsibleIconFalse_10dvk_95{color:var(--dixa-color-red-500)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Ad = { exports: {} }, za = {}, xx;
function $D() {
  if (xx) return za;
  xx = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return za.Fragment = r, za.jsx = s, za.jsxs = s, za;
}
var es = {}, _x;
function TD() {
  return _x || (_x = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        P("error", t, m);
      }
    }
    function P(t, c, m) {
      {
        var y = x.ReactDebugCurrentFrame, F = y.getStackAddendum();
        F !== "" && (c += "%s", m = m.concat([F]));
        var T = m.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var E = !1, I = !1, w = !1, A = !1, H = !1, Y;
    Y = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ne(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || H || t === a || t === p || t === d || A || t === v || E || I || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function W(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var F = c.displayName || c.name || "";
      return F !== "" ? m + "(" + F + ")" : m;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function D(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var m = t;
            return B(m._context) + ".Provider";
          case u:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : D(t.type) || "Memo";
          case h: {
            var F = t, T = F._payload, S = F._init;
            try {
              return D(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var M = Object.assign, Z = 0, je, ge, ye, ke, q, _e, De;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function Ye() {
      {
        if (Z === 0) {
          je = console.log, ge = console.info, ye = console.warn, ke = console.error, q = console.group, _e = console.groupCollapsed, De = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function sn() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: M({}, t, {
              value: je
            }),
            info: M({}, t, {
              value: ge
            }),
            warn: M({}, t, {
              value: ye
            }),
            error: M({}, t, {
              value: ke
            }),
            group: M({}, t, {
              value: q
            }),
            groupCollapsed: M({}, t, {
              value: _e
            }),
            groupEnd: M({}, t, {
              value: De
            })
          });
        }
        Z < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = x.ReactCurrentDispatcher, Ue;
    function Pe(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (F) {
            var y = F.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Le;
    {
      var Xe = typeof WeakMap == "function" ? WeakMap : Map;
      Le = new Xe();
    }
    function Fe(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Le.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      Be = !0;
      var F = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ye();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (re) {
              y = re;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (re) {
              y = re;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            y = re;
          }
          t();
        }
      } catch (re) {
        if (re && y && typeof re.stack == "string") {
          for (var _ = re.stack.split(`
`), ee = y.stack.split(`
`), L = _.length - 1, U = ee.length - 1; L >= 1 && U >= 0 && _[L] !== ee[U]; )
            U--;
          for (; L >= 1 && U >= 0; L--, U--)
            if (_[L] !== ee[U]) {
              if (L !== 1 || U !== 1)
                do
                  if (L--, U--, U < 0 || _[L] !== ee[U]) {
                    var ce = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && ce.includes("<anonymous>") && (ce = ce.replace("<anonymous>", t.displayName)), typeof t == "function" && Le.set(t, ce), ce;
                  }
                while (L >= 1 && U >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = F;
      }
      var ze = t ? t.displayName || t.name : "", Oe = ze ? Pe(ze) : "";
      return typeof t == "function" && Le.set(t, Oe), Oe;
    }
    function Me(t, c, m) {
      return Fe(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Fe(t, nn(t));
      if (typeof t == "string")
        return Pe(t);
      switch (t) {
        case p:
          return Pe("Suspense");
        case d:
          return Pe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return Me(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, F = y._payload, T = y._init;
            try {
              return se(T(F), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Se = {}, Ae = x.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(m);
      } else
        Ae.setExtraStackFrame(null);
    }
    function yn(t, c, m, y, F) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + m + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              _ = t[S](c, S, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Re(F), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, S, typeof _), Re(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Re(F), g("Failed %s type: %s", m, _.message), Re(null));
          }
      }
    }
    var Q = Array.isArray;
    function $(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ae(t);
    }
    var J = x.ReactCurrentOwner, de = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, xe, $e;
    function tn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && J.current;
    }
    function pn(t, c) {
      {
        var m = function() {
          xe || (xe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function Fn(t, c) {
      {
        var m = function() {
          $e || ($e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, m, y, F, T, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: F
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, m, y, F) {
      {
        var T, S = {}, _ = null, ee = null;
        m !== void 0 && (V(m), _ = "" + m), gn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ee = c.ref, on(c));
        for (T in c)
          le.call(c, T) && !de.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (T in L)
            S[T] === void 0 && (S[T] = L[T]);
        }
        if (_ || ee) {
          var U = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, U), ee && Fn(S, U);
        }
        return xn(t, _, ee, F, y, J.current, S);
      }
    }
    var en = x.ReactCurrentOwner, vn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        vn.setExtraStackFrame(m);
      } else
        vn.setExtraStackFrame(null);
    }
    var un;
    un = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = D(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Nn = {};
    function Rn(t) {
      {
        var c = jn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function kn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Rn(c);
        if (Nn[m])
          return;
        Nn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + D(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Ve(null);
      }
    }
    function _n(t, c) {
      {
        if (typeof t != "object")
          return;
        if ($(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            dn(y) && kn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var F = N(t);
          if (typeof F == "function" && F !== t.entries)
            for (var T = F.call(t), S; !(S = T.next()).done; )
              dn(S.value) && kn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = D(c);
          yn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !un) {
          un = !0;
          var F = D(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", F || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, m, y, F, T) {
      {
        var S = ne(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = Bn();
          ee ? _ += ee : _ += jn();
          var L;
          t === null ? L = "null" : $(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (D(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var U = En(t, c, m, F, T);
        if (U == null)
          return U;
        if (S) {
          var ce = c.children;
          if (ce !== void 0)
            if (y)
              if ($(ce)) {
                for (var ze = 0; ze < ce.length; ze++)
                  _n(ce[ze], t);
                Object.freeze && Object.freeze(ce);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _n(ce, t);
        }
        if (le.call(c, "key")) {
          var Oe = D(t), re = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), mn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Oe + mn]) {
            var Dn = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Oe, Dn, Oe), Cn[Oe + mn] = !0;
          }
        }
        return t === i ? Ln(U) : An(U), U;
      }
    }
    function Vn(t, c, m) {
      return wn(t, c, m, !0);
    }
    function qn(t, c, m) {
      return wn(t, c, m, !1);
    }
    var zn = qn, Wn = Vn;
    es.Fragment = i, es.jsx = zn, es.jsxs = Wn;
  })()), es;
}
var Sx;
function OD() {
  return Sx || (Sx = 1, process.env.NODE_ENV === "production" ? Ad.exports = $D() : Ad.exports = TD()), Ad.exports;
}
var te = OD();
const DD = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "exportUserDetails" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_ExportedUserDetails" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "users" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "braze_id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "dob" } }, { kind: "Field", name: { kind: "Name", value: "home_city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "language" } }, { kind: "Field", name: { kind: "Name", value: "time_zone" } }, { kind: "Field", name: { kind: "Name", value: "total_revenue" } }, { kind: "Field", name: { kind: "Name", value: "push_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "email_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "custom_attributes" } }, { kind: "Field", name: { kind: "Name", value: "apps" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "platform" } }, { kind: "Field", name: { kind: "Name", value: "version" } }, { kind: "Field", name: { kind: "Name", value: "sessions" } }, { kind: "Field", name: { kind: "Name", value: "first_used" } }, { kind: "Field", name: { kind: "Name", value: "last_used" } }] } }, { kind: "Field", name: { kind: "Name", value: "devices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "model" } }, { kind: "Field", name: { kind: "Name", value: "os" } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "idfv" } }, { kind: "Field", name: { kind: "Name", value: "idfa" } }, { kind: "Field", name: { kind: "Name", value: "google_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "roku_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "ad_tracking_enabled" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_events" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "purchases" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] } }] }, PD = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_updateEmailSubscriptionStatus_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] }, RD = {
  "\n  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {\n    Braze {\n      exportUserDetails(input: $input) {\n        ... on Braze_exportUserDetails_response {\n          ... on Braze_ExportedUserDetails {\n            message\n            users {\n              external_id\n              braze_id\n              created_at\n              email\n              first_name\n              last_name\n              dob\n              home_city\n              country\n              phone\n              language\n              time_zone\n              total_revenue\n              push_subscribe\n              email_subscribe\n              custom_attributes\n              apps {\n                name\n                platform\n                version\n                sessions\n                first_used\n                last_used\n              }\n              devices {\n                model\n                os\n                carrier\n                idfv\n                idfa\n                google_ad_id\n                roku_ad_id\n                ad_tracking_enabled\n              }\n              custom_events {\n                name\n                first\n                last\n                count\n              }\n              purchases {\n                name\n                first\n                last\n                count\n              }\n            }\n          }\n\n          ... on Braze_BasicResponse {\n            message\n          }\n        }\n      }\n    }\n  }\n": DD,
  "\n  mutation updateEmailSubscriptionStatus(\n    $input: Braze_updateEmailSubscriptionStatus_request_Input!\n  ) {\n    Braze {\n      updateEmailSubscriptionStatus(input: $input) {\n        message\n      }\n    }\n  }\n": PD
};
function TC(e) {
  return RD[e] ?? {};
}
const AD = TC(
  /* GraphQL */
  `
  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {
    Braze {
      exportUserDetails(input: $input) {
        ... on Braze_exportUserDetails_response {
          ... on Braze_ExportedUserDetails {
            message
            users {
              external_id
              braze_id
              created_at
              email
              first_name
              last_name
              dob
              home_city
              country
              phone
              language
              time_zone
              total_revenue
              push_subscribe
              email_subscribe
              custom_attributes
              apps {
                name
                platform
                version
                sessions
                first_used
                last_used
              }
              devices {
                model
                os
                carrier
                idfv
                idfa
                google_ad_id
                roku_ad_id
                ad_tracking_enabled
              }
              custom_events {
                name
                first
                last
                count
              }
              purchases {
                name
                first
                last
                count
              }
            }
          }

          ... on Braze_BasicResponse {
            message
          }
        }
      }
    }
  }
`
), LD = TC(
  /* GraphQL */
  `
  mutation updateEmailSubscriptionStatus(
    $input: Braze_updateEmailSubscriptionStatus_request_Input!
  ) {
    Braze {
      updateEmailSubscriptionStatus(input: $input) {
        message
      }
    }
  }
`
), VD = "_copyIcon_10dvk_54", zD = "_list_10dvk_59", UD = "_listItem_10dvk_69", MD = "_collapsible_10dvk_78", BD = "_collapsibleIsOpen_10dvk_86", qD = "_collapsibleHeader_10dvk_89", HD = "_collapsibleIconTrue_10dvk_92", WD = "_collapsibleIconFalse_10dvk_95", Un = {
  copyIcon: VD,
  list: zD,
  listItem: UD,
  collapsible: MD,
  collapsibleIsOpen: BD,
  collapsibleHeader: qD,
  collapsibleIconTrue: HD,
  collapsibleIconFalse: WD
}, KD = ({
  app: e,
  openByDefault: n
}) => {
  const [r, i] = ue(n);
  if (!e)
    return null;
  const {
    name: a,
    platform: o,
    version: s,
    sessions: l,
    first_used: u,
    last_used: p
  } = e;
  return /* @__PURE__ */ te.jsxs(
    b,
    {
      className: ut(Un.collapsible, {
        [Un.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ te.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Un.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "1", children: a }),
              /* @__PURE__ */ te.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ te.jsxs(Qe, { className: Un.list, children: [
          /* @__PURE__ */ te.jsx(Qe.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "3", children: "Platform" }),
            /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "5", color: "secondary", children: o })
          ] }) }),
          /* @__PURE__ */ te.jsx(Qe.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "3", children: "Version" }),
            /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ te.jsx(Qe.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "3", children: "Sessions" }),
            /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ te.jsx(Qe.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "3", children: "First used" }),
            /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "5", color: "secondary", children: Jn(u).format(jt) })
          ] }) }),
          /* @__PURE__ */ te.jsx(Qe.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "3", children: "Last used" }),
            /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "5", color: "secondary", children: Jn(p).format(jt) })
          ] }) })
        ] })
      ]
    }
  );
}, GD = ({ apps: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ te.jsx(O.Heading, { variant: "heading-3", children: "Apps" }),
      n && /* @__PURE__ */ te.jsx(Mn, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ te.jsx(
      O.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no apps associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ te.jsx(KD, { app: r, openByDefault: i === 0 }, i))
  ] });
}, YD = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_attributes: n } = e, r = !!n && Object.keys(n).length > 0;
  return /* @__PURE__ */ te.jsx(te.Fragment, { children: /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ te.jsx(O.Heading, { variant: "heading-3", children: "Custom attributes" }),
    !r && /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom attributes available" }),
    r && /* @__PURE__ */ te.jsx(Qe, { className: Un.list, children: Object.entries(
      n
    ).map(([i, a], o) => (typeof a == "boolean" || typeof a == "string" || typeof a == "number") && /* @__PURE__ */ te.jsx(
      Qe.Text,
      {
        variant: "dense",
        className: Un.listItem,
        children: /* @__PURE__ */ te.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "4", children: i }),
          Pi(a)
        ] })
      },
      o
    )) })
  ] }) });
}, JD = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_events: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ te.jsx(te.Fragment, { children: /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ te.jsx(O.Heading, { variant: "heading-3", children: "Custom events" }),
    !i && /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom events available" }),
    i && /* @__PURE__ */ te.jsx(Qe, { className: Un.list, children: r.map((a, o) => /* @__PURE__ */ te.jsx(
      Qe.Text,
      {
        variant: "dense",
        className: Un.listItem,
        children: /* @__PURE__ */ te.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ te.jsx(
            Ze,
            {
              content: /* @__PURE__ */ te.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ te.jsx(b, { children: `First ${Jn(a?.first).format(
                  jt
                )}` }),
                /* @__PURE__ */ te.jsx(b, { children: `Last ${Jn(a?.last).format(
                  jt
                )}` })
              ] }),
              children: /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, tl = ({
  state: e,
  noTooltip: n = !1,
  isPush: r = !1
}) => {
  if (!e) return null;
  const i = e === "subscribed", a = e === "unsubscribed", o = () => i ? "exclamation" : a ? "close-circle-filled" : "check-circle-filled", s = () => i ? "neutral.500" : a ? "red.500" : "green.500", l = () => {
    const u = r ? "push notifications" : "emails";
    return i ? `Default case "subscribed": The user has neither unsubscribed nor explicitly opted-in to receive ${u}. This is the default subscription state when a user profile is created.` : a ? `Unsubscribed: The user has explicitly unsubscribed from receiving ${u}.` : `Opted in: The user has explicitly confirmed they want to receive ${u}.`;
  };
  return /* @__PURE__ */ te.jsx(Ze, { content: n ? null : l(), children: /* @__PURE__ */ te.jsx(b, { alignItems: "center", children: /* @__PURE__ */ te.jsx(he, { size: 14, name: o(), color: s() }) }) });
}, QD = "_wrapper_1xucg_1", XD = "_externalLink_1xucg_7", Ld = {
  wrapper: QD,
  externalLink: XD
}, ZD = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = Jt(), { isCopied: i, copy: a } = Jt(), { isCopied: o, copy: s } = Jt(), { isCopied: l, copy: u } = Jt(), { isCopied: p, copy: d } = Jt();
  if (!e)
    return null;
  const {
    external_id: f,
    braze_id: h,
    first_name: v,
    last_name: C,
    home_city: j,
    country: N,
    email: x,
    phone: g,
    dob: P,
    created_at: E,
    email_subscribe: I,
    push_subscribe: w
  } = e, A = 14, H = `${v || ""} ${C || ""}`.trim() || "A customer has no name", Y = `${j ? `${j} /` : ""} ${N || ""}`.trim(), ne = P ? Jn(P).isSame(Date.now(), "day") : !1;
  return /* @__PURE__ */ te.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ te.jsxs(b, { className: Ld.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ te.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: Ld.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ te.jsx(O.Heading, { variant: "heading-2", children: H }),
          ne && /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "4", color: "secondary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    E && /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "4", children: Jn(E).format(jt) })
    ] }),
    Y && /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ te.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ te.jsx(he, { size: A, name: "map-pin" }),
        /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "4", children: Y })
      ] }),
      /* @__PURE__ */ te.jsx(Ze, { content: "Copy location", children: /* @__PURE__ */ te.jsx(b, { alignItems: "center", children: /* @__PURE__ */ te.jsx(
        he,
        {
          size: A,
          name: o ? "done" : "copy",
          onClick: () => s(Y),
          className: Un.copyIcon
        }
      ) }) })
    ] }),
    x && /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ te.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ te.jsx(he, { size: A, name: "mail" }),
        /* @__PURE__ */ te.jsx("span", { className: Ld.externalLink, children: x })
      ] }),
      /* @__PURE__ */ te.jsx(Ze, { content: "Copy email", children: /* @__PURE__ */ te.jsx(b, { alignItems: "center", children: /* @__PURE__ */ te.jsx(
        he,
        {
          size: A,
          name: n ? "done" : "copy",
          onClick: () => r(x),
          className: Un.copyIcon
        }
      ) }) })
    ] }),
    g && /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ te.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ te.jsx(he, { size: A, name: "phone" }),
        /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "4", children: g })
      ] }),
      /* @__PURE__ */ te.jsx(Ze, { content: "Copy phone number", children: /* @__PURE__ */ te.jsx(b, { alignItems: "center", children: /* @__PURE__ */ te.jsx(
        he,
        {
          size: A,
          name: i ? "done" : "copy",
          onClick: () => a(g),
          className: Un.copyIcon
        }
      ) }) })
    ] }),
    h && /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ te.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ te.jsx(he, { size: A, name: "user" }),
        /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "4", children: "Braze ID" }),
        /* @__PURE__ */ te.jsxs(O.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          h,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ te.jsx(Ze, { content: "Copy Braze ID", children: /* @__PURE__ */ te.jsx(b, { alignItems: "center", children: /* @__PURE__ */ te.jsx(
        he,
        {
          size: A,
          name: l ? "done" : "copy",
          onClick: () => u(h),
          className: Un.copyIcon
        }
      ) }) })
    ] }),
    f && /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ te.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ te.jsx(he, { size: A, name: "tag" }),
        /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "4", children: "External ID" }),
        /* @__PURE__ */ te.jsxs(O.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          f,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ te.jsx(Ze, { content: "Copy External ID", children: /* @__PURE__ */ te.jsx(b, { alignItems: "center", children: /* @__PURE__ */ te.jsx(
        he,
        {
          size: A,
          name: p ? "done" : "copy",
          onClick: () => d(f),
          className: Un.copyIcon
        }
      ) }) })
    ] }),
    I && /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ te.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ te.jsx(he, { size: A, name: "sync" }),
        /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ te.jsx(tl, { state: I })
    ] }),
    w && /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ te.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ te.jsx(he, { size: A, name: "bell" }),
        /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "4", children: "Push notification subscription state" })
      ] }),
      /* @__PURE__ */ te.jsx(tl, { isPush: !0, state: w })
    ] })
  ] }) });
}, eP = ({
  device: e,
  openByDefault: n
}) => {
  const [r, i] = ue(n);
  if (!e)
    return null;
  const a = 14, {
    model: o,
    os: s,
    carrier: l,
    ad_tracking_enabled: u,
    idfa: p,
    idfv: d,
    google_ad_id: f,
    roku_ad_id: h
  } = e;
  return /* @__PURE__ */ te.jsxs(
    b,
    {
      className: ut(Un.collapsible, {
        [Un.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ te.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Un.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "1", children: o }),
              /* @__PURE__ */ te.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ te.jsxs(Qe, { className: Un.list, children: [
          /* @__PURE__ */ te.jsx(Qe.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "3", children: "OS" }),
            /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ te.jsx(Qe.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "3", children: "Carrier" }),
            /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ te.jsx(Qe.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "3", children: "Ad tracking enabled" }),
            /* @__PURE__ */ te.jsx(
              he,
              {
                size: a,
                className: ut({
                  [Un.collapsibleIconTrue]: u,
                  [Un.collapsibleIconFalse]: !u
                }),
                name: u ? "check-circle-filled" : "close-circle-filled"
              }
            )
          ] }) }),
          /* @__PURE__ */ te.jsx(Ze, { content: "The Apple Identifier for Vendor (iOS)", children: /* @__PURE__ */ te.jsx(Qe.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ te.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "3", children: "Braze device identifier" }),
                /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "5", color: "secondary", children: d })
              ]
            }
          ) }) }),
          /* @__PURE__ */ te.jsx(Ze, { content: "For iOS", children: /* @__PURE__ */ te.jsx(Qe.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ te.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "3", children: "Identifier for Advertising" }),
                /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "5", color: "secondary", children: p })
              ]
            }
          ) }) }),
          /* @__PURE__ */ te.jsx(Qe.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ te.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "3", children: "Roku Advertising id" }),
                /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "5", color: "secondary", children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ te.jsx(Qe.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ te.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "3", children: "Google Play Advertising id" }),
                /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "5", color: "secondary", children: f })
              ]
            }
          ) })
        ] })
      ]
    }
  );
}, nP = ({ devices: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ te.jsx(O.Heading, { variant: "heading-3", children: "Devices" }),
      n && /* @__PURE__ */ te.jsx(Mn, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ te.jsx(
      O.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no devices associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ te.jsx(eP, { device: r, openByDefault: i === 0 }, i))
  ] });
}, Ua = {
  optIn: {
    label: "Opt in",
    icon: "check-circle-filled",
    color: "var(--dixa-color-green-500)",
    tooltipContent: "Opt in to receive emails",
    parameter: "opted_in"
  },
  unsubscribe: {
    label: "Unsubscribe",
    icon: "close-circle-filled",
    color: "var(--dixa-color-red-500)",
    tooltipContent: "Unsubscribe from emails",
    parameter: "unsubscribed"
  }
}, ns = ({
  email: e,
  updateTo: n,
  refetchCustomerDetails: r
}) => {
  const { track: i } = In(), { useMutation: a } = bn(), [o, s] = ue(!1), [l] = a(
    LD,
    {
      onCompleted: (p) => {
        p?.Braze?.updateEmailSubscriptionStatus?.message === "success" && i(n === "optIn" ? "braze:email:subscription:opt-in:succeeded" : "braze:email:subscription:unsubscribe:succeeded");
      }
    }
  ), u = async () => {
    s(!0), await l({
      variables: {
        input: {
          email: e,
          // eslint-disable-next-line camelcase
          subscription_state: Ua[n].parameter
        }
      }
    }), setTimeout(async () => {
      await r().finally(() => s(!1));
    }, 500);
  };
  return /* @__PURE__ */ te.jsx(Ze, { content: Ua[n].tooltipContent, children: /* @__PURE__ */ te.jsx(
    et,
    {
      variant: "secondary",
      color: Ua[n].color,
      isLoading: o,
      onClick: () => u(),
      "data-testid": "braze-subscription-button",
      children: /* @__PURE__ */ te.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ te.jsx(
          tl,
          {
            noTooltip: !0,
            state: Ua[n].parameter
          }
        ),
        Ua[n].label
      ] })
    }
  ) });
}, tP = ({
  customerDetails: e,
  showCustomerDetails: n,
  refetchCustomerDetails: r
}) => {
  if (!e)
    return null;
  const { email: i, email_subscribe: a } = e;
  if (!i)
    return null;
  const o = a === "subscribed", s = a === "unsubscribed", l = a === "opted_in";
  return /* @__PURE__ */ te.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ te.jsx(O.Heading, { variant: "heading-3", children: "Update Email subscription state" }),
    !n && /* @__PURE__ */ te.jsx(Qe, { className: Un.list, children: /* @__PURE__ */ te.jsx(Qe.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ te.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ te.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ te.jsx(he, { size: 14, name: "sync" }),
        /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ te.jsx(tl, { state: a })
    ] }) }) }),
    /* @__PURE__ */ te.jsxs(b, { gap: "200", alignItems: "center", children: [
      o && /* @__PURE__ */ te.jsxs(te.Fragment, { children: [
        /* @__PURE__ */ te.jsx(
          ns,
          {
            email: i,
            updateTo: "optIn",
            refetchCustomerDetails: r
          }
        ),
        /* @__PURE__ */ te.jsx(
          ns,
          {
            email: i,
            updateTo: "unsubscribe",
            refetchCustomerDetails: r
          }
        )
      ] }),
      s && /* @__PURE__ */ te.jsx(
        ns,
        {
          email: i,
          updateTo: "optIn",
          refetchCustomerDetails: r
        }
      ),
      l && /* @__PURE__ */ te.jsx(
        ns,
        {
          email: i,
          updateTo: "unsubscribe",
          refetchCustomerDetails: r
        }
      )
    ] })
  ] }) });
}, rP = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { purchases: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ te.jsx(te.Fragment, { children: /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ te.jsx(O.Heading, { variant: "heading-3", children: "Purchases" }),
    !i && /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No purchases available" }),
    i && /* @__PURE__ */ te.jsx(Qe, { className: Un.list, children: r.map((a, o) => /* @__PURE__ */ te.jsx(
      Qe.Text,
      {
        variant: "dense",
        className: Un.listItem,
        children: /* @__PURE__ */ te.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ te.jsx(
            Ze,
            {
              content: /* @__PURE__ */ te.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ te.jsx(b, { children: `First ${Jn(a?.first).format(
                  jt
                )}` }),
                /* @__PURE__ */ te.jsx(b, { children: `Last ${Jn(a?.last).format(
                  jt
                )}` })
              ] }),
              children: /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ te.jsx(O.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, iP = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = In(), { useMutation: i } = bn(), [a, o] = ue(), [s, l] = ue(!1), [u, p] = ue(!1), d = e?.customer?.email, f = e?.customer?.phone_number, h = n.displayCustomerDetails ?? !1, v = n.updateEmailSubscriptionState ?? !1, C = n.displayCustomAttributes ?? !1, j = n.displayCustomEvents ?? !1, N = n.displayPuchases ?? !1, x = n.displayDevices ?? !1, g = n.displayApps ?? !1, P = !h && !v && !C && !j && !N, [E, { error: I }] = i(
    AD,
    {
      onError: () => {
      },
      onCompleted: (A) => {
        const H = A?.Braze?.exportUserDetails?.users?.[0];
        H ? (o(H), l(!1), r("braze:profile:received")) : (o(void 0), l(!0));
      }
    }
  ), w = async () => {
    d || f ? await E({
      variables: {
        input: {
          // Use the email if exists. Otherwise use the phone number. We decided
          // to not search for both together, because we receive a customer
          // entity for each input parameter and we only want one.
          /* eslint-disable camelcase */
          ...d ? { email_address: d } : { phone: f },
          fields_to_export: [
            "external_id",
            "braze_id",
            "created_at",
            "email",
            "first_name",
            "last_name",
            "dob",
            "home_city",
            "country",
            "phone",
            "language",
            "time_zone",
            "total_revenue",
            "push_subscribe",
            "email_subscribe",
            "custom_attributes",
            "custom_events",
            "purchases",
            "apps",
            "devices"
          ]
          /* eslint-enable camelcase */
        }
      }
    }) : l(!0);
  };
  if (Je(() => {
    async function A() {
      p(!0), await w();
    }
    A().finally(() => p(!1));
  }, [d, f]), I) {
    const A = I.graphQLErrors;
    return gl({ errors: A }) ? /* @__PURE__ */ te.jsx(
      O.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API key used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : vl({ errors: A }) ? /* @__PURE__ */ te.jsx(
      O.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Braze. Please contact your administrator."
      }
    ) : /* @__PURE__ */ te.jsx(Tn, { error: I });
  }
  return u ? /* @__PURE__ */ te.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ te.jsx(hn, {}) }) : P ? /* @__PURE__ */ te.jsx(
    O.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : s ? /* @__PURE__ */ te.jsx(
    O.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-customer-found",
      children: "No customer found with this email or phone number."
    }
  ) : /* @__PURE__ */ te.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ te.jsx(ZD, { customerDetails: a }),
        v && !!a && /* @__PURE__ */ te.jsx(
          tP,
          {
            customerDetails: a,
            showCustomerDetails: h,
            refetchCustomerDetails: async () => await w()
          }
        ),
        C && !!a && /* @__PURE__ */ te.jsx(YD, { customerDetails: a }),
        j && !!a && /* @__PURE__ */ te.jsx(JD, { customerDetails: a }),
        N && !!a && /* @__PURE__ */ te.jsx(rP, { customerDetails: a }),
        x && !!a && /* @__PURE__ */ te.jsx(nP, { devices: a?.devices }),
        g && !!a && /* @__PURE__ */ te.jsx(GD, { apps: a?.apps })
      ]
    }
  );
}, rl = [
  {
    key: "apiHostName",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "brazeApiKey",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "displayCustomerDetails",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "updateEmailSubscriptionState",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayCustomAttributes",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayCustomEvents",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    // Yeah, there is a typo 😅 We need to stick with it now, since customers
    // might have used it in the past..
    key: "displayPuchases",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayDevices",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayApps",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], aP = {
  enabled: !1,
  name: "",
  brazeApiKey: "",
  ...sy([], rl)
}, oP = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = dt({
    mode: "onChange",
    defaultValues: aP
  }), {
    create: l,
    update: u,
    remove: p,
    isLoading: d,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = hr({
    integrationId: e,
    integrationType: "BRAZE",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: C,
    error: j,
    isWidgetUnknown: N,
    refetch: x,
    widgetConfiguration: g
  } = yr({
    integrationId: e,
    fieldDefinitions: rl,
    form: s,
    onMisconfigured: v
  }), { renderConditions: P, setRenderConditions: E, renderConditionsForSubmit: I } = gr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), w = (H) => kr(H, {
    fieldDefinitions: rl,
    isCreationMode: o,
    create: l,
    update: u,
    renderConditions: I
  }), A = s.watch("name");
  return /* @__PURE__ */ te.jsxs(
    vr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: w,
      error: j ?? f,
      onRetry: j ? x : void 0,
      isLoading: d || C,
      isWidgetUnknown: N,
      children: [
        h && /* @__PURE__ */ te.jsx(br, { cause: h }),
        /* @__PURE__ */ te.jsxs(tt, { children: [
          /* @__PURE__ */ te.jsx(ie, { children: /* @__PURE__ */ te.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ te.jsx(
            Sn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ te.jsx(ie, { span: 3, children: /* @__PURE__ */ te.jsx(
            Gn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ te.jsx(ie, { span: 3 }),
          /* @__PURE__ */ te.jsx(ie, { span: 3, children: /* @__PURE__ */ te.jsx(
            Gn,
            {
              name: "apiHostName",
              label: "API endpoint",
              control: s.control,
              rules: {
                required: "API endpoint is required",
                validate: (H) => oy(H) || !0
              },
              componentProps: {
                placeholder: "REST API endpoint for your region, e.g. rest.iad-01.braze.com",
                autoComplete: "off",
                prefix: "https://"
              }
            }
          ) }),
          /* @__PURE__ */ te.jsx(ie, { span: 3 }),
          /* @__PURE__ */ te.jsx(ie, { span: 3, children: /* @__PURE__ */ te.jsx(
            mi,
            {
              name: "brazeApiKey",
              label: "API key",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API key is required" },
              componentProps: {
                placeholder: "Insert your API key",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ te.jsx(ie, { span: 3 }),
          /* @__PURE__ */ te.jsx(ie, { span: 3, children: /* @__PURE__ */ te.jsx(We, { label: "Display customer details", children: /* @__PURE__ */ te.jsx(
            Sn,
            {
              name: "displayCustomerDetails",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ te.jsx(ie, { span: 3 }),
          /* @__PURE__ */ te.jsx(ie, { span: 3, children: /* @__PURE__ */ te.jsx(We, { label: "Display the button to change the email subscription state", children: /* @__PURE__ */ te.jsx(
            Sn,
            {
              name: "updateEmailSubscriptionState",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ te.jsx(ie, { span: 3 }),
          /* @__PURE__ */ te.jsx(ie, { span: 3, children: /* @__PURE__ */ te.jsx(We, { label: "Display a list of custom attributes", children: /* @__PURE__ */ te.jsx(
            Sn,
            {
              name: "displayCustomAttributes",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ te.jsx(ie, { span: 3 }),
          /* @__PURE__ */ te.jsx(ie, { span: 3, children: /* @__PURE__ */ te.jsx(We, { label: "Display a list of custom events", children: /* @__PURE__ */ te.jsx(
            Sn,
            {
              name: "displayCustomEvents",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ te.jsx(ie, { span: 3 }),
          /* @__PURE__ */ te.jsx(ie, { span: 3, children: /* @__PURE__ */ te.jsx(We, { label: "Display a list of purchases", children: /* @__PURE__ */ te.jsx(
            Sn,
            {
              name: "displayPuchases",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ te.jsx(ie, { span: 3 }),
          /* @__PURE__ */ te.jsx(ie, { span: 3, children: /* @__PURE__ */ te.jsx(We, { label: "Display customer devices", children: /* @__PURE__ */ te.jsx(
            Sn,
            {
              name: "displayDevices",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ te.jsx(ie, { span: 3 }),
          /* @__PURE__ */ te.jsx(ie, { span: 3, children: /* @__PURE__ */ te.jsx(We, { label: "Display customer apps", children: /* @__PURE__ */ te.jsx(
            Sn,
            {
              name: "displayApps",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ te.jsx(ie, { span: 3 }),
          a && P !== null && /* @__PURE__ */ te.jsx(ie, { children: a({
            value: P,
            onChange: E,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ te.jsx(
          xr,
          {
            integrationType: "BRAZE",
            integrationId: e,
            widgetName: A,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => p()
          }
        )
      ]
    }
  );
};
function sP() {
  var e = Ei(!1), n = ft(function() {
    return e.current;
  }, []);
  return Je(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), n;
}
var lP = function(e) {
  e === void 0 && (e = {});
  var n = ue(e), r = n[0], i = n[1], a = ft(function(o) {
    i(function(s) {
      return Object.assign({}, s, o instanceof Function ? o(s) : o);
    });
  }, []);
  return [r, a];
}, cP = function(e, n) {
  return typeof n == "boolean" ? n : !e;
}, Nx = function(e) {
  return aF(cP, e);
}, Vd, jx;
function uP() {
  return jx || (jx = 1, Vd = function() {
    var e = document.getSelection();
    if (!e.rangeCount)
      return function() {
      };
    for (var n = document.activeElement, r = [], i = 0; i < e.rangeCount; i++)
      r.push(e.getRangeAt(i));
    switch (n.tagName.toUpperCase()) {
      // .toUpperCase handles XHTML
      case "INPUT":
      case "TEXTAREA":
        n.blur();
        break;
      default:
        n = null;
        break;
    }
    return e.removeAllRanges(), function() {
      e.type === "Caret" && e.removeAllRanges(), e.rangeCount || r.forEach(function(a) {
        e.addRange(a);
      }), n && n.focus();
    };
  }), Vd;
}
var zd, wx;
function dP() {
  if (wx) return zd;
  wx = 1;
  var e = uP(), n = {
    "text/plain": "Text",
    "text/html": "Url",
    default: "Text"
  }, r = "Copy to clipboard: #{key}, Enter";
  function i(o) {
    var s = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
    return o.replace(/#{\s*key\s*}/g, s);
  }
  function a(o, s) {
    var l, u, p, d, f, h, v = !1;
    s || (s = {}), l = s.debug || !1;
    try {
      p = e(), d = document.createRange(), f = document.getSelection(), h = document.createElement("span"), h.textContent = o, h.ariaHidden = "true", h.style.all = "unset", h.style.position = "fixed", h.style.top = 0, h.style.clip = "rect(0, 0, 0, 0)", h.style.whiteSpace = "pre", h.style.webkitUserSelect = "text", h.style.MozUserSelect = "text", h.style.msUserSelect = "text", h.style.userSelect = "text", h.addEventListener("copy", function(j) {
        if (j.stopPropagation(), s.format)
          if (j.preventDefault(), typeof j.clipboardData > "u") {
            l && console.warn("unable to use e.clipboardData"), l && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
            var N = n[s.format] || n.default;
            window.clipboardData.setData(N, o);
          } else
            j.clipboardData.clearData(), j.clipboardData.setData(s.format, o);
        s.onCopy && (j.preventDefault(), s.onCopy(j.clipboardData));
      }), document.body.appendChild(h), d.selectNodeContents(h), f.addRange(d);
      var C = document.execCommand("copy");
      if (!C)
        throw new Error("copy command was unsuccessful");
      v = !0;
    } catch (j) {
      l && console.error("unable to copy using execCommand: ", j), l && console.warn("trying IE specific stuff");
      try {
        window.clipboardData.setData(s.format || "text", o), s.onCopy && s.onCopy(window.clipboardData), v = !0;
      } catch (N) {
        l && console.error("unable to copy using clipboardData: ", N), l && console.error("falling back to prompt"), u = i("message" in s ? s.message : r), window.prompt(u, o);
      }
    } finally {
      f && (typeof f.removeRange == "function" ? f.removeRange(d) : f.removeAllRanges()), h && document.body.removeChild(h), p();
    }
    return v;
  }
  return zd = a, zd;
}
var mP = dP();
const pP = /* @__PURE__ */ py(mP);
var OC = function() {
  var e = sP(), n = lP({
    value: void 0,
    error: void 0,
    noUserInteraction: !0
  }), r = n[0], i = n[1], a = ft(function(o) {
    if (e()) {
      var s, l;
      try {
        if (typeof o != "string" && typeof o != "number") {
          var u = new Error("Cannot copy typeof " + typeof o + " to clipboard, must be a string");
          process.env.NODE_ENV === "development" && console.error(u), i({
            value: o,
            error: u,
            noUserInteraction: !0
          });
          return;
        } else if (o === "") {
          var u = new Error("Cannot copy empty string to clipboard.");
          process.env.NODE_ENV === "development" && console.error(u), i({
            value: o,
            error: u,
            noUserInteraction: !0
          });
          return;
        }
        l = o.toString(), s = pP(l), i({
          value: l,
          error: void 0,
          noUserInteraction: s
        });
      } catch (p) {
        i({
          value: l,
          error: p,
          noUserInteraction: s
        });
      }
    }
  }, []);
  return [r, a];
};
function fP(e, n) {
  n === void 0 && (n = 0);
  var r = Ei(!1), i = Ei(), a = Ei(e), o = ft(function() {
    return r.current;
  }, []), s = ft(function() {
    r.current = !1, i.current && clearTimeout(i.current), i.current = setTimeout(function() {
      r.current = !0, a.current();
    }, n);
  }, [n]), l = ft(function() {
    r.current = null, i.current && clearTimeout(i.current);
  }, []);
  return Je(function() {
    a.current = e;
  }, [e]), Je(function() {
    return s(), l;
  }, [n]), [o, l, s];
}
function zi(e, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = []);
  var i = fP(e, n), a = i[0], o = i[1], s = i[2];
  return Je(s, r), [a, o];
}
var hP = function(e) {
  Je(e, []);
}, yP = function(e, n) {
  var r = Ei(function() {
  });
  Je(function() {
    r.current = e;
  }), Je(function() {
    if (n !== null) {
      var i = setInterval(function() {
        return r.current();
      }, n || 0);
      return function() {
        return clearInterval(i);
      };
    }
  }, [n]);
}, gP = function(e) {
  e === void 0 && (e = {});
  var n = ue(e), r = n[0], i = n[1], a = Xn(function() {
    return {
      set: function(s, l) {
        i(function(u) {
          var p;
          return Gl(Gl({}, u), (p = {}, p[s] = l, p));
        });
      },
      setAll: function(s) {
        i(s);
      },
      remove: function(s) {
        i(function(l) {
          var u = l, p = s;
          u[p];
          var d = SF(u, [typeof p == "symbol" ? p : p + ""]);
          return d;
        });
      },
      reset: function() {
        return i(e);
      }
    };
  }, [i]), o = Gl({ get: ft(function(s) {
    return r[s];
  }, [r]) }, a);
  return [r, o];
}, vP = function(e) {
  var n = Ei(e);
  n.current = e, hP(function() {
    return function() {
      return n.current();
    };
  });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._contentWrapper_1vx3c_1{margin-bottom:var(--dixa-size-spacer-300)}._contentWrapperHeadline_1vx3c_4{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary);margin-bottom:var(--dixa-size-spacer-100)}._contentWrapperBody_1vx3c_11{max-height:75vh;overflow-y:auto}._contentWrapperAssigneeIcon_1vx3c_15{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle}._contentWrapperStatusTag_1vx3c_20{margin-right:var(--dixa-size-spacer-200)}._collapse_1bdjy_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_1bdjy_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_1bdjy_10>div>div>p{white-space:unset!important}._collapseHeader_1bdjy_10>div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_1bdjy_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderKey_1bdjy_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-700)}._collapseHeaderKeyIcon_1bdjy_36{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._collapseHeaderKeyLink_1bdjy_41{text-decoration:none}._collapseHeaderIcon_1bdjy_44{padding-top:.35em;margin-left:var(--dixa-size-spacer-100);vertical-align:text-bottom}._collapseHeaderTitle_1bdjy_49{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_1bdjy_57{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentButtonSpacer_1bdjy_60{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_1bdjy_63{color:var(--dixa-typography-color-link)}._result_1uaom_1{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_1uaom_1:hover,._result_1uaom_1:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1uaom_21{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultItemIcon_1uaom_29{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._resultDescription_1uaom_34{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_1uaom_46{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_1uaom_55{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipName_1uaom_61{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1uaom_66{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipTag_1uaom_71{width:fit-content;max-width:15em}._itemButton_3sxfy_1{border:none;padding:0}._result_3sxfy_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_3sxfy_6:hover,._result_3sxfy_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_3sxfy_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_3sxfy_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-normal)}._resultCheckIcon_3sxfy_38{height:var(--dixa-size-spacer-400)}._resultAssigneeIcon_3sxfy_41{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle;margin-right:var(--dixa-size-spacer-200)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_19v8w_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_19v8w_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300);text-align:center}._inputField_19v8w_15{text-align:center}._buttonLink_19v8w_19{color:var(--dixa-typography-color-link)}._noItemsFound_19v8w_23{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._createIssueButton_19v8w_28{min-height:38px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Ud = { exports: {} }, Ma = {}, Cx;
function kP() {
  if (Cx) return Ma;
  Cx = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Ma.Fragment = r, Ma.jsx = s, Ma.jsxs = s, Ma;
}
var ts = {}, Ix;
function bP() {
  return Ix || (Ix = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        P("error", t, m);
      }
    }
    function P(t, c, m) {
      {
        var y = x.ReactDebugCurrentFrame, F = y.getStackAddendum();
        F !== "" && (c += "%s", m = m.concat([F]));
        var T = m.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var E = !1, I = !1, w = !1, A = !1, H = !1, Y;
    Y = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ne(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || H || t === a || t === p || t === d || A || t === v || E || I || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function W(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var F = c.displayName || c.name || "";
      return F !== "" ? m + "(" + F + ")" : m;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function D(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var m = t;
            return B(m._context) + ".Provider";
          case u:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : D(t.type) || "Memo";
          case h: {
            var F = t, T = F._payload, S = F._init;
            try {
              return D(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var M = Object.assign, Z = 0, je, ge, ye, ke, q, _e, De;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function Ye() {
      {
        if (Z === 0) {
          je = console.log, ge = console.info, ye = console.warn, ke = console.error, q = console.group, _e = console.groupCollapsed, De = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function sn() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: M({}, t, {
              value: je
            }),
            info: M({}, t, {
              value: ge
            }),
            warn: M({}, t, {
              value: ye
            }),
            error: M({}, t, {
              value: ke
            }),
            group: M({}, t, {
              value: q
            }),
            groupCollapsed: M({}, t, {
              value: _e
            }),
            groupEnd: M({}, t, {
              value: De
            })
          });
        }
        Z < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = x.ReactCurrentDispatcher, Ue;
    function Pe(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (F) {
            var y = F.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Le;
    {
      var Xe = typeof WeakMap == "function" ? WeakMap : Map;
      Le = new Xe();
    }
    function Fe(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Le.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      Be = !0;
      var F = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ye();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (re) {
              y = re;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (re) {
              y = re;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            y = re;
          }
          t();
        }
      } catch (re) {
        if (re && y && typeof re.stack == "string") {
          for (var _ = re.stack.split(`
`), ee = y.stack.split(`
`), L = _.length - 1, U = ee.length - 1; L >= 1 && U >= 0 && _[L] !== ee[U]; )
            U--;
          for (; L >= 1 && U >= 0; L--, U--)
            if (_[L] !== ee[U]) {
              if (L !== 1 || U !== 1)
                do
                  if (L--, U--, U < 0 || _[L] !== ee[U]) {
                    var ce = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && ce.includes("<anonymous>") && (ce = ce.replace("<anonymous>", t.displayName)), typeof t == "function" && Le.set(t, ce), ce;
                  }
                while (L >= 1 && U >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = F;
      }
      var ze = t ? t.displayName || t.name : "", Oe = ze ? Pe(ze) : "";
      return typeof t == "function" && Le.set(t, Oe), Oe;
    }
    function Me(t, c, m) {
      return Fe(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Fe(t, nn(t));
      if (typeof t == "string")
        return Pe(t);
      switch (t) {
        case p:
          return Pe("Suspense");
        case d:
          return Pe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return Me(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, F = y._payload, T = y._init;
            try {
              return se(T(F), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Se = {}, Ae = x.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(m);
      } else
        Ae.setExtraStackFrame(null);
    }
    function yn(t, c, m, y, F) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + m + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              _ = t[S](c, S, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Re(F), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, S, typeof _), Re(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Re(F), g("Failed %s type: %s", m, _.message), Re(null));
          }
      }
    }
    var Q = Array.isArray;
    function $(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ae(t);
    }
    var J = x.ReactCurrentOwner, de = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, xe, $e;
    function tn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && J.current;
    }
    function pn(t, c) {
      {
        var m = function() {
          xe || (xe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function Fn(t, c) {
      {
        var m = function() {
          $e || ($e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, m, y, F, T, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: F
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, m, y, F) {
      {
        var T, S = {}, _ = null, ee = null;
        m !== void 0 && (V(m), _ = "" + m), gn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ee = c.ref, on(c));
        for (T in c)
          le.call(c, T) && !de.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (T in L)
            S[T] === void 0 && (S[T] = L[T]);
        }
        if (_ || ee) {
          var U = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, U), ee && Fn(S, U);
        }
        return xn(t, _, ee, F, y, J.current, S);
      }
    }
    var en = x.ReactCurrentOwner, vn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        vn.setExtraStackFrame(m);
      } else
        vn.setExtraStackFrame(null);
    }
    var un;
    un = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = D(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Nn = {};
    function Rn(t) {
      {
        var c = jn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function kn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Rn(c);
        if (Nn[m])
          return;
        Nn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + D(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Ve(null);
      }
    }
    function _n(t, c) {
      {
        if (typeof t != "object")
          return;
        if ($(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            dn(y) && kn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var F = N(t);
          if (typeof F == "function" && F !== t.entries)
            for (var T = F.call(t), S; !(S = T.next()).done; )
              dn(S.value) && kn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = D(c);
          yn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !un) {
          un = !0;
          var F = D(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", F || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, m, y, F, T) {
      {
        var S = ne(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = Bn();
          ee ? _ += ee : _ += jn();
          var L;
          t === null ? L = "null" : $(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (D(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var U = En(t, c, m, F, T);
        if (U == null)
          return U;
        if (S) {
          var ce = c.children;
          if (ce !== void 0)
            if (y)
              if ($(ce)) {
                for (var ze = 0; ze < ce.length; ze++)
                  _n(ce[ze], t);
                Object.freeze && Object.freeze(ce);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _n(ce, t);
        }
        if (le.call(c, "key")) {
          var Oe = D(t), re = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), mn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Oe + mn]) {
            var Dn = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Oe, Dn, Oe), Cn[Oe + mn] = !0;
          }
        }
        return t === i ? Ln(U) : An(U), U;
      }
    }
    function Vn(t, c, m) {
      return wn(t, c, m, !0);
    }
    function qn(t, c, m) {
      return wn(t, c, m, !1);
    }
    var zn = qn, Wn = Vn;
    ts.Fragment = i, ts.jsx = zn, ts.jsxs = Wn;
  })()), ts;
}
var Fx;
function xP() {
  return Fx || (Fx = 1, process.env.NODE_ENV === "production" ? Ud.exports = kP() : Ud.exports = bP()), Ud.exports;
}
var be = xP();
const _P = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "IssueFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "issueState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, SP = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "PullRequestFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "prState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, NP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubOrganizationMembersByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "organization" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "login" }, value: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "members" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "login" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] } }] }, jP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createGithubIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GitHub_CreateIssueInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, wP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubRepositoriesByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "REPOSITORY" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repositoryCount" } }, { kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Repository" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, CP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "issues" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "pullRequests" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "prQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] } }] }, IP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, FP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPullRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pullRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "prNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, EP = {
  "\n  query getGithubOrganizationMembersByName(\n    $organizationQuery: String!\n    $usersQuery: String!\n    $maxResults: Int!\n  ) {\n    GitHub {\n      organization(login: $organizationQuery) {\n        teams(first: $maxResults) {\n          edges {\n            node {\n              id\n              name\n              members(first: $maxResults, query: $usersQuery) {\n                edges {\n                  node {\n                    id\n                    name\n                    login\n                    avatarUrl\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": NP,
  "\n  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {\n    GitHub {\n      createIssue(input: $input) {\n        issue {\n          id\n          number\n          repository {\n            name\n          }\n        }\n      }\n    }\n  }\n": jP,
  "\n  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {\n    GitHub {\n      search(query: $query, type: REPOSITORY, first: $maxResults) {\n        repositoryCount\n        edges {\n          node {\n            ... on GitHub_Repository {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": wP,
  "\n  fragment IssueFields on GitHub_Issue {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    issueState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": _P,
  "\n  fragment PullRequestFields on GitHub_PullRequest {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    prState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": SP,
  "\n  query searchItems(\n    $issueQuery: String!\n    $prQuery: String!\n    $maxIssueResults: Int\n    $maxPRResults: Int\n  ) {\n    GitHub {\n      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {\n        issueCount\n        nodes {\n          ... on GitHub_Issue {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {\n        issueCount\n        nodes {\n          ... on GitHub_PullRequest {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": CP,
  "\n  query getIssue(\n    $owner: String!\n    $repositoryName: String!\n    $issueNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        issue(number: $issueNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": IP,
  "\n  query getPullRequest(\n    $owner: String!\n    $repositoryName: String!\n    $prNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        pullRequest(number: $prNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": FP
};
function Ca(e) {
  return EP[e] ?? {};
}
const $P = Ca(
  /* GraphQL */
  `
  query searchItems(
    $issueQuery: String!
    $prQuery: String!
    $maxIssueResults: Int
    $maxPRResults: Int
  ) {
    GitHub {
      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {
        issueCount
        nodes {
          ... on GitHub_Issue {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {
        issueCount
        nodes {
          ... on GitHub_PullRequest {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
    }
  }
`
), TP = Ca(
  /* GraphQL */
  `
  query getIssue(
    $owner: String!
    $repositoryName: String!
    $issueNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        issue(number: $issueNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), OP = Ca(
  /* GraphQL */
  `
  query getPullRequest(
    $owner: String!
    $repositoryName: String!
    $prNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        pullRequest(number: $prNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), Ex = ({
  owner: e,
  repository: n,
  number: r
}) => `https://github.com/${e}/${n}/issues/${r}`, ur = ({
  owner: e,
  repository: n,
  number: r
}) => `${e}/${n} #${r}`, DP = ({
  number: e,
  repository: n
}) => ({
  number: e,
  repository: n.name,
  owner: n.owner.login
}), $x = (e) => {
  switch (e) {
    case "ISSUE":
      return "issue";
    case "PR":
      return "pull request";
    default:
      return e;
  }
}, wh = (e, n, r) => e === "ISSUE" ? {
  OPEN: /* @__PURE__ */ be.jsxs(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      height: "16",
      width: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ be.jsx("path", { d: "M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" }),
        /* @__PURE__ */ be.jsx("path", { d: "M8 0a8 8 0 100 16A8 8 0 008 0zM1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z" })
      ]
    }
  ),
  CLOSED: /* @__PURE__ */ be.jsxs(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ be.jsx("path", { d: "M11.28 6.78a.75.75 0 00-1.06-1.06L7.25 8.69 5.78 7.22a.75.75 0 00-1.06 1.06l2 2a.75.75 0 001.06 0l3.5-3.5z" }),
        /* @__PURE__ */ be.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-1.5 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"
          }
        )
      ]
    }
  )
}[n] : {
  OPEN: /* @__PURE__ */ be.jsx(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ be.jsx("path", { d: "M7.177 3.073L9.573.677A.25.25 0 0110 .854v4.792a.25.25 0 01-.427.177L7.177 3.427a.25.25 0 010-.354zM3.75 2.5a.75.75 0 100 1.5.75.75 0 000-1.5zm-2.25.75a2.25 2.25 0 113 2.122v5.256a2.251 2.251 0 11-1.5 0V5.372A2.25 2.25 0 011.5 3.25zM11 2.5h-1V4h1a1 1 0 011 1v5.628a2.251 2.251 0 101.5 0V5A2.5 2.5 0 0011 2.5zm1 10.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.75 12a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  ),
  MERGED: /* @__PURE__ */ be.jsx(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ be.jsx("path", { d: "M5 3.254V3.25v.005a.75.75 0 110-.005v.004zm.45 1.9a2.25 2.25 0 10-1.95.218v5.256a2.25 2.25 0 101.5 0V7.123A5.735 5.735 0 009.25 9h1.378a2.251 2.251 0 100-1.5H9.25a4.25 4.25 0 01-3.8-2.346zM12.75 9a.75.75 0 100-1.5.75.75 0 000 1.5zm-8.5 4.5a.75.75 0 100-1.5.75.75 0 000 1.5z" })
    }
  ),
  CLOSED: /* @__PURE__ */ be.jsx(
    "svg",
    {
      className: r,
      fill: "#f85149",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ be.jsx("path", { d: "M10.72 1.227a.75.75 0 011.06 0l.97.97.97-.97a.75.75 0 111.06 1.061l-.97.97.97.97a.75.75 0 01-1.06 1.06l-.97-.97-.97.97a.75.75 0 11-1.06-1.06l.97-.97-.97-.97a.75.75 0 010-1.06zM12.75 6.5a.75.75 0 00-.75.75v3.378a2.251 2.251 0 101.5 0V7.25a.75.75 0 00-.75-.75zm0 5.5a.75.75 0 100 1.5.75.75 0 000-1.5zM2.5 3.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.25 1a2.25 2.25 0 00-.75 4.372v5.256a2.251 2.251 0 101.5 0V5.372A2.25 2.25 0 003.25 1zm0 11a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  )
}[n];
function PP({
  conversationId: e,
  githubOrganization: n
}) {
  const r = {
    github: { issues: [], pullRequests: [] }
  }, [i, a] = ue(
    []
  ), [o, s] = ue([]), [l, u] = ue([]), [p, d] = ue([]), [f, h] = ue(), { showNotification: v, showModal: C, executeQuery: j } = bn(), { track: N } = In(), {
    loading: x,
    data: g,
    error: P,
    store: E
  } = ly(e ?? null), I = g?.github?.issues || [], w = g?.github?.pullRequests || [], [A, H] = ue(!1), [Y, ne] = ue();
  Je(
    () => h(P || Y || void 0),
    [P, Y]
  ), Je(
    () => {
      !x && (I?.length || w?.length) ? (a(I), s(w), B(I, w)) : (a([]), s([]), u([]), d([]));
    },
    // Only trigger when data is loaded, not when the loading status changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [g]
  );
  const W = async (ke, q) => {
    await E(ke).then(() => {
      v({
        icon: "check-circle-filled",
        severity: "success",
        title: q.success.title,
        text: q.success.text
      });
    }).catch((_e) => {
      v({
        title: q.error.title,
        text: `${q.error.text} ${_e.message && " (" + _e.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, B = (ke, q) => {
    if (!ke?.length && !q?.length) {
      u([]), d([]);
      return;
    }
    const _e = (ke || []).map(
      (Ye) => j(TP, {
        owner: Ye.owner,
        repositoryName: Ye.repository,
        issueNumber: Ye.number
      })
    ), De = (q || []).map(
      (Ye) => j(OP, {
        owner: Ye.owner,
        repositoryName: Ye.repository,
        prNumber: Ye.number
      })
    ), G = [..._e, ...De];
    H(!0), Promise.all(G).then((Ye) => {
      const sn = [], Ie = [];
      Ye.forEach((Ue) => {
        const Pe = Ue?.data?.GitHub;
        if (!Pe) {
          u([]), d([]);
          return;
        }
        Object.keys(Pe).forEach((Be) => {
          if (Be.startsWith("repository")) {
            const Le = Pe[Be];
            Object.keys(Le).forEach((Xe) => {
              const Fe = Le[Xe], Me = {
                number: Fe?.number,
                owner: Fe?.repository?.owner?.login,
                repository: Fe?.repository?.name
              };
              Xe.startsWith("issue") && sn.push({
                ...Fe,
                type: "ISSUE",
                key: Me
              }), Xe.startsWith("pullRequest") && Ie.push({
                ...Fe,
                type: "PR",
                key: Me
              });
            });
          }
        });
      }), u(sn), d(Ie);
    }).catch(ne).finally(() => {
      H(!1);
    });
  }, D = ({ key: ke, type: q }) => {
    N("github:link:issue:clicked", {
      githubOrganization: n
    });
    const _e = g && (I.length || w.length) ? g : r, De = q === "ISSUE" ? "issues" : "pullRequests";
    _e.github[De] = Array.from(
      new Set(_e.github[De]).add(ke)
    ), W(_e, {
      success: {
        title: "GitHub issue linked",
        text: `You linked the GitHub issue ${ur(
          ke
        )} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${ur(ke)} failed. Please try again.`
      }
    });
  }, M = async ({ key: ke, type: q }) => {
    N("github:link:issue:clicked", {
      githubOrganization: n
    });
    const _e = g && (I.length || w.length) ? g : r, De = q === "ISSUE" ? "issues" : "pullRequests";
    _e.github[De] = Array.from(
      new Set(_e.github[De]).add(ke)
    ), await E(_e).catch((G) => {
      v({
        title: "Linking failed",
        text: `Linking ${ke} failed. Please try again. ${G.message && " (" + G.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, Z = ({ key: ke, type: q }) => {
    N("github:unlink:issue:clicked", {
      githubOrganization: n
    });
    const _e = q === "ISSUE" ? "issue" : "pull request";
    C({
      headline: `Unlink ${_e} ${ur(ke)}?`,
      text: `You are about to unlink the ${_e} ${ur(
        ke
      )}. Do you want to proceed?`,
      confirmLabel: `Unlink GitHub ${_e}`,
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        const De = q === "ISSUE" ? "issues" : "pullRequests";
        if (!g)
          return;
        const G = {
          ...g,
          github: {
            ...g?.github,
            [De]: g?.github?.[De].filter(
              (Ye) => Ye.number !== ke.number || Ye.owner !== ke.owner || Ye.repository !== ke.repository
            )
          }
        };
        N("github:unlink:issue:confirmed", {
          githubOrganization: n
        }), W(G, {
          success: {
            title: `GitHub ${_e} unlinked`,
            text: `You unlinked the GitHub ${_e} ${ur(
              ke
            )}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${ur(ke)} failed.`
          }
        });
      },
      onCancel: () => {
        N("github:unlink:issue:canceled", {
          githubOrganization: n
        });
      }
    });
  }, je = () => {
    N("github:unlink:all:clicked", {
      githubOrganization: n
    }), C({
      headline: "Unlink all GitHub issues/pull requests?",
      text: "You are about to unlink the all GitHub issues/pull requests from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues/pull requests",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        N("github:unlink:all:confirmed", {
          githubOrganization: n
        }), W(r, {
          success: {
            title: "Unlinking successful",
            text: "All GitHub issues/pull requests were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues/pull requests failed."
          }
        });
      },
      onCancel: () => {
        N("github:unlink:all:canceled", {
          githubOrganization: n
        });
      }
    });
  }, ge = I.filter(
    (ke) => !i?.includes(ke)
  ) || [], ye = w.filter(
    (ke) => !o?.includes(ke)
  ) || [];
  return {
    linkGithubItem: D,
    linkGithubItemQuietly: M,
    unlinkGithubItem: Z,
    loadGithubItems: B,
    removeDanglingGithubItemLinks: () => {
      const ke = {
        ...g,
        github: {
          ...g?.github,
          issues: I.filter(
            (q) => !ge.includes(q)
          ) || [],
          pullRequests: w.filter(
            (q) => !ye.includes(q)
          ) || []
        }
      };
      E(ke);
    },
    unlinkAllGithubItems: je,
    isLoadingGithubItemLinks: x,
    danglingIssueLinks: ge,
    danglingPullRequestLinks: ye,
    isLoadingGithubItems: A,
    issues: l,
    pullRequests: p,
    error: f
  };
}
const RP = "_contentWrapper_1vx3c_1", AP = "_contentWrapperHeadline_1vx3c_4", LP = "_contentWrapperBody_1vx3c_11", VP = "_contentWrapperAssigneeIcon_1vx3c_15", zP = "_contentWrapperStatusTag_1vx3c_20", Jr = {
  contentWrapper: RP,
  contentWrapperHeadline: AP,
  contentWrapperBody: LP,
  contentWrapperAssigneeIcon: VP,
  contentWrapperStatusTag: zP
}, DC = ({
  description: e,
  assignees: n,
  labels: r
}) => /* @__PURE__ */ be.jsxs(be.Fragment, { children: [
  e && /* @__PURE__ */ be.jsxs(lt, { className: Jr.contentWrapper, children: [
    /* @__PURE__ */ be.jsx(lt, { className: Jr.contentWrapperHeadline, children: "Description" }),
    /* @__PURE__ */ be.jsx(lt, { className: Jr.contentWrapperBody, children: e })
  ] }),
  n?.nodes && n.nodes.length > 0 && /* @__PURE__ */ be.jsxs(lt, { className: Jr.contentWrapper, children: [
    /* @__PURE__ */ be.jsx(lt, { className: Jr.contentWrapperHeadline, children: "Assignees" }),
    /* @__PURE__ */ be.jsx(lt, { className: Jr.contentWrapperBody, children: n.nodes.map(
      (i) => i && /* @__PURE__ */ be.jsxs(lt, { margin: "100 0", children: [
        /* @__PURE__ */ be.jsx(
          "img",
          {
            className: Jr.contentWrapperAssigneeIcon,
            src: i.avatarUrl,
            alt: i.name || ""
          }
        ),
        " ",
        i.name
      ] }, i.name)
    ) })
  ] }),
  r?.nodes && r?.nodes.length > 0 && /* @__PURE__ */ be.jsx(lt, { className: Jr.contentWrapper, children: r.nodes.map(
    (i) => i && /* @__PURE__ */ be.jsx(
      Yn,
      {
        className: Jr.contentWrapperStatusTag,
        children: i.name
      },
      i.name
    )
  ) })
] }), UP = "_collapse_1bdjy_1", MP = "_collapseHeader_1bdjy_10", BP = "_collapseHeaderKey_1bdjy_31", qP = "_collapseHeaderKeyIcon_1bdjy_36", HP = "_collapseHeaderKeyLink_1bdjy_41", WP = "_collapseHeaderIcon_1bdjy_44", KP = "_collapseHeaderTitle_1bdjy_49", GP = "_collapseContent_1bdjy_57", YP = "_collapseContentButtonSpacer_1bdjy_60", JP = "_collapseContentButtonLink_1bdjy_63", Tr = {
  collapse: UP,
  collapseHeader: MP,
  collapseHeaderKey: BP,
  collapseHeaderKeyIcon: qP,
  collapseHeaderKeyLink: HP,
  collapseHeaderIcon: WP,
  collapseHeaderTitle: KP,
  collapseContent: GP,
  collapseContentButtonSpacer: YP,
  collapseContentButtonLink: JP
}, QP = ({
  items: e,
  unlinkGithubItem: n,
  githubOrganization: r
}) => {
  const i = e.reduce(
    (u, p) => ({ ...u, [p.id]: !1 }),
    {}
  ), [a, o] = ue(i), { track: s } = In(), l = (u, p) => {
    o({ ...a, [u]: p });
  };
  return /* @__PURE__ */ be.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((u) => {
    const {
      id: p,
      number: d,
      key: f,
      title: h,
      bodyText: v,
      repository: C,
      type: j,
      state: N,
      assignees: x,
      labels: g
    } = u, P = a[p];
    return /* @__PURE__ */ be.jsxs(
      pr,
      {
        onToggle: () => l(p, !a[p]),
        isOpen: P,
        className: Tr.collapse,
        children: [
          /* @__PURE__ */ be.jsx(pr.Header, { className: Tr.collapseHeader, children: /* @__PURE__ */ be.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ be.jsx(lt, { children: /* @__PURE__ */ be.jsxs(lt, { as: "span", className: Tr.collapseHeaderKey, children: [
                  wh(
                    j,
                    N,
                    Tr.collapseHeaderKeyIcon
                  ),
                  /* @__PURE__ */ be.jsxs(
                    "a",
                    {
                      href: Ex(f),
                      className: Tr.collapseHeaderKeyLink,
                      target: "_blank",
                      rel: "noreferrer",
                      onClick: (E) => {
                        E.stopPropagation();
                      },
                      children: [
                        ur(f),
                        /* @__PURE__ */ be.jsx(
                          he,
                          {
                            className: Tr.collapseHeaderIcon,
                            name: "external-link",
                            size: 16
                          }
                        )
                      ]
                    }
                  )
                ] }) }),
                /* @__PURE__ */ be.jsx(lt, { className: Tr.collapseHeaderTitle, children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ be.jsx(pr.Content, { className: Tr.collapseContent, children: /* @__PURE__ */ be.jsxs(b, { flexDirection: "column", margin: "0 0 200 0", children: [
            /* @__PURE__ */ be.jsx(
              DC,
              {
                description: v,
                assignees: x,
                labels: g
              }
            ),
            /* @__PURE__ */ be.jsxs(
              et,
              {
                icon: "link-slash",
                variant: "secondary",
                className: Tr.collapseContentButtonSpacer,
                onClick: () => n({
                  key: {
                    number: d,
                    owner: C?.owner.login,
                    repository: u.repository.name
                  },
                  type: j
                }),
                children: [
                  "Unlink ",
                  $x(j)
                ]
              }
            ),
            /* @__PURE__ */ be.jsxs(
              At,
              {
                slotEnd: /* @__PURE__ */ be.jsx(he, { name: "external-link" }),
                variant: "tertiary",
                className: Tr.collapseContentButtonLink,
                navigate: () => {
                  s("github:view:link:clicked", {
                    githubOrganization: r
                  }), window.open(Ex(f), "_blank")?.focus();
                },
                children: [
                  "View ",
                  $x(j),
                  " in GitHub"
                ]
              }
            )
          ] }) })
        ]
      },
      p
    );
  }) : /* @__PURE__ */ be.jsx(be.Fragment, {}) });
}, XP = "_result_1uaom_1", ZP = "_resultName_1uaom_21", eR = "_resultItemIcon_1uaom_29", nR = "_resultDescription_1uaom_34", tR = "_resultLinkIcon_1uaom_46", rR = "_tooltip_1uaom_55", iR = "_tooltipName_1uaom_61", aR = "_tooltipTag_1uaom_71", Qr = {
  result: XP,
  resultName: ZP,
  resultItemIcon: eR,
  resultDescription: nR,
  resultLinkIcon: tR,
  tooltip: rR,
  tooltipName: iR,
  tooltipTag: aR
}, oR = ({
  item: e,
  onSelect: n
}) => {
  const { key: r, title: i, type: a, state: o, labels: s, bodyText: l, assignees: u } = e, [p, d] = ue(!1);
  return /* @__PURE__ */ be.jsx(
    Ze,
    {
      className: Qr.tooltip,
      content: /* @__PURE__ */ be.jsxs(b, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
        /* @__PURE__ */ be.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
            margin: "0 0 300 0",
            children: [
              /* @__PURE__ */ be.jsxs(lt, { as: "span", className: Qr.tooltipName, children: [
                wh(a, o, Qr.resultItemIcon),
                i
              ] }),
              /* @__PURE__ */ be.jsx(Yn, { className: Qr.tooltipTag, children: o })
            ]
          }
        ),
        /* @__PURE__ */ be.jsx(
          DC,
          {
            description: l,
            assignees: u,
            labels: s
          }
        )
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ be.jsxs(
        "button",
        {
          className: Qr.result,
          type: "button",
          onClick: () => {
            n(e);
          },
          onMouseEnter: () => d(!0),
          onMouseLeave: () => d(!1),
          children: [
            /* @__PURE__ */ be.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                width: "100%",
                style: {
                  width: p ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ be.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ be.jsxs(lt, { as: "span", className: Qr.resultName, children: [
                    wh(a, o, Qr.resultItemIcon),
                    ur(r)
                  ] }) }),
                  /* @__PURE__ */ be.jsx(lt, { className: Qr.resultDescription, children: i })
                ]
              }
            ),
            p && /* @__PURE__ */ be.jsx(
              he,
              {
                className: Qr.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, sR = ({
  className: e,
  searched: n,
  githubOrganization: r
}) => /* @__PURE__ */ be.jsx(
  At,
  {
    slotEnd: /* @__PURE__ */ be.jsx(he, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `https://github.com/search?q=is:issue+org:${r}+${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching items on GitHub"
  }
), il = "[a-zA-z0-9_.-]+", PC = "[0-9]+", lR = new RegExp(
  `(${il})/(${il})/(?:issues|pull)/(${PC})`,
  "i"
), Tx = new RegExp(`^${lR.source}$`), Ox = new RegExp(
  `https://github.com/(${il})/(${il})/(?:issues|pull)/(${PC})`,
  "i"
), cR = ({
  onSelectItem: e,
  githubOrganization: n,
  linkedIssues: r,
  linkedPullRequests: i
}) => {
  const a = Xn(() => r?.map((w) => w.id) || [], [r]), o = Xn(() => i?.map((w) => w.id) || [], [i]), [s, l] = ue([]), { useLazyQuery: u } = bn(), [p, d] = ue(), [f, { loading: h, error: v, data: C, networkStatus: j }] = u($P, {
    notifyOnNetworkStatusChange: !0
  });
  zi(
    () => {
      !h && p && j === rr.ready ? f({
        variables: {
          issueQuery: `${p} type:issue`,
          prQuery: `${p} type:pr`,
          maxIssueResults: 12,
          maxPRResults: 12
        }
      }) : l([]);
    },
    500,
    [p]
  ), Je(() => {
    let w = C?.GitHub?.issues?.nodes || [], A = C?.GitHub?.pullRequests.nodes || [];
    a.length > 0 && (w = w.filter((H) => !a.includes(H.id))), o.length > 0 && (A = A.filter(
      (H) => !o.includes(H.id)
    )), l([
      ...w.map((H) => ({
        ...H,
        type: "ISSUE",
        key: {
          number: H.number,
          owner: H.repository.owner.login,
          repository: H.repository.name
        }
      })),
      ...A.map((H) => ({
        ...H,
        type: "PR",
        key: {
          number: H.number,
          owner: H.repository.owner.login,
          repository: H.repository.name
        }
      }))
    ]);
  }, [C, a, o]);
  function N(w) {
    const A = w?.trim();
    if (Tx.test(A)) {
      const [H, Y, ne, W] = A.match(Tx) || [];
      return Y !== n ? void 0 : {
        owner: n,
        repository: ne,
        number: parseInt(W)
      };
    }
    if (Ox.test(A)) {
      const [H, Y, ne, W] = A.match(Ox) || [];
      return Y !== n ? void 0 : {
        owner: n,
        repository: ne,
        number: parseInt(W)
      };
    }
  }
  const x = (w) => {
    e({
      key: DP(w),
      type: w.type
    }), d(void 0);
  }, g = (w) => {
    const A = N(w);
    d(
      A ? `org:${A.owner} repo:${A.repository} ${A.number}` : `org:${n} ${w}`
    );
  }, P = () => {
    d(void 0);
  }, E = ({ className: w, searched: A }) => /* @__PURE__ */ be.jsx(
    sR,
    {
      className: w,
      searched: A,
      githubOrganization: n
    }
  ), I = ({ item: w, onSelect: A }) => /* @__PURE__ */ be.jsx(oR, { item: w, onSelect: A });
  return !h && v ? /* @__PURE__ */ be.jsx(Tn, { error: v }) : /* @__PURE__ */ be.jsx(
    Er,
    {
      items: s?.map((w) => ({ name: w.title, ...w })),
      loading: h,
      onSearch: g,
      onSelect: x,
      onClear: P,
      emptyMessage: p ? h ? "" : "No GitHub items found" : "Enter GitHub item key, link or search terms",
      suggestionComponent: E,
      itemComponent: I,
      placeholder: "Search GitHub items",
      searchable: !0,
      clearable: !0
    }
  );
}, uR = "_itemButton_3sxfy_1", dR = "_result_3sxfy_6", mR = "_resultName_3sxfy_30", pR = "_resultCheckIcon_3sxfy_38", fR = "_resultAssigneeIcon_3sxfy_41", Ba = {
  itemButton: uR,
  result: dR,
  resultName: mR,
  resultCheckIcon: pR,
  resultAssigneeIcon: fR
}, RC = ({
  item: e,
  checked: n = !1,
  onSelectItem: r
}) => /* @__PURE__ */ be.jsx(
  b,
  {
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    "data-testid": "github-select-item-component",
    children: /* @__PURE__ */ be.jsx(
      "button",
      {
        onClick: () => {
          r(e);
        },
        className: Ba.itemButton,
        children: /* @__PURE__ */ be.jsxs(b, { className: Ba.result, flexDirection: "row", width: "100%", children: [
          e.iconUrl && /* @__PURE__ */ be.jsx(lt, { margin: "100 0", children: /* @__PURE__ */ be.jsx(
            "img",
            {
              className: Ba.resultAssigneeIcon,
              src: e.iconUrl,
              alt: e.name
            }
          ) }, e.name),
          /* @__PURE__ */ be.jsx(lt, { className: Ba.resultName, children: e.name }),
          n && /* @__PURE__ */ be.jsx(lt, { className: Ba.resultCheckIcon, children: /* @__PURE__ */ be.jsx(he, { name: "done" }) })
        ] })
      }
    )
  }
), hR = Ca(
  /* GraphQL */
  `
  query getGithubOrganizationMembersByName(
    $organizationQuery: String!
    $usersQuery: String!
    $maxResults: Int!
  ) {
    GitHub {
      organization(login: $organizationQuery) {
        teams(first: $maxResults) {
          edges {
            node {
              id
              name
              members(first: $maxResults, query: $usersQuery) {
                edges {
                  node {
                    id
                    name
                    login
                    avatarUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
), yR = ({
  githubOrganization: e,
  selectedItems: n,
  onChange: r,
  multiple: i = !1
}) => {
  const { useLazyQuery: a } = bn(), [o, s] = ue([]), [l, u] = ue(""), p = 2, [d, { loading: f, error: h, data: v, networkStatus: C }] = a(
    hR,
    {
      notifyOnNetworkStatusChange: !0
    }
  );
  return zi(
    () => {
      !f && l && l.length >= p && C === rr.ready ? d({
        variables: {
          usersQuery: l,
          organizationQuery: e,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), Je(() => {
    const j = v?.GitHub?.organization?.teams || { edges: [] }, N = [];
    j?.edges?.forEach((x) => {
      const g = x?.node?.members?.edges;
      (g?.length || 0) > 0 && g?.forEach((P) => {
        const E = P?.node;
        E && (E?.id && N.find((I) => I.id === E.id) || N.push(E));
      });
    }), s(
      N.sort((x, g) => {
        const P = x.name?.toLowerCase() || x.login?.toLowerCase(), E = g.name?.toLowerCase() || g.login?.toLowerCase();
        return P.localeCompare(E, void 0, {
          sensitivity: "base"
        });
      })
    );
  }, [v]), !f && h ? /* @__PURE__ */ be.jsx(Tn, { error: h }) : /* @__PURE__ */ be.jsx(
    Er,
    {
      clearable: !0,
      searchable: !0,
      multiple: i,
      items: o?.map(({ id: j, name: N, login: x, avatarUrl: g }) => ({
        id: j,
        name: N || x,
        iconUrl: g
      })) || [],
      loading: f,
      onSearch: (j) => u(j),
      onChange: (j, N) => {
        const x = j.id;
        i ? (N && !n.find(
          (g) => g.id === x
        ) && n.push(j), N || (n = n.filter(
          (g) => g.id !== x
        ))) : n = N ? [j] : [], r(n);
      },
      onClear: () => u(""),
      selectedItems: n,
      emptyMessage: l ? f ? "" : "No user found" : "Search users",
      itemComponent: ({ item: j, onSelect: N, checked: x }) => /* @__PURE__ */ be.jsx(
        RC,
        {
          item: j,
          checked: x,
          onSelectItem: N
        }
      ),
      placeholder: "Search GitHub users"
    }
  );
}, gR = ({
  field: e,
  value: n,
  onChange: r,
  githubOrganization: i
}) => {
  const { multiple: a, type: o } = e;
  switch (o) {
    case "any":
      return /* @__PURE__ */ be.jsx(mr, { onChange: r, value: n });
    case "array":
      return e?.allowedValues ? /* @__PURE__ */ be.jsx(
        Er,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues.map(({ id: s, name: l, value: u }) => ({
            id: s,
            name: l || u
          }))
        }
      ) : /* @__PURE__ */ be.jsx(
        kl,
        {
          onChange: r,
          selectedTags: Array.isArray(n) ? n : []
        }
      );
    case "number":
      return /* @__PURE__ */ be.jsx(mr, { type: "number", onChange: r, value: n });
    case "option":
      return /* @__PURE__ */ be.jsx(
        Er,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues?.map(
            ({ id: s, name: l, value: u }) => ({
              id: s,
              name: l || u
            })
          ) || []
        }
      );
    case "string":
      return /* @__PURE__ */ be.jsx(mr, { onChange: r, value: n || "" });
    case "textarea":
      return /* @__PURE__ */ be.jsx(vh, { onChange: r, value: n || "" });
    case "user":
      return /* @__PURE__ */ be.jsx(
        yR,
        {
          githubOrganization: i,
          onChange: r,
          selectedItems: Array.isArray(n) ? n : [],
          multiple: a
        }
      );
    default:
      return /* @__PURE__ */ be.jsx(be.Fragment, { children: "Your organizations GitHub configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field." });
  }
}, vR = ({
  issueTypeFields: e,
  control: n,
  githubOrganization: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ be.jsx(be.Fragment, { children: e.filter(({ key: o }) => o !== "repository").map((o) => /* @__PURE__ */ be.jsx(
  xt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ be.jsx(
      We,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: gR({
          field: o,
          value: l,
          onChange: s,
          githubOrganization: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), kR = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => {
  const o = `${n}/${e.repository.name}/issues/${e.number}`;
  return /* @__PURE__ */ be.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "400",
      "data-testid": "github-create-issue-success-message",
      children: [
        /* @__PURE__ */ be.jsxs(O.Paragraph, { children: [
          "You can visit your new issue by following",
          " ",
          /* @__PURE__ */ be.jsxs(O.ExternalLink, { href: o, target: "_blank", children: [
            "this link ",
            /* @__PURE__ */ be.jsx(he, { name: "external-link" })
          ] }),
          " ",
          "or copy it from the field below."
        ] }),
        /* @__PURE__ */ be.jsx(We, { label: "GitHub issue link", children: /* @__PURE__ */ be.jsx(
          mr,
          {
            readOnly: !0,
            value: o,
            suffix: {
              type: "button",
              button: {
                icon: r ? "done" : "copy",
                onClick: () => {
                  i(!0), a(o);
                }
              }
            }
          }
        ) })
      ]
    }
  );
}, bR = "_modalBody_1hk1o_1", xR = "_modalBodyFormFields_1hk1o_4", Md = {
  modalBody: bR,
  modalBodyFormFields: xR
}, _R = Ca(
  /* GraphQL */
  `
  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {
    GitHub {
      search(query: $query, type: REPOSITORY, first: $maxResults) {
        repositoryCount
        edges {
          node {
            ... on GitHub_Repository {
              id
              name
            }
          }
        }
      }
    }
  }
`
), SR = Ca(
  /* GraphQL */
  `
  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {
    GitHub {
      createIssue(input: $input) {
        issue {
          id
          number
          repository {
            name
          }
        }
      }
    }
  }
`
), NR = [
  {
    key: "title",
    name: "Title",
    type: "string",
    required: !0
  },
  {
    key: "assignees",
    name: "Assignees",
    type: "user",
    required: !1,
    multiple: !0
  },
  {
    key: "body",
    name: "Description",
    type: "textarea",
    required: !1
  }
], jR = ({
  isOpen: e,
  onClose: n,
  linkGithubIssueQuietly: r,
  conversationContext: i,
  githubOrganization: a
}) => {
  const { showNotification: o, useLazyQuery: s, useMutation: l } = bn(), { track: u } = In(), {
    control: p,
    handleSubmit: d,
    formState: { errors: f },
    reset: h,
    getValues: v
  } = dt(), [C, j] = ue(""), [N, x] = ue([]), [g, P] = ue(), [E, I] = ue(!1), [w, A] = ue(!1), [H, Y] = OC(), [
    ne,
    {
      loading: W,
      error: B,
      networkStatus: D
    }
  ] = s(_R, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (De) => {
      x(
        De.GitHub.search?.edges?.map((G) => G?.node)
      );
    },
    onError: () => {
      o({
        title: "Could not get repository list",
        text: "We could not fetch the list of your repositories. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), x([]);
    }
  });
  zi(
    () => {
      !W && C && D === rr.ready ? ne({
        variables: {
          query: C,
          maxResults: 10
        }
      }) : x([]);
    },
    500,
    [C]
  );
  const [M, { error: Z }] = l(
    SR,
    {
      onError: (De) => {
        I(!1), o({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), console.warn("Error in createMutation", De);
      },
      onCompleted: (De) => {
        I(!1);
        const G = De.GitHub.createIssue?.issue;
        P(G), o({
          title: "Success",
          text: `GitHub issue '${G.number}' created`,
          icon: "check-circle-filled",
          severity: "success"
        }), r({
          owner: a,
          repository: G.repository.name,
          number: G.number
        });
      }
    }
  ), je = (De) => {
    j(`org:${a} ${De}`);
  }, ge = (De, G) => {
    G(De), j("");
  }, ye = () => {
    j("");
  }, ke = (De) => {
    u("github:create:issue:confirmed", {
      githubOrganization: a
    }), I(!0), M({
      variables: {
        input: {
          repositoryId: De.repository.id,
          title: De.title,
          body: De.body,
          assigneeIds: De.assignees?.length > 0 ? De.assignees.map((G) => G.id) : void 0
        }
      }
    });
  };
  Je(() => {
    const De = w ? window.setTimeout(() => A(!1), 2e3) : void 0;
    return () => window.clearTimeout(De);
  }, [w]);
  const q = () => {
    j(""), x([]), P(void 0), I(!1), A(!1);
  }, _e = () => {
    u("github:create:issue:canceled", {
      githubOrganization: a
    }), q(), h(), n();
  };
  return /* @__PURE__ */ be.jsxs(
    Ct,
    {
      isOpen: e,
      "data-testid": "github-create-issue-modal",
      onClose: _e,
      children: [
        /* @__PURE__ */ be.jsx(
          It,
          {
            title: g ? "Issue creation successful" : "Create new GitHub issue",
            onClose: _e
          }
        ),
        /* @__PURE__ */ be.jsxs(Ft, { className: Md.modalBody, children: [
          !W && B && /* @__PURE__ */ be.jsx(Tn, { error: B }),
          !E && Z && /* @__PURE__ */ be.jsx(Tn, { error: Z }),
          g ? /* @__PURE__ */ be.jsx(
            kR,
            {
              createdIssue: g,
              issueBaseLink: `https://github.com/${a}`,
              issueLinkCopied: w,
              setIssueLinkCopied: A,
              copyToClipboard: Y
            }
          ) : /* @__PURE__ */ be.jsx(
            "form",
            {
              "data-testid": "github-create-issue-form",
              onSubmit: d(ke),
              children: /* @__PURE__ */ be.jsxs(tt, { children: [
                /* @__PURE__ */ be.jsx(ie, { children: /* @__PURE__ */ be.jsx(We, { label: "Repository", required: !0, children: /* @__PURE__ */ be.jsx(
                  xt,
                  {
                    control: p,
                    name: "repository",
                    rules: { required: "Please select a repository" },
                    render: ({ field: { onChange: De, value: G } }) => /* @__PURE__ */ be.jsx(
                      Er,
                      {
                        className: Md.modalBodyRepository,
                        searchable: !0,
                        clearable: !0,
                        loading: W,
                        onSearch: je,
                        onSelect: (Ye) => ge(Ye, De),
                        onClear: ye,
                        selectedItems: [G],
                        placeholder: "Search GitHub repositories",
                        emptyMessage: B ? "No repositories found" : "No repositories available",
                        items: N || [],
                        itemComponent: ({ item: Ye, onSelect: sn, checked: Ie }) => /* @__PURE__ */ be.jsx(
                          RC,
                          {
                            item: Ye,
                            checked: Ie,
                            onSelectItem: sn
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ be.jsx(ie, { className: Md.modalBodyFormFields, children: /* @__PURE__ */ be.jsx(
                  vR,
                  {
                    control: p,
                    errors: f,
                    getValues: v,
                    githubOrganization: a,
                    conversationContext: i,
                    issueTypeFields: NR
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ be.jsx(
          Vt,
          {
            confirmOnClick: g ? _e : d(ke),
            confirmProps: {
              isLoading: E,
              loadingIndicator: /* @__PURE__ */ be.jsx(hn, { size: 16 })
            },
            confirmName: g ? "Close" : "Save",
            cancelOnClick: g ? void 0 : _e
          }
        )
      ]
    }
  );
}, wR = "_wrapper_19v8w_1", CR = "_inputWrapper_19v8w_6", IR = "_buttonLink_19v8w_19", FR = "_noItemsFound_19v8w_23", ER = "_createIssueButton_19v8w_28", Gi = {
  wrapper: wR,
  inputWrapper: CR,
  buttonLink: IR,
  noItemsFound: FR,
  createIssueButton: ER
}, $R = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = ue(!1), { track: a } = In(), o = n?.githubOrganization, s = !!n?.enableRemoveAllLinks, {
    linkGithubItem: l,
    linkGithubItemQuietly: u,
    unlinkGithubItem: p,
    loadGithubItems: d,
    removeDanglingGithubItemLinks: f,
    unlinkAllGithubItems: h,
    isLoadingGithubItemLinks: v,
    danglingIssueLinks: C,
    danglingPullRequestLinks: j,
    isLoadingGithubItems: N,
    issues: x,
    pullRequests: g,
    error: P
  } = PP({
    conversationId: e?.conversationId || null,
    githubOrganization: o
  }), E = (Y) => u({ key: Y, type: "ISSUE" }), I = !(!!x?.length).valueOf() && !(!!g?.length).valueOf() && !(!!C?.length).valueOf() && !(!!j?.length).valueOf(), w = !v && !N && !!C?.length && !!j?.length && !!n?.showDanglingLinks, A = n?.enableCreateIssue, H = !!x?.length || !!g?.length;
  return !N && P ? /* @__PURE__ */ be.jsx(Tn, { error: P, retry: () => d() }) : /* @__PURE__ */ be.jsxs(be.Fragment, { children: [
    /* @__PURE__ */ be.jsxs(b, { className: Gi.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ be.jsxs(b, { className: Gi.inputWrapper, flexDirection: "column", children: [
        A && /* @__PURE__ */ be.jsxs(be.Fragment, { children: [
          /* @__PURE__ */ be.jsx(
            et,
            {
              variant: "primary",
              onClick: () => {
                a("github:create:issue:clicked", {
                  githubOrganization: n?.githubOrganization
                }), i(!0);
              },
              className: Gi.createIssueButton,
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ be.jsx("div", { className: Gi.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ be.jsx(
          cR,
          {
            onSelectItem: l,
            githubOrganization: o,
            linkedIssues: x,
            linkedPullRequests: g
          }
        )
      ] }),
      N ? /* @__PURE__ */ be.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ be.jsx(hn, { "data-testid": "github-widget-item-spinner" }) }) : H ? /* @__PURE__ */ be.jsx(
        QP,
        {
          items: [...x, ...g],
          unlinkGithubItem: p,
          githubOrganization: o
        }
      ) : /* @__PURE__ */ be.jsx(O.Paragraph, { align: "center", className: Gi.noItemsFound, children: "No linked items found." }),
      w && /* @__PURE__ */ be.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ be.jsx(O.Heading, { variant: "heading-3", children: "Unresolved linked issues and/or pull requests" }),
            /* @__PURE__ */ be.jsxs(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: [
              C.map((Y) => /* @__PURE__ */ be.jsx(
                Yn,
                {
                  onDelete: () => p({
                    key: Y,
                    type: "ISSUE"
                  }),
                  children: ur(Y)
                },
                ur(Y)
              )),
              j.map((Y) => /* @__PURE__ */ be.jsx(
                Yn,
                {
                  onDelete: () => p({ key: Y, type: "PR" }),
                  children: ur(Y)
                },
                ur(Y)
              ))
            ] }),
            /* @__PURE__ */ be.jsx(
              et,
              {
                variant: "secondary",
                onClick: () => f(),
                icon: "link-slash",
                children: "Remove all"
              }
            )
          ]
        }
      ),
      s && H && /* @__PURE__ */ be.jsx(
        et,
        {
          variant: "secondary",
          disabled: I,
          onClick: h,
          children: "Remove all links"
        }
      ),
      /* @__PURE__ */ be.jsx(
        At,
        {
          slotEnd: /* @__PURE__ */ be.jsx(he, { name: "external-link" }),
          variant: "tertiary",
          className: Gi.buttonLink,
          navigate: () => {
            window.open(`https://github.com/${o}`, "_blank")?.focus();
          },
          children: "Open GitHub"
        }
      )
    ] }),
    /* @__PURE__ */ be.jsx(
      jR,
      {
        isOpen: r,
        onClose: () => i(!1),
        linkGithubIssueQuietly: E,
        conversationContext: e,
        githubOrganization: o
      }
    )
  ] });
}, Ch = [
  {
    key: "githubOrganization",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "enableRemoveAllLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], vi = "GITHUB", TR = {
  enabled: !1,
  name: "",
  githubOrganization: "",
  enableRemoveAllLinks: !1,
  showDanglingLinks: !1,
  enableCreateIssue: !0
}, OR = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = dt({
    mode: "onChange",
    defaultValues: TR
  }), {
    create: u,
    update: p,
    remove: d,
    isLoading: f,
    error: h,
    misconfigurationCause: v,
    setMisconfigurationCause: C
  } = hr({
    integrationId: e,
    integrationType: vi,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: j,
    error: N,
    isWidgetUnknown: x,
    refetch: g,
    widgetConfiguration: P
  } = yr({
    integrationId: e,
    fieldDefinitions: Ch,
    form: l,
    onMisconfigured: C
  }), { renderConditions: E, setRenderConditions: I, renderConditionsForSubmit: w } = gr({
    integrationId: e,
    widgetConfiguration: P,
    renderConditionsEditor: o
  }), A = (Y) => kr(Y, {
    fieldDefinitions: Ch,
    isCreationMode: s,
    create: u,
    update: p,
    renderConditions: w
  }), H = l.watch("name");
  return /* @__PURE__ */ be.jsxs(
    vr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: A,
      error: N ?? h,
      onRetry: N ? g : void 0,
      isLoading: f || j,
      isWidgetUnknown: x,
      children: [
        v && /* @__PURE__ */ be.jsx(br, { cause: v }),
        /* @__PURE__ */ be.jsxs(tt, { children: [
          /* @__PURE__ */ be.jsx(ie, { children: /* @__PURE__ */ be.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ be.jsx(
            Sn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ be.jsx(ie, { span: 3, children: /* @__PURE__ */ be.jsx(
            Gn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ be.jsx(ie, { span: 3 }),
          /* @__PURE__ */ be.jsx(ie, { span: 3, children: /* @__PURE__ */ be.jsx(
            Gn,
            {
              name: "githubOrganization",
              label: "GitHub organization or user",
              control: l.control,
              rules: { required: "GitHub organization or user is required" },
              componentProps: {
                placeholder: "Insert your GitHub organization or user name, e.g. dixahq",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ be.jsx(ie, { span: 3 }),
          /* @__PURE__ */ be.jsx(ie, { span: 3, children: /* @__PURE__ */ be.jsx(We, { label: 'Enable the "Remove all links" button', children: /* @__PURE__ */ be.jsx(
            Sn,
            {
              name: "enableRemoveAllLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ be.jsx(ie, { span: 3 }),
          /* @__PURE__ */ be.jsx(ie, { span: 3, children: /* @__PURE__ */ be.jsx(We, { label: "Show unresolved links to GitHub items", children: /* @__PURE__ */ be.jsx(
            Sn,
            {
              name: "showDanglingLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ be.jsx(ie, { span: 3 }),
          /* @__PURE__ */ be.jsx(ie, { span: 3, children: /* @__PURE__ */ be.jsx(We, { label: 'Enable the "Create issue" button', children: /* @__PURE__ */ be.jsx(
            Sn,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ be.jsx(ie, { span: 3 }),
          !s && e && /* @__PURE__ */ be.jsx(
            pi,
            {
              configuration: n,
              integrationId: e,
              integrationType: vi,
              label: "Authorize with OAuth"
            }
          ),
          o && E !== null && /* @__PURE__ */ be.jsx(ie, { children: o({
            value: E,
            onChange: I,
            configurationKey: P?.id
          }) })
        ] }),
        /* @__PURE__ */ be.jsx(
          xr,
          {
            integrationType: vi,
            integrationId: e,
            widgetName: H,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => d(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ be.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ be.jsx(
                he,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ be.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ be.jsxs(O.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  vi,
                  " integration, all links between Dixa and ",
                  vi,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ be.jsxs(O.Paragraph, { children: [
                  "All data in ",
                  vi,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ be.jsxs(O.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  vi,
                  " ",
                  'integration "',
                  H,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_16pij_1{padding:0}._listItem_16pij_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_16pij_4:last-child{border-bottom:none}._listItemEdit_16pij_11{cursor:pointer}._clickableIcon_16pij_15{cursor:pointer;color:var(--dixa-typography-color-secondary)}._boxWrapper_89s7l_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._boxWrapper_89s7l_1:hover{border-color:var(--dixa-color-neutral-300)}._trackButton_89s7l_10{color:var(--dixa-typography-color-link)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Bd = { exports: {} }, qa = {}, Dx;
function DR() {
  if (Dx) return qa;
  Dx = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return qa.Fragment = r, qa.jsx = s, qa.jsxs = s, qa;
}
var rs = {}, Px;
function PR() {
  return Px || (Px = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        P("error", t, m);
      }
    }
    function P(t, c, m) {
      {
        var y = x.ReactDebugCurrentFrame, F = y.getStackAddendum();
        F !== "" && (c += "%s", m = m.concat([F]));
        var T = m.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var E = !1, I = !1, w = !1, A = !1, H = !1, Y;
    Y = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ne(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || H || t === a || t === p || t === d || A || t === v || E || I || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function W(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var F = c.displayName || c.name || "";
      return F !== "" ? m + "(" + F + ")" : m;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function D(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var m = t;
            return B(m._context) + ".Provider";
          case u:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : D(t.type) || "Memo";
          case h: {
            var F = t, T = F._payload, S = F._init;
            try {
              return D(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var M = Object.assign, Z = 0, je, ge, ye, ke, q, _e, De;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function Ye() {
      {
        if (Z === 0) {
          je = console.log, ge = console.info, ye = console.warn, ke = console.error, q = console.group, _e = console.groupCollapsed, De = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function sn() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: M({}, t, {
              value: je
            }),
            info: M({}, t, {
              value: ge
            }),
            warn: M({}, t, {
              value: ye
            }),
            error: M({}, t, {
              value: ke
            }),
            group: M({}, t, {
              value: q
            }),
            groupCollapsed: M({}, t, {
              value: _e
            }),
            groupEnd: M({}, t, {
              value: De
            })
          });
        }
        Z < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = x.ReactCurrentDispatcher, Ue;
    function Pe(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (F) {
            var y = F.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Le;
    {
      var Xe = typeof WeakMap == "function" ? WeakMap : Map;
      Le = new Xe();
    }
    function Fe(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Le.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      Be = !0;
      var F = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ye();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (re) {
              y = re;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (re) {
              y = re;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            y = re;
          }
          t();
        }
      } catch (re) {
        if (re && y && typeof re.stack == "string") {
          for (var _ = re.stack.split(`
`), ee = y.stack.split(`
`), L = _.length - 1, U = ee.length - 1; L >= 1 && U >= 0 && _[L] !== ee[U]; )
            U--;
          for (; L >= 1 && U >= 0; L--, U--)
            if (_[L] !== ee[U]) {
              if (L !== 1 || U !== 1)
                do
                  if (L--, U--, U < 0 || _[L] !== ee[U]) {
                    var ce = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && ce.includes("<anonymous>") && (ce = ce.replace("<anonymous>", t.displayName)), typeof t == "function" && Le.set(t, ce), ce;
                  }
                while (L >= 1 && U >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = F;
      }
      var ze = t ? t.displayName || t.name : "", Oe = ze ? Pe(ze) : "";
      return typeof t == "function" && Le.set(t, Oe), Oe;
    }
    function Me(t, c, m) {
      return Fe(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Fe(t, nn(t));
      if (typeof t == "string")
        return Pe(t);
      switch (t) {
        case p:
          return Pe("Suspense");
        case d:
          return Pe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return Me(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, F = y._payload, T = y._init;
            try {
              return se(T(F), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Se = {}, Ae = x.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(m);
      } else
        Ae.setExtraStackFrame(null);
    }
    function yn(t, c, m, y, F) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + m + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              _ = t[S](c, S, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Re(F), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, S, typeof _), Re(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Re(F), g("Failed %s type: %s", m, _.message), Re(null));
          }
      }
    }
    var Q = Array.isArray;
    function $(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ae(t);
    }
    var J = x.ReactCurrentOwner, de = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, xe, $e;
    function tn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && J.current;
    }
    function pn(t, c) {
      {
        var m = function() {
          xe || (xe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function Fn(t, c) {
      {
        var m = function() {
          $e || ($e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, m, y, F, T, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: F
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, m, y, F) {
      {
        var T, S = {}, _ = null, ee = null;
        m !== void 0 && (V(m), _ = "" + m), gn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ee = c.ref, on(c));
        for (T in c)
          le.call(c, T) && !de.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (T in L)
            S[T] === void 0 && (S[T] = L[T]);
        }
        if (_ || ee) {
          var U = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, U), ee && Fn(S, U);
        }
        return xn(t, _, ee, F, y, J.current, S);
      }
    }
    var en = x.ReactCurrentOwner, vn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        vn.setExtraStackFrame(m);
      } else
        vn.setExtraStackFrame(null);
    }
    var un;
    un = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = D(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Nn = {};
    function Rn(t) {
      {
        var c = jn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function kn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Rn(c);
        if (Nn[m])
          return;
        Nn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + D(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Ve(null);
      }
    }
    function _n(t, c) {
      {
        if (typeof t != "object")
          return;
        if ($(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            dn(y) && kn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var F = N(t);
          if (typeof F == "function" && F !== t.entries)
            for (var T = F.call(t), S; !(S = T.next()).done; )
              dn(S.value) && kn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = D(c);
          yn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !un) {
          un = !0;
          var F = D(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", F || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, m, y, F, T) {
      {
        var S = ne(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = Bn();
          ee ? _ += ee : _ += jn();
          var L;
          t === null ? L = "null" : $(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (D(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var U = En(t, c, m, F, T);
        if (U == null)
          return U;
        if (S) {
          var ce = c.children;
          if (ce !== void 0)
            if (y)
              if ($(ce)) {
                for (var ze = 0; ze < ce.length; ze++)
                  _n(ce[ze], t);
                Object.freeze && Object.freeze(ce);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _n(ce, t);
        }
        if (le.call(c, "key")) {
          var Oe = D(t), re = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), mn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Oe + mn]) {
            var Dn = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Oe, Dn, Oe), Cn[Oe + mn] = !0;
          }
        }
        return t === i ? Ln(U) : An(U), U;
      }
    }
    function Vn(t, c, m) {
      return wn(t, c, m, !0);
    }
    function qn(t, c, m) {
      return wn(t, c, m, !1);
    }
    var zn = qn, Wn = Vn;
    rs.Fragment = i, rs.jsx = zn, rs.jsxs = Wn;
  })()), rs;
}
var Rx;
function RR() {
  return Rx || (Rx = 1, process.env.NODE_ENV === "production" ? Bd.exports = DR() : Bd.exports = PR()), Bd.exports;
}
var we = RR(), go = /* @__PURE__ */ ((e) => (e.Outbound = "OUTBOUND", e.Return = "RETURN", e.UnknownDirectionType = "UNKNOWN_DIRECTION_TYPE", e.Unspecified = "UNSPECIFIED", e))(go || {}), ji = /* @__PURE__ */ ((e) => (e.Delivery = "DELIVERY", e.Instore = "INSTORE", e.Inwarehouse = "INWAREHOUSE", e.Mailbox = "MAILBOX", e.Pickup = "PICKUP", e.Unknown = "UNKNOWN", e))(ji || {}), Xt = /* @__PURE__ */ ((e) => (e.StepAwaitingSupplier = "STEP_AWAITING_SUPPLIER", e.StepConfirmedByMerchant = "STEP_CONFIRMED_BY_MERCHANT", e.StepDeliveredToConsumer = "STEP_DELIVERED_TO_CONSUMER", e.StepDeliveredToMerchant = "STEP_DELIVERED_TO_MERCHANT", e.StepDeliveredToPickupPoint = "STEP_DELIVERED_TO_PICKUP_POINT", e.StepLinehaulToCarrier = "STEP_LINEHAUL_TO_CARRIER", e.StepOnRoute = "STEP_ON_ROUTE", e.StepPreparedByMerchant = "STEP_PREPARED_BY_MERCHANT", e.StepReturnRequested = "STEP_RETURN_REQUESTED", e.StepSentBack = "STEP_SENT_BACK", e.StepSubmittedToCarrier = "STEP_SUBMITTED_TO_CARRIER", e.StepTerminated = "STEP_TERMINATED", e.StepUnknown = "STEP_UNKNOWN", e))(Xt || {});
const AR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "locale" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Ingrid" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "DeliveryTracking_GetTrackingOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "locale" }, value: { kind: "Variable", name: { kind: "Name", value: "locale" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_GetTrackingOrdersResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "analytics_id" } }, { kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "preselected_parcel_index" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "site_name" } }, { kind: "Field", name: { kind: "Name", value: "tos_id" } }, { kind: "Field", name: { kind: "Name", value: "tracking_links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "cart" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_quantity" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_total_price" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "variant" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "size" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "prices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shipping_components" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "total" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "items_discount" } }, { kind: "Field", name: { kind: "Name", value: "items_price" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "shipping_discount" } }, { kind: "Field", name: { kind: "Name", value: "shipping_price" } }, { kind: "Field", name: { kind: "Name", value: "tax" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "parcels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alerts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "awaiting_supplier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "delivery_attempt_failed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed_from_carrier" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time_updated" } }, { kind: "Field", name: { kind: "Name", value: "linehaul" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "out_for_delivery" } }, { kind: "Field", name: { kind: "Name", value: "submission_delayed" } }] } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "carrier_fallback_enabled" } }, { kind: "Field", name: { kind: "Name", value: "carrier_link" } }, { kind: "Field", name: { kind: "Name", value: "carrier_logo_pattern" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_id" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_ref" } }, { kind: "Field", name: { kind: "Name", value: "delivery_type" } }, { kind: "Field", name: { kind: "Name", value: "direction_type" } }, { kind: "Field", name: { kind: "Name", value: "display_carrier_name" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "exceptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "status" } }] } }, { kind: "Field", name: { kind: "Name", value: "index" } }, { kind: "Field", name: { kind: "Name", value: "line_items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "location" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address_lines" } }, { kind: "Field", name: { kind: "Name", value: "apartment_number" } }, { kind: "Field", name: { kind: "Name", value: "attn" } }, { kind: "Field", name: { kind: "Name", value: "building_name" } }, { kind: "Field", name: { kind: "Name", value: "care_of" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "coordinates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lat" } }, { kind: "Field", name: { kind: "Name", value: "lng" } }] } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "door_code" } }, { kind: "Field", name: { kind: "Name", value: "floor_number" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "po_box_id" } }, { kind: "Field", name: { kind: "Name", value: "postal_code" } }, { kind: "Field", name: { kind: "Name", value: "region" } }, { kind: "Field", name: { kind: "Name", value: "street" } }, { kind: "Field", name: { kind: "Name", value: "street_number" } }, { kind: "Field", name: { kind: "Name", value: "subregion" } }] } }, { kind: "Field", name: { kind: "Name", value: "location_external_id" } }, { kind: "Field", name: { kind: "Name", value: "location_type" } }, { kind: "Field", name: { kind: "Name", value: "operational_hours" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "free_text" } }, { kind: "Field", name: { kind: "Name", value: "fri" } }, { kind: "Field", name: { kind: "Name", value: "mon" } }, { kind: "Field", name: { kind: "Name", value: "sat" } }, { kind: "Field", name: { kind: "Name", value: "sun" } }, { kind: "Field", name: { kind: "Name", value: "thu" } }, { kind: "Field", name: { kind: "Name", value: "tue" } }, { kind: "Field", name: { kind: "Name", value: "wed" } }] } }, { kind: "Field", name: { kind: "Name", value: "pickup_instructions" } }] } }, { kind: "Field", name: { kind: "Name", value: "progress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "step" } }, { kind: "Field", name: { kind: "Name", value: "time" } }] } }, { kind: "Field", name: { kind: "Name", value: "requested_shipping_method" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "tracking_link" } }, { kind: "Field", name: { kind: "Name", value: "tracking_number" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_Error" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "details" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, LR = {
  "\n  query getOrders($email: String!, $locale: String!) {\n    Ingrid {\n      DeliveryTracking_GetTrackingOrders(\n        email: $email\n        locale: $locale\n      ) {\n        ... on Ingrid_GetTrackingOrdersResponse {\n          orders {\n            analytics_id\n            external_id\n            preselected_parcel_index\n            sender_name\n            site_name\n            tos_id\n            tracking_links {\n              links {\n                type\n                url\n              }\n            }\n            items {\n              discount\n              image\n              name\n              price\n              quantity\n              sku\n              total_price\n            }\n            cart {\n              currency\n              items {\n                attributes\n                cancelled_quantity\n                cancelled_total_price\n                discount\n                image\n                name\n                price\n                quantity\n                sku\n                total_price\n                variant {\n                  color\n                  size\n                }\n              }\n              prices {\n                shipping_components {\n                  discount\n                  name\n                  price\n                }\n                total {\n                  discount\n                  items_discount\n                  items_price\n                  price\n                  shipping_discount\n                  shipping_price\n                  tax\n                }\n              }\n            }\n            parcels {\n              alerts {\n                created_at\n                type\n                awaiting_supplier {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                delivery_attempt_failed\n                delivery_delayed\n                delivery_delayed_from_carrier\n                estimated_delivery_time_updated\n                linehaul {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                out_for_delivery\n                submission_delayed\n              }\n              carrier\n              carrier_fallback_enabled\n              carrier_link\n              carrier_logo_pattern\n              carrier_product_id\n              carrier_product_ref\n              delivery_type\n              direction_type\n              display_carrier_name\n              estimated_delivery_time {\n                end\n                start\n              }\n              exceptions {\n                created_at\n                status\n              }\n              index\n              line_items {\n                currency\n                discount\n                image\n                name\n                price\n                properties\n                quantity\n                sku\n                total_price\n              }\n              location {\n                address {\n                  address_lines\n                  apartment_number\n                  attn\n                  building_name\n                  care_of\n                  city\n                  coordinates {\n                    lat\n                    lng\n                  }\n                  country\n                  door_code\n                  floor_number\n                  name\n                  po_box_id\n                  postal_code\n                  region\n                  street\n                  street_number\n                  subregion\n                }\n                location_external_id\n                location_type\n                operational_hours {\n                  free_text\n                  fri\n                  mon\n                  sat\n                  sun\n                  thu\n                  tue\n                  wed\n                }\n                pickup_instructions\n              }\n              progress {\n                estimated_time {\n                  end\n                  start\n                }\n                step\n                time\n              }\n              requested_shipping_method\n              sender_name\n              tracking_link\n              tracking_number\n            }\n          }\n        }\n\n        ... on Ingrid_Error {\n          code\n          details\n          message\n        }\n      }\n    }\n  }\n": AR
};
function VR(e) {
  return LR[e] ?? {};
}
const zR = VR(
  /* GraphQL */
  `
  query getOrders($email: String!, $locale: String!) {
    Ingrid {
      DeliveryTracking_GetTrackingOrders(
        email: $email
        locale: $locale
      ) {
        ... on Ingrid_GetTrackingOrdersResponse {
          orders {
            analytics_id
            external_id
            preselected_parcel_index
            sender_name
            site_name
            tos_id
            tracking_links {
              links {
                type
                url
              }
            }
            items {
              discount
              image
              name
              price
              quantity
              sku
              total_price
            }
            cart {
              currency
              items {
                attributes
                cancelled_quantity
                cancelled_total_price
                discount
                image
                name
                price
                quantity
                sku
                total_price
                variant {
                  color
                  size
                }
              }
              prices {
                shipping_components {
                  discount
                  name
                  price
                }
                total {
                  discount
                  items_discount
                  items_price
                  price
                  shipping_discount
                  shipping_price
                  tax
                }
              }
            }
            parcels {
              alerts {
                created_at
                type
                awaiting_supplier {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                delivery_attempt_failed
                delivery_delayed
                delivery_delayed_from_carrier
                estimated_delivery_time_updated
                linehaul {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                out_for_delivery
                submission_delayed
              }
              carrier
              carrier_fallback_enabled
              carrier_link
              carrier_logo_pattern
              carrier_product_id
              carrier_product_ref
              delivery_type
              direction_type
              display_carrier_name
              estimated_delivery_time {
                end
                start
              }
              exceptions {
                created_at
                status
              }
              index
              line_items {
                currency
                discount
                image
                name
                price
                properties
                quantity
                sku
                total_price
              }
              location {
                address {
                  address_lines
                  apartment_number
                  attn
                  building_name
                  care_of
                  city
                  coordinates {
                    lat
                    lng
                  }
                  country
                  door_code
                  floor_number
                  name
                  po_box_id
                  postal_code
                  region
                  street
                  street_number
                  subregion
                }
                location_external_id
                location_type
                operational_hours {
                  free_text
                  fri
                  mon
                  sat
                  sun
                  thu
                  tue
                  wed
                }
                pickup_instructions
              }
              progress {
                estimated_time {
                  end
                  start
                }
                step
                time
              }
              requested_shipping_method
              sender_name
              tracking_link
              tracking_number
            }
          }
        }

        ... on Ingrid_Error {
          code
          details
          message
        }
      }
    }
  }
`
), Ax = (e) => {
  if (!e) return "";
  try {
    return new Intl.DateTimeFormat(void 0, {
      dateStyle: "medium",
      timeStyle: "short"
    }).format(new Date(e));
  } catch {
    return e;
  }
}, AC = (e, n) => {
  try {
    return new Intl.NumberFormat(void 0, {
      style: "currency",
      currency: n
    }).format(e);
  } catch {
    return e.toString();
  }
}, UR = "_listItem_16pij_4", MR = "_clickableIcon_16pij_15", To = {
  listItem: UR,
  clickableIcon: MR
}, LC = ({
  items: e,
  title: n,
  currency: r,
  openByDefault: i = !1
}) => {
  const [a, o] = ue(i);
  return !e || e.length === 0 ? null : /* @__PURE__ */ we.jsx(b, { gap: "100", flexDirection: "column", children: /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ we.jsx(he, { size: 14, name: "list-ul", color: "blue.900" }),
      /* @__PURE__ */ we.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ we.jsxs(
        b,
        {
          gap: "100",
          flexDirection: "row",
          onClick: () => o(!a),
          className: To.clickableIcon,
          alignItems: "center",
          children: [
            /* @__PURE__ */ we.jsx(O.Paragraph, { variant: "3", children: n }),
            /* @__PURE__ */ we.jsx(
              he,
              {
                size: 14,
                name: a ? "angle-down" : "angle-right"
              }
            )
          ]
        }
      ) })
    ] }),
    a && /* @__PURE__ */ we.jsx(Qe, { children: e.map((l, u) => {
      if (!l) return null;
      const { name: p, quantity: d, price: f, image: h, sku: v } = l, C = l.currency ?? r;
      return /* @__PURE__ */ we.jsx(
        Qe.Item,
        {
          contentLeft: /* @__PURE__ */ we.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ we.jsx(O.Paragraph, { children: d }),
            /* @__PURE__ */ we.jsx(O.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ we.jsxs(b, { flexDirection: "column", gap: "050", children: [
            /* @__PURE__ */ we.jsx(O.Paragraph, { variant: "4", children: p }),
            f != null && /* @__PURE__ */ we.jsx(O.Paragraph, { variant: "4", color: "tertiary", children: AC(f / 100, C) })
          ] }),
          contentRight: h && /* @__PURE__ */ we.jsx(xa, { src: h, alt: p ?? "Product image" }),
          className: To.listItem
        },
        `item-${u}-${v}`
      );
    }) })
  ] }) });
}, BR = "_boxWrapper_89s7l_1", qR = "_trackButton_89s7l_10", Lx = {
  boxWrapper: BR,
  trackButton: qR
}, HR = {
  [Xt.StepUnknown]: "Unknown",
  [Xt.StepConfirmedByMerchant]: "Confirmed by merchant",
  [Xt.StepPreparedByMerchant]: "Prepared by merchant",
  [Xt.StepSubmittedToCarrier]: "Submitted to carrier",
  [Xt.StepLinehaulToCarrier]: "Linehaul to carrier",
  [Xt.StepOnRoute]: "On route",
  [Xt.StepDeliveredToPickupPoint]: "At pickup point",
  [Xt.StepDeliveredToConsumer]: "Delivered to customer",
  [Xt.StepDeliveredToMerchant]: "Returned to merchant",
  [Xt.StepReturnRequested]: "Return requested",
  [Xt.StepSentBack]: "Sent back",
  [Xt.StepTerminated]: "Terminated",
  [Xt.StepAwaitingSupplier]: "Awaiting supplier"
}, WR = {
  [ji.Delivery]: "Home delivery",
  [ji.Pickup]: "Pickup point",
  [ji.Instore]: "In-store pickup",
  [ji.Mailbox]: "Mailbox",
  [ji.Inwarehouse]: "Warehouse",
  [ji.Unknown]: "Unknown"
}, KR = {
  [go.Outbound]: "From merchant to customer",
  [go.Return]: "Return from customer to merchant",
  [go.Unspecified]: "Unspecified",
  [go.UnknownDirectionType]: "Unknown"
}, GR = (e) => e ? HR[e] ?? e : "", YR = (e) => e ? WR[e] ?? e : "", JR = (e) => e ? KR[e] ?? e : "", QR = (e) => {
  if (!e) return null;
  const n = [e.street, e.street_number].filter(Boolean).join(" ");
  return [
    e.name,
    n,
    e.postal_code,
    e.city,
    e.country
  ].filter(Boolean).join(`
`);
}, XR = ({
  parcel: e
}) => {
  const { isCopied: n, copy: r } = Jt();
  if (!e)
    return null;
  const {
    carrier: i,
    progress: a,
    tracking_number: o,
    line_items: s,
    carrier_product_ref: l,
    carrier_link: u,
    display_carrier_name: p,
    delivery_type: d,
    direction_type: f,
    estimated_delivery_time: h
  } = e, v = p || l || i, C = a?.filter((E) => E?.time !== ""), j = GR(C?.[0]?.step), N = YR(d), x = JR(f), g = QR(e.location?.address), P = 14;
  return /* @__PURE__ */ we.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      padding: "250",
      className: Lx.boxWrapper,
      children: [
        /* @__PURE__ */ we.jsx(O.Heading, { variant: "heading-4", children: v }),
        /* @__PURE__ */ we.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ we.jsx(
              he,
              {
                size: P,
                name: "magnifying-glass-chart",
                color: "blue.900"
              }
            ),
            /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ we.jsx(O.Paragraph, { variant: "3", children: "Carrier tracking ID" }),
              /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                !o && /* @__PURE__ */ we.jsx(O.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                o && /* @__PURE__ */ we.jsx(O.Paragraph, { variant: "4", color: "secondary", children: o })
              ] })
            ] })
          ] }),
          o && /* @__PURE__ */ we.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ we.jsx(Ze, { content: "Copy tracking ID", children: /* @__PURE__ */ we.jsx(
            he,
            {
              size: P,
              name: n ? "done" : "copy",
              className: To.clickableIcon,
              onClick: () => r(o)
            }
          ) }) })
        ] }),
        j && /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ we.jsx(he, { size: P, name: "chart-donut", color: "blue.900" }),
          /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ we.jsx(O.Paragraph, { variant: "3", children: "Status" }),
            /* @__PURE__ */ we.jsx(O.Paragraph, { variant: "4", color: "secondary", children: j })
          ] })
        ] }),
        x && /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ we.jsx(he, { size: P, name: "arrow-right", color: "blue.900" }),
          /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ we.jsx(O.Paragraph, { variant: "3", children: "Direction" }),
            /* @__PURE__ */ we.jsx(O.Paragraph, { variant: "4", color: "secondary", children: x })
          ] })
        ] }),
        h && /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ we.jsx(he, { size: P, name: "calendar", color: "blue.900" }),
          /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ we.jsx(O.Paragraph, { variant: "3", children: "Estimated delivery" }),
            /* @__PURE__ */ we.jsxs(O.Paragraph, { variant: "4", color: "secondary", children: [
              Ax(h.start),
              " ",
              h.end && " until"
            ] }),
            h.end && /* @__PURE__ */ we.jsx(O.Paragraph, { variant: "4", color: "secondary", children: Ax(h.end) })
          ] })
        ] }),
        d && /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ we.jsx(he, { size: P, name: "info", color: "blue.900" }),
          /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ we.jsx(O.Paragraph, { variant: "3", children: "Delivery type" }),
            /* @__PURE__ */ we.jsx(O.Paragraph, { variant: "4", color: "secondary", children: N })
          ] })
        ] }),
        g && /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ we.jsx(he, { size: P, name: "map-pin", color: "blue.900" }),
          /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ we.jsx(O.Paragraph, { variant: "3", children: "Pickup location" }),
            /* @__PURE__ */ we.jsx(O.Paragraph, { variant: "4", color: "secondary", children: g })
          ] })
        ] }),
        /* @__PURE__ */ we.jsx(LC, { title: "Parcel items", items: s }),
        u && /* @__PURE__ */ we.jsxs(
          At,
          {
            variant: "secondary",
            className: Lx.trackButton,
            navigate: () => window.open(u, "_blank")?.focus(),
            slotStart: /* @__PURE__ */ we.jsx(he, { name: "external-link" }),
            children: [
              "Track on ",
              v ?? "carrier",
              " website"
            ]
          }
        )
      ]
    }
  );
}, ZR = "_order_135ze_1", eA = "_orderIsOpen_135ze_9", nA = "_orderHeader_135ze_12", qd = {
  order: ZR,
  orderIsOpen: eA,
  orderHeader: nA
}, Vx = "No order number found", tA = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = ue(n), { isCopied: a, copy: o } = Jt(), { isCopied: s, copy: l } = Jt();
  if (!e)
    return null;
  const { cart: u, parcels: p, sender_name: d, tos_id: f } = e, h = e.external_id?.trim(), v = u?.currency || "", C = u?.prices?.total?.price ?? 0, j = AC(C / 100, v), N = 14, x = d && d.trim() !== "" ? d : "unknown sender";
  return /* @__PURE__ */ we.jsxs(
    b,
    {
      className: ut(qd.order, {
        [qd.orderIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ we.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: qd.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ we.jsxs(O.Paragraph, { variant: "4", children: [
                  "From ",
                  x
                ] }),
                h ? /* @__PURE__ */ we.jsx(O.Paragraph, { variant: "3", children: /* @__PURE__ */ we.jsxs("span", { children: [
                  "#",
                  h
                ] }) }) : /* @__PURE__ */ we.jsx(O.Paragraph, { variant: "4", color: "tertiary", children: Vx })
              ] }),
              /* @__PURE__ */ we.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ we.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ we.jsx(he, { size: N, name: "tag", color: "blue.900" }),
              /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ we.jsx(O.Paragraph, { variant: "3", children: "Order number" }),
                /* @__PURE__ */ we.jsx(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: h ? /* @__PURE__ */ we.jsx(O.Paragraph, { variant: "4", color: "secondary", children: h }) : /* @__PURE__ */ we.jsx(O.Paragraph, { variant: "4", color: "tertiary", children: Vx }) })
              ] })
            ] }),
            h && /* @__PURE__ */ we.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ we.jsx(Ze, { content: "Copy order number", children: /* @__PURE__ */ we.jsx(
              he,
              {
                size: N,
                name: s ? "done" : "copy",
                className: To.clickableIcon,
                onClick: () => l(h)
              }
            ) }) })
          ] }),
          /* @__PURE__ */ we.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ we.jsx(
                he,
                {
                  size: N,
                  name: "magnifying-glass-chart",
                  color: "blue.900"
                }
              ),
              /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ we.jsx(O.Paragraph, { variant: "3", children: "Ingrid tracking ID" }),
                /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                  !f && /* @__PURE__ */ we.jsx(O.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                  f && /* @__PURE__ */ we.jsx(O.Paragraph, { variant: "4", color: "secondary", children: f })
                ] })
              ] })
            ] }),
            f && /* @__PURE__ */ we.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ we.jsx(Ze, { content: "Copy tracking ID", children: /* @__PURE__ */ we.jsx(
              he,
              {
                size: N,
                name: a ? "done" : "copy",
                className: To.clickableIcon,
                onClick: () => o(f)
              }
            ) }) })
          ] }),
          d && /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ we.jsx(he, { size: 14, name: "user", color: "blue.900" }),
            /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ we.jsx(O.Paragraph, { variant: "3", children: "Sender" }),
              /* @__PURE__ */ we.jsx(O.Paragraph, { variant: "4", children: d })
            ] })
          ] }),
          /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ we.jsx(he, { size: 14, name: "chart-bar", color: "blue.900" }),
            /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ we.jsx(O.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ we.jsx(O.Paragraph, { variant: "4", children: j })
            ] })
          ] }),
          /* @__PURE__ */ we.jsx(
            LC,
            {
              openByDefault: !0,
              title: "Order items",
              items: u?.items?.map((g) => g),
              currency: u?.currency
            }
          ),
          p && /* @__PURE__ */ we.jsxs(b, { gap: "200", flexDirection: "column", margin: "0 0 100 0", children: [
            /* @__PURE__ */ we.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
              /* @__PURE__ */ we.jsx(O.Heading, { variant: "heading-4", children: "Parcels" }),
              p.length > 0 && /* @__PURE__ */ we.jsx(Mn, { variant: "success", size: "small", children: p.length })
            ] }),
            p.length === 0 && /* @__PURE__ */ we.jsx(O.Paragraph, { variant: "4", color: "secondary", children: "No parcels here" }),
            p.map((g, P) => /* @__PURE__ */ we.jsx(
              XR,
              {
                parcel: g
              },
              `parcel-${P}-${g?.tracking_number}`
            ))
          ] })
        ] })
      ]
    }
  );
}, rA = (e) => {
  const n = [], r = /* @__PURE__ */ new Map();
  for (const i of e) {
    if (!i?.external_id) {
      n.push(i);
      continue;
    }
    const a = r.get(i.external_id);
    if (a)
      a.parcels = [
        ...a.parcels ?? [],
        ...i.parcels ?? []
      ];
    else {
      const o = { ...i };
      r.set(i.external_id, o), n.push(o);
    }
  }
  return n;
}, zx = (e) => {
  let n = 1 / 0;
  for (const r of e?.parcels ?? [])
    for (const i of r?.progress ?? []) {
      if (!i?.time)
        continue;
      const a = new Date(i.time).getTime();
      !Number.isNaN(a) && a < n && (n = a);
    }
  return n === 1 / 0 ? -1 / 0 : n;
}, iA = (e) => [...e].sort(
  (n, r) => zx(r) - zx(n)
), aA = ({
  customerEmail: e
}) => {
  const { useQuery: n } = bn(), [r, i] = ue([]), a = !e, { data: o, loading: s, error: l } = n(zR, {
    skip: a,
    variables: {
      email: e,
      locale: "en-GB"
    }
  }), u = !s && r.length > 0, p = l ? HI({
    error: l.graphQLErrors?.[0]
  }) : !1, d = l ? ow({
    error: l.graphQLErrors?.[0]
  }) : !1;
  return Je(() => {
    const f = o?.Ingrid?.DeliveryTracking_GetTrackingOrders;
    f?.orders && i(
      iA(
        rA(f.orders)
      )
    );
  }, [o?.Ingrid?.DeliveryTracking_GetTrackingOrders]), s ? /* @__PURE__ */ we.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ we.jsx(hn, {}) }) : p || !u && !l ? /* @__PURE__ */ we.jsx(O.Paragraph, { color: "tertiary", align: "center", children: "No orders to track" }) : d ? /* @__PURE__ */ we.jsx(O.Paragraph, { color: "tertiary", align: "center", children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator." }) : l ? /* @__PURE__ */ we.jsx(Tn, { error: l }) : /* @__PURE__ */ we.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ we.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ we.jsx(O.Heading, { variant: "heading-3", children: "Orders" }),
      /* @__PURE__ */ we.jsx(Mn, { variant: "success", size: "small", children: r.length })
    ] }),
    /* @__PURE__ */ we.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ we.jsx(b, { gap: "200", flexDirection: "column", children: r.map((f, h) => /* @__PURE__ */ we.jsx(
      tA,
      {
        order: f,
        openByDefault: h === 0
      },
      `${h}-${f?.tos_id}`
    )) }) })
  ] });
}, oA = ({ conversationContext: e }) => {
  const n = e?.customer?.email;
  return /* @__PURE__ */ we.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: /* @__PURE__ */ we.jsx(aA, { customerEmail: n })
    }
  );
}, Ih = [
  {
    key: "ingridUseStagingEnvironment",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "ingridSiteId",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "ingridApiToken",
    type: "string",
    secret: !0,
    defaultValue: ""
  }
], sA = {
  enabled: !1,
  name: "",
  ingridSiteId: "",
  ingridApiToken: "",
  ingridUseStagingEnvironment: !1
}, lA = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = dt({
    mode: "onChange",
    defaultValues: sA
  }), {
    create: l,
    update: u,
    remove: p,
    isLoading: d,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = hr({
    integrationId: e,
    integrationType: "INGRID",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: C,
    error: j,
    isWidgetUnknown: N,
    refetch: x,
    widgetConfiguration: g
  } = yr({
    integrationId: e,
    fieldDefinitions: Ih,
    form: s,
    onMisconfigured: v
  }), { renderConditions: P, setRenderConditions: E, renderConditionsForSubmit: I } = gr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), w = (H) => kr(H, {
    fieldDefinitions: Ih,
    isCreationMode: o,
    create: l,
    update: u,
    renderConditions: I
  }), A = s.watch("name");
  return /* @__PURE__ */ we.jsxs(
    vr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: w,
      error: j ?? f,
      onRetry: j ? x : void 0,
      isLoading: d || C,
      isWidgetUnknown: N,
      children: [
        h && /* @__PURE__ */ we.jsx(br, { cause: h }),
        /* @__PURE__ */ we.jsxs(tt, { children: [
          /* @__PURE__ */ we.jsx(ie, { children: /* @__PURE__ */ we.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ we.jsx(
            Sn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ we.jsx(ie, { span: 3, children: /* @__PURE__ */ we.jsx(
            Gn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ we.jsx(ie, { span: 3 }),
          /* @__PURE__ */ we.jsx(ie, { span: 3, children: /* @__PURE__ */ we.jsx(We, { label: "Use Ingrid staging environment", children: /* @__PURE__ */ we.jsx(
            Sn,
            {
              name: "ingridUseStagingEnvironment",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ we.jsx(ie, { span: 3 }),
          /* @__PURE__ */ we.jsx(ie, { span: 3, children: /* @__PURE__ */ we.jsx(
            Gn,
            {
              name: "ingridSiteId",
              label: "Site ID",
              control: s.control,
              rules: { required: "Site ID is required" },
              componentProps: {
                placeholder: "Site ID from Ingrid",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ we.jsx(ie, { span: 3 }),
          /* @__PURE__ */ we.jsx(ie, { span: 3, children: /* @__PURE__ */ we.jsx(
            mi,
            {
              name: "ingridApiToken",
              label: "API token",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API token is required" },
              componentProps: {
                placeholder: "API token from Ingrid",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ we.jsx(ie, { span: 3 }),
          a && P !== null && /* @__PURE__ */ we.jsx(ie, { children: a({
            value: P,
            onChange: E,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ we.jsx(
          xr,
          {
            integrationType: "INGRID",
            integrationId: e,
            widgetName: A,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => p()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._jiraCode_h30p6_1{padding:2px 4px;font-size:100%;font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-primary);border-radius:4px}._jiraCodeInline_h30p6_8{background-color:var(--dixa-color-neutral-200)}._collapse_m2gjh_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_m2gjh_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_m2gjh_10>div>div>p{white-space:unset!important}._collapseHeader_m2gjh_10>div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_m2gjh_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderLink_m2gjh_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-link);text-decoration:none}._collapseHeaderLink_m2gjh_31:hover{text-decoration:underline}._collapseHeaderStatus_m2gjh_40{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-500);float:right}._collapseHeaderIcon_m2gjh_46{padding-top:.35em;transform:scale(1.4);margin-left:var(--dixa-size-spacer-100)}._collapseHeaderTitle_m2gjh_51{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_m2gjh_59{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentHeadline_m2gjh_62{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary)}._collapseContentButtonSpacer_m2gjh_68{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_m2gjh_71{color:var(--dixa-typography-color-link)}._collapseContentStatusTag_m2gjh_74{max-width:10em}._collapseContentDescription_m2gjh_77{max-height:75vh;overflow-y:auto}._result_1wiub_54{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_1wiub_54:hover,._result_1wiub_54:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1wiub_74{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultNameIcon_1wiub_82{height:var(--dixa-typography-line-height-200);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._resultDescription_1wiub_87{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_1wiub_99{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_1wiub_108{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipContent_1wiub_114{display:flex;flex-direction:column;width:100%;max-height:60vh;max-height:60dvh}._tooltipName_1wiub_121{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1wiub_126{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipDescription_1wiub_131{padding-top:.5em;width:100%;text-align:left;color:var(--dixa-typography-color-secondary);flex-grow:1;overflow-y:auto}._tooltipSummary_1wiub_139{padding-top:.5em;font-weight:var(--dixa-typography-weight-semibold)}._tooltipTag_1wiub_143{width:fit-content;max-width:15em}._itemButton_1hl53_1{border:none;padding:0}._result_1hl53_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_1hl53_6:hover,._result_1hl53_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_1hl53_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_1hl53_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultCheckIcon_1hl53_38{height:var(--dixa-size-spacer-400)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_1bylq_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_1bylq_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_1bylq_14{text-align:center}._inputSeparator_1bylq_18{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_1bylq_23{color:var(--dixa-typography-color-link)}._noIssuesFound_1bylq_27{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Hd = { exports: {} }, Ha = {}, Ux;
function cA() {
  if (Ux) return Ha;
  Ux = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Ha.Fragment = r, Ha.jsx = s, Ha.jsxs = s, Ha;
}
var is = {}, Mx;
function uA() {
  return Mx || (Mx = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        P("error", t, m);
      }
    }
    function P(t, c, m) {
      {
        var y = x.ReactDebugCurrentFrame, F = y.getStackAddendum();
        F !== "" && (c += "%s", m = m.concat([F]));
        var T = m.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var E = !1, I = !1, w = !1, A = !1, H = !1, Y;
    Y = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ne(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || H || t === a || t === p || t === d || A || t === v || E || I || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function W(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var F = c.displayName || c.name || "";
      return F !== "" ? m + "(" + F + ")" : m;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function D(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var m = t;
            return B(m._context) + ".Provider";
          case u:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : D(t.type) || "Memo";
          case h: {
            var F = t, T = F._payload, S = F._init;
            try {
              return D(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var M = Object.assign, Z = 0, je, ge, ye, ke, q, _e, De;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function Ye() {
      {
        if (Z === 0) {
          je = console.log, ge = console.info, ye = console.warn, ke = console.error, q = console.group, _e = console.groupCollapsed, De = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function sn() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: M({}, t, {
              value: je
            }),
            info: M({}, t, {
              value: ge
            }),
            warn: M({}, t, {
              value: ye
            }),
            error: M({}, t, {
              value: ke
            }),
            group: M({}, t, {
              value: q
            }),
            groupCollapsed: M({}, t, {
              value: _e
            }),
            groupEnd: M({}, t, {
              value: De
            })
          });
        }
        Z < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = x.ReactCurrentDispatcher, Ue;
    function Pe(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (F) {
            var y = F.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Le;
    {
      var Xe = typeof WeakMap == "function" ? WeakMap : Map;
      Le = new Xe();
    }
    function Fe(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Le.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      Be = !0;
      var F = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ye();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (re) {
              y = re;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (re) {
              y = re;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            y = re;
          }
          t();
        }
      } catch (re) {
        if (re && y && typeof re.stack == "string") {
          for (var _ = re.stack.split(`
`), ee = y.stack.split(`
`), L = _.length - 1, U = ee.length - 1; L >= 1 && U >= 0 && _[L] !== ee[U]; )
            U--;
          for (; L >= 1 && U >= 0; L--, U--)
            if (_[L] !== ee[U]) {
              if (L !== 1 || U !== 1)
                do
                  if (L--, U--, U < 0 || _[L] !== ee[U]) {
                    var ce = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && ce.includes("<anonymous>") && (ce = ce.replace("<anonymous>", t.displayName)), typeof t == "function" && Le.set(t, ce), ce;
                  }
                while (L >= 1 && U >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = F;
      }
      var ze = t ? t.displayName || t.name : "", Oe = ze ? Pe(ze) : "";
      return typeof t == "function" && Le.set(t, Oe), Oe;
    }
    function Me(t, c, m) {
      return Fe(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Fe(t, nn(t));
      if (typeof t == "string")
        return Pe(t);
      switch (t) {
        case p:
          return Pe("Suspense");
        case d:
          return Pe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return Me(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, F = y._payload, T = y._init;
            try {
              return se(T(F), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Se = {}, Ae = x.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(m);
      } else
        Ae.setExtraStackFrame(null);
    }
    function yn(t, c, m, y, F) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + m + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              _ = t[S](c, S, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Re(F), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, S, typeof _), Re(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Re(F), g("Failed %s type: %s", m, _.message), Re(null));
          }
      }
    }
    var Q = Array.isArray;
    function $(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ae(t);
    }
    var J = x.ReactCurrentOwner, de = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, xe, $e;
    function tn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && J.current;
    }
    function pn(t, c) {
      {
        var m = function() {
          xe || (xe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function Fn(t, c) {
      {
        var m = function() {
          $e || ($e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, m, y, F, T, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: F
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, m, y, F) {
      {
        var T, S = {}, _ = null, ee = null;
        m !== void 0 && (V(m), _ = "" + m), gn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ee = c.ref, on(c));
        for (T in c)
          le.call(c, T) && !de.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (T in L)
            S[T] === void 0 && (S[T] = L[T]);
        }
        if (_ || ee) {
          var U = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, U), ee && Fn(S, U);
        }
        return xn(t, _, ee, F, y, J.current, S);
      }
    }
    var en = x.ReactCurrentOwner, vn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        vn.setExtraStackFrame(m);
      } else
        vn.setExtraStackFrame(null);
    }
    var un;
    un = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = D(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Nn = {};
    function Rn(t) {
      {
        var c = jn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function kn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Rn(c);
        if (Nn[m])
          return;
        Nn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + D(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Ve(null);
      }
    }
    function _n(t, c) {
      {
        if (typeof t != "object")
          return;
        if ($(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            dn(y) && kn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var F = N(t);
          if (typeof F == "function" && F !== t.entries)
            for (var T = F.call(t), S; !(S = T.next()).done; )
              dn(S.value) && kn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = D(c);
          yn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !un) {
          un = !0;
          var F = D(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", F || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, m, y, F, T) {
      {
        var S = ne(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = Bn();
          ee ? _ += ee : _ += jn();
          var L;
          t === null ? L = "null" : $(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (D(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var U = En(t, c, m, F, T);
        if (U == null)
          return U;
        if (S) {
          var ce = c.children;
          if (ce !== void 0)
            if (y)
              if ($(ce)) {
                for (var ze = 0; ze < ce.length; ze++)
                  _n(ce[ze], t);
                Object.freeze && Object.freeze(ce);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _n(ce, t);
        }
        if (le.call(c, "key")) {
          var Oe = D(t), re = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), mn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Oe + mn]) {
            var Dn = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Oe, Dn, Oe), Cn[Oe + mn] = !0;
          }
        }
        return t === i ? Ln(U) : An(U), U;
      }
    }
    function Vn(t, c, m) {
      return wn(t, c, m, !0);
    }
    function qn(t, c, m) {
      return wn(t, c, m, !1);
    }
    var zn = qn, Wn = Vn;
    is.Fragment = i, is.jsx = zn, is.jsxs = Wn;
  })()), is;
}
var Bx;
function dA() {
  return Bx || (Bx = 1, process.env.NODE_ENV === "production" ? Hd.exports = cA() : Hd.exports = uA()), Hd.exports;
}
var me = dA();
const Yy = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => Yy(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, mA = "_jiraCode_h30p6_1", pA = "_jiraCodeInline_h30p6_8", Wd = {
  jiraCode: mA,
  jiraCodeInline: pA
}, VC = {
  default: (e, n) => n().every((r) => typeof r == "string") ? n().join(" ") : /* @__PURE__ */ me.jsx(me.Fragment, { children: n() }),
  nodes: {
    doc: (e, n) => /* @__PURE__ */ me.jsx("div", { children: n() }),
    paragraph: (e, n) => /* @__PURE__ */ me.jsx("p", { children: n() }),
    text: (e) => e.text || "",
    hardBreak: () => /* @__PURE__ */ me.jsx("br", {}),
    bulletList: (e, n) => /* @__PURE__ */ me.jsx("ul", { children: n() }),
    orderedList: (e, n) => /* @__PURE__ */ me.jsx("ol", { children: n() }),
    listItem: (e, n) => /* @__PURE__ */ me.jsx("li", { children: n() }),
    codeBlock: (e, n) => /* @__PURE__ */ me.jsx("pre", { children: /* @__PURE__ */ me.jsx("code", { className: Wd.jiraCode, children: n() }) }),
    heading: (e, n) => {
      switch (e.attrs?.level) {
        // Not using headlines above level 3
        case 1:
          return /* @__PURE__ */ me.jsx("h3", { children: n() });
        case 2:
          return /* @__PURE__ */ me.jsx("h4", { children: n() });
        case 3:
          return /* @__PURE__ */ me.jsx("h5", { children: n() });
        case 4:
          return /* @__PURE__ */ me.jsx("h6", { children: n() });
        case 5:
          return /* @__PURE__ */ me.jsx("b", { children: n() });
        case 6:
          return /* @__PURE__ */ me.jsx("b", { children: n() });
        default:
          return /* @__PURE__ */ me.jsx("h4", { children: n() });
      }
    }
  },
  marks: {
    text: {
      em: (e, n) => /* @__PURE__ */ me.jsx("em", { children: n() }),
      strong: (e, n) => /* @__PURE__ */ me.jsx("b", { children: n() }),
      underline: (e, n) => /* @__PURE__ */ me.jsx("u", { children: n() }),
      link: (e, n) => /* @__PURE__ */ me.jsx("a", { href: e.attrs?.href || "", target: "_blank", rel: "noreferrer", children: n() }),
      code: (e, n) => /* @__PURE__ */ me.jsx("code", { className: ut(Wd.jiraCode, Wd.jiraCodeInline), children: n() })
      // Removing color support for now.
      // textColor: (mark, next) => (
      // 	<span style={{ color: mark.attrs?.['color'] }}>{next()}</span>
      // ),
    }
  }
}, al = ({
  iconUrl: e,
  className: n,
  width: r
}) => {
  const [i, a] = ue(!1);
  return !e || i ? /* @__PURE__ */ me.jsx(he, { size: r, name: "question", className: n }) : /* @__PURE__ */ me.jsx(
    "img",
    {
      src: e,
      width: r,
      className: n,
      onError: ({ currentTarget: o }) => {
        o.onerror = null, a(!0);
      }
    }
  );
}, fA = "_collapse_m2gjh_1", hA = "_collapseHeader_m2gjh_10", yA = "_collapseHeaderLink_m2gjh_31", gA = "_collapseHeaderStatus_m2gjh_40", vA = "_collapseHeaderTitle_m2gjh_51", kA = "_collapseContent_m2gjh_59", bA = "_collapseContentHeadline_m2gjh_62", xA = "_collapseContentButtonSpacer_m2gjh_68", _A = "_collapseContentButtonLink_m2gjh_71", SA = "_collapseContentStatusTag_m2gjh_74", NA = "_collapseContentDescription_m2gjh_77", Nr = {
  collapse: fA,
  collapseHeader: hA,
  collapseHeaderLink: yA,
  collapseHeaderStatus: gA,
  collapseHeaderTitle: vA,
  collapseContent: kA,
  collapseContentHeadline: bA,
  collapseContentButtonSpacer: xA,
  collapseContentButtonLink: _A,
  collapseContentStatusTag: SA,
  collapseContentDescription: NA
}, zC = ({
  jiraInstanceUrl: e,
  avatarId: n,
  iconUrl: r
}) => n ? `${e}/rest/api/3/universal_avatar/view/type/issuetype/avatar/${n}?size=medium` : r, jA = ({
  issues: e,
  jiraInstanceUrl: n,
  unlinkIssue: r
}) => {
  const i = e.reduce(
    (u, p) => p?.id ? { ...u, [p.id]: !1 } : u,
    {}
  ), [a, o] = ue(i), { track: s } = In(), l = (u, p) => {
    o({ ...a, [u]: p });
  };
  return /* @__PURE__ */ me.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((u) => {
    const { summary: p, description: d, status: f, issuetype: h } = u?.fields || {}, v = zC({
      avatarId: h?.avatarId,
      iconUrl: h?.iconUrl,
      jiraInstanceUrl: n
    }), C = !!(u?.id && a[u.id]);
    return /* @__PURE__ */ me.jsxs(
      pr,
      {
        onToggle: () => u?.id && l(u.id, !a[u.id]),
        isOpen: C,
        className: Nr.collapse,
        children: [
          /* @__PURE__ */ me.jsx(pr.Header, { className: Nr.collapseHeader, children: /* @__PURE__ */ me.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ me.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                  /* @__PURE__ */ me.jsxs(b, { alignItems: "center", gap: "200", children: [
                    /* @__PURE__ */ me.jsx(al, { width: 16, iconUrl: v }),
                    /* @__PURE__ */ me.jsx(
                      "a",
                      {
                        className: Nr.collapseHeaderLink,
                        href: `${n}/browse/${u?.key}`,
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: (j) => {
                          j.stopPropagation(), u?.key && s("jira:view:issue:clicked", {
                            jiraIssueKey: u.key,
                            jiraInstanceUrl: n
                          });
                        },
                        children: /* @__PURE__ */ me.jsxs(b, { alignItems: "center", gap: "200", children: [
                          u?.key,
                          /* @__PURE__ */ me.jsx(he, { name: "external-link", size: 16 })
                        ] })
                      },
                      u?.key
                    )
                  ] }),
                  /* @__PURE__ */ me.jsx("span", { className: Nr.collapseHeaderStatus, children: f?.name && /* @__PURE__ */ me.jsx(Yn, { className: Nr.collapseContentStatusTag, children: f.name }) })
                ] }),
                /* @__PURE__ */ me.jsx("div", { className: Nr.collapseHeaderTitle, children: p })
              ]
            }
          ) }),
          /* @__PURE__ */ me.jsx(pr.Content, { className: Nr.collapseContent, children: /* @__PURE__ */ me.jsxs(b, { flexDirection: "column", gap: "250", margin: "0 0 200 0", children: [
            /* @__PURE__ */ me.jsx("div", { className: Nr.collapseContentHeadline, children: "Description" }),
            /* @__PURE__ */ me.jsx(lt, { className: Nr.collapseContentDescription, children: d ? Yy(d, VC) : "" }),
            /* @__PURE__ */ me.jsx(
              et,
              {
                icon: "link-slash",
                variant: "secondary",
                className: Nr.collapseContentButtonSpacer,
                onClick: () => u?.key && r(u.key),
                children: "Unlink issue from Jira"
              }
            ),
            /* @__PURE__ */ me.jsx(
              At,
              {
                slotEnd: /* @__PURE__ */ me.jsx(he, { name: "external-link" }),
                variant: "tertiary",
                className: Nr.collapseContentButtonLink,
                navigate: () => {
                  u?.key && (s("jira:view:issue:clicked", {
                    jiraIssueKey: u.key,
                    jiraInstanceUrl: n
                  }), window.open(
                    `${n}/browse/${u.key}`,
                    "_blank"
                  )?.focus());
                },
                children: "View issue in Jira"
              }
            )
          ] }) })
        ]
      },
      u?.id
    );
  }) : /* @__PURE__ */ me.jsx(me.Fragment, {}) });
}, wA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "title" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "url" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createOrUpdateRemoteIssueLink" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "application" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "name" }, value: { kind: "StringValue", value: "Dixa Conversations", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "StringValue", value: "com.dixa.conversations", block: !1 } }] } }, { kind: "ObjectField", name: { kind: "Name", value: "relationship" }, value: { kind: "StringValue", value: "dixa-backlink", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "object" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "title" } } }, { kind: "ObjectField", name: { kind: "Name", value: "url" }, value: { kind: "Variable", name: { kind: "Name", value: "url" } } }, { kind: "ObjectField", name: { kind: "Name", value: "icon" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "url16x16" }, value: { kind: "StringValue", value: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "StringValue", value: "Dixa", block: !1 } }] } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }] } }] } }] } }] }, CA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removeBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "deleteRemoteIssueLinkByGlobalId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }] }] } }] } }] }, IA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Jira_IssueUpdateDetails_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_CreatedIssue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_ErrorCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorMessages" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "errors" } }] } }] } }] } }] } }] }, FA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAllProjects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, EA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCreateIssueMeta" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectKey" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCreateIssueMeta" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "projectKeys" }, value: { kind: "ListValue", values: [{ kind: "Variable", name: { kind: "Name", value: "projectKey" } }] } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "StringValue", value: "projects.issuetypes.fields", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "issuetypes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "iconUrl" } }, { kind: "Field", name: { kind: "Name", value: "entityId" } }, { kind: "Field", name: { kind: "Name", value: "hierarchyLevel" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "scope" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalProperties" } }] } }, { kind: "Field", name: { kind: "Name", value: "expand" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "required" } }, { kind: "Field", name: { kind: "Name", value: "hasDefaultValue" } }, { kind: "Field", name: { kind: "Name", value: "schema" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "system" } }, { kind: "Field", name: { kind: "Name", value: "items" } }, { kind: "Field", name: { kind: "Name", value: "custom" } }, { kind: "Field", name: { kind: "Name", value: "customId" } }] } }, { kind: "Field", name: { kind: "Name", value: "allowedValues" } }, { kind: "Field", name: { kind: "Name", value: "defaultValue" } }, { kind: "Field", name: { kind: "Name", value: "operations" } }, { kind: "Field", name: { kind: "Name", value: "autoCompleteUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, $A = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "jql" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "jql" }, value: { kind: "Variable", name: { kind: "Name", value: "jql" } } }, { kind: "Argument", name: { kind: "Name", value: "maxResults" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "ListValue", values: [{ kind: "StringValue", value: "summary", block: !1 }, { kind: "StringValue", value: "description", block: !1 }, { kind: "StringValue", value: "status", block: !1 }, { kind: "StringValue", value: "updated", block: !1 }, { kind: "StringValue", value: "issuetype", block: !1 }, { kind: "StringValue", value: "project", block: !1 }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "fields" } }] } }] } }] } }] } }] }, TA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "findUsers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findUsers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountId" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "self" } }, { kind: "Field", name: { kind: "Name", value: "active" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, OA = {
  '\n  mutation createBacklink(\n    $issueKey: String!\n    $title: String!\n    $url: String!\n    $globalId: String!\n  ) {\n    Jira {\n      createOrUpdateRemoteIssueLink(\n        issueIdOrKey: $issueKey\n        input: {\n          globalId: $globalId\n          application: {\n            name: "Dixa Conversations"\n            type: "com.dixa.conversations"\n          }\n          relationship: "dixa-backlink"\n          object: {\n            title: $title\n            url: $url\n            icon: {\n              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"\n              title: "Dixa"\n            }\n          }\n        }\n      ) {\n        __typename\n      }\n    }\n  }\n': wA,
  "\n  mutation removeBacklink($issueKey: String!, $globalId: String!) {\n    Jira {\n      deleteRemoteIssueLinkByGlobalId(\n        issueIdOrKey: $issueKey\n        globalId: $globalId\n      )\n    }\n  }\n": CA,
  "\n  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {\n    Jira {\n      createIssue(input: $input) {\n        ... on Jira_CreatedIssue {\n          id\n          key\n        }\n        ... on Jira_ErrorCollection {\n          errorMessages\n          status\n          errors\n        }\n      }\n    }\n  }\n": IA,
  "\n  query jira {\n    Jira {\n      getAllProjects {\n        id\n        key\n        name\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": FA,
  '\n  query getCreateIssueMeta($projectKey: String) {\n    Jira {\n      getCreateIssueMeta(\n        projectKeys: [$projectKey]\n        expand: "projects.issuetypes.fields"\n      ) {\n        projects {\n          id\n          key\n          name\n          issuetypes {\n            id\n            name\n            iconUrl\n            entityId\n            hierarchyLevel\n            subtask\n            scope {\n              type\n              project {\n                id\n                key\n                name\n              }\n              additionalProperties\n            }\n            expand\n            subtask\n            description\n            fields {\n              additionalProperties {\n                key\n                value {\n                  key\n                  name\n                  required\n                  hasDefaultValue\n                  schema {\n                    type\n                    system\n                    items\n                    custom\n                    customId\n                  }\n                  allowedValues\n                  defaultValue\n                  operations\n                  autoCompleteUrl\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n': EA,
  '\n  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {\n    Jira {\n      searchAndReconsileIssuesUsingJql(\n        jql: $jql\n        maxResults: $maxResults\n        fields: [\n          "summary"\n          "description"\n          "status"\n          "updated"\n          "issuetype"\n          "project"\n        ]\n      ) {\n        issues {\n          id\n          key\n          fields\n        }\n      }\n    }\n  }\n': $A,
  "\n  query findUsers($query: String) {\n    Jira {\n      findUsers(query: $query) {\n        accountId\n        displayName\n        self\n        active\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": TA
};
function Ui(e) {
  return OA[e] ?? {};
}
const UC = Ui(
  /* GraphQL */
  `
  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {
    Jira {
      searchAndReconsileIssuesUsingJql(
        jql: $jql
        maxResults: $maxResults
        fields: [
          "summary"
          "description"
          "status"
          "updated"
          "issuetype"
          "project"
        ]
      ) {
        issues {
          id
          key
          fields
        }
      }
    }
  }
`
), DA = Ui(
  /* GraphQL */
  `
  mutation createBacklink(
    $issueKey: String!
    $title: String!
    $url: String!
    $globalId: String!
  ) {
    Jira {
      createOrUpdateRemoteIssueLink(
        issueIdOrKey: $issueKey
        input: {
          globalId: $globalId
          application: {
            name: "Dixa Conversations"
            type: "com.dixa.conversations"
          }
          relationship: "dixa-backlink"
          object: {
            title: $title
            url: $url
            icon: {
              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"
              title: "Dixa"
            }
          }
        }
      ) {
        __typename
      }
    }
  }
`
), PA = Ui(
  /* GraphQL */
  `
  mutation removeBacklink($issueKey: String!, $globalId: String!) {
    Jira {
      deleteRemoteIssueLinkByGlobalId(
        issueIdOrKey: $issueKey
        globalId: $globalId
      )
    }
  }
`
), RA = Ui(
  /* GraphQL */
  `
  query jira {
    Jira {
      getAllProjects {
        id
        key
        name
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), AA = Ui(
  /* GraphQL */
  `
  query getCreateIssueMeta($projectKey: String) {
    Jira {
      getCreateIssueMeta(
        projectKeys: [$projectKey]
        expand: "projects.issuetypes.fields"
      ) {
        projects {
          id
          key
          name
          issuetypes {
            id
            name
            iconUrl
            entityId
            hierarchyLevel
            subtask
            scope {
              type
              project {
                id
                key
                name
              }
              additionalProperties
            }
            expand
            subtask
            description
            fields {
              additionalProperties {
                key
                value {
                  key
                  name
                  required
                  hasDefaultValue
                  schema {
                    type
                    system
                    items
                    custom
                    customId
                  }
                  allowedValues
                  defaultValue
                  operations
                  autoCompleteUrl
                }
              }
            }
          }
        }
      }
    }
  }
`
), LA = Ui(
  /* GraphQL */
  `
  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {
    Jira {
      createIssue(input: $input) {
        ... on Jira_CreatedIssue {
          id
          key
        }
        ... on Jira_ErrorCollection {
          errorMessages
          status
          errors
        }
      }
    }
  }
`
), VA = Ui(
  /* GraphQL */
  `
  query findUsers($query: String) {
    Jira {
      findUsers(query: $query) {
        accountId
        displayName
        self
        active
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), Jy = new RegExp("[a-zA-Z0-9_]{2,}-[0-9]+"), zA = new RegExp(`^${Jy.source}$`), UA = new RegExp(`/${Jy.source}$`), qx = new RegExp(
  `.+?[&?]selectedIssue=(${Jy.source})[&?]?.*`
);
function MC(e, n) {
  const r = { jira: { issues: [] } }, [i, a] = ue([]), [o, s] = ue([]), [l, u] = ue(), { track: p } = In(), { showNotification: d, showModal: f, useLazyQuery: h, useMutation: v } = bn(), {
    loading: C,
    data: j,
    error: N,
    store: x
  } = ly(e ?? null), [
    g,
    { loading: P, error: E, data: I }
  ] = h(UC, {
    notifyOnNetworkStatusChange: !0
  });
  Je(() => {
    const ye = I?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    ye?.length && (s(ye), a(ye.map((ke) => ke?.key).filter(Boolean)));
  }, [I]), Je(
    () => u(N || E || void 0),
    [N, E]
  ), Je(
    () => {
      C || B();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [j?.jira?.issues, C]
  );
  const w = async (ye, ke) => {
    await x(ye).then(() => {
      d({
        icon: "check-circle-filled",
        severity: "success",
        title: ke.success.title,
        text: ke.success.text
      });
    }).catch((q) => {
      d({
        title: ke.error.title,
        text: `${ke.error.text} ${q.message && " (" + q.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, [A] = v(DA, {
    onError: (ye) => {
      d({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to create a link back from the issue to the conversation. Please create it manually in Jira.
				${ye.message && " (" + ye.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), H = (ye, ke) => {
    const q = window.location.href, _e = ke ? q.replace(
      e?.toString() ?? "",
      ke?.toString()
    ) : q, De = ke ? `# ${ke}` : `# ${e}`;
    A({
      variables: {
        issueKey: ye,
        title: De,
        url: _e,
        globalId: `system=${_e}`
      }
    });
  }, [Y] = v(PA, {
    onError: (ye) => {
      d({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to remove a link back from the issue to the conversation. Please remove it manually from Jira.
					${ye.message && " (" + ye.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), ne = (ye) => {
    const ke = window.location.href;
    Y({
      variables: {
        issueKey: ye,
        globalId: `system=${ke}`
      }
    });
  }, W = (ye) => ({
    jiraInstanceUrl: n,
    jiraIssueKey: ye
  }), B = () => {
    j && j.jira?.issues?.length > 0 ? g({
      variables: {
        jql: `key in (${j?.jira?.issues.join(",")})`,
        maxResults: 15
      }
    }) : s([]);
  }, D = async (ye, ke) => {
    p("jira:issue:link:clicked", W(ye));
    const q = j?.jira?.issues ? j : r;
    q.jira.issues = Array.from(
      new Set(q.jira.issues).add(ye)
    ), await x(q, ke?.toString()).then(() => H(ye, ke)).catch((_e) => {
      d({
        title: "Linking failed",
        text: `Linking ${ye} failed. Please try again. ${_e.message && " (" + _e.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, M = (ye) => {
    p("jira:issue:link:clicked", W(ye));
    const ke = j?.jira?.issues ? j : r;
    ke.jira.issues = Array.from(
      new Set(ke.jira.issues).add(ye)
    ), w(ke, {
      success: {
        title: "Jira issue linked",
        text: `You linked the Jira issue ${ye} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${ye} failed. Please try again.`
      }
    }).then(() => H(ye));
  }, Z = (ye) => {
    p("jira:issue:unlink:clicked", W(ye)), f({
      headline: `Unlink issue ${ye}?`,
      text: `You are about to unlink the issue ${ye}. Do you want to proceed?`,
      confirmLabel: "Unlink Jira issue",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        p("jira:issue:unlink:confirmed", W(ye));
        const ke = {
          ...j,
          jira: {
            ...j?.jira,
            issues: j?.jira?.issues.filter((q) => q !== ye) || []
          }
        };
        w(ke, {
          success: {
            title: "Jira issue unlinked",
            text: `You unlinked the Jira issue ${ye}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${ye} failed.`
          }
        }).then(() => ne(ye));
      },
      onCancel: () => p("jira:issue:unlink:cancelled", W(ye))
    });
  }, je = () => {
    p("jira:issue:unlink-all:clicked", { jiraInstanceUrl: n }), f({
      headline: "Unlink all Jira issues?",
      text: "You are about to unlink the all Jira issues from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        p("jira:issue:unlink-all:confirmed", { jiraInstanceUrl: n }), o?.forEach((ye) => ye?.key && ne(ye.key)), w(r, {
          success: {
            title: "Unlinking successful",
            text: "All Jira issues were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues failed."
          }
        });
      },
      onCancel: () => p("jira:issue:unlink-all:cancelled", { jiraInstanceUrl: n })
    });
  }, ge = j?.jira?.issues?.filter(
    (ye) => !i?.includes(ye)
  ) || [];
  return {
    linkIssue: M,
    linkIssueQuietly: D,
    unlinkIssue: Z,
    loadIssues: B,
    removeDanglingIssueLinks: () => {
      p("jira:issue:unlink-all-dangling:clicked", {
        jiraInstanceUrl: n
      });
      const ye = {
        ...j,
        jira: {
          ...j?.jira,
          issues: j?.jira?.issues.filter(
            (ke) => !ge.includes(ke)
          ) || []
        }
      };
      x(ye);
    },
    unlinkAllIssues: je,
    maybeExtractIssueKey: (ye) => {
      const ke = ye.replace(/\s/g, "");
      if (zA.test(ke))
        return ke;
      if (qx.test(ye))
        return ye.match(qx)?.[1];
      if (ye.startsWith(n) && UA.test(ye))
        return ye.substring(ye.lastIndexOf("/") + 1);
    },
    isLoadingIssueLinks: C,
    danglingIssueLinks: ge,
    isLoadingIssues: P,
    issues: o,
    error: l
  };
}
function MA(e = !1, n) {
  const [r, i] = ue(e);
  return Je(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copyToClipboard: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const BA = "_result_1wiub_54", qA = "_resultName_1wiub_74", HA = "_resultNameIcon_1wiub_82", WA = "_resultDescription_1wiub_87", KA = "_resultLinkIcon_1wiub_99", GA = "_tooltip_1wiub_108", YA = "_tooltipContent_1wiub_114", JA = "_tooltipName_1wiub_121", QA = "_tooltipNameIcon_1wiub_126", XA = "_tooltipDescription_1wiub_131", ZA = "_tooltipSummary_1wiub_139", e2 = "_tooltipTag_1wiub_143", cr = {
  result: BA,
  resultName: qA,
  resultNameIcon: HA,
  resultDescription: WA,
  resultLinkIcon: KA,
  tooltip: GA,
  tooltipContent: YA,
  tooltipName: JA,
  tooltipNameIcon: QA,
  tooltipDescription: XA,
  tooltipSummary: ZA,
  tooltipTag: e2
}, n2 = ({
  item: e,
  jiraInstanceUrl: n,
  onSelect: r,
  disableTooltip: i = !1,
  ...a
}) => {
  const { issuetype: o, name: s, status: l, text: u, description: p } = e, [d, f] = ue(!1), h = zC({
    avatarId: o?.avatarId,
    iconUrl: o?.iconUrl,
    jiraInstanceUrl: n
  });
  return /* @__PURE__ */ me.jsx(
    Ze,
    {
      disabled: i,
      className: cr.tooltip,
      content: /* @__PURE__ */ me.jsxs("div", { className: cr.tooltipContent, children: [
        /* @__PURE__ */ me.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            children: [
              /* @__PURE__ */ me.jsxs("span", { className: cr.tooltipName, children: [
                /* @__PURE__ */ me.jsx(
                  al,
                  {
                    width: 16,
                    iconUrl: h,
                    className: cr.tooltipNameIcon
                  }
                ),
                " ",
                s
              ] }),
              /* @__PURE__ */ me.jsx(Yn, { className: cr.tooltipTag, children: l.name })
            ]
          }
        ),
        p && /* @__PURE__ */ me.jsx("div", { className: cr.tooltipSummary, children: p }),
        u && /* @__PURE__ */ me.jsx("div", { className: cr.tooltipDescription, children: u })
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ me.jsxs(
        "button",
        {
          ...a,
          className: cr.result,
          type: "button",
          onClick: () => {
            r(e);
          },
          onMouseEnter: () => f(!0),
          onMouseLeave: () => f(!1),
          children: [
            /* @__PURE__ */ me.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                style: {
                  width: d ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ me.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ me.jsxs("span", { className: cr.resultName, children: [
                    /* @__PURE__ */ me.jsx(
                      al,
                      {
                        width: 16,
                        iconUrl: h,
                        className: cr.resultNameIcon
                      }
                    ),
                    " ",
                    s
                  ] }) }),
                  p && /* @__PURE__ */ me.jsx("div", { className: cr.resultDescription, children: p })
                ]
              }
            ),
            d && /* @__PURE__ */ me.jsx(
              he,
              {
                className: cr.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, t2 = ({
  className: e,
  searched: n,
  jiraInstanceUrl: r
}) => /* @__PURE__ */ me.jsx(
  At,
  {
    slotEnd: /* @__PURE__ */ me.jsx(he, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `${r}/secure/QuickSearch.jspa?searchString=${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching issues in Jira"
  }
), r2 = ({
  onSelectIssue: e,
  jiraInstanceUrl: n,
  filterByProjectKey: r,
  disableTooltip: i
}) => {
  const { useLazyQuery: a } = bn(), [o, s] = ue([]), [l, u] = ue(""), [p, { loading: d, error: f, data: h, networkStatus: v }] = a(UC, {
    notifyOnNetworkStatusChange: !0
  }), { maybeExtractIssueKey: C } = MC(null, n);
  zi(
    () => {
      !d && l && v === rr.ready ? p({
        variables: {
          jql: l,
          maxResults: 25
        }
      }) : s([]);
    },
    500,
    [l]
  ), Je(() => {
    const E = h?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    s(
      E.map((I) => ({
        id: I?.key ?? "",
        name: I?.key ?? "",
        description: I?.fields.summary,
        status: I?.fields.status,
        issuetype: I?.fields.issuetype,
        text: I?.fields.description ? Yy(I?.fields.description, VC) : /* @__PURE__ */ me.jsx(me.Fragment, {})
      }))
    );
  }, [h]);
  const j = (E) => {
    e(E.id), u("");
  }, N = (E) => {
    const I = E.trim(), w = C(I);
    if (w) {
      const A = w.replaceAll("[-_|]", "\\\\$0");
      u(`key = '${A}'`);
    } else I !== "" && u(
      `text ~ '${I}'${r ? " and project = " + r : ""}`
    );
  }, x = () => {
    u("");
  }, g = (E) => /* @__PURE__ */ me.jsx(t2, { ...E, jiraInstanceUrl: n }), P = (E) => /* @__PURE__ */ me.jsx(
    n2,
    {
      ...E,
      jiraInstanceUrl: n,
      disableTooltip: i
    }
  );
  return !d && f ? /* @__PURE__ */ me.jsx(Tn, { error: f }) : /* @__PURE__ */ me.jsx(
    Er,
    {
      items: o,
      loading: d,
      onSearch: N,
      onSelect: j,
      onClear: x,
      emptyMessage: l ? d ? "" : "No Jira Issues found" : "Enter Jira issue key, link or search terms",
      suggestionComponent: g,
      itemComponent: P,
      placeholder: "Search and link existing issue",
      searchable: !0,
      clearable: !0
    }
  );
}, i2 = ({
  field: e,
  value: n,
  onChange: r
}) => {
  const [i, a] = ue(n ? [n] : []), o = (s, l) => {
    a(
      l ? [...i, s] : i.filter(({ id: u }) => u !== s.id)
    );
  };
  return Je(() => {
    r(i);
  }, [i]), /* @__PURE__ */ me.jsx(
    Er,
    {
      multiple: !0,
      onChange: o,
      selectedItems: i,
      items: e?.allowedValues?.map(
        ({ id: s, name: l, value: u }) => ({
          id: s,
          name: l || u
        })
      )
    }
  );
}, a2 = "_itemButton_1hl53_1", o2 = "_result_1hl53_6", s2 = "_resultIcon_1hl53_26", l2 = "_resultName_1hl53_30", c2 = "_resultCheckIcon_1hl53_38", Wa = {
  itemButton: a2,
  result: o2,
  resultIcon: s2,
  resultName: l2,
  resultCheckIcon: c2
}, Fh = ({
  item: e,
  checked: n = !1,
  onSelectItem: r,
  jiraInstanceUrl: i
}) => {
  const a = (s) => {
    const l = s.indexOf("/rest/api/");
    return l >= 0 ? `${i}${s?.substring(l)}` : s;
  };
  let o = e?.iconUrl || e?.avatarUrls?._24x24 || null;
  return o && (o = o?.startsWith("https://api.atlassian.com/ex/") ? a(o) : o), /* @__PURE__ */ me.jsx(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      width: "100%",
      "data-testid": "jira-select-item-component",
      children: /* @__PURE__ */ me.jsx(
        "button",
        {
          onClick: () => {
            r(e);
          },
          className: Wa.itemButton,
          children: /* @__PURE__ */ me.jsxs(b, { className: Wa.result, flexDirection: "row", width: "100%", children: [
            /* @__PURE__ */ me.jsx(
              al,
              {
                width: 36,
                iconUrl: o || "",
                className: Wa.resultIcon
              }
            ),
            /* @__PURE__ */ me.jsx(lt, { className: Wa.resultName, children: e.name }),
            n && /* @__PURE__ */ me.jsx(lt, { className: Wa.resultCheckIcon, children: /* @__PURE__ */ me.jsx(he, { name: "done" }) })
          ] })
        }
      )
    }
  );
}, u2 = ({
  selectedItems: e,
  agentEmail: n,
  onSelect: r,
  jiraInstanceUrl: i
}) => {
  const { useLazyQuery: a } = bn(), [o, s] = ue([]), [l, u] = ue(), p = 2, [d, { loading: f, error: h, data: v, networkStatus: C }] = a(VA, {
    notifyOnNetworkStatusChange: !0
  });
  return zi(
    () => {
      !f && l && l.length >= p && C === rr.ready ? d({
        variables: {
          query: l,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), Je(() => {
    n && d({
      variables: {
        query: n,
        maxResults: 1
      }
    }).then((j) => {
      if (j?.data?.Jira.findUsers?.length === 1) {
        const N = j?.data?.Jira?.findUsers[0];
        r(N.accountId), s([
          {
            id: N.accountId,
            name: N.displayName
          }
        ]);
      }
    });
  }, []), Je(() => {
    const j = v?.Jira?.findUsers || [];
    s(
      j.filter(({ active: N }) => N).map(({ accountId: N, displayName: x, avatarUrls: g, active: P }) => ({
        id: N,
        name: x,
        avatarUrls: g,
        active: P
      }))
    );
  }, [v]), !f && h ? /* @__PURE__ */ me.jsx(Tn, { error: h }) : /* @__PURE__ */ me.jsx(
    Er,
    {
      clearable: !0,
      searchable: !0,
      items: o,
      loading: f,
      onSearch: (j) => u(j),
      onSelect: r,
      onClear: () => u(void 0),
      selectedItems: e,
      emptyMessage: l ? f ? "" : "No user found" : "Enter keyword to search for user",
      itemComponent: ({ item: j, onSelect: N, checked: x }) => /* @__PURE__ */ me.jsx(
        Fh,
        {
          item: j,
          checked: x,
          onSelectItem: N,
          jiraInstanceUrl: i
        }
      ),
      placeholder: "Search Jira users"
    }
  );
}, Hx = ({
  field: e
}) => {
  const [n, r] = ue(!1), [i, a] = OC();
  return Je(() => {
    const o = n ? window.setTimeout(() => r(!1), 2e3) : void 0;
    return () => window.clearTimeout(o);
  }, [n]), /* @__PURE__ */ me.jsxs(b, { alignItems: "center", gap: "400", justifyContent: "space-between", children: [
    /* @__PURE__ */ me.jsx(b, { children: /* @__PURE__ */ me.jsx(he, { size: 24, name: "exclamation-triangle-filled", color: "red.500" }) }),
    /* @__PURE__ */ me.jsx(O.Paragraph, { children: "Your organizations Jira configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field. Please, attach a copy of the field details when contacting us. You can use the copy button to do so." }),
    /* @__PURE__ */ me.jsx(Ze, { content: n ? "Copied" : "Copy field details", children: /* @__PURE__ */ me.jsx(
      ir,
      {
        variant: "secondary",
        icon: n ? "done" : "copy",
        onClick: () => {
          a(JSON.stringify(e, null, 2)), r(!0);
        }
      }
    ) })
  ] });
}, d2 = ({
  field: e,
  onChange: n,
  value: r,
  conversationContext: i,
  jiraInstanceUrl: a
}) => {
  const { type: o, system: s } = e.schema;
  if (["array", "option", "priority"].includes(o) && (!e?.allowedValues || e.allowedValues.length === 0))
    return /* @__PURE__ */ me.jsx(Hx, { field: e });
  switch (o) {
    case "issuelink":
    case "environment":
    case "any":
      return /* @__PURE__ */ me.jsx(mr, { onChange: n, value: r });
    case "string":
      return s === "description" ? /* @__PURE__ */ me.jsx(vh, { onChange: n, value: r }) : /* @__PURE__ */ me.jsx(mr, { onChange: n, value: r });
    case "textarea":
      return /* @__PURE__ */ me.jsx(vh, { onChange: n, value: r });
    case "number":
      return /* @__PURE__ */ me.jsx(mr, { type: "number", onChange: n, value: r });
    case "user":
      return /* @__PURE__ */ me.jsx(
        u2,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          agentEmail: e.key === "reporter" && i?.agent?.email || void 0,
          jiraInstanceUrl: a
        }
      );
    case "option":
    case "priority":
      return /* @__PURE__ */ me.jsx(
        Er,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          items: e?.allowedValues?.map(
            ({ id: l, name: u, value: p }) => ({
              id: l,
              name: u || p
            })
          ) || []
        }
      );
    case "array":
      return /* @__PURE__ */ me.jsx(i2, { field: e, value: r, onChange: n });
    default:
      return /* @__PURE__ */ me.jsx(Hx, { field: e });
  }
}, m2 = ["description", "reporter", "summary"], p2 = ({
  issueTypeFields: e,
  control: n,
  jiraInstanceUrl: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ me.jsx(me.Fragment, { children: e.filter(({ key: o }) => o !== "project" && o !== "issuetype").filter(
  ({ key: o, required: s }) => s || m2.includes(o)
).map((o) => /* @__PURE__ */ me.jsx(
  xt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ me.jsx(
      We,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: d2({
          field: o,
          onChange: s,
          value: l,
          conversationContext: i,
          jiraInstanceUrl: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), f2 = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => /* @__PURE__ */ me.jsxs(
  b,
  {
    flexDirection: "column",
    gap: "400",
    "data-testid": "jira-create-issue-success-message",
    children: [
      /* @__PURE__ */ me.jsxs(O.Paragraph, { children: [
        "You can visit your new issue by following",
        " ",
        /* @__PURE__ */ me.jsxs(
          O.ExternalLink,
          {
            href: `${n}/${e.key}`,
            target: "_blank",
            children: [
              "this link ",
              /* @__PURE__ */ me.jsx(he, { name: "external-link" })
            ]
          }
        ),
        " ",
        "or copy it from the field below."
      ] }),
      /* @__PURE__ */ me.jsx(We, { label: "Jira issue link", children: /* @__PURE__ */ me.jsx(
        mr,
        {
          readOnly: !0,
          value: `${n}/${e.key}`,
          suffix: {
            type: "button",
            button: {
              icon: r ? "done" : "copy",
              onClick: () => {
                i(!0), a(`${n}/${e.key}`);
              }
            }
          }
        }
      ) })
    ]
  }
), h2 = "_modalBody_1hk1o_1", y2 = "_modalBodyFormFields_1hk1o_4", Wx = {
  modalBody: h2,
  modalBodyFormFields: y2
}, g2 = (e) => ({
  version: 1,
  type: "doc",
  content: e?.trim()?.split(`
`).filter((n) => n !== "").map((n) => ({
    type: "paragraph",
    content: [
      {
        type: "text",
        text: n
      }
    ]
  }))
}), v2 = (e) => e?.custom?.split(":")?.[1] || null, k2 = (e, n) => {
  if (e.startsWith("customfield_")) {
    const r = n.find((i) => i.key === e)?.schema;
    if (r)
      return r;
  }
  return null;
}, b2 = (e, n) => {
  const r = ["environment", "textarea", "description"];
  return {
    fields: {
      ...Object.entries(e).reduce((i, [a, o]) => {
        if (!o || o === "")
          return delete e[a], i;
        const s = k2(a, n), l = v2(s) ?? a;
        return r.includes(l) ? i[a] = g2(o) : s?.type === "number" ? i[a] = parseInt(o) : i[a] = o, i;
      }, {}),
      summary: e.summary,
      project: { id: e.project.id },
      issuetype: { id: e.issuetype.id },
      ...e?.parent && { parent: { key: e.parent } },
      ...e?.reporter && {
        reporter: { id: e.reporter?.id ?? e.reporter }
      },
      ...e?.assignee && {
        assignee: { id: e.assignee?.id ?? e.assignee }
      }
    }
  };
}, x2 = ({
  isOpen: e,
  onClose: n,
  linkIssueQuietly: r,
  conversationContext: i,
  jiraInstanceUrl: a,
  hasSortIssueTypeByLabelEnabled: o
}) => {
  const s = { project: void 0, issuetype: void 0 }, [l, u] = ue([]), [p, d] = ue(), [f, h] = ue(0), [v, C] = ue([]), [j, N] = ue([]), [x, g] = ue(!1), [P, E] = ue(!1), [I, w] = ue({}), { track: A } = In(), { isCopied: H, copyToClipboard: Y } = MA(), ne = Xn(() => i?.conversationId, [e]), { useMutation: W, useLazyQuery: B, showNotification: D } = bn(), {
    control: M,
    handleSubmit: Z,
    formState: { errors: je },
    reset: ge,
    setValue: ye,
    getValues: ke
  } = dt({
    defaultValues: s
  }), q = j.length > 0, _e = `${a}/browse`, De = Object.keys(I).length > 0, [G, { loading: Ye, error: sn }] = B(RA, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (le) => {
      u(le.Jira.getAllProjects);
    },
    onError: (le) => {
      D({
        title: "Could not get project list",
        text: "We could not fetch the list of your projects. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error response when fetching projects", le), u([]);
    }
  }), [
    Ie,
    { loading: Ue, error: Pe }
  ] = B(AA, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (le) => {
      h(0);
      const Se = le?.Jira?.getCreateIssueMeta?.projects[0];
      if (Se) {
        const Ae = Se?.issuetypes.filter(
          ({ subtask: Re }) => !Re
        );
        C(Ae || []), ye(
          "issuetype",
          Ae.length > 0 ? Ae[0] : void 0
        );
      } else
        D({
          title: "Could not get issue-type list",
          text: "It seems that there are no issue-types for this project or you might not have the necessary access rights to view them.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), C([]), N([]);
    },
    onError: (le) => {
      D({
        title: "Could not get issue list",
        text: "We could not fetch the list of issue-types for this project. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error in getCreateIssueMeta", le), C([]), N([]), h(0);
    }
  }), [Be, { error: Le }] = W(
    LA,
    {
      onError: () => {
        g(!1), D({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), A("jira:issue:create:failed", { jiraInstanceUrl: a });
      },
      onCompleted: (le) => {
        if (g(!1), le?.Jira && "key" in le.Jira.createIssue)
          d(le?.Jira?.createIssue), D({
            title: "Success",
            text: `Jira issue '${le.Jira.createIssue.key}' created`,
            icon: "check-circle-filled",
            severity: "success"
          }), A("jira:issue:create:succeeded", {
            jiraInstanceUrl: a,
            jiraIssueKey: le.Jira.createIssue.key
          }), ne && r(
            le.Jira.createIssue.key,
            ne
          );
        else if ("errorMessages" in le.Jira.createIssue || "errors" in le.Jira.createIssue) {
          const Se = le?.Jira?.createIssue?.errors;
          console.warn("There was a problem creating a Jira issue.", Se), D({
            title: "Creation was not successful",
            text: "Something went wrong. Please get in contact with Dixa.",
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
        }
      }
    }
  ), Xe = (le) => {
    g(!0), w({}), Be({
      variables: {
        input: b2(le, j)
      }
    });
  };
  Je(() => {
    if (e)
      try {
        G();
      } catch (le) {
        console.warn("Error when fetching initial projects", le);
      }
  }, [e]), Je(() => {
    const le = P ? window.setTimeout(() => E(!1), 2e3) : void 0;
    return () => window.clearTimeout(le);
  }, [P]), Je(() => {
    if (v?.length > 0) {
      ye("issuetype", v[f]);
      const le = v[f]?.fields?.additionalProperties;
      if (le?.length > 0) {
        const Se = le.map(
          ({ value: Q }) => Q
        ), Ae = (o ? Se.sort(({ name: Q }, { name: $ }) => Q.localeCompare($)) : Se).sort(
          ({ required: Q }, { required: $ }) => Number($) - Number(Q)
        ), { project: Re, issuetype: yn } = ke();
        ge({ project: Re, issuetype: yn }), N(Ae);
      }
    } else
      N([]), ye("issuetype", void 0);
  }, [v, ye, f]), Je(() => {
    if (Le && hw(Le)) {
      if (Le?.graphQLErrors?.length > 0) {
        const { graphQLErrors: le } = Le, Se = le[0].extensions?.integration?.responseBody;
        try {
          const Ae = JSON.parse(Se);
          if (Ae?.errors) {
            const Re = Object.keys(Ae.errors).reduce(
              (yn, Q) => ({
                ...yn,
                [Q]: {
                  type: "required",
                  message: Ae.errors[Q],
                  ref: {
                    name: Q
                  }
                }
              }),
              {}
            );
            w(Re);
          }
        } catch {
        }
      }
    } else
      w({});
  }, [Le]);
  const Fe = () => {
    u([]), N([]), C([]), d(void 0), h(0), g(!1), w({});
  }, Me = () => {
    Fe(), ge(s), n();
  }, nn = (le) => {
    le && Ie({
      variables: {
        projectKey: le
      }
    });
  }, se = (le) => {
    const Se = v.map((Ae) => Ae.id).indexOf(le);
    h(Se ?? 0);
  };
  return /* @__PURE__ */ me.jsxs(
    Ct,
    {
      isOpen: e,
      "data-testid": "jira-create-issue-modal",
      onClose: Me,
      children: [
        /* @__PURE__ */ me.jsx(
          It,
          {
            title: p ? "Issue creation successful" : "Create new Jira issue",
            onClose: Me
          }
        ),
        /* @__PURE__ */ me.jsxs(Ft, { className: Wx.modalBody, children: [
          !Ye && sn && /* @__PURE__ */ me.jsx(Tn, { error: sn, retry: G }),
          !Ue && Pe && /* @__PURE__ */ me.jsx(
            Tn,
            {
              error: Pe,
              retry: Ie
            }
          ),
          !x && De && /* @__PURE__ */ me.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ me.jsx(
            bl,
            {
              variant: "warning",
              description: /* @__PURE__ */ me.jsxs(
                b,
                {
                  gap: "300",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  children: [
                    /* @__PURE__ */ me.jsx(O.Paragraph, { variant: "4", children: "The form contains input validation errors. Please correct them and try again to save. If your inputs seem fine, please contact our support team and provide the form schema to debug further." }),
                    /* @__PURE__ */ me.jsx(
                      et,
                      {
                        icon: H ? "done" : "copy",
                        variant: "secondary",
                        onClick: () => Y(JSON.stringify(j, null, 2)),
                        children: "Copy form schema"
                      }
                    )
                  ]
                }
              )
            }
          ) }),
          p ? /* @__PURE__ */ me.jsx(
            f2,
            {
              createdIssue: p,
              issueBaseLink: _e,
              issueLinkCopied: P,
              setIssueLinkCopied: E,
              copyToClipboard: Y
            }
          ) : /* @__PURE__ */ me.jsx(
            "form",
            {
              "data-testid": "jira-create-issue-form",
              onSubmit: Z(Xe),
              children: /* @__PURE__ */ me.jsxs(tt, { children: [
                /* @__PURE__ */ me.jsx(ie, { span: 3, children: /* @__PURE__ */ me.jsx(We, { label: "Project", required: !0, children: /* @__PURE__ */ me.jsx(
                  xt,
                  {
                    control: M,
                    name: "project",
                    rules: { required: "Please select a project" },
                    render: ({ field: { onChange: le, value: Se } }) => /* @__PURE__ */ me.jsx(
                      Er,
                      {
                        searchable: !0,
                        loading: Ye,
                        onSelect: (Ae) => {
                          nn(Ae.key), le(Ae);
                        },
                        selectedItems: [Se],
                        placeholder: "Select Jira project",
                        emptyMessage: sn ? "No projects found" : "No projects available",
                        items: l || [],
                        itemComponent: ({ item: Ae, onSelect: Re, checked: yn }) => /* @__PURE__ */ me.jsx(
                          Fh,
                          {
                            item: Ae,
                            checked: yn,
                            onSelectItem: Re,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ me.jsx(ie, { span: 3, children: /* @__PURE__ */ me.jsx(We, { label: "Issue type", required: !0, children: /* @__PURE__ */ me.jsx(
                  xt,
                  {
                    control: M,
                    name: "issuetype",
                    rules: { required: "Please select an issue type" },
                    render: ({ field: { onChange: le, value: Se } }) => /* @__PURE__ */ me.jsx(
                      Er,
                      {
                        disabled: v.length === 0,
                        loading: Ue,
                        onSelect: (Ae) => {
                          se(Ae.id), le(Ae);
                        },
                        selectedItems: [Se],
                        placeholder: v.length > 0 ? "Select Jira issue type" : "",
                        emptyMessage: Pe ? "No issues found" : "No issues available",
                        items: v,
                        itemComponent: ({ item: Ae, onSelect: Re, checked: yn }) => /* @__PURE__ */ me.jsx(
                          Fh,
                          {
                            item: Ae,
                            checked: yn,
                            onSelectItem: Re,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                q && // Wrapping all dynamic input fields inside one `FormField`
                // which can handle the overflow scrolling in case we get many
                // input fields in the form
                /* @__PURE__ */ me.jsx(ie, { className: Wx.modalBodyFormFields, children: /* @__PURE__ */ me.jsx(
                  p2,
                  {
                    control: M,
                    errors: { ...je, ...I },
                    getValues: ke,
                    conversationContext: i,
                    jiraInstanceUrl: a,
                    issueTypeFields: j
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ me.jsx(
          Vt,
          {
            confirmOnClick: p ? Me : Z(Xe),
            confirmProps: {
              disabled: !q,
              isLoading: x,
              loadingIndicator: /* @__PURE__ */ me.jsx(hn, { size: 16 })
            },
            confirmName: p ? "Close" : "Save",
            cancelOnClick: p ? void 0 : Me
          }
        )
      ]
    }
  );
}, _2 = (e) => {
  if (!e) return "";
  const n = "https://", r = (e.startsWith(n) ? e.slice(n.length) : e).split("/")[0];
  return `${n}${r}`;
}, S2 = (e) => {
  if (!e?.trim())
    return "Please add a value";
  const n = "https://";
  if (e.startsWith(" ") || e.endsWith(" "))
    return "Please remove any empty spaces before or after the URL";
  const r = e.startsWith(n);
  if (r) {
    const i = e.slice(n.length).split("/");
    if (i.length > 1) {
      const a = r ? n.length + i[0].length : i[0].length;
      return i.length === 2 && i[1] === "" ? "Please remove the trailing slash `/`" : `Please remove the trailing path \`${e.slice(a)}\``;
    }
  } else
    return e.includes("://") ? `The protocol \`${e.substring(
      0,
      e.indexOf("://") + 3
    )}\` is not supported` : `Please add \`${n}\` as protocol`;
}, N2 = "_wrapper_1bylq_1", j2 = "_inputWrapper_1bylq_6", w2 = "_inputSeparator_1bylq_18", C2 = "_buttonLink_1bylq_23", I2 = "_noIssuesFound_1bylq_27", Ka = {
  wrapper: N2,
  inputWrapper: j2,
  inputSeparator: w2,
  buttonLink: C2,
  noIssuesFound: I2
}, F2 = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = In(), i = _2(n?.jiraSiteUrl), [a, o] = ue(!1), s = !!e?.conversationId, {
    linkIssue: l,
    linkIssueQuietly: u,
    unlinkIssue: p,
    unlinkAllIssues: d,
    loadIssues: f,
    removeDanglingIssueLinks: h,
    danglingIssueLinks: v,
    isLoadingIssueLinks: C,
    isLoadingIssues: j,
    issues: N,
    error: x
  } = MC(
    s ? e.conversationId : null,
    i
  ), g = !!n?.enableCreateIssue, P = !!n?.enableSortIssueTypeByLabel, E = !!(N?.length || v?.length), I = !!n?.enableRemoveAllLinks && E, w = !C && !j && v?.length > 0 && !!n?.showDanglingLinks;
  return !j && x ? /* @__PURE__ */ me.jsx(Tn, { error: x, retry: () => f() }) : /* @__PURE__ */ me.jsxs(me.Fragment, { children: [
    /* @__PURE__ */ me.jsxs(b, { className: Ka.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ me.jsxs(b, { className: Ka.inputWrapper, flexDirection: "column", children: [
        g && /* @__PURE__ */ me.jsxs(me.Fragment, { children: [
          /* @__PURE__ */ me.jsx(
            et,
            {
              variant: "primary",
              onClick: () => o(!0),
              style: {
                minHeight: "38px"
              },
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ me.jsx("div", { className: Ka.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ me.jsx(
          r2,
          {
            onSelectIssue: l,
            jiraInstanceUrl: i
          }
        )
      ] }),
      j ? /* @__PURE__ */ me.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ me.jsx(hn, { "data-testid": "jira-widget-issue-spinner" }) }) : N?.length ? /* @__PURE__ */ me.jsx(
        jA,
        {
          issues: N,
          jiraInstanceUrl: i,
          unlinkIssue: p
        }
      ) : /* @__PURE__ */ me.jsx(O.Paragraph, { align: "center", className: Ka.noIssuesFound, children: "No linked issues found" }),
      I && N?.length > 0 && /* @__PURE__ */ me.jsx(
        et,
        {
          variant: "secondary",
          disabled: !N?.length && !v?.length,
          onClick: d,
          children: "Unlink all issues"
        }
      ),
      w && /* @__PURE__ */ me.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ me.jsx(O.Heading, { variant: "heading-3", children: "Unresolved linked issues" }),
            /* @__PURE__ */ me.jsx(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: v.map((A) => /* @__PURE__ */ me.jsx(Yn, { onDelete: () => p(A), children: A }, A)) }),
            /* @__PURE__ */ me.jsx(
              et,
              {
                variant: "secondary",
                onClick: () => h(),
                icon: "link-slash",
                children: "Remove all unresolved issues"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ me.jsx(
        At,
        {
          slotEnd: /* @__PURE__ */ me.jsx(he, { name: "external-link" }),
          variant: "tertiary",
          className: Ka.buttonLink,
          navigate: () => {
            r("jira:view:jira:clicked", { jiraInstanceUrl: i }), window.open(i, "_blank")?.focus();
          },
          children: "Open Jira"
        }
      )
    ] }),
    a && /* @__PURE__ */ me.jsx(
      x2,
      {
        isOpen: a,
        onClose: () => o(!1),
        linkIssueQuietly: u,
        conversationContext: e,
        jiraInstanceUrl: i,
        hasSortIssueTypeByLabelEnabled: P
      }
    )
  ] });
}, Eh = [
  {
    key: "jiraSiteUrl",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "enableRemoveAllLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableSortIssueTypeByLabel",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  }
], E2 = (e) => {
  const n = S2(e);
  return typeof n == "string" ? n : !0;
}, ki = "JIRA", $2 = {
  enabled: !1,
  name: "",
  jiraSiteUrl: "",
  enableRemoveAllLinks: !1,
  showDanglingLinks: !1,
  enableCreateIssue: !0,
  enableSortIssueTypeByLabel: !1
}, T2 = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = dt({
    mode: "onChange",
    defaultValues: $2
  }), {
    create: u,
    update: p,
    remove: d,
    isLoading: f,
    error: h,
    misconfigurationCause: v,
    setMisconfigurationCause: C
  } = hr({
    integrationId: e,
    integrationType: ki,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: j,
    error: N,
    isWidgetUnknown: x,
    refetch: g,
    widgetConfiguration: P
  } = yr({
    integrationId: e,
    fieldDefinitions: Eh,
    form: l,
    onMisconfigured: C
  }), { renderConditions: E, setRenderConditions: I, renderConditionsForSubmit: w } = gr({
    integrationId: e,
    widgetConfiguration: P,
    renderConditionsEditor: o
  }), A = (Y) => kr(Y, {
    fieldDefinitions: Eh,
    isCreationMode: s,
    create: u,
    update: p,
    renderConditions: w
  }), H = l.watch("name");
  return /* @__PURE__ */ me.jsxs(
    vr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: A,
      error: N ?? h,
      onRetry: N ? g : void 0,
      isLoading: f || j,
      isWidgetUnknown: x,
      children: [
        v && /* @__PURE__ */ me.jsx(br, { cause: v }),
        /* @__PURE__ */ me.jsxs(tt, { children: [
          /* @__PURE__ */ me.jsx(ie, { children: /* @__PURE__ */ me.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ me.jsx(
            Sn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ me.jsx(ie, { span: 3, children: /* @__PURE__ */ me.jsx(
            Gn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ me.jsx(ie, { span: 3 }),
          /* @__PURE__ */ me.jsx(ie, { span: 3, children: /* @__PURE__ */ me.jsx(
            Gn,
            {
              name: "jiraSiteUrl",
              label: "Jira site URL",
              control: l.control,
              rules: {
                validate: (Y) => E2(Y)
              },
              componentProps: {
                placeholder: 'Insert your Jira site URL, e.g. "https://your-site.atlassian.net/"',
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ me.jsx(ie, { span: 3 }),
          /* @__PURE__ */ me.jsx(ie, { span: 3, children: /* @__PURE__ */ me.jsx(We, { label: 'Enable the "Remove all links" button', children: /* @__PURE__ */ me.jsx(
            Sn,
            {
              name: "enableRemoveAllLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ me.jsx(ie, { span: 3 }),
          /* @__PURE__ */ me.jsx(ie, { span: 3, children: /* @__PURE__ */ me.jsx(We, { label: "Show unresolved links to Jira issues", children: /* @__PURE__ */ me.jsx(
            Sn,
            {
              name: "showDanglingLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ me.jsx(ie, { span: 3 }),
          /* @__PURE__ */ me.jsx(ie, { span: 3, children: /* @__PURE__ */ me.jsx(We, { label: 'Enable the "Create issue" button', children: /* @__PURE__ */ me.jsx(
            Sn,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ me.jsx(ie, { span: 3 }),
          /* @__PURE__ */ me.jsx(ie, { span: 3, children: /* @__PURE__ */ me.jsx(We, { label: "Enable to sort the issue types by label", children: /* @__PURE__ */ me.jsx(
            Sn,
            {
              name: "enableSortIssueTypeByLabel",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ me.jsx(ie, { span: 3 }),
          !s && e && /* @__PURE__ */ me.jsx(
            pi,
            {
              configuration: n,
              integrationId: e,
              integrationType: ki,
              label: "Authorize with OAuth"
            }
          ),
          o && E !== null && /* @__PURE__ */ me.jsx(ie, { children: o({
            value: E,
            onChange: I,
            configurationKey: P?.id
          }) })
        ] }),
        /* @__PURE__ */ me.jsx(
          xr,
          {
            integrationType: ki,
            integrationId: e,
            widgetName: H,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => d(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ me.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ me.jsx(
                he,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ me.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ me.jsxs(O.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  ki,
                  " integration, all links between Dixa and ",
                  ki,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ me.jsxs(O.Paragraph, { children: [
                  "All data in ",
                  ki,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ me.jsxs(O.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  ki,
                  " ",
                  'integration "',
                  H,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._notificationText_1polx_1{color:var(--dixa-color-neutral-500)}._message_zrl8q_54{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}._message_zrl8q_54:hover,._messageIsOpen_zrl8q_62{border-color:var(--dixa-color-neutral-400)}._messageHeader_zrl8q_65{cursor:pointer}._messageUnattended_zrl8q_68{text-decoration:line-through}._messageLabel_zrl8q_71{color:var(--dixa-typography-color-secondary)}._messageText_zrl8q_74{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:auto}._messageText_zrl8q_74::-webkit-scrollbar{width:7px;height:7px}._messageText_zrl8q_74::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-000)}._messageText_zrl8q_74::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:4px}._messageText_zrl8q_74::-webkit-scrollbar-thumb:hover{background-color:var(--dixa-color-neutral-500)}._list_ld0hf_1{padding:0}._listItem_ld0hf_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ld0hf_4:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._subscriptionError_1qhhx_1{color:var(--dixa-typography-color-error);font-size:var(--dixa-typography-size-200)}._settingsWrapper_eleyu_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-300)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Kd = { exports: {} }, Ga = {}, Kx;
function O2() {
  if (Kx) return Ga;
  Kx = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Ga.Fragment = r, Ga.jsx = s, Ga.jsxs = s, Ga;
}
var as = {}, Gx;
function D2() {
  return Gx || (Gx = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        P("error", t, m);
      }
    }
    function P(t, c, m) {
      {
        var y = x.ReactDebugCurrentFrame, F = y.getStackAddendum();
        F !== "" && (c += "%s", m = m.concat([F]));
        var T = m.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var E = !1, I = !1, w = !1, A = !1, H = !1, Y;
    Y = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ne(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || H || t === a || t === p || t === d || A || t === v || E || I || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function W(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var F = c.displayName || c.name || "";
      return F !== "" ? m + "(" + F + ")" : m;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function D(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var m = t;
            return B(m._context) + ".Provider";
          case u:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : D(t.type) || "Memo";
          case h: {
            var F = t, T = F._payload, S = F._init;
            try {
              return D(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var M = Object.assign, Z = 0, je, ge, ye, ke, q, _e, De;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function Ye() {
      {
        if (Z === 0) {
          je = console.log, ge = console.info, ye = console.warn, ke = console.error, q = console.group, _e = console.groupCollapsed, De = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function sn() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: M({}, t, {
              value: je
            }),
            info: M({}, t, {
              value: ge
            }),
            warn: M({}, t, {
              value: ye
            }),
            error: M({}, t, {
              value: ke
            }),
            group: M({}, t, {
              value: q
            }),
            groupCollapsed: M({}, t, {
              value: _e
            }),
            groupEnd: M({}, t, {
              value: De
            })
          });
        }
        Z < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = x.ReactCurrentDispatcher, Ue;
    function Pe(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (F) {
            var y = F.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Le;
    {
      var Xe = typeof WeakMap == "function" ? WeakMap : Map;
      Le = new Xe();
    }
    function Fe(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Le.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      Be = !0;
      var F = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ye();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (re) {
              y = re;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (re) {
              y = re;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            y = re;
          }
          t();
        }
      } catch (re) {
        if (re && y && typeof re.stack == "string") {
          for (var _ = re.stack.split(`
`), ee = y.stack.split(`
`), L = _.length - 1, U = ee.length - 1; L >= 1 && U >= 0 && _[L] !== ee[U]; )
            U--;
          for (; L >= 1 && U >= 0; L--, U--)
            if (_[L] !== ee[U]) {
              if (L !== 1 || U !== 1)
                do
                  if (L--, U--, U < 0 || _[L] !== ee[U]) {
                    var ce = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && ce.includes("<anonymous>") && (ce = ce.replace("<anonymous>", t.displayName)), typeof t == "function" && Le.set(t, ce), ce;
                  }
                while (L >= 1 && U >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = F;
      }
      var ze = t ? t.displayName || t.name : "", Oe = ze ? Pe(ze) : "";
      return typeof t == "function" && Le.set(t, Oe), Oe;
    }
    function Me(t, c, m) {
      return Fe(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Fe(t, nn(t));
      if (typeof t == "string")
        return Pe(t);
      switch (t) {
        case p:
          return Pe("Suspense");
        case d:
          return Pe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return Me(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, F = y._payload, T = y._init;
            try {
              return se(T(F), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Se = {}, Ae = x.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(m);
      } else
        Ae.setExtraStackFrame(null);
    }
    function yn(t, c, m, y, F) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + m + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              _ = t[S](c, S, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Re(F), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, S, typeof _), Re(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Re(F), g("Failed %s type: %s", m, _.message), Re(null));
          }
      }
    }
    var Q = Array.isArray;
    function $(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ae(t);
    }
    var J = x.ReactCurrentOwner, de = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, xe, $e;
    function tn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && J.current;
    }
    function pn(t, c) {
      {
        var m = function() {
          xe || (xe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function Fn(t, c) {
      {
        var m = function() {
          $e || ($e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, m, y, F, T, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: F
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, m, y, F) {
      {
        var T, S = {}, _ = null, ee = null;
        m !== void 0 && (V(m), _ = "" + m), gn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ee = c.ref, on(c));
        for (T in c)
          le.call(c, T) && !de.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (T in L)
            S[T] === void 0 && (S[T] = L[T]);
        }
        if (_ || ee) {
          var U = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, U), ee && Fn(S, U);
        }
        return xn(t, _, ee, F, y, J.current, S);
      }
    }
    var en = x.ReactCurrentOwner, vn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        vn.setExtraStackFrame(m);
      } else
        vn.setExtraStackFrame(null);
    }
    var un;
    un = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = D(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Nn = {};
    function Rn(t) {
      {
        var c = jn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function kn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Rn(c);
        if (Nn[m])
          return;
        Nn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + D(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Ve(null);
      }
    }
    function _n(t, c) {
      {
        if (typeof t != "object")
          return;
        if ($(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            dn(y) && kn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var F = N(t);
          if (typeof F == "function" && F !== t.entries)
            for (var T = F.call(t), S; !(S = T.next()).done; )
              dn(S.value) && kn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = D(c);
          yn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !un) {
          un = !0;
          var F = D(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", F || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, m, y, F, T) {
      {
        var S = ne(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = Bn();
          ee ? _ += ee : _ += jn();
          var L;
          t === null ? L = "null" : $(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (D(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var U = En(t, c, m, F, T);
        if (U == null)
          return U;
        if (S) {
          var ce = c.children;
          if (ce !== void 0)
            if (y)
              if ($(ce)) {
                for (var ze = 0; ze < ce.length; ze++)
                  _n(ce[ze], t);
                Object.freeze && Object.freeze(ce);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _n(ce, t);
        }
        if (le.call(c, "key")) {
          var Oe = D(t), re = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), mn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Oe + mn]) {
            var Dn = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Oe, Dn, Oe), Cn[Oe + mn] = !0;
          }
        }
        return t === i ? Ln(U) : An(U), U;
      }
    }
    function Vn(t, c, m) {
      return wn(t, c, m, !0);
    }
    function qn(t, c, m) {
      return wn(t, c, m, !1);
    }
    var zn = qn, Wn = Vn;
    as.Fragment = i, as.jsx = zn, as.jsxs = Wn;
  })()), as;
}
var Yx;
function P2() {
  return Yx || (Yx = 1, process.env.NODE_ENV === "production" ? Kd.exports = O2() : Kd.exports = D2()), Kd.exports;
}
var fe = P2();
function R2({
  query: e,
  options: n,
  delayMs: r
}) {
  const { useLazyQuery: i } = bn(), [a, o] = ue([]), [s] = i(e, n), [l, u] = ue(
    []
  );
  return Je(() => () => {
    l.forEach((p) => window.clearTimeout(p));
  }, []), [async (p) => {
    const d = [];
    for (const [f, h] of p.entries()) {
      f !== 0 && await new Promise((C) => {
        const j = setTimeout(C, r);
        u([...l, j]);
      });
      const v = await s({
        variables: h
      });
      d.push(v);
    }
    o(d);
  }, a];
}
var BC = /* @__PURE__ */ ((e) => (e.List = "list", e))(BC || {}), $h = /* @__PURE__ */ ((e) => (e.Profile = "profile", e))($h || {}), Th = /* @__PURE__ */ ((e) => (e.Subscribed = "SUBSCRIBED", e))(Th || {}), Oh = /* @__PURE__ */ ((e) => (e.Unsubscribed = "UNSUBSCRIBED", e))(Oh || {});
const A2 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, L2 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, V2 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }] }, z2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getLists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_lists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetListListResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "created" } }, { kind: "Field", name: { kind: "Name", value: "updated" } }] } }, { kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "self" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "self" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, U2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "subscribeProfileToChannel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "relationships" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bulk_subscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_create_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }, { kind: "ObjectField", name: { kind: "Name", value: "relationships" }, value: { kind: "Variable", name: { kind: "Name", value: "relationships" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, M2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "unsubscribeProfileByContact" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bulk_unsubscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_delete_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, B2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getEvents" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "pageSize" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_PositiveInt" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "receivedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "openedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "clickedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "bouncedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "receivedSms" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, q2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFlowMessage" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "messageId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_flow_message" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "messageId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "definition" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_FlowEmail" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "preview_text" } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, H2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getMetrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_metrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetMetricResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, W2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileByFilter" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "profileByEmail" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "profileByPhoneNumber" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, K2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }, { kind: "EnumValue", value: "properties" }, { kind: "EnumValue", value: "predictive_analytics" }] } }, { kind: "Argument", name: { kind: "Name", value: "additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }, { kind: "EnumValue", value: "predictive_analytics" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "predictive_analytics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "average_order_value" } }, { kind: "Field", name: { kind: "Name", value: "churn_probability" } }, { kind: "Field", name: { kind: "Name", value: "predicted_clv" } }, { kind: "Field", name: { kind: "Name", value: "historic_clv" } }, { kind: "Field", name: { kind: "Name", value: "total_clv" } }, { kind: "Field", name: { kind: "Name", value: "historic_number_of_orders" } }, { kind: "Field", name: { kind: "Name", value: "predicted_number_of_orders" } }, { kind: "Field", name: { kind: "Name", value: "average_days_between_orders" } }, { kind: "Field", name: { kind: "Name", value: "expected_date_of_next_order" } }, { kind: "Field", name: { kind: "Name", value: "ranked_channel_affinity" } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, G2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getListsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_lists_for_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetListResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, Y2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getSegmentsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_segments_for_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetSegmentResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, J2 = {
  "\n  query getLists {\n    Klaviyo {\n      get_lists {\n        ... on Klaviyo_GetListListResponseCollectionCompoundDocument {\n          data {\n            type\n            id\n            attributes {\n              name\n              created\n              updated\n            }\n            links {\n              self\n            }\n          }\n          links {\n            self\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": z2,
  "\n  fragment ClientErrorResponseFragment on Klaviyo_ClientError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": A2,
  "\n  fragment ServerErrorResponseFragment on Klaviyo_ServerError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": L2,
  "\n  mutation subscribeProfileToChannel(\n    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!\n    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!\n  ) {\n    Klaviyo {\n      bulk_subscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_create_job\n            attributes: $attributes\n            relationships: $relationships\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": U2,
  "\n  mutation unsubscribeProfileByContact(\n    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!\n  ) {\n    Klaviyo {\n      bulk_unsubscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_delete_job\n            attributes: $attributes\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": M2,
  "\n  fragment GetEventResponseFragment on Klaviyo_GetEventResponseCollectionCompoundDocument {\n    data {\n      id\n      type\n      attributes {\n        timestamp\n        event_properties\n      }\n    }\n  }\n": V2,
  "\n  query getEvents(\n    $receivedEmailEventsFilter: String!\n    $openedEmailEventsFilter: String!\n    $clickedEmailEventsFilter: String!\n    $bouncedEmailEventsFilter: String!\n    $receivedSmsEventsFilter: String!\n    $pageSize: Klaviyo_PositiveInt!\n  ) {\n    Klaviyo {\n      receivedEmail: get_events(\n        filter: $receivedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      openedEmail: get_events(\n        filter: $openedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      clickedEmail: get_events(\n        filter: $clickedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      bouncedEmail: get_events(\n        filter: $bouncedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      receivedSms: get_events(\n        filter: $receivedSmsEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": B2,
  "\n  query getFlowMessage($messageId: String!) {\n    Klaviyo {\n      get_flow_message(id: $messageId) {\n        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {\n          data {\n            id\n            type\n            attributes {\n              definition {\n                ... on Klaviyo_FlowEmail {\n                  preview_text\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": q2,
  "\n  query getMetrics {\n    Klaviyo {\n      get_metrics {\n        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": H2,
  "\n  query getProfileByFilter(\n    $emailFilter: String\n    $phoneNumberFilter: String\n    $hasEmail: Boolean!\n    $hasPhoneNumber: Boolean!\n  ) {\n    Klaviyo {\n      profileByEmail: get_profiles(\n        filter: $emailFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasEmail) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      profileByPhoneNumber: get_profiles(\n        filter: $phoneNumberFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasPhoneNumber) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": W2,
  "\n  query getProfileById($profileId: String!) {\n    Klaviyo {\n      get_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          properties\n          predictive_analytics\n        ]\n        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          predictive_analytics\n        ]\n      ) {\n        ... on Klaviyo_GetProfileResponseCompoundDocument {\n          data {\n            attributes {\n              subscriptions {\n                email {\n                  marketing {\n                    consent\n                  }\n                }\n                sms {\n                  marketing {\n                    consent\n                  }\n                }\n              }\n              properties\n              predictive_analytics {\n                average_order_value\n                churn_probability\n                predicted_clv\n                historic_clv\n                total_clv\n                historic_number_of_orders\n                predicted_number_of_orders\n                average_days_between_orders\n                expected_date_of_next_order\n                ranked_channel_affinity\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": K2,
  "\n  query getListsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_lists_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetListResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": G2,
  "\n  query getSegmentsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_segments_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetSegmentResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": Y2
};
function Hr(e) {
  return J2[e] ?? {};
}
const Q2 = Hr(
  /* GraphQL */
  `
  query getEvents(
    $receivedEmailEventsFilter: String!
    $openedEmailEventsFilter: String!
    $clickedEmailEventsFilter: String!
    $bouncedEmailEventsFilter: String!
    $receivedSmsEventsFilter: String!
    $pageSize: Klaviyo_PositiveInt!
  ) {
    Klaviyo {
      receivedEmail: get_events(
        filter: $receivedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      openedEmail: get_events(
        filter: $openedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      clickedEmail: get_events(
        filter: $clickedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      bouncedEmail: get_events(
        filter: $bouncedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      receivedSms: get_events(
        filter: $receivedSmsEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), X2 = Hr(
  /* GraphQL */
  `
  query getFlowMessage($messageId: String!) {
    Klaviyo {
      get_flow_message(id: $messageId) {
        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {
          data {
            id
            type
            attributes {
              definition {
                ... on Klaviyo_FlowEmail {
                  preview_text
                }
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), Z2 = Hr(
  /* GraphQL */
  `
  query getMetrics {
    Klaviyo {
      get_metrics {
        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), eL = Hr(
  /* GraphQL */
  `
  query getProfileByFilter(
    $emailFilter: String
    $phoneNumberFilter: String
    $hasEmail: Boolean!
    $hasPhoneNumber: Boolean!
  ) {
    Klaviyo {
      profileByEmail: get_profiles(
        filter: $emailFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasEmail) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      profileByPhoneNumber: get_profiles(
        filter: $phoneNumberFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasPhoneNumber) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), nL = Hr(
  /* GraphQL */
  `
  query getProfileById($profileId: String!) {
    Klaviyo {
      get_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [
          subscriptions
          properties
          predictive_analytics
        ]
        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [
          subscriptions
          predictive_analytics
        ]
      ) {
        ... on Klaviyo_GetProfileResponseCompoundDocument {
          data {
            attributes {
              subscriptions {
                email {
                  marketing {
                    consent
                  }
                }
                sms {
                  marketing {
                    consent
                  }
                }
              }
              properties
              predictive_analytics {
                average_order_value
                churn_probability
                predicted_clv
                historic_clv
                total_clv
                historic_number_of_orders
                predicted_number_of_orders
                average_days_between_orders
                expected_date_of_next_order
                ranked_channel_affinity
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), tL = Hr(
  /* GraphQL */
  `
  query getListsByProfileId($profileId: String!) {
    Klaviyo {
      get_lists_for_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetListResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), rL = Hr(
  /* GraphQL */
  `
  query getSegmentsByProfileId($profileId: String!) {
    Klaviyo {
      get_segments_for_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetSegmentResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), iL = Hr(
  /* GraphQL */
  `
  mutation subscribeProfileToChannel(
    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!
    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!
  ) {
    Klaviyo {
      bulk_subscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_create_job
            attributes: $attributes
            relationships: $relationships
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), aL = Hr(
  /* GraphQL */
  `
  mutation unsubscribeProfileByContact(
    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!
  ) {
    Klaviyo {
      bulk_unsubscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_delete_job
            attributes: $attributes
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
);
function Dh(e) {
  return e?.attributes?.event_properties?.$flow !== void 0;
}
function Jx(e) {
  return Dh(e) && e?.attributes?.event_properties?.$message;
}
function oL(e) {
  return e?.attributes?.event_properties?.["Bounce Type"] !== void 0;
}
function Qx(e) {
  const n = e?.attributes?.timestamp;
  if (n)
    return n;
}
function sL(e) {
  return e.Klaviyo?.get_metrics?.__typename === "Klaviyo_GetMetricResponseCollectionCompoundDocument" && e.Klaviyo.get_metrics.data || [];
}
function lL(e) {
  return (e?.Klaviyo?.receivedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function cL(e) {
  return (e?.Klaviyo?.receivedSms?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedSms.data || [])?.map((n) => ({
    ...n,
    eventType: "SMS"
  }));
}
function uL(e) {
  return (e?.Klaviyo?.openedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.openedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function dL(e) {
  return (e?.Klaviyo?.clickedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.clickedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function mL(e) {
  return (e?.Klaviyo?.bouncedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.bouncedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function Xx(e) {
  return e?.Klaviyo?.get_flow_message?.__typename === "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument" && e.Klaviyo.get_flow_message.data || void 0;
}
function pL(e) {
  return e?.attributes?.definition?.__typename === "Klaviyo_FlowEmail" && e.attributes.definition.preview_text || void 0;
}
function fL(e) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch {
    return console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
  }
}
const hL = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
function yL(e) {
  return e?.data?.attributes?.subscriptions?.email?.marketing?.consent === "SUBSCRIBED";
}
function gL(e) {
  return e?.data?.attributes?.subscriptions?.sms?.marketing?.consent === "SUBSCRIBED";
}
function vL({
  profileId: e,
  noOfMessagesToShow: n
}) {
  const { useLazyQuery: r, useQuery: i } = bn(), { track: a } = In(), [o, s] = ue(null), [l, u] = ue(
    null
  ), [p, d] = ue(null), [f, h] = ue(null), [v, C] = ue(
    null
  ), [j, N] = ue([]), {
    data: x,
    error: g,
    loading: P,
    networkStatus: E
  } = i(Z2, {
    /*
    	Since metrics should rarely be changed, query once when the client initializes
    	and then read from the cache for the subsequent queries.
    */
    fetchPolicy: "network-only",
    // Used for first execution
    nextFetchPolicy: "cache-first",
    // Used for subsequent executions
    notifyOnNetworkStatusChange: !0
  }), [
    I,
    {
      data: w,
      error: A,
      loading: H,
      networkStatus: Y
    }
  ] = r(Q2, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return Je(() => {
    if (x && !P && E === rr.ready) {
      const ne = sL(x);
      s(
        ne.find((W) => W?.attributes?.name === "Received Email")?.id || null
      ), u(
        ne.find((W) => W?.attributes?.name === "Opened Email")?.id || null
      ), d(
        ne.find((W) => W?.attributes?.name === "Clicked Email")?.id || null
      ), h(
        ne.find((W) => W?.attributes?.name === "Bounced Email")?.id || null
      ), C(
        ne.find((W) => W?.attributes?.name === "Received SMS")?.id || null
      );
    } else
      s(null), u(null), d(null), h(null), C(null);
  }, [x]), Je(() => {
    o && l && p && f && v && !H && Y === rr.ready ? I({
      variables: {
        receivedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${o}")`,
        openedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${l}")`,
        clickedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${p}")`,
        bouncedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${f}")`,
        receivedSmsEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${v}")`,
        pageSize: n
      }
    }) : N([]);
  }, [
    o,
    l,
    p,
    f,
    v
  ]), Je(() => {
    if (!H && w) {
      const ne = lL(w), W = uL(
        w
      ).map(
        (ge) => ge?.attributes?.event_properties.$message
      ), B = dL(
        w
      ).map(
        (ge) => ge?.attributes?.event_properties.$message
      );
      ne.forEach((ge) => {
        const ye = ge.attributes?.event_properties.$message;
        ge.opened = W.includes(ye), ge.clicked = B.includes(ye);
      });
      const D = cL(w), M = mL(w), Z = [
        ...ne,
        ...M,
        ...D
      ].sort((ge, ye) => {
        const ke = Qx(ge), q = Qx(ye);
        return ke == null && q == null ? 0 : ke == null ? 1 : q == null ? -1 : q - ke;
      }).slice(0, n);
      N(Z);
      const je = Z.map((ge) => ge.id);
      a("klaviyo:messages:received", {
        emailsReceived: ne.filter(
          (ge) => je.includes(ge.id)
        ).length,
        emailsBounced: M.filter(
          (ge) => je.includes(ge.id)
        ).length,
        smsReceived: D.filter(
          (ge) => je.includes(ge.id)
        ).length,
        total: je.length
      });
    } else
      N([]);
  }, [H, w]), Xn(
    () => ({
      receivedMessages: j,
      isLoading: P || H,
      error: g || A
    }),
    [
      j,
      P,
      H,
      g,
      A
    ]
  );
}
function kL({ profileId: e }) {
  const { useQuery: n } = bn(), [r, i] = ue(), [a, o] = ue(), {
    data: s,
    error: l,
    loading: u,
    refetch: p
  } = n(nL, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    variables: {
      profileId: e
    }
  });
  Je(() => {
    l && o(l);
  }, [l]), Je(() => {
    !u && s && i(s.Klaviyo.get_profile);
  }, [u, s]);
  const d = async () => {
    const f = await p();
    f.error ? o(f.error) : f.data && i(
      f.data.Klaviyo.get_profile
    );
  };
  return Xn(
    () => ({
      profile: r,
      refetchProfile: d,
      isLoading: u,
      error: a
    }),
    // No need to add `refetchProfile` as a dependency here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, u, a]
  );
}
function bL({
  email: e,
  phoneNumber: n
}) {
  const { track: r } = In(), { useLazyQuery: i } = bn(), [a, o] = ue(), [s, l] = ue(), [
    u,
    { data: p, error: d, loading: f }
  ] = i(eL, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  Je(() => {
    if (!f && p) {
      const v = p.Klaviyo?.profileByEmail?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && p.Klaviyo.profileByEmail || void 0, C = p.Klaviyo?.profileByPhoneNumber?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && p.Klaviyo.profileByPhoneNumber || void 0;
      h(v, C);
    }
  }, [f, p]);
  const h = (v, C) => {
    const j = v?.data?.length === 1 && v.data[0]?.id || void 0, N = C?.data?.length === 1 && C.data[0]?.id || void 0, x = j || N, g = !j || !N || j === N;
    if (x && g) {
      o(j || N), r("klaviyo:profile:received", { hasProfile: !0 });
      return;
    }
    o(void 0), r("klaviyo:profile:received", { hasProfile: !1 }), g || l(
      new Error(
        `Two different profiles were retrieved from Klaviyo for the email ${e} (profile ID ${j}) and phone number ${n} (profile ID ${N}).`
      )
    );
  };
  return Xn(
    () => ({
      profileId: a,
      getProfileId: u,
      isLoading: f,
      error: d || s
    }),
    [a, u, f, d, s]
  );
}
const Zx = 800, xL = {
  min: 800,
  // 0.8 seconds
  max: 1200
  // 1.2 seconds
}, _L = 3, SL = 1.5, NL = ({
  query: e,
  delay: n,
  delayRange: r,
  maxCount: i = _L,
  useDelayRange: a = !1
}) => {
  const o = (A) => Math.floor(Math.random() * (A.max - A.min) + A.min), [s, l] = ue(0), [u, p] = ue(n || Zx), [d, f] = ue(r || xL), [h, v] = ue(!1), [C, j] = ue(!1), N = a || !!r, x = N ? o(d) : n || Zx, [g, P] = ue(x);
  yP(
    async () => {
      const A = s + 1, H = SL ** A;
      l(A), P(
        (N ? o(d) : u) * H
      ), await e().then(() => {
        j(!0), w();
      });
    },
    h ? g : null
  ), vP(() => w());
  const E = ft(() => {
    l(0), P(x);
  }, [x]), I = ft(
    (A = {}) => {
      const { delay: H, delayRange: Y } = A;
      j(!1), E(), Y && (f(Y), P(o(Y))), H && (p(H), P(H)), v(!0);
    },
    [E]
  ), w = ft(() => {
    v(!1), E();
  }, [E]);
  return Je(() => {
    s >= i && w();
  }, [s, i, w]), Xn(
    () => ({ isRunning: h, isSuccessful: C, start: I, stop: w }),
    [h, C, I, w]
  );
}, jL = (e) => {
  const n = e.graphQLErrors[0]?.extensions.integration?.responseHeaders?.["retry-after"];
  return n ? parseInt(n, 10) : void 0;
}, wL = (e) => ({
  min: e * 1e3,
  max: e * 1e3 + 500
});
function CL({
  profileId: e,
  query: n
}) {
  const { useQuery: r } = bn(), [i, a] = ue(), [o, s] = ue(), {
    data: l,
    error: u,
    loading: p,
    refetch: d,
    networkStatus: f
  } = r(
    n === "lists" ? tL : rL,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0,
      variables: {
        profileId: e
      }
    }
  ), {
    isRunning: h,
    start: v,
    stop: C
  } = NL({
    query: d,
    useDelayRange: !0
  }), j = p || h;
  return Je(() => {
    if (u)
      if (GI({
        errors: u.graphQLErrors
      })) {
        if (!h) {
          const N = jL(u);
          v({
            ...N && {
              delayRange: wL(N)
            }
          });
        }
      } else
        s(u);
  }, [u]), Je(() => {
    if (!p && l?.Klaviyo) {
      let N = {}, x = {};
      n === "lists" && (N = l?.Klaviyo?.get_lists_for_profile), n === "segments" && (x = l?.Klaviyo?.get_segments_for_profile), (N?.data || x?.data) && (C(), a(
        (n === "lists" ? N?.data : x?.data)?.map((g) => ({
          ...g,
          type: n === "lists" ? "list" : "segment"
        }))
      ));
    }
  }, [p, l]), Xn(
    () => ({
      listsOrSegments: i,
      refetchListOrSegments: v,
      isLoading: j,
      error: o,
      networkStatus: f
    }),
    [i, j, o, f, v]
  );
}
const IL = "_notificationText_1polx_1", Qy = {
  notificationText: IL
}, Ol = ({ error: e }) => {
  const { track: n } = In();
  let r = e;
  if (hw(e)) {
    const i = e.graphQLErrors, a = i.length === 1 && ow({ error: i[0] }), o = i.length === 1 && WI({ error: i[0] });
    if (a)
      n("klaviyo:profile:failed", { reason: "Invalid access token" }), r = new Error(
        "It was not possible to retrieve data from Klaviyo due to an access issue. Please contact your administrator."
      );
    else if (o)
      n("klaviyo:profile:failed", { reason: "Insufficient permissions" }), r = new Error(
        "You don't have enough permissions to see Klaviyo profile data for this conversation. This is typically due to a misconfiguration of the Klaviyo integration."
      );
    else
      return n("klaviyo:profile:failed", { reason: "Unexpected error" }), /* @__PURE__ */ fe.jsx(Tn, { error: e });
  }
  return /* @__PURE__ */ fe.jsx(b, { margin: "0 0 300", children: /* @__PURE__ */ fe.jsx(
    Qe.Item,
    {
      contentLeft: /* @__PURE__ */ fe.jsx(he, { color: "red.500", size: 20, name: "exclamation-triangle-filled" }),
      titleSecondary: r.message,
      title: "Unable to show Klaviyo profile data",
      variant: "dense"
    }
  ) });
}, FL = "_message_zrl8q_54", EL = "_messageIsOpen_zrl8q_62", $L = "_messageHeader_zrl8q_65", TL = "_messageLabel_zrl8q_71", OL = "_messageText_zrl8q_74", ua = {
  message: FL,
  messageIsOpen: EL,
  messageHeader: $L,
  messageLabel: TL,
  messageText: OL
}, DL = ({ event: e, isLoadingPreview: n }) => {
  const r = e?.attributes?.event_properties, i = e.flowMessage && pL(e.flowMessage);
  return /* @__PURE__ */ fe.jsxs(fe.Fragment, { children: [
    /* @__PURE__ */ fe.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
      /* @__PURE__ */ fe.jsx(O.Paragraph, { variant: "4", className: ua.messageLabel, children: "Campaign name" }),
      /* @__PURE__ */ fe.jsx(O.Paragraph, { children: r["Campaign Name"] })
    ] }),
    n ? /* @__PURE__ */ fe.jsx(b, { justifyContent: "center", margin: "100", children: /* @__PURE__ */ fe.jsx(hn, { size: 22 }) }) : i && i.length > 0 && /* @__PURE__ */ fe.jsxs(
      b,
      {
        flexDirection: "column",
        justifyContent: "space-between",
        gap: "100",
        children: [
          /* @__PURE__ */ fe.jsx(b, { children: /* @__PURE__ */ fe.jsx(
            O.Paragraph,
            {
              variant: "4",
              className: ua.messageLabel,
              children: "Preview text"
            }
          ) }),
          /* @__PURE__ */ fe.jsx(O.Paragraph, { variant: "4", className: ua.messageText, children: i })
        ]
      }
    )
  ] });
}, PL = ({ event: e }) => {
  const n = e?.attributes?.event_properties;
  return /* @__PURE__ */ fe.jsx(fe.Fragment, { children: /* @__PURE__ */ fe.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
    /* @__PURE__ */ fe.jsx(b, { children: /* @__PURE__ */ fe.jsx(O.Heading, { variant: "heading-4", children: "Message" }) }),
    /* @__PURE__ */ fe.jsx(b, { children: n?.extra?.["Message Body"] })
  ] }) });
}, RL = ({
  event: e,
  isLoadingPreview: n,
  openByDefault: r
}) => {
  const [i, a] = ue(r), { attributes: o, eventType: s } = e, l = o?.datetime, u = o?.timestamp, p = "DD MMM YYYY @ HH:mm", d = Xn(
    () => () => l ? Jn(l).format(p) : u ? Jn.unix(u).format(p) : null,
    [u, l]
  )(), f = s === "EMAIL", h = s === "SMS", v = f && e.opened, C = f && e.clicked, j = f && o?.event_properties.Subject, N = h && o?.event_properties["Message Name"], x = f ? "mail" : "sms";
  return /* @__PURE__ */ fe.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      className: ut(ua.message, {
        [ua.messageIsOpen]: i
      }),
      children: [
        /* @__PURE__ */ fe.jsxs(
          b,
          {
            alignItems: "center",
            justifyContent: "space-between",
            className: ua.messageHeader,
            onClick: () => a(!i),
            children: [
              /* @__PURE__ */ fe.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ fe.jsxs(b, { gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ fe.jsx(he, { size: 16, name: x }),
                  " ",
                  hL(s),
                  d && /* @__PURE__ */ fe.jsx(Mn, { size: "small", variant: "info", children: d })
                ] }),
                j && j,
                N && N
              ] }),
              /* @__PURE__ */ fe.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: i ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        i && /* @__PURE__ */ fe.jsxs(b, { flexDirection: "column", gap: "300", children: [
          /* @__PURE__ */ fe.jsx(uy, {}),
          oL(e) && /* @__PURE__ */ fe.jsx(b, { children: /* @__PURE__ */ fe.jsx(Mn, { size: "medium", variant: "error", children: "Bounced" }) }),
          f && /* @__PURE__ */ fe.jsxs(fe.Fragment, { children: [
            /* @__PURE__ */ fe.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
              /* @__PURE__ */ fe.jsx(Yn, { children: /* @__PURE__ */ fe.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ fe.jsx(
                  he,
                  {
                    size: 16,
                    color: v ? "green.400" : "red.400",
                    name: v ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Opened"
              ] }) }),
              /* @__PURE__ */ fe.jsx(Yn, { children: /* @__PURE__ */ fe.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ fe.jsx(
                  he,
                  {
                    size: 16,
                    color: C ? "green.400" : "red.400",
                    name: C ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Clicked"
              ] }) })
            ] }),
            /* @__PURE__ */ fe.jsx(DL, { event: e, isLoadingPreview: n })
          ] }),
          h && /* @__PURE__ */ fe.jsx(PL, { event: e })
        ] })
      ]
    }
  );
}, AL = {
  /*
  	Compiler needs this casting so as not to complain that the string literal 'no-cache'
  	is actually of type "FetchPolicy", which type is defined as one of many string values,
  	including 'no-cache'.
  */
  fetchPolicy: "no-cache",
  notifyOnNetworkStatusChange: !0
}, LL = ({
  profileId: e,
  noOfMessagesToShow: n
}) => {
  const [r, i] = ue(!1), {
    receivedMessages: a,
    isLoading: o,
    error: s
  } = vL({
    profileId: e,
    noOfMessagesToShow: n
  }), [l, u] = R2({
    query: X2,
    options: AL,
    delayMs: 1e3
  }), [p, d] = ue([]);
  Je(() => {
    if (a.length > 0) {
      d(a);
      const h = a.filter((v) => Dh(v)).map((v) => Jx(v));
      h.length > 0 && (i(!0), l(
        h.map((v) => ({
          messageId: v
        }))
      ).finally(() => i(!1)));
    }
  }, [a]), Je(() => {
    u.length > 0 && d(
      a?.map((h) => {
        if (h.eventType === "EMAIL" && Dh(h) && !h.flowMessage) {
          const v = Jx(h), C = u.find((N) => (N.data && Xx(N.data))?.id === v), j = C?.data && Xx(C.data);
          if (j)
            return {
              ...fL(h),
              flowMessage: j
            };
        }
        return h;
      })
    );
  }, [u]);
  const f = [];
  return s && f.push(s), u.length > 0 && f.push(
    ...u.map((h) => h.error).filter((h) => h)
  ), f && f.length > 0 ? /* @__PURE__ */ fe.jsx(fe.Fragment, { children: f.map((h, v) => h.graphQLErrors ? /* @__PURE__ */ fe.jsx(
    Tn,
    {
      error: h
    },
    `lastMessagesError${v}`
  ) : /* @__PURE__ */ fe.jsx(
    Ol,
    {
      error: h
    },
    `lastMessagesError${v}`
  )) }) : /* @__PURE__ */ fe.jsxs(fe.Fragment, { children: [
    /* @__PURE__ */ fe.jsx(O.Heading, { variant: "heading-3", children: "Messages" }),
    o ? /* @__PURE__ */ fe.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ fe.jsx(hn, {}) }) : /* @__PURE__ */ fe.jsx(fe.Fragment, { children: p?.length > 0 ? /* @__PURE__ */ fe.jsx(b, { gap: "200", flexDirection: "column", children: p.map((h, v) => /* @__PURE__ */ fe.jsx(
      RL,
      {
        event: h,
        isLoadingPreview: r,
        openByDefault: v === 0
      },
      h.id
    )) }) : /* @__PURE__ */ fe.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200",
        className: Qy.notificationText,
        children: "No messages found for the profile"
      }
    ) })
  ] });
}, VL = "_list_ld0hf_1", zL = "_listItem_ld0hf_4", ni = {
  list: VL,
  listItem: zL
}, UL = ({
  profile: e
}) => {
  const n = e?.data?.attributes?.properties, r = Object.entries(
    n ?? {}
  ).filter(([a, o]) => a !== "__typename" && o != null), i = r.length > 0;
  return /* @__PURE__ */ fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ fe.jsx(O.Heading, { variant: "heading-3", children: "Custom properties" }),
    !i && /* @__PURE__ */ fe.jsx(O.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom properties available" }),
    i && /* @__PURE__ */ fe.jsx(Qe, { className: ni.list, children: r.map(([a, o]) => typeof o == "boolean" || typeof o == "string" || typeof o == "number" || Array.isArray(o) && o.every((s) => typeof s == "string") ? /* @__PURE__ */ fe.jsx(Qe.Text, { variant: "dense", className: ni.listItem, children: /* @__PURE__ */ fe.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: "200",
        children: [
          /* @__PURE__ */ fe.jsx(O.Paragraph, { variant: "4", children: KI(a) }),
          /* @__PURE__ */ fe.jsx(
            b,
            {
              style: { flex: 1, minWidth: 0 },
              justifyContent: "flex-end",
              children: Pi(o)
            }
          )
        ]
      }
    ) }, a) : null) })
  ] });
}, e_ = ({
  profileId: e,
  type: n
}) => {
  const [r, i] = ue(!1), {
    listsOrSegments: a,
    error: o,
    isLoading: s,
    networkStatus: l,
    refetchListOrSegments: u
  } = CL({ profileId: e, query: n });
  Je(() => {
    l === 4 && i(!0);
  }, [l]);
  const p = () => {
    a || u();
  }, d = a || [];
  return o ? /* @__PURE__ */ fe.jsx(Ol, { error: o }) : s ? /* @__PURE__ */ fe.jsx(Qe.Text, { variant: "dense", className: ni.listItem, children: /* @__PURE__ */ fe.jsx(hn, { size: 14 }) }, "loading") : d.length > 0 ? /* @__PURE__ */ fe.jsx(fe.Fragment, { children: d.map(
    ({ attributes: f, type: h }, v) => /* @__PURE__ */ fe.jsx(Qe.Text, { variant: "dense", className: ni.listItem, children: /* @__PURE__ */ fe.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ fe.jsx(O.Paragraph, { variant: "4", children: f?.name }),
      !!h && /* @__PURE__ */ fe.jsx(Yn, { children: sw(h) })
    ] }) }, v)
  ) }) : r && !a ? /* @__PURE__ */ fe.jsx(Qe.Text, { variant: "dense", className: ni.listItem, children: /* @__PURE__ */ fe.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ fe.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ fe.jsx(he, { name: "exclamation-triangle-filled", color: "red" }),
      /* @__PURE__ */ fe.jsxs(O.Paragraph, { variant: "4", color: "red.500", children: [
        n === "lists" ? "Lists" : "Segments",
        " could not be loaded"
      ] })
    ] }),
    /* @__PURE__ */ fe.jsx(Ze, { content: "Refresh lists and segments", children: /* @__PURE__ */ fe.jsx(et, { icon: "sync", variant: "secondary", onClick: () => p(), children: "Retry" }) })
  ] }) }, "refetch") : /* @__PURE__ */ fe.jsx(Qe.Text, { variant: "dense", className: ni.listItem, children: /* @__PURE__ */ fe.jsx(b, { justifyContent: "space-between", alignItems: "center", children: /* @__PURE__ */ fe.jsx(O.Paragraph, { variant: "4", subdued: !0, children: /* @__PURE__ */ fe.jsx("i", { children: `No ${n === "lists" ? "lists" : "segments"} available` }) }) }) }, "refetch");
}, ML = 0.7, BL = 0.3, qL = (e) => e >= ML ? { variant: "error", label: "High risk" } : e >= BL ? { variant: "warning", label: "Medium risk" } : { variant: "success", label: "Low risk" }, HL = (e) => /* @__PURE__ */ fe.jsx(O.Paragraph, { as: "span", variant: "4", children: e.toFixed(2) }), WL = (e) => {
  const n = qL(e);
  return /* @__PURE__ */ fe.jsxs(b, { alignItems: "center", gap: "100", children: [
    /* @__PURE__ */ fe.jsx(Mn, { size: "small", variant: n.variant, children: n.label }),
    /* @__PURE__ */ fe.jsx(O.Paragraph, { as: "span", variant: "4", children: `${(e * 100).toFixed(1)}%` })
  ] });
}, KL = (e) => {
  const n = e?.data?.attributes?.predictive_analytics ?? null;
  if (!n)
    return [];
  const r = [
    ["Average order value", n.average_order_value],
    ["Historic lifetime value", n.historic_clv],
    ["Predicted lifetime value", n.predicted_clv],
    ["Total lifetime value", n.total_clv]
  ], i = [
    ["Historic orders", n.historic_number_of_orders],
    ["Predicted orders", n.predicted_number_of_orders],
    [
      "Average days between orders",
      n.average_days_between_orders
    ],
    ["Expected next order", n.expected_date_of_next_order]
  ], a = n.churn_probability, o = n.ranked_channel_affinity?.filter(Boolean) ?? null;
  return [
    ...r.flatMap(
      ([s, l]) => l ? [{ label: s, content: HL(l) }] : []
    ),
    ...i.flatMap(
      ([s, l]) => l ? [{ label: s, content: Pi(l) }] : []
    ),
    ...a ? [
      {
        label: "Churn probability",
        content: WL(a)
      }
    ] : [],
    ...o?.length ? [
      {
        label: "Channel affinity",
        content: Pi(o)
      }
    ] : []
  ];
}, GL = ({
  profile: e
}) => {
  const n = KL(e);
  return /* @__PURE__ */ fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ fe.jsx(O.Heading, { variant: "heading-3", children: "Predictive analytics" }),
    n.length === 0 && /* @__PURE__ */ fe.jsx(O.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No predictive analytics available" }),
    n.length > 0 && /* @__PURE__ */ fe.jsx(Qe, { className: ni.list, children: n.map(({ label: r, content: i }) => /* @__PURE__ */ fe.jsx(Qe.Text, { variant: "dense", className: ni.listItem, children: /* @__PURE__ */ fe.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        gap: "200",
        children: [
          /* @__PURE__ */ fe.jsx(O.Paragraph, { as: "span", variant: "4", children: r }),
          i
        ]
      }
    ) }, r)) })
  ] });
}, YL = "_tagHover_kzbzk_1", JL = "_channelUnsubscribed_kzbzk_6", n_ = {
  tagHover: YL,
  channelUnsubscribed: JL
}, t_ = ({
  isSubscribed: e,
  isLoading: n,
  channelName: r,
  channelIcon: i,
  hasReSubscriptionFeature: a,
  handleAction: o
}) => {
  const s = e ? "Unsubscribe" : "Subscribe", l = !e && !a;
  return /* @__PURE__ */ fe.jsx(
    Ze,
    {
      content: l ? "You have to select a resubscription list in the settings." : s,
      children: /* @__PURE__ */ fe.jsx(
        Yn,
        {
          className: n_.tagHover,
          color: e ? "green.500" : "neutral.200",
          children: /* @__PURE__ */ fe.jsxs(
            b,
            {
              "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
              gap: "200",
              alignItems: "center",
              className: ut({
                [n_.channelUnsubscribed]: !e || l
              }),
              onClick: () => {
                l || o();
              },
              children: [
                n ? /* @__PURE__ */ fe.jsx(hn, { size: 16 }) : /* @__PURE__ */ fe.jsx(he, { size: 16, name: i }),
                r
              ]
            }
          )
        }
      )
    }
  );
}, QL = "_subscriptionError_1qhhx_1", XL = {
  subscriptionError: QL
}, ZL = ({
  subscriptionListId: e,
  profile: n,
  email: r,
  phoneNumber: i,
  profileId: a,
  refetchProfile: o
}) => {
  const [s, l] = ue(!1), [u, p] = ue(!1), [d, f] = ue(), { track: h } = In(), [v, C] = gP({
    channel: null,
    request: null
  }), j = yL(n), N = gL(n), x = !!e, { useMutation: g } = bn(), [P] = g(
    iL
  ), [E] = g(
    aL
  ), I = (H) => {
    h("klaviyo:profile:subscribe:clicked", { channel: H }), C.setAll({
      channel: H,
      request: "subscribed"
    }), ((Y) => P({
      variables: {
        attributes: {
          // eslint-disable-next-line camelcase
          custom_source: "Dixa integration",
          profiles: {
            data: [
              {
                type: $h.Profile,
                id: a,
                attributes: {
                  email: r,
                  // eslint-disable-next-line camelcase
                  ...i ? { phone_number: i } : {},
                  subscriptions: {
                    ...Y === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: Th.Subscribed
                        }
                      }
                    },
                    ...Y === "SMS" && {
                      sms: {
                        marketing: {
                          consent: Th.Subscribed
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        },
        relationships: {
          list: {
            data: {
              type: BC.List,
              id: e
            }
          }
        }
      }
    }))(H).then(
      (Y) => A({
        channel: H,
        mutationResponse: Y,
        isSubscriptionRequest: !0
      })
    ).catch(
      (Y) => A({
        channel: H,
        mutationErrorResponse: Y,
        isSubscriptionRequest: !0
      })
    );
  }, w = (H) => {
    h("klaviyo:profile:unsubscribe:clicked", { channel: H }), C.setAll({
      channel: H,
      request: "unsubscribed"
    }), E({
      variables: {
        attributes: {
          profiles: {
            data: [
              {
                type: $h.Profile,
                attributes: {
                  ...H === "EMAIL" ? { email: r } : {},
                  // eslint-disable-next-line camelcase
                  ...H === "SMS" ? { phone_number: i } : {},
                  subscriptions: {
                    ...H === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: Oh.Unsubscribed
                        }
                      }
                    },
                    ...H === "SMS" && {
                      sms: {
                        marketing: {
                          consent: Oh.Unsubscribed
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        }
      }
    }).then(
      (Y) => A({
        channel: H,
        mutationResponse: Y,
        isSubscriptionRequest: !1
      })
    ).catch(
      (Y) => A({
        channel: H,
        mutationErrorResponse: Y,
        isSubscriptionRequest: !1
      })
    );
  }, A = async ({
    channel: H,
    mutationResponse: Y,
    mutationErrorResponse: ne,
    isSubscriptionRequest: W
  }) => {
    const B = ne?.networkError, D = B ? B?.statusCode : NaN, M = Y?.errors, Z = !!M && lw({
      errors: M
    });
    D === 202 ? (h(
      W ? "klaviyo:profile:subscribe:succeeded" : "klaviyo:profile:unsubscribe:succeeded",
      { channel: H }
    ), await o()) : Z ? (h(
      W ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: H,
        reason: "Insufficient permissions"
      }
    ), f(
      `Request failed with a permission error. Could not ${W ? "opt-in" : "opt-out"}.`
    )) : (h(
      W ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: H,
        reason: B?.message || "Unexpected error"
      }
    ), f(
      `Request failed. Could not ${W ? "opt-in" : "opt-out"}.`
    )), p(!1), l(!1);
  };
  return Je(() => {
    if (v.request === "subscribed") {
      const H = `This subscription might be a double opt-in. The customer needs to check if they received a confirmation ${v.channel === "EMAIL" ? "email" : "sms"} to give consent.`;
      v.channel === "EMAIL" && !s && n?.data?.attributes?.subscriptions?.email?.marketing?.consent !== "SUBSCRIBED" && (f(H), C.reset()), v.channel === "SMS" && !u && n?.data?.attributes?.subscriptions?.sms?.marketing?.consent !== "SUBSCRIBED" && (f(H), C.reset());
    }
  }, [
    n?.data?.attributes?.subscriptions?.email?.marketing?.consent,
    n?.data?.attributes?.subscriptions?.sms?.marketing?.consent,
    s,
    u
  ]), /* @__PURE__ */ fe.jsx(
    b,
    {
      "data-testid": "subscription-channels",
      gap: "200",
      flexDirection: "column",
      children: /* @__PURE__ */ fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ fe.jsx(O.Heading, { variant: "heading-3", children: "Subscription channels" }),
        /* @__PURE__ */ fe.jsxs(b, { gap: "100", flexDirection: "row", children: [
          /* @__PURE__ */ fe.jsx(
            t_,
            {
              "data-testid": "subscription-channels-email-button",
              isLoading: s,
              isSubscribed: j,
              channelName: "Email",
              channelIcon: "mail",
              hasReSubscriptionFeature: x,
              handleAction: () => {
                l(!0), f(void 0), j ? w("EMAIL") : I("EMAIL");
              }
            }
          ),
          /* @__PURE__ */ fe.jsx(
            t_,
            {
              "data-testid": "subscription-channels-sms-button",
              isLoading: u,
              isSubscribed: N,
              channelName: "Sms",
              channelIcon: "sms",
              hasReSubscriptionFeature: x,
              handleAction: () => {
                p(!0), f(void 0), N ? w("SMS") : I("SMS");
              }
            }
          )
        ] }),
        d && /* @__PURE__ */ fe.jsx(b, { className: XL.subscriptionError, children: d })
      ] })
    }
  );
}, eV = ({
  profileId: e,
  email: n,
  phoneNumber: r,
  showProfileLists: i,
  showProfileSegments: a,
  showSubscriptions: o,
  showCustomProperties: s,
  showPredictiveAnalytics: l,
  noOfMessagesToShow: u,
  subscriptionListId: p
}) => {
  const {
    profile: d,
    error: f,
    isLoading: h,
    refetchProfile: v
  } = kL({ profileId: e });
  return f ? /* @__PURE__ */ fe.jsx(Ol, { error: f }) : h ? /* @__PURE__ */ fe.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ fe.jsx(hn, {}) }) : !d && !h ? /* @__PURE__ */ fe.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200",
      className: Qy.notificationText,
      children: "No Klaviyo profile data found"
    }
  ) : /* @__PURE__ */ fe.jsxs(b, { flexDirection: "column", gap: "300", margin: "200 0 300", children: [
    (i || a) && /* @__PURE__ */ fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ fe.jsx(O.Heading, { variant: "heading-3", children: "Lists & Segments" }),
      /* @__PURE__ */ fe.jsxs(Qe, { className: ni.list, children: [
        i && /* @__PURE__ */ fe.jsx(e_, { profileId: e, type: "lists" }),
        a && /* @__PURE__ */ fe.jsx(
          e_,
          {
            profileId: e,
            type: "segments"
          }
        )
      ] })
    ] }),
    d && e && o && /* @__PURE__ */ fe.jsx(
      ZL,
      {
        profile: d,
        profileId: e,
        subscriptionListId: p,
        refetchProfile: v,
        email: n,
        phoneNumber: r
      }
    ),
    d && l && /* @__PURE__ */ fe.jsx(GL, { profile: d }),
    d && s && /* @__PURE__ */ fe.jsx(UL, { profile: d }),
    /* @__PURE__ */ fe.jsx(
      LL,
      {
        profileId: e,
        noOfMessagesToShow: u
      }
    )
  ] });
}, nV = ({
  conversationContext: e,
  settings: n
}) => {
  const r = e.customer?.email || void 0, i = e.customer?.phone_number || void 0, a = n?.showProfileLists, o = n?.showProfileSegments, s = n?.showSubscriptions, l = n?.showCustomProperties, u = n?.showPredictiveAnalytics, p = Number(n?.noOfMessagesToShow), d = n?.subscriptionListId, {
    profileId: f,
    getProfileId: h,
    isLoading: v,
    error: C
  } = bL({ email: r, phoneNumber: i });
  return oF(() => {
    (r || i) && h({
      variables: {
        emailFilter: r ? `equals(email,"${r}")` : void 0,
        phoneNumberFilter: i ? `equals(phone_number,"${i}")` : void 0,
        hasEmail: !!r,
        hasPhoneNumber: !!i
      }
    });
  }, [r, i]), !r && !i ? /* @__PURE__ */ fe.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: "The customer does not have an email nor a phone number" }) : v ? /* @__PURE__ */ fe.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ fe.jsx(hn, {}) }) : C ? /* @__PURE__ */ fe.jsx(Ol, { error: C }) : f ? /* @__PURE__ */ fe.jsx(
    eV,
    {
      profileId: f,
      email: r,
      phoneNumber: i,
      showProfileLists: a,
      showProfileSegments: o,
      showSubscriptions: s,
      showCustomProperties: l,
      showPredictiveAnalytics: u,
      noOfMessagesToShow: p,
      subscriptionListId: d
    }
  ) : /* @__PURE__ */ fe.jsx(
    b,
    {
      justifyContent: "center",
      margin: "0 0 300 0",
      className: Qy.notificationText,
      children: "No profile ID found"
    }
  );
}, r_ = [
  { value: "3", label: "The three latest messages" },
  { value: "4", label: "The four latest messages" },
  { value: "5", label: "The five latest messages" }
], tV = ({
  control: e,
  name: n
}) => /* @__PURE__ */ fe.jsx(
  fr,
  {
    name: n,
    control: e,
    label: "Choose how many messages to show",
    rules: { required: "Please choose how many messages to show" },
    componentProps: {
      placeholder: "Select an option",
      equalityFn: (r, i) => r === i,
      getItemTitleByValue: (r) => {
        const i = r_.find(
          (a) => a.value === r
        )?.label;
        return i ? /* @__PURE__ */ fe.jsx(O.Paragraph, { children: i }) : null;
      }
    },
    children: r_.map((r) => /* @__PURE__ */ fe.jsx(pt.Item, { value: r.value, children: r.label }, r.value))
  }
), rV = "_settingsWrapper_eleyu_1", iV = {
  settingsWrapper: rV
}, aV = Hr(
  /* GraphQL */
  `
  query getLists {
    Klaviyo {
      get_lists {
        ... on Klaviyo_GetListListResponseCollectionCompoundDocument {
          data {
            type
            id
            attributes {
              name
              created
              updated
            }
            links {
              self
            }
          }
          links {
            self
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), i_ = [], oV = ({
  value: e,
  onChange: n
}) => {
  const { useQuery: r } = bn(), [i, a] = ue(i_), [o, s] = ue(!!e), {
    data: l,
    error: u,
    loading: p
  } = r(aV, {
    skip: !o,
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return Je(() => {
    e && s(!0);
  }, [e]), Je(() => {
    const d = l?.Klaviyo?.get_lists;
    if (o && d && !p && !u) {
      const f = d?.data?.map(
        (h) => ({
          value: h?.id,
          label: h?.attributes?.name
        })
      ) || i_;
      a(f);
    }
  }, [o, l, p, u]), /* @__PURE__ */ fe.jsxs(fe.Fragment, { children: [
    /* @__PURE__ */ fe.jsx(ie, { span: 3, children: /* @__PURE__ */ fe.jsxs(
      b,
      {
        gap: "300",
        flexDirection: "column",
        className: iV.settingsWrapper,
        children: [
          /* @__PURE__ */ fe.jsx(We, { label: "Activate re-/subscription list selection", children: /* @__PURE__ */ fe.jsx(
            xl,
            {
              input: {
                name: "subscriptionListId-switch",
                value: "switchValueFromComponent",
                checked: o,
                onChange: () => {
                  const d = !o;
                  d || n(""), s(d);
                }
              }
            }
          ) }),
          o && u && !p && /* @__PURE__ */ fe.jsx(We, { children: /* @__PURE__ */ fe.jsx(Tn, { error: u }) }),
          o && !u && p && /* @__PURE__ */ fe.jsx(We, { children: /* @__PURE__ */ fe.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ fe.jsx(hn, {}) }) }),
          o && !u && !p && i && /* @__PURE__ */ fe.jsx(We, { label: "Available lists to subscribe to", children: /* @__PURE__ */ fe.jsx(
            ei,
            {
              required: !0,
              placeholder: "Select a list",
              onChange: (d) => n(d?.selectedValues?.[0]?.value ?? ""),
              getItemTitleByValue: (d) => d ? /* @__PURE__ */ fe.jsx(O.Paragraph, { children: d.label }) : null,
              value: e ? [
                {
                  label: (i || []).find(
                    (d) => d.value === e
                  )?.label,
                  value: e
                }
              ] : [],
              equalityFn: (d, f) => d.value === f.value,
              children: i.map((d) => /* @__PURE__ */ fe.jsx(pt.Item, { value: d, children: d.label }, d.value))
            }
          ) })
        ]
      }
    ) }),
    /* @__PURE__ */ fe.jsx(ie, { span: 3 })
  ] });
}, ol = [
  {
    key: "klaviyoApiKey",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "showProfileLists",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showProfileSegments",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showSubscriptions",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showCustomProperties",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showPredictiveAnalytics",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  // Populated by the subscribe-list selector; empty means the feature is off.
  {
    key: "subscriptionListId",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "noOfMessagesToShow",
    type: "string",
    secret: !1,
    defaultValue: "5"
  }
], sV = [
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: pi
  }
], lV = [
  {
    key: "klaviyoApiKey",
    label: "API key",
    placeholder: "API key from Klaviyo",
    required: !0,
    secret: !0,
    type: "input"
  }
], Gd = "KLAVIYO", cV = {
  enabled: !1,
  name: "",
  ...sy(
    [],
    ol
  )
}, uV = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = dt({
    mode: "onChange",
    defaultValues: cV
  }), {
    create: u,
    update: p,
    remove: d,
    isLoading: f,
    error: h,
    misconfigurationCause: v,
    setMisconfigurationCause: C
  } = hr({
    integrationId: e,
    integrationType: Gd,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: j,
    error: N,
    isWidgetUnknown: x,
    refetch: g,
    widgetConfiguration: P
  } = yr({
    integrationId: e,
    fieldDefinitions: ol,
    form: l,
    onMisconfigured: C
  }), { renderConditions: E, setRenderConditions: I, renderConditionsForSubmit: w } = gr({
    integrationId: e,
    widgetConfiguration: P,
    renderConditionsEditor: o
  }), A = s || !!P?.additionalProperties?.isUsingOAuth, H = (ne) => kr(ne, {
    fieldDefinitions: ol,
    isCreationMode: s,
    create: u,
    update: p,
    renderConditions: w
  }), Y = l.watch("name");
  return /* @__PURE__ */ fe.jsxs(
    vr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: H,
      error: N ?? h,
      onRetry: N ? g : void 0,
      isLoading: f || j,
      isWidgetUnknown: x,
      children: [
        v && /* @__PURE__ */ fe.jsx(br, { cause: v }),
        /* @__PURE__ */ fe.jsxs(tt, { children: [
          /* @__PURE__ */ fe.jsx(ie, { children: /* @__PURE__ */ fe.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ fe.jsx(
            Sn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ fe.jsx(ie, { span: 3, children: /* @__PURE__ */ fe.jsx(
            Gn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ fe.jsx(ie, { span: 3 }),
          !A && /* @__PURE__ */ fe.jsxs(fe.Fragment, { children: [
            /* @__PURE__ */ fe.jsx(ie, { span: 3, children: /* @__PURE__ */ fe.jsx(
              mi,
              {
                name: "klaviyoApiKey",
                label: "API key",
                control: l.control,
                isCreationMode: s,
                rules: { required: "API key is required" },
                componentProps: {
                  placeholder: "API key from Klaviyo",
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ fe.jsx(ie, { span: 3 })
          ] }),
          /* @__PURE__ */ fe.jsx(ie, { span: 3, children: /* @__PURE__ */ fe.jsx(We, { label: "Show Klaviyo lists for a profile", children: /* @__PURE__ */ fe.jsx(
            Sn,
            {
              name: "showProfileLists",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ fe.jsx(ie, { span: 3 }),
          /* @__PURE__ */ fe.jsx(ie, { span: 3, children: /* @__PURE__ */ fe.jsx(We, { label: "Show Klaviyo segments for a profile", children: /* @__PURE__ */ fe.jsx(
            Sn,
            {
              name: "showProfileSegments",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ fe.jsx(ie, { span: 3 }),
          /* @__PURE__ */ fe.jsx(ie, { span: 3, children: /* @__PURE__ */ fe.jsx(We, { label: "Show subscription channels for Klaviyo messages", children: /* @__PURE__ */ fe.jsx(
            Sn,
            {
              name: "showSubscriptions",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ fe.jsx(ie, { span: 3 }),
          /* @__PURE__ */ fe.jsx(ie, { span: 3, children: /* @__PURE__ */ fe.jsx(We, { label: "Show custom properties for a profile", children: /* @__PURE__ */ fe.jsx(
            Sn,
            {
              name: "showCustomProperties",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ fe.jsx(ie, { span: 3 }),
          /* @__PURE__ */ fe.jsx(ie, { span: 3, children: /* @__PURE__ */ fe.jsx(We, { label: "Show predictive analytics for a profile", children: /* @__PURE__ */ fe.jsx(
            Sn,
            {
              name: "showPredictiveAnalytics",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ fe.jsx(ie, { span: 3 }),
          !s && /* @__PURE__ */ fe.jsx(
            xt,
            {
              name: "subscriptionListId",
              control: l.control,
              render: ({ field: ne }) => /* @__PURE__ */ fe.jsx(
                oV,
                {
                  value: ne.value,
                  onChange: ne.onChange
                }
              )
            }
          ),
          /* @__PURE__ */ fe.jsx(ie, { span: 3, children: /* @__PURE__ */ fe.jsx(
            tV,
            {
              name: "noOfMessagesToShow",
              control: l.control
            }
          ) }),
          /* @__PURE__ */ fe.jsx(ie, { span: 3 }),
          A && !s && e && /* @__PURE__ */ fe.jsx(
            pi,
            {
              configuration: n,
              integrationId: e,
              integrationType: Gd,
              label: "Authorize with OAuth"
            }
          ),
          o && E !== null && /* @__PURE__ */ fe.jsx(ie, { children: o({
            value: E,
            onChange: I,
            configurationKey: P?.id
          }) })
        ] }),
        /* @__PURE__ */ fe.jsx(
          xr,
          {
            integrationType: Gd,
            integrationId: e,
            widgetName: Y,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => d()
          }
        )
      ]
    }
  );
};
function dV(e, n) {
  const r = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (r.padRight ? " " : "") + "," + (r.padLeft === !1 ? "" : " ")
  ).trim();
}
const mV = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, pV = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, fV = {};
function a_(e, n) {
  return (fV.jsx ? pV : mV).test(e);
}
const hV = /[ \t\n\f\r]/g;
function yV(e) {
  return typeof e == "object" ? e.type === "text" ? o_(e.value) : !1 : o_(e);
}
function o_(e) {
  return e.replace(hV, "") === "";
}
class Uo {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(n, r, i) {
    this.property = n, this.normal = r, i && (this.space = i);
  }
}
Uo.prototype.property = {};
Uo.prototype.normal = {};
Uo.prototype.space = null;
function qC(e, n) {
  const r = {}, i = {};
  let a = -1;
  for (; ++a < e.length; )
    Object.assign(r, e[a].property), Object.assign(i, e[a].normal);
  return new Uo(r, i, n);
}
function Ph(e) {
  return e.toLowerCase();
}
class _r {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(n, r) {
    this.property = n, this.attribute = r;
  }
}
_r.prototype.space = null;
_r.prototype.boolean = !1;
_r.prototype.booleanish = !1;
_r.prototype.overloadedBoolean = !1;
_r.prototype.number = !1;
_r.prototype.commaSeparated = !1;
_r.prototype.spaceSeparated = !1;
_r.prototype.commaOrSpaceSeparated = !1;
_r.prototype.mustUseProperty = !1;
_r.prototype.defined = !1;
let gV = 0;
const On = Mi(), bt = Mi(), HC = Mi(), Ge = Mi(), st = Mi(), da = Mi(), ar = Mi();
function Mi() {
  return 2 ** ++gV;
}
const Rh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: On,
  booleanish: bt,
  commaOrSpaceSeparated: ar,
  commaSeparated: da,
  number: Ge,
  overloadedBoolean: HC,
  spaceSeparated: st
}, Symbol.toStringTag, { value: "Module" })), Yd = Object.keys(Rh);
class Xy extends _r {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(n, r, i, a) {
    let o = -1;
    if (super(n, r), s_(this, "space", a), typeof i == "number")
      for (; ++o < Yd.length; ) {
        const s = Yd[o];
        s_(this, Yd[o], (i & Rh[s]) === Rh[s]);
      }
  }
}
Xy.prototype.defined = !0;
function s_(e, n, r) {
  r && (e[n] = r);
}
const vV = {}.hasOwnProperty;
function Ia(e) {
  const n = {}, r = {};
  let i;
  for (i in e.properties)
    if (vV.call(e.properties, i)) {
      const a = e.properties[i], o = new Xy(
        i,
        e.transform(e.attributes || {}, i),
        a,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(i) && (o.mustUseProperty = !0), n[i] = o, r[Ph(i)] = i, r[Ph(o.attribute)] = i;
    }
  return new Uo(n, r, e.space);
}
const WC = Ia({
  space: "xlink",
  transform(e, n) {
    return "xlink:" + n.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), KC = Ia({
  space: "xml",
  transform(e, n) {
    return "xml:" + n.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function GC(e, n) {
  return n in e ? e[n] : n;
}
function YC(e, n) {
  return GC(e, n.toLowerCase());
}
const JC = Ia({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: YC,
  properties: { xmlns: null, xmlnsXLink: null }
}), QC = Ia({
  transform(e, n) {
    return n === "role" ? n : "aria-" + n.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: bt,
    ariaAutoComplete: null,
    ariaBusy: bt,
    ariaChecked: bt,
    ariaColCount: Ge,
    ariaColIndex: Ge,
    ariaColSpan: Ge,
    ariaControls: st,
    ariaCurrent: null,
    ariaDescribedBy: st,
    ariaDetails: null,
    ariaDisabled: bt,
    ariaDropEffect: st,
    ariaErrorMessage: null,
    ariaExpanded: bt,
    ariaFlowTo: st,
    ariaGrabbed: bt,
    ariaHasPopup: null,
    ariaHidden: bt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: st,
    ariaLevel: Ge,
    ariaLive: null,
    ariaModal: bt,
    ariaMultiLine: bt,
    ariaMultiSelectable: bt,
    ariaOrientation: null,
    ariaOwns: st,
    ariaPlaceholder: null,
    ariaPosInSet: Ge,
    ariaPressed: bt,
    ariaReadOnly: bt,
    ariaRelevant: null,
    ariaRequired: bt,
    ariaRoleDescription: st,
    ariaRowCount: Ge,
    ariaRowIndex: Ge,
    ariaRowSpan: Ge,
    ariaSelected: bt,
    ariaSetSize: Ge,
    ariaSort: null,
    ariaValueMax: Ge,
    ariaValueMin: Ge,
    ariaValueNow: Ge,
    ariaValueText: null,
    role: null
  }
}), kV = Ia({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: YC,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: da,
    acceptCharset: st,
    accessKey: st,
    action: null,
    allow: null,
    allowFullScreen: On,
    allowPaymentRequest: On,
    allowUserMedia: On,
    alt: null,
    as: null,
    async: On,
    autoCapitalize: null,
    autoComplete: st,
    autoFocus: On,
    autoPlay: On,
    blocking: st,
    capture: null,
    charSet: null,
    checked: On,
    cite: null,
    className: st,
    cols: Ge,
    colSpan: null,
    content: null,
    contentEditable: bt,
    controls: On,
    controlsList: st,
    coords: Ge | da,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: On,
    defer: On,
    dir: null,
    dirName: null,
    disabled: On,
    download: HC,
    draggable: bt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: On,
    formTarget: null,
    headers: st,
    height: Ge,
    hidden: On,
    high: Ge,
    href: null,
    hrefLang: null,
    htmlFor: st,
    httpEquiv: st,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: On,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: On,
    itemId: null,
    itemProp: st,
    itemRef: st,
    itemScope: On,
    itemType: st,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: On,
    low: Ge,
    manifest: null,
    max: null,
    maxLength: Ge,
    media: null,
    method: null,
    min: null,
    minLength: Ge,
    multiple: On,
    muted: On,
    name: null,
    nonce: null,
    noModule: On,
    noValidate: On,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: On,
    optimum: Ge,
    pattern: null,
    ping: st,
    placeholder: null,
    playsInline: On,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: On,
    referrerPolicy: null,
    rel: st,
    required: On,
    reversed: On,
    rows: Ge,
    rowSpan: Ge,
    sandbox: st,
    scope: null,
    scoped: On,
    seamless: On,
    selected: On,
    shadowRootClonable: On,
    shadowRootDelegatesFocus: On,
    shadowRootMode: null,
    shape: null,
    size: Ge,
    sizes: null,
    slot: null,
    span: Ge,
    spellCheck: bt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: Ge,
    step: null,
    style: null,
    tabIndex: Ge,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: On,
    useMap: null,
    value: bt,
    width: Ge,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: st,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: Ge,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: Ge,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: On,
    // Lists. Use CSS to reduce space between items instead
    declare: On,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: Ge,
    // `<img>` and `<object>`
    leftMargin: Ge,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: Ge,
    // `<body>`
    marginWidth: Ge,
    // `<body>`
    noResize: On,
    // `<frame>`
    noHref: On,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: On,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: On,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: Ge,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: bt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: Ge,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: Ge,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: On,
    disableRemotePlayback: On,
    prefix: null,
    property: null,
    results: Ge,
    security: null,
    unselectable: null
  }
}), bV = Ia({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: GC,
  properties: {
    about: ar,
    accentHeight: Ge,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: Ge,
    amplitude: Ge,
    arabicForm: null,
    ascent: Ge,
    attributeName: null,
    attributeType: null,
    azimuth: Ge,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: Ge,
    by: null,
    calcMode: null,
    capHeight: Ge,
    className: st,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: Ge,
    diffuseConstant: Ge,
    direction: null,
    display: null,
    dur: null,
    divisor: Ge,
    dominantBaseline: null,
    download: On,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: Ge,
    enableBackground: null,
    end: null,
    event: null,
    exponent: Ge,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: Ge,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: da,
    g2: da,
    glyphName: da,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: Ge,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: Ge,
    horizOriginX: Ge,
    horizOriginY: Ge,
    id: null,
    ideographic: Ge,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: Ge,
    k: Ge,
    k1: Ge,
    k2: Ge,
    k3: Ge,
    k4: Ge,
    kernelMatrix: ar,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: Ge,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: Ge,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: Ge,
    overlineThickness: Ge,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: Ge,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: st,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: Ge,
    pointsAtY: Ge,
    pointsAtZ: Ge,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: ar,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: ar,
    rev: ar,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: ar,
    requiredFeatures: ar,
    requiredFonts: ar,
    requiredFormats: ar,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: Ge,
    specularExponent: Ge,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: Ge,
    strikethroughThickness: Ge,
    string: null,
    stroke: null,
    strokeDashArray: ar,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: Ge,
    strokeOpacity: Ge,
    strokeWidth: null,
    style: null,
    surfaceScale: Ge,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: ar,
    tabIndex: Ge,
    tableValues: null,
    target: null,
    targetX: Ge,
    targetY: Ge,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: ar,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: Ge,
    underlineThickness: Ge,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: Ge,
    values: null,
    vAlphabetic: Ge,
    vMathematical: Ge,
    vectorEffect: null,
    vHanging: Ge,
    vIdeographic: Ge,
    version: null,
    vertAdvY: Ge,
    vertOriginX: Ge,
    vertOriginY: Ge,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: Ge,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), xV = /^data[-\w.:]+$/i, l_ = /-[a-z]/g, _V = /[A-Z]/g;
function SV(e, n) {
  const r = Ph(n);
  let i = n, a = _r;
  if (r in e.normal)
    return e.property[e.normal[r]];
  if (r.length > 4 && r.slice(0, 4) === "data" && xV.test(n)) {
    if (n.charAt(4) === "-") {
      const o = n.slice(5).replace(l_, jV);
      i = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = n.slice(4);
      if (!l_.test(o)) {
        let s = o.replace(_V, NV);
        s.charAt(0) !== "-" && (s = "-" + s), n = "data" + s;
      }
    }
    a = Xy;
  }
  return new a(i, n);
}
function NV(e) {
  return "-" + e.toLowerCase();
}
function jV(e) {
  return e.charAt(1).toUpperCase();
}
const wV = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, CV = qC([KC, WC, JC, QC, kV], "html"), Zy = qC([KC, WC, JC, QC, bV], "svg");
function IV(e) {
  return e.join(" ").trim();
}
var Yi = {}, Jd, c_;
function FV() {
  if (c_) return Jd;
  c_ = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, n = /\n/g, r = /^\s*/, i = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, a = /^:\s*/, o = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, s = /^[;\s]*/, l = /^\s+|\s+$/g, u = `
`, p = "/", d = "*", f = "", h = "comment", v = "declaration";
  Jd = function(j, N) {
    if (typeof j != "string")
      throw new TypeError("First argument must be a string");
    if (!j) return [];
    N = N || {};
    var x = 1, g = 1;
    function P(D) {
      var M = D.match(n);
      M && (x += M.length);
      var Z = D.lastIndexOf(u);
      g = ~Z ? D.length - Z : g + D.length;
    }
    function E() {
      var D = { line: x, column: g };
      return function(M) {
        return M.position = new I(D), H(), M;
      };
    }
    function I(D) {
      this.start = D, this.end = { line: x, column: g }, this.source = N.source;
    }
    I.prototype.content = j;
    function w(D) {
      var M = new Error(
        N.source + ":" + x + ":" + g + ": " + D
      );
      if (M.reason = D, M.filename = N.source, M.line = x, M.column = g, M.source = j, !N.silent) throw M;
    }
    function A(D) {
      var M = D.exec(j);
      if (M) {
        var Z = M[0];
        return P(Z), j = j.slice(Z.length), M;
      }
    }
    function H() {
      A(r);
    }
    function Y(D) {
      var M;
      for (D = D || []; M = ne(); )
        M !== !1 && D.push(M);
      return D;
    }
    function ne() {
      var D = E();
      if (!(p != j.charAt(0) || d != j.charAt(1))) {
        for (var M = 2; f != j.charAt(M) && (d != j.charAt(M) || p != j.charAt(M + 1)); )
          ++M;
        if (M += 2, f === j.charAt(M - 1))
          return w("End of comment missing");
        var Z = j.slice(2, M - 2);
        return g += 2, P(Z), j = j.slice(M), g += 2, D({
          type: h,
          comment: Z
        });
      }
    }
    function W() {
      var D = E(), M = A(i);
      if (M) {
        if (ne(), !A(a)) return w("property missing ':'");
        var Z = A(o), je = D({
          type: v,
          property: C(M[0].replace(e, f)),
          value: Z ? C(Z[0].replace(e, f)) : f
        });
        return A(s), je;
      }
    }
    function B() {
      var D = [];
      Y(D);
      for (var M; M = W(); )
        M !== !1 && (D.push(M), Y(D));
      return D;
    }
    return H(), B();
  };
  function C(j) {
    return j ? j.replace(l, f) : f;
  }
  return Jd;
}
var u_;
function EV() {
  if (u_) return Yi;
  u_ = 1;
  var e = Yi && Yi.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(Yi, "__esModule", { value: !0 }), Yi.default = r;
  var n = e(FV());
  function r(i, a) {
    var o = null;
    if (!i || typeof i != "string")
      return o;
    var s = (0, n.default)(i), l = typeof a == "function";
    return s.forEach(function(u) {
      if (u.type === "declaration") {
        var p = u.property, d = u.value;
        l ? a(p, d, u) : d && (o = o || {}, o[p] = d);
      }
    }), o;
  }
  return Yi;
}
var $V = EV();
const d_ = /* @__PURE__ */ py($V), TV = d_.default || d_, XC = ZC("end"), eg = ZC("start");
function ZC(e) {
  return n;
  function n(r) {
    const i = r && r.position && r.position[e] || {};
    if (typeof i.line == "number" && i.line > 0 && typeof i.column == "number" && i.column > 0)
      return {
        line: i.line,
        column: i.column,
        offset: typeof i.offset == "number" && i.offset > -1 ? i.offset : void 0
      };
  }
}
function OV(e) {
  const n = eg(e), r = XC(e);
  if (n && r)
    return { start: n, end: r };
}
function _o(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? m_(e.position) : "start" in e || "end" in e ? m_(e) : "line" in e || "column" in e ? Ah(e) : "";
}
function Ah(e) {
  return p_(e && e.line) + ":" + p_(e && e.column);
}
function m_(e) {
  return Ah(e && e.start) + "-" + Ah(e && e.end);
}
function p_(e) {
  return e && typeof e == "number" ? e : 1;
}
class Bt extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(n, r, i) {
    super(), typeof r == "string" && (i = r, r = void 0);
    let a = "", o = {}, s = !1;
    if (r && ("line" in r && "column" in r ? o = { place: r } : "start" in r && "end" in r ? o = { place: r } : "type" in r ? o = {
      ancestors: [r],
      place: r.position
    } : o = { ...r }), typeof n == "string" ? a = n : !o.cause && n && (s = !0, a = n.message, o.cause = n), !o.ruleId && !o.source && typeof i == "string") {
      const u = i.indexOf(":");
      u === -1 ? o.ruleId = i : (o.source = i.slice(0, u), o.ruleId = i.slice(u + 1));
    }
    if (!o.place && o.ancestors && o.ancestors) {
      const u = o.ancestors[o.ancestors.length - 1];
      u && (o.place = u.position);
    }
    const l = o.place && "start" in o.place ? o.place.start : o.place;
    this.ancestors = o.ancestors || void 0, this.cause = o.cause || void 0, this.column = l ? l.column : void 0, this.fatal = void 0, this.file, this.message = a, this.line = l ? l.line : void 0, this.name = _o(o.place) || "1:1", this.place = o.place || void 0, this.reason = this.message, this.ruleId = o.ruleId || void 0, this.source = o.source || void 0, this.stack = s && o.cause && typeof o.cause.stack == "string" ? o.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
Bt.prototype.file = "";
Bt.prototype.name = "";
Bt.prototype.reason = "";
Bt.prototype.message = "";
Bt.prototype.stack = "";
Bt.prototype.column = void 0;
Bt.prototype.line = void 0;
Bt.prototype.ancestors = void 0;
Bt.prototype.cause = void 0;
Bt.prototype.fatal = void 0;
Bt.prototype.place = void 0;
Bt.prototype.ruleId = void 0;
Bt.prototype.source = void 0;
const ng = {}.hasOwnProperty, DV = /* @__PURE__ */ new Map(), PV = /[A-Z]/g, RV = /-([a-z])/g, AV = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), LV = /* @__PURE__ */ new Set(["td", "th"]), e1 = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function VV(e, n) {
  if (!n || n.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const r = n.filePath || void 0;
  let i;
  if (n.development) {
    if (typeof n.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    i = KV(r, n.jsxDEV);
  } else {
    if (typeof n.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof n.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    i = WV(r, n.jsx, n.jsxs);
  }
  const a = {
    Fragment: n.Fragment,
    ancestors: [],
    components: n.components || {},
    create: i,
    elementAttributeNameCase: n.elementAttributeNameCase || "react",
    evaluater: n.createEvaluater ? n.createEvaluater() : void 0,
    filePath: r,
    ignoreInvalidStyle: n.ignoreInvalidStyle || !1,
    passKeys: n.passKeys !== !1,
    passNode: n.passNode || !1,
    schema: n.space === "svg" ? Zy : CV,
    stylePropertyNameCase: n.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: n.tableCellAlignToStyle !== !1
  }, o = n1(a, e, void 0);
  return o && typeof o != "string" ? o : a.create(
    e,
    a.Fragment,
    { children: o || void 0 },
    void 0
  );
}
function n1(e, n, r) {
  if (n.type === "element")
    return zV(e, n, r);
  if (n.type === "mdxFlowExpression" || n.type === "mdxTextExpression")
    return UV(e, n);
  if (n.type === "mdxJsxFlowElement" || n.type === "mdxJsxTextElement")
    return BV(e, n, r);
  if (n.type === "mdxjsEsm")
    return MV(e, n);
  if (n.type === "root")
    return qV(e, n, r);
  if (n.type === "text")
    return HV(e, n);
}
function zV(e, n, r) {
  const i = e.schema;
  let a = i;
  n.tagName.toLowerCase() === "svg" && i.space === "html" && (a = Zy, e.schema = a), e.ancestors.push(n);
  const o = r1(e, n.tagName, !1), s = GV(e, n);
  let l = rg(e, n);
  return AV.has(n.tagName) && (l = l.filter(function(u) {
    return typeof u == "string" ? !yV(u) : !0;
  })), t1(e, s, o, n), tg(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function UV(e, n) {
  if (n.data && n.data.estree && e.evaluater) {
    const i = n.data.estree.body[0];
    return i.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(i.expression);
  }
  Oo(e, n.position);
}
function MV(e, n) {
  if (n.data && n.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(n.data.estree)
    );
  Oo(e, n.position);
}
function BV(e, n, r) {
  const i = e.schema;
  let a = i;
  n.name === "svg" && i.space === "html" && (a = Zy, e.schema = a), e.ancestors.push(n);
  const o = n.name === null ? e.Fragment : r1(e, n.name, !0), s = YV(e, n), l = rg(e, n);
  return t1(e, s, o, n), tg(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function qV(e, n, r) {
  const i = {};
  return tg(i, rg(e, n)), e.create(n, e.Fragment, i, r);
}
function HV(e, n) {
  return n.value;
}
function t1(e, n, r, i) {
  typeof r != "string" && r !== e.Fragment && e.passNode && (n.node = i);
}
function tg(e, n) {
  if (n.length > 0) {
    const r = n.length > 1 ? n : n[0];
    r && (e.children = r);
  }
}
function WV(e, n, r) {
  return i;
  function i(a, o, s, l) {
    const p = Array.isArray(s.children) ? r : n;
    return l ? p(o, s, l) : p(o, s);
  }
}
function KV(e, n) {
  return r;
  function r(i, a, o, s) {
    const l = Array.isArray(o.children), u = eg(i);
    return n(
      a,
      o,
      s,
      l,
      {
        columnNumber: u ? u.column - 1 : void 0,
        fileName: e,
        lineNumber: u ? u.line : void 0
      },
      void 0
    );
  }
}
function GV(e, n) {
  const r = {};
  let i, a;
  for (a in n.properties)
    if (a !== "children" && ng.call(n.properties, a)) {
      const o = JV(e, a, n.properties[a]);
      if (o) {
        const [s, l] = o;
        e.tableCellAlignToStyle && s === "align" && typeof l == "string" && LV.has(n.tagName) ? i = l : r[s] = l;
      }
    }
  if (i) {
    const o = (
      /** @type {Style} */
      r.style || (r.style = {})
    );
    o[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = i;
  }
  return r;
}
function YV(e, n) {
  const r = {};
  for (const i of n.attributes)
    if (i.type === "mdxJsxExpressionAttribute")
      if (i.data && i.data.estree && e.evaluater) {
        const o = i.data.estree.body[0];
        o.type;
        const s = o.expression;
        s.type;
        const l = s.properties[0];
        l.type, Object.assign(
          r,
          e.evaluater.evaluateExpression(l.argument)
        );
      } else
        Oo(e, n.position);
    else {
      const a = i.name;
      let o;
      if (i.value && typeof i.value == "object")
        if (i.value.data && i.value.data.estree && e.evaluater) {
          const l = i.value.data.estree.body[0];
          l.type, o = e.evaluater.evaluateExpression(l.expression);
        } else
          Oo(e, n.position);
      else
        o = i.value === null ? !0 : i.value;
      r[a] = /** @type {Props[keyof Props]} */
      o;
    }
  return r;
}
function rg(e, n) {
  const r = [];
  let i = -1;
  const a = e.passKeys ? /* @__PURE__ */ new Map() : DV;
  for (; ++i < n.children.length; ) {
    const o = n.children[i];
    let s;
    if (e.passKeys) {
      const u = o.type === "element" ? o.tagName : o.type === "mdxJsxFlowElement" || o.type === "mdxJsxTextElement" ? o.name : void 0;
      if (u) {
        const p = a.get(u) || 0;
        s = u + "-" + p, a.set(u, p + 1);
      }
    }
    const l = n1(e, o, s);
    l !== void 0 && r.push(l);
  }
  return r;
}
function JV(e, n, r) {
  const i = SV(e.schema, n);
  if (!(r == null || typeof r == "number" && Number.isNaN(r))) {
    if (Array.isArray(r) && (r = i.commaSeparated ? dV(r) : IV(r)), i.property === "style") {
      let a = typeof r == "object" ? r : QV(e, String(r));
      return e.stylePropertyNameCase === "css" && (a = XV(a)), ["style", a];
    }
    return [
      e.elementAttributeNameCase === "react" && i.space ? wV[i.property] || i.property : i.attribute,
      r
    ];
  }
}
function QV(e, n) {
  const r = {};
  try {
    TV(n, i);
  } catch (a) {
    if (!e.ignoreInvalidStyle) {
      const o = (
        /** @type {Error} */
        a
      ), s = new Bt("Cannot parse `style` attribute", {
        ancestors: e.ancestors,
        cause: o,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw s.file = e.filePath || void 0, s.url = e1 + "#cannot-parse-style-attribute", s;
    }
  }
  return r;
  function i(a, o) {
    let s = a;
    s.slice(0, 2) !== "--" && (s.slice(0, 4) === "-ms-" && (s = "ms-" + s.slice(4)), s = s.replace(RV, e3)), r[s] = o;
  }
}
function r1(e, n, r) {
  let i;
  if (!r)
    i = { type: "Literal", value: n };
  else if (n.includes(".")) {
    const a = n.split(".");
    let o = -1, s;
    for (; ++o < a.length; ) {
      const l = a_(a[o]) ? { type: "Identifier", name: a[o] } : { type: "Literal", value: a[o] };
      s = s ? {
        type: "MemberExpression",
        object: s,
        property: l,
        computed: !!(o && l.type === "Literal"),
        optional: !1
      } : l;
    }
    i = s;
  } else
    i = a_(n) && !/^[a-z]/.test(n) ? { type: "Identifier", name: n } : { type: "Literal", value: n };
  if (i.type === "Literal") {
    const a = (
      /** @type {keyof JSX.IntrinsicElements} */
      i.value
    );
    return ng.call(e.components, a) ? e.components[a] : a;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(i);
  Oo(e);
}
function Oo(e, n) {
  const r = new Bt(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: n,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw r.file = e.filePath || void 0, r.url = e1 + "#cannot-handle-mdx-estrees-without-createevaluater", r;
}
function XV(e) {
  const n = {};
  let r;
  for (r in e)
    ng.call(e, r) && (n[ZV(r)] = e[r]);
  return n;
}
function ZV(e) {
  let n = e.replace(PV, n3);
  return n.slice(0, 3) === "ms-" && (n = "-" + n), n;
}
function e3(e, n) {
  return n.toUpperCase();
}
function n3(e) {
  return "-" + e.toLowerCase();
}
const Qd = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, t3 = {};
function r3(e, n) {
  const r = t3, i = typeof r.includeImageAlt == "boolean" ? r.includeImageAlt : !0, a = typeof r.includeHtml == "boolean" ? r.includeHtml : !0;
  return i1(e, i, a);
}
function i1(e, n, r) {
  if (i3(e)) {
    if ("value" in e)
      return e.type === "html" && !r ? "" : e.value;
    if (n && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return f_(e.children, n, r);
  }
  return Array.isArray(e) ? f_(e, n, r) : "";
}
function f_(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; )
    i[a] = i1(e[a], n, r);
  return i.join("");
}
function i3(e) {
  return !!(e && typeof e == "object");
}
const h_ = document.createElement("i");
function ig(e) {
  const n = "&" + e + ";";
  h_.innerHTML = n;
  const r = h_.textContent;
  return r.charCodeAt(r.length - 1) === 59 && e !== "semi" || r === n ? !1 : r;
}
function Mr(e, n, r, i) {
  const a = e.length;
  let o = 0, s;
  if (n < 0 ? n = -n > a ? 0 : a + n : n = n > a ? a : n, r = r > 0 ? r : 0, i.length < 1e4)
    s = Array.from(i), s.unshift(n, r), e.splice(...s);
  else
    for (r && e.splice(n, r); o < i.length; )
      s = i.slice(o, o + 1e4), s.unshift(n, 0), e.splice(...s), o += 1e4, n += 1e4;
}
function dr(e, n) {
  return e.length > 0 ? (Mr(e, e.length, 0, n), e) : n;
}
const y_ = {}.hasOwnProperty;
function a3(e) {
  const n = {};
  let r = -1;
  for (; ++r < e.length; )
    o3(n, e[r]);
  return n;
}
function o3(e, n) {
  let r;
  for (r in n) {
    const a = (y_.call(e, r) ? e[r] : void 0) || (e[r] = {}), o = n[r];
    let s;
    if (o)
      for (s in o) {
        y_.call(a, s) || (a[s] = []);
        const l = o[s];
        s3(
          // @ts-expect-error Looks like a list.
          a[s],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function s3(e, n) {
  let r = -1;
  const i = [];
  for (; ++r < n.length; )
    (n[r].add === "after" ? e : i).push(n[r]);
  Mr(e, 0, 0, i);
}
function a1(e, n) {
  const r = Number.parseInt(e, n);
  return (
    // C0 except for HT, LF, FF, CR, space.
    r < 9 || r === 11 || r > 13 && r < 32 || // Control character (DEL) of C0, and C1 controls.
    r > 126 && r < 160 || // Lone high surrogates and low surrogates.
    r > 55295 && r < 57344 || // Noncharacters.
    r > 64975 && r < 65008 || /* eslint-disable no-bitwise */
    (r & 65535) === 65535 || (r & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    r > 1114111 ? "�" : String.fromCodePoint(r)
  );
}
function ma(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Ar = hi(/[A-Za-z]/), lr = hi(/[\dA-Za-z]/), l3 = hi(/[#-'*+\--9=?A-Z^-~]/);
function Lh(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const Vh = hi(/\d/), c3 = hi(/[\dA-Fa-f]/), u3 = hi(/[!-/:-@[-`{-~]/);
function $n(e) {
  return e !== null && e < -2;
}
function nr(e) {
  return e !== null && (e < 0 || e === 32);
}
function Qn(e) {
  return e === -2 || e === -1 || e === 32;
}
const d3 = hi(new RegExp("\\p{P}|\\p{S}", "u")), m3 = hi(/\s/);
function hi(e) {
  return n;
  function n(r) {
    return r !== null && r > -1 && e.test(String.fromCharCode(r));
  }
}
function Fa(e) {
  const n = [];
  let r = -1, i = 0, a = 0;
  for (; ++r < e.length; ) {
    const o = e.charCodeAt(r);
    let s = "";
    if (o === 37 && lr(e.charCodeAt(r + 1)) && lr(e.charCodeAt(r + 2)))
      a = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (s = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const l = e.charCodeAt(r + 1);
      o < 56320 && l > 56319 && l < 57344 ? (s = String.fromCharCode(o, l), a = 1) : s = "�";
    } else
      s = String.fromCharCode(o);
    s && (n.push(e.slice(i, r), encodeURIComponent(s)), i = r + a + 1, s = ""), a && (r += a, a = 0);
  }
  return n.join("") + e.slice(i);
}
function ct(e, n, r, i) {
  const a = i ? i - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return s;
  function s(u) {
    return Qn(u) ? (e.enter(r), l(u)) : n(u);
  }
  function l(u) {
    return Qn(u) && o++ < a ? (e.consume(u), l) : (e.exit(r), n(u));
  }
}
const p3 = {
  tokenize: f3
};
function f3(e) {
  const n = e.attempt(this.parser.constructs.contentInitial, i, a);
  let r;
  return n;
  function i(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), ct(e, n, "linePrefix");
  }
  function a(l) {
    return e.enter("paragraph"), o(l);
  }
  function o(l) {
    const u = e.enter("chunkText", {
      contentType: "text",
      previous: r
    });
    return r && (r.next = u), r = u, s(l);
  }
  function s(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return $n(l) ? (e.consume(l), e.exit("chunkText"), o) : (e.consume(l), s);
  }
}
const h3 = {
  tokenize: y3
}, g_ = {
  tokenize: g3
};
function y3(e) {
  const n = this, r = [];
  let i = 0, a, o, s;
  return l;
  function l(P) {
    if (i < r.length) {
      const E = r[i];
      return n.containerState = E[1], e.attempt(E[0].continuation, u, p)(P);
    }
    return p(P);
  }
  function u(P) {
    if (i++, n.containerState._closeFlow) {
      n.containerState._closeFlow = void 0, a && g();
      const E = n.events.length;
      let I = E, w;
      for (; I--; )
        if (n.events[I][0] === "exit" && n.events[I][1].type === "chunkFlow") {
          w = n.events[I][1].end;
          break;
        }
      x(i);
      let A = E;
      for (; A < n.events.length; )
        n.events[A][1].end = {
          ...w
        }, A++;
      return Mr(n.events, I + 1, 0, n.events.slice(E)), n.events.length = A, p(P);
    }
    return l(P);
  }
  function p(P) {
    if (i === r.length) {
      if (!a)
        return h(P);
      if (a.currentConstruct && a.currentConstruct.concrete)
        return C(P);
      n.interrupt = !!(a.currentConstruct && !a._gfmTableDynamicInterruptHack);
    }
    return n.containerState = {}, e.check(g_, d, f)(P);
  }
  function d(P) {
    return a && g(), x(i), h(P);
  }
  function f(P) {
    return n.parser.lazy[n.now().line] = i !== r.length, s = n.now().offset, C(P);
  }
  function h(P) {
    return n.containerState = {}, e.attempt(g_, v, C)(P);
  }
  function v(P) {
    return i++, r.push([n.currentConstruct, n.containerState]), h(P);
  }
  function C(P) {
    if (P === null) {
      a && g(), x(0), e.consume(P);
      return;
    }
    return a = a || n.parser.flow(n.now()), e.enter("chunkFlow", {
      _tokenizer: a,
      contentType: "flow",
      previous: o
    }), j(P);
  }
  function j(P) {
    if (P === null) {
      N(e.exit("chunkFlow"), !0), x(0), e.consume(P);
      return;
    }
    return $n(P) ? (e.consume(P), N(e.exit("chunkFlow")), i = 0, n.interrupt = void 0, l) : (e.consume(P), j);
  }
  function N(P, E) {
    const I = n.sliceStream(P);
    if (E && I.push(null), P.previous = o, o && (o.next = P), o = P, a.defineSkip(P.start), a.write(I), n.parser.lazy[P.start.line]) {
      let w = a.events.length;
      for (; w--; )
        if (
          // The token starts before the line ending…
          a.events[w][1].start.offset < s && // …and either is not ended yet…
          (!a.events[w][1].end || // …or ends after it.
          a.events[w][1].end.offset > s)
        )
          return;
      const A = n.events.length;
      let H = A, Y, ne;
      for (; H--; )
        if (n.events[H][0] === "exit" && n.events[H][1].type === "chunkFlow") {
          if (Y) {
            ne = n.events[H][1].end;
            break;
          }
          Y = !0;
        }
      for (x(i), w = A; w < n.events.length; )
        n.events[w][1].end = {
          ...ne
        }, w++;
      Mr(n.events, H + 1, 0, n.events.slice(A)), n.events.length = w;
    }
  }
  function x(P) {
    let E = r.length;
    for (; E-- > P; ) {
      const I = r[E];
      n.containerState = I[1], I[0].exit.call(n, e);
    }
    r.length = P;
  }
  function g() {
    a.write([null]), o = void 0, a = void 0, n.containerState._closeFlow = void 0;
  }
}
function g3(e, n, r) {
  return ct(e, e.attempt(this.parser.constructs.document, n, r), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function v_(e) {
  if (e === null || nr(e) || m3(e))
    return 1;
  if (d3(e))
    return 2;
}
function ag(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; ) {
    const o = e[a].resolveAll;
    o && !i.includes(o) && (n = o(n, r), i.push(o));
  }
  return n;
}
const zh = {
  name: "attention",
  resolveAll: v3,
  tokenize: k3
};
function v3(e, n) {
  let r = -1, i, a, o, s, l, u, p, d;
  for (; ++r < e.length; )
    if (e[r][0] === "enter" && e[r][1].type === "attentionSequence" && e[r][1]._close) {
      for (i = r; i--; )
        if (e[i][0] === "exit" && e[i][1].type === "attentionSequence" && e[i][1]._open && // If the markers are the same:
        n.sliceSerialize(e[i][1]).charCodeAt(0) === n.sliceSerialize(e[r][1]).charCodeAt(0)) {
          if ((e[i][1]._close || e[r][1]._open) && (e[r][1].end.offset - e[r][1].start.offset) % 3 && !((e[i][1].end.offset - e[i][1].start.offset + e[r][1].end.offset - e[r][1].start.offset) % 3))
            continue;
          u = e[i][1].end.offset - e[i][1].start.offset > 1 && e[r][1].end.offset - e[r][1].start.offset > 1 ? 2 : 1;
          const f = {
            ...e[i][1].end
          }, h = {
            ...e[r][1].start
          };
          k_(f, -u), k_(h, u), s = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: {
              ...e[i][1].end
            }
          }, l = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[r][1].start
            },
            end: h
          }, o = {
            type: u > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[i][1].end
            },
            end: {
              ...e[r][1].start
            }
          }, a = {
            type: u > 1 ? "strong" : "emphasis",
            start: {
              ...s.start
            },
            end: {
              ...l.end
            }
          }, e[i][1].end = {
            ...s.start
          }, e[r][1].start = {
            ...l.end
          }, p = [], e[i][1].end.offset - e[i][1].start.offset && (p = dr(p, [["enter", e[i][1], n], ["exit", e[i][1], n]])), p = dr(p, [["enter", a, n], ["enter", s, n], ["exit", s, n], ["enter", o, n]]), p = dr(p, ag(n.parser.constructs.insideSpan.null, e.slice(i + 1, r), n)), p = dr(p, [["exit", o, n], ["enter", l, n], ["exit", l, n], ["exit", a, n]]), e[r][1].end.offset - e[r][1].start.offset ? (d = 2, p = dr(p, [["enter", e[r][1], n], ["exit", e[r][1], n]])) : d = 0, Mr(e, i - 1, r - i + 3, p), r = i + p.length - d - 2;
          break;
        }
    }
  for (r = -1; ++r < e.length; )
    e[r][1].type === "attentionSequence" && (e[r][1].type = "data");
  return e;
}
function k3(e, n) {
  const r = this.parser.constructs.attentionMarkers.null, i = this.previous, a = v_(i);
  let o;
  return s;
  function s(u) {
    return o = u, e.enter("attentionSequence"), l(u);
  }
  function l(u) {
    if (u === o)
      return e.consume(u), l;
    const p = e.exit("attentionSequence"), d = v_(u), f = !d || d === 2 && a || r.includes(u), h = !a || a === 2 && d || r.includes(i);
    return p._open = !!(o === 42 ? f : f && (a || !h)), p._close = !!(o === 42 ? h : h && (d || !f)), n(u);
  }
}
function k_(e, n) {
  e.column += n, e.offset += n, e._bufferIndex += n;
}
const b3 = {
  name: "autolink",
  tokenize: x3
};
function x3(e, n, r) {
  let i = 0;
  return a;
  function a(v) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(v) {
    return Ar(v) ? (e.consume(v), s) : v === 64 ? r(v) : p(v);
  }
  function s(v) {
    return v === 43 || v === 45 || v === 46 || lr(v) ? (i = 1, l(v)) : p(v);
  }
  function l(v) {
    return v === 58 ? (e.consume(v), i = 0, u) : (v === 43 || v === 45 || v === 46 || lr(v)) && i++ < 32 ? (e.consume(v), l) : (i = 0, p(v));
  }
  function u(v) {
    return v === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.exit("autolink"), n) : v === null || v === 32 || v === 60 || Lh(v) ? r(v) : (e.consume(v), u);
  }
  function p(v) {
    return v === 64 ? (e.consume(v), d) : l3(v) ? (e.consume(v), p) : r(v);
  }
  function d(v) {
    return lr(v) ? f(v) : r(v);
  }
  function f(v) {
    return v === 46 ? (e.consume(v), i = 0, d) : v === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.exit("autolink"), n) : h(v);
  }
  function h(v) {
    if ((v === 45 || lr(v)) && i++ < 63) {
      const C = v === 45 ? h : f;
      return e.consume(v), C;
    }
    return r(v);
  }
}
const Dl = {
  partial: !0,
  tokenize: _3
};
function _3(e, n, r) {
  return i;
  function i(o) {
    return Qn(o) ? ct(e, a, "linePrefix")(o) : a(o);
  }
  function a(o) {
    return o === null || $n(o) ? n(o) : r(o);
  }
}
const o1 = {
  continuation: {
    tokenize: N3
  },
  exit: j3,
  name: "blockQuote",
  tokenize: S3
};
function S3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    if (s === 62) {
      const l = i.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(s), e.exit("blockQuoteMarker"), o;
    }
    return r(s);
  }
  function o(s) {
    return Qn(s) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(s), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), n) : (e.exit("blockQuotePrefix"), n(s));
  }
}
function N3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return Qn(s) ? ct(e, o, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s) : o(s);
  }
  function o(s) {
    return e.attempt(o1, n, r)(s);
  }
}
function j3(e) {
  e.exit("blockQuote");
}
const s1 = {
  name: "characterEscape",
  tokenize: w3
};
function w3(e, n, r) {
  return i;
  function i(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), a;
  }
  function a(o) {
    return u3(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), n) : r(o);
  }
}
const l1 = {
  name: "characterReference",
  tokenize: C3
};
function C3(e, n, r) {
  const i = this;
  let a = 0, o, s;
  return l;
  function l(f) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), u;
  }
  function u(f) {
    return f === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(f), e.exit("characterReferenceMarkerNumeric"), p) : (e.enter("characterReferenceValue"), o = 31, s = lr, d(f));
  }
  function p(f) {
    return f === 88 || f === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(f), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, s = c3, d) : (e.enter("characterReferenceValue"), o = 7, s = Vh, d(f));
  }
  function d(f) {
    if (f === 59 && a) {
      const h = e.exit("characterReferenceValue");
      return s === lr && !ig(i.sliceSerialize(h)) ? r(f) : (e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), e.exit("characterReference"), n);
    }
    return s(f) && a++ < o ? (e.consume(f), d) : r(f);
  }
}
const b_ = {
  partial: !0,
  tokenize: F3
}, x_ = {
  concrete: !0,
  name: "codeFenced",
  tokenize: I3
};
function I3(e, n, r) {
  const i = this, a = {
    partial: !0,
    tokenize: I
  };
  let o = 0, s = 0, l;
  return u;
  function u(w) {
    return p(w);
  }
  function p(w) {
    const A = i.events[i.events.length - 1];
    return o = A && A[1].type === "linePrefix" ? A[2].sliceSerialize(A[1], !0).length : 0, l = w, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), d(w);
  }
  function d(w) {
    return w === l ? (s++, e.consume(w), d) : s < 3 ? r(w) : (e.exit("codeFencedFenceSequence"), Qn(w) ? ct(e, f, "whitespace")(w) : f(w));
  }
  function f(w) {
    return w === null || $n(w) ? (e.exit("codeFencedFence"), i.interrupt ? n(w) : e.check(b_, j, E)(w)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), h(w));
  }
  function h(w) {
    return w === null || $n(w) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), f(w)) : Qn(w) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), ct(e, v, "whitespace")(w)) : w === 96 && w === l ? r(w) : (e.consume(w), h);
  }
  function v(w) {
    return w === null || $n(w) ? f(w) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), C(w));
  }
  function C(w) {
    return w === null || $n(w) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), f(w)) : w === 96 && w === l ? r(w) : (e.consume(w), C);
  }
  function j(w) {
    return e.attempt(a, E, N)(w);
  }
  function N(w) {
    return e.enter("lineEnding"), e.consume(w), e.exit("lineEnding"), x;
  }
  function x(w) {
    return o > 0 && Qn(w) ? ct(e, g, "linePrefix", o + 1)(w) : g(w);
  }
  function g(w) {
    return w === null || $n(w) ? e.check(b_, j, E)(w) : (e.enter("codeFlowValue"), P(w));
  }
  function P(w) {
    return w === null || $n(w) ? (e.exit("codeFlowValue"), g(w)) : (e.consume(w), P);
  }
  function E(w) {
    return e.exit("codeFenced"), n(w);
  }
  function I(w, A, H) {
    let Y = 0;
    return ne;
    function ne(Z) {
      return w.enter("lineEnding"), w.consume(Z), w.exit("lineEnding"), W;
    }
    function W(Z) {
      return w.enter("codeFencedFence"), Qn(Z) ? ct(w, B, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(Z) : B(Z);
    }
    function B(Z) {
      return Z === l ? (w.enter("codeFencedFenceSequence"), D(Z)) : H(Z);
    }
    function D(Z) {
      return Z === l ? (Y++, w.consume(Z), D) : Y >= s ? (w.exit("codeFencedFenceSequence"), Qn(Z) ? ct(w, M, "whitespace")(Z) : M(Z)) : H(Z);
    }
    function M(Z) {
      return Z === null || $n(Z) ? (w.exit("codeFencedFence"), A(Z)) : H(Z);
    }
  }
}
function F3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return s === null ? r(s) : (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
const Xd = {
  name: "codeIndented",
  tokenize: $3
}, E3 = {
  partial: !0,
  tokenize: T3
};
function $3(e, n, r) {
  const i = this;
  return a;
  function a(p) {
    return e.enter("codeIndented"), ct(e, o, "linePrefix", 5)(p);
  }
  function o(p) {
    const d = i.events[i.events.length - 1];
    return d && d[1].type === "linePrefix" && d[2].sliceSerialize(d[1], !0).length >= 4 ? s(p) : r(p);
  }
  function s(p) {
    return p === null ? u(p) : $n(p) ? e.attempt(E3, s, u)(p) : (e.enter("codeFlowValue"), l(p));
  }
  function l(p) {
    return p === null || $n(p) ? (e.exit("codeFlowValue"), s(p)) : (e.consume(p), l);
  }
  function u(p) {
    return e.exit("codeIndented"), n(p);
  }
}
function T3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return i.parser.lazy[i.now().line] ? r(s) : $n(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), a) : ct(e, o, "linePrefix", 5)(s);
  }
  function o(s) {
    const l = i.events[i.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : $n(s) ? a(s) : r(s);
  }
}
const O3 = {
  name: "codeText",
  previous: P3,
  resolve: D3,
  tokenize: R3
};
function D3(e) {
  let n = e.length - 4, r = 3, i, a;
  if ((e[r][1].type === "lineEnding" || e[r][1].type === "space") && (e[n][1].type === "lineEnding" || e[n][1].type === "space")) {
    for (i = r; ++i < n; )
      if (e[i][1].type === "codeTextData") {
        e[r][1].type = "codeTextPadding", e[n][1].type = "codeTextPadding", r += 2, n -= 2;
        break;
      }
  }
  for (i = r - 1, n++; ++i <= n; )
    a === void 0 ? i !== n && e[i][1].type !== "lineEnding" && (a = i) : (i === n || e[i][1].type === "lineEnding") && (e[a][1].type = "codeTextData", i !== a + 2 && (e[a][1].end = e[i - 1][1].end, e.splice(a + 2, i - a - 2), n -= i - a - 2, i = a + 2), a = void 0);
  return e;
}
function P3(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function R3(e, n, r) {
  let i = 0, a, o;
  return s;
  function s(f) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(f);
  }
  function l(f) {
    return f === 96 ? (e.consume(f), i++, l) : (e.exit("codeTextSequence"), u(f));
  }
  function u(f) {
    return f === null ? r(f) : f === 32 ? (e.enter("space"), e.consume(f), e.exit("space"), u) : f === 96 ? (o = e.enter("codeTextSequence"), a = 0, d(f)) : $n(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), u) : (e.enter("codeTextData"), p(f));
  }
  function p(f) {
    return f === null || f === 32 || f === 96 || $n(f) ? (e.exit("codeTextData"), u(f)) : (e.consume(f), p);
  }
  function d(f) {
    return f === 96 ? (e.consume(f), a++, d) : a === i ? (e.exit("codeTextSequence"), e.exit("codeText"), n(f)) : (o.type = "codeTextData", p(f));
  }
}
class A3 {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(n) {
    this.left = n ? [...n] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(n) {
    if (n < 0 || n >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + n + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return n < this.left.length ? this.left[n] : this.right[this.right.length - n + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(n, r) {
    const i = r ?? Number.POSITIVE_INFINITY;
    return i < this.left.length ? this.left.slice(n, i) : n > this.left.length ? this.right.slice(this.right.length - i + this.left.length, this.right.length - n + this.left.length).reverse() : this.left.slice(n).concat(this.right.slice(this.right.length - i + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(n, r, i) {
    const a = r || 0;
    this.setCursor(Math.trunc(n));
    const o = this.right.splice(this.right.length - a, Number.POSITIVE_INFINITY);
    return i && Ya(this.left, i), o.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(n) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(n);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(n) {
    this.setCursor(Number.POSITIVE_INFINITY), Ya(this.left, n);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(n) {
    this.setCursor(0), this.right.push(n);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(n) {
    this.setCursor(0), Ya(this.right, n.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n) {
    if (!(n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0))
      if (n < this.left.length) {
        const r = this.left.splice(n, Number.POSITIVE_INFINITY);
        Ya(this.right, r.reverse());
      } else {
        const r = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
        Ya(this.left, r.reverse());
      }
  }
}
function Ya(e, n) {
  let r = 0;
  if (n.length < 1e4)
    e.push(...n);
  else
    for (; r < n.length; )
      e.push(...n.slice(r, r + 1e4)), r += 1e4;
}
function c1(e) {
  const n = {};
  let r = -1, i, a, o, s, l, u, p;
  const d = new A3(e);
  for (; ++r < d.length; ) {
    for (; r in n; )
      r = n[r];
    if (i = d.get(r), r && i[1].type === "chunkFlow" && d.get(r - 1)[1].type === "listItemPrefix" && (u = i[1]._tokenizer.events, o = 0, o < u.length && u[o][1].type === "lineEndingBlank" && (o += 2), o < u.length && u[o][1].type === "content"))
      for (; ++o < u.length && u[o][1].type !== "content"; )
        u[o][1].type === "chunkText" && (u[o][1]._isInFirstContentOfListItem = !0, o++);
    if (i[0] === "enter")
      i[1].contentType && (Object.assign(n, L3(d, r)), r = n[r], p = !0);
    else if (i[1]._container) {
      for (o = r, a = void 0; o-- && (s = d.get(o), s[1].type === "lineEnding" || s[1].type === "lineEndingBlank"); )
        s[0] === "enter" && (a && (d.get(a)[1].type = "lineEndingBlank"), s[1].type = "lineEnding", a = o);
      a && (i[1].end = {
        ...d.get(a)[1].start
      }, l = d.slice(a, r), l.unshift(i), d.splice(a, r - a + 1, l));
    }
  }
  return Mr(e, 0, Number.POSITIVE_INFINITY, d.slice(0)), !p;
}
function L3(e, n) {
  const r = e.get(n)[1], i = e.get(n)[2];
  let a = n - 1;
  const o = [], s = r._tokenizer || i.parser[r.contentType](r.start), l = s.events, u = [], p = {};
  let d, f, h = -1, v = r, C = 0, j = 0;
  const N = [j];
  for (; v; ) {
    for (; e.get(++a)[1] !== v; )
      ;
    o.push(a), v._tokenizer || (d = i.sliceStream(v), v.next || d.push(null), f && s.defineSkip(v.start), v._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = !0), s.write(d), v._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = void 0)), f = v, v = v.next;
  }
  for (v = r; ++h < l.length; )
    // Find a void token that includes a break.
    l[h][0] === "exit" && l[h - 1][0] === "enter" && l[h][1].type === l[h - 1][1].type && l[h][1].start.line !== l[h][1].end.line && (j = h + 1, N.push(j), v._tokenizer = void 0, v.previous = void 0, v = v.next);
  for (s.events = [], v ? (v._tokenizer = void 0, v.previous = void 0) : N.pop(), h = N.length; h--; ) {
    const x = l.slice(N[h], N[h + 1]), g = o.pop();
    u.push([g, g + x.length - 1]), e.splice(g, 2, x);
  }
  for (u.reverse(), h = -1; ++h < u.length; )
    p[C + u[h][0]] = C + u[h][1], C += u[h][1] - u[h][0] - 1;
  return p;
}
const V3 = {
  resolve: U3,
  tokenize: M3
}, z3 = {
  partial: !0,
  tokenize: B3
};
function U3(e) {
  return c1(e), e;
}
function M3(e, n) {
  let r;
  return i;
  function i(l) {
    return e.enter("content"), r = e.enter("chunkContent", {
      contentType: "content"
    }), a(l);
  }
  function a(l) {
    return l === null ? o(l) : $n(l) ? e.check(z3, s, o)(l) : (e.consume(l), a);
  }
  function o(l) {
    return e.exit("chunkContent"), e.exit("content"), n(l);
  }
  function s(l) {
    return e.consume(l), e.exit("chunkContent"), r.next = e.enter("chunkContent", {
      contentType: "content",
      previous: r
    }), r = r.next, a;
  }
}
function B3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), ct(e, o, "linePrefix");
  }
  function o(s) {
    if (s === null || $n(s))
      return r(s);
    const l = i.events[i.events.length - 1];
    return !i.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : e.interrupt(i.parser.constructs.flow, r, n)(s);
  }
}
function u1(e, n, r, i, a, o, s, l, u) {
  const p = u || Number.POSITIVE_INFINITY;
  let d = 0;
  return f;
  function f(x) {
    return x === 60 ? (e.enter(i), e.enter(a), e.enter(o), e.consume(x), e.exit(o), h) : x === null || x === 32 || x === 41 || Lh(x) ? r(x) : (e.enter(i), e.enter(s), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), j(x));
  }
  function h(x) {
    return x === 62 ? (e.enter(o), e.consume(x), e.exit(o), e.exit(a), e.exit(i), n) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), v(x));
  }
  function v(x) {
    return x === 62 ? (e.exit("chunkString"), e.exit(l), h(x)) : x === null || x === 60 || $n(x) ? r(x) : (e.consume(x), x === 92 ? C : v);
  }
  function C(x) {
    return x === 60 || x === 62 || x === 92 ? (e.consume(x), v) : v(x);
  }
  function j(x) {
    return !d && (x === null || x === 41 || nr(x)) ? (e.exit("chunkString"), e.exit(l), e.exit(s), e.exit(i), n(x)) : d < p && x === 40 ? (e.consume(x), d++, j) : x === 41 ? (e.consume(x), d--, j) : x === null || x === 32 || x === 40 || Lh(x) ? r(x) : (e.consume(x), x === 92 ? N : j);
  }
  function N(x) {
    return x === 40 || x === 41 || x === 92 ? (e.consume(x), j) : j(x);
  }
}
function d1(e, n, r, i, a, o) {
  const s = this;
  let l = 0, u;
  return p;
  function p(v) {
    return e.enter(i), e.enter(a), e.consume(v), e.exit(a), e.enter(o), d;
  }
  function d(v) {
    return l > 999 || v === null || v === 91 || v === 93 && !u || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    v === 94 && !l && "_hiddenFootnoteSupport" in s.parser.constructs ? r(v) : v === 93 ? (e.exit(o), e.enter(a), e.consume(v), e.exit(a), e.exit(i), n) : $n(v) ? (e.enter("lineEnding"), e.consume(v), e.exit("lineEnding"), d) : (e.enter("chunkString", {
      contentType: "string"
    }), f(v));
  }
  function f(v) {
    return v === null || v === 91 || v === 93 || $n(v) || l++ > 999 ? (e.exit("chunkString"), d(v)) : (e.consume(v), u || (u = !Qn(v)), v === 92 ? h : f);
  }
  function h(v) {
    return v === 91 || v === 92 || v === 93 ? (e.consume(v), l++, f) : f(v);
  }
}
function m1(e, n, r, i, a, o) {
  let s;
  return l;
  function l(h) {
    return h === 34 || h === 39 || h === 40 ? (e.enter(i), e.enter(a), e.consume(h), e.exit(a), s = h === 40 ? 41 : h, u) : r(h);
  }
  function u(h) {
    return h === s ? (e.enter(a), e.consume(h), e.exit(a), e.exit(i), n) : (e.enter(o), p(h));
  }
  function p(h) {
    return h === s ? (e.exit(o), u(s)) : h === null ? r(h) : $n(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), ct(e, p, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), d(h));
  }
  function d(h) {
    return h === s || h === null || $n(h) ? (e.exit("chunkString"), p(h)) : (e.consume(h), h === 92 ? f : d);
  }
  function f(h) {
    return h === s || h === 92 ? (e.consume(h), d) : d(h);
  }
}
function So(e, n) {
  let r;
  return i;
  function i(a) {
    return $n(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), r = !0, i) : Qn(a) ? ct(e, i, r ? "linePrefix" : "lineSuffix")(a) : n(a);
  }
}
const q3 = {
  name: "definition",
  tokenize: W3
}, H3 = {
  partial: !0,
  tokenize: K3
};
function W3(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(v) {
    return e.enter("definition"), s(v);
  }
  function s(v) {
    return d1.call(
      i,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(v);
  }
  function l(v) {
    return a = ma(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1)), v === 58 ? (e.enter("definitionMarker"), e.consume(v), e.exit("definitionMarker"), u) : r(v);
  }
  function u(v) {
    return nr(v) ? So(e, p)(v) : p(v);
  }
  function p(v) {
    return u1(
      e,
      d,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(v);
  }
  function d(v) {
    return e.attempt(H3, f, f)(v);
  }
  function f(v) {
    return Qn(v) ? ct(e, h, "whitespace")(v) : h(v);
  }
  function h(v) {
    return v === null || $n(v) ? (e.exit("definition"), i.parser.defined.push(a), n(v)) : r(v);
  }
}
function K3(e, n, r) {
  return i;
  function i(l) {
    return nr(l) ? So(e, a)(l) : r(l);
  }
  function a(l) {
    return m1(e, o, r, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(l);
  }
  function o(l) {
    return Qn(l) ? ct(e, s, "whitespace")(l) : s(l);
  }
  function s(l) {
    return l === null || $n(l) ? n(l) : r(l);
  }
}
const G3 = {
  name: "hardBreakEscape",
  tokenize: Y3
};
function Y3(e, n, r) {
  return i;
  function i(o) {
    return e.enter("hardBreakEscape"), e.consume(o), a;
  }
  function a(o) {
    return $n(o) ? (e.exit("hardBreakEscape"), n(o)) : r(o);
  }
}
const J3 = {
  name: "headingAtx",
  resolve: Q3,
  tokenize: X3
};
function Q3(e, n) {
  let r = e.length - 2, i = 3, a, o;
  return e[i][1].type === "whitespace" && (i += 2), r - 2 > i && e[r][1].type === "whitespace" && (r -= 2), e[r][1].type === "atxHeadingSequence" && (i === r - 1 || r - 4 > i && e[r - 2][1].type === "whitespace") && (r -= i + 1 === r ? 2 : 4), r > i && (a = {
    type: "atxHeadingText",
    start: e[i][1].start,
    end: e[r][1].end
  }, o = {
    type: "chunkText",
    start: e[i][1].start,
    end: e[r][1].end,
    contentType: "text"
  }, Mr(e, i, r - i + 1, [["enter", a, n], ["enter", o, n], ["exit", o, n], ["exit", a, n]])), e;
}
function X3(e, n, r) {
  let i = 0;
  return a;
  function a(d) {
    return e.enter("atxHeading"), o(d);
  }
  function o(d) {
    return e.enter("atxHeadingSequence"), s(d);
  }
  function s(d) {
    return d === 35 && i++ < 6 ? (e.consume(d), s) : d === null || nr(d) ? (e.exit("atxHeadingSequence"), l(d)) : r(d);
  }
  function l(d) {
    return d === 35 ? (e.enter("atxHeadingSequence"), u(d)) : d === null || $n(d) ? (e.exit("atxHeading"), n(d)) : Qn(d) ? ct(e, l, "whitespace")(d) : (e.enter("atxHeadingText"), p(d));
  }
  function u(d) {
    return d === 35 ? (e.consume(d), u) : (e.exit("atxHeadingSequence"), l(d));
  }
  function p(d) {
    return d === null || d === 35 || nr(d) ? (e.exit("atxHeadingText"), l(d)) : (e.consume(d), p);
  }
}
const Z3 = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], __ = ["pre", "script", "style", "textarea"], ez = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: rz,
  tokenize: iz
}, nz = {
  partial: !0,
  tokenize: oz
}, tz = {
  partial: !0,
  tokenize: az
};
function rz(e) {
  let n = e.length;
  for (; n-- && !(e[n][0] === "enter" && e[n][1].type === "htmlFlow"); )
    ;
  return n > 1 && e[n - 2][1].type === "linePrefix" && (e[n][1].start = e[n - 2][1].start, e[n + 1][1].start = e[n - 2][1].start, e.splice(n - 2, 2)), e;
}
function iz(e, n, r) {
  const i = this;
  let a, o, s, l, u;
  return p;
  function p(G) {
    return d(G);
  }
  function d(G) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(G), f;
  }
  function f(G) {
    return G === 33 ? (e.consume(G), h) : G === 47 ? (e.consume(G), o = !0, j) : G === 63 ? (e.consume(G), a = 3, i.interrupt ? n : q) : Ar(G) ? (e.consume(G), s = String.fromCharCode(G), N) : r(G);
  }
  function h(G) {
    return G === 45 ? (e.consume(G), a = 2, v) : G === 91 ? (e.consume(G), a = 5, l = 0, C) : Ar(G) ? (e.consume(G), a = 4, i.interrupt ? n : q) : r(G);
  }
  function v(G) {
    return G === 45 ? (e.consume(G), i.interrupt ? n : q) : r(G);
  }
  function C(G) {
    const Ye = "CDATA[";
    return G === Ye.charCodeAt(l++) ? (e.consume(G), l === Ye.length ? i.interrupt ? n : B : C) : r(G);
  }
  function j(G) {
    return Ar(G) ? (e.consume(G), s = String.fromCharCode(G), N) : r(G);
  }
  function N(G) {
    if (G === null || G === 47 || G === 62 || nr(G)) {
      const Ye = G === 47, sn = s.toLowerCase();
      return !Ye && !o && __.includes(sn) ? (a = 1, i.interrupt ? n(G) : B(G)) : Z3.includes(s.toLowerCase()) ? (a = 6, Ye ? (e.consume(G), x) : i.interrupt ? n(G) : B(G)) : (a = 7, i.interrupt && !i.parser.lazy[i.now().line] ? r(G) : o ? g(G) : P(G));
    }
    return G === 45 || lr(G) ? (e.consume(G), s += String.fromCharCode(G), N) : r(G);
  }
  function x(G) {
    return G === 62 ? (e.consume(G), i.interrupt ? n : B) : r(G);
  }
  function g(G) {
    return Qn(G) ? (e.consume(G), g) : ne(G);
  }
  function P(G) {
    return G === 47 ? (e.consume(G), ne) : G === 58 || G === 95 || Ar(G) ? (e.consume(G), E) : Qn(G) ? (e.consume(G), P) : ne(G);
  }
  function E(G) {
    return G === 45 || G === 46 || G === 58 || G === 95 || lr(G) ? (e.consume(G), E) : I(G);
  }
  function I(G) {
    return G === 61 ? (e.consume(G), w) : Qn(G) ? (e.consume(G), I) : P(G);
  }
  function w(G) {
    return G === null || G === 60 || G === 61 || G === 62 || G === 96 ? r(G) : G === 34 || G === 39 ? (e.consume(G), u = G, A) : Qn(G) ? (e.consume(G), w) : H(G);
  }
  function A(G) {
    return G === u ? (e.consume(G), u = null, Y) : G === null || $n(G) ? r(G) : (e.consume(G), A);
  }
  function H(G) {
    return G === null || G === 34 || G === 39 || G === 47 || G === 60 || G === 61 || G === 62 || G === 96 || nr(G) ? I(G) : (e.consume(G), H);
  }
  function Y(G) {
    return G === 47 || G === 62 || Qn(G) ? P(G) : r(G);
  }
  function ne(G) {
    return G === 62 ? (e.consume(G), W) : r(G);
  }
  function W(G) {
    return G === null || $n(G) ? B(G) : Qn(G) ? (e.consume(G), W) : r(G);
  }
  function B(G) {
    return G === 45 && a === 2 ? (e.consume(G), je) : G === 60 && a === 1 ? (e.consume(G), ge) : G === 62 && a === 4 ? (e.consume(G), _e) : G === 63 && a === 3 ? (e.consume(G), q) : G === 93 && a === 5 ? (e.consume(G), ke) : $n(G) && (a === 6 || a === 7) ? (e.exit("htmlFlowData"), e.check(nz, De, D)(G)) : G === null || $n(G) ? (e.exit("htmlFlowData"), D(G)) : (e.consume(G), B);
  }
  function D(G) {
    return e.check(tz, M, De)(G);
  }
  function M(G) {
    return e.enter("lineEnding"), e.consume(G), e.exit("lineEnding"), Z;
  }
  function Z(G) {
    return G === null || $n(G) ? D(G) : (e.enter("htmlFlowData"), B(G));
  }
  function je(G) {
    return G === 45 ? (e.consume(G), q) : B(G);
  }
  function ge(G) {
    return G === 47 ? (e.consume(G), s = "", ye) : B(G);
  }
  function ye(G) {
    if (G === 62) {
      const Ye = s.toLowerCase();
      return __.includes(Ye) ? (e.consume(G), _e) : B(G);
    }
    return Ar(G) && s.length < 8 ? (e.consume(G), s += String.fromCharCode(G), ye) : B(G);
  }
  function ke(G) {
    return G === 93 ? (e.consume(G), q) : B(G);
  }
  function q(G) {
    return G === 62 ? (e.consume(G), _e) : G === 45 && a === 2 ? (e.consume(G), q) : B(G);
  }
  function _e(G) {
    return G === null || $n(G) ? (e.exit("htmlFlowData"), De(G)) : (e.consume(G), _e);
  }
  function De(G) {
    return e.exit("htmlFlow"), n(G);
  }
}
function az(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return $n(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o) : r(s);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
function oz(e, n, r) {
  return i;
  function i(a) {
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), e.attempt(Dl, n, r);
  }
}
const sz = {
  name: "htmlText",
  tokenize: lz
};
function lz(e, n, r) {
  const i = this;
  let a, o, s;
  return l;
  function l(q) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(q), u;
  }
  function u(q) {
    return q === 33 ? (e.consume(q), p) : q === 47 ? (e.consume(q), I) : q === 63 ? (e.consume(q), P) : Ar(q) ? (e.consume(q), H) : r(q);
  }
  function p(q) {
    return q === 45 ? (e.consume(q), d) : q === 91 ? (e.consume(q), o = 0, C) : Ar(q) ? (e.consume(q), g) : r(q);
  }
  function d(q) {
    return q === 45 ? (e.consume(q), v) : r(q);
  }
  function f(q) {
    return q === null ? r(q) : q === 45 ? (e.consume(q), h) : $n(q) ? (s = f, ge(q)) : (e.consume(q), f);
  }
  function h(q) {
    return q === 45 ? (e.consume(q), v) : f(q);
  }
  function v(q) {
    return q === 62 ? je(q) : q === 45 ? h(q) : f(q);
  }
  function C(q) {
    const _e = "CDATA[";
    return q === _e.charCodeAt(o++) ? (e.consume(q), o === _e.length ? j : C) : r(q);
  }
  function j(q) {
    return q === null ? r(q) : q === 93 ? (e.consume(q), N) : $n(q) ? (s = j, ge(q)) : (e.consume(q), j);
  }
  function N(q) {
    return q === 93 ? (e.consume(q), x) : j(q);
  }
  function x(q) {
    return q === 62 ? je(q) : q === 93 ? (e.consume(q), x) : j(q);
  }
  function g(q) {
    return q === null || q === 62 ? je(q) : $n(q) ? (s = g, ge(q)) : (e.consume(q), g);
  }
  function P(q) {
    return q === null ? r(q) : q === 63 ? (e.consume(q), E) : $n(q) ? (s = P, ge(q)) : (e.consume(q), P);
  }
  function E(q) {
    return q === 62 ? je(q) : P(q);
  }
  function I(q) {
    return Ar(q) ? (e.consume(q), w) : r(q);
  }
  function w(q) {
    return q === 45 || lr(q) ? (e.consume(q), w) : A(q);
  }
  function A(q) {
    return $n(q) ? (s = A, ge(q)) : Qn(q) ? (e.consume(q), A) : je(q);
  }
  function H(q) {
    return q === 45 || lr(q) ? (e.consume(q), H) : q === 47 || q === 62 || nr(q) ? Y(q) : r(q);
  }
  function Y(q) {
    return q === 47 ? (e.consume(q), je) : q === 58 || q === 95 || Ar(q) ? (e.consume(q), ne) : $n(q) ? (s = Y, ge(q)) : Qn(q) ? (e.consume(q), Y) : je(q);
  }
  function ne(q) {
    return q === 45 || q === 46 || q === 58 || q === 95 || lr(q) ? (e.consume(q), ne) : W(q);
  }
  function W(q) {
    return q === 61 ? (e.consume(q), B) : $n(q) ? (s = W, ge(q)) : Qn(q) ? (e.consume(q), W) : Y(q);
  }
  function B(q) {
    return q === null || q === 60 || q === 61 || q === 62 || q === 96 ? r(q) : q === 34 || q === 39 ? (e.consume(q), a = q, D) : $n(q) ? (s = B, ge(q)) : Qn(q) ? (e.consume(q), B) : (e.consume(q), M);
  }
  function D(q) {
    return q === a ? (e.consume(q), a = void 0, Z) : q === null ? r(q) : $n(q) ? (s = D, ge(q)) : (e.consume(q), D);
  }
  function M(q) {
    return q === null || q === 34 || q === 39 || q === 60 || q === 61 || q === 96 ? r(q) : q === 47 || q === 62 || nr(q) ? Y(q) : (e.consume(q), M);
  }
  function Z(q) {
    return q === 47 || q === 62 || nr(q) ? Y(q) : r(q);
  }
  function je(q) {
    return q === 62 ? (e.consume(q), e.exit("htmlTextData"), e.exit("htmlText"), n) : r(q);
  }
  function ge(q) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(q), e.exit("lineEnding"), ye;
  }
  function ye(q) {
    return Qn(q) ? ct(e, ke, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(q) : ke(q);
  }
  function ke(q) {
    return e.enter("htmlTextData"), s(q);
  }
}
const og = {
  name: "labelEnd",
  resolveAll: mz,
  resolveTo: pz,
  tokenize: fz
}, cz = {
  tokenize: hz
}, uz = {
  tokenize: yz
}, dz = {
  tokenize: gz
};
function mz(e) {
  let n = -1;
  const r = [];
  for (; ++n < e.length; ) {
    const i = e[n][1];
    if (r.push(e[n]), i.type === "labelImage" || i.type === "labelLink" || i.type === "labelEnd") {
      const a = i.type === "labelImage" ? 4 : 2;
      i.type = "data", n += a;
    }
  }
  return e.length !== r.length && Mr(e, 0, e.length, r), e;
}
function pz(e, n) {
  let r = e.length, i = 0, a, o, s, l;
  for (; r--; )
    if (a = e[r][1], o) {
      if (a.type === "link" || a.type === "labelLink" && a._inactive)
        break;
      e[r][0] === "enter" && a.type === "labelLink" && (a._inactive = !0);
    } else if (s) {
      if (e[r][0] === "enter" && (a.type === "labelImage" || a.type === "labelLink") && !a._balanced && (o = r, a.type !== "labelLink")) {
        i = 2;
        break;
      }
    } else a.type === "labelEnd" && (s = r);
  const u = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, p = {
    type: "label",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[s][1].end
    }
  }, d = {
    type: "labelText",
    start: {
      ...e[o + i + 2][1].end
    },
    end: {
      ...e[s - 2][1].start
    }
  };
  return l = [["enter", u, n], ["enter", p, n]], l = dr(l, e.slice(o + 1, o + i + 3)), l = dr(l, [["enter", d, n]]), l = dr(l, ag(n.parser.constructs.insideSpan.null, e.slice(o + i + 4, s - 3), n)), l = dr(l, [["exit", d, n], e[s - 2], e[s - 1], ["exit", p, n]]), l = dr(l, e.slice(s + 1)), l = dr(l, [["exit", u, n]]), Mr(e, o, e.length, l), e;
}
function fz(e, n, r) {
  const i = this;
  let a = i.events.length, o, s;
  for (; a--; )
    if ((i.events[a][1].type === "labelImage" || i.events[a][1].type === "labelLink") && !i.events[a][1]._balanced) {
      o = i.events[a][1];
      break;
    }
  return l;
  function l(h) {
    return o ? o._inactive ? f(h) : (s = i.parser.defined.includes(ma(i.sliceSerialize({
      start: o.end,
      end: i.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(h), e.exit("labelMarker"), e.exit("labelEnd"), u) : r(h);
  }
  function u(h) {
    return h === 40 ? e.attempt(cz, d, s ? d : f)(h) : h === 91 ? e.attempt(uz, d, s ? p : f)(h) : s ? d(h) : f(h);
  }
  function p(h) {
    return e.attempt(dz, d, f)(h);
  }
  function d(h) {
    return n(h);
  }
  function f(h) {
    return o._balanced = !0, r(h);
  }
}
function hz(e, n, r) {
  return i;
  function i(f) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), a;
  }
  function a(f) {
    return nr(f) ? So(e, o)(f) : o(f);
  }
  function o(f) {
    return f === 41 ? d(f) : u1(e, s, l, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(f);
  }
  function s(f) {
    return nr(f) ? So(e, u)(f) : d(f);
  }
  function l(f) {
    return r(f);
  }
  function u(f) {
    return f === 34 || f === 39 || f === 40 ? m1(e, p, r, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(f) : d(f);
  }
  function p(f) {
    return nr(f) ? So(e, d)(f) : d(f);
  }
  function d(f) {
    return f === 41 ? (e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), e.exit("resource"), n) : r(f);
  }
}
function yz(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return d1.call(i, e, o, s, "reference", "referenceMarker", "referenceString")(l);
  }
  function o(l) {
    return i.parser.defined.includes(ma(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1))) ? n(l) : r(l);
  }
  function s(l) {
    return r(l);
  }
}
function gz(e, n, r) {
  return i;
  function i(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), a;
  }
  function a(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), n) : r(o);
  }
}
const vz = {
  name: "labelStartImage",
  resolveAll: og.resolveAll,
  tokenize: kz
};
function kz(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), o;
  }
  function o(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), s) : r(l);
  }
  function s(l) {
    return l === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(l) : n(l);
  }
}
const bz = {
  name: "labelStartLink",
  resolveAll: og.resolveAll,
  tokenize: xz
};
function xz(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(s) : n(s);
  }
}
const Zd = {
  name: "lineEnding",
  tokenize: _z
};
function _z(e, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), ct(e, n, "linePrefix");
  }
}
const zs = {
  name: "thematicBreak",
  tokenize: Sz
};
function Sz(e, n, r) {
  let i = 0, a;
  return o;
  function o(p) {
    return e.enter("thematicBreak"), s(p);
  }
  function s(p) {
    return a = p, l(p);
  }
  function l(p) {
    return p === a ? (e.enter("thematicBreakSequence"), u(p)) : i >= 3 && (p === null || $n(p)) ? (e.exit("thematicBreak"), n(p)) : r(p);
  }
  function u(p) {
    return p === a ? (e.consume(p), i++, u) : (e.exit("thematicBreakSequence"), Qn(p) ? ct(e, l, "whitespace")(p) : l(p));
  }
}
const Zt = {
  continuation: {
    tokenize: Cz
  },
  exit: Fz,
  name: "list",
  tokenize: wz
}, Nz = {
  partial: !0,
  tokenize: Ez
}, jz = {
  partial: !0,
  tokenize: Iz
};
function wz(e, n, r) {
  const i = this, a = i.events[i.events.length - 1];
  let o = a && a[1].type === "linePrefix" ? a[2].sliceSerialize(a[1], !0).length : 0, s = 0;
  return l;
  function l(v) {
    const C = i.containerState.type || (v === 42 || v === 43 || v === 45 ? "listUnordered" : "listOrdered");
    if (C === "listUnordered" ? !i.containerState.marker || v === i.containerState.marker : Vh(v)) {
      if (i.containerState.type || (i.containerState.type = C, e.enter(C, {
        _container: !0
      })), C === "listUnordered")
        return e.enter("listItemPrefix"), v === 42 || v === 45 ? e.check(zs, r, p)(v) : p(v);
      if (!i.interrupt || v === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), u(v);
    }
    return r(v);
  }
  function u(v) {
    return Vh(v) && ++s < 10 ? (e.consume(v), u) : (!i.interrupt || s < 2) && (i.containerState.marker ? v === i.containerState.marker : v === 41 || v === 46) ? (e.exit("listItemValue"), p(v)) : r(v);
  }
  function p(v) {
    return e.enter("listItemMarker"), e.consume(v), e.exit("listItemMarker"), i.containerState.marker = i.containerState.marker || v, e.check(
      Dl,
      // Can’t be empty when interrupting.
      i.interrupt ? r : d,
      e.attempt(Nz, h, f)
    );
  }
  function d(v) {
    return i.containerState.initialBlankLine = !0, o++, h(v);
  }
  function f(v) {
    return Qn(v) ? (e.enter("listItemPrefixWhitespace"), e.consume(v), e.exit("listItemPrefixWhitespace"), h) : r(v);
  }
  function h(v) {
    return i.containerState.size = o + i.sliceSerialize(e.exit("listItemPrefix"), !0).length, n(v);
  }
}
function Cz(e, n, r) {
  const i = this;
  return i.containerState._closeFlow = void 0, e.check(Dl, a, o);
  function a(l) {
    return i.containerState.furtherBlankLines = i.containerState.furtherBlankLines || i.containerState.initialBlankLine, ct(e, n, "listItemIndent", i.containerState.size + 1)(l);
  }
  function o(l) {
    return i.containerState.furtherBlankLines || !Qn(l) ? (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, s(l)) : (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, e.attempt(jz, n, s)(l));
  }
  function s(l) {
    return i.containerState._closeFlow = !0, i.interrupt = void 0, ct(e, e.attempt(Zt, n, r), "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(l);
  }
}
function Iz(e, n, r) {
  const i = this;
  return ct(e, a, "listItemIndent", i.containerState.size + 1);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return s && s[1].type === "listItemIndent" && s[2].sliceSerialize(s[1], !0).length === i.containerState.size ? n(o) : r(o);
  }
}
function Fz(e) {
  e.exit(this.containerState.type);
}
function Ez(e, n, r) {
  const i = this;
  return ct(e, a, "listItemPrefixWhitespace", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return !Qn(o) && s && s[1].type === "listItemPrefixWhitespace" ? n(o) : r(o);
  }
}
const S_ = {
  name: "setextUnderline",
  resolveTo: $z,
  tokenize: Tz
};
function $z(e, n) {
  let r = e.length, i, a, o;
  for (; r--; )
    if (e[r][0] === "enter") {
      if (e[r][1].type === "content") {
        i = r;
        break;
      }
      e[r][1].type === "paragraph" && (a = r);
    } else
      e[r][1].type === "content" && e.splice(r, 1), !o && e[r][1].type === "definition" && (o = r);
  const s = {
    type: "setextHeading",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[a][1].type = "setextHeadingText", o ? (e.splice(a, 0, ["enter", s, n]), e.splice(o + 1, 0, ["exit", e[i][1], n]), e[i][1].end = {
    ...e[o][1].end
  }) : e[i][1] = s, e.push(["exit", s, n]), e;
}
function Tz(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(p) {
    let d = i.events.length, f;
    for (; d--; )
      if (i.events[d][1].type !== "lineEnding" && i.events[d][1].type !== "linePrefix" && i.events[d][1].type !== "content") {
        f = i.events[d][1].type === "paragraph";
        break;
      }
    return !i.parser.lazy[i.now().line] && (i.interrupt || f) ? (e.enter("setextHeadingLine"), a = p, s(p)) : r(p);
  }
  function s(p) {
    return e.enter("setextHeadingLineSequence"), l(p);
  }
  function l(p) {
    return p === a ? (e.consume(p), l) : (e.exit("setextHeadingLineSequence"), Qn(p) ? ct(e, u, "lineSuffix")(p) : u(p));
  }
  function u(p) {
    return p === null || $n(p) ? (e.exit("setextHeadingLine"), n(p)) : r(p);
  }
}
const Oz = {
  tokenize: Dz
};
function Dz(e) {
  const n = this, r = e.attempt(
    // Try to parse a blank line.
    Dl,
    i,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, a, ct(e, e.attempt(this.parser.constructs.flow, a, e.attempt(V3, a)), "linePrefix"))
  );
  return r;
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), n.currentConstruct = void 0, r;
  }
  function a(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), n.currentConstruct = void 0, r;
  }
}
const Pz = {
  resolveAll: f1()
}, Rz = p1("string"), Az = p1("text");
function p1(e) {
  return {
    resolveAll: f1(e === "text" ? Lz : void 0),
    tokenize: n
  };
  function n(r) {
    const i = this, a = this.parser.constructs[e], o = r.attempt(a, s, l);
    return s;
    function s(d) {
      return p(d) ? o(d) : l(d);
    }
    function l(d) {
      if (d === null) {
        r.consume(d);
        return;
      }
      return r.enter("data"), r.consume(d), u;
    }
    function u(d) {
      return p(d) ? (r.exit("data"), o(d)) : (r.consume(d), u);
    }
    function p(d) {
      if (d === null)
        return !0;
      const f = a[d];
      let h = -1;
      if (f)
        for (; ++h < f.length; ) {
          const v = f[h];
          if (!v.previous || v.previous.call(i, i.previous))
            return !0;
        }
      return !1;
    }
  }
}
function f1(e) {
  return n;
  function n(r, i) {
    let a = -1, o;
    for (; ++a <= r.length; )
      o === void 0 ? r[a] && r[a][1].type === "data" && (o = a, a++) : (!r[a] || r[a][1].type !== "data") && (a !== o + 2 && (r[o][1].end = r[a - 1][1].end, r.splice(o + 2, a - o - 2), a = o + 2), o = void 0);
    return e ? e(r, i) : r;
  }
}
function Lz(e, n) {
  let r = 0;
  for (; ++r <= e.length; )
    if ((r === e.length || e[r][1].type === "lineEnding") && e[r - 1][1].type === "data") {
      const i = e[r - 1][1], a = n.sliceStream(i);
      let o = a.length, s = -1, l = 0, u;
      for (; o--; ) {
        const p = a[o];
        if (typeof p == "string") {
          for (s = p.length; p.charCodeAt(s - 1) === 32; )
            l++, s--;
          if (s) break;
          s = -1;
        } else if (p === -2)
          u = !0, l++;
        else if (p !== -1) {
          o++;
          break;
        }
      }
      if (l) {
        const p = {
          type: r === e.length || u || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: o ? s : i.start._bufferIndex + s,
            _index: i.start._index + o,
            line: i.end.line,
            column: i.end.column - l,
            offset: i.end.offset - l
          },
          end: {
            ...i.end
          }
        };
        i.end = {
          ...p.start
        }, i.start.offset === i.end.offset ? Object.assign(i, p) : (e.splice(r, 0, ["enter", p, n], ["exit", p, n]), r += 2);
      }
      r++;
    }
  return e;
}
const Vz = {
  42: Zt,
  43: Zt,
  45: Zt,
  48: Zt,
  49: Zt,
  50: Zt,
  51: Zt,
  52: Zt,
  53: Zt,
  54: Zt,
  55: Zt,
  56: Zt,
  57: Zt,
  62: o1
}, zz = {
  91: q3
}, Uz = {
  [-2]: Xd,
  [-1]: Xd,
  32: Xd
}, Mz = {
  35: J3,
  42: zs,
  45: [S_, zs],
  60: ez,
  61: S_,
  95: zs,
  96: x_,
  126: x_
}, Bz = {
  38: l1,
  92: s1
}, qz = {
  [-5]: Zd,
  [-4]: Zd,
  [-3]: Zd,
  33: vz,
  38: l1,
  42: zh,
  60: [b3, sz],
  91: bz,
  92: [G3, s1],
  93: og,
  95: zh,
  96: O3
}, Hz = {
  null: [zh, Pz]
}, Wz = {
  null: [42, 95]
}, Kz = {
  null: []
}, Gz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: Wz,
  contentInitial: zz,
  disable: Kz,
  document: Vz,
  flow: Mz,
  flowInitial: Uz,
  insideSpan: Hz,
  string: Bz,
  text: qz
}, Symbol.toStringTag, { value: "Module" }));
function Yz(e, n, r) {
  let i = {
    _bufferIndex: -1,
    _index: 0,
    line: r && r.line || 1,
    column: r && r.column || 1,
    offset: r && r.offset || 0
  };
  const a = {}, o = [];
  let s = [], l = [];
  const u = {
    attempt: A(I),
    check: A(w),
    consume: g,
    enter: P,
    exit: E,
    interrupt: A(w, {
      interrupt: !0
    })
  }, p = {
    code: null,
    containerState: {},
    defineSkip: j,
    events: [],
    now: C,
    parser: e,
    previous: null,
    sliceSerialize: h,
    sliceStream: v,
    write: f
  };
  let d = n.tokenize.call(p, u);
  return n.resolveAll && o.push(n), p;
  function f(W) {
    return s = dr(s, W), N(), s[s.length - 1] !== null ? [] : (H(n, 0), p.events = ag(o, p.events, p), p.events);
  }
  function h(W, B) {
    return Qz(v(W), B);
  }
  function v(W) {
    return Jz(s, W);
  }
  function C() {
    const {
      _bufferIndex: W,
      _index: B,
      line: D,
      column: M,
      offset: Z
    } = i;
    return {
      _bufferIndex: W,
      _index: B,
      line: D,
      column: M,
      offset: Z
    };
  }
  function j(W) {
    a[W.line] = W.column, ne();
  }
  function N() {
    let W;
    for (; i._index < s.length; ) {
      const B = s[i._index];
      if (typeof B == "string")
        for (W = i._index, i._bufferIndex < 0 && (i._bufferIndex = 0); i._index === W && i._bufferIndex < B.length; )
          x(B.charCodeAt(i._bufferIndex));
      else
        x(B);
    }
  }
  function x(W) {
    d = d(W);
  }
  function g(W) {
    $n(W) ? (i.line++, i.column = 1, i.offset += W === -3 ? 2 : 1, ne()) : W !== -1 && (i.column++, i.offset++), i._bufferIndex < 0 ? i._index++ : (i._bufferIndex++, i._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    s[i._index].length && (i._bufferIndex = -1, i._index++)), p.previous = W;
  }
  function P(W, B) {
    const D = B || {};
    return D.type = W, D.start = C(), p.events.push(["enter", D, p]), l.push(D), D;
  }
  function E(W) {
    const B = l.pop();
    return B.end = C(), p.events.push(["exit", B, p]), B;
  }
  function I(W, B) {
    H(W, B.from);
  }
  function w(W, B) {
    B.restore();
  }
  function A(W, B) {
    return D;
    function D(M, Z, je) {
      let ge, ye, ke, q;
      return Array.isArray(M) ? (
        /* c8 ignore next 1 */
        De(M)
      ) : "tokenize" in M ? (
        // Looks like a construct.
        De([
          /** @type {Construct} */
          M
        ])
      ) : _e(M);
      function _e(Ie) {
        return Ue;
        function Ue(Pe) {
          const Be = Pe !== null && Ie[Pe], Le = Pe !== null && Ie.null, Xe = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(Be) ? Be : Be ? [Be] : [],
            ...Array.isArray(Le) ? Le : Le ? [Le] : []
          ];
          return De(Xe)(Pe);
        }
      }
      function De(Ie) {
        return ge = Ie, ye = 0, Ie.length === 0 ? je : G(Ie[ye]);
      }
      function G(Ie) {
        return Ue;
        function Ue(Pe) {
          return q = Y(), ke = Ie, Ie.partial || (p.currentConstruct = Ie), Ie.name && p.parser.constructs.disable.null.includes(Ie.name) ? sn() : Ie.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            B ? Object.assign(Object.create(p), B) : p,
            u,
            Ye,
            sn
          )(Pe);
        }
      }
      function Ye(Ie) {
        return W(ke, q), Z;
      }
      function sn(Ie) {
        return q.restore(), ++ye < ge.length ? G(ge[ye]) : je;
      }
    }
  }
  function H(W, B) {
    W.resolveAll && !o.includes(W) && o.push(W), W.resolve && Mr(p.events, B, p.events.length - B, W.resolve(p.events.slice(B), p)), W.resolveTo && (p.events = W.resolveTo(p.events, p));
  }
  function Y() {
    const W = C(), B = p.previous, D = p.currentConstruct, M = p.events.length, Z = Array.from(l);
    return {
      from: M,
      restore: je
    };
    function je() {
      i = W, p.previous = B, p.currentConstruct = D, p.events.length = M, l = Z, ne();
    }
  }
  function ne() {
    i.line in a && i.column < 2 && (i.column = a[i.line], i.offset += a[i.line] - 1);
  }
}
function Jz(e, n) {
  const r = n.start._index, i = n.start._bufferIndex, a = n.end._index, o = n.end._bufferIndex;
  let s;
  if (r === a)
    s = [e[r].slice(i, o)];
  else {
    if (s = e.slice(r, a), i > -1) {
      const l = s[0];
      typeof l == "string" ? s[0] = l.slice(i) : s.shift();
    }
    o > 0 && s.push(e[a].slice(0, o));
  }
  return s;
}
function Qz(e, n) {
  let r = -1;
  const i = [];
  let a;
  for (; ++r < e.length; ) {
    const o = e[r];
    let s;
    if (typeof o == "string")
      s = o;
    else switch (o) {
      case -5: {
        s = "\r";
        break;
      }
      case -4: {
        s = `
`;
        break;
      }
      case -3: {
        s = `\r
`;
        break;
      }
      case -2: {
        s = n ? " " : "	";
        break;
      }
      case -1: {
        if (!n && a) continue;
        s = " ";
        break;
      }
      default:
        s = String.fromCharCode(o);
    }
    a = o === -2, i.push(s);
  }
  return i.join("");
}
function Xz(e) {
  const i = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      a3([Gz, ...(e || {}).extensions || []])
    ),
    content: a(p3),
    defined: [],
    document: a(h3),
    flow: a(Oz),
    lazy: {},
    string: a(Rz),
    text: a(Az)
  };
  return i;
  function a(o) {
    return s;
    function s(l) {
      return Yz(i, o, l);
    }
  }
}
function Zz(e) {
  for (; !c1(e); )
    ;
  return e;
}
const N_ = /[\0\t\n\r]/g;
function eU() {
  let e = 1, n = "", r = !0, i;
  return a;
  function a(o, s, l) {
    const u = [];
    let p, d, f, h, v;
    for (o = n + (typeof o == "string" ? o.toString() : new TextDecoder(s || void 0).decode(o)), f = 0, n = "", r && (o.charCodeAt(0) === 65279 && f++, r = void 0); f < o.length; ) {
      if (N_.lastIndex = f, p = N_.exec(o), h = p && p.index !== void 0 ? p.index : o.length, v = o.charCodeAt(h), !p) {
        n = o.slice(f);
        break;
      }
      if (v === 10 && f === h && i)
        u.push(-3), i = void 0;
      else
        switch (i && (u.push(-5), i = void 0), f < h && (u.push(o.slice(f, h)), e += h - f), v) {
          case 0: {
            u.push(65533), e++;
            break;
          }
          case 9: {
            for (d = Math.ceil(e / 4) * 4, u.push(-2); e++ < d; ) u.push(-1);
            break;
          }
          case 10: {
            u.push(-4), e = 1;
            break;
          }
          default:
            i = !0, e = 1;
        }
      f = h + 1;
    }
    return l && (i && u.push(-5), n && u.push(n), u.push(null)), u;
  }
}
const nU = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function tU(e) {
  return e.replace(nU, rU);
}
function rU(e, n, r) {
  if (n)
    return n;
  if (r.charCodeAt(0) === 35) {
    const a = r.charCodeAt(1), o = a === 120 || a === 88;
    return a1(r.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return ig(r) || e;
}
const h1 = {}.hasOwnProperty;
function iU(e, n, r) {
  return typeof n != "string" && (r = n, n = void 0), aU(r)(Zz(Xz(r).document().write(eU()(e, n, !0))));
}
function aU(e) {
  const n = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: o(Re),
      autolinkProtocol: Y,
      autolinkEmail: Y,
      atxHeading: o(se),
      blockQuote: o(Le),
      characterEscape: Y,
      characterReference: Y,
      codeFenced: o(Xe),
      codeFencedFenceInfo: s,
      codeFencedFenceMeta: s,
      codeIndented: o(Xe, s),
      codeText: o(Fe, s),
      codeTextData: Y,
      data: Y,
      codeFlowValue: Y,
      definition: o(Me),
      definitionDestinationString: s,
      definitionLabelString: s,
      definitionTitleString: s,
      emphasis: o(nn),
      hardBreakEscape: o(le),
      hardBreakTrailing: o(le),
      htmlFlow: o(Se, s),
      htmlFlowData: Y,
      htmlText: o(Se, s),
      htmlTextData: Y,
      image: o(Ae),
      label: s,
      link: o(Re),
      listItem: o(Q),
      listItemValue: h,
      listOrdered: o(yn, f),
      listUnordered: o(yn),
      paragraph: o($),
      reference: G,
      referenceString: s,
      resourceDestinationString: s,
      resourceTitleString: s,
      setextHeading: o(se),
      strong: o(z),
      thematicBreak: o(ae)
    },
    exit: {
      atxHeading: u(),
      atxHeadingSequence: I,
      autolink: u(),
      autolinkEmail: Be,
      autolinkProtocol: Pe,
      blockQuote: u(),
      characterEscapeValue: ne,
      characterReferenceMarkerHexadecimal: sn,
      characterReferenceMarkerNumeric: sn,
      characterReferenceValue: Ie,
      characterReference: Ue,
      codeFenced: u(N),
      codeFencedFence: j,
      codeFencedFenceInfo: v,
      codeFencedFenceMeta: C,
      codeFlowValue: ne,
      codeIndented: u(x),
      codeText: u(Z),
      codeTextData: ne,
      data: ne,
      definition: u(),
      definitionDestinationString: E,
      definitionLabelString: g,
      definitionTitleString: P,
      emphasis: u(),
      hardBreakEscape: u(B),
      hardBreakTrailing: u(B),
      htmlFlow: u(D),
      htmlFlowData: ne,
      htmlText: u(M),
      htmlTextData: ne,
      image: u(ge),
      label: ke,
      labelText: ye,
      lineEnding: W,
      link: u(je),
      listItem: u(),
      listOrdered: u(),
      listUnordered: u(),
      paragraph: u(),
      referenceString: Ye,
      resourceDestinationString: q,
      resourceTitleString: _e,
      resource: De,
      setextHeading: u(H),
      setextHeadingLineSequence: A,
      setextHeadingText: w,
      strong: u(),
      thematicBreak: u()
    }
  };
  y1(n, (e || {}).mdastExtensions || []);
  const r = {};
  return i;
  function i(V) {
    let J = {
      type: "root",
      children: []
    };
    const de = {
      stack: [J],
      tokenStack: [],
      config: n,
      enter: l,
      exit: p,
      buffer: s,
      resume: d,
      data: r
    }, xe = [];
    let $e = -1;
    for (; ++$e < V.length; )
      if (V[$e][1].type === "listOrdered" || V[$e][1].type === "listUnordered")
        if (V[$e][0] === "enter")
          xe.push($e);
        else {
          const tn = xe.pop();
          $e = a(V, tn, $e);
        }
    for ($e = -1; ++$e < V.length; ) {
      const tn = n[V[$e][0]];
      h1.call(tn, V[$e][1].type) && tn[V[$e][1].type].call(Object.assign({
        sliceSerialize: V[$e][2].sliceSerialize
      }, de), V[$e][1]);
    }
    if (de.tokenStack.length > 0) {
      const tn = de.tokenStack[de.tokenStack.length - 1];
      (tn[1] || j_).call(de, void 0, tn[0]);
    }
    for (J.position = {
      start: oi(V.length > 0 ? V[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: oi(V.length > 0 ? V[V.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, $e = -1; ++$e < n.transforms.length; )
      J = n.transforms[$e](J) || J;
    return J;
  }
  function a(V, J, de) {
    let xe = J - 1, $e = -1, tn = !1, gn, on, pn, Fn;
    for (; ++xe <= de; ) {
      const xn = V[xe];
      switch (xn[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          xn[0] === "enter" ? $e++ : $e--, Fn = void 0;
          break;
        }
        case "lineEndingBlank": {
          xn[0] === "enter" && (gn && !Fn && !$e && !pn && (pn = xe), Fn = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          Fn = void 0;
      }
      if (!$e && xn[0] === "enter" && xn[1].type === "listItemPrefix" || $e === -1 && xn[0] === "exit" && (xn[1].type === "listUnordered" || xn[1].type === "listOrdered")) {
        if (gn) {
          let En = xe;
          for (on = void 0; En--; ) {
            const en = V[En];
            if (en[1].type === "lineEnding" || en[1].type === "lineEndingBlank") {
              if (en[0] === "exit") continue;
              on && (V[on][1].type = "lineEndingBlank", tn = !0), en[1].type = "lineEnding", on = En;
            } else if (!(en[1].type === "linePrefix" || en[1].type === "blockQuotePrefix" || en[1].type === "blockQuotePrefixWhitespace" || en[1].type === "blockQuoteMarker" || en[1].type === "listItemIndent")) break;
          }
          pn && (!on || pn < on) && (gn._spread = !0), gn.end = Object.assign({}, on ? V[on][1].start : xn[1].end), V.splice(on || xe, 0, ["exit", gn, xn[2]]), xe++, de++;
        }
        if (xn[1].type === "listItemPrefix") {
          const En = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, xn[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          gn = En, V.splice(xe, 0, ["enter", En, xn[2]]), xe++, de++, pn = void 0, Fn = !0;
        }
      }
    }
    return V[J][1]._spread = tn, de;
  }
  function o(V, J) {
    return de;
    function de(xe) {
      l.call(this, V(xe), xe), J && J.call(this, xe);
    }
  }
  function s() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function l(V, J, de) {
    this.stack[this.stack.length - 1].children.push(V), this.stack.push(V), this.tokenStack.push([J, de || void 0]), V.position = {
      start: oi(J.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function u(V) {
    return J;
    function J(de) {
      V && V.call(this, de), p.call(this, de);
    }
  }
  function p(V, J) {
    const de = this.stack.pop(), xe = this.tokenStack.pop();
    if (xe)
      xe[0].type !== V.type && (J ? J.call(this, V, xe[0]) : (xe[1] || j_).call(this, V, xe[0]));
    else throw new Error("Cannot close `" + V.type + "` (" + _o({
      start: V.start,
      end: V.end
    }) + "): it’s not open");
    de.position.end = oi(V.end);
  }
  function d() {
    return r3(this.stack.pop());
  }
  function f() {
    this.data.expectingFirstListItemValue = !0;
  }
  function h(V) {
    if (this.data.expectingFirstListItemValue) {
      const J = this.stack[this.stack.length - 2];
      J.start = Number.parseInt(this.sliceSerialize(V), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function v() {
    const V = this.resume(), J = this.stack[this.stack.length - 1];
    J.lang = V;
  }
  function C() {
    const V = this.resume(), J = this.stack[this.stack.length - 1];
    J.meta = V;
  }
  function j() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function N() {
    const V = this.resume(), J = this.stack[this.stack.length - 1];
    J.value = V.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function x() {
    const V = this.resume(), J = this.stack[this.stack.length - 1];
    J.value = V.replace(/(\r?\n|\r)$/g, "");
  }
  function g(V) {
    const J = this.resume(), de = this.stack[this.stack.length - 1];
    de.label = J, de.identifier = ma(this.sliceSerialize(V)).toLowerCase();
  }
  function P() {
    const V = this.resume(), J = this.stack[this.stack.length - 1];
    J.title = V;
  }
  function E() {
    const V = this.resume(), J = this.stack[this.stack.length - 1];
    J.url = V;
  }
  function I(V) {
    const J = this.stack[this.stack.length - 1];
    if (!J.depth) {
      const de = this.sliceSerialize(V).length;
      J.depth = de;
    }
  }
  function w() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function A(V) {
    const J = this.stack[this.stack.length - 1];
    J.depth = this.sliceSerialize(V).codePointAt(0) === 61 ? 1 : 2;
  }
  function H() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function Y(V) {
    const de = this.stack[this.stack.length - 1].children;
    let xe = de[de.length - 1];
    (!xe || xe.type !== "text") && (xe = X(), xe.position = {
      start: oi(V.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, de.push(xe)), this.stack.push(xe);
  }
  function ne(V) {
    const J = this.stack.pop();
    J.value += this.sliceSerialize(V), J.position.end = oi(V.end);
  }
  function W(V) {
    const J = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const de = J.children[J.children.length - 1];
      de.position.end = oi(V.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && n.canContainEols.includes(J.type) && (Y.call(this, V), ne.call(this, V));
  }
  function B() {
    this.data.atHardBreak = !0;
  }
  function D() {
    const V = this.resume(), J = this.stack[this.stack.length - 1];
    J.value = V;
  }
  function M() {
    const V = this.resume(), J = this.stack[this.stack.length - 1];
    J.value = V;
  }
  function Z() {
    const V = this.resume(), J = this.stack[this.stack.length - 1];
    J.value = V;
  }
  function je() {
    const V = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const J = this.data.referenceType || "shortcut";
      V.type += "Reference", V.referenceType = J, delete V.url, delete V.title;
    } else
      delete V.identifier, delete V.label;
    this.data.referenceType = void 0;
  }
  function ge() {
    const V = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const J = this.data.referenceType || "shortcut";
      V.type += "Reference", V.referenceType = J, delete V.url, delete V.title;
    } else
      delete V.identifier, delete V.label;
    this.data.referenceType = void 0;
  }
  function ye(V) {
    const J = this.sliceSerialize(V), de = this.stack[this.stack.length - 2];
    de.label = tU(J), de.identifier = ma(J).toLowerCase();
  }
  function ke() {
    const V = this.stack[this.stack.length - 1], J = this.resume(), de = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, de.type === "link") {
      const xe = V.children;
      de.children = xe;
    } else
      de.alt = J;
  }
  function q() {
    const V = this.resume(), J = this.stack[this.stack.length - 1];
    J.url = V;
  }
  function _e() {
    const V = this.resume(), J = this.stack[this.stack.length - 1];
    J.title = V;
  }
  function De() {
    this.data.inReference = void 0;
  }
  function G() {
    this.data.referenceType = "collapsed";
  }
  function Ye(V) {
    const J = this.resume(), de = this.stack[this.stack.length - 1];
    de.label = J, de.identifier = ma(this.sliceSerialize(V)).toLowerCase(), this.data.referenceType = "full";
  }
  function sn(V) {
    this.data.characterReferenceType = V.type;
  }
  function Ie(V) {
    const J = this.sliceSerialize(V), de = this.data.characterReferenceType;
    let xe;
    de ? (xe = a1(J, de === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : xe = ig(J);
    const $e = this.stack[this.stack.length - 1];
    $e.value += xe;
  }
  function Ue(V) {
    const J = this.stack.pop();
    J.position.end = oi(V.end);
  }
  function Pe(V) {
    ne.call(this, V);
    const J = this.stack[this.stack.length - 1];
    J.url = this.sliceSerialize(V);
  }
  function Be(V) {
    ne.call(this, V);
    const J = this.stack[this.stack.length - 1];
    J.url = "mailto:" + this.sliceSerialize(V);
  }
  function Le() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function Xe() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function Fe() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function Me() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function nn() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function se() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function le() {
    return {
      type: "break"
    };
  }
  function Se() {
    return {
      type: "html",
      value: ""
    };
  }
  function Ae() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Re() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function yn(V) {
    return {
      type: "list",
      ordered: V.type === "listOrdered",
      start: null,
      spread: V._spread,
      children: []
    };
  }
  function Q(V) {
    return {
      type: "listItem",
      spread: V._spread,
      checked: null,
      children: []
    };
  }
  function $() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function z() {
    return {
      type: "strong",
      children: []
    };
  }
  function X() {
    return {
      type: "text",
      value: ""
    };
  }
  function ae() {
    return {
      type: "thematicBreak"
    };
  }
}
function oi(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function y1(e, n) {
  let r = -1;
  for (; ++r < n.length; ) {
    const i = n[r];
    Array.isArray(i) ? y1(e, i) : oU(e, i);
  }
}
function oU(e, n) {
  let r;
  for (r in n)
    if (h1.call(n, r))
      switch (r) {
        case "canContainEols": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "transforms": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "enter":
        case "exit": {
          const i = n[r];
          i && Object.assign(e[r], i);
          break;
        }
      }
}
function j_(e, n) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + _o({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + n.type + "`, " + _o({
    start: n.start,
    end: n.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + n.type + "`, " + _o({
    start: n.start,
    end: n.end
  }) + ") is still open");
}
function sU(e) {
  const n = this;
  n.parser = r;
  function r(i) {
    return iU(i, {
      ...n.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: n.data("micromarkExtensions") || [],
      mdastExtensions: n.data("fromMarkdownExtensions") || []
    });
  }
}
function lU(e, n) {
  const r = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(n), !0)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function cU(e, n) {
  const r = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(n, r), [e.applyData(n, r), { type: "text", value: `
` }];
}
function uU(e, n) {
  const r = n.value ? n.value + `
` : "", i = {}, a = n.lang ? n.lang.split(/\s+/) : [];
  a.length > 0 && (i.className = ["language-" + a[0]]);
  let o = {
    type: "element",
    tagName: "code",
    properties: i,
    children: [{ type: "text", value: r }]
  };
  return n.meta && (o.data = { meta: n.meta }), e.patch(n, o), o = e.applyData(n, o), o = { type: "element", tagName: "pre", properties: {}, children: [o] }, e.patch(n, o), o;
}
function dU(e, n) {
  const r = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function mU(e, n) {
  const r = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function pU(e, n) {
  const r = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", i = String(n.identifier).toUpperCase(), a = Fa(i.toLowerCase()), o = e.footnoteOrder.indexOf(i);
  let s, l = e.footnoteCounts.get(i);
  l === void 0 ? (l = 0, e.footnoteOrder.push(i), s = e.footnoteOrder.length) : s = o + 1, l += 1, e.footnoteCounts.set(i, l);
  const u = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + r + "fn-" + a,
      id: r + "fnref-" + a + (l > 1 ? "-" + l : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(s) }]
  };
  e.patch(n, u);
  const p = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [u]
  };
  return e.patch(n, p), e.applyData(n, p);
}
function fU(e, n) {
  const r = {
    type: "element",
    tagName: "h" + n.depth,
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function hU(e, n) {
  if (e.options.allowDangerousHtml) {
    const r = { type: "raw", value: n.value };
    return e.patch(n, r), e.applyData(n, r);
  }
}
function g1(e, n) {
  const r = n.referenceType;
  let i = "]";
  if (r === "collapsed" ? i += "[]" : r === "full" && (i += "[" + (n.label || n.identifier) + "]"), n.type === "imageReference")
    return [{ type: "text", value: "![" + n.alt + i }];
  const a = e.all(n), o = a[0];
  o && o.type === "text" ? o.value = "[" + o.value : a.unshift({ type: "text", value: "[" });
  const s = a[a.length - 1];
  return s && s.type === "text" ? s.value += i : a.push({ type: "text", value: i }), a;
}
function yU(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return g1(e, n);
  const a = { src: Fa(i.url || ""), alt: n.alt };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = { type: "element", tagName: "img", properties: a, children: [] };
  return e.patch(n, o), e.applyData(n, o);
}
function gU(e, n) {
  const r = { src: Fa(n.url) };
  n.alt !== null && n.alt !== void 0 && (r.alt = n.alt), n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = { type: "element", tagName: "img", properties: r, children: [] };
  return e.patch(n, i), e.applyData(n, i);
}
function vU(e, n) {
  const r = { type: "text", value: n.value.replace(/\r?\n|\r/g, " ") };
  e.patch(n, r);
  const i = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [r]
  };
  return e.patch(n, i), e.applyData(n, i);
}
function kU(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return g1(e, n);
  const a = { href: Fa(i.url || "") };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = {
    type: "element",
    tagName: "a",
    properties: a,
    children: e.all(n)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function bU(e, n) {
  const r = { href: Fa(n.url) };
  n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: r,
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function xU(e, n, r) {
  const i = e.all(n), a = r ? _U(r) : v1(n), o = {}, s = [];
  if (typeof n.checked == "boolean") {
    const d = i[0];
    let f;
    d && d.type === "element" && d.tagName === "p" ? f = d : (f = { type: "element", tagName: "p", properties: {}, children: [] }, i.unshift(f)), f.children.length > 0 && f.children.unshift({ type: "text", value: " " }), f.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: n.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < i.length; ) {
    const d = i[l];
    (a || l !== 0 || d.type !== "element" || d.tagName !== "p") && s.push({ type: "text", value: `
` }), d.type === "element" && d.tagName === "p" && !a ? s.push(...d.children) : s.push(d);
  }
  const u = i[i.length - 1];
  u && (a || u.type !== "element" || u.tagName !== "p") && s.push({ type: "text", value: `
` });
  const p = { type: "element", tagName: "li", properties: o, children: s };
  return e.patch(n, p), e.applyData(n, p);
}
function _U(e) {
  let n = !1;
  if (e.type === "list") {
    n = e.spread || !1;
    const r = e.children;
    let i = -1;
    for (; !n && ++i < r.length; )
      n = v1(r[i]);
  }
  return n;
}
function v1(e) {
  const n = e.spread;
  return n ?? e.children.length > 1;
}
function SU(e, n) {
  const r = {}, i = e.all(n);
  let a = -1;
  for (typeof n.start == "number" && n.start !== 1 && (r.start = n.start); ++a < i.length; ) {
    const s = i[a];
    if (s.type === "element" && s.tagName === "li" && s.properties && Array.isArray(s.properties.className) && s.properties.className.includes("task-list-item")) {
      r.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: n.ordered ? "ol" : "ul",
    properties: r,
    children: e.wrap(i, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function NU(e, n) {
  const r = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function jU(e, n) {
  const r = { type: "root", children: e.wrap(e.all(n)) };
  return e.patch(n, r), e.applyData(n, r);
}
function wU(e, n) {
  const r = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function CU(e, n) {
  const r = e.all(n), i = r.shift(), a = [];
  if (i) {
    const s = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([i], !0)
    };
    e.patch(n.children[0], s), a.push(s);
  }
  if (r.length > 0) {
    const s = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(r, !0)
    }, l = eg(n.children[1]), u = XC(n.children[n.children.length - 1]);
    l && u && (s.position = { start: l, end: u }), a.push(s);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(a, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function IU(e, n, r) {
  const i = r ? r.children : void 0, o = (i ? i.indexOf(n) : 1) === 0 ? "th" : "td", s = r && r.type === "table" ? r.align : void 0, l = s ? s.length : n.children.length;
  let u = -1;
  const p = [];
  for (; ++u < l; ) {
    const f = n.children[u], h = {}, v = s ? s[u] : void 0;
    v && (h.align = v);
    let C = { type: "element", tagName: o, properties: h, children: [] };
    f && (C.children = e.all(f), e.patch(f, C), C = e.applyData(f, C)), p.push(C);
  }
  const d = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(p, !0)
  };
  return e.patch(n, d), e.applyData(n, d);
}
function FU(e, n) {
  const r = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
const w_ = 9, C_ = 32;
function EU(e) {
  const n = String(e), r = /\r?\n|\r/g;
  let i = r.exec(n), a = 0;
  const o = [];
  for (; i; )
    o.push(
      I_(n.slice(a, i.index), a > 0, !0),
      i[0]
    ), a = i.index + i[0].length, i = r.exec(n);
  return o.push(I_(n.slice(a), a > 0, !1)), o.join("");
}
function I_(e, n, r) {
  let i = 0, a = e.length;
  if (n) {
    let o = e.codePointAt(i);
    for (; o === w_ || o === C_; )
      i++, o = e.codePointAt(i);
  }
  if (r) {
    let o = e.codePointAt(a - 1);
    for (; o === w_ || o === C_; )
      a--, o = e.codePointAt(a - 1);
  }
  return a > i ? e.slice(i, a) : "";
}
function $U(e, n) {
  const r = { type: "text", value: EU(String(n.value)) };
  return e.patch(n, r), e.applyData(n, r);
}
function TU(e, n) {
  const r = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(n, r), e.applyData(n, r);
}
const OU = {
  blockquote: lU,
  break: cU,
  code: uU,
  delete: dU,
  emphasis: mU,
  footnoteReference: pU,
  heading: fU,
  html: hU,
  imageReference: yU,
  image: gU,
  inlineCode: vU,
  linkReference: kU,
  link: bU,
  listItem: xU,
  list: SU,
  paragraph: NU,
  // @ts-expect-error: root is different, but hard to type.
  root: jU,
  strong: wU,
  table: CU,
  tableCell: FU,
  tableRow: IU,
  text: $U,
  thematicBreak: TU,
  toml: os,
  yaml: os,
  definition: os,
  footnoteDefinition: os
};
function os() {
}
const k1 = -1, Pl = 0, sl = 1, ll = 2, sg = 3, lg = 4, cg = 5, ug = 6, b1 = 7, x1 = 8, F_ = typeof self == "object" ? self : globalThis, DU = (e, n) => {
  const r = (a, o) => (e.set(o, a), a), i = (a) => {
    if (e.has(a))
      return e.get(a);
    const [o, s] = n[a];
    switch (o) {
      case Pl:
      case k1:
        return r(s, a);
      case sl: {
        const l = r([], a);
        for (const u of s)
          l.push(i(u));
        return l;
      }
      case ll: {
        const l = r({}, a);
        for (const [u, p] of s)
          l[i(u)] = i(p);
        return l;
      }
      case sg:
        return r(new Date(s), a);
      case lg: {
        const { source: l, flags: u } = s;
        return r(new RegExp(l, u), a);
      }
      case cg: {
        const l = r(/* @__PURE__ */ new Map(), a);
        for (const [u, p] of s)
          l.set(i(u), i(p));
        return l;
      }
      case ug: {
        const l = r(/* @__PURE__ */ new Set(), a);
        for (const u of s)
          l.add(i(u));
        return l;
      }
      case b1: {
        const { name: l, message: u } = s;
        return r(new F_[l](u), a);
      }
      case x1:
        return r(BigInt(s), a);
      case "BigInt":
        return r(Object(BigInt(s)), a);
    }
    return r(new F_[o](s), a);
  };
  return i;
}, E_ = (e) => DU(/* @__PURE__ */ new Map(), e)(0), Ji = "", { toString: PU } = {}, { keys: RU } = Object, Ja = (e) => {
  const n = typeof e;
  if (n !== "object" || !e)
    return [Pl, n];
  const r = PU.call(e).slice(8, -1);
  switch (r) {
    case "Array":
      return [sl, Ji];
    case "Object":
      return [ll, Ji];
    case "Date":
      return [sg, Ji];
    case "RegExp":
      return [lg, Ji];
    case "Map":
      return [cg, Ji];
    case "Set":
      return [ug, Ji];
  }
  return r.includes("Array") ? [sl, r] : r.includes("Error") ? [b1, r] : [ll, r];
}, ss = ([e, n]) => e === Pl && (n === "function" || n === "symbol"), AU = (e, n, r, i) => {
  const a = (s, l) => {
    const u = i.push(s) - 1;
    return r.set(l, u), u;
  }, o = (s) => {
    if (r.has(s))
      return r.get(s);
    let [l, u] = Ja(s);
    switch (l) {
      case Pl: {
        let d = s;
        switch (u) {
          case "bigint":
            l = x1, d = s.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + u);
            d = null;
            break;
          case "undefined":
            return a([k1], s);
        }
        return a([l, d], s);
      }
      case sl: {
        if (u)
          return a([u, [...s]], s);
        const d = [], f = a([l, d], s);
        for (const h of s)
          d.push(o(h));
        return f;
      }
      case ll: {
        if (u)
          switch (u) {
            case "BigInt":
              return a([u, s.toString()], s);
            case "Boolean":
            case "Number":
            case "String":
              return a([u, s.valueOf()], s);
          }
        if (n && "toJSON" in s)
          return o(s.toJSON());
        const d = [], f = a([l, d], s);
        for (const h of RU(s))
          (e || !ss(Ja(s[h]))) && d.push([o(h), o(s[h])]);
        return f;
      }
      case sg:
        return a([l, s.toISOString()], s);
      case lg: {
        const { source: d, flags: f } = s;
        return a([l, { source: d, flags: f }], s);
      }
      case cg: {
        const d = [], f = a([l, d], s);
        for (const [h, v] of s)
          (e || !(ss(Ja(h)) || ss(Ja(v)))) && d.push([o(h), o(v)]);
        return f;
      }
      case ug: {
        const d = [], f = a([l, d], s);
        for (const h of s)
          (e || !ss(Ja(h))) && d.push(o(h));
        return f;
      }
    }
    const { message: p } = s;
    return a([l, { name: u, message: p }], s);
  };
  return o;
}, $_ = (e, { json: n, lossy: r } = {}) => {
  const i = [];
  return AU(!(n || r), !!n, /* @__PURE__ */ new Map(), i)(e), i;
}, cl = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, n) => n && ("json" in n || "lossy" in n) ? E_($_(e, n)) : structuredClone(e)
) : (e, n) => E_($_(e, n));
function LU(e, n) {
  const r = [{ type: "text", value: "↩" }];
  return n > 1 && r.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(n) }]
  }), r;
}
function VU(e, n) {
  return "Back to reference " + (e + 1) + (n > 1 ? "-" + n : "");
}
function zU(e) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = e.options.footnoteBackContent || LU, i = e.options.footnoteBackLabel || VU, a = e.options.footnoteLabel || "Footnotes", o = e.options.footnoteLabelTagName || "h2", s = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, l = [];
  let u = -1;
  for (; ++u < e.footnoteOrder.length; ) {
    const p = e.footnoteById.get(
      e.footnoteOrder[u]
    );
    if (!p)
      continue;
    const d = e.all(p), f = String(p.identifier).toUpperCase(), h = Fa(f.toLowerCase());
    let v = 0;
    const C = [], j = e.footnoteCounts.get(f);
    for (; j !== void 0 && ++v <= j; ) {
      C.length > 0 && C.push({ type: "text", value: " " });
      let g = typeof r == "string" ? r : r(u, v);
      typeof g == "string" && (g = { type: "text", value: g }), C.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + n + "fnref-" + h + (v > 1 ? "-" + v : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof i == "string" ? i : i(u, v),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(g) ? g : [g]
      });
    }
    const N = d[d.length - 1];
    if (N && N.type === "element" && N.tagName === "p") {
      const g = N.children[N.children.length - 1];
      g && g.type === "text" ? g.value += " " : N.children.push({ type: "text", value: " " }), N.children.push(...C);
    } else
      d.push(...C);
    const x = {
      type: "element",
      tagName: "li",
      properties: { id: n + "fn-" + h },
      children: e.wrap(d, !0)
    };
    e.patch(p, x), l.push(x);
  }
  if (l.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: o,
          properties: {
            ...cl(s),
            id: "footnote-label"
          },
          children: [{ type: "text", value: a }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(l, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const _1 = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(e) {
    if (e == null)
      return qU;
    if (typeof e == "function")
      return Rl(e);
    if (typeof e == "object")
      return Array.isArray(e) ? UU(e) : MU(e);
    if (typeof e == "string")
      return BU(e);
    throw new Error("Expected function, string, or object as test");
  })
);
function UU(e) {
  const n = [];
  let r = -1;
  for (; ++r < e.length; )
    n[r] = _1(e[r]);
  return Rl(i);
  function i(...a) {
    let o = -1;
    for (; ++o < n.length; )
      if (n[o].apply(this, a)) return !0;
    return !1;
  }
}
function MU(e) {
  const n = (
    /** @type {Record<string, unknown>} */
    e
  );
  return Rl(r);
  function r(i) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      i
    );
    let o;
    for (o in e)
      if (a[o] !== n[o]) return !1;
    return !0;
  }
}
function BU(e) {
  return Rl(n);
  function n(r) {
    return r && r.type === e;
  }
}
function Rl(e) {
  return n;
  function n(r, i, a) {
    return !!(HU(r) && e.call(
      this,
      r,
      typeof i == "number" ? i : void 0,
      a || void 0
    ));
  }
}
function qU() {
  return !0;
}
function HU(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const S1 = [], WU = !0, T_ = !1, KU = "skip";
function GU(e, n, r, i) {
  let a;
  typeof n == "function" && typeof r != "function" ? (i = r, r = n) : a = n;
  const o = _1(a), s = i ? -1 : 1;
  l(e, void 0, [])();
  function l(u, p, d) {
    const f = (
      /** @type {Record<string, unknown>} */
      u && typeof u == "object" ? u : {}
    );
    if (typeof f.type == "string") {
      const v = (
        // `hast`
        typeof f.tagName == "string" ? f.tagName : (
          // `xast`
          typeof f.name == "string" ? f.name : void 0
        )
      );
      Object.defineProperty(h, "name", {
        value: "node (" + (u.type + (v ? "<" + v + ">" : "")) + ")"
      });
    }
    return h;
    function h() {
      let v = S1, C, j, N;
      if ((!n || o(u, p, d[d.length - 1] || void 0)) && (v = YU(r(u, d)), v[0] === T_))
        return v;
      if ("children" in u && u.children) {
        const x = (
          /** @type {UnistParent} */
          u
        );
        if (x.children && v[0] !== KU)
          for (j = (i ? x.children.length : -1) + s, N = d.concat(x); j > -1 && j < x.children.length; ) {
            const g = x.children[j];
            if (C = l(g, j, N)(), C[0] === T_)
              return C;
            j = typeof C[1] == "number" ? C[1] : j + s;
          }
      }
      return v;
    }
  }
}
function YU(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [WU, e] : e == null ? S1 : [e];
}
function N1(e, n, r, i) {
  let a, o, s;
  typeof n == "function" && typeof r != "function" ? (o = void 0, s = n, a = r) : (o = n, s = r, a = i), GU(e, o, l, a);
  function l(u, p) {
    const d = p[p.length - 1], f = d ? d.children.indexOf(u) : void 0;
    return s(u, f, d);
  }
}
const Uh = {}.hasOwnProperty, JU = {};
function QU(e, n) {
  const r = n || JU, i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), s = { ...OU, ...r.handlers }, l = {
    all: p,
    applyData: ZU,
    definitionById: i,
    footnoteById: a,
    footnoteCounts: o,
    footnoteOrder: [],
    handlers: s,
    one: u,
    options: r,
    patch: XU,
    wrap: n4
  };
  return N1(e, function(d) {
    if (d.type === "definition" || d.type === "footnoteDefinition") {
      const f = d.type === "definition" ? i : a, h = String(d.identifier).toUpperCase();
      f.has(h) || f.set(h, d);
    }
  }), l;
  function u(d, f) {
    const h = d.type, v = l.handlers[h];
    if (Uh.call(l.handlers, h) && v)
      return v(l, d, f);
    if (l.options.passThrough && l.options.passThrough.includes(h)) {
      if ("children" in d) {
        const { children: j, ...N } = d, x = cl(N);
        return x.children = l.all(d), x;
      }
      return cl(d);
    }
    return (l.options.unknownHandler || e4)(l, d, f);
  }
  function p(d) {
    const f = [];
    if ("children" in d) {
      const h = d.children;
      let v = -1;
      for (; ++v < h.length; ) {
        const C = l.one(h[v], d);
        if (C) {
          if (v && h[v - 1].type === "break" && (!Array.isArray(C) && C.type === "text" && (C.value = O_(C.value)), !Array.isArray(C) && C.type === "element")) {
            const j = C.children[0];
            j && j.type === "text" && (j.value = O_(j.value));
          }
          Array.isArray(C) ? f.push(...C) : f.push(C);
        }
      }
    }
    return f;
  }
}
function XU(e, n) {
  e.position && (n.position = OV(e));
}
function ZU(e, n) {
  let r = n;
  if (e && e.data) {
    const i = e.data.hName, a = e.data.hChildren, o = e.data.hProperties;
    if (typeof i == "string")
      if (r.type === "element")
        r.tagName = i;
      else {
        const s = "children" in r ? r.children : [r];
        r = { type: "element", tagName: i, properties: {}, children: s };
      }
    r.type === "element" && o && Object.assign(r.properties, cl(o)), "children" in r && r.children && a !== null && a !== void 0 && (r.children = a);
  }
  return r;
}
function e4(e, n) {
  const r = n.data || {}, i = "value" in n && !(Uh.call(r, "hProperties") || Uh.call(r, "hChildren")) ? { type: "text", value: n.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function n4(e, n) {
  const r = [];
  let i = -1;
  for (n && r.push({ type: "text", value: `
` }); ++i < e.length; )
    i && r.push({ type: "text", value: `
` }), r.push(e[i]);
  return n && e.length > 0 && r.push({ type: "text", value: `
` }), r;
}
function O_(e) {
  let n = 0, r = e.charCodeAt(n);
  for (; r === 9 || r === 32; )
    n++, r = e.charCodeAt(n);
  return e.slice(n);
}
function D_(e, n) {
  const r = QU(e, n), i = r.one(e, void 0), a = zU(r), o = Array.isArray(i) ? { type: "root", children: i } : i || { type: "root", children: [] };
  return a && o.children.push({ type: "text", value: `
` }, a), o;
}
function t4(e, n) {
  return e && "run" in e ? async function(r, i) {
    const a = (
      /** @type {HastRoot} */
      D_(r, { file: i, ...n })
    );
    await e.run(a, i);
  } : function(r, i) {
    return (
      /** @type {HastRoot} */
      D_(r, { file: i, ...e || n })
    );
  };
}
function P_(e) {
  if (e)
    throw e;
}
var em, R_;
function r4() {
  if (R_) return em;
  R_ = 1;
  var e = Object.prototype.hasOwnProperty, n = Object.prototype.toString, r = Object.defineProperty, i = Object.getOwnPropertyDescriptor, a = function(p) {
    return typeof Array.isArray == "function" ? Array.isArray(p) : n.call(p) === "[object Array]";
  }, o = function(p) {
    if (!p || n.call(p) !== "[object Object]")
      return !1;
    var d = e.call(p, "constructor"), f = p.constructor && p.constructor.prototype && e.call(p.constructor.prototype, "isPrototypeOf");
    if (p.constructor && !d && !f)
      return !1;
    var h;
    for (h in p)
      ;
    return typeof h > "u" || e.call(p, h);
  }, s = function(p, d) {
    r && d.name === "__proto__" ? r(p, d.name, {
      enumerable: !0,
      configurable: !0,
      value: d.newValue,
      writable: !0
    }) : p[d.name] = d.newValue;
  }, l = function(p, d) {
    if (d === "__proto__")
      if (e.call(p, d)) {
        if (i)
          return i(p, d).value;
      } else return;
    return p[d];
  };
  return em = function u() {
    var p, d, f, h, v, C, j = arguments[0], N = 1, x = arguments.length, g = !1;
    for (typeof j == "boolean" && (g = j, j = arguments[1] || {}, N = 2), (j == null || typeof j != "object" && typeof j != "function") && (j = {}); N < x; ++N)
      if (p = arguments[N], p != null)
        for (d in p)
          f = l(j, d), h = l(p, d), j !== h && (g && h && (o(h) || (v = a(h))) ? (v ? (v = !1, C = f && a(f) ? f : []) : C = f && o(f) ? f : {}, s(j, { name: d, newValue: u(g, C, h) })) : typeof h < "u" && s(j, { name: d, newValue: h }));
    return j;
  }, em;
}
var i4 = r4();
const nm = /* @__PURE__ */ py(i4);
function Mh(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function a4() {
  const e = [], n = { run: r, use: i };
  return n;
  function r(...a) {
    let o = -1;
    const s = a.pop();
    if (typeof s != "function")
      throw new TypeError("Expected function as last argument, not " + s);
    l(null, ...a);
    function l(u, ...p) {
      const d = e[++o];
      let f = -1;
      if (u) {
        s(u);
        return;
      }
      for (; ++f < a.length; )
        (p[f] === null || p[f] === void 0) && (p[f] = a[f]);
      a = p, d ? o4(d, l)(...p) : s(null, ...p);
    }
  }
  function i(a) {
    if (typeof a != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + a
      );
    return e.push(a), n;
  }
}
function o4(e, n) {
  let r;
  return i;
  function i(...s) {
    const l = e.length > s.length;
    let u;
    l && s.push(a);
    try {
      u = e.apply(this, s);
    } catch (p) {
      const d = (
        /** @type {Error} */
        p
      );
      if (l && r)
        throw d;
      return a(d);
    }
    l || (u instanceof Promise ? u.then(o, a) : u instanceof Error ? a(u) : o(u));
  }
  function a(s, ...l) {
    r || (r = !0, n(s, ...l));
  }
  function o(s) {
    a(null, s);
  }
}
const Pr = { basename: s4, dirname: l4, extname: c4, join: u4, sep: "/" };
function s4(e, n) {
  if (n !== void 0 && typeof n != "string")
    throw new TypeError('"ext" argument must be a string');
  Mo(e);
  let r = 0, i = -1, a = e.length, o;
  if (n === void 0 || n.length === 0 || n.length > e.length) {
    for (; a--; )
      if (e.codePointAt(a) === 47) {
        if (o) {
          r = a + 1;
          break;
        }
      } else i < 0 && (o = !0, i = a + 1);
    return i < 0 ? "" : e.slice(r, i);
  }
  if (n === e)
    return "";
  let s = -1, l = n.length - 1;
  for (; a--; )
    if (e.codePointAt(a) === 47) {
      if (o) {
        r = a + 1;
        break;
      }
    } else
      s < 0 && (o = !0, s = a + 1), l > -1 && (e.codePointAt(a) === n.codePointAt(l--) ? l < 0 && (i = a) : (l = -1, i = s));
  return r === i ? i = s : i < 0 && (i = e.length), e.slice(r, i);
}
function l4(e) {
  if (Mo(e), e.length === 0)
    return ".";
  let n = -1, r = e.length, i;
  for (; --r; )
    if (e.codePointAt(r) === 47) {
      if (i) {
        n = r;
        break;
      }
    } else i || (i = !0);
  return n < 0 ? e.codePointAt(0) === 47 ? "/" : "." : n === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, n);
}
function c4(e) {
  Mo(e);
  let n = e.length, r = -1, i = 0, a = -1, o = 0, s;
  for (; n--; ) {
    const l = e.codePointAt(n);
    if (l === 47) {
      if (s) {
        i = n + 1;
        break;
      }
      continue;
    }
    r < 0 && (s = !0, r = n + 1), l === 46 ? a < 0 ? a = n : o !== 1 && (o = 1) : a > -1 && (o = -1);
  }
  return a < 0 || r < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && a === r - 1 && a === i + 1 ? "" : e.slice(a, r);
}
function u4(...e) {
  let n = -1, r;
  for (; ++n < e.length; )
    Mo(e[n]), e[n] && (r = r === void 0 ? e[n] : r + "/" + e[n]);
  return r === void 0 ? "." : d4(r);
}
function d4(e) {
  Mo(e);
  const n = e.codePointAt(0) === 47;
  let r = m4(e, !n);
  return r.length === 0 && !n && (r = "."), r.length > 0 && e.codePointAt(e.length - 1) === 47 && (r += "/"), n ? "/" + r : r;
}
function m4(e, n) {
  let r = "", i = 0, a = -1, o = 0, s = -1, l, u;
  for (; ++s <= e.length; ) {
    if (s < e.length)
      l = e.codePointAt(s);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(a === s - 1 || o === 1)) if (a !== s - 1 && o === 2) {
        if (r.length < 2 || i !== 2 || r.codePointAt(r.length - 1) !== 46 || r.codePointAt(r.length - 2) !== 46) {
          if (r.length > 2) {
            if (u = r.lastIndexOf("/"), u !== r.length - 1) {
              u < 0 ? (r = "", i = 0) : (r = r.slice(0, u), i = r.length - 1 - r.lastIndexOf("/")), a = s, o = 0;
              continue;
            }
          } else if (r.length > 0) {
            r = "", i = 0, a = s, o = 0;
            continue;
          }
        }
        n && (r = r.length > 0 ? r + "/.." : "..", i = 2);
      } else
        r.length > 0 ? r += "/" + e.slice(a + 1, s) : r = e.slice(a + 1, s), i = s - a - 1;
      a = s, o = 0;
    } else l === 46 && o > -1 ? o++ : o = -1;
  }
  return r;
}
function Mo(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const p4 = { cwd: f4 };
function f4() {
  return "/";
}
function Bh(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function h4(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!Bh(e)) {
    const n = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw n.code = "ERR_INVALID_ARG_TYPE", n;
  }
  if (e.protocol !== "file:") {
    const n = new TypeError("The URL must be of scheme file");
    throw n.code = "ERR_INVALID_URL_SCHEME", n;
  }
  return y4(e);
}
function y4(e) {
  if (e.hostname !== "") {
    const i = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw i.code = "ERR_INVALID_FILE_URL_HOST", i;
  }
  const n = e.pathname;
  let r = -1;
  for (; ++r < n.length; )
    if (n.codePointAt(r) === 37 && n.codePointAt(r + 1) === 50) {
      const i = n.codePointAt(r + 2);
      if (i === 70 || i === 102) {
        const a = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw a.code = "ERR_INVALID_FILE_URL_PATH", a;
      }
    }
  return decodeURIComponent(n);
}
const tm = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class j1 {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(n) {
    let r;
    n ? Bh(n) ? r = { path: n } : typeof n == "string" || g4(n) ? r = { value: n } : r = n : r = {}, this.cwd = "cwd" in r ? "" : p4.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let i = -1;
    for (; ++i < tm.length; ) {
      const o = tm[i];
      o in r && r[o] !== void 0 && r[o] !== null && (this[o] = o === "history" ? [...r[o]] : r[o]);
    }
    let a;
    for (a in r)
      tm.includes(a) || (this[a] = r[a]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? Pr.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(n) {
    im(n, "basename"), rm(n, "basename"), this.path = Pr.join(this.dirname || "", n);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? Pr.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(n) {
    A_(this.basename, "dirname"), this.path = Pr.join(n || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? Pr.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(n) {
    if (rm(n, "extname"), A_(this.dirname, "extname"), n) {
      if (n.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (n.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Pr.join(this.dirname, this.stem + (n || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(n) {
    Bh(n) && (n = h4(n)), im(n, "path"), this.path !== n && this.history.push(n);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? Pr.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(n) {
    im(n, "stem"), rm(n, "stem"), this.path = Pr.join(this.dirname || "", n + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(n, r, i) {
    const a = this.message(n, r, i);
    throw a.fatal = !0, a;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(n, r, i) {
    const a = this.message(n, r, i);
    return a.fatal = void 0, a;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(n, r, i) {
    const a = new Bt(
      // @ts-expect-error: the overloads are fine.
      n,
      r,
      i
    );
    return this.path && (a.name = this.path + ":" + a.name, a.file = this.path), a.fatal = !1, this.messages.push(a), a;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(n) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(n || void 0).decode(this.value);
  }
}
function rm(e, n) {
  if (e && e.includes(Pr.sep))
    throw new Error(
      "`" + n + "` cannot be a path: did not expect `" + Pr.sep + "`"
    );
}
function im(e, n) {
  if (!e)
    throw new Error("`" + n + "` cannot be empty");
}
function A_(e, n) {
  if (!e)
    throw new Error("Setting `" + n + "` requires `path` to be set too");
}
function g4(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const v4 = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(e) {
    const i = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), a = i[e], o = function() {
      return a.apply(o, arguments);
    };
    return Object.setPrototypeOf(o, i), o;
  })
), k4 = {}.hasOwnProperty;
class dg extends v4 {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = a4();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const n = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new dg()
    );
    let r = -1;
    for (; ++r < this.attachers.length; ) {
      const i = this.attachers[r];
      n.use(...i);
    }
    return n.data(nm(!0, {}, this.namespace)), n;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(n, r) {
    return typeof n == "string" ? arguments.length === 2 ? (sm("data", this.frozen), this.namespace[n] = r, this) : k4.call(this.namespace, n) && this.namespace[n] || void 0 : n ? (sm("data", this.frozen), this.namespace = n, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const n = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [r, ...i] = this.attachers[this.freezeIndex];
      if (i[0] === !1)
        continue;
      i[0] === !0 && (i[0] = void 0);
      const a = r.call(n, ...i);
      typeof a == "function" && this.transformers.use(a);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(n) {
    this.freeze();
    const r = ls(n), i = this.parser || this.Parser;
    return am("parse", i), i(String(r), r);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(n, r) {
    const i = this;
    return this.freeze(), am("process", this.parser || this.Parser), om("process", this.compiler || this.Compiler), r ? a(void 0, r) : new Promise(a);
    function a(o, s) {
      const l = ls(n), u = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        i.parse(l)
      );
      i.run(u, l, function(d, f, h) {
        if (d || !f || !h)
          return p(d);
        const v = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          f
        ), C = i.stringify(v, h);
        _4(C) ? h.value = C : h.result = C, p(
          d,
          /** @type {VFileWithOutput<CompileResult>} */
          h
        );
      });
      function p(d, f) {
        d || !f ? s(d) : o ? o(f) : r(void 0, f);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(n) {
    let r = !1, i;
    return this.freeze(), am("processSync", this.parser || this.Parser), om("processSync", this.compiler || this.Compiler), this.process(n, a), V_("processSync", "process", r), i;
    function a(o, s) {
      r = !0, P_(o), i = s;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(n, r, i) {
    L_(n), this.freeze();
    const a = this.transformers;
    return !i && typeof r == "function" && (i = r, r = void 0), i ? o(void 0, i) : new Promise(o);
    function o(s, l) {
      const u = ls(r);
      a.run(n, u, p);
      function p(d, f, h) {
        const v = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          f || n
        );
        d ? l(d) : s ? s(v) : i(void 0, v, h);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(n, r) {
    let i = !1, a;
    return this.run(n, r, o), V_("runSync", "run", i), a;
    function o(s, l) {
      P_(s), a = l, i = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(n, r) {
    this.freeze();
    const i = ls(r), a = this.compiler || this.Compiler;
    return om("stringify", a), L_(n), a(n, i);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(n, ...r) {
    const i = this.attachers, a = this.namespace;
    if (sm("use", this.frozen), n != null) if (typeof n == "function")
      u(n, r);
    else if (typeof n == "object")
      Array.isArray(n) ? l(n) : s(n);
    else
      throw new TypeError("Expected usable value, not `" + n + "`");
    return this;
    function o(p) {
      if (typeof p == "function")
        u(p, []);
      else if (typeof p == "object")
        if (Array.isArray(p)) {
          const [d, ...f] = (
            /** @type {PluginTuple<Array<unknown>>} */
            p
          );
          u(d, f);
        } else
          s(p);
      else
        throw new TypeError("Expected usable value, not `" + p + "`");
    }
    function s(p) {
      if (!("plugins" in p) && !("settings" in p))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      l(p.plugins), p.settings && (a.settings = nm(!0, a.settings, p.settings));
    }
    function l(p) {
      let d = -1;
      if (p != null) if (Array.isArray(p))
        for (; ++d < p.length; ) {
          const f = p[d];
          o(f);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + p + "`");
    }
    function u(p, d) {
      let f = -1, h = -1;
      for (; ++f < i.length; )
        if (i[f][0] === p) {
          h = f;
          break;
        }
      if (h === -1)
        i.push([p, ...d]);
      else if (d.length > 0) {
        let [v, ...C] = d;
        const j = i[h][1];
        Mh(j) && Mh(v) && (v = nm(!0, j, v)), i[h] = [p, v, ...C];
      }
    }
  }
}
const b4 = new dg().freeze();
function am(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function om(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function sm(e, n) {
  if (n)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function L_(e) {
  if (!Mh(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function V_(e, n, r) {
  if (!r)
    throw new Error(
      "`" + e + "` finished async. Use `" + n + "` instead"
    );
}
function ls(e) {
  return x4(e) ? e : new j1(e);
}
function x4(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function _4(e) {
  return typeof e == "string" || S4(e);
}
function S4(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const N4 = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", z_ = [], U_ = { allowDangerousHtml: !0 }, j4 = /^(https?|ircs?|mailto|xmpp)$/i, w4 = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function C4(e) {
  const n = e.allowedElements, r = e.allowElement, i = e.children || "", a = e.className, o = e.components, s = e.disallowedElements, l = e.rehypePlugins || z_, u = e.remarkPlugins || z_, p = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...U_ } : U_, d = e.skipHtml, f = e.unwrapDisallowed, h = e.urlTransform || I4, v = b4().use(sU).use(u).use(t4, p).use(l), C = new j1();
  typeof i == "string" && (C.value = i);
  for (const g of w4)
    Object.hasOwn(e, g.from) && ("" + g.from + (g.to ? "use `" + g.to + "` instead" : "remove it") + N4 + g.id, void 0);
  const j = v.parse(C);
  let N = v.runSync(j, C);
  return a && (N = {
    type: "element",
    tagName: "div",
    properties: { className: a },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      N.type === "root" ? N.children : [N]
    )
  }), N1(N, x), VV(N, {
    Fragment: Ke.Fragment,
    components: o,
    ignoreInvalidStyle: !0,
    jsx: Ke.jsx,
    jsxs: Ke.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function x(g, P, E) {
    if (g.type === "raw" && E && typeof P == "number")
      return d ? E.children.splice(P, 1) : E.children[P] = { type: "text", value: g.value }, P;
    if (g.type === "element") {
      let I;
      for (I in Qd)
        if (Object.hasOwn(Qd, I) && Object.hasOwn(g.properties, I)) {
          const w = g.properties[I], A = Qd[I];
          (A === null || A.includes(g.tagName)) && (g.properties[I] = h(String(w || ""), I, g));
        }
    }
    if (g.type === "element") {
      let I = n ? !n.includes(g.tagName) : s ? s.includes(g.tagName) : !1;
      if (!I && r && typeof P == "number" && (I = !r(g, P, E)), I && E && typeof P == "number")
        return f && g.children ? E.children.splice(P, 1, ...g.children) : E.children.splice(P, 1), P;
    }
  }
}
function I4(e) {
  const n = e.indexOf(":"), r = e.indexOf("?"), i = e.indexOf("#"), a = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    n < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    a > -1 && n > a || r > -1 && n > r || i > -1 && n > i || // It is a protocol, it should be allowed.
    j4.test(e.slice(0, n)) ? e : ""
  );
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('._issueAvatar_kc0sw_1{margin:var(--dixa-size-spacer-100) 0}._issueAvatar_kc0sw_1 h2{font-weight:var(--dixa-typography-weight-normal);align-items:center;display:flex}._issueField_kc0sw_9{font-weight:var(--dixa-typography-weight-normal)}._issueDescription_kc0sw_12{font-weight:var(--dixa-typography-weight-normal);color:var(--dixa-color-neutral-800);padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._issueDescription_kc0sw_12 p{margin:unset}._wrapper_e0qj3_1{width:400px;padding:0 0 var(--dixa-size-spacer-200) 0;max-height:400px;overflow:hidden;position:relative}._wrapper_e0qj3_1 ._description_e0qj3_8{color:var(--dixa-color-neutral-600)}._wrapper_e0qj3_1:after{width:100%;height:var(--dixa-size-spacer-400);content:"";position:absolute;bottom:0;left:0;background:linear-gradient(0deg,#fff,#ffffffbc 19%,#ffffff8a 34%,#ffffff61 47%,#ffffff47 56.5%,#ffffff31 65%,#ffffff20 73%,#ffffff13 80.2%,#ffffff0b 86.1%,#ffffff05 91%,#ffffff02 95.2%,#ffffff01 98.2%,#fff0)}._resultTitle_e0qj3_21{text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--dixa-color-neutral-600)}._resultTooltipTitle_e0qj3_28{margin-bottom:var(--dixa-size-spacer-200)}._resultLinkIcon_e0qj3_31{position:absolute;right:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-000);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);color:var(--dixa-color-neutral-500)}._loader_13xpk_1{width:100%;display:flex;padding:var(--dixa-size-spacer-200);justify-content:center}._dropdown_13xpk_8{max-height:300px;overflow-y:scroll}._loadMore_13xpk_13{cursor:pointer}._loadMore_13xpk_13:hover{background-color:var(--dixa-color-neutral-100)}._loadMore_13xpk_13:hover p{color:var(--dixa-color-purple-600)}._loadMore_13xpk_13 p{color:var(--dixa-color-purple-500)}._collapse_su0f9_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8{padding:var(--dixa-size-spacer-250);width:100%;box-sizing:border-box;background-color:transparent;gap:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8>div:first-of-type{padding:0!important;padding-right:var(--dixa-size-spacer-300);width:100%}._collapseHeader_su0f9_8>div>div:first-of-type{padding:0!important;width:100%}._collapseHeader_su0f9_8 p>div:first-of-type{justify-content:space-between}._collapseHeader_su0f9_8>div>div>p{white-space:unset!important;margin:0}._collapseContent_su0f9_31{padding:0 var(--dixa-size-spacer-250) var(--dixa-size-spacer-250) var(--dixa-size-spacer-250)}._url_su0f9_35{align-items:center;display:flex;flex-direction:row;gap:var(--dixa-size-spacer-100);color:var(--dixa-color-purple-500);font-weight:var(--dixa-typography-weight-semibold);cursor:pointer;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200)}._empty_su0f9_47 p{color:var(--dixa-color-neutral-400)}._externalLink_su0f9_51{color:var(--dixa-typography-color-link)}._emptyState_su0f9_55{font-weight:var(--dixa-typography-weight-normal)}._modalBody_iv3ua_1{width:600px}._error_iv3ua_5{border:var(--dixa-size-border-100) solid var(--dixa-typography-color-error)}._emptyState_iv3ua_9{padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200) var(--dixa-size-spacer-200)}._emptyState_iv3ua_9 p{color:var(--dixa-color-neutral-400)}._dropdown_iv3ua_16{max-height:300px;overflow-y:scroll}._modalWrapper_4kh9u_1{min-width:600px;position:relative}._copyButton_4kh9u_6{height:var(--dixa-size-spacer-500);width:var(--dixa-size-spacer-500)}._copyButton_4kh9u_6 button{background-color:var(--dixa-color-neutral-100);border-radius:0 var(--dixa-size-border-radius-100) var(--dixa-size-border-radius-100) 0}._copyWrapper_4kh9u_15{box-sizing:border-box}._copyWrapper_4kh9u_15:focus-within{border-radius:var(--dixa-size-border-radius-100);outline:solid var(--dixa-size-border-100) var(--dixa-color-purple-500);box-shadow:0 0 0 3px var(--dixa-color-purple-300)}._copyField_4kh9u_24{cursor:pointer;min-width:62ch;height:var(--dixa-size-spacer-500);border-radius:var(--dixa-size-border-radius-100) 0 0 var(--dixa-size-border-radius-100);border:none}._copyField_4kh9u_24:hover{border:none}._copyField_4kh9u_24:focus-within{box-shadow:none;border:none;outline:none}._copyField_4kh9u_24 input{color:var(--dixa-color-neutral-800);background-color:var(--dixa-color-neutral-100);cursor:pointer;border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-right:none}._externalLink_4kh9u_47{display:flex;align-items:center}._externalLinkIcon_4kh9u_52{align-self:center}._textWrapper_4kh9u_56{display:flex;gap:var(--dixa-size-spacer-100)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var lm = { exports: {} }, Qa = {}, M_;
function F4() {
  if (M_) return Qa;
  M_ = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Qa.Fragment = r, Qa.jsx = s, Qa.jsxs = s, Qa;
}
var cs = {}, B_;
function E4() {
  return B_ || (B_ = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        P("error", t, m);
      }
    }
    function P(t, c, m) {
      {
        var y = x.ReactDebugCurrentFrame, F = y.getStackAddendum();
        F !== "" && (c += "%s", m = m.concat([F]));
        var T = m.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var E = !1, I = !1, w = !1, A = !1, H = !1, Y;
    Y = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ne(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || H || t === a || t === p || t === d || A || t === v || E || I || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function W(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var F = c.displayName || c.name || "";
      return F !== "" ? m + "(" + F + ")" : m;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function D(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var m = t;
            return B(m._context) + ".Provider";
          case u:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : D(t.type) || "Memo";
          case h: {
            var F = t, T = F._payload, S = F._init;
            try {
              return D(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var M = Object.assign, Z = 0, je, ge, ye, ke, q, _e, De;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function Ye() {
      {
        if (Z === 0) {
          je = console.log, ge = console.info, ye = console.warn, ke = console.error, q = console.group, _e = console.groupCollapsed, De = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function sn() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: M({}, t, {
              value: je
            }),
            info: M({}, t, {
              value: ge
            }),
            warn: M({}, t, {
              value: ye
            }),
            error: M({}, t, {
              value: ke
            }),
            group: M({}, t, {
              value: q
            }),
            groupCollapsed: M({}, t, {
              value: _e
            }),
            groupEnd: M({}, t, {
              value: De
            })
          });
        }
        Z < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = x.ReactCurrentDispatcher, Ue;
    function Pe(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (F) {
            var y = F.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Le;
    {
      var Xe = typeof WeakMap == "function" ? WeakMap : Map;
      Le = new Xe();
    }
    function Fe(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Le.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      Be = !0;
      var F = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ye();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (re) {
              y = re;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (re) {
              y = re;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            y = re;
          }
          t();
        }
      } catch (re) {
        if (re && y && typeof re.stack == "string") {
          for (var _ = re.stack.split(`
`), ee = y.stack.split(`
`), L = _.length - 1, U = ee.length - 1; L >= 1 && U >= 0 && _[L] !== ee[U]; )
            U--;
          for (; L >= 1 && U >= 0; L--, U--)
            if (_[L] !== ee[U]) {
              if (L !== 1 || U !== 1)
                do
                  if (L--, U--, U < 0 || _[L] !== ee[U]) {
                    var ce = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && ce.includes("<anonymous>") && (ce = ce.replace("<anonymous>", t.displayName)), typeof t == "function" && Le.set(t, ce), ce;
                  }
                while (L >= 1 && U >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = F;
      }
      var ze = t ? t.displayName || t.name : "", Oe = ze ? Pe(ze) : "";
      return typeof t == "function" && Le.set(t, Oe), Oe;
    }
    function Me(t, c, m) {
      return Fe(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Fe(t, nn(t));
      if (typeof t == "string")
        return Pe(t);
      switch (t) {
        case p:
          return Pe("Suspense");
        case d:
          return Pe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return Me(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, F = y._payload, T = y._init;
            try {
              return se(T(F), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Se = {}, Ae = x.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(m);
      } else
        Ae.setExtraStackFrame(null);
    }
    function yn(t, c, m, y, F) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + m + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              _ = t[S](c, S, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Re(F), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, S, typeof _), Re(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Re(F), g("Failed %s type: %s", m, _.message), Re(null));
          }
      }
    }
    var Q = Array.isArray;
    function $(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ae(t);
    }
    var J = x.ReactCurrentOwner, de = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, xe, $e;
    function tn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && J.current;
    }
    function pn(t, c) {
      {
        var m = function() {
          xe || (xe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function Fn(t, c) {
      {
        var m = function() {
          $e || ($e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, m, y, F, T, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: F
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, m, y, F) {
      {
        var T, S = {}, _ = null, ee = null;
        m !== void 0 && (V(m), _ = "" + m), gn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ee = c.ref, on(c));
        for (T in c)
          le.call(c, T) && !de.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (T in L)
            S[T] === void 0 && (S[T] = L[T]);
        }
        if (_ || ee) {
          var U = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, U), ee && Fn(S, U);
        }
        return xn(t, _, ee, F, y, J.current, S);
      }
    }
    var en = x.ReactCurrentOwner, vn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        vn.setExtraStackFrame(m);
      } else
        vn.setExtraStackFrame(null);
    }
    var un;
    un = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = D(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Nn = {};
    function Rn(t) {
      {
        var c = jn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function kn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Rn(c);
        if (Nn[m])
          return;
        Nn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + D(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Ve(null);
      }
    }
    function _n(t, c) {
      {
        if (typeof t != "object")
          return;
        if ($(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            dn(y) && kn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var F = N(t);
          if (typeof F == "function" && F !== t.entries)
            for (var T = F.call(t), S; !(S = T.next()).done; )
              dn(S.value) && kn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = D(c);
          yn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !un) {
          un = !0;
          var F = D(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", F || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, m, y, F, T) {
      {
        var S = ne(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = Bn();
          ee ? _ += ee : _ += jn();
          var L;
          t === null ? L = "null" : $(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (D(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var U = En(t, c, m, F, T);
        if (U == null)
          return U;
        if (S) {
          var ce = c.children;
          if (ce !== void 0)
            if (y)
              if ($(ce)) {
                for (var ze = 0; ze < ce.length; ze++)
                  _n(ce[ze], t);
                Object.freeze && Object.freeze(ce);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _n(ce, t);
        }
        if (le.call(c, "key")) {
          var Oe = D(t), re = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), mn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Oe + mn]) {
            var Dn = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Oe, Dn, Oe), Cn[Oe + mn] = !0;
          }
        }
        return t === i ? Ln(U) : An(U), U;
      }
    }
    function Vn(t, c, m) {
      return wn(t, c, m, !0);
    }
    function qn(t, c, m) {
      return wn(t, c, m, !1);
    }
    var zn = qn, Wn = Vn;
    cs.Fragment = i, cs.jsx = zn, cs.jsxs = Wn;
  })()), cs;
}
var q_;
function $4() {
  return q_ || (q_ = 1, process.env.NODE_ENV === "production" ? lm.exports = F4() : lm.exports = E4()), lm.exports;
}
var oe = $4();
const T4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "statusId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "priority" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } } }, { kind: "ObjectField", name: { kind: "Name", value: "description" }, value: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } } }, { kind: "ObjectField", name: { kind: "Name", value: "teamId" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "projectId" }, value: { kind: "Variable", name: { kind: "Name", value: "projectId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "stateId" }, value: { kind: "Variable", name: { kind: "Name", value: "statusId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "priority" }, value: { kind: "Variable", name: { kind: "Name", value: "priority" } } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "success" } }, { kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] }, O4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "staticData" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "issuePriorityValues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "label" } }] } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] }, D4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "teamData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "team" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "states" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "templates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "templateData" } }] } }] } }] } }] } }] } }] } }] }, P4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "after" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchIssues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }, { kind: "Argument", name: { kind: "Name", value: "after" }, value: { kind: "Variable", name: { kind: "Name", value: "after" } } }, { kind: "Argument", name: { kind: "Name", value: "term" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "pageInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hasNextPage" } }, { kind: "Field", name: { kind: "Name", value: "endCursor" } }] } }] } }] } }] } }] }, R4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchLinkedIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } }, type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "in" }, value: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, A4 = {
  "\n  mutation createIssue(\n    $issueTitle: String!\n    $issueDescription: String\n    $teamId: String!\n    $projectId: String\n    $statusId: String\n    $priority: Int\n  ) {\n    Linear {\n      issueCreate(\n        input: {\n          title: $issueTitle\n          description: $issueDescription\n          teamId: $teamId\n          projectId: $projectId\n          stateId: $statusId\n          priority: $priority\n        }\n      ) {\n        success\n        issue {\n          id\n          title\n          identifier\n          url\n        }\n      }\n    }\n  }\n": T4,
  "\n  query staticData {\n    Linear {\n      teams {\n        edges {\n          node {\n            id\n            name\n            organization {\n              urlKey\n            }\n          }\n        }\n      }\n      issuePriorityValues {\n        priority\n        label\n      }\n      organization {\n        urlKey\n      }\n    }\n  }\n": O4,
  "\n  query teamData($teamId: String!) {\n    Linear {\n      team(id: $teamId) {\n        projects {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        states {\n          edges {\n            node {\n              id\n              name\n              type\n              color\n            }\n          }\n        }\n        templates {\n          edges {\n            node {\n              id\n              name\n              type\n              templateData\n            }\n          }\n        }\n      }\n    }\n  }\n": D4,
  "\n  query searchIssues($issueQuery: String! $after: String, $first: Int ) {\n    Linear {\n      searchIssues(\n        first:$first\n        after:$after\n        term: $issueQuery\n      ) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n": P4,
  "\n  query searchLinkedIssues($linkedIssues: [ID!]) {\n    Linear {\n      issues(filter: { id: { in: $linkedIssues } }) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": R4
};
function Bo(e) {
  return A4[e] ?? {};
}
const L4 = Bo(
  /* GraphQL */
  `
  query searchIssues($issueQuery: String! $after: String, $first: Int ) {
    Linear {
      searchIssues(
        first:$first
        after:$after
        term: $issueQuery
      ) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`
), V4 = Bo(
  /* GraphQL */
  `
  query searchLinkedIssues($linkedIssues: [ID!]) {
    Linear {
      issues(filter: { id: { in: $linkedIssues } }) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
      }
    }
  }
`
), us = ({
  title: e,
  children: n
}) => /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "100", children: [
  /* @__PURE__ */ oe.jsx(O.Paragraph, { variant: "5", color: "neutral.500", children: e }),
  n
] }), z4 = "_issueAvatar_kc0sw_1", U4 = "_issueField_kc0sw_9", M4 = "_issueDescription_kc0sw_12", ds = {
  issueAvatar: z4,
  issueField: U4,
  issueDescription: M4
}, w1 = ({ issue: e }) => /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
  /* @__PURE__ */ oe.jsx(us, { title: "Assignee", children: /* @__PURE__ */ oe.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "row",
      alignContent: "center",
      className: ds.issueAvatar,
      children: [
        /* @__PURE__ */ oe.jsx(
          dy,
          {
            size: "24",
            user: e.assignee ? {
              name: e.assignee.name || null,
              // eslint-disable-next-line camelcase
              avatar_url: e.assignee.avatarUrl || null,
              email: e.assignee.email
            } : void 0
          }
        ),
        /* @__PURE__ */ oe.jsx(O.Heading, { variant: "heading-4", children: e.assignee ? e.assignee.name : "Unassigned" })
      ]
    }
  ) }),
  e.team?.name && /* @__PURE__ */ oe.jsx(us, { title: "Team", children: /* @__PURE__ */ oe.jsx(
    O.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: ds.issueField,
      children: e.team.name
    }
  ) }),
  e.project?.name && /* @__PURE__ */ oe.jsx(us, { title: "Project", children: /* @__PURE__ */ oe.jsx(
    O.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: ds.issueField,
      children: e.project.name
    }
  ) }),
  /* @__PURE__ */ oe.jsx(us, { title: "Description", children: /* @__PURE__ */ oe.jsx(C4, { className: ds.issueDescription, children: e.description }) })
] }), B4 = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "No Priority",
    "data-testid": "noPriorityIcon",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 5 7)" }),
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 8 7)" }),
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 11 7)" })
    ]
  }
), q4 = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Low Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1", fillOpacity: "0.4" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), H4 = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Medium Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), W4 = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "High Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1" })
    ]
  }
), K4 = /* @__PURE__ */ oe.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "-1 -1 15 15",
    "aria-label": "Urgent Priority",
    fill: "var(--dixa-color-orange-400)",
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 0a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V2a2 2 0 00-2-2H2zm3.914 3h1.738L7.5 8.602H6.07L5.914 3zm1.809 7.164a.95.95 0 01-.938.938.934.934 0 110-1.867c.5 0 .934.417.938.93z"
      }
    )
  }
), C1 = {
  0: B4,
  1: K4,
  2: W4,
  3: H4,
  4: q4
}, G4 = (e) => e in C1, ul = ({ priority: e }) => G4(e) ? C1[e] : /* @__PURE__ */ oe.jsx(Yn, { "data-testid": "defaultPriorityTag", children: e }), Y4 = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    "data-testid": "defaultStatusIcon",
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        d: "M13.9408 7.91426L11.9576 7.65557C11.9855 7.4419 12 7.22314 12 7C12 6.77686 11.9855 6.5581 11.9576 6.34443L13.9408 6.08573C13.9799 6.38496 14 6.69013 14 7C14 7.30987 13.9799 7.61504 13.9408 7.91426ZM13.4688 4.32049C13.2328 3.7514 12.9239 3.22019 12.5538 2.73851L10.968 3.95716C11.2328 4.30185 11.4533 4.68119 11.6214 5.08659L13.4688 4.32049ZM11.2615 1.4462L10.0428 3.03204C9.69815 2.76716 9.31881 2.54673 8.91341 2.37862L9.67951 0.531163C10.2486 0.767153 10.7798 1.07605 11.2615 1.4462ZM7.91426 0.0591659L7.65557 2.04237C7.4419 2.01449 7.22314 2 7 2C6.77686 2 6.5581 2.01449 6.34443 2.04237L6.08574 0.059166C6.38496 0.0201343 6.69013 0 7 0C7.30987 0 7.61504 0.0201343 7.91426 0.0591659ZM4.32049 0.531164L5.08659 2.37862C4.68119 2.54673 4.30185 2.76716 3.95716 3.03204L2.73851 1.4462C3.22019 1.07605 3.7514 0.767153 4.32049 0.531164ZM1.4462 2.73851L3.03204 3.95716C2.76716 4.30185 2.54673 4.68119 2.37862 5.08659L0.531164 4.32049C0.767153 3.7514 1.07605 3.22019 1.4462 2.73851ZM0.0591659 6.08574C0.0201343 6.38496 0 6.69013 0 7C0 7.30987 0.0201343 7.61504 0.059166 7.91426L2.04237 7.65557C2.01449 7.4419 2 7.22314 2 7C2 6.77686 2.01449 6.5581 2.04237 6.34443L0.0591659 6.08574ZM0.531164 9.67951L2.37862 8.91341C2.54673 9.31881 2.76716 9.69815 3.03204 10.0428L1.4462 11.2615C1.07605 10.7798 0.767153 10.2486 0.531164 9.67951ZM2.73851 12.5538L3.95716 10.968C4.30185 11.2328 4.68119 11.4533 5.08659 11.6214L4.32049 13.4688C3.7514 13.2328 3.22019 12.9239 2.73851 12.5538ZM6.08574 13.9408L6.34443 11.9576C6.5581 11.9855 6.77686 12 7 12C7.22314 12 7.4419 11.9855 7.65557 11.9576L7.91427 13.9408C7.61504 13.9799 7.30987 14 7 14C6.69013 14 6.38496 13.9799 6.08574 13.9408ZM9.67951 13.4688L8.91341 11.6214C9.31881 11.4533 9.69815 11.2328 10.0428 10.968L11.2615 12.5538C10.7798 12.9239 10.2486 13.2328 9.67951 13.4688ZM12.5538 11.2615L10.968 10.0428C11.2328 9.69815 11.4533 9.31881 11.6214 8.91341L13.4688 9.67951C13.2328 10.2486 12.924 10.7798 12.5538 11.2615Z",
        stroke: "none"
      }
    )
  }
), J4 = (e, n) => /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    "aria-label": n,
    "data-testid": "unstartedStatusIcon",
    children: [
      /* @__PURE__ */ oe.jsx(
        "rect",
        {
          x: "1",
          y: "1",
          width: "12",
          height: "12",
          rx: "6",
          stroke: e,
          strokeWidth: "2",
          fill: "none"
        }
      ),
      /* @__PURE__ */ oe.jsx(
        "path",
        {
          fill: e,
          stroke: "none",
          d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 0 z",
          transform: "translate(3.5,3.5)"
        }
      )
    ]
  }
), Q4 = (e, n) => /* @__PURE__ */ oe.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", "aria-label": n, children: [
  /* @__PURE__ */ oe.jsx(
    "rect",
    {
      x: "1",
      y: "1",
      width: "12",
      height: "12",
      rx: "6",
      stroke: e,
      strokeWidth: "2",
      fill: "none"
    }
  ),
  /* @__PURE__ */ oe.jsx(
    "path",
    {
      fill: e,
      stroke: "none",
      d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 7 z",
      transform: "translate(3.5,3.5)"
    }
  )
] }), X4 = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), Z4 = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM5.03033 3.96967C4.73744 3.67678 4.26256 3.67678 3.96967 3.96967C3.67678 4.26256 3.67678 4.73744 3.96967 5.03033L5.93934 7L3.96967 8.96967C3.67678 9.26256 3.67678 9.73744 3.96967 10.0303C4.26256 10.3232 4.73744 10.3232 5.03033 10.0303L7 8.06066L8.96967 10.0303C9.26256 10.3232 9.73744 10.3232 10.0303 10.0303C10.3232 9.73744 10.3232 9.26256 10.0303 8.96967L8.06066 7L10.0303 5.03033C10.3232 4.73744 10.3232 4.26256 10.0303 3.96967C9.73744 3.67678 9.26256 3.67678 8.96967 3.96967L7 5.93934L5.03033 3.96967Z",
        stroke: "none"
      }
    )
  }
), eM = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), qh = {
  backlog: (e, n) => Y4(e, n),
  unstarted: (e, n) => J4(e, n),
  started: (e, n) => Q4(e, n),
  done: (e, n) => X4(e, n),
  canceled: (e, n) => Z4(e, n),
  completed: (e, n) => eM(e, n)
}, nM = (e) => e in qh, dl = ({
  type: e = "backlog",
  color: n = "var(--dixa-color-neutral-400)",
  name: r = "linear-backlog-icon"
}) => nM(e) ? qh[e](n, r) : qh.backlog(
  "var(--dixa-color-neutral-400)",
  "linear-backlog-icon"
), tM = "_wrapper_e0qj3_1", rM = "_resultTitle_e0qj3_21", iM = "_resultTooltipTitle_e0qj3_28", aM = "_resultLinkIcon_e0qj3_31", Xa = {
  wrapper: tM,
  resultTitle: rM,
  resultTooltipTitle: iM,
  resultLinkIcon: aM
}, oM = ({
  issue: e
}) => {
  const [n, r] = ue(!1), {
    list: { isDisabled: i },
    item: { onSelect: a }
  } = cy(dF()), o = ft(
    (s) => {
      i || a({
        value: e,
        meta: {
          target: s?.target,
          event: s || void 0
        }
      });
    },
    [i, a, e]
  );
  return /* @__PURE__ */ oe.jsx(
    Ze,
    {
      wrap: "none",
      side: "left",
      content: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "300", className: Xa.wrapper, children: [
        /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", justifyContent: "space-between", gap: "300", children: [
          /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ oe.jsx(
              dl,
              {
                type: e.state.type,
                name: e.state.name,
                color: e.state.color
              }
            ),
            /* @__PURE__ */ oe.jsx(O.Heading, { variant: "heading-3", children: e.identifier }),
            /* @__PURE__ */ oe.jsx(ul, { priority: e.priority })
          ] }),
          /* @__PURE__ */ oe.jsx(Yn, { children: e.state.name })
        ] }),
        /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ oe.jsx(
            O.Heading,
            {
              variant: "heading-3",
              className: Xa.resultTooltipTitle,
              children: e.title
            }
          ),
          /* @__PURE__ */ oe.jsx(w1, { issue: e })
        ] })
      ] }),
      light: !0,
      children: /* @__PURE__ */ oe.jsx(
        pt.Item,
        {
          value: e,
          noFixedSelectionStateSpace: !0,
          className: Xa.result,
          onMouseEnter: () => r(!0),
          onMouseLeave: () => r(!1),
          "data-testid": "selectionListItemWrapper",
          onClick: o,
          children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              flexDirection: "column",
              style: {
                width: n ? "calc(100% - 32px)" : "100%"
              },
              children: [
                /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ oe.jsx(
                    dl,
                    {
                      type: e.state.type,
                      color: e.state.color,
                      name: e.state.name
                    }
                  ),
                  /* @__PURE__ */ oe.jsx(O.Heading, { variant: "heading-3", children: e.identifier }),
                  /* @__PURE__ */ oe.jsx(ul, { priority: e.priority })
                ] }),
                /* @__PURE__ */ oe.jsx(O.Paragraph, { variant: "4", className: Xa.resultTitle, children: e.title }),
                n && /* @__PURE__ */ oe.jsx(
                  he,
                  {
                    className: Xa.resultLinkIcon,
                    name: "plus",
                    size: 32
                  }
                )
              ]
            }
          )
        },
        e.id
      )
    }
  );
}, sM = "_loader_13xpk_1", lM = "_dropdown_13xpk_8", cM = "_loadMore_13xpk_13", cm = {
  loader: sM,
  dropdown: lM,
  loadMore: cM
}, uM = ({
  handleSelect: e,
  linkedIssues: n
}) => {
  const [r, i] = ue(), [a, o] = ue([]), [s, l] = ue(""), [u, p] = ue(!1), { useLazyQuery: d } = bn(), [f, { data: h, loading: v, networkStatus: C }] = d(
    L4,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0
    }
  );
  zi(
    () => {
      !v && s !== "" && C === rr.ready ? f({
        variables: {
          issueQuery: s,
          first: 8
        }
      }) : o([]);
    },
    500,
    [s]
  ), Je(() => {
    v || o([]);
  }, [s]), Je(() => {
    if (h && Object.keys(h).length > 0) {
      const N = h.Linear.searchIssues.edges.map(
        ({ node: E }) => E
      ), x = a.filter(
        (E) => !n.find((I) => I.id === E.id)
      ), g = x.filter(
        (E) => !N.find(
          (I) => I.id === E.id
        )
      ), P = N.filter(
        (E) => !n.find((I) => I.id === E.id)
      );
      n.length > 0 ? o(
        u ? [...g, ...P] : P
      ) : h?.Linear?.searchIssues?.edges && o(
        u ? [...x, ...N] : N
      ), h.Linear.searchIssues.pageInfo.hasNextPage && p(!1), i(h.Linear.searchIssues?.pageInfo);
    }
  }, [h, n]);
  const j = () => {
    !v && s !== "" && C === rr.ready ? (p(!0), f({
      variables: {
        issueQuery: s,
        first: 8,
        after: r?.endCursor
      }
    })) : o([]);
  };
  return /* @__PURE__ */ oe.jsx(b, { flexDirection: "column", gap: "200", "data-testid": "searchBarWrapper", children: /* @__PURE__ */ oe.jsxs(
    ei,
    {
      "data-testid": "searchBarComponent",
      clearable: !0,
      getItemTitleByValue: (N) => N?.title,
      onChange: (N) => e(N.selectedValues[0]),
      dropdownProps: { className: cm.dropdown },
      filter: {
        value: s,
        onChange: (N) => {
          const x = N.target.value;
          l(x);
        }
      },
      placeholder: "Search Linear issues",
      children: [
        a?.map((N) => /* @__PURE__ */ oe.jsx(oM, { issue: N }, N.id)),
        r?.hasNextPage && !v && s !== "" && a.length && /* @__PURE__ */ oe.jsx(
          b,
          {
            gap: "100",
            justifyContent: "center",
            padding: "200",
            alignItems: "center",
            onClick: () => j(),
            className: cm.loadMore,
            children: /* @__PURE__ */ oe.jsx(O.Paragraph, { variant: "3", children: "Load more ..." })
          }
        ),
        v && s !== "" && /* @__PURE__ */ oe.jsx(b, { justifyContent: "center", className: cm.loader, children: /* @__PURE__ */ oe.jsx(hn, { size: 24 }) }),
        s === "" && a.length === 0 && /* @__PURE__ */ oe.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ oe.jsx(O.Paragraph, { variant: "3", color: "neutral.400", children: "Enter issue title or description" })
          }
        ),
        a.length === 0 && s !== "" && !v && /* @__PURE__ */ oe.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ oe.jsx(O.Paragraph, { variant: "3", color: "neutral.400", children: "No Linear issues found" })
          }
        )
      ]
    }
  ) });
}, dM = "_collapse_su0f9_1", mM = "_collapseHeader_su0f9_8", pM = "_collapseContent_su0f9_31", fM = "_url_su0f9_35", hM = "_externalLink_su0f9_51", yM = "_emptyState_su0f9_55", si = {
  collapse: dM,
  collapseHeader: mM,
  collapseContent: pM,
  url: fM,
  externalLink: hM,
  emptyState: yM
}, gM = ({
  linkedIssues: e,
  isLoading: n,
  handleUnlinkIssue: r,
  showUnlinkAllModal: i,
  showUnlinkAllButton: a,
  organizationUrl: o
}) => {
  const s = e.reduce(
    (d, f) => ({ ...d, [f.id]: !1 }),
    {}
  ), [l, u] = ue(s), { track: p } = In();
  return n ? /* @__PURE__ */ oe.jsx(
    b,
    {
      flexDirection: "column",
      margin: "0 0 400 0",
      justifyContent: "center",
      alignItems: "center",
      children: /* @__PURE__ */ oe.jsx(hn, { size: 24 })
    }
  ) : e.length === 0 ? /* @__PURE__ */ oe.jsxs(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      margin: "0 0 300 0",
      gap: "300",
      children: [
        /* @__PURE__ */ oe.jsx(
          O.Paragraph,
          {
            align: "center",
            variant: "3",
            color: "neutral.400",
            className: si.emptyState,
            children: "No linked issues found"
          }
        ),
        /* @__PURE__ */ oe.jsx(
          At,
          {
            slotEnd: /* @__PURE__ */ oe.jsx(he, { name: "external-link" }),
            variant: "tertiary",
            className: si.externalLink,
            navigate: () => window.open(
              `https://linear.app/${e[0]?.team?.organization.urlKey ?? ""}`,
              "_blank"
            )?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  ) : /* @__PURE__ */ oe.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "250",
      margin: "0 0 400 0",
      "data-testid": "linkedIssueWrapper",
      children: [
        e.map((d) => {
          const f = l[d.id];
          return /* @__PURE__ */ oe.jsxs(
            pr,
            {
              "data-testid": "collapseCard",
              onToggle: () => u({ ...l, [d.id]: !l[d.id] }),
              isOpen: f,
              className: si.collapse,
              children: [
                /* @__PURE__ */ oe.jsx(pr.Header, { className: si.collapseHeader, children: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                    /* @__PURE__ */ oe.jsxs(b, { gap: "100", alignItems: "center", children: [
                      /* @__PURE__ */ oe.jsx(Ze, { content: /* @__PURE__ */ oe.jsx(b, { children: d.state.name }), children: /* @__PURE__ */ oe.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ oe.jsx(
                        dl,
                        {
                          type: d.state.type,
                          color: d.state.color,
                          name: d.state.name
                        }
                      ) }) }),
                      /* @__PURE__ */ oe.jsxs(
                        O.ExternalLink,
                        {
                          className: si.url,
                          href: d.url,
                          target: "_blank",
                          rel: "noreferrer",
                          children: [
                            d.identifier,
                            /* @__PURE__ */ oe.jsx(he, { name: "external-link" })
                          ]
                        }
                      ),
                      /* @__PURE__ */ oe.jsx(Ze, { content: /* @__PURE__ */ oe.jsx(b, { children: d.priorityLabel }), children: /* @__PURE__ */ oe.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ oe.jsx(ul, { priority: d.priority }) }) })
                    ] }),
                    /* @__PURE__ */ oe.jsx(Yn, { children: d.state.name })
                  ] }),
                  d.title
                ] }) }),
                /* @__PURE__ */ oe.jsx(pr.Content, { className: si.collapseContent, children: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "300", children: [
                  d?.labels && d?.labels?.edges?.length > 0 && /* @__PURE__ */ oe.jsx(
                    b,
                    {
                      flexDirection: "row",
                      gap: "200",
                      alignItems: "center",
                      flexWrap: "wrap",
                      children: d.labels?.edges.map((h) => /* @__PURE__ */ oe.jsx(Yn, { color: h.node.color, children: h.node.name }, h.node.id))
                    }
                  ),
                  /* @__PURE__ */ oe.jsx(w1, { issue: d }),
                  /* @__PURE__ */ oe.jsx(
                    et,
                    {
                      slotStart: /* @__PURE__ */ oe.jsx(he, { name: "link-slash" }),
                      variant: "secondary",
                      onClick: () => r(d.id),
                      style: { marginTop: "var(--dixa-size-spacer-200)" },
                      children: "Unlink issue from Linear"
                    }
                  ),
                  /* @__PURE__ */ oe.jsxs(
                    At,
                    {
                      slotEnd: /* @__PURE__ */ oe.jsx(he, { name: "external-link" }),
                      variant: "tertiary",
                      className: si.externalLink,
                      onClick: () => {
                        p("linear:open:issue:clicked", {
                          linearInstanceUrl: o,
                          linearIssueKey: d.id
                        });
                      },
                      navigate: () => window.open(d.url, "_blank")?.focus(),
                      children: [
                        "View ",
                        d.identifier,
                        " in Linear"
                      ]
                    }
                  )
                ] }) })
              ]
            },
            d.id
          );
        }),
        e.length > 1 && a && /* @__PURE__ */ oe.jsx(
          et,
          {
            slotStart: /* @__PURE__ */ oe.jsx(he, { name: "link-slash" }),
            variant: "secondary",
            onClick: () => i(!0),
            children: "Unlink all issues"
          }
        ),
        /* @__PURE__ */ oe.jsx(
          At,
          {
            slotEnd: /* @__PURE__ */ oe.jsx(he, { name: "external-link" }),
            variant: "tertiary",
            className: si.externalLink,
            onClick: () => {
              p("linear:open:linear:clicked", {
                // we check against empty linkedIssues earlier in the code.
                // function is using item at index 0 since all teams belong in the same organization/workspace,
                linearInstanceUrl: o,
                linearIssueKey: e[0].id
              });
            },
            disabled: !o,
            navigate: () => window.open(o, "_blank")?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  );
}, vM = {
  default: (e, n) => (n() ?? []).join(""),
  nodes: {
    doc: (e, n) => (n() ?? []).join(""),
    heading: (e, n) => `
${"#".repeat(
      parseInt(e.attrs?.level) || 1
    )} ${n()}

`,
    bullet_list: (e, n) => `
` + n().map((r) => `- ${r}`).join(""),
    ordered_list: (e, n) => `
` + n().map((r) => `1. ${r}`).join(""),
    // We're not emitting list items from the listItem formatter but from the
    // ordered/bullet list nodes above, as markdown does not encapsulate list items
    //listItem: (_node, children) => '- ' + children(),
    paragraph: (e, n) => n().join("") + `
`,
    text: (e) => e.text ?? "",
    hard_break: () => `
`,
    blockquote: (e, n) => `> ${n().join("")}
`,
    code_block: (e, n) => "\n```" + (e.attrs?.language || "") + `
` + n() + "\n```\n"
  },
  marks: {
    text: {
      strong: (e, n) => `**${n()}**`,
      strike: (e, n) => `~~${n()}~~`,
      subsup: (e, n) => {
        switch (e.attrs?.type) {
          case "sub":
            return `<sub>${n()}</sub>`;
          case "sup":
            return `<sup>${n()}</sup>`;
          default:
            return n();
        }
      },
      underline: (e, n) => `<u>${n()}</u>`,
      em: (e, n) => `*${n()}*`,
      link: (e, n) => `[${n()}](${e.attrs?.href})`,
      code: (e, n) => `\`${n()}\``
    }
  }
}, I1 = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => I1(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, kM = "_modalBody_iv3ua_1", bM = "_error_iv3ua_5", xM = "_dropdown_iv3ua_16", Qi = {
  modalBody: kM,
  error: bM,
  dropdown: xM
}, _M = Bo(
  /* GraphQL */
  `
  mutation createIssue(
    $issueTitle: String!
    $issueDescription: String
    $teamId: String!
    $projectId: String
    $statusId: String
    $priority: Int
  ) {
    Linear {
      issueCreate(
        input: {
          title: $issueTitle
          description: $issueDescription
          teamId: $teamId
          projectId: $projectId
          stateId: $statusId
          priority: $priority
        }
      ) {
        success
        issue {
          id
          title
          identifier
          url
        }
      }
    }
  }
`
), SM = Bo(
  /* GraphQL */
  `
  query staticData {
    Linear {
      teams {
        edges {
          node {
            id
            name
            organization {
              urlKey
            }
          }
        }
      }
      issuePriorityValues {
        priority
        label
      }
      organization {
        urlKey
      }
    }
  }
`
), NM = Bo(
  /* GraphQL */
  `
  query teamData($teamId: String!) {
    Linear {
      team(id: $teamId) {
        projects {
          edges {
            node {
              id
              name
            }
          }
        }
        states {
          edges {
            node {
              id
              name
              type
              color
            }
          }
        }
        templates {
          edges {
            node {
              id
              name
              type
              templateData
            }
          }
        }
      }
    }
  }
`
), jM = ({
  setCreatedIssue: e,
  isCreateIssueModalOpen: n,
  setIsCreateIssueModalOpen: r,
  setIsCreationSuccessfulModalOpen: i,
  addToLinkedIssueIds: a,
  organizationUrl: o,
  setOrganizationUrl: s
}) => {
  const { useLazyQuery: l, showNotification: u } = bn(), { control: p, handleSubmit: d, reset: f } = dt(), [h, v] = ue([]), [C, j] = ue(), [N, x] = ue([]), [g, P] = ue(), [E, I] = ue([]), [w, A] = ue(), [H, Y] = ue([]), [ne, W] = ue(), [B, D] = ue([]), [M, Z] = ue(), [je, ge] = ue(!1), { useMutation: ye } = bn(), { track: ke } = In(), [q, { loading: _e }] = ye(
    _M,
    {
      onError: () => {
        ge(!1), u({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (Fe) => {
        const Me = {
          identifier: Fe.Linear?.issueCreate?.issue?.identifier,
          url: Fe.Linear?.issueCreate?.issue?.url
        };
        Fe.Linear && Fe.Linear?.issueCreate?.issue?.id && (a(Fe.Linear?.issueCreate?.issue?.id), Be(Me), ge(!1), u({
          title: "Issue was created and linked to the conversation",
          text: `Issue ${Fe.Linear.issueCreate.issue.identifier} was created and added to the active conversation`,
          icon: "exclamation-triangle-filled",
          severity: "success"
        }), ke("linear:create:new:issue:confirmed", {
          linearInstanceUrl: o
        }));
      }
    }
  ), [
    De,
    { data: G, loading: Ye, error: sn }
  ] = l(SM, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => u({
      title: "Error while fetching team ID",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (Fe) => {
      const Me = Fe.Linear.teams.edges.map(
        ({ node: nn }) => nn
      );
      v(Me), Y(Fe.Linear.issuePriorityValues), s(`${DM}${Fe.Linear.organization.urlKey}`);
    }
  }), [Ie, { data: Ue, loading: Pe }] = l(NM, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => u({
      title: "Error while fetching team projects",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (Fe) => {
      const Me = Fe?.Linear?.team?.projects?.edges?.map(
        ({ node: le }) => le
      );
      x(Me);
      const nn = Fe?.Linear?.team?.states?.edges?.map(
        ({ node: le }) => le
      );
      I(nn);
      const se = Fe?.Linear?.team?.templates?.edges?.map(
        ({ node: le }) => le
      );
      D(
        se.filter(
          (le) => le.type === "issue"
        )
      );
    }
  }), Be = (Fe) => {
    r(!1), P(void 0), j(void 0), A(void 0), W(void 0), Z(void 0), Fe && (e(Fe), i(!0)), f({
      title: "",
      description: "",
      projectId: "",
      teamId: "",
      statusId: "",
      priority: void 0
    });
  }, Le = (Fe) => {
    G && !Ye && (q({
      variables: {
        issueTitle: Fe.title,
        issueDescription: Fe?.description,
        teamId: Fe.team.id,
        projectId: Fe?.project?.id,
        statusId: Fe?.status?.id,
        priority: Fe?.priority?.priority
      }
    }), ge(!0));
  };
  Je(() => {
    n && De();
  }, [n]);
  const Xe = () => {
    ke("linear:create:new:issue:cancelled", {
      linearInstanceUrl: o
    });
  };
  return /* @__PURE__ */ oe.jsxs(
    Ct,
    {
      isOpen: n,
      onClose: () => {
        Xe(), Be();
      },
      children: [
        /* @__PURE__ */ oe.jsx(
          It,
          {
            title: "Create new Linear issue",
            onClose: () => {
              Xe(), Be();
            }
          }
        ),
        /* @__PURE__ */ oe.jsx(
          Ft,
          {
            className: Qi.modalBody,
            "data-testid": "createIssueModalBody",
            children: sn ? /* @__PURE__ */ oe.jsx(Tn, { error: sn }) : /* @__PURE__ */ oe.jsx("form", { onSubmit: d(Le), id: "issueCreationForm", children: /* @__PURE__ */ oe.jsxs(tt, { children: [
              /* @__PURE__ */ oe.jsx(ie, { span: 3, children: /* @__PURE__ */ oe.jsx(
                xt,
                {
                  control: p,
                  name: "team",
                  rules: {
                    required: "Team is required"
                  },
                  render: ({
                    field: { value: Fe, onChange: Me },
                    fieldState: { error: nn }
                  }) => /* @__PURE__ */ oe.jsx(
                    We,
                    {
                      required: !0,
                      label: "Team",
                      meta: {
                        error: nn?.message ?? null
                      },
                      children: /* @__PURE__ */ oe.jsx(
                        ei,
                        {
                          dropdownProps: { className: Qi.dropdown },
                          placeholder: "Select Linear team",
                          className: ut({ [Qi.error]: nn }),
                          getItemTitleByValue: (se) => se?.name,
                          onChange: (se) => {
                            P(void 0), A(void 0), W(void 0), Z(void 0), j(se.selectedValues[0]), Ie({
                              variables: { teamId: se.selectedValues[0].id }
                            }), Me(se.selectedValues[0]);
                          },
                          value: C ? [Fe] : void 0,
                          children: h?.map((se) => /* @__PURE__ */ oe.jsx(
                            pt.Item,
                            {
                              value: se,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsx(O.Paragraph, { children: se.name })
                            },
                            se.id
                          ))
                        }
                      )
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ oe.jsx(ie, { span: 3, children: /* @__PURE__ */ oe.jsx(
                xt,
                {
                  control: p,
                  name: "project",
                  render: ({ field: { value: Fe, onChange: Me } }) => {
                    const nn = Pe ? [{ name: "Loading projects...", id: "" }] : void 0;
                    return /* @__PURE__ */ oe.jsx(We, { label: "Project", children: /* @__PURE__ */ oe.jsx(
                      ei,
                      {
                        dropdownProps: { className: Qi.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (se) => se?.name,
                        disabled: C === void 0,
                        placeholder: C ? "Select Linear project" : "Select a Team first",
                        onChange: (se) => {
                          P(se.selectedValues[0]), Me(se.selectedValues[0]);
                        },
                        value: g ? [Fe] : nn,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          Pe && /* @__PURE__ */ oe.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(hn, { size: 24 })
                            }
                          ),
                          Ue && !Pe && N.map((se) => /* @__PURE__ */ oe.jsx(
                            pt.Item,
                            {
                              value: se,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsx(O.Paragraph, { children: se.name })
                            },
                            se.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(ie, { span: 6, children: /* @__PURE__ */ oe.jsx(We, { label: "Template", children: /* @__PURE__ */ oe.jsx(
                ei,
                {
                  clearable: !0,
                  dropdownProps: { className: Qi.dropdown },
                  disabled: !C || Pe,
                  placeholder: C ? "Select template" : "Select a Team first",
                  getItemTitleByValue: (Fe) => Fe?.name,
                  onChange: (Fe) => {
                    if (Fe.selectedValues.length > 0) {
                      Z(Fe.selectedValues[0]);
                      const Me = JSON.parse(
                        Fe.selectedValues[0].templateData
                      ), nn = H.filter(
                        (Ae) => Ae.priority === Me.priority
                      );
                      W(
                        nn ? nn[0] : void 0
                      );
                      const se = E.filter(
                        (Ae) => Ae.id === Me.stateId
                      );
                      A(
                        se ? se[0] : void 0
                      );
                      const le = N.filter(
                        (Ae) => Ae.id === Me.projectId
                      );
                      P(
                        le ? le[0] : void 0
                      );
                      const Se = Me.description;
                      f({
                        title: Me?.title,
                        priority: nn[0],
                        status: se[0],
                        project: le[0],
                        description: Se ? I1(Se, vM) : "",
                        team: C
                      });
                    } else
                      f({
                        title: "",
                        description: "",
                        team: C
                      }), P(void 0), W(void 0), A(void 0), Z(void 0);
                  },
                  value: M ? [M] : void 0,
                  children: B?.map((Fe) => /* @__PURE__ */ oe.jsx(
                    pt.Item,
                    {
                      value: Fe,
                      noFixedSelectionStateSpace: !0,
                      children: /* @__PURE__ */ oe.jsx(O.Paragraph, { children: Fe.name })
                    },
                    Fe.id
                  ))
                }
              ) }) }),
              /* @__PURE__ */ oe.jsx(ie, { span: 6, children: /* @__PURE__ */ oe.jsx(
                xt,
                {
                  control: p,
                  name: "title",
                  rules: {
                    required: "Title field is required",
                    minLength: 2
                  },
                  render: ({
                    field: { onChange: Fe, value: Me },
                    fieldState: { error: nn }
                  }) => /* @__PURE__ */ oe.jsx(
                    tr,
                    {
                      required: !0,
                      label: "Title",
                      placeholder: "Insert issue title here",
                      input: {
                        name: "issueTitle",
                        value: Me || "",
                        onChange: Fe
                      },
                      meta: {
                        error: nn?.message ?? null
                      }
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ oe.jsx(ie, { span: 3, children: /* @__PURE__ */ oe.jsx(
                xt,
                {
                  control: p,
                  name: "status",
                  render: ({ field: { value: Fe, onChange: Me } }) => {
                    const nn = Pe ? [
                      {
                        name: "Loading statuses...",
                        id: "",
                        type: "",
                        color: ""
                      }
                    ] : void 0;
                    return /* @__PURE__ */ oe.jsx(We, { label: "Status", children: /* @__PURE__ */ oe.jsx(
                      ei,
                      {
                        dropdownProps: { className: Qi.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (se) => se?.name,
                        disabled: C === void 0,
                        placeholder: C ? "Select Issue status" : "Select a Team first",
                        onChange: (se) => {
                          A(se.selectedValues[0]), Me(se.selectedValues[0]);
                        },
                        value: w ? [Fe] : nn,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          Pe && /* @__PURE__ */ oe.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(hn, { size: 24 })
                            }
                          ),
                          Ue && !Pe && E.map((se) => /* @__PURE__ */ oe.jsx(
                            pt.Item,
                            {
                              value: se,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ oe.jsx(
                                      dl,
                                      {
                                        type: se.type,
                                        color: se.color,
                                        name: se.name
                                      }
                                    ),
                                    /* @__PURE__ */ oe.jsx(O.Paragraph, { children: se.name })
                                  ]
                                }
                              )
                            },
                            se.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(ie, { span: 3, children: /* @__PURE__ */ oe.jsx(
                xt,
                {
                  control: p,
                  name: "priority",
                  render: ({ field: { value: Fe, onChange: Me } }) => {
                    const nn = Ye ? [
                      {
                        label: "Loading Priorities...",
                        priority: 0
                      }
                    ] : void 0;
                    return /* @__PURE__ */ oe.jsx(We, { label: "Priority", children: /* @__PURE__ */ oe.jsx(
                      ei,
                      {
                        clearable: !0,
                        getItemTitleByValue: (se) => se?.label,
                        disabled: C === void 0,
                        placeholder: C ? "Select Issue priority" : "Select a Team first",
                        onChange: (se) => {
                          W(se.selectedValues[0]), Me(se.selectedValues[0]);
                        },
                        value: ne ? [Fe] : nn,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          Pe && /* @__PURE__ */ oe.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(hn, { size: 24 })
                            }
                          ),
                          G && !Ye && H.map((se) => /* @__PURE__ */ oe.jsx(
                            pt.Item,
                            {
                              value: se,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ oe.jsx(
                                      ul,
                                      {
                                        priority: se.priority
                                      }
                                    ),
                                    /* @__PURE__ */ oe.jsx(O.Paragraph, { children: se.label })
                                  ]
                                }
                              )
                            },
                            se.priority
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(ie, { children: /* @__PURE__ */ oe.jsx(
                xt,
                {
                  control: p,
                  name: "description",
                  render: ({
                    field: { onChange: Fe, value: Me },
                    fieldState: { error: nn }
                  }) => /* @__PURE__ */ oe.jsx(
                    cF,
                    {
                      label: "Description",
                      placeholder: "Insert Issue description here",
                      input: {
                        name: "description",
                        value: Me || "",
                        onChange: Fe
                      },
                      meta: {
                        error: nn?.message ?? null
                      }
                    }
                  )
                }
              ) })
            ] }) })
          }
        ),
        /* @__PURE__ */ oe.jsx(
          Vt,
          {
            confirmOnClick: d(Le),
            confirmProps: {
              disabled: _e || !G,
              isLoading: je || Ye || Pe,
              loadingIndicator: /* @__PURE__ */ oe.jsx(hn, { size: 16 })
            },
            confirmName: "Save",
            cancelOnClick: () => {
              Xe(), Be();
            }
          }
        )
      ]
    }
  );
}, wM = "_modalWrapper_4kh9u_1", CM = "_copyButton_4kh9u_6", IM = "_copyWrapper_4kh9u_15", FM = "_copyField_4kh9u_24", EM = "_externalLink_4kh9u_47", $M = "_externalLinkIcon_4kh9u_52", TM = "_textWrapper_4kh9u_56", bi = {
  modalWrapper: wM,
  copyButton: CM,
  copyWrapper: IM,
  copyField: FM,
  externalLink: EM,
  externalLinkIcon: $M,
  textWrapper: TM
}, OM = ({
  isCreationSuccessfulModalOpen: e,
  createdIssueData: n,
  setIsCreationSuccessfulModalOpen: r
}) => /* @__PURE__ */ oe.jsxs(
  Ct,
  {
    isOpen: !!n && e,
    className: bi.modalWrapper,
    onClose: () => r(!1),
    children: [
      /* @__PURE__ */ oe.jsx(
        It,
        {
          title: "Issue creation successful",
          onClose: () => r(!1)
        }
      ),
      /* @__PURE__ */ oe.jsx(Ft, { children: /* @__PURE__ */ oe.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          "data-testid": "creationSuccessfulModal",
          children: [
            /* @__PURE__ */ oe.jsxs(O.Paragraph, { className: bi.textWrapper, children: [
              `You can visit issue ${n?.identifier} by following `,
              " ",
              /* @__PURE__ */ oe.jsxs(
                O.ExternalLink,
                {
                  href: n?.url,
                  target: "_blank",
                  className: bi.externalLink,
                  children: [
                    "this link",
                    " ",
                    /* @__PURE__ */ oe.jsx(he, { name: "external-link", className: bi.externalLinkIcon })
                  ]
                }
              ),
              "or copy it from the field below."
            ] }),
            /* @__PURE__ */ oe.jsx(We, { label: "Linear issue link", children: /* @__PURE__ */ oe.jsxs(
              b,
              {
                flexDirection: "row",
                alignItems: "center",
                "data-testid": "copyInputField",
                className: bi.copyWrapper,
                children: [
                  /* @__PURE__ */ oe.jsx(
                    mr,
                    {
                      readOnly: !0,
                      value: n?.url,
                      className: bi.copyField
                    }
                  ),
                  /* @__PURE__ */ oe.jsx(
                    uF,
                    {
                      className: bi.copyButton,
                      textToCopy: n?.url || "",
                      clickedProps: {
                        icon: "check-circle-filled"
                      }
                    }
                  )
                ]
              }
            ) })
          ]
        }
      ) }),
      /* @__PURE__ */ oe.jsx(
        Vt,
        {
          cancelOnClick: () => r(!1),
          cancelProps: { variant: "primary" },
          cancelName: "Close"
        }
      )
    ]
  }
), DM = "https://linear.app/", PM = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = ue([]), [a, o] = ue([]), [s, l] = ue(!1), [u, p] = ue(!1), [d, f] = ue(!1), [h, v] = ue(), { useLazyQuery: C } = bn(), [j, N] = ue(""), x = n?.enableCreateIssue, g = !!n?.enableUnlinkAll, { track: P } = In(), {
    loading: E,
    data: I,
    error: w,
    store: A
  } = ly(e?.conversationId ?? null), [
    H,
    {
      data: Y,
      loading: ne,
      networkStatus: W,
      error: B
    }
  ] = C(V4, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  Je(() => {
    !E && !w && I && I?.linear?.issues?.length > 0 ? (o(I.linear.issues), H({
      variables: {
        linkedIssues: I.linear.issues
      }
    })) : !E && !w && (i([]), o([]));
  }, [I, E, w]), Je(() => {
    Y && Y?.Linear && !ne && W === rr.ready && Object.keys(Y).length > 0 && i(Y.Linear.issues?.edges?.map(({ node: ge }) => ge));
  }, [Y, ne, W]);
  const D = (ge) => {
    ge && ge?.team?.organization?.urlKey && P("linear:link:issue:clicked", {
      linearInstanceUrl: j,
      linearIssueKey: ge.id
    });
    const ye = (ke) => ke.id === ge?.id;
    r.some((ke) => ke && ye(ke)) || (I && a.length === 0 && o([]), A({
      linear: {
        issues: [...a, ge.id]
      }
    }));
  }, M = (ge) => {
    const ye = I?.linear.issues.filter((ke) => ke !== ge) || [];
    P("linear:unlink:issue:clicked", {
      linearInstanceUrl: j,
      linearIssueKey: ge
    }), i(r.filter(({ id: ke }) => ke !== ge)), o(ye), A({
      linear: {
        issues: ye
      }
    });
  }, Z = () => {
    l(!1), i([]), o([]), A({
      linear: {
        issues: []
      }
    });
  }, je = E || ne || !I && !w || (I?.linear?.issues?.length ?? 0) > 0 && r.length === 0;
  return !E && !ne && (B || w) ? /* @__PURE__ */ oe.jsx(Tn, { error: B || w }) : /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "300", children: [
    /* @__PURE__ */ oe.jsxs(
      Ct,
      {
        isOpen: s,
        onClose: () => l(!1),
        children: [
          /* @__PURE__ */ oe.jsx(
            It,
            {
              title: "Unlink all Linear issues?",
              onClose: () => l(!1)
            }
          ),
          /* @__PURE__ */ oe.jsx(Ft, { "data-testid": "unlinkAllIssuesModalBody", children: "You are about to unlink all Linear issues from the conversation. Do you want to proceed?" }),
          /* @__PURE__ */ oe.jsx(
            Vt,
            {
              confirmOnClick: () => Z(),
              confirmName: "Unlink all",
              cancelOnClick: () => l(!1)
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ oe.jsx(
      jM,
      {
        isCreateIssueModalOpen: u,
        setIsCreateIssueModalOpen: (ge) => p(ge),
        setIsCreationSuccessfulModalOpen: (ge) => f(ge),
        addToLinkedIssueIds: (ge) => {
          A({
            linear: {
              issues: [...a, ge]
            }
          });
        },
        setCreatedIssue: (ge) => v(ge),
        organizationUrl: j,
        setOrganizationUrl: (ge) => N(ge)
      }
    ),
    /* @__PURE__ */ oe.jsx(
      OM,
      {
        isCreationSuccessfulModalOpen: d,
        setIsCreationSuccessfulModalOpen: (ge) => f(ge),
        createdIssueData: h
      }
    ),
    /* @__PURE__ */ oe.jsxs(
      b,
      {
        flexDirection: "column",
        background: "neutral.100",
        padding: "300",
        borderRadius: "100",
        gap: "250",
        children: [
          x && /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
            /* @__PURE__ */ oe.jsx(
              et,
              {
                variant: "primary",
                onClick: () => {
                  P("linear:create:new:issue:clicked", {
                    linearInstanceUrl: j
                  }), p(!0);
                },
                style: { minHeight: "38px" },
                children: "Create new issue"
              }
            ),
            /* @__PURE__ */ oe.jsx(O.Paragraph, { color: "neutral.600", align: "center", children: "or" })
          ] }),
          /* @__PURE__ */ oe.jsx(uM, { handleSelect: D, linkedIssues: r })
        ]
      }
    ),
    /* @__PURE__ */ oe.jsx(
      gM,
      {
        linkedIssues: r,
        isLoading: je,
        handleUnlinkIssue: M,
        showUnlinkAllModal: (ge) => l(ge),
        showUnlinkAllButton: g,
        organizationUrl: j
      }
    )
  ] });
}, Hh = [
  {
    key: "enableCreateIssue",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableUnlinkAll",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], xi = "LINEAR", RM = {
  enabled: !1,
  name: "",
  enableCreateIssue: !0,
  enableUnlinkAll: !0
}, AM = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = dt({
    mode: "onChange",
    defaultValues: RM
  }), {
    create: u,
    update: p,
    remove: d,
    isLoading: f,
    error: h,
    misconfigurationCause: v,
    setMisconfigurationCause: C
  } = hr({
    integrationId: e,
    integrationType: xi,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: j,
    error: N,
    isWidgetUnknown: x,
    refetch: g,
    widgetConfiguration: P
  } = yr({
    integrationId: e,
    fieldDefinitions: Hh,
    form: l,
    onMisconfigured: C
  }), { renderConditions: E, setRenderConditions: I, renderConditionsForSubmit: w } = gr({
    integrationId: e,
    widgetConfiguration: P,
    renderConditionsEditor: o
  }), A = (Y) => kr(Y, {
    fieldDefinitions: Hh,
    isCreationMode: s,
    create: u,
    update: p,
    renderConditions: w
  }), H = l.watch("name");
  return /* @__PURE__ */ oe.jsxs(
    vr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: A,
      error: N ?? h,
      onRetry: N ? g : void 0,
      isLoading: f || j,
      isWidgetUnknown: x,
      children: [
        v && /* @__PURE__ */ oe.jsx(br, { cause: v }),
        /* @__PURE__ */ oe.jsxs(tt, { children: [
          /* @__PURE__ */ oe.jsx(ie, { children: /* @__PURE__ */ oe.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ oe.jsx(
            Sn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ oe.jsx(ie, { span: 3, children: /* @__PURE__ */ oe.jsx(
            Gn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ oe.jsx(ie, { span: 3 }),
          /* @__PURE__ */ oe.jsx(ie, { span: 3, children: /* @__PURE__ */ oe.jsx(We, { label: 'Enable the "Create issue" button', children: /* @__PURE__ */ oe.jsx(
            Sn,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ oe.jsx(ie, { span: 3 }),
          /* @__PURE__ */ oe.jsx(ie, { span: 3, children: /* @__PURE__ */ oe.jsx(We, { label: 'Enable the "Unlink all" button', children: /* @__PURE__ */ oe.jsx(
            Sn,
            {
              name: "enableUnlinkAll",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ oe.jsx(ie, { span: 3 }),
          !s && e && /* @__PURE__ */ oe.jsx(
            pi,
            {
              configuration: n,
              integrationId: e,
              integrationType: xi,
              label: "Authorize with OAuth"
            }
          ),
          o && E !== null && /* @__PURE__ */ oe.jsx(ie, { children: o({
            value: E,
            onChange: I,
            configurationKey: P?.id
          }) })
        ] }),
        /* @__PURE__ */ oe.jsx(
          xr,
          {
            integrationType: xi,
            integrationId: e,
            widgetName: H,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => d(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ oe.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ oe.jsx(
                he,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ oe.jsxs(O.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  xi,
                  " integration, all links between Dixa and ",
                  xi,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ oe.jsxs(O.Paragraph, { children: [
                  "All data in ",
                  xi,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ oe.jsxs(O.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  xi,
                  " ",
                  'integration "',
                  H,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._wrapper_27vny_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_27vny_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._copyIcon_27vny_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._labelText_1q5b5_1{color:var(--dixa-typography-color-secondary)}._list_1q5b5_5{padding:0}._listItem_1q5b5_8{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1q5b5_8:last-child{border-bottom:none}._listItemEdit_1q5b5_15{cursor:pointer}._notificationText_1q5b5_19{color:var(--dixa-color-neutral-500)}._modalBody_1clhs_1{width:400px}._reward_1wxia_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1wxia_1:hover{border-color:var(--dixa-color-neutral-400)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var um = { exports: {} }, Za = {}, H_;
function LM() {
  if (H_) return Za;
  H_ = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Za.Fragment = r, Za.jsx = s, Za.jsxs = s, Za;
}
var ms = {}, W_;
function VM() {
  return W_ || (W_ = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        P("error", t, m);
      }
    }
    function P(t, c, m) {
      {
        var y = x.ReactDebugCurrentFrame, F = y.getStackAddendum();
        F !== "" && (c += "%s", m = m.concat([F]));
        var T = m.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var E = !1, I = !1, w = !1, A = !1, H = !1, Y;
    Y = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ne(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || H || t === a || t === p || t === d || A || t === v || E || I || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function W(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var F = c.displayName || c.name || "";
      return F !== "" ? m + "(" + F + ")" : m;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function D(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var m = t;
            return B(m._context) + ".Provider";
          case u:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : D(t.type) || "Memo";
          case h: {
            var F = t, T = F._payload, S = F._init;
            try {
              return D(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var M = Object.assign, Z = 0, je, ge, ye, ke, q, _e, De;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function Ye() {
      {
        if (Z === 0) {
          je = console.log, ge = console.info, ye = console.warn, ke = console.error, q = console.group, _e = console.groupCollapsed, De = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function sn() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: M({}, t, {
              value: je
            }),
            info: M({}, t, {
              value: ge
            }),
            warn: M({}, t, {
              value: ye
            }),
            error: M({}, t, {
              value: ke
            }),
            group: M({}, t, {
              value: q
            }),
            groupCollapsed: M({}, t, {
              value: _e
            }),
            groupEnd: M({}, t, {
              value: De
            })
          });
        }
        Z < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = x.ReactCurrentDispatcher, Ue;
    function Pe(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (F) {
            var y = F.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Le;
    {
      var Xe = typeof WeakMap == "function" ? WeakMap : Map;
      Le = new Xe();
    }
    function Fe(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Le.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      Be = !0;
      var F = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ye();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (re) {
              y = re;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (re) {
              y = re;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            y = re;
          }
          t();
        }
      } catch (re) {
        if (re && y && typeof re.stack == "string") {
          for (var _ = re.stack.split(`
`), ee = y.stack.split(`
`), L = _.length - 1, U = ee.length - 1; L >= 1 && U >= 0 && _[L] !== ee[U]; )
            U--;
          for (; L >= 1 && U >= 0; L--, U--)
            if (_[L] !== ee[U]) {
              if (L !== 1 || U !== 1)
                do
                  if (L--, U--, U < 0 || _[L] !== ee[U]) {
                    var ce = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && ce.includes("<anonymous>") && (ce = ce.replace("<anonymous>", t.displayName)), typeof t == "function" && Le.set(t, ce), ce;
                  }
                while (L >= 1 && U >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = F;
      }
      var ze = t ? t.displayName || t.name : "", Oe = ze ? Pe(ze) : "";
      return typeof t == "function" && Le.set(t, Oe), Oe;
    }
    function Me(t, c, m) {
      return Fe(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Fe(t, nn(t));
      if (typeof t == "string")
        return Pe(t);
      switch (t) {
        case p:
          return Pe("Suspense");
        case d:
          return Pe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return Me(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, F = y._payload, T = y._init;
            try {
              return se(T(F), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Se = {}, Ae = x.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(m);
      } else
        Ae.setExtraStackFrame(null);
    }
    function yn(t, c, m, y, F) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + m + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              _ = t[S](c, S, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Re(F), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, S, typeof _), Re(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Re(F), g("Failed %s type: %s", m, _.message), Re(null));
          }
      }
    }
    var Q = Array.isArray;
    function $(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ae(t);
    }
    var J = x.ReactCurrentOwner, de = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, xe, $e;
    function tn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && J.current;
    }
    function pn(t, c) {
      {
        var m = function() {
          xe || (xe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function Fn(t, c) {
      {
        var m = function() {
          $e || ($e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, m, y, F, T, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: F
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, m, y, F) {
      {
        var T, S = {}, _ = null, ee = null;
        m !== void 0 && (V(m), _ = "" + m), gn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ee = c.ref, on(c));
        for (T in c)
          le.call(c, T) && !de.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (T in L)
            S[T] === void 0 && (S[T] = L[T]);
        }
        if (_ || ee) {
          var U = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, U), ee && Fn(S, U);
        }
        return xn(t, _, ee, F, y, J.current, S);
      }
    }
    var en = x.ReactCurrentOwner, vn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        vn.setExtraStackFrame(m);
      } else
        vn.setExtraStackFrame(null);
    }
    var un;
    un = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = D(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Nn = {};
    function Rn(t) {
      {
        var c = jn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function kn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Rn(c);
        if (Nn[m])
          return;
        Nn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + D(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Ve(null);
      }
    }
    function _n(t, c) {
      {
        if (typeof t != "object")
          return;
        if ($(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            dn(y) && kn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var F = N(t);
          if (typeof F == "function" && F !== t.entries)
            for (var T = F.call(t), S; !(S = T.next()).done; )
              dn(S.value) && kn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = D(c);
          yn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !un) {
          un = !0;
          var F = D(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", F || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, m, y, F, T) {
      {
        var S = ne(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = Bn();
          ee ? _ += ee : _ += jn();
          var L;
          t === null ? L = "null" : $(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (D(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var U = En(t, c, m, F, T);
        if (U == null)
          return U;
        if (S) {
          var ce = c.children;
          if (ce !== void 0)
            if (y)
              if ($(ce)) {
                for (var ze = 0; ze < ce.length; ze++)
                  _n(ce[ze], t);
                Object.freeze && Object.freeze(ce);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _n(ce, t);
        }
        if (le.call(c, "key")) {
          var Oe = D(t), re = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), mn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Oe + mn]) {
            var Dn = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Oe, Dn, Oe), Cn[Oe + mn] = !0;
          }
        }
        return t === i ? Ln(U) : An(U), U;
      }
    }
    function Vn(t, c, m) {
      return wn(t, c, m, !0);
    }
    function qn(t, c, m) {
      return wn(t, c, m, !1);
    }
    var zn = qn, Wn = Vn;
    ms.Fragment = i, ms.jsx = zn, ms.jsxs = Wn;
  })()), ms;
}
var K_;
function zM() {
  return K_ || (K_ = 1, process.env.NODE_ENV === "production" ? um.exports = LM() : um.exports = VM()), um.exports;
}
var Ee = zM();
const UM = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, MM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "addPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UpdateCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UpdateCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, BM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "removeCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RemoveCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "RemoveCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, qM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "points_approved" } }, { kind: "Field", name: { kind: "Name", value: "points_pending" } }, { kind: "Field", name: { kind: "Name", value: "points_spent" } }, { kind: "Field", name: { kind: "Name", value: "rewards_claimed" } }, { kind: "Field", name: { kind: "Name", value: "birthday" } }, { kind: "Field", name: { kind: "Name", value: "guest" } }, { kind: "Field", name: { kind: "Name", value: "blocked" } }, { kind: "Field", name: { kind: "Name", value: "enrolled" } }, { kind: "Field", name: { kind: "Name", value: "enrolled_at" } }, { kind: "Field", name: { kind: "Name", value: "referral_id" } }, { kind: "Field", name: { kind: "Name", value: "referred_by" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }] } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier_membership" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "started_at" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "manual" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "position" } }, { kind: "Field", name: { kind: "Name", value: "default" } }, { kind: "Field", name: { kind: "Name", value: "hidden" } }, { kind: "Field", name: { kind: "Name", value: "lower_bound" } }, { kind: "Field", name: { kind: "Name", value: "upper_bound" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "insights_segment" } }, { kind: "Field", name: { kind: "Name", value: "referral_url" } }, { kind: "Field", name: { kind: "Name", value: "metadata" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopify_source_url" } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }] } }] } }] } }] } }] } }] } }] } }] }, HM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getRewards" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAvailableRewards" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getAvailableRewards_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Rewards" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "rewards" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "site_id" } }, { kind: "Field", name: { kind: "Name", value: "target_site" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "point_cost" } }] } }] } }, { kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, WM = {
  "\n  fragment BadRequest on LoyaltyLion_BadRequest {\n    message\n  }\n  fragment Unauthorized on LoyaltyLion_Unauthorized {\n    message\n  }\n  fragment Forbidden on LoyaltyLion_Forbidden {\n    message\n  }\n  fragment NotFound on LoyaltyLion_NotFound {\n    message\n  }\n  fragment UnprocessableEntity on LoyaltyLion_UnprocessableEntity {\n    message\n  }\n  fragment ServerError on LoyaltyLion_ServerError {\n    message\n  }\n\n  fragment UpdateCustomersPointsResponse on LoyaltyLion_updateCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n\n  fragment RemoveCustomersPointsResponse on LoyaltyLion_removeCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n": UM,
  "\n  mutation addPoints(\n    $merchantId: String!\n    $input: LoyaltyLion_updateCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      updateCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_updateCustomersPoints_response {\n          ...UpdateCustomersPointsResponse\n        }\n      }\n    }\n  }\n": MM,
  "\n  mutation removePoints(\n    $merchantId: String!\n    $input: LoyaltyLion_removeCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      removeCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_removeCustomersPoints_response {\n          ...RemoveCustomersPointsResponse\n        }\n      }\n    }\n  }\n": BM,
  "\n  query getCustomers($email: String!) {\n    LoyaltyLion {\n      getCustomers(email: $email) {\n        ... on LoyaltyLion_getCustomers_response {\n          ... on LoyaltyLion_Customers {\n            customers {\n              id\n              merchant_id\n              email\n              points_approved\n              points_pending\n              points_spent\n              rewards_claimed\n              birthday\n              guest\n              blocked\n              enrolled\n              enrolled_at\n              referral_id\n              referred_by {\n                id\n                merchant_id\n              }\n              loyalty_tier_membership {\n                started_at\n                expires_at\n                manual\n                loyalty_tier {\n                  id\n                  name\n                  position\n                  default\n                  hidden\n                  lower_bound\n                  upper_bound\n                }\n              }\n              insights_segment\n              referral_url\n              metadata {\n                shopify_source_url\n              }\n              properties {\n                name\n                first_name\n                last_name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": qM,
  "\n  query getRewards($merchantId: String!) {\n    LoyaltyLion {\n      getAvailableRewards(merchant_id: $merchantId) {\n        ... on LoyaltyLion_getAvailableRewards_response {\n          ... on LoyaltyLion_Rewards {\n            rewards {\n              id\n              title\n              description\n              site_id\n              target_site {\n                id\n                name\n                url\n              }\n              content\n              kind\n              point_cost\n            }\n          }\n          ...BadRequest\n          ...Unauthorized\n          ...Forbidden\n          ...NotFound\n          ...ServerError\n        }\n      }\n    }\n  }\n": HM
};
function Al(e) {
  return WM[e] ?? {};
}
const KM = Al(
  /* GraphQL */
  `
  query getCustomers($email: String!) {
    LoyaltyLion {
      getCustomers(email: $email) {
        ... on LoyaltyLion_getCustomers_response {
          ... on LoyaltyLion_Customers {
            customers {
              id
              merchant_id
              email
              points_approved
              points_pending
              points_spent
              rewards_claimed
              birthday
              guest
              blocked
              enrolled
              enrolled_at
              referral_id
              referred_by {
                id
                merchant_id
              }
              loyalty_tier_membership {
                started_at
                expires_at
                manual
                loyalty_tier {
                  id
                  name
                  position
                  default
                  hidden
                  lower_bound
                  upper_bound
                }
              }
              insights_segment
              referral_url
              metadata {
                shopify_source_url
              }
              properties {
                name
                first_name
                last_name
              }
            }
          }
        }
      }
    }
  }
`
), GM = Al(
  /* GraphQL */
  `
  query getRewards($merchantId: String!) {
    LoyaltyLion {
      getAvailableRewards(merchant_id: $merchantId) {
        ... on LoyaltyLion_getAvailableRewards_response {
          ... on LoyaltyLion_Rewards {
            rewards {
              id
              title
              description
              site_id
              target_site {
                id
                name
                url
              }
              content
              kind
              point_cost
            }
          }
          ...BadRequest
          ...Unauthorized
          ...Forbidden
          ...NotFound
          ...ServerError
        }
      }
    }
  }
`
), YM = Al(
  /* GraphQL */
  `
  mutation addPoints(
    $merchantId: String!
    $input: LoyaltyLion_updateCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      updateCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_updateCustomersPoints_response {
          ...UpdateCustomersPointsResponse
        }
      }
    }
  }
`
), JM = Al(
  /* GraphQL */
  `
  mutation removePoints(
    $merchantId: String!
    $input: LoyaltyLion_removeCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      removeCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_removeCustomersPoints_response {
          ...RemoveCustomersPointsResponse
        }
      }
    }
  }
`
);
function dm(e = !1, n) {
  const [r, i] = ue(e);
  return Je(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const QM = "_wrapper_27vny_1", XM = "_copyIcon_27vny_12", eo = {
  wrapper: QM,
  copyIcon: XM
}, ZM = ({
  customer: e
}) => {
  const { isCopied: n, copy: r } = dm(), { isCopied: i, copy: a } = dm(), { isCopied: o, copy: s } = dm();
  if (!e)
    return null;
  const l = 14, {
    email: u,
    properties: p,
    metadata: d,
    birthday: f,
    created_at: h,
    enrolled: v,
    enrolled_at: C,
    referral_url: j
  } = e, N = f ? Jn(f).isSame(Date.now(), "day") : !1, { name: x, first_name: g, last_name: P } = p ?? {}, E = x ?? (`${g} ${P}`.trim() || "A customer has no name"), I = d?.shopify_source_url ? d.shopify_source_url.startsWith("https://") ? d.shopify_source_url : `https://${d.shopify_source_url}` : "";
  return /* @__PURE__ */ Ee.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Ee.jsxs(b, { className: eo.wrapper, gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ Ee.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: eo.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ Ee.jsx(O.Heading, { variant: "heading-2", children: E }),
          N && /* @__PURE__ */ Ee.jsx(O.Paragraph, { variant: "4", color: "primary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    h && /* @__PURE__ */ Ee.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ee.jsx(O.Paragraph, { variant: "4", color: "secondary", children: "Member since" }),
      /* @__PURE__ */ Ee.jsx(O.Paragraph, { variant: "4", color: "secondary", children: Jn(h).format("DD MMM YYYY @ HH:mm") })
    ] }),
    v && /* @__PURE__ */ Ee.jsx(b, { gap: "200", children: /* @__PURE__ */ Ee.jsxs(O.Paragraph, { variant: "4", color: "secondary", children: [
      "Enrolled since ",
      Jn(C).format("DD MMM YYYY @ HH:mm")
    ] }) }),
    /* @__PURE__ */ Ee.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ee.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Ee.jsx(he, { size: l, name: "mail" }),
        /* @__PURE__ */ Ee.jsx(O.ExternalLink, { href: `mailto:${u}`, children: u })
      ] }),
      /* @__PURE__ */ Ee.jsx(Ze, { content: n ? "Copied" : "Copy", children: /* @__PURE__ */ Ee.jsx(
        he,
        {
          size: l,
          name: n ? "done" : "copy",
          onClick: () => r(u),
          className: eo.copyIcon
        }
      ) })
    ] }),
    I && /* @__PURE__ */ Ee.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ee.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Ee.jsx(he, { size: l, name: "link" }),
        /* @__PURE__ */ Ee.jsx(Ze, { content: "Shopify shop", children: /* @__PURE__ */ Ee.jsx(
          O.ExternalLink,
          {
            href: I,
            target: "_blank",
            rel: "noreferrer",
            children: I.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ Ee.jsx(Ze, { content: i ? "Copied" : "Copy", children: /* @__PURE__ */ Ee.jsx(
        he,
        {
          size: l,
          name: i ? "done" : "copy",
          onClick: () => a(I),
          className: eo.copyIcon
        }
      ) })
    ] }),
    j && /* @__PURE__ */ Ee.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ee.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Ee.jsx(he, { size: l, name: "external-link" }),
        /* @__PURE__ */ Ee.jsx(Ze, { content: "Referral link", children: /* @__PURE__ */ Ee.jsx(
          O.ExternalLink,
          {
            href: j,
            target: "_blank",
            rel: "noreferrer",
            children: j.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ Ee.jsx(Ze, { content: o ? "Copied" : "Copy", children: /* @__PURE__ */ Ee.jsx(
        he,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(j),
          className: eo.copyIcon
        }
      ) })
    ] })
  ] }) });
}, e5 = "_list_1q5b5_5", n5 = "_listItem_1q5b5_8", t5 = "_listItemEdit_1q5b5_15", r5 = "_notificationText_1q5b5_19", va = {
  list: e5,
  listItem: n5,
  listItemEdit: t5,
  notificationText: r5
}, i5 = "_modalBody_1clhs_1", a5 = {
  modalBody: i5
}, o5 = ({
  isOpen: e,
  points: n,
  merchantId: r,
  onClose: i,
  refetchCustomerData: a
}) => {
  const { useMutation: o, showNotification: s } = bn(), { track: l } = In(), [u, p] = ue(n), [d, f] = ue(""), [h, v] = ue(), [C, { loading: j }] = o(
    YM,
    {
      onCompleted: () => {
        s({
          title: "Success",
          text: "Added points successfully",
          icon: "check-circle-filled",
          severity: "success"
        }), l("loyaltylion:add:points:succeeded"), W();
      }
    }
  ), [N, { loading: x }] = o(JM), g = j || x, P = !!h, E = n === u ? "Change the value to update the points" : "", I = isNaN(u), w = I ? "Points can not be empty" : "", A = u > n && u - n > 1e6, H = A ? "Points can not exceed 1,000,000" : "", Y = () => {
    if (!r) {
      v(["Merchant information is missing."]), u > n ? l("loyaltylion:add:points:failed") : u < n && l("loyaltylion:remove:points:failed");
      return;
    }
    u > n && C({
      variables: {
        input: {
          points: u - n,
          reason: d
        },
        merchantId: r
      }
    }).catch((B) => {
      const D = B?.networkError;
      (D ? D?.statusCode : NaN) === 201 ? (l("loyaltylion:add:points:succeeded"), s({
        title: "Success",
        text: "Added points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), W()) : (l("loyaltylion:add:points:failed"), v(["Failed to add points, try again later."]));
    }), u < n && N({
      variables: {
        input: {
          points: n - u,
          reason: d
        },
        merchantId: r
      }
    }).then((B) => {
      B.data?.LoyaltyLion?.removeCustomersPoints?.__typename === "LoyaltyLion_Void_container" ? (l("loyaltylion:remove:points:succeeded"), s({
        title: "Success",
        text: "Removed points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), W()) : "errors" in B && (l("loyaltylion:remove:points:failed"), v(
        B.errors?.map((D) => D.message) ?? [
          "Failed to remove points, try again later."
        ]
      ));
    }).catch(() => {
      l("loyaltylion:remove:points:failed"), v(["Failed to remove points, try again later."]);
    });
  }, ne = () => {
    I && p(n), f(""), i();
  }, W = () => {
    a(), ne();
  };
  return /* @__PURE__ */ Ee.jsxs(
    Ct,
    {
      isOpen: e,
      onClose: ne,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ Ee.jsx(It, { title: "Change points", onClose: ne }),
        /* @__PURE__ */ Ee.jsxs(Ft, { className: a5.modalBody, children: [
          /* @__PURE__ */ Ee.jsxs(tt, { children: [
            /* @__PURE__ */ Ee.jsx(ie, { span: 6, children: /* @__PURE__ */ Ee.jsx(
              tr,
              {
                required: !0,
                label: "New points",
                type: "number",
                placeholder: "Insert new points",
                min: 0,
                max: 1e5,
                meta: {
                  error: H || w,
                  warning: E
                },
                input: {
                  name: "points",
                  value: u.toString(),
                  onChange: (B) => p(B?.target.valueAsNumber ?? 0)
                },
                "data-testid": "points-input"
              }
            ) }),
            /* @__PURE__ */ Ee.jsx(ie, { span: 6, children: /* @__PURE__ */ Ee.jsx(
              tr,
              {
                label: "Reason",
                placeholder: "Insert an optional reason",
                input: {
                  name: "reason",
                  value: d,
                  onChange: (B) => f(B?.target.value ?? "")
                }
              }
            ) })
          ] }),
          !g && P && /* @__PURE__ */ Ee.jsx(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ Ee.jsx(Qe, { children: h?.map((B, D) => /* @__PURE__ */ Ee.jsx(
            Qe.Item,
            {
              variant: "dense",
              title: B,
              contentLeft: /* @__PURE__ */ Ee.jsx(
                he,
                {
                  color: "red.500",
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            D
          )) }) })
        ] }),
        /* @__PURE__ */ Ee.jsx(
          Vt,
          {
            confirmName: "Save",
            confirmOnClick: () => Y(),
            confirmProps: {
              isLoading: g,
              disabled: I || A || n === u,
              loadingIndicator: /* @__PURE__ */ Ee.jsx(hn, { size: 16 })
            },
            cancelOnClick: ne
          }
        )
      ]
    }
  );
}, s5 = ({
  label: e,
  points: n,
  setIsModalOpen: r
}) => {
  const i = n > 0 ? "green.500" : "neutral.400", a = n > 0 ? "warning" : "secondary", o = 10;
  return /* @__PURE__ */ Ee.jsx(Qe.Text, { variant: "dense", className: va.listItem, children: /* @__PURE__ */ Ee.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ Ee.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Ee.jsx(he, { color: i, size: o, name: "star-full" }),
      /* @__PURE__ */ Ee.jsx(O.Paragraph, { variant: "4", children: e })
    ] }),
    /* @__PURE__ */ Ee.jsxs(b, { gap: "200", alignItems: "center", children: [
      r && /* @__PURE__ */ Ee.jsx(Ze, { content: "Edit points", children: /* @__PURE__ */ Ee.jsx(
        he,
        {
          name: "pen",
          size: o,
          "aria-label": "Edit points",
          className: va.listItemEdit,
          onClick: () => r(!0)
        }
      ) }),
      /* @__PURE__ */ Ee.jsx(Mn, { size: "small", variant: a, children: n })
    ] })
  ] }) });
}, l5 = ({
  customer: e,
  refetchCustomerData: n
}) => {
  const [r, i] = ue(!1);
  if (!e)
    return null;
  const {
    merchant_id: a,
    points_approved: o,
    points_pending: s,
    points_spent: l,
    rewards_claimed: u
  } = e, p = [
    {
      id: "pointsApproved",
      label: "Points approved",
      points: o ?? 0,
      setIsModalOpen: i
    },
    {
      id: "pointsPending",
      label: "Points pending",
      points: s ?? 0
    },
    {
      id: "pointsSpent",
      label: "Points spent",
      points: l ?? 0
    },
    {
      id: "rewardClaimed",
      label: "Rewards claimed",
      points: u ?? 0
    }
  ];
  return /* @__PURE__ */ Ee.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ee.jsx(O.Heading, { variant: "heading-3", children: "Points balance" }),
    /* @__PURE__ */ Ee.jsx(Qe, { className: va.list, children: p.map(({ id: d, points: f, label: h, setIsModalOpen: v }) => /* @__PURE__ */ Ee.jsx(
      s5,
      {
        points: f,
        label: h,
        setIsModalOpen: v
      },
      d
    )) }),
    /* @__PURE__ */ Ee.jsx(
      o5,
      {
        isOpen: r,
        points: o,
        merchantId: a,
        onClose: () => i(!1),
        refetchCustomerData: n
      }
    )
  ] });
}, c5 = "_reward_1wxia_1", u5 = {
  reward: c5
}, d5 = ({ reward: e }) => {
  const {
    title: n,
    point_cost: r,
    target_site: i,
    description: a
  } = e, o = i?.name, s = i?.url;
  return /* @__PURE__ */ Ee.jsx(b, { gap: "100", flexDirection: "column", className: u5.reward, children: /* @__PURE__ */ Ee.jsx(Ze, { content: a ?? "No description", children: /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ Ee.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ Ee.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ Ee.jsx(he, { name: "star", size: 12, color: "neutral.500" }),
        n
      ] }),
      /* @__PURE__ */ Ee.jsxs(Mn, { size: "small", variant: "info", children: [
        r ?? 0,
        " points"
      ] })
    ] }),
    o && s && /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Ee.jsx(he, { size: 14, name: "external-link" }),
      /* @__PURE__ */ Ee.jsx(
        O.ExternalLink,
        {
          href: s,
          target: "_blank",
          rel: "noreferrer",
          children: o
        }
      )
    ] })
  ] }) }) });
}, m5 = ({ customer: e }) => {
  const { useQuery: n } = bn(), [r, i] = ue(), { merchant_id: a } = e, {
    loading: o,
    error: s,
    data: l
  } = n(GM, {
    skip: !a,
    variables: {
      merchantId: a
    }
  });
  if (Je(() => {
    if (l?.LoyaltyLion) {
      const u = l.LoyaltyLion?.getAvailableRewards?.rewards;
      u && i(u);
    }
  }, [l]), s) {
    const u = s.graphQLErrors;
    return ba({ errors: u }) ? /* @__PURE__ */ Ee.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: va.notificationText,
        children: "No rewards found"
      }
    ) : lw({ errors: u }) ? /* @__PURE__ */ Ee.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: va.notificationText,
        children: "You don't have permissions to view rewards"
      }
    ) : /* @__PURE__ */ Ee.jsx(Tn, { error: s });
  }
  return /* @__PURE__ */ Ee.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ee.jsx(O.Heading, { variant: "heading-3", children: "Available rewards" }),
    o ? /* @__PURE__ */ Ee.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Ee.jsx(hn, {}) }) : /* @__PURE__ */ Ee.jsx(b, { gap: "200", flexDirection: "column", children: r?.map((u) => /* @__PURE__ */ Ee.jsx(d5, { reward: u }, u.id)) })
  ] });
}, p5 = ({ customer: e }) => {
  const { blocked: n, guest: r, insights_segment: i } = e ?? {}, a = n || r || i, o = 14;
  return a ? /* @__PURE__ */ Ee.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
    n && /* @__PURE__ */ Ee.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Ee.jsx(Yn, { children: /* @__PURE__ */ Ee.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Ee.jsx(
        he,
        {
          size: o,
          color: "red.500",
          name: "exclamation-triangle-filled"
        }
      ),
      "Blocked"
    ] }) }) }),
    r && /* @__PURE__ */ Ee.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Ee.jsx(Yn, { children: /* @__PURE__ */ Ee.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Ee.jsx(he, { size: o, color: "green.500", name: "user" }),
      "Guest"
    ] }) }) }),
    i && /* @__PURE__ */ Ee.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Ee.jsx(Ze, { content: "Insights segment", children: /* @__PURE__ */ Ee.jsx(Yn, { children: /* @__PURE__ */ Ee.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Ee.jsx(he, { size: o, color: "green.500", name: "team" }),
      i
    ] }) }) }) })
  ] }) : null;
}, f5 = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = bn(), { track: i } = In(), [a, o] = ue(null), { customer: s } = e, {
    showCustomerSummary: l,
    showTags: u,
    showPointsBalance: p,
    showAvailableRewards: d
  } = n, f = !l && !u && !p && !d, {
    loading: h,
    error: v,
    data: C,
    refetch: j
  } = r(KM, {
    skip: !s?.email,
    variables: {
      email: s?.email ?? ""
    }
  });
  return Je(() => {
    if (C && !h) {
      const N = (C?.LoyaltyLion?.getCustomers).customers;
      N && N.length > 0 && (o(N[0]), i("loyaltylion:customer:received"));
    }
  }, [C, h]), s?.email ? v ? ba({
    errors: v.graphQLErrors
  }) ? /* @__PURE__ */ Ee.jsxs(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      className: va.notificationText,
      children: [
        "No user found for email: ",
        s?.email
      ]
    }
  ) : /* @__PURE__ */ Ee.jsx(Tn, { error: v }) : h ? /* @__PURE__ */ Ee.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Ee.jsx(hn, {}) }) : f ? /* @__PURE__ */ Ee.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-feature-enabled-message",
      children: "All features toggles in the integration settings are disabled"
    }
  ) : /* @__PURE__ */ Ee.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: a ? /* @__PURE__ */ Ee.jsxs(Ee.Fragment, { children: [
        l && /* @__PURE__ */ Ee.jsx(ZM, { customer: a }),
        u && /* @__PURE__ */ Ee.jsx(p5, { customer: a }),
        p && /* @__PURE__ */ Ee.jsx(
          l5,
          {
            customer: a,
            refetchCustomerData: j
          }
        ),
        d && /* @__PURE__ */ Ee.jsx(m5, { customer: a })
      ] }) : /* @__PURE__ */ Ee.jsx(b, { justifyContent: "center", padding: "200", children: "Nothing found" })
    }
  ) : /* @__PURE__ */ Ee.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-email-message",
      children: "We can only search LoyaltyLion with an email and there seems to be no email in this conversation"
    }
  );
}, Wh = [
  {
    key: "basicAuthorization",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "showCustomerSummary",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showTags",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showPointsBalance",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showAvailableRewards",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], G_ = "LOYALTYLION", h5 = {
  enabled: !1,
  name: "",
  basicAuthorization: "",
  showCustomerSummary: !0,
  showTags: !0,
  showPointsBalance: !0,
  showAvailableRewards: !0
}, y5 = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = dt({
    mode: "onChange",
    defaultValues: h5
  }), {
    create: l,
    update: u,
    remove: p,
    isLoading: d,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = hr({
    integrationId: e,
    integrationType: G_,
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: C,
    error: j,
    isWidgetUnknown: N,
    refetch: x,
    widgetConfiguration: g
  } = yr({
    integrationId: e,
    fieldDefinitions: Wh,
    form: s,
    onMisconfigured: v
  }), { renderConditions: P, setRenderConditions: E, renderConditionsForSubmit: I } = gr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), w = (H) => kr(H, {
    fieldDefinitions: Wh,
    isCreationMode: o,
    create: l,
    update: u,
    renderConditions: I
  }), A = s.watch("name");
  return /* @__PURE__ */ Ee.jsxs(
    vr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: w,
      error: j ?? f,
      onRetry: j ? x : void 0,
      isLoading: d || C,
      isWidgetUnknown: N,
      children: [
        h && /* @__PURE__ */ Ee.jsx(br, { cause: h }),
        /* @__PURE__ */ Ee.jsxs(tt, { children: [
          /* @__PURE__ */ Ee.jsx(ie, { children: /* @__PURE__ */ Ee.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Ee.jsx(
            Sn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ee.jsx(ie, { span: 3, children: /* @__PURE__ */ Ee.jsx(
            Gn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Ee.jsx(ie, { span: 3 }),
          /* @__PURE__ */ Ee.jsx(ie, { span: 3, children: /* @__PURE__ */ Ee.jsx(
            YI,
            {
              name: "basicAuthorization",
              label: "LoyaltyLion authorization",
              control: s.control,
              isCreationMode: o,
              rules: { required: "Please insert a value for both fields" },
              usernameLabel: "Token",
              passwordLabel: "Secret",
              usernamePlaceholder: "Insert your token",
              passwordPlaceholder: "Insert your secret"
            }
          ) }),
          /* @__PURE__ */ Ee.jsx(ie, { span: 3 }),
          /* @__PURE__ */ Ee.jsx(ie, { span: 3, children: /* @__PURE__ */ Ee.jsx(We, { label: "Show customer summary", children: /* @__PURE__ */ Ee.jsx(
            Sn,
            {
              name: "showCustomerSummary",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ee.jsx(ie, { span: 3 }),
          /* @__PURE__ */ Ee.jsx(ie, { span: 3, children: /* @__PURE__ */ Ee.jsx(We, { label: "Show tags", children: /* @__PURE__ */ Ee.jsx(
            Sn,
            {
              name: "showTags",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ee.jsx(ie, { span: 3 }),
          /* @__PURE__ */ Ee.jsx(ie, { span: 3, children: /* @__PURE__ */ Ee.jsx(We, { label: "Show points balance", children: /* @__PURE__ */ Ee.jsx(
            Sn,
            {
              name: "showPointsBalance",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ee.jsx(ie, { span: 3 }),
          /* @__PURE__ */ Ee.jsx(ie, { span: 3, children: /* @__PURE__ */ Ee.jsx(We, { label: "Show available rewards", children: /* @__PURE__ */ Ee.jsx(
            Sn,
            {
              name: "showAvailableRewards",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ee.jsx(ie, { span: 3 }),
          a && P !== null && /* @__PURE__ */ Ee.jsx(ie, { children: a({
            value: P,
            onChange: E,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ Ee.jsx(
          xr,
          {
            integrationType: G_,
            integrationId: e,
            widgetName: A,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => p()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._messageContainer_1rxr4_1{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid}._chip_1rxr4_7{color:var(--dixa-typography-color-secondary)}._chipLabel_1rxr4_10{font-weight:var(--dixa-typography-weight-semibold)}._chipValue_1rxr4_13{font-weight:var(--dixa-typography-weight-normal)}._conversation_1draa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._conversation_1draa_1:hover{border-color:var(--dixa-color-neutral-400)}._conversationSubLine_1draa_9{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._modal_1draa_14{width:800px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var mm = { exports: {} }, no = {}, Y_;
function g5() {
  if (Y_) return no;
  Y_ = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return no.Fragment = r, no.jsx = s, no.jsxs = s, no;
}
var ps = {}, J_;
function v5() {
  return J_ || (J_ = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        P("error", t, m);
      }
    }
    function P(t, c, m) {
      {
        var y = x.ReactDebugCurrentFrame, F = y.getStackAddendum();
        F !== "" && (c += "%s", m = m.concat([F]));
        var T = m.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var E = !1, I = !1, w = !1, A = !1, H = !1, Y;
    Y = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ne(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || H || t === a || t === p || t === d || A || t === v || E || I || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function W(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var F = c.displayName || c.name || "";
      return F !== "" ? m + "(" + F + ")" : m;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function D(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var m = t;
            return B(m._context) + ".Provider";
          case u:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : D(t.type) || "Memo";
          case h: {
            var F = t, T = F._payload, S = F._init;
            try {
              return D(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var M = Object.assign, Z = 0, je, ge, ye, ke, q, _e, De;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function Ye() {
      {
        if (Z === 0) {
          je = console.log, ge = console.info, ye = console.warn, ke = console.error, q = console.group, _e = console.groupCollapsed, De = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function sn() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: M({}, t, {
              value: je
            }),
            info: M({}, t, {
              value: ge
            }),
            warn: M({}, t, {
              value: ye
            }),
            error: M({}, t, {
              value: ke
            }),
            group: M({}, t, {
              value: q
            }),
            groupCollapsed: M({}, t, {
              value: _e
            }),
            groupEnd: M({}, t, {
              value: De
            })
          });
        }
        Z < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = x.ReactCurrentDispatcher, Ue;
    function Pe(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (F) {
            var y = F.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Le;
    {
      var Xe = typeof WeakMap == "function" ? WeakMap : Map;
      Le = new Xe();
    }
    function Fe(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Le.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      Be = !0;
      var F = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ye();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (re) {
              y = re;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (re) {
              y = re;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            y = re;
          }
          t();
        }
      } catch (re) {
        if (re && y && typeof re.stack == "string") {
          for (var _ = re.stack.split(`
`), ee = y.stack.split(`
`), L = _.length - 1, U = ee.length - 1; L >= 1 && U >= 0 && _[L] !== ee[U]; )
            U--;
          for (; L >= 1 && U >= 0; L--, U--)
            if (_[L] !== ee[U]) {
              if (L !== 1 || U !== 1)
                do
                  if (L--, U--, U < 0 || _[L] !== ee[U]) {
                    var ce = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && ce.includes("<anonymous>") && (ce = ce.replace("<anonymous>", t.displayName)), typeof t == "function" && Le.set(t, ce), ce;
                  }
                while (L >= 1 && U >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = F;
      }
      var ze = t ? t.displayName || t.name : "", Oe = ze ? Pe(ze) : "";
      return typeof t == "function" && Le.set(t, Oe), Oe;
    }
    function Me(t, c, m) {
      return Fe(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Fe(t, nn(t));
      if (typeof t == "string")
        return Pe(t);
      switch (t) {
        case p:
          return Pe("Suspense");
        case d:
          return Pe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return Me(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, F = y._payload, T = y._init;
            try {
              return se(T(F), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Se = {}, Ae = x.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(m);
      } else
        Ae.setExtraStackFrame(null);
    }
    function yn(t, c, m, y, F) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + m + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              _ = t[S](c, S, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Re(F), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, S, typeof _), Re(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Re(F), g("Failed %s type: %s", m, _.message), Re(null));
          }
      }
    }
    var Q = Array.isArray;
    function $(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ae(t);
    }
    var J = x.ReactCurrentOwner, de = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, xe, $e;
    function tn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && J.current;
    }
    function pn(t, c) {
      {
        var m = function() {
          xe || (xe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function Fn(t, c) {
      {
        var m = function() {
          $e || ($e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, m, y, F, T, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: F
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, m, y, F) {
      {
        var T, S = {}, _ = null, ee = null;
        m !== void 0 && (V(m), _ = "" + m), gn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ee = c.ref, on(c));
        for (T in c)
          le.call(c, T) && !de.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (T in L)
            S[T] === void 0 && (S[T] = L[T]);
        }
        if (_ || ee) {
          var U = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, U), ee && Fn(S, U);
        }
        return xn(t, _, ee, F, y, J.current, S);
      }
    }
    var en = x.ReactCurrentOwner, vn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        vn.setExtraStackFrame(m);
      } else
        vn.setExtraStackFrame(null);
    }
    var un;
    un = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = D(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Nn = {};
    function Rn(t) {
      {
        var c = jn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function kn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Rn(c);
        if (Nn[m])
          return;
        Nn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + D(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Ve(null);
      }
    }
    function _n(t, c) {
      {
        if (typeof t != "object")
          return;
        if ($(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            dn(y) && kn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var F = N(t);
          if (typeof F == "function" && F !== t.entries)
            for (var T = F.call(t), S; !(S = T.next()).done; )
              dn(S.value) && kn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = D(c);
          yn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !un) {
          un = !0;
          var F = D(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", F || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, m, y, F, T) {
      {
        var S = ne(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = Bn();
          ee ? _ += ee : _ += jn();
          var L;
          t === null ? L = "null" : $(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (D(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var U = En(t, c, m, F, T);
        if (U == null)
          return U;
        if (S) {
          var ce = c.children;
          if (ce !== void 0)
            if (y)
              if ($(ce)) {
                for (var ze = 0; ze < ce.length; ze++)
                  _n(ce[ze], t);
                Object.freeze && Object.freeze(ce);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _n(ce, t);
        }
        if (le.call(c, "key")) {
          var Oe = D(t), re = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), mn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Oe + mn]) {
            var Dn = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Oe, Dn, Oe), Cn[Oe + mn] = !0;
          }
        }
        return t === i ? Ln(U) : An(U), U;
      }
    }
    function Vn(t, c, m) {
      return wn(t, c, m, !0);
    }
    function qn(t, c, m) {
      return wn(t, c, m, !1);
    }
    var zn = qn, Wn = Vn;
    ps.Fragment = i, ps.jsx = zn, ps.jsxs = Wn;
  })()), ps;
}
var Q_;
function k5() {
  return Q_ || (Q_ = 1, process.env.NODE_ENV === "production" ? mm.exports = g5() : mm.exports = v5()), mm.exports;
}
var fn = k5();
const b5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "conversationsQuery" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Miuros" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findTickets" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "page_size" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "labels" } }, { kind: "Field", name: { kind: "Name", value: "subject" } }, { kind: "Field", name: { kind: "Name", value: "messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "direction" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "agent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }] } }] } }] } }] }, x5 = {
  "\n  query conversationsQuery($query: String) {\n    Miuros {\n      findTickets(query: $query, page_size: 10) {\n        data {\n          id\n          labels\n          subject\n          messages {\n            direction\n            body\n            agent {\n              email\n              name\n            }\n            created_at\n          }\n          custom_fields {\n            additionalProperties {\n              key\n              value {\n                value\n              }\n            }\n          }\n          created_at\n        }\n      }\n    }\n  }\n": b5
};
function _5(e) {
  return x5[e] ?? {};
}
function X_(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var r = 0, i = Array(n); r < n; r++) i[r] = e[r];
  return i;
}
function S5(e) {
  if (Array.isArray(e)) return e;
}
function N5(e, n) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var i, a, o, s, l = [], u = !0, p = !1;
    try {
      if (o = (r = r.call(e)).next, n !== 0) for (; !(u = (i = o.call(r)).done) && (l.push(i.value), l.length !== n); u = !0) ;
    } catch (d) {
      p = !0, a = d;
    } finally {
      try {
        if (!u && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (p) throw a;
      }
    }
    return l;
  }
}
function j5() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function w5(e, n) {
  return S5(e) || N5(e, n) || C5(e, n) || j5();
}
function C5(e, n) {
  if (e) {
    if (typeof e == "string") return X_(e, n);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? X_(e, n) : void 0;
  }
}
const F1 = Object.entries, Z_ = Object.setPrototypeOf, I5 = Object.isFrozen, F5 = Object.getPrototypeOf, E5 = Object.getOwnPropertyDescriptor;
let Rt = Object.freeze, Lt = Object.seal, ia = Object.create, E1 = typeof Reflect < "u" && Reflect, Kh = E1.apply, Gh = E1.construct;
Rt || (Rt = function(e) {
  return e;
});
Lt || (Lt = function(e) {
  return e;
});
Kh || (Kh = function(e, n) {
  for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++)
    i[a - 2] = arguments[a];
  return e.apply(n, i);
});
Gh || (Gh = function(e) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    r[i - 1] = arguments[i];
  return new e(...r);
});
const to = _t(Array.prototype.forEach), $5 = _t(Array.prototype.lastIndexOf), eS = _t(Array.prototype.pop), Xi = _t(Array.prototype.push), T5 = _t(Array.prototype.splice), ui = Array.isArray, vo = _t(String.prototype.toLowerCase), pm = _t(String.prototype.toString), nS = _t(String.prototype.match), ro = _t(String.prototype.replace), tS = _t(String.prototype.indexOf), O5 = _t(String.prototype.trim), D5 = _t(Number.prototype.toString), P5 = _t(Boolean.prototype.toString), rS = typeof BigInt > "u" ? null : _t(BigInt.prototype.toString), iS = typeof Symbol > "u" ? null : _t(Symbol.prototype.toString), wt = _t(Object.prototype.hasOwnProperty), io = _t(Object.prototype.toString), $t = _t(RegExp.prototype.test), _i = R5(TypeError);
function _t(e) {
  return function(n) {
    n instanceof RegExp && (n.lastIndex = 0);
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
      i[a - 1] = arguments[a];
    return Kh(e, n, i);
  };
}
function R5(e) {
  return function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return Gh(e, r);
  };
}
function Hn(e, n) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : vo;
  if (Z_ && Z_(e, null), !ui(n))
    return e;
  let i = n.length;
  for (; i--; ) {
    let a = n[i];
    if (typeof a == "string") {
      const o = r(a);
      o !== a && (I5(n) || (n[i] = o), a = o);
    }
    e[a] = !0;
  }
  return e;
}
function A5(e) {
  for (let n = 0; n < e.length; n++)
    wt(e, n) || (e[n] = null);
  return e;
}
function Ht(e) {
  const n = ia(null);
  for (const i of F1(e)) {
    var r = w5(i, 2);
    const a = r[0], o = r[1];
    wt(e, a) && (ui(o) ? n[a] = A5(o) : o && typeof o == "object" && o.constructor === Object ? n[a] = Ht(o) : n[a] = o);
  }
  return n;
}
function L5(e) {
  switch (typeof e) {
    case "string":
      return e;
    case "number":
      return D5(e);
    case "boolean":
      return P5(e);
    case "bigint":
      return rS ? rS(e) : "0";
    case "symbol":
      return iS ? iS(e) : "Symbol()";
    case "undefined":
      return io(e);
    case "function":
    case "object": {
      if (e === null)
        return io(e);
      const n = e, r = Dr(n, "toString");
      if (typeof r == "function") {
        const i = r(n);
        return typeof i == "string" ? i : io(i);
      }
      return io(e);
    }
    default:
      return io(e);
  }
}
function Dr(e, n) {
  for (; e !== null; ) {
    const i = E5(e, n);
    if (i) {
      if (i.get)
        return _t(i.get);
      if (typeof i.value == "function")
        return _t(i.value);
    }
    e = F5(e);
  }
  function r() {
    return null;
  }
  return r;
}
function V5(e) {
  try {
    return $t(e, ""), !0;
  } catch {
    return !1;
  }
}
const aS = Rt(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), fm = Rt(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), hm = Rt(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), z5 = Rt(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), ym = Rt(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), U5 = Rt(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), oS = Rt(["#text"]), sS = Rt(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "command", "commandfor", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns"]), gm = Rt(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), lS = Rt(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), fs = Rt(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), M5 = Lt(/{{[\w\W]*|^[\w\W]*}}/g), B5 = Lt(/<%[\w\W]*|^[\w\W]*%>/g), q5 = Lt(/\${[\w\W]*/g), H5 = Lt(/^data-[\-\w.\u00B7-\uFFFF]+$/), W5 = Lt(/^aria-[\-\w]+$/), cS = Lt(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), K5 = Lt(/^(?:\w+script|data):/i), G5 = Lt(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), Y5 = Lt(/^html$/i), J5 = Lt(/^[a-z][.\w]*(-[.\w]+)+$/i), uS = Lt(/<[/\w!]/g), Q5 = Lt(/<[/\w]/g), X5 = Lt(/<\/no(script|embed|frames)/i), Z5 = Lt(/\/>/i), Or = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  processingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12
  // Deprecated
}, eB = function() {
  return typeof window > "u" ? null : window;
}, nB = function(e, n) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let r = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (r = n.getAttribute(i));
  const a = "dompurify" + (r ? "#" + r : "");
  try {
    return e.createPolicy(a, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
}, dS = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
}, li = function(e, n, r, i) {
  return wt(e, n) && ui(e[n]) ? Hn(i.base ? Ht(i.base) : {}, e[n], i.transform) : r;
};
function $1() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : eB();
  const n = (K) => $1(K);
  if (n.version = "3.4.11", n.removed = [], !e || !e.document || e.document.nodeType !== Or.document || !e.Element)
    return n.isSupported = !1, n;
  let r = e.document;
  const i = r, a = i.currentScript;
  e.DocumentFragment;
  const o = e.HTMLTemplateElement, s = e.Node, l = e.Element, u = e.NodeFilter;
  e.NamedNodeMap === void 0 && (e.NamedNodeMap || e.MozNamedAttrMap), e.HTMLFormElement;
  const d = e.DOMParser, f = e.trustedTypes, h = l.prototype, v = Dr(h, "cloneNode"), C = Dr(h, "remove"), j = Dr(h, "nextSibling"), N = Dr(h, "childNodes"), x = Dr(h, "parentNode"), g = Dr(h, "shadowRoot"), P = Dr(h, "attributes"), E = s && s.prototype ? Dr(s.prototype, "nodeType") : null, I = s && s.prototype ? Dr(s.prototype, "nodeName") : null;
  if (typeof o == "function") {
    const K = r.createElement("template");
    K.content && K.content.ownerDocument && (r = K.content.ownerDocument);
  }
  let w, A = "", H, Y = !1, ne = 0;
  const W = function() {
    if (ne > 0)
      throw _i('A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the "DOMPurify and Trusted Types" section of the README.');
  }, B = function(K) {
    W(), ne++;
    try {
      return w.createHTML(K);
    } finally {
      ne--;
    }
  }, D = function(K) {
    W(), ne++;
    try {
      return w.createScriptURL(K);
    } finally {
      ne--;
    }
  }, M = function() {
    return Y || (H = nB(f, a), Y = !0), H;
  }, Z = r, je = Z.implementation, ge = Z.createNodeIterator, ye = Z.createDocumentFragment, ke = Z.getElementsByTagName, q = i.importNode;
  let _e = dS();
  n.isSupported = typeof F1 == "function" && typeof x == "function" && je && je.createHTMLDocument !== void 0;
  const De = M5, G = B5, Ye = q5, sn = H5, Ie = W5, Ue = K5, Pe = G5, Be = J5;
  let Le = cS, Xe = null;
  const Fe = Hn({}, [...aS, ...fm, ...hm, ...ym, ...oS]);
  let Me = null;
  const nn = Hn({}, [...sS, ...gm, ...lS, ...fs]);
  let se = Object.seal(ia(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), le = null, Se = null;
  const Ae = Object.seal(ia(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let Re = !0, yn = !0, Q = !1, $ = !0, z = !1, X = !0, ae = !1, V = !1, J = null, de = null, xe = !1, $e = !1, tn = !1, gn = !1, on = !0, pn = !1;
  const Fn = "user-content-";
  let xn = !0, En = !1, en = {}, vn = null;
  const Ve = Hn({}, [
    "annotation-xml",
    "audio",
    "colgroup",
    "desc",
    "foreignobject",
    "head",
    "iframe",
    "math",
    "mi",
    "mn",
    "mo",
    "ms",
    "mtext",
    "noembed",
    "noframes",
    "noscript",
    "plaintext",
    "script",
    // <selectedcontent> mirrors the selected <option>'s subtree, cloned by
    // the UA (customizable <select>) — including any on* handlers — and the
    // engine re-mirrors synchronously whenever a removal changes which
    // option/selectedcontent is current, even inside DOMPurify's inert
    // DOMParser document. Hoisting its children on removal re-inserts a fresh
    // mirror target ahead of the walk, which the engine refills, looping
    // forever (DoS) and amplifying output. Dropping its content on removal
    // (rather than hoisting) breaks that cascade; the content is a duplicate
    // of the option, which is sanitized on its own. See campaign-3 F1/F6.
    "selectedcontent",
    "style",
    "svg",
    "template",
    "thead",
    "title",
    "video",
    "xmp"
  ]);
  let un = null;
  const dn = Hn({}, ["audio", "video", "img", "source", "image", "track"]);
  let jn = null;
  const Bn = Hn({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Nn = "http://www.w3.org/1998/Math/MathML", Rn = "http://www.w3.org/2000/svg", kn = "http://www.w3.org/1999/xhtml";
  let _n = kn, An = !1, Ln = null;
  const Cn = Hn({}, [Nn, Rn, kn], pm), wn = Rt(["mi", "mo", "mn", "ms", "mtext"]);
  let Vn = Hn({}, wn);
  const qn = Rt(["annotation-xml"]);
  let zn = Hn({}, qn);
  const Wn = Hn({}, ["title", "style", "font", "a", "script"]);
  let t = null;
  const c = ["application/xhtml+xml", "text/html"], m = "text/html";
  let y = null, F = null;
  const T = r.createElement("form"), S = function(K) {
    return K instanceof RegExp || K instanceof Function;
  }, _ = function() {
    let K = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (F && F === K)
      return;
    (!K || typeof K != "object") && (K = {}), K = Ht(K), t = // eslint-disable-next-line unicorn/prefer-includes
    c.indexOf(K.PARSER_MEDIA_TYPE) === -1 ? m : K.PARSER_MEDIA_TYPE, y = t === "application/xhtml+xml" ? pm : vo, Xe = li(K, "ALLOWED_TAGS", Fe, {
      transform: y
    }), Me = li(K, "ALLOWED_ATTR", nn, {
      transform: y
    }), Ln = li(K, "ALLOWED_NAMESPACES", Cn, {
      transform: pm
    }), jn = li(K, "ADD_URI_SAFE_ATTR", Bn, {
      transform: y,
      base: Bn
    }), un = li(K, "ADD_DATA_URI_TAGS", dn, {
      transform: y,
      base: dn
    }), vn = li(K, "FORBID_CONTENTS", Ve, {
      transform: y
    }), le = li(K, "FORBID_TAGS", Ht({}), {
      transform: y
    }), Se = li(K, "FORBID_ATTR", Ht({}), {
      transform: y
    }), en = wt(K, "USE_PROFILES") ? K.USE_PROFILES && typeof K.USE_PROFILES == "object" ? Ht(K.USE_PROFILES) : K.USE_PROFILES : !1, Re = K.ALLOW_ARIA_ATTR !== !1, yn = K.ALLOW_DATA_ATTR !== !1, Q = K.ALLOW_UNKNOWN_PROTOCOLS || !1, $ = K.ALLOW_SELF_CLOSE_IN_ATTR !== !1, z = K.SAFE_FOR_TEMPLATES || !1, X = K.SAFE_FOR_XML !== !1, ae = K.WHOLE_DOCUMENT || !1, $e = K.RETURN_DOM || !1, tn = K.RETURN_DOM_FRAGMENT || !1, gn = K.RETURN_TRUSTED_TYPE || !1, xe = K.FORCE_BODY || !1, on = K.SANITIZE_DOM !== !1, pn = K.SANITIZE_NAMED_PROPS || !1, xn = K.KEEP_CONTENT !== !1, En = K.IN_PLACE || !1, Le = V5(K.ALLOWED_URI_REGEXP) ? K.ALLOWED_URI_REGEXP : cS, _n = typeof K.NAMESPACE == "string" ? K.NAMESPACE : kn, Vn = wt(K, "MATHML_TEXT_INTEGRATION_POINTS") && K.MATHML_TEXT_INTEGRATION_POINTS && typeof K.MATHML_TEXT_INTEGRATION_POINTS == "object" ? Ht(K.MATHML_TEXT_INTEGRATION_POINTS) : Hn({}, wn), zn = wt(K, "HTML_INTEGRATION_POINTS") && K.HTML_INTEGRATION_POINTS && typeof K.HTML_INTEGRATION_POINTS == "object" ? Ht(K.HTML_INTEGRATION_POINTS) : Hn({}, qn);
    const Te = wt(K, "CUSTOM_ELEMENT_HANDLING") && K.CUSTOM_ELEMENT_HANDLING && typeof K.CUSTOM_ELEMENT_HANDLING == "object" ? Ht(K.CUSTOM_ELEMENT_HANDLING) : ia(null);
    if (se = ia(null), wt(Te, "tagNameCheck") && S(Te.tagNameCheck) && (se.tagNameCheck = Te.tagNameCheck), wt(Te, "attributeNameCheck") && S(Te.attributeNameCheck) && (se.attributeNameCheck = Te.attributeNameCheck), wt(Te, "allowCustomizedBuiltInElements") && typeof Te.allowCustomizedBuiltInElements == "boolean" && (se.allowCustomizedBuiltInElements = Te.allowCustomizedBuiltInElements), Lt(se), z && (yn = !1), tn && ($e = !0), en && (Xe = Hn({}, oS), Me = ia(null), en.html === !0 && (Hn(Xe, aS), Hn(Me, sS)), en.svg === !0 && (Hn(Xe, fm), Hn(Me, gm), Hn(Me, fs)), en.svgFilters === !0 && (Hn(Xe, hm), Hn(Me, gm), Hn(Me, fs)), en.mathMl === !0 && (Hn(Xe, ym), Hn(Me, lS), Hn(Me, fs))), Ae.tagCheck = null, Ae.attributeCheck = null, wt(K, "ADD_TAGS") && (typeof K.ADD_TAGS == "function" ? Ae.tagCheck = K.ADD_TAGS : ui(K.ADD_TAGS) && (Xe === Fe && (Xe = Ht(Xe)), Hn(Xe, K.ADD_TAGS, y))), wt(K, "ADD_ATTR") && (typeof K.ADD_ATTR == "function" ? Ae.attributeCheck = K.ADD_ATTR : ui(K.ADD_ATTR) && (Me === nn && (Me = Ht(Me)), Hn(Me, K.ADD_ATTR, y))), wt(K, "ADD_URI_SAFE_ATTR") && ui(K.ADD_URI_SAFE_ATTR) && Hn(jn, K.ADD_URI_SAFE_ATTR, y), wt(K, "FORBID_CONTENTS") && ui(K.FORBID_CONTENTS) && (vn === Ve && (vn = Ht(vn)), Hn(vn, K.FORBID_CONTENTS, y)), wt(K, "ADD_FORBID_CONTENTS") && ui(K.ADD_FORBID_CONTENTS) && (vn === Ve && (vn = Ht(vn)), Hn(vn, K.ADD_FORBID_CONTENTS, y)), xn && (Xe["#text"] = !0), ae && Hn(Xe, ["html", "head", "body"]), Xe.table && (Hn(Xe, ["tbody"]), delete le.tbody), K.TRUSTED_TYPES_POLICY) {
      if (typeof K.TRUSTED_TYPES_POLICY.createHTML != "function")
        throw _i('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      if (typeof K.TRUSTED_TYPES_POLICY.createScriptURL != "function")
        throw _i('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      const He = w;
      w = K.TRUSTED_TYPES_POLICY;
      try {
        A = B("");
      } catch (cn) {
        throw w = He, cn;
      }
    } else K.TRUSTED_TYPES_POLICY === null ? (w = void 0, A = "") : (w === void 0 && (w = M()), w && typeof A == "string" && (A = B("")));
    Rt && Rt(K), F = K;
  }, ee = Hn({}, [...fm, ...hm, ...z5]), L = Hn({}, [...ym, ...U5]), U = function(K, Te, He) {
    return Te.namespaceURI === kn ? K === "svg" : Te.namespaceURI === Nn ? K === "svg" && (He === "annotation-xml" || Vn[He]) : !!ee[K];
  }, ce = function(K, Te, He) {
    return Te.namespaceURI === kn ? K === "math" : Te.namespaceURI === Rn ? K === "math" && zn[He] : !!L[K];
  }, ze = function(K, Te, He) {
    return Te.namespaceURI === Rn && !zn[He] || Te.namespaceURI === Nn && !Vn[He] ? !1 : !L[K] && (Wn[K] || !ee[K]);
  }, Oe = function(K) {
    let Te = x(K);
    (!Te || !Te.tagName) && (Te = {
      namespaceURI: _n,
      tagName: "template"
    });
    const He = vo(K.tagName), cn = vo(Te.tagName);
    return Ln[K.namespaceURI] ? K.namespaceURI === Rn ? U(He, Te, cn) : K.namespaceURI === Nn ? ce(He, Te, cn) : K.namespaceURI === kn ? ze(He, Te, cn) : !!(t === "application/xhtml+xml" && Ln[K.namespaceURI]) : !1;
  }, re = function(K) {
    Xi(n.removed, {
      element: K
    });
    try {
      x(K).removeChild(K);
    } catch {
      if (C(K), !x(K))
        throw _i("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
    }
  }, mn = function(K) {
    const Te = N(K);
    if (Te) {
      const cn = [];
      to(Te, (Pn) => {
        Xi(cn, Pn);
      }), to(cn, (Pn) => {
        try {
          C(Pn);
        } catch {
        }
      });
    }
    const He = P(K);
    if (He)
      for (let cn = He.length - 1; cn >= 0; --cn) {
        const Pn = He[cn], nt = Pn && Pn.name;
        if (typeof nt == "string")
          try {
            K.removeAttribute(nt);
          } catch {
          }
      }
  }, Dn = function(K, Te) {
    try {
      Xi(n.removed, {
        attribute: Te.getAttributeNode(K),
        from: Te
      });
    } catch {
      Xi(n.removed, {
        attribute: null,
        from: Te
      });
    }
    if (Te.removeAttribute(K), K === "is")
      if ($e || tn)
        try {
          re(Te);
        } catch {
        }
      else
        try {
          Te.setAttribute(K, "");
        } catch {
        }
  }, Kn = function(K) {
    const Te = P(K);
    if (Te)
      for (let He = Te.length - 1; He >= 0; --He) {
        const cn = Te[He], Pn = cn && cn.name;
        if (!(typeof Pn != "string" || Me[y(Pn)]))
          try {
            K.removeAttribute(Pn);
          } catch {
          }
      }
  }, TI = function(K) {
    const Te = [K];
    for (; Te.length > 0; ) {
      const He = Te.pop();
      (E ? E(He) : He.nodeType) === Or.element && Kn(He);
      const cn = N(He);
      if (cn)
        for (let Pn = cn.length - 1; Pn >= 0; --Pn)
          Te.push(cn[Pn]);
    }
  }, Mg = function(K) {
    let Te = null, He = null;
    if (xe)
      K = "<remove></remove>" + K;
    else {
      const nt = nS(K, /^[\r\n\t ]+/);
      He = nt && nt[0];
    }
    t === "application/xhtml+xml" && _n === kn && (K = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + K + "</body></html>");
    const cn = w ? B(K) : K;
    if (_n === kn)
      try {
        Te = new d().parseFromString(cn, t);
      } catch {
      }
    if (!Te || !Te.documentElement) {
      Te = je.createDocument(_n, "template", null);
      try {
        Te.documentElement.innerHTML = An ? A : cn;
      } catch {
      }
    }
    const Pn = Te.body || Te.documentElement;
    return K && He && Pn.insertBefore(r.createTextNode(He), Pn.childNodes[0] || null), _n === kn ? ke.call(Te, ae ? "html" : "body")[0] : ae ? Te.documentElement : Pn;
  }, Bg = function(K) {
    return ge.call(
      K.ownerDocument || K,
      K,
      // eslint-disable-next-line no-bitwise
      u.SHOW_ELEMENT | u.SHOW_COMMENT | u.SHOW_TEXT | u.SHOW_PROCESSING_INSTRUCTION | u.SHOW_CDATA_SECTION,
      null
    );
  }, Ko = function(K) {
    return K = ro(K, De, " "), K = ro(K, G, " "), K = ro(K, Ye, " "), K;
  }, Wl = function(K) {
    var Te;
    K.normalize();
    const He = ge.call(
      K.ownerDocument || K,
      K,
      // eslint-disable-next-line no-bitwise
      u.SHOW_TEXT | u.SHOW_COMMENT | u.SHOW_CDATA_SECTION | u.SHOW_PROCESSING_INSTRUCTION,
      null
    );
    let cn = He.nextNode();
    for (; cn; )
      cn.data = Ko(cn.data), cn = He.nextNode();
    const Pn = (Te = K.querySelectorAll) === null || Te === void 0 ? void 0 : Te.call(K, "template");
    Pn && to(Pn, (nt) => {
      Hi(nt.content) && Wl(nt.content);
    });
  }, Go = function(K) {
    const Te = I ? I(K) : null;
    return typeof Te != "string" || y(Te) !== "form" ? !1 : typeof K.nodeName != "string" || typeof K.textContent != "string" || typeof K.removeChild != "function" || // Realm-safe NamedNodeMap detection: equality against the cached
    // prototype getter. Clobbered .attributes (e.g. <input name="attributes">)
    // makes the direct read diverge from the cached read; a clean form
    // (same-realm OR foreign-realm) has both reads pointing at the same
    // canonical NamedNodeMap.
    K.attributes !== P(K) || typeof K.removeAttribute != "function" || typeof K.setAttribute != "function" || typeof K.namespaceURI != "string" || typeof K.insertBefore != "function" || typeof K.hasChildNodes != "function" || // NodeType clobbering probe. Cached Node.prototype.nodeType getter
    // returns the integer 1 for any Element regardless of realm; direct
    // read on a clobbered form (e.g. <input name="nodeType">) returns
    // the named child element. Cheap addition — nodeType is read from
    // an internal slot, no serialization cost — and removes a residual
    // clobbering surface used by several mXSS / PI / comment branches
    // in _sanitizeElements that compare currentNode.nodeType directly.
    K.nodeType !== E(K) || // HTMLFormElement has [LegacyOverrideBuiltIns]: a descendant named
    // "childNodes" shadows the prototype getter. Direct reads of
    // form.childNodes from a clobbered form return the named child
    // instead of the real NodeList, so any walk that reads it directly
    // skips the form's real children. Compare the direct read to the
    // cached Node.prototype getter — when the form's named-property
    // getter intercepts the read, the two values differ and we flag
    // the form. This catches every clobbering child type (input,
    // select, etc.) regardless of whether the named child happens to
    // carry a numeric .length, which a typeof-based probe would miss
    // (e.g. HTMLSelectElement.length is a defined unsigned-long).
    K.childNodes !== N(K);
  }, Hi = function(K) {
    if (!E || typeof K != "object" || K === null)
      return !1;
    try {
      return E(K) === Or.documentFragment;
    } catch {
      return !1;
    }
  }, Oa = function(K) {
    if (!E || typeof K != "object" || K === null)
      return !1;
    try {
      return typeof E(K) == "number";
    } catch {
      return !1;
    }
  };
  function Kr(K, Te, He) {
    K.length !== 0 && to(K, (cn) => {
      cn.call(n, Te, He, F);
    });
  }
  const OI = function(K, Te) {
    return !!(X && K.hasChildNodes() && !Oa(K.firstElementChild) && $t(uS, K.textContent) && $t(uS, K.innerHTML) || X && K.namespaceURI === kn && Te === "style" && Oa(K.firstElementChild) || K.nodeType === Or.processingInstruction || X && K.nodeType === Or.comment && $t(Q5, K.data));
  }, DI = function(K, Te) {
    if (!le[Te] && Wg(Te) && (se.tagNameCheck instanceof RegExp && $t(se.tagNameCheck, Te) || se.tagNameCheck instanceof Function && se.tagNameCheck(Te)))
      return !1;
    if (xn && !vn[Te]) {
      const He = x(K), cn = N(K);
      if (cn && He) {
        const Pn = cn.length;
        for (let nt = Pn - 1; nt >= 0; --nt) {
          const rt = En ? cn[nt] : v(cn[nt], !0);
          He.insertBefore(rt, j(K));
        }
      }
    }
    return re(K), !0;
  }, qg = function(K) {
    if (Kr(_e.beforeSanitizeElements, K, null), Go(K))
      return re(K), !0;
    const Te = y(I ? I(K) : K.nodeName);
    if (Kr(_e.uponSanitizeElement, K, {
      tagName: Te,
      allowedTags: Xe
    }), OI(K, Te))
      return re(K), !0;
    if (le[Te] || !(Ae.tagCheck instanceof Function && Ae.tagCheck(Te)) && !Xe[Te])
      return DI(K, Te);
    if ((E ? E(K) : K.nodeType) === Or.element && !Oe(K) || (Te === "noscript" || Te === "noembed" || Te === "noframes") && $t(X5, K.innerHTML))
      return re(K), !0;
    if (z && K.nodeType === Or.text) {
      const He = Ko(K.textContent);
      K.textContent !== He && (Xi(n.removed, {
        element: K.cloneNode()
      }), K.textContent = He);
    }
    return Kr(_e.afterSanitizeElements, K, null), !1;
  }, Hg = function(K, Te, He) {
    if (Se[Te] || on && (Te === "id" || Te === "name") && (He in r || He in T))
      return !1;
    const cn = Me[Te] || Ae.attributeCheck instanceof Function && Ae.attributeCheck(Te, K);
    if (!(yn && $t(sn, Te)) && !(Re && $t(Ie, Te))) {
      if (cn) {
        if (!jn[Te] && !$t(Le, ro(He, Pe, "")) && !((Te === "src" || Te === "xlink:href" || Te === "href") && K !== "script" && tS(He, "data:") === 0 && un[K]) && !(Q && !$t(Ue, ro(He, Pe, ""))) && He)
          return !1;
      } else if (
        // First condition does a very basic check if a) it's basically a valid custom element tagname AND
        // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
        !(Wg(K) && (se.tagNameCheck instanceof RegExp && $t(se.tagNameCheck, K) || se.tagNameCheck instanceof Function && se.tagNameCheck(K)) && (se.attributeNameCheck instanceof RegExp && $t(se.attributeNameCheck, Te) || se.attributeNameCheck instanceof Function && se.attributeNameCheck(Te, K)) || // Alternative, second condition checks if it's an `is`-attribute, AND
        // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        Te === "is" && se.allowCustomizedBuiltInElements && (se.tagNameCheck instanceof RegExp && $t(se.tagNameCheck, He) || se.tagNameCheck instanceof Function && se.tagNameCheck(He)))
      ) return !1;
    }
    return !0;
  }, PI = Hn({}, ["annotation-xml", "color-profile", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "missing-glyph"]), Wg = function(K) {
    return !PI[vo(K)] && $t(Be, K);
  }, RI = function(K, Te, He, cn) {
    if (w && typeof f == "object" && typeof f.getAttributeType == "function" && !He)
      switch (f.getAttributeType(K, Te)) {
        case "TrustedHTML":
          return B(cn);
        case "TrustedScriptURL":
          return D(cn);
      }
    return cn;
  }, AI = function(K, Te, He, cn) {
    try {
      He ? K.setAttributeNS(He, Te, cn) : K.setAttribute(Te, cn), Go(K) ? re(K) : eS(n.removed);
    } catch {
      Dn(Te, K);
    }
  }, Kg = function(K) {
    Kr(_e.beforeSanitizeAttributes, K, null);
    const Te = K.attributes;
    if (!Te || Go(K))
      return;
    const He = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: Me,
      forceKeepAttr: void 0
    };
    let cn = Te.length;
    const Pn = y(K.nodeName);
    for (; cn--; ) {
      const nt = Te[cn], rt = nt.name, gi = nt.namespaceURI, ii = nt.value, Qt = y(rt), ai = ii;
      let qt = rt === "value" ? ai : O5(ai);
      if (He.attrName = Qt, He.attrValue = qt, He.keepAttr = !0, He.forceKeepAttr = void 0, Kr(_e.uponSanitizeAttribute, K, He), qt = He.attrValue, pn && (Qt === "id" || Qt === "name") && tS(qt, Fn) !== 0 && (Dn(rt, K), qt = Fn + qt), X && $t(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, qt)) {
        Dn(rt, K);
        continue;
      }
      if (Qt === "attributename" && nS(qt, "href")) {
        Dn(rt, K);
        continue;
      }
      if (!He.forceKeepAttr) {
        if (!He.keepAttr) {
          Dn(rt, K);
          continue;
        }
        if (!$ && $t(Z5, qt)) {
          Dn(rt, K);
          continue;
        }
        if (z && (qt = Ko(qt)), !Hg(Pn, Qt, qt)) {
          Dn(rt, K);
          continue;
        }
        qt = RI(Pn, Qt, gi, qt), qt !== ai && AI(K, rt, gi, qt);
      }
    }
    Kr(_e.afterSanitizeAttributes, K, null);
  }, Yo = function(K) {
    let Te = null;
    const He = Bg(K);
    for (Kr(_e.beforeSanitizeShadowDOM, K, null); Te = He.nextNode(); )
      if (Kr(_e.uponSanitizeShadowNode, Te, null), qg(Te), Kg(Te), Hi(Te.content) && Yo(Te.content), (E ? E(Te) : Te.nodeType) === Or.element) {
        const cn = g(Te);
        Hi(cn) && (Kl(cn), Yo(cn));
      }
    Kr(_e.afterSanitizeShadowDOM, K, null);
  }, Kl = function(K) {
    const Te = [{
      node: K,
      shadow: null
    }];
    for (; Te.length > 0; ) {
      const He = Te.pop();
      if (He.shadow) {
        Yo(He.shadow);
        continue;
      }
      const cn = He.node, Pn = (E ? E(cn) : cn.nodeType) === Or.element, nt = N(cn);
      if (nt)
        for (let rt = nt.length - 1; rt >= 0; --rt)
          Te.push({
            node: nt[rt],
            shadow: null
          });
      if (Pn) {
        const rt = I ? I(cn) : null;
        if (typeof rt == "string" && y(rt) === "template") {
          const gi = cn.content;
          Hi(gi) && Te.push({
            node: gi,
            shadow: null
          });
        }
      }
      if (Pn) {
        const rt = g(cn);
        Hi(rt) && Te.push({
          node: null,
          shadow: rt
        }, {
          node: rt,
          shadow: null
        });
      }
    }
  };
  return n.sanitize = function(K) {
    let Te = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, He = null, cn = null, Pn = null, nt = null;
    if (An = !K, An && (K = "<!-->"), typeof K != "string" && !Oa(K) && (K = L5(K), typeof K != "string"))
      throw _i("dirty is not a string, aborting");
    if (!n.isSupported)
      return K;
    V ? (Xe = J, Me = de) : _(Te), (_e.uponSanitizeElement.length > 0 || _e.uponSanitizeAttribute.length > 0) && (Xe = Ht(Xe)), _e.uponSanitizeAttribute.length > 0 && (Me = Ht(Me)), n.removed = [];
    const rt = En && typeof K != "string" && Oa(K);
    if (rt) {
      const Qt = I ? I(K) : K.nodeName;
      if (typeof Qt == "string") {
        const ai = y(Qt);
        if (!Xe[ai] || le[ai])
          throw _i("root node is forbidden and cannot be sanitized in-place");
      }
      if (Go(K))
        throw _i("root node is clobbered and cannot be sanitized in-place");
      try {
        Kl(K);
      } catch (ai) {
        throw mn(K), ai;
      }
    } else if (Oa(K))
      He = Mg("<!---->"), cn = He.ownerDocument.importNode(K, !0), cn.nodeType === Or.element && cn.nodeName === "BODY" || cn.nodeName === "HTML" ? He = cn : He.appendChild(cn), Kl(cn);
    else {
      if (!$e && !z && !ae && // eslint-disable-next-line unicorn/prefer-includes
      K.indexOf("<") === -1)
        return w && gn ? B(K) : K;
      if (He = Mg(K), !He)
        return $e ? null : gn ? A : "";
    }
    He && xe && re(He.firstChild);
    const gi = Bg(rt ? K : He);
    try {
      for (; Pn = gi.nextNode(); )
        qg(Pn), Kg(Pn), Hi(Pn.content) && Yo(Pn.content);
    } catch (Qt) {
      throw rt && mn(K), Qt;
    }
    if (rt)
      return to(n.removed, (Qt) => {
        Qt.element && TI(Qt.element);
      }), z && Wl(K), K;
    if ($e) {
      if (z && Wl(He), tn)
        for (nt = ye.call(He.ownerDocument); He.firstChild; )
          nt.appendChild(He.firstChild);
      else
        nt = He;
      return (Me.shadowroot || Me.shadowrootmode) && (nt = q.call(i, nt, !0)), nt;
    }
    let ii = ae ? He.outerHTML : He.innerHTML;
    return ae && Xe["!doctype"] && He.ownerDocument && He.ownerDocument.doctype && He.ownerDocument.doctype.name && $t(Y5, He.ownerDocument.doctype.name) && (ii = "<!DOCTYPE " + He.ownerDocument.doctype.name + `>
` + ii), z && (ii = Ko(ii)), w && gn ? B(ii) : ii;
  }, n.setConfig = function() {
    let K = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _(K), V = !0, J = Xe, de = Me;
  }, n.clearConfig = function() {
    F = null, V = !1, J = null, de = null, w = H, A = "";
  }, n.isValidAttribute = function(K, Te, He) {
    F || _({});
    const cn = y(K), Pn = y(Te);
    return Hg(cn, Pn, He);
  }, n.addHook = function(K, Te) {
    typeof Te == "function" && wt(_e, K) && Xi(_e[K], Te);
  }, n.removeHook = function(K, Te) {
    if (wt(_e, K)) {
      if (Te !== void 0) {
        const He = $5(_e[K], Te);
        return He === -1 ? void 0 : T5(_e[K], He, 1)[0];
      }
      return eS(_e[K]);
    }
  }, n.removeHooks = function(K) {
    wt(_e, K) && (_e[K] = []);
  }, n.removeAllHooks = function() {
    _e = dS();
  }, n;
}
var tB = $1();
const rB = "_messageContainer_1rxr4_1", iB = "_chip_1rxr4_7", aB = "_chipLabel_1rxr4_10", oB = "_chipValue_1rxr4_13", hs = {
  messageContainer: rB,
  chip: iB,
  chipLabel: aB,
  chipValue: oB
}, mS = {
  INBOUND: {
    background: "var(--dixa-color-neutral-000)",
    borderColor: "var(--dixa-color-neutral-100)"
  },
  OUTBOUND: {
    background: "var(--dixa-color-neutral-100)",
    borderColor: "var(--dixa-color-neutral-200)"
  },
  INTERNAL: {
    background: "var(--dixa-color-orange-100)",
    borderColor: "var(--dixa-color-orange-200)"
  }
}, sB = ({
  messages: e,
  customFields: n,
  attachments: r,
  conversationContext: i
}) => {
  Je(() => {
    document.getElementById("endOfConversationAnchor") && document.getElementById("endOfConversationAnchor")?.scrollIntoView({ behavior: "smooth" });
  }, [e]);
  const a = () => {
    const o = "Contact";
    if (!i?.customer)
      return o;
    const {
      name: s,
      given_name: l,
      family_name: u,
      email: p,
      phone_number: d
    } = i.customer;
    return s ?? l ?? u ?? p ?? d ?? o;
  };
  return /* @__PURE__ */ fn.jsxs(b, { flexDirection: "column", gap: "200", children: [
    /* @__PURE__ */ fn.jsx(b, { flexDirection: "row", flexWrap: "wrap", margin: "0 0 300", children: !!n?.length && /* @__PURE__ */ fn.jsxs(b, { gap: "100", children: [
      /* @__PURE__ */ fn.jsx(Ze, { content: "Conversation Attributes", children: /* @__PURE__ */ fn.jsx(
        dy,
        {
          icon: "input",
          color: {
            contentColor: "var(--dixa-color-neutral-700)",
            backgroundColor: "var(--dixa-color-neutral-200)"
          }
        }
      ) }),
      n.map((o, s) => /* @__PURE__ */ fn.jsx(b, { alignItems: "center", children: /* @__PURE__ */ fn.jsx(Yn, { className: hs.chip, children: /* @__PURE__ */ fn.jsxs(b, { gap: "100", children: [
        /* @__PURE__ */ fn.jsxs(lt, { className: hs.chipLabel, children: [
          o.name,
          ":"
        ] }),
        /* @__PURE__ */ fn.jsx(lt, { className: hs.chipValue, children: o.value })
      ] }) }) }, `${s}-${o.name}`))
    ] }) }),
    e?.map((o) => /* @__PURE__ */ fn.jsx(
      b,
      {
        className: hs.messageContainer,
        gap: "200",
        style: {
          backgroundColor: o?.direction ? mS[o.direction].background : "var(--dixa-color-neutral-000)",
          borderColor: o?.direction ? mS[o.direction].borderColor : "var(--dixa-color-neutral-100)"
        },
        children: /* @__PURE__ */ fn.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
          /* @__PURE__ */ fn.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
            /* @__PURE__ */ fn.jsx(O.Heading, { variant: "heading-3", children: o?.direction == "INBOUND" ? a() : o?.agent?.name }),
            /* @__PURE__ */ fn.jsx(O.Paragraph, { variant: "4", children: /* @__PURE__ */ fn.jsx(mF, { relative: !0, time: o?.created_at }) })
          ] }),
          /* @__PURE__ */ fn.jsx(
            "div",
            {
              dangerouslySetInnerHTML: {
                __html: tB.sanitize(
                  o?.body?.replaceAll(/\r\n?|\n/g, "<br />") || ""
                )
              }
            }
          )
        ] })
      },
      o?.created_at
    )),
    r && /* @__PURE__ */ fn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", margin: "300 0 0", children: r.map((o, s) => /* @__PURE__ */ fn.jsx(
      pF,
      {
        fileName: o.url,
        label: o.label,
        onDownload: () => {
          window.open(o.url, "_blank")?.focus();
        }
      },
      `${s}-${o.url}`
    )) }),
    /* @__PURE__ */ fn.jsx("div", { id: "endOfConversationAnchor", children: " " })
  ] });
}, lB = "_conversation_1draa_1", cB = "_conversationSubLine_1draa_9", uB = "_modal_1draa_14", vm = {
  conversation: lB,
  conversationSubLine: cB,
  modal: uB
}, dB = (e) => (e && JSON.parse(e) || []).map((n) => ({
  url: n.URL__c,
  label: n.Name,
  type: n.File_Type__c
})), mB = (e) => Object.entries(e || {}).filter(([n]) => n.endsWith("__c")).map(([n, r]) => ({
  name: n.replace("__c", "").replaceAll("_", " "),
  // transform key into readable name
  value: r?.value ? r.value.toString() : ""
})), pB = ({
  conversation: e,
  conversationContext: n
}) => {
  const [r, i] = ue(!1), a = e?.created_at, o = e?.custom_fields, s = o && "attachments" in o;
  return /* @__PURE__ */ fn.jsxs(b, { className: vm.conversation, gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ fn.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ fn.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ fn.jsxs(b, { flexDirection: "row", gap: "100", children: [
          /* @__PURE__ */ fn.jsx(O.Heading, { variant: "heading-4", children: e?.id }),
          a && /* @__PURE__ */ fn.jsx(Mn, { size: "small", variant: "info", children: Jn(e?.created_at).format("DD MMM YYYY @ HH:mm") })
        ] }),
        /* @__PURE__ */ fn.jsx(
          O.Heading,
          {
            variant: "heading-4",
            className: vm.conversationSubLine,
            children: e?.subject
          }
        ),
        !!e?.labels?.length && /* @__PURE__ */ fn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [...new Set(e.labels)].map((l) => /* @__PURE__ */ fn.jsx(Yn, { children: l }, `${e.id}-${l}`)) })
      ] }),
      /* @__PURE__ */ fn.jsx(Ze, { content: "Show conversation preview", children: /* @__PURE__ */ fn.jsx(
        ir,
        {
          variant: "secondary",
          icon: "eye",
          onClick: () => i(!0),
          "data-testid": "open-messages-preview"
        }
      ) })
    ] }),
    /* @__PURE__ */ fn.jsxs(
      Ct,
      {
        isOpen: r,
        allowEscClose: !0,
        onClose: () => i(!1),
        className: vm.modal,
        children: [
          /* @__PURE__ */ fn.jsx(
            It,
            {
              title: "Conversation preview",
              onClose: () => i(!1)
            }
          ),
          /* @__PURE__ */ fn.jsx(Ft, { children: /* @__PURE__ */ fn.jsx(
            sB,
            {
              messages: e?.messages || [],
              ...s && {
                attachments: dB(
                  o?.attachments?.value
                )
              },
              conversationContext: n,
              customFields: mB(
                e?.custom_fields
              )
            }
          ) })
        ]
      }
    )
  ] });
}, fB = ({
  conversations: e,
  conversationContext: n,
  conversationsToShow: r
}) => {
  const [i, a] = ue(!1), o = r > 0 ? r : 1, s = e?.length > o, l = Xn(
    () => e?.sort((u, p) => p?.created_at.localeCompare(u?.created_at)).slice(
      0,
      i ? e.length : o
    ),
    [e, i, o]
  );
  return /* @__PURE__ */ fn.jsxs(b, { flexDirection: "column", gap: "200", margin: "200 0 300 0", children: [
    l.map((u, p) => /* @__PURE__ */ fn.jsx(
      pB,
      {
        conversation: u,
        conversationContext: n
      },
      `${p}-${u?.id}`
    )),
    s && /* @__PURE__ */ fn.jsxs(
      et,
      {
        variant: "secondary",
        onClick: () => a(!i),
        children: [
          "Show ",
          i ? "less" : "all"
        ]
      }
    )
  ] });
}, hB = _5(
  /* GraphQL*/
  `
  query conversationsQuery($query: String) {
    Miuros {
      findTickets(query: $query, page_size: 10) {
        data {
          id
          labels
          subject
          messages {
            direction
            body
            agent {
              email
              name
            }
            created_at
          }
          custom_fields {
            additionalProperties {
              key
              value {
                value
              }
            }
          }
          created_at
        }
      }
    }
  }
`
), yB = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = ue([]), a = Number.parseInt(n?.amountOfConversationsToShow) || 1, o = [
    e.customer?.email,
    e.customer?.phone_number
  ].filter((d) => !!d).map((d) => `'${d}'`).join(","), { useQuery: s } = bn(), { data: l, loading: u, error: p } = s(hB, {
    skip: o.length === 0,
    variables: {
      query: `requester_id=in=(${o})`
    }
  });
  return Je(() => {
    if (l?.Miuros) {
      const d = l?.Miuros?.findTickets?.data;
      d && i(d);
    }
  }, [l]), p ? /* @__PURE__ */ fn.jsx(Tn, { error: p }) : u ? /* @__PURE__ */ fn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ fn.jsx(hn, {}) }) : r?.length === 0 ? /* @__PURE__ */ fn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: "No conversations found for this customer" }) : /* @__PURE__ */ fn.jsx(
    fB,
    {
      "data-testid": "conversation-list",
      conversationsToShow: a,
      conversations: r,
      conversationContext: e
    }
  );
}, Yh = [
  {
    key: "miurosClientId",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "miurosClientSecret",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "amountOfConversationsToShow",
    type: "string",
    secret: !1,
    defaultValue: "1"
  }
], km = "MIUROS", gB = {
  enabled: !1,
  name: "",
  miurosClientId: "",
  miurosClientSecret: "",
  amountOfConversationsToShow: "1"
}, vB = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = dt({
    mode: "onChange",
    defaultValues: gB
  }), {
    create: u,
    update: p,
    remove: d,
    isLoading: f,
    error: h,
    misconfigurationCause: v,
    setMisconfigurationCause: C
  } = hr({
    integrationId: e,
    integrationType: km,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: j,
    error: N,
    isWidgetUnknown: x,
    refetch: g,
    widgetConfiguration: P
  } = yr({
    integrationId: e,
    fieldDefinitions: Yh,
    form: l,
    onMisconfigured: C
  }), { renderConditions: E, setRenderConditions: I, renderConditionsForSubmit: w } = gr({
    integrationId: e,
    widgetConfiguration: P,
    renderConditionsEditor: o
  }), A = (Y) => kr(Y, {
    fieldDefinitions: Yh,
    isCreationMode: s,
    create: u,
    update: p,
    renderConditions: w
  }), H = l.watch("name");
  return /* @__PURE__ */ fn.jsxs(
    vr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: A,
      error: N ?? h,
      onRetry: N ? g : void 0,
      isLoading: f || j,
      isWidgetUnknown: x,
      children: [
        v && /* @__PURE__ */ fn.jsx(br, { cause: v }),
        /* @__PURE__ */ fn.jsxs(tt, { children: [
          /* @__PURE__ */ fn.jsx(ie, { children: /* @__PURE__ */ fn.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ fn.jsx(
            Sn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ fn.jsx(ie, { span: 3, children: /* @__PURE__ */ fn.jsx(
            Gn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ fn.jsx(ie, { span: 3 }),
          /* @__PURE__ */ fn.jsx(ie, { span: 3, children: /* @__PURE__ */ fn.jsx(
            Gn,
            {
              name: "miurosClientId",
              label: "Authorization: Client ID",
              control: l.control,
              rules: { required: "Client ID is required" },
              componentProps: {
                placeholder: "Insert client ID",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ fn.jsx(ie, { span: 3 }),
          /* @__PURE__ */ fn.jsx(ie, { span: 3, children: /* @__PURE__ */ fn.jsx(
            mi,
            {
              name: "miurosClientSecret",
              label: "Authorization: Client secret",
              control: l.control,
              isCreationMode: s,
              rules: { required: "Client secret is required" },
              componentProps: {
                placeholder: "Insert client secret",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ fn.jsx(ie, { span: 3 }),
          /* @__PURE__ */ fn.jsx(ie, { span: 3, children: /* @__PURE__ */ fn.jsx(
            Gn,
            {
              name: "amountOfConversationsToShow",
              label: "Number of conversation to show before the fold",
              control: l.control,
              rules: {
                required: "Please enter a number",
                validate: (Y) => !Number.isNaN(Number.parseInt(Y, 10)) || "Please enter a number"
              },
              componentProps: {
                placeholder: "Enter number",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ fn.jsx(ie, { span: 3 }),
          !s && e && /* @__PURE__ */ fn.jsx(
            pi,
            {
              configuration: n,
              integrationId: e,
              integrationType: km,
              label: "Authorize"
            }
          ),
          o && E !== null && /* @__PURE__ */ fn.jsx(ie, { children: o({
            value: E,
            onChange: I,
            configurationKey: P?.id
          }) })
        ] }),
        /* @__PURE__ */ fn.jsx(
          xr,
          {
            integrationType: km,
            integrationId: e,
            widgetName: H,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => d()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_2c4dq_1{padding:0}._listItem_2c4dq_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_2c4dq_4:last-child{border-bottom:none}._copyIcon_2c4dq_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1nher_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._order_1dlaa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_1dlaa_1:hover,._orderIsOpen_1dlaa_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_1dlaa_12{cursor:pointer}._note_1dlaa_16{border:var(--dixa-size-border-100) dashed var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-200);max-height:100px;overflow-y:auto}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var bm = { exports: {} }, ao = {}, pS;
function kB() {
  if (pS) return ao;
  pS = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ao.Fragment = r, ao.jsx = s, ao.jsxs = s, ao;
}
var ys = {}, fS;
function bB() {
  return fS || (fS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        P("error", t, m);
      }
    }
    function P(t, c, m) {
      {
        var y = x.ReactDebugCurrentFrame, F = y.getStackAddendum();
        F !== "" && (c += "%s", m = m.concat([F]));
        var T = m.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var E = !1, I = !1, w = !1, A = !1, H = !1, Y;
    Y = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ne(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || H || t === a || t === p || t === d || A || t === v || E || I || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function W(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var F = c.displayName || c.name || "";
      return F !== "" ? m + "(" + F + ")" : m;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function D(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var m = t;
            return B(m._context) + ".Provider";
          case u:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : D(t.type) || "Memo";
          case h: {
            var F = t, T = F._payload, S = F._init;
            try {
              return D(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var M = Object.assign, Z = 0, je, ge, ye, ke, q, _e, De;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function Ye() {
      {
        if (Z === 0) {
          je = console.log, ge = console.info, ye = console.warn, ke = console.error, q = console.group, _e = console.groupCollapsed, De = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function sn() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: M({}, t, {
              value: je
            }),
            info: M({}, t, {
              value: ge
            }),
            warn: M({}, t, {
              value: ye
            }),
            error: M({}, t, {
              value: ke
            }),
            group: M({}, t, {
              value: q
            }),
            groupCollapsed: M({}, t, {
              value: _e
            }),
            groupEnd: M({}, t, {
              value: De
            })
          });
        }
        Z < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = x.ReactCurrentDispatcher, Ue;
    function Pe(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (F) {
            var y = F.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Le;
    {
      var Xe = typeof WeakMap == "function" ? WeakMap : Map;
      Le = new Xe();
    }
    function Fe(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Le.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      Be = !0;
      var F = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ye();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (re) {
              y = re;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (re) {
              y = re;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            y = re;
          }
          t();
        }
      } catch (re) {
        if (re && y && typeof re.stack == "string") {
          for (var _ = re.stack.split(`
`), ee = y.stack.split(`
`), L = _.length - 1, U = ee.length - 1; L >= 1 && U >= 0 && _[L] !== ee[U]; )
            U--;
          for (; L >= 1 && U >= 0; L--, U--)
            if (_[L] !== ee[U]) {
              if (L !== 1 || U !== 1)
                do
                  if (L--, U--, U < 0 || _[L] !== ee[U]) {
                    var ce = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && ce.includes("<anonymous>") && (ce = ce.replace("<anonymous>", t.displayName)), typeof t == "function" && Le.set(t, ce), ce;
                  }
                while (L >= 1 && U >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = F;
      }
      var ze = t ? t.displayName || t.name : "", Oe = ze ? Pe(ze) : "";
      return typeof t == "function" && Le.set(t, Oe), Oe;
    }
    function Me(t, c, m) {
      return Fe(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Fe(t, nn(t));
      if (typeof t == "string")
        return Pe(t);
      switch (t) {
        case p:
          return Pe("Suspense");
        case d:
          return Pe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return Me(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, F = y._payload, T = y._init;
            try {
              return se(T(F), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Se = {}, Ae = x.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(m);
      } else
        Ae.setExtraStackFrame(null);
    }
    function yn(t, c, m, y, F) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + m + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              _ = t[S](c, S, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Re(F), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, S, typeof _), Re(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Re(F), g("Failed %s type: %s", m, _.message), Re(null));
          }
      }
    }
    var Q = Array.isArray;
    function $(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ae(t);
    }
    var J = x.ReactCurrentOwner, de = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, xe, $e;
    function tn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && J.current;
    }
    function pn(t, c) {
      {
        var m = function() {
          xe || (xe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function Fn(t, c) {
      {
        var m = function() {
          $e || ($e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, m, y, F, T, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: F
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, m, y, F) {
      {
        var T, S = {}, _ = null, ee = null;
        m !== void 0 && (V(m), _ = "" + m), gn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ee = c.ref, on(c));
        for (T in c)
          le.call(c, T) && !de.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (T in L)
            S[T] === void 0 && (S[T] = L[T]);
        }
        if (_ || ee) {
          var U = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, U), ee && Fn(S, U);
        }
        return xn(t, _, ee, F, y, J.current, S);
      }
    }
    var en = x.ReactCurrentOwner, vn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        vn.setExtraStackFrame(m);
      } else
        vn.setExtraStackFrame(null);
    }
    var un;
    un = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = D(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Nn = {};
    function Rn(t) {
      {
        var c = jn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function kn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Rn(c);
        if (Nn[m])
          return;
        Nn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + D(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Ve(null);
      }
    }
    function _n(t, c) {
      {
        if (typeof t != "object")
          return;
        if ($(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            dn(y) && kn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var F = N(t);
          if (typeof F == "function" && F !== t.entries)
            for (var T = F.call(t), S; !(S = T.next()).done; )
              dn(S.value) && kn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = D(c);
          yn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !un) {
          un = !0;
          var F = D(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", F || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, m, y, F, T) {
      {
        var S = ne(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = Bn();
          ee ? _ += ee : _ += jn();
          var L;
          t === null ? L = "null" : $(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (D(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var U = En(t, c, m, F, T);
        if (U == null)
          return U;
        if (S) {
          var ce = c.children;
          if (ce !== void 0)
            if (y)
              if ($(ce)) {
                for (var ze = 0; ze < ce.length; ze++)
                  _n(ce[ze], t);
                Object.freeze && Object.freeze(ce);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _n(ce, t);
        }
        if (le.call(c, "key")) {
          var Oe = D(t), re = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), mn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Oe + mn]) {
            var Dn = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Oe, Dn, Oe), Cn[Oe + mn] = !0;
          }
        }
        return t === i ? Ln(U) : An(U), U;
      }
    }
    function Vn(t, c, m) {
      return wn(t, c, m, !0);
    }
    function qn(t, c, m) {
      return wn(t, c, m, !1);
    }
    var zn = qn, Wn = Vn;
    ys.Fragment = i, ys.jsx = zn, ys.jsxs = Wn;
  })()), ys;
}
var hS;
function xB() {
  return hS || (hS = 1, process.env.NODE_ENV === "production" ? bm.exports = kB() : bm.exports = bB()), bm.exports;
}
var Ce = xB();
const _B = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getAddresses" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAddresses" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Addresses" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "addresses" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "payment_method_id" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "customer_id" } }, { kind: "Field", name: { kind: "Name", value: "discounts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "value_type" } }] } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "order_attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "value" } }] } }, { kind: "Field", name: { kind: "Name", value: "order_note" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "presentment_currency" } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_conserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_override" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] }, SB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getStore" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Store" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "store" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }, { kind: "Field", name: { kind: "Name", value: "customer_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "merchant_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "checkout_platform" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "external_customer_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ecommerce" } }] } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_active_count" } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_total_count" } }, { kind: "Field", name: { kind: "Name", value: "has_valid_payment_method" } }, { kind: "Field", name: { kind: "Name", value: "hash" } }] } }] } }] } }] } }] } }] }, NB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "addressId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "address_id" }, value: { kind: "Variable", name: { kind: "Name", value: "addressId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Orders" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "is_prepaid" } }, { kind: "Field", name: { kind: "Name", value: "note" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "subtotal_price" } }, { kind: "Field", name: { kind: "Name", value: "total_discounts" } }, { kind: "Field", name: { kind: "Name", value: "total_duties" } }, { kind: "Field", name: { kind: "Name", value: "total_line_items_price" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "total_refunds" } }, { kind: "Field", name: { kind: "Name", value: "total_tax" } }, { kind: "Field", name: { kind: "Name", value: "total_weight_grams" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "charge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_transaction_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "payment_processor" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billing_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] } }] }, jB = {
  "\n  query getAddresses($customerId: String) {\n    Recharge {\n      getAddresses(customer_id: $customerId) {\n        ... on Recharge_Addresses {\n          addresses {\n            id\n            payment_method_id\n            address1\n            address2\n            city\n            company\n            country_code\n            created_at\n            customer_id\n            discounts {\n              id\n              code\n              value\n              value_type\n            }\n            first_name\n            last_name\n            order_attributes {\n              name\n              value\n            }\n            order_note\n            phone\n            presentment_currency\n            shipping_lines_conserved {\n              code\n              title\n              price\n            }\n            shipping_lines_override {\n              code\n              title\n              price\n            }\n            updated_at\n            zip\n          }\n        }\n      }\n    }\n  }\n": _B,
  "\n  query getCustomerDetails($email: String) {\n    Recharge {\n      getStore {\n        ... on Recharge_Store {\n          store {\n            id\n            name\n            external_platform\n            customer_portal_base_url\n            merchant_portal_base_url\n            identifier\n            checkout_platform\n            external_platform\n          }\n        }\n      }\n      getCustomers(email: $email) {\n        ... on Recharge_Customers {\n          customers {\n            id\n            email\n            phone\n            first_name\n            last_name\n            created_at\n            updated_at\n            external_customer_id {\n              ecommerce\n            }\n            subscriptions_active_count\n            subscriptions_total_count\n            has_valid_payment_method\n            hash\n          }\n        }\n      }\n    }\n  }\n": SB,
  "\n  query getOrders($customerId: String, $limit: String, $addressId: String) {\n    Recharge {\n      getOrders(\n        customer_id: $customerId\n        limit: $limit\n        address_id: $addressId\n      ) {\n        ... on Recharge_Orders {\n          orders {\n            id\n            created_at\n            currency\n            is_prepaid\n            note\n            status\n            subtotal_price\n            total_discounts\n            total_duties\n            total_line_items_price\n            total_price\n            total_refunds\n            total_tax\n            total_weight_grams\n            type\n            charge {\n              external_transaction_id {\n                payment_processor\n              }\n            }\n            billing_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n            shipping_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n          }\n        }\n      }\n    }\n  }\n": NB
};
function mg(e) {
  return jB[e] ?? {};
}
const wB = mg(
  /* GraphQL */
  `
  query getCustomerDetails($email: String) {
    Recharge {
      getStore {
        ... on Recharge_Store {
          store {
            id
            name
            external_platform
            customer_portal_base_url
            merchant_portal_base_url
            identifier
            checkout_platform
            external_platform
          }
        }
      }
      getCustomers(email: $email) {
        ... on Recharge_Customers {
          customers {
            id
            email
            phone
            first_name
            last_name
            created_at
            updated_at
            external_customer_id {
              ecommerce
            }
            subscriptions_active_count
            subscriptions_total_count
            has_valid_payment_method
            hash
          }
        }
      }
    }
  }
`
), CB = mg(
  /* GraphQL */
  `
  query getAddresses($customerId: String) {
    Recharge {
      getAddresses(customer_id: $customerId) {
        ... on Recharge_Addresses {
          addresses {
            id
            payment_method_id
            address1
            address2
            city
            company
            country_code
            created_at
            customer_id
            discounts {
              id
              code
              value
              value_type
            }
            first_name
            last_name
            order_attributes {
              name
              value
            }
            order_note
            phone
            presentment_currency
            shipping_lines_conserved {
              code
              title
              price
            }
            shipping_lines_override {
              code
              title
              price
            }
            updated_at
            zip
          }
        }
      }
    }
  }
`
), IB = mg(
  /* GraphQL */
  `
  query getOrders($customerId: String, $limit: String, $addressId: String) {
    Recharge {
      getOrders(
        customer_id: $customerId
        limit: $limit
        address_id: $addressId
      ) {
        ... on Recharge_Orders {
          orders {
            id
            created_at
            currency
            is_prepaid
            note
            status
            subtotal_price
            total_discounts
            total_duties
            total_line_items_price
            total_price
            total_refunds
            total_tax
            total_weight_grams
            type
            charge {
              external_transaction_id {
                payment_processor
              }
            }
            billing_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
            shipping_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
          }
        }
      }
    }
  }
`
);
function Jh(e = !1, n) {
  const [r, i] = ue(e);
  return Je(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const FB = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, T1 = "DD MMM YYYY @ HH:mm", EB = "_list_2c4dq_1", $B = "_listItem_2c4dq_4", TB = "_copyIcon_2c4dq_12", Oi = {
  list: EB,
  listItem: $B,
  copyIcon: TB
}, Qh = ({
  address: e,
  icon: n,
  title: r,
  isLoading: i = !1,
  hasMultipleAddresses: a = !1
}) => {
  const { isCopied: o, copy: s } = Jh(), l = 14, {
    first_name: u,
    last_name: p,
    address1: d,
    address2: f,
    city: h,
    zip: v,
    country_code: C
  } = e ?? {}, j = `${u} ${p}`.trim() || void 0, N = `${h} ${v}`.trim() || void 0, x = [j, d, f, N, C].filter(
    Boolean
  );
  return /* @__PURE__ */ Ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
    /* @__PURE__ */ Ce.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ Ce.jsx(he, { size: l, name: n }),
      i ? /* @__PURE__ */ Ce.jsx(hn, { size: l }) : /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
        r && /* @__PURE__ */ Ce.jsx(O.Paragraph, { variant: "3", children: r }),
        /* @__PURE__ */ Ce.jsx(O.Paragraph, { variant: "4", children: x.map((g, P) => /* @__PURE__ */ Ce.jsx(lt, { children: g }, P)) })
      ] })
    ] }),
    !i && /* @__PURE__ */ Ce.jsxs(b, { gap: "100", children: [
      a && /* @__PURE__ */ Ce.jsx(Ze, { content: "The customer has multiple addresses, showing only the first here.", children: /* @__PURE__ */ Ce.jsx(
        he,
        {
          size: l,
          name: "exclamation",
          className: Oi.copyIcon
        }
      ) }),
      /* @__PURE__ */ Ce.jsx(Ze, { content: `Copy ${r ? r.toLowerCase() : "address"}`, children: /* @__PURE__ */ Ce.jsx(
        he,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(x.join(", ")),
          className: Oi.copyIcon
        }
      ) })
    ] })
  ] });
}, OB = "_wrapper_1nher_1", DB = {
  wrapper: OB
}, PB = ({
  customer: e,
  store: n
}) => {
  const { track: r } = In(), { isCopied: i, copy: a } = Jh(), { isCopied: o, copy: s } = Jh(), { useQuery: l } = bn(), u = e?.id, {
    loading: p,
    error: d,
    data: f
  } = l(CB, {
    skip: !u,
    variables: {
      customerId: u?.toString()
    }
  }), h = f?.Recharge?.getAddresses, v = !p && h?.addresses?.[0] ? h.addresses[0] : void 0, C = (h?.addresses?.length ?? 0) > 1;
  if (Je(() => {
    v && r("recharge:profile:received");
  }, [v, r]), d)
    return /* @__PURE__ */ Ce.jsx(Tn, { error: d });
  if (!e)
    return null;
  const {
    id: j,
    phone: N,
    email: x,
    first_name: g,
    last_name: P,
    created_at: E,
    has_valid_payment_method: I
  } = e, w = 14, A = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/customers/${j}` : null, H = `${g || ""} ${P || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ Ce.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Ce.jsxs(b, { className: DB.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ce.jsx(O.Heading, { variant: "heading-2", children: H }),
    E && /* @__PURE__ */ Ce.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ Ce.jsx(O.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ Ce.jsx(O.Paragraph, { variant: "4", children: Jn(E).format(T1) })
    ] }),
    x && /* @__PURE__ */ Ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ce.jsx(he, { size: w, name: "mail" }),
        /* @__PURE__ */ Ce.jsx(O.ExternalLink, { href: `mailto:${x}`, children: x })
      ] }),
      /* @__PURE__ */ Ce.jsx(Ze, { content: "Copy email", children: /* @__PURE__ */ Ce.jsx(
        he,
        {
          size: w,
          name: i ? "done" : "copy",
          onClick: () => a(x),
          className: Oi.copyIcon
        }
      ) })
    ] }),
    N && /* @__PURE__ */ Ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ce.jsx(he, { size: w, name: "phone" }),
        /* @__PURE__ */ Ce.jsx(O.Paragraph, { variant: "4", children: N })
      ] }),
      /* @__PURE__ */ Ce.jsx(Ze, { content: "Copy phone number", children: /* @__PURE__ */ Ce.jsx(
        he,
        {
          size: w,
          name: o ? "done" : "copy",
          onClick: () => s(N),
          className: Oi.copyIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ Ce.jsx(
      Qh,
      {
        address: v,
        icon: "home",
        isLoading: p,
        hasMultipleAddresses: C
      }
    ),
    /* @__PURE__ */ Ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ce.jsx(he, { size: w, name: "credit-card" }),
        /* @__PURE__ */ Ce.jsx(O.Paragraph, { variant: "4", children: "Has valid payment method" })
      ] }),
      /* @__PURE__ */ Ce.jsx(
        he,
        {
          size: w,
          name: I ? "check-circle" : "close-circle-filled",
          color: I ? "green.500" : "red.500"
        }
      )
    ] }),
    A && /* @__PURE__ */ Ce.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ Ce.jsx(he, { size: w, name: "external-link" }),
      /* @__PURE__ */ Ce.jsx(
        O.ExternalLink,
        {
          href: A,
          target: "_blank",
          rel: "noreferrer",
          onClick: () => r("recharge:external:customer:overview:opened"),
          children: "View customer in Recharge"
        }
      )
    ] })
  ] }) });
}, RB = "_order_1dlaa_1", AB = "_orderIsOpen_1dlaa_9", LB = "_orderHeader_1dlaa_12", VB = "_note_1dlaa_16", gs = {
  order: RB,
  orderIsOpen: AB,
  orderHeader: LB,
  note: VB
}, zB = ({
  order: e,
  isOpenByDefault: n,
  store: r
}) => {
  const { track: i } = In(), [a, o] = ue(n), {
    id: s,
    status: l,
    charge: u,
    currency: p,
    note: d,
    created_at: f,
    billing_address: h,
    shipping_address: v,
    total_price: C,
    is_prepaid: j
  } = e, N = 14, x = r ? `https://${r.identifier}.admin.rechargeapps.com/merchant/orders/${s}` : null, g = u?.external_transaction_id?.payment_processor || void 0;
  return /* @__PURE__ */ Ce.jsxs(
    b,
    {
      className: ut(gs.order, {
        [gs.orderIsOpen]: a
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ Ce.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: gs.orderHeader,
            onClick: () => o(!a),
            children: [
              /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "column", children: [
                f && /* @__PURE__ */ Ce.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Ce.jsx(O.Paragraph, { variant: "4", children: Jn(f).format(T1) }) }),
                /* @__PURE__ */ Ce.jsxs(O.Paragraph, { variant: "1", children: [
                  "Order #",
                  s
                ] })
              ] }),
              /* @__PURE__ */ Ce.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: a ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        a && /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          d && /* @__PURE__ */ Ce.jsx(Ze, { content: "Note", children: /* @__PURE__ */ Ce.jsx(
            O.Paragraph,
            {
              variant: "4",
              color: "secondary",
              className: gs.note,
              children: d
            }
          ) }),
          l && /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ce.jsx(he, { size: N, name: "activity" }),
            /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ce.jsx(O.Paragraph, { variant: "3", children: "Status" }),
              /* @__PURE__ */ Ce.jsx(O.Paragraph, { variant: "4", children: FB(l) })
            ] })
          ] }),
          /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ce.jsx(he, { size: N, name: "credit-card" }),
            /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ce.jsx(O.Paragraph, { variant: "3", children: "Prepaid" }),
              /* @__PURE__ */ Ce.jsx(O.Paragraph, { variant: "4", children: j ? "Yes" : "No" })
            ] })
          ] }),
          g && /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ce.jsx(he, { size: N, name: "cog" }),
            /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ce.jsx(O.Paragraph, { variant: "3", children: "Payment processor" }),
              /* @__PURE__ */ Ce.jsx(O.Paragraph, { variant: "4", children: g })
            ] })
          ] }),
          /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ce.jsx(he, { size: N, name: "chart-bar" }),
            /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ce.jsx(O.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ Ce.jsxs(O.Paragraph, { variant: "4", children: [
                C,
                " ",
                p
              ] })
            ] })
          ] }),
          /* @__PURE__ */ Ce.jsx(
            Qh,
            {
              address: h,
              icon: "home",
              title: "Billing address"
            }
          ),
          /* @__PURE__ */ Ce.jsx(
            Qh,
            {
              address: v,
              icon: "map-pin",
              title: "Shipping address"
            }
          ),
          x && /* @__PURE__ */ Ce.jsx(
            At,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(x, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ Ce.jsx(he, { name: "external-link" }),
              onClick: () => i("recharge:external:order:opened"),
              children: "View order in Recharge"
            }
          )
        ] })
      ]
    }
  );
}, UB = ({
  customerId: e,
  store: n
}) => {
  const { track: r } = In(), { useQuery: i } = bn(), {
    loading: a,
    error: o,
    data: s
  } = i(IB, {
    skip: !e,
    variables: {
      customerId: e?.toString(),
      limit: "5"
    }
  }), l = s?.Recharge?.getOrders, u = !a && l?.orders && l.orders.length > 0 ? l.orders : [];
  if (!e)
    return null;
  if (o)
    return /* @__PURE__ */ Ce.jsx(Tn, { error: o });
  const p = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/orders/processed?limit=25` : null;
  return /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Ce.jsx(O.Heading, { variant: "heading-3", children: "Customer orders" }),
      !a && /* @__PURE__ */ Ce.jsx(Mn, { variant: "success", size: "small", children: u.length })
    ] }),
    /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
      a && /* @__PURE__ */ Ce.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Ce.jsx(hn, {}) }),
      !a && u.length === 0 && /* @__PURE__ */ Ce.jsx(
        b,
        {
          justifyContent: "center",
          margin: "200 0 300 0",
          "data-testid": "widget-no-orders",
          children: /* @__PURE__ */ Ce.jsx(O.Paragraph, { color: "tertiary", children: "No orders found" })
        }
      ),
      !a && u.length > 0 && /* @__PURE__ */ Ce.jsx(b, { gap: "200", flexDirection: "column", children: u.map((d, f) => /* @__PURE__ */ Ce.jsx(
        zB,
        {
          order: d,
          isOpenByDefault: f === 0,
          store: n
        },
        `${f}-${d.id}`
      )) }),
      p && /* @__PURE__ */ Ce.jsx(
        At,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(p, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ Ce.jsx(he, { name: "external-link" }),
          onClick: () => r("recharge:external:orders:list:opened"),
          children: "View all orders in Recharge"
        }
      )
    ] })
  ] });
}, MB = ({
  customer: e
}) => {
  if (!e)
    return null;
  const {
    subscriptions_active_count: n,
    subscriptions_total_count: r
  } = e, i = r ?? 0, a = n ?? 0;
  return /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ce.jsx(O.Heading, { variant: "heading-3", children: "Subscriptions overview" }),
    /* @__PURE__ */ Ce.jsxs(Qe, { className: Oi.list, children: [
      /* @__PURE__ */ Ce.jsx(Qe.Text, { variant: "dense", className: Oi.listItem, children: /* @__PURE__ */ Ce.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Ce.jsx(O.Paragraph, { variant: "4", children: "Total subscriptions" }),
        /* @__PURE__ */ Ce.jsx(O.Paragraph, { variant: "4", children: i })
      ] }) }),
      /* @__PURE__ */ Ce.jsx(Qe.Text, { variant: "dense", className: Oi.listItem, children: /* @__PURE__ */ Ce.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Ce.jsx(O.Paragraph, { variant: "4", children: "Active subscriptions" }),
        /* @__PURE__ */ Ce.jsx(O.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] });
}, BB = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = bn(), i = e?.customer?.email, a = n.displayCustomerDetails ?? !1, o = n.displaysubscriptionOverview ?? !1, s = n.displayOrders ?? !1, l = !a && !o && !s, {
    loading: u,
    error: p,
    data: d
  } = r(wB, {
    skip: !i,
    variables: {
      email: i
    }
  }), f = !u && d ? d?.Recharge?.getCustomers?.customers?.[0] : void 0, h = !u && d ? d?.Recharge?.getStore?.store ?? void 0 : void 0;
  if (p) {
    const v = p.graphQLErrors;
    return gl({ errors: v }) ? /* @__PURE__ */ Ce.jsx(
      O.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : vl({ errors: v }) ? /* @__PURE__ */ Ce.jsx(
      O.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Recharge. Please contact your administrator."
      }
    ) : /* @__PURE__ */ Ce.jsx(Tn, { error: p });
  }
  return u ? /* @__PURE__ */ Ce.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Ce.jsx(hn, {}) }) : f ? l ? /* @__PURE__ */ Ce.jsx(
    O.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : /* @__PURE__ */ Ce.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        a && /* @__PURE__ */ Ce.jsx(PB, { customer: f, store: h }),
        o && /* @__PURE__ */ Ce.jsx(MB, { customer: f }),
        s && /* @__PURE__ */ Ce.jsx(UB, { customerId: f.id, store: h })
      ]
    }
  ) : /* @__PURE__ */ Ce.jsx(
    O.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-customer-not-found",
      children: "No data found for this customer in Recharge."
    }
  );
}, Xh = [
  {
    key: "rechargeAccessToken",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "displayCustomerDetails",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displaysubscriptionOverview",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayOrders",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], qB = {
  enabled: !1,
  name: "",
  rechargeAccessToken: "",
  displayCustomerDetails: !0,
  displaysubscriptionOverview: !0,
  displayOrders: !0
}, HB = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = dt({
    mode: "onChange",
    defaultValues: qB
  }), {
    create: l,
    update: u,
    remove: p,
    isLoading: d,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = hr({
    integrationId: e,
    integrationType: "RECHARGE",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: C,
    error: j,
    isWidgetUnknown: N,
    refetch: x,
    widgetConfiguration: g
  } = yr({
    integrationId: e,
    fieldDefinitions: Xh,
    form: s,
    onMisconfigured: v
  }), { renderConditions: P, setRenderConditions: E, renderConditionsForSubmit: I } = gr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), w = (H) => kr(H, {
    fieldDefinitions: Xh,
    isCreationMode: o,
    create: l,
    update: u,
    renderConditions: I
  }), A = s.watch("name");
  return /* @__PURE__ */ Ce.jsxs(
    vr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: w,
      error: j ?? f,
      onRetry: j ? x : void 0,
      isLoading: d || C,
      isWidgetUnknown: N,
      children: [
        h && /* @__PURE__ */ Ce.jsx(br, { cause: h }),
        /* @__PURE__ */ Ce.jsxs(tt, { children: [
          /* @__PURE__ */ Ce.jsx(ie, { children: /* @__PURE__ */ Ce.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Ce.jsx(
            Sn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ce.jsx(ie, { span: 3, children: /* @__PURE__ */ Ce.jsx(
            Gn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Ce.jsx(ie, { span: 3 }),
          /* @__PURE__ */ Ce.jsx(ie, { span: 3, children: /* @__PURE__ */ Ce.jsx(
            mi,
            {
              name: "rechargeAccessToken",
              label: "API token",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API token is required" },
              componentProps: {
                placeholder: "Insert the Admin API token for Recharge",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Ce.jsx(ie, { span: 3 }),
          /* @__PURE__ */ Ce.jsx(ie, { span: 3, children: /* @__PURE__ */ Ce.jsx(We, { label: "Displays details of a customer", children: /* @__PURE__ */ Ce.jsx(
            Sn,
            {
              name: "displayCustomerDetails",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ce.jsx(ie, { span: 3 }),
          /* @__PURE__ */ Ce.jsx(ie, { span: 3, children: /* @__PURE__ */ Ce.jsx(We, { label: "Displays the subscription overview", children: /* @__PURE__ */ Ce.jsx(
            Sn,
            {
              name: "displaysubscriptionOverview",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ce.jsx(ie, { span: 3 }),
          /* @__PURE__ */ Ce.jsx(ie, { span: 3, children: /* @__PURE__ */ Ce.jsx(We, { label: "Displays the last 5 orders", children: /* @__PURE__ */ Ce.jsx(
            Sn,
            {
              name: "displayOrders",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ce.jsx(ie, { span: 3 }),
          a && P !== null && /* @__PURE__ */ Ce.jsx(ie, { children: a({
            value: P,
            onChange: E,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ Ce.jsx(
          xr,
          {
            integrationType: "RECHARGE",
            integrationId: e,
            widgetName: A,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => p()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._wrapper_l5y5y_54{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_l5y5y_59{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_l5y5y_67{text-align:center}._inputSeparator_l5y5y_71{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_l5y5y_76{color:var(--dixa-typography-color-link)}._noIssuesFound_l5y5y_80{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._list_l5y5y_85{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_l5y5y_95{background-color:transparent;padding:var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_l5y5y_95:last-child{box-shadow:none}._listItemHighlighted_l5y5y_103{border-left:var(--dixa-size-spacer-200) solid var(--dixa-color-orange-300)}._listItemEdit_l5y5y_106{cursor:pointer}._fullWidth_l5y5y_110{width:100%}._boxWrapper_l5y5y_114{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._clickableIcon_l5y5y_120{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._list_rxh85_1{padding:0;overflow-y:auto;max-height:230px}._listItem_rxh85_6{cursor:pointer;font-size:var(--dixa-typography-size-100);background-color:transparent;padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_rxh85_6:last-child{box-shadow:none}._listItemHighlighted_rxh85_16{border-left:var(--dixa-size-spacer-200) solid var(--dixa-color-orange-300)}._modalBody_1clhs_1{width:400px}._reward_1gmba_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1gmba_1:hover{border-color:var(--dixa-color-neutral-400)}._clickable_1gmba_10{cursor:pointer}._voucherCode_1gmba_14{font-family:monospace}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var xm = { exports: {} }, oo = {}, yS;
function WB() {
  if (yS) return oo;
  yS = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return oo.Fragment = r, oo.jsx = s, oo.jsxs = s, oo;
}
var vs = {}, gS;
function KB() {
  return gS || (gS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        P("error", t, m);
      }
    }
    function P(t, c, m) {
      {
        var y = x.ReactDebugCurrentFrame, F = y.getStackAddendum();
        F !== "" && (c += "%s", m = m.concat([F]));
        var T = m.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var E = !1, I = !1, w = !1, A = !1, H = !1, Y;
    Y = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ne(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || H || t === a || t === p || t === d || A || t === v || E || I || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function W(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var F = c.displayName || c.name || "";
      return F !== "" ? m + "(" + F + ")" : m;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function D(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var m = t;
            return B(m._context) + ".Provider";
          case u:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : D(t.type) || "Memo";
          case h: {
            var F = t, T = F._payload, S = F._init;
            try {
              return D(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var M = Object.assign, Z = 0, je, ge, ye, ke, q, _e, De;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function Ye() {
      {
        if (Z === 0) {
          je = console.log, ge = console.info, ye = console.warn, ke = console.error, q = console.group, _e = console.groupCollapsed, De = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function sn() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: M({}, t, {
              value: je
            }),
            info: M({}, t, {
              value: ge
            }),
            warn: M({}, t, {
              value: ye
            }),
            error: M({}, t, {
              value: ke
            }),
            group: M({}, t, {
              value: q
            }),
            groupCollapsed: M({}, t, {
              value: _e
            }),
            groupEnd: M({}, t, {
              value: De
            })
          });
        }
        Z < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = x.ReactCurrentDispatcher, Ue;
    function Pe(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (F) {
            var y = F.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Le;
    {
      var Xe = typeof WeakMap == "function" ? WeakMap : Map;
      Le = new Xe();
    }
    function Fe(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Le.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      Be = !0;
      var F = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ye();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (re) {
              y = re;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (re) {
              y = re;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            y = re;
          }
          t();
        }
      } catch (re) {
        if (re && y && typeof re.stack == "string") {
          for (var _ = re.stack.split(`
`), ee = y.stack.split(`
`), L = _.length - 1, U = ee.length - 1; L >= 1 && U >= 0 && _[L] !== ee[U]; )
            U--;
          for (; L >= 1 && U >= 0; L--, U--)
            if (_[L] !== ee[U]) {
              if (L !== 1 || U !== 1)
                do
                  if (L--, U--, U < 0 || _[L] !== ee[U]) {
                    var ce = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && ce.includes("<anonymous>") && (ce = ce.replace("<anonymous>", t.displayName)), typeof t == "function" && Le.set(t, ce), ce;
                  }
                while (L >= 1 && U >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = F;
      }
      var ze = t ? t.displayName || t.name : "", Oe = ze ? Pe(ze) : "";
      return typeof t == "function" && Le.set(t, Oe), Oe;
    }
    function Me(t, c, m) {
      return Fe(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Fe(t, nn(t));
      if (typeof t == "string")
        return Pe(t);
      switch (t) {
        case p:
          return Pe("Suspense");
        case d:
          return Pe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return Me(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, F = y._payload, T = y._init;
            try {
              return se(T(F), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Se = {}, Ae = x.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(m);
      } else
        Ae.setExtraStackFrame(null);
    }
    function yn(t, c, m, y, F) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + m + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              _ = t[S](c, S, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Re(F), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, S, typeof _), Re(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Re(F), g("Failed %s type: %s", m, _.message), Re(null));
          }
      }
    }
    var Q = Array.isArray;
    function $(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ae(t);
    }
    var J = x.ReactCurrentOwner, de = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, xe, $e;
    function tn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && J.current;
    }
    function pn(t, c) {
      {
        var m = function() {
          xe || (xe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function Fn(t, c) {
      {
        var m = function() {
          $e || ($e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, m, y, F, T, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: F
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, m, y, F) {
      {
        var T, S = {}, _ = null, ee = null;
        m !== void 0 && (V(m), _ = "" + m), gn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ee = c.ref, on(c));
        for (T in c)
          le.call(c, T) && !de.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (T in L)
            S[T] === void 0 && (S[T] = L[T]);
        }
        if (_ || ee) {
          var U = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, U), ee && Fn(S, U);
        }
        return xn(t, _, ee, F, y, J.current, S);
      }
    }
    var en = x.ReactCurrentOwner, vn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        vn.setExtraStackFrame(m);
      } else
        vn.setExtraStackFrame(null);
    }
    var un;
    un = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = D(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Nn = {};
    function Rn(t) {
      {
        var c = jn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function kn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Rn(c);
        if (Nn[m])
          return;
        Nn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + D(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Ve(null);
      }
    }
    function _n(t, c) {
      {
        if (typeof t != "object")
          return;
        if ($(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            dn(y) && kn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var F = N(t);
          if (typeof F == "function" && F !== t.entries)
            for (var T = F.call(t), S; !(S = T.next()).done; )
              dn(S.value) && kn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = D(c);
          yn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !un) {
          un = !0;
          var F = D(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", F || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, m, y, F, T) {
      {
        var S = ne(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = Bn();
          ee ? _ += ee : _ += jn();
          var L;
          t === null ? L = "null" : $(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (D(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var U = En(t, c, m, F, T);
        if (U == null)
          return U;
        if (S) {
          var ce = c.children;
          if (ce !== void 0)
            if (y)
              if ($(ce)) {
                for (var ze = 0; ze < ce.length; ze++)
                  _n(ce[ze], t);
                Object.freeze && Object.freeze(ce);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _n(ce, t);
        }
        if (le.call(c, "key")) {
          var Oe = D(t), re = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), mn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Oe + mn]) {
            var Dn = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Oe, Dn, Oe), Cn[Oe + mn] = !0;
          }
        }
        return t === i ? Ln(U) : An(U), U;
      }
    }
    function Vn(t, c, m) {
      return wn(t, c, m, !0);
    }
    function qn(t, c, m) {
      return wn(t, c, m, !1);
    }
    var zn = qn, Wn = Vn;
    vs.Fragment = i, vs.jsx = zn, vs.jsxs = Wn;
  })()), vs;
}
var vS;
function GB() {
  return vS || (vS = 1, process.env.NODE_ENV === "production" ? xm.exports = WB() : xm.exports = KB()), xm.exports;
}
var ve = GB(), O1 = /* @__PURE__ */ ((e) => (e.CustomAction = "custom_action", e.FacebookLike = "facebook_like", e.FacebookShare = "facebook_share", e.InstagramFollow = "instagram_follow", e.Manual = "manual", e.ReferralComplete = "referral_complete", e.TiktokFollow = "tiktok_follow", e.TwitterFollow = "twitter_follow", e.TwitterShare = "twitter_share", e.VisitUrl = "visit_url", e))(O1 || {}), pa = /* @__PURE__ */ ((e) => (e.Excluded = "excluded", e.Guest = "guest", e.Member = "member", e))(pa || {});
const YB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "adjustCustomerPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "RivoLoyalty_adjust_customer_points_request_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "adjust_customer_points" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] } }] }, JB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "return_customer" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_identifier" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "StringValue", value: "lifetime_earnings_tally,next_vip_tier", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "accepts_marketing" } }, { kind: "Field", name: { kind: "Name", value: "orders_count" } }, { kind: "Field", name: { kind: "Name", value: "verified_email" } }, { kind: "Field", name: { kind: "Name", value: "total_spent" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_status" } }, { kind: "Field", name: { kind: "Name", value: "points_tally" } }, { kind: "Field", name: { kind: "Name", value: "credits_tally" } }, { kind: "Field", name: { kind: "Name", value: "vip_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "threshold" } }] } }, { kind: "Field", name: { kind: "Name", value: "points_expire_at" } }, { kind: "Field", name: { kind: "Name", value: "next_vip_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "threshold" } }, { kind: "Field", name: { kind: "Name", value: "to_spend_or_earn" } }] } }, { kind: "Field", name: { kind: "Name", value: "lifetime_earnings_tally" } }] } }] } }] } }] } }] } }] }, QB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFavoriteProducts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "list_customer_favorite_products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "data_source" }, value: { kind: "EnumValue", value: "shopify" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "product_id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "handle" } }] } }] } }] } }] } }] }, XB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPointsRedemptions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "list_points_redemptions" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "points_amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "used_at" } }, { kind: "Field", name: { kind: "Name", value: "refunded_at" } }, { kind: "Field", name: { kind: "Name", value: "revoked_at" } }] } }] } }] } }] } }] } }] }, ZB = {
  "\n  mutation adjustCustomerPoints(\n    $input: RivoLoyalty_adjust_customer_points_request_Input\n  ) {\n    RivoLoyalty {\n      adjust_customer_points(input: $input)\n    }\n  }\n": YB,
  '\n  query getCustomer($email: String!) {\n    RivoLoyalty {\n      return_customer(\n        customer_identifier: $email\n        fields: "lifetime_earnings_tally,next_vip_tier"\n      ) {\n        data {\n          attributes {\n            id\n            email\n            first_name\n            last_name\n            accepts_marketing\n            orders_count\n            verified_email\n            total_spent\n            loyalty_status\n            points_tally\n            credits_tally\n            vip_tier {\n              name\n              threshold\n            }\n            points_expire_at\n            next_vip_tier {\n              name\n              threshold\n              to_spend_or_earn\n            }\n            lifetime_earnings_tally\n          }\n        }\n      }\n    }\n  }\n': JB,
  "\n  query getFavoriteProducts($customerId: String!) {\n    RivoLoyalty {\n      list_customer_favorite_products(\n        customer_id: $customerId\n        data_source: shopify\n      ) {\n        data {\n          product_id\n          title\n          handle\n        }\n      }\n    }\n  }\n": QB,
  "\n  query getPointsRedemptions($customerId: String!) {\n    RivoLoyalty {\n      list_points_redemptions(\n        filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_: $customerId\n      ) {\n        data {\n          id\n          attributes {\n            points_amount\n            name\n            code\n            expires_at\n            used_at\n            refunded_at\n            revoked_at\n          }\n        }\n      }\n    }\n  }\n": XB
};
function Ll(e) {
  return ZB[e] ?? {};
}
const eq = Ll(
  /* GraphQL */
  `
  query getCustomer($email: String!) {
    RivoLoyalty {
      return_customer(
        customer_identifier: $email
        fields: "lifetime_earnings_tally,next_vip_tier"
      ) {
        data {
          attributes {
            id
            email
            first_name
            last_name
            accepts_marketing
            orders_count
            verified_email
            total_spent
            loyalty_status
            points_tally
            credits_tally
            vip_tier {
              name
              threshold
            }
            points_expire_at
            next_vip_tier {
              name
              threshold
              to_spend_or_earn
            }
            lifetime_earnings_tally
          }
        }
      }
    }
  }
`
), nq = Ll(
  /* GraphQL */
  `
  query getFavoriteProducts($customerId: String!) {
    RivoLoyalty {
      list_customer_favorite_products(
        customer_id: $customerId
        data_source: shopify
      ) {
        data {
          product_id
          title
          handle
        }
      }
    }
  }
`
), tq = Ll(
  /* GraphQL */
  `
  query getPointsRedemptions($customerId: String!) {
    RivoLoyalty {
      list_points_redemptions(
        filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_: $customerId
      ) {
        data {
          id
          attributes {
            points_amount
            name
            code
            expires_at
            used_at
            refunded_at
            revoked_at
          }
        }
      }
    }
  }
`
), rq = Ll(
  /* GraphQL */
  `
  mutation adjustCustomerPoints(
    $input: RivoLoyalty_adjust_customer_points_request_Input
  ) {
    RivoLoyalty {
      adjust_customer_points(input: $input)
    }
  }
`
), iq = "_list_l5y5y_85", aq = "_listItem_l5y5y_95", oq = "_listItemHighlighted_l5y5y_103", sq = "_listItemEdit_l5y5y_106", lq = "_clickableIcon_l5y5y_120", Cr = {
  list: iq,
  listItem: aq,
  listItemHighlighted: oq,
  listItemEdit: sq,
  clickableIcon: lq
}, pg = "rivoLoyaltyShopifyApiHostName", D1 = "https://admin.shopify.com";
function P1(e) {
  return e.split(".")[0];
}
const cq = "_wrapper_1xucg_1", kS = {
  wrapper: cq
}, uq = ({
  customerDetails: e,
  rivoLoyaltyShopifyApiHostName: n
}) => {
  const { track: r } = In(), { isCopied: i, copy: a } = Jt(), { attributes: o } = e, {
    first_name: s,
    last_name: l,
    email: u,
    verified_email: p
  } = o, d = 14, f = `${s || ""} ${l || ""}`.trim() || "No name found for customer";
  return /* @__PURE__ */ ve.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ve.jsxs(b, { className: kS.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ve.jsx(
      b,
      {
        justifyContent: "space-between",
        className: kS.block,
        alignItems: "center",
        children: /* @__PURE__ */ ve.jsx(O.Heading, { variant: "heading-2", children: f })
      }
    ),
    u && /* @__PURE__ */ ve.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ ve.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ ve.jsx(he, { size: d, name: "mail" }),
        /* @__PURE__ */ ve.jsx(O.ExternalLink, { href: `mailto:${u}`, children: u }),
        /* @__PURE__ */ ve.jsx(
          Ze,
          {
            content: p ? "Verified email" : "Email is not verified",
            children: /* @__PURE__ */ ve.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ve.jsx(
              he,
              {
                size: d,
                color: p ? "green.500" : "red.500",
                name: p ? "check-circle" : "exclamation"
              }
            ) })
          }
        )
      ] }),
      /* @__PURE__ */ ve.jsx(Ze, { content: "Copy Email", children: /* @__PURE__ */ ve.jsx(
        he,
        {
          size: d,
          name: i ? "done" : "copy",
          onClick: () => a(u),
          className: Cr.clickableIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ ve.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ve.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ve.jsx(he, { size: d, name: "sign-in" }),
        /* @__PURE__ */ ve.jsx(O.Paragraph, { variant: "2", children: "Marketing consent" })
      ] }),
      /* @__PURE__ */ ve.jsx(
        he,
        {
          name: o.accepts_marketing ? "check-circle-filled" : "close-circle-filled",
          color: o.accepts_marketing ? "green.500" : "neutral.500"
        }
      )
    ] }),
    /* @__PURE__ */ ve.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ ve.jsx(he, { size: d, name: "external-link" }),
      /* @__PURE__ */ ve.jsx(
        O.ExternalLink,
        {
          href: dq(n, o.id),
          target: "_blank",
          rel: "noreferrer",
          onClick: () => {
            r("rivoloyalty:customer:clicked", {});
          },
          children: "View customer in Rivo Loyalty"
        }
      )
    ] })
  ] }) });
};
function dq(e, n) {
  const r = P1(e);
  return `${D1}/store/${r}/apps/rivo-loyalty/customers/${n}`;
}
const mq = "_list_rxh85_1", pq = "_listItem_rxh85_6", bS = {
  list: mq,
  listItem: pq
}, fq = ({
  customerId: e,
  rivoLoyaltyShopifyApiHostName: n
}) => {
  const { useQuery: r } = bn(), {
    loading: i,
    error: a,
    data: o
  } = r(nq, {
    skip: !e,
    variables: {
      customerId: e?.toString()
    }
  }), s = !i && o ? o.RivoLoyalty?.list_customer_favorite_products?.data ?? [] : [], l = 14, u = () => a ? /* @__PURE__ */ ve.jsx(Tn, { error: a }) : i ? /* @__PURE__ */ ve.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ ve.jsx(hn, {}) }) : s.length === 0 ? /* @__PURE__ */ ve.jsx(O.Paragraph, { variant: "4", color: "secondary", children: "No favorite products found." }) : /* @__PURE__ */ ve.jsx(Qe, { className: bS.list, children: s.map((p) => /* @__PURE__ */ ve.jsxs(
    b,
    {
      alignItems: "center",
      gap: "200",
      className: bS.listItem,
      children: [
        /* @__PURE__ */ ve.jsx(he, { size: l, name: "external-link" }),
        /* @__PURE__ */ ve.jsx(
          O.ExternalLink,
          {
            href: hq(
              n,
              p.product_id
            ),
            target: "_blank",
            rel: "noreferrer",
            children: p.title
          }
        )
      ]
    },
    p.product_id
  )) });
  return /* @__PURE__ */ ve.jsx(ve.Fragment, { children: /* @__PURE__ */ ve.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ve.jsx(O.Heading, { variant: "heading-3", children: "Favorite products" }),
    u()
  ] }) });
};
function hq(e, n) {
  const r = P1(e);
  return `${D1}/store/${r}/products/${n}`;
}
const yq = "_modalBody_1clhs_1", gq = {
  modalBody: yq
};
function vq(e, n) {
  if (isNaN(e))
    return "Points can not be empty";
  if (e < n.min)
    return `Points cannot be below ${n.min}`;
  if (e > n.max)
    return `Points can not exceed ${n.max}`;
}
function kq(e, n) {
  if (e === n)
    return "Change the value to update the points";
}
const bq = O1, ks = {
  addPoints: {
    successEventName: "rivoloyalty:points:add:succeeded",
    successEventText: "Added points successfully",
    failEventName: "rivoloyalty:points:add:failed",
    failEventText: "Failed to add points, try again later."
  },
  removePoints: {
    successEventName: "rivoloyalty:points:remove:succeeded",
    successEventText: "Removed points successfully",
    failEventName: "rivoloyalty:points:remove:failed",
    failEventText: "Failed to remove points, try again later."
  }
}, xq = ({
  customerIdentifier: e,
  isOpen: n,
  points: r,
  onClose: i,
  refetchCustomerData: a
}) => {
  const { useMutation: o, showNotification: s } = bn(), { track: l } = In(), [u, p] = ue(r), [d, f] = ue(""), [h, v] = ue(!0), [C, j] = ue(), N = {
    min: 0,
    max: 1e5
  }, [x, { loading: g }] = o(
    rq,
    {
      onCompleted: () => {
        const ne = u > r ? ks.addPoints : ks.removePoints;
        s({
          title: "Success",
          text: ne.successEventText,
          icon: "check-circle-filled",
          severity: "success"
        }), l(ne.successEventName), Y();
      }
    }
  ), P = () => {
    p(r), f(""), v(!0), j(void 0);
  };
  Je(() => {
    n && P();
  }, [n]);
  const E = !!C, I = vq(u, N), w = kq(r, u), A = () => {
    if (u !== r) {
      const ne = u > r ? ks.addPoints : ks.removePoints, W = !h;
      x({
        variables: {
          input: {
            // eslint-disable-next-line camelcase
            points_amount: u - r,
            // eslint-disable-next-line camelcase
            ...d && { internal_note: d },
            // eslint-disable-next-line camelcase
            customer_identifier: e?.toString(),
            source: bq.Manual,
            // eslint-disable-next-line camelcase
            skip_email: W
          }
        }
      }).catch(() => {
        l(ne.failEventName), j([ne.failEventText]);
      });
    }
  }, H = () => {
    P(), i();
  }, Y = () => {
    a(), H();
  };
  return /* @__PURE__ */ ve.jsxs(
    Ct,
    {
      isOpen: n,
      onClose: H,
      "data-testid": "rivo-loyalty-change-points-modal",
      children: [
        /* @__PURE__ */ ve.jsx(It, { title: "Change points", onClose: H }),
        /* @__PURE__ */ ve.jsxs(Ft, { className: gq.modalBody, children: [
          /* @__PURE__ */ ve.jsxs(tt, { children: [
            /* @__PURE__ */ ve.jsx(ie, { span: 6, "data-testid": "rivo-loyalty-points-input", children: /* @__PURE__ */ ve.jsx(
              tr,
              {
                label: "New points balance",
                type: "number",
                placeholder: "Insert points balance",
                min: N.min,
                max: N.max,
                meta: {
                  error: I,
                  warning: w
                },
                input: {
                  name: "points",
                  value: u.toString(),
                  onChange: (ne) => p(ne?.target.valueAsNumber ?? 0)
                }
              }
            ) }),
            /* @__PURE__ */ ve.jsx(ie, { span: 6, children: /* @__PURE__ */ ve.jsx(
              tr,
              {
                label: "Internal note",
                placeholder: "Insert an internal note (optional)",
                input: {
                  name: "internalNote",
                  value: d,
                  onChange: (ne) => f(ne?.target.value ?? "")
                }
              }
            ) }),
            /* @__PURE__ */ ve.jsx(ie, { span: 6, children: /* @__PURE__ */ ve.jsx(We, { label: "Notify the customer by email", children: /* @__PURE__ */ ve.jsx(
              xl,
              {
                input: {
                  name: "sendEmail",
                  value: "sendEmail",
                  checked: h,
                  onChange: () => v(!h)
                }
              }
            ) }) })
          ] }),
          !g && E && /* @__PURE__ */ ve.jsx(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ ve.jsx(Qe, { children: C?.map((ne, W) => /* @__PURE__ */ ve.jsx(
            Qe.Item,
            {
              variant: "dense",
              title: ne,
              contentLeft: /* @__PURE__ */ ve.jsx(
                he,
                {
                  color: "red.500",
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            W
          )) }) })
        ] }),
        /* @__PURE__ */ ve.jsx(
          Vt,
          {
            confirmName: "Save",
            confirmOnClick: () => A(),
            confirmProps: {
              isLoading: g,
              loadingIndicator: /* @__PURE__ */ ve.jsx(hn, { size: 16 }),
              disabled: !!(I || w)
            },
            cancelOnClick: H
          }
        )
      ]
    }
  );
}, Zi = ({
  description: e,
  content: n,
  tooltip: r,
  isHighlighted: i = !1
}) => {
  if (n == null)
    return null;
  const a = uw(n);
  return /* @__PURE__ */ ve.jsx(
    Qe.Text,
    {
      variant: "dense",
      className: ut(Cr.listItem, {
        [Cr.listItemHighlighted]: i
      }),
      children: /* @__PURE__ */ ve.jsx(Ze, { content: r, children: /* @__PURE__ */ ve.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ ve.jsx(O.Paragraph, { variant: "4", children: e }),
        a ? n : Pi(n)
      ] }) })
    }
  );
}, xS = {
  [pa.Guest]: {
    name: "Guest",
    tooltip: "Customers who can participate in your loyalty program without creating a full account. They can earn and redeem points through email verification or one-time codes.",
    badgeColor: "info"
  },
  [pa.Member]: {
    name: "Member",
    tooltip: "Customers who have activated their loyalty membership and have full access to all program features, including account dashboards and advanced features.",
    badgeColor: "success"
  },
  [pa.Excluded]: {
    name: "Excluded",
    tooltip: "Customers who have been excluded from the loyalty program (typically through the “Rivo Excluded” tag or manual exclusion).",
    badgeColor: "warning"
  }
}, _q = ({
  customer: e,
  allowAdjustLoyaltyPoints: n,
  refetchCustomerData: r
}) => {
  const { attributes: i } = e, a = i.loyalty_status ? xS[i.loyalty_status] : xS[pa.Guest], o = a?.name === pa.Excluded, s = i.lifetime_earnings_tally, l = i.total_spent ?? 0, u = i.points_tally ?? 0, p = i.next_vip_tier, d = i.next_vip_tier?.to_spend_or_earn, f = p?.name ?? "None", [h, v] = ue(!1), C = 10, j = () => /* @__PURE__ */ ve.jsx(
    Qe.Text,
    {
      variant: "dense",
      className: ut(Cr.listItem),
      children: /* @__PURE__ */ ve.jsx(Ze, { content: a.tooltip, children: /* @__PURE__ */ ve.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ ve.jsx(O.Paragraph, { variant: "4", children: "Loyalty status" }),
        /* @__PURE__ */ ve.jsx(Mn, { variant: a.badgeColor, size: "small", children: a.name })
      ] }) })
    }
  ), N = () => o ? j() : /* @__PURE__ */ ve.jsxs(ve.Fragment, { children: [
    /* @__PURE__ */ ve.jsx(
      Qe.Text,
      {
        variant: "dense",
        className: ut(
          Cr.listItem,
          Cr.listItemHighlighted,
          {
            [Cr.listItemEdit]: n
          }
        ),
        onClick: () => n ? v(!0) : void 0,
        children: /* @__PURE__ */ ve.jsx(Ze, { content: "The current balance of loyalty points for the customer.", children: /* @__PURE__ */ ve.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ ve.jsx(O.Paragraph, { variant: "4", children: "Points balance" }),
          /* @__PURE__ */ ve.jsxs(
            b,
            {
              alignItems: "center",
              justifyContent: "space-between",
              gap: "100",
              children: [
                n && /* @__PURE__ */ ve.jsx(
                  he,
                  {
                    name: "pen",
                    size: C,
                    "aria-label": "Edit points"
                  }
                ),
                /* @__PURE__ */ ve.jsx(O.Paragraph, { variant: "4", children: Pi(u) })
              ]
            }
          )
        ] }) })
      }
    ),
    d != null && f && /* @__PURE__ */ ve.jsx(
      Zi,
      {
        description: `Points until ${f} tier`,
        tooltip: `Loyalty points until the customer advances to ${f} tier`,
        content: d
      }
    ),
    /* @__PURE__ */ ve.jsx(
      Zi,
      {
        description: "Points expiry date",
        tooltip: "The timestamp when the customer's loyalty points are set to expire.",
        content: i.points_expire_at ?? "No expiry"
      }
    ),
    /* @__PURE__ */ ve.jsx(
      Zi,
      {
        description: "Total points earned",
        tooltip: "The total number of loyalty points earned by the customer.",
        content: s
      }
    ),
    /* @__PURE__ */ ve.jsx(
      Zi,
      {
        description: "Total points spent",
        tooltip: "The total number of loyalty points spent by the customer.",
        content: l
      }
    ),
    j(),
    /* @__PURE__ */ ve.jsx(
      Zi,
      {
        description: "VIP tier",
        tooltip: "The name of the customer's current VIP tier status.",
        content: i.vip_tier?.name ?? "None"
      }
    ),
    /* @__PURE__ */ ve.jsx(
      Zi,
      {
        description: "Next VIP tier",
        tooltip: "The name of the customer's next VIP tier status.",
        content: f
      }
    )
  ] });
  return /* @__PURE__ */ ve.jsxs(ve.Fragment, { children: [
    /* @__PURE__ */ ve.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ ve.jsx(O.Heading, { variant: "heading-3", children: "Loyalty" }),
      /* @__PURE__ */ ve.jsx(Qe, { className: Cr.list, children: N() })
    ] }),
    /* @__PURE__ */ ve.jsx(
      xq,
      {
        customerIdentifier: i.id,
        isOpen: h,
        points: u,
        onClose: () => v(!1),
        refetchCustomerData: r
      }
    )
  ] });
}, Sq = ({
  ordersCount: e
}) => /* @__PURE__ */ ve.jsx(ve.Fragment, { children: /* @__PURE__ */ ve.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ ve.jsx(O.Heading, { variant: "heading-3", children: "Orders overview" }),
  /* @__PURE__ */ ve.jsx(Qe, { className: Cr.list, children: /* @__PURE__ */ ve.jsx(Qe.Text, { variant: "dense", className: Cr.listItem, children: /* @__PURE__ */ ve.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ ve.jsx(O.Paragraph, { variant: "4", children: "Total orders" }),
    /* @__PURE__ */ ve.jsx(O.Paragraph, { variant: "4", children: e ?? 0 })
  ] }) }) })
] }) }), Nq = "_reward_1gmba_1", jq = "_voucherCode_1gmba_14", _S = {
  reward: Nq,
  voucherCode: jq
}, wq = ({
  pointsRedemption: e
}) => {
  const { isCopied: n, copy: r } = Jt(), {
    name: i,
    code: a,
    points_amount: o
  } = e.attributes;
  return /* @__PURE__ */ ve.jsx(b, { gap: "100", flexDirection: "column", children: /* @__PURE__ */ ve.jsxs(b, { gap: "100", flexDirection: "column", className: _S.reward, children: [
    /* @__PURE__ */ ve.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ ve.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ ve.jsx(he, { name: "star", size: 12, color: "neutral.500" }),
        i
      ] }),
      /* @__PURE__ */ ve.jsxs(Mn, { size: "small", variant: "info", children: [
        o ?? 0,
        " points"
      ] })
    ] }),
    /* @__PURE__ */ ve.jsxs(
      b,
      {
        gap: "100",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ ve.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", children: [
            /* @__PURE__ */ ve.jsx(he, { size: 14, name: "tag" }),
            /* @__PURE__ */ ve.jsx(b, { children: /* @__PURE__ */ ve.jsx(O.Paragraph, { variant: "4", className: _S.voucherCode, children: a }) })
          ] }),
          /* @__PURE__ */ ve.jsx(Ze, { content: "Copy reward code", children: /* @__PURE__ */ ve.jsx(
            he,
            {
              size: 14,
              name: n ? "done" : "copy",
              className: Cr.clickableIcon,
              onClick: () => r(a)
            }
          ) })
        ]
      }
    )
  ] }) });
}, Cq = ({
  customer: e
}) => {
  const { useQuery: n } = bn(), {
    loading: r,
    error: i,
    data: a
  } = n(tq, {
    skip: !e,
    variables: {
      customerId: e.attributes.id.toString()
    }
  }), o = (!r && e && a ? a?.RivoLoyalty?.list_points_redemptions?.data ?? [] : []).filter(
    ({ attributes: l }) => Iq({
      usedAt: l.used_at,
      revokedAt: l.revoked_at,
      refundedAt: l.refunded_at
    }) === "Issued"
  ), s = () => i ? /* @__PURE__ */ ve.jsx(Tn, { error: i }) : r ? /* @__PURE__ */ ve.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ ve.jsx(hn, {}) }) : o.length > 0 ? /* @__PURE__ */ ve.jsx(b, { gap: "200", flexDirection: "column", children: o.map((l) => /* @__PURE__ */ ve.jsx(
    wq,
    {
      pointsRedemption: l
    },
    l.id
  )) }) : /* @__PURE__ */ ve.jsx(O.Paragraph, { variant: "4", color: "secondary", children: "No loyalty rewards found." });
  return /* @__PURE__ */ ve.jsx(ve.Fragment, { children: /* @__PURE__ */ ve.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ve.jsx(O.Heading, { variant: "heading-3", children: "Available rewards" }),
    s()
  ] }) });
};
function Iq(e) {
  return e.usedAt ? "Used" : e.revokedAt ? "Revoked" : e.refundedAt ? "Refunded" : "Issued";
}
const Fq = (e) => {
  const { conversationContext: n, settings: r } = e, {
    rivoLoyaltyShowOrders: i,
    rivoLoyaltyShowLoyalty: a,
    rivoLoyaltyAdjustLoyaltyPoints: o,
    rivoLoyaltyShowFavoriteProducts: s,
    rivoLoyaltyShowPointsRedemptions: l
  } = r, u = r[pg].toString(), { useQuery: p } = bn(), { track: d } = In(), [f, h] = ue(!1), v = n?.customer?.email, {
    loading: C,
    error: j,
    data: N,
    refetch: x
  } = p(eq, {
    skip: !v,
    variables: {
      email: v
    }
  }), g = !C && N ? N.RivoLoyalty?.return_customer?.data : void 0;
  Je(() => {
    !C && g && !f && (d("rivoloyalty:customer:received"), h(!0));
  }, [C, g]);
  const P = () => /* @__PURE__ */ ve.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ ve.jsx(O.Paragraph, { variant: "4", color: "secondary", children: "No customer profile found." }) });
  if (j) {
    const E = j.graphQLErrors;
    return ba({ errors: E }) ? P() : gl({ errors: E }) ? /* @__PURE__ */ ve.jsx(
      O.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : vl({ errors: E }) ? /* @__PURE__ */ ve.jsx(
      O.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Rivo Loyalty. Please contact your administrator."
      }
    ) : /* @__PURE__ */ ve.jsx(Tn, { error: j });
  }
  return C ? /* @__PURE__ */ ve.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ ve.jsx(hn, {}) }) : !v || !g ? P() : /* @__PURE__ */ ve.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ ve.jsx(
          uq,
          {
            customerDetails: g,
            rivoLoyaltyShopifyApiHostName: u
          }
        ),
        i && /* @__PURE__ */ ve.jsx(
          Sq,
          {
            ordersCount: g.attributes?.orders_count ?? 0
          }
        ),
        a && /* @__PURE__ */ ve.jsx(
          _q,
          {
            customer: g,
            refetchCustomerData: x,
            allowAdjustLoyaltyPoints: !!o
          }
        ),
        s && /* @__PURE__ */ ve.jsx(
          fq,
          {
            customerId: g.attributes.id,
            rivoLoyaltyShopifyApiHostName: u
          }
        ),
        l && /* @__PURE__ */ ve.jsx(Cq, { customer: g })
      ]
    }
  );
};
var qo = (e) => e.type === "checkbox", Fi = (e) => e instanceof Date, Yt = (e) => e == null;
const R1 = (e) => typeof e == "object";
var vt = (e) => !Yt(e) && !Array.isArray(e) && R1(e) && !Fi(e), A1 = (e) => vt(e) && e.target ? qo(e.target) ? e.target.checked : e.target.value : e, Eq = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, L1 = (e, n) => e.has(Eq(n)), $q = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return vt(n) && n.hasOwnProperty("isPrototypeOf");
}, fg = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Dt(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(fg && (e instanceof Blob || i)) && (r || vt(e)))
    if (n = r ? [] : {}, !r && !$q(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = Dt(e[a]));
  else
    return e;
  return n;
}
var Vl = (e) => Array.isArray(e) ? e.filter(Boolean) : [], yt = (e) => e === void 0, an = (e, n, r) => {
  if (!n || !vt(e))
    return r;
  const i = Vl(n.split(/[,[\].]+?/)).reduce((a, o) => Yt(a) ? a : a[o], e);
  return yt(i) || i === e ? yt(e[n]) ? r : e[n] : i;
}, sr = (e) => typeof e == "boolean", hg = (e) => /^\w*$/.test(e), V1 = (e) => Vl(e.replace(/["|']|\]/g, "").split(/\.|\[/)), at = (e, n, r) => {
  let i = -1;
  const a = hg(n) ? [n] : V1(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let u = r;
    if (i !== s) {
      const p = e[l];
      u = vt(p) || Array.isArray(p) ? p : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = u, e = e[l];
  }
};
const ml = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, Ir = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Xr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, Tq = qe.createContext(null), yg = () => qe.useContext(Tq);
var z1 = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== Ir.all && (n._proxyFormState[s] = !i || Ir.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function Oq(e) {
  const n = yg(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = qe.useState(r._formState), u = qe.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), p = qe.useRef(a);
  return p.current = a, qe.useEffect(() => r._subscribe({
    name: p.current,
    formState: u.current,
    exact: o,
    callback: (d) => {
      !i && l({
        ...r._formState,
        ...d
      });
    }
  }), [r, i, o]), qe.useEffect(() => {
    u.current.isValid && r._setValid(!0);
  }, [r]), qe.useMemo(() => z1(s, r, u.current, !1), [s, r]);
}
var zr = (e) => typeof e == "string", U1 = (e, n, r, i, a) => zr(e) ? (i && n.watch.add(e), an(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), an(r, o))) : (i && (n.watchAll = !0), r);
function Dq(e) {
  const n = yg(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = qe.useRef(i), u = qe.useRef(a);
  l.current = i, qe.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && d(U1(l.current, r._names, f.values || r._formValues, !1, u.current))
  }), [r, o, s]);
  const [p, d] = qe.useState(r._getWatch(i, a));
  return qe.useEffect(() => r._removeUnmounted()), p;
}
function Pq(e) {
  const n = yg(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = L1(a._names.array, r), l = Dq({
    control: a,
    name: r,
    defaultValue: an(a._formValues, r, an(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), u = Oq({
    control: a,
    name: r,
    exact: !0
  }), p = qe.useRef(e), d = qe.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...sr(e.disabled) ? { disabled: e.disabled } : {}
  })), f = qe.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!an(u.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!an(u.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!an(u.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!an(u.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => an(u.errors, r)
    }
  }), [u, r]), h = qe.useCallback((N) => d.current.onChange({
    target: {
      value: A1(N),
      name: r
    },
    type: ml.CHANGE
  }), [r]), v = qe.useCallback(() => d.current.onBlur({
    target: {
      value: an(a._formValues, r),
      name: r
    },
    type: ml.BLUR
  }), [r, a._formValues]), C = qe.useCallback((N) => {
    const x = an(a._fields, r);
    x && N && (x._f.ref = {
      focus: () => N.focus(),
      select: () => N.select(),
      setCustomValidity: (g) => N.setCustomValidity(g),
      reportValidity: () => N.reportValidity()
    });
  }, [a._fields, r]), j = qe.useMemo(() => ({
    name: r,
    value: l,
    ...sr(i) || u.disabled ? { disabled: u.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: C
  }), [r, i, u.disabled, h, v, C, l]);
  return qe.useEffect(() => {
    const N = a._options.shouldUnregister || o;
    a.register(r, {
      ...p.current.rules,
      ...sr(p.current.disabled) ? { disabled: p.current.disabled } : {}
    });
    const x = (g, P) => {
      const E = an(a._fields, g);
      E && E._f && (E._f.mount = P);
    };
    if (x(r, !0), N) {
      const g = Dt(an(a._options.defaultValues, r));
      at(a._defaultValues, r, g), yt(an(a._formValues, r)) && at(a._formValues, r, g);
    }
    return !s && a.register(r), () => {
      (s ? N && !a._state.action : N) ? a.unregister(r) : x(r, !1);
    };
  }, [r, a, s, o]), qe.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), qe.useMemo(() => ({
    field: j,
    formState: u,
    fieldState: f
  }), [j, u, f]);
}
var Rq = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, No = (e) => Array.isArray(e) ? e : [e], SS = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Zh = (e) => Yt(e) || !R1(e);
function di(e, n) {
  if (Zh(e) || Zh(n))
    return e === n;
  if (Fi(e) && Fi(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (Fi(o) && Fi(s) || vt(o) && vt(s) || Array.isArray(o) && Array.isArray(s) ? !di(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Kt = (e) => vt(e) && !Object.keys(e).length, gg = (e) => e.type === "file", Fr = (e) => typeof e == "function", pl = (e) => {
  if (!fg)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, M1 = (e) => e.type === "select-multiple", vg = (e) => e.type === "radio", Aq = (e) => vg(e) || qo(e), _m = (e) => pl(e) && e.isConnected;
function Lq(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = yt(e) ? i++ : e[n[i++]];
  return e;
}
function Vq(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !yt(e[n]))
      return !1;
  return !0;
}
function Nt(e, n) {
  const r = Array.isArray(n) ? n : hg(n) ? [n] : V1(n), i = r.length === 1 ? e : Lq(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (vt(i) && Kt(i) || Array.isArray(i) && Vq(i)) && Nt(e, r.slice(0, -1)), e;
}
var B1 = (e) => {
  for (const n in e)
    if (Fr(e[n]))
      return !0;
  return !1;
};
function fl(e, n = {}) {
  const r = Array.isArray(e);
  if (vt(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || vt(e[i]) && !B1(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, fl(e[i], n[i])) : Yt(e[i]) || (n[i] = !0);
  return n;
}
function q1(e, n, r) {
  const i = Array.isArray(e);
  if (vt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || vt(e[a]) && !B1(e[a]) ? yt(n) || Zh(r[a]) ? r[a] = Array.isArray(e[a]) ? fl(e[a], []) : { ...fl(e[a]) } : q1(e[a], Yt(n) ? {} : n[a], r[a]) : r[a] = !di(e[a], n[a]);
  return r;
}
var so = (e, n) => q1(e, n, fl(n));
const NS = {
  value: !1,
  isValid: !1
}, jS = { value: !0, isValid: !0 };
var H1 = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !yt(e[0].attributes.value) ? yt(e[0].value) || e[0].value === "" ? jS : { value: e[0].value, isValid: !0 } : jS
    ) : NS;
  }
  return NS;
}, W1 = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => yt(e) ? e : n ? e === "" ? NaN : e && +e : r && zr(e) ? new Date(e) : i ? i(e) : e;
const wS = {
  isValid: !1,
  value: null
};
var K1 = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, wS) : wS;
function CS(e) {
  const n = e.ref;
  return gg(n) ? n.files : vg(n) ? K1(e.refs).value : M1(n) ? [...n.selectedOptions].map(({ value: r }) => r) : qo(n) ? H1(e.refs).value : W1(yt(n.value) ? e.ref.value : n.value, e);
}
var zq = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = an(n, o);
    s && at(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, hl = (e) => e instanceof RegExp, lo = (e) => yt(e) ? e : hl(e) ? e.source : vt(e) ? hl(e.value) ? e.value.source : e.value : e, IS = (e) => ({
  isOnSubmit: !e || e === Ir.onSubmit,
  isOnBlur: e === Ir.onBlur,
  isOnChange: e === Ir.onChange,
  isOnAll: e === Ir.all,
  isOnTouch: e === Ir.onTouched
});
const FS = "AsyncFunction";
var Uq = (e) => !!e && !!e.validate && !!(Fr(e.validate) && e.validate.constructor.name === FS || vt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === FS)), Mq = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), ES = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const jo = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = an(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (jo(l, n))
          break;
      } else if (vt(l) && jo(l, n))
        break;
    }
  }
};
function $S(e, n, r) {
  const i = an(e, r);
  if (i || hg(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = an(n, o), l = an(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var Bq = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Kt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || Ir.all));
}, qq = (e, n, r) => !e || !n || e === n || No(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), Hq = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, Wq = (e, n) => !Vl(an(e, n)).length && Nt(e, n), Kq = (e, n, r) => {
  const i = No(an(e, r));
  return at(i, "root", n[r]), at(e, r, i), e;
}, Us = (e) => zr(e);
function TS(e, n, r = "validate") {
  if (Us(e) || Array.isArray(e) && e.every(Us) || sr(e) && !e)
    return {
      type: r,
      message: Us(e) ? e : "",
      ref: n
    };
}
var ea = (e) => vt(e) && !hl(e) ? e : {
  value: e,
  message: ""
}, OS = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: u, maxLength: p, minLength: d, min: f, max: h, pattern: v, validate: C, name: j, valueAsNumber: N, mount: x } = e._f, g = an(r, j);
  if (!x || n.has(j))
    return {};
  const P = l ? l[0] : s, E = (B) => {
    a && P.reportValidity && (P.setCustomValidity(sr(B) ? "" : B || ""), P.reportValidity());
  }, I = {}, w = vg(s), A = qo(s), H = w || A, Y = (N || gg(s)) && yt(s.value) && yt(g) || pl(s) && s.value === "" || g === "" || Array.isArray(g) && !g.length, ne = Rq.bind(null, j, i, I), W = (B, D, M, Z = Xr.maxLength, je = Xr.minLength) => {
    const ge = B ? D : M;
    I[j] = {
      type: B ? Z : je,
      message: ge,
      ref: s,
      ...ne(B ? Z : je, ge)
    };
  };
  if (o ? !Array.isArray(g) || !g.length : u && (!H && (Y || Yt(g)) || sr(g) && !g || A && !H1(l).isValid || w && !K1(l).isValid)) {
    const { value: B, message: D } = Us(u) ? { value: !!u, message: u } : ea(u);
    if (B && (I[j] = {
      type: Xr.required,
      message: D,
      ref: P,
      ...ne(Xr.required, D)
    }, !i))
      return E(D), I;
  }
  if (!Y && (!Yt(f) || !Yt(h))) {
    let B, D;
    const M = ea(h), Z = ea(f);
    if (!Yt(g) && !isNaN(g)) {
      const je = s.valueAsNumber || g && +g;
      Yt(M.value) || (B = je > M.value), Yt(Z.value) || (D = je < Z.value);
    } else {
      const je = s.valueAsDate || new Date(g), ge = (q) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + q), ye = s.type == "time", ke = s.type == "week";
      zr(M.value) && g && (B = ye ? ge(g) > ge(M.value) : ke ? g > M.value : je > new Date(M.value)), zr(Z.value) && g && (D = ye ? ge(g) < ge(Z.value) : ke ? g < Z.value : je < new Date(Z.value));
    }
    if ((B || D) && (W(!!B, M.message, Z.message, Xr.max, Xr.min), !i))
      return E(I[j].message), I;
  }
  if ((p || d) && !Y && (zr(g) || o && Array.isArray(g))) {
    const B = ea(p), D = ea(d), M = !Yt(B.value) && g.length > +B.value, Z = !Yt(D.value) && g.length < +D.value;
    if ((M || Z) && (W(M, B.message, D.message), !i))
      return E(I[j].message), I;
  }
  if (v && !Y && zr(g)) {
    const { value: B, message: D } = ea(v);
    if (hl(B) && !g.match(B) && (I[j] = {
      type: Xr.pattern,
      message: D,
      ref: s,
      ...ne(Xr.pattern, D)
    }, !i))
      return E(D), I;
  }
  if (C) {
    if (Fr(C)) {
      const B = await C(g, r), D = TS(B, P);
      if (D && (I[j] = {
        ...D,
        ...ne(Xr.validate, D.message)
      }, !i))
        return E(D.message), I;
    } else if (vt(C)) {
      let B = {};
      for (const D in C) {
        if (!Kt(B) && !i)
          break;
        const M = TS(await C[D](g, r), P, D);
        M && (B = {
          ...M,
          ...ne(D, M.message)
        }, E(M.message), i && (I[j] = B));
      }
      if (!Kt(B) && (I[j] = {
        ref: P,
        ...B
      }, !i))
        return I;
    }
  }
  return E(!0), I;
};
const Gq = {
  mode: Ir.onSubmit,
  reValidateMode: Ir.onChange,
  shouldFocusError: !0
};
function Yq(e = {}) {
  let n = {
    ...Gq,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Fr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = vt(n.defaultValues) || vt(n.values) ? Dt(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : Dt(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, u, p = 0;
  const d = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...d
  };
  const h = {
    array: SS(),
    state: SS()
  }, v = IS(n.mode), C = IS(n.reValidateMode), j = n.criteriaMode === Ir.all, N = (Q) => ($) => {
    clearTimeout(p), p = setTimeout(Q, $);
  }, x = async (Q) => {
    if (!n.disabled && (d.isValid || f.isValid || Q)) {
      const $ = n.resolver ? Kt((await Y()).errors) : await W(i, !0);
      $ !== r.isValid && h.state.next({
        isValid: $
      });
    }
  }, g = (Q, $) => {
    !n.disabled && (d.isValidating || d.validatingFields || f.isValidating || f.validatingFields) && ((Q || Array.from(l.mount)).forEach((z) => {
      z && ($ ? at(r.validatingFields, z, $) : Nt(r.validatingFields, z));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Kt(r.validatingFields)
    }));
  }, P = (Q, $ = [], z, X, ae = !0, V = !0) => {
    if (X && z && !n.disabled) {
      if (s.action = !0, V && Array.isArray(an(i, Q))) {
        const J = z(an(i, Q), X.argA, X.argB);
        ae && at(i, Q, J);
      }
      if (V && Array.isArray(an(r.errors, Q))) {
        const J = z(an(r.errors, Q), X.argA, X.argB);
        ae && at(r.errors, Q, J), Wq(r.errors, Q);
      }
      if ((d.touchedFields || f.touchedFields) && V && Array.isArray(an(r.touchedFields, Q))) {
        const J = z(an(r.touchedFields, Q), X.argA, X.argB);
        ae && at(r.touchedFields, Q, J);
      }
      (d.dirtyFields || f.dirtyFields) && (r.dirtyFields = so(a, o)), h.state.next({
        name: Q,
        isDirty: D(Q, $),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      at(o, Q, $);
  }, E = (Q, $) => {
    at(r.errors, Q, $), h.state.next({
      errors: r.errors
    });
  }, I = (Q) => {
    r.errors = Q, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, w = (Q, $, z, X) => {
    const ae = an(i, Q);
    if (ae) {
      const V = an(o, Q, yt(z) ? an(a, Q) : z);
      yt(V) || X && X.defaultChecked || $ ? at(o, Q, $ ? V : CS(ae._f)) : je(Q, V), s.mount && x();
    }
  }, A = (Q, $, z, X, ae) => {
    let V = !1, J = !1;
    const de = {
      name: Q
    };
    if (!n.disabled) {
      if (!z || X) {
        (d.isDirty || f.isDirty) && (J = r.isDirty, r.isDirty = de.isDirty = D(), V = J !== de.isDirty);
        const xe = di(an(a, Q), $);
        J = !!an(r.dirtyFields, Q), xe ? Nt(r.dirtyFields, Q) : at(r.dirtyFields, Q, !0), de.dirtyFields = r.dirtyFields, V = V || (d.dirtyFields || f.dirtyFields) && J !== !xe;
      }
      if (z) {
        const xe = an(r.touchedFields, Q);
        xe || (at(r.touchedFields, Q, z), de.touchedFields = r.touchedFields, V = V || (d.touchedFields || f.touchedFields) && xe !== z);
      }
      V && ae && h.state.next(de);
    }
    return V ? de : {};
  }, H = (Q, $, z, X) => {
    const ae = an(r.errors, Q), V = (d.isValid || f.isValid) && sr($) && r.isValid !== $;
    if (n.delayError && z ? (u = N(() => E(Q, z)), u(n.delayError)) : (clearTimeout(p), u = null, z ? at(r.errors, Q, z) : Nt(r.errors, Q)), (z ? !di(ae, z) : ae) || !Kt(X) || V) {
      const J = {
        ...X,
        ...V && sr($) ? { isValid: $ } : {},
        errors: r.errors,
        name: Q
      };
      r = {
        ...r,
        ...J
      }, h.state.next(J);
    }
  }, Y = async (Q) => {
    g(Q, !0);
    const $ = await n.resolver(o, n.context, zq(Q || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return g(Q), $;
  }, ne = async (Q) => {
    const { errors: $ } = await Y(Q);
    if (Q)
      for (const z of Q) {
        const X = an($, z);
        X ? at(r.errors, z, X) : Nt(r.errors, z);
      }
    else
      r.errors = $;
    return $;
  }, W = async (Q, $, z = {
    valid: !0
  }) => {
    for (const X in Q) {
      const ae = Q[X];
      if (ae) {
        const { _f: V, ...J } = ae;
        if (V) {
          const de = l.array.has(V.name), xe = ae._f && Uq(ae._f);
          xe && d.validatingFields && g([X], !0);
          const $e = await OS(ae, l.disabled, o, j, n.shouldUseNativeValidation && !$, de);
          if (xe && d.validatingFields && g([X]), $e[V.name] && (z.valid = !1, $))
            break;
          !$ && (an($e, V.name) ? de ? Kq(r.errors, $e, V.name) : at(r.errors, V.name, $e[V.name]) : Nt(r.errors, V.name));
        }
        !Kt(J) && await W(J, $, z);
      }
    }
    return z.valid;
  }, B = () => {
    for (const Q of l.unMount) {
      const $ = an(i, Q);
      $ && ($._f.refs ? $._f.refs.every((z) => !_m(z)) : !_m($._f.ref)) && Be(Q);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, D = (Q, $) => !n.disabled && (Q && $ && at(o, Q, $), !di(De(), a)), M = (Q, $, z) => U1(Q, l, {
    ...s.mount ? o : yt($) ? a : zr(Q) ? { [Q]: $ } : $
  }, z, $), Z = (Q) => Vl(an(s.mount ? o : a, Q, n.shouldUnregister ? an(a, Q, []) : [])), je = (Q, $, z = {}) => {
    const X = an(i, Q);
    let ae = $;
    if (X) {
      const V = X._f;
      V && (!V.disabled && at(o, Q, W1($, V)), ae = pl(V.ref) && Yt($) ? "" : $, M1(V.ref) ? [...V.ref.options].forEach((J) => J.selected = ae.includes(J.value)) : V.refs ? qo(V.ref) ? V.refs.length > 1 ? V.refs.forEach((J) => (!J.defaultChecked || !J.disabled) && (J.checked = Array.isArray(ae) ? !!ae.find((de) => de === J.value) : ae === J.value)) : V.refs[0] && (V.refs[0].checked = !!ae) : V.refs.forEach((J) => J.checked = J.value === ae) : gg(V.ref) ? V.ref.value = "" : (V.ref.value = ae, V.ref.type || h.state.next({
        name: Q,
        values: Dt(o)
      })));
    }
    (z.shouldDirty || z.shouldTouch) && A(Q, ae, z.shouldTouch, z.shouldDirty, !0), z.shouldValidate && _e(Q);
  }, ge = (Q, $, z) => {
    for (const X in $) {
      const ae = $[X], V = `${Q}.${X}`, J = an(i, V);
      (l.array.has(Q) || vt(ae) || J && !J._f) && !Fi(ae) ? ge(V, ae, z) : je(V, ae, z);
    }
  }, ye = (Q, $, z = {}) => {
    const X = an(i, Q), ae = l.array.has(Q), V = Dt($);
    at(o, Q, V), ae ? (h.array.next({
      name: Q,
      values: Dt(o)
    }), (d.isDirty || d.dirtyFields || f.isDirty || f.dirtyFields) && z.shouldDirty && h.state.next({
      name: Q,
      dirtyFields: so(a, o),
      isDirty: D(Q, V)
    })) : X && !X._f && !Yt(V) ? ge(Q, V, z) : je(Q, V, z), ES(Q, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? Q : void 0,
      values: Dt(o)
    });
  }, ke = async (Q) => {
    s.mount = !0;
    const $ = Q.target;
    let z = $.name, X = !0;
    const ae = an(i, z), V = (J) => {
      X = Number.isNaN(J) || Fi(J) && isNaN(J.getTime()) || di(J, an(o, z, J));
    };
    if (ae) {
      let J, de;
      const xe = $.type ? CS(ae._f) : A1(Q), $e = Q.type === ml.BLUR || Q.type === ml.FOCUS_OUT, tn = !Mq(ae._f) && !n.resolver && !an(r.errors, z) && !ae._f.deps || Hq($e, an(r.touchedFields, z), r.isSubmitted, C, v), gn = ES(z, l, $e);
      at(o, z, xe), $e ? (ae._f.onBlur && ae._f.onBlur(Q), u && u(0)) : ae._f.onChange && ae._f.onChange(Q);
      const on = A(z, xe, $e), pn = !Kt(on) || gn;
      if (!$e && h.state.next({
        name: z,
        type: Q.type,
        values: Dt(o)
      }), tn)
        return (d.isValid || f.isValid) && (n.mode === "onBlur" ? $e && x() : $e || x()), pn && h.state.next({ name: z, ...gn ? {} : on });
      if (!$e && gn && h.state.next({ ...r }), n.resolver) {
        const { errors: Fn } = await Y([z]);
        if (V(xe), X) {
          const xn = $S(r.errors, i, z), En = $S(Fn, i, xn.name || z);
          J = En.error, z = En.name, de = Kt(Fn);
        }
      } else
        g([z], !0), J = (await OS(ae, l.disabled, o, j, n.shouldUseNativeValidation))[z], g([z]), V(xe), X && (J ? de = !1 : (d.isValid || f.isValid) && (de = await W(i, !0)));
      X && (ae._f.deps && _e(ae._f.deps), H(z, de, J, on));
    }
  }, q = (Q, $) => {
    if (an(r.errors, $) && Q.focus)
      return Q.focus(), 1;
  }, _e = async (Q, $ = {}) => {
    let z, X;
    const ae = No(Q);
    if (n.resolver) {
      const V = await ne(yt(Q) ? Q : ae);
      z = Kt(V), X = Q ? !ae.some((J) => an(V, J)) : z;
    } else Q ? (X = (await Promise.all(ae.map(async (V) => {
      const J = an(i, V);
      return await W(J && J._f ? { [V]: J } : J);
    }))).every(Boolean), !(!X && !r.isValid) && x()) : X = z = await W(i);
    return h.state.next({
      ...!zr(Q) || (d.isValid || f.isValid) && z !== r.isValid ? {} : { name: Q },
      ...n.resolver || !Q ? { isValid: z } : {},
      errors: r.errors
    }), $.shouldFocus && !X && jo(i, q, Q ? ae : l.mount), X;
  }, De = (Q) => {
    const $ = {
      ...s.mount ? o : a
    };
    return yt(Q) ? $ : zr(Q) ? an($, Q) : Q.map((z) => an($, z));
  }, G = (Q, $) => ({
    invalid: !!an(($ || r).errors, Q),
    isDirty: !!an(($ || r).dirtyFields, Q),
    error: an(($ || r).errors, Q),
    isValidating: !!an(r.validatingFields, Q),
    isTouched: !!an(($ || r).touchedFields, Q)
  }), Ye = (Q) => {
    Q && No(Q).forEach(($) => Nt(r.errors, $)), h.state.next({
      errors: Q ? r.errors : {}
    });
  }, sn = (Q, $, z) => {
    const X = (an(i, Q, { _f: {} })._f || {}).ref, ae = an(r.errors, Q) || {}, { ref: V, message: J, type: de, ...xe } = ae;
    at(r.errors, Q, {
      ...xe,
      ...$,
      ref: X
    }), h.state.next({
      name: Q,
      errors: r.errors,
      isValid: !1
    }), z && z.shouldFocus && X && X.focus && X.focus();
  }, Ie = (Q, $) => Fr(Q) ? h.state.subscribe({
    next: (z) => Q(M(void 0, $), z)
  }) : M(Q, $, !0), Ue = (Q) => h.state.subscribe({
    next: ($) => {
      qq(Q.name, $.name, Q.exact) && Bq($, Q.formState || d, Re, Q.reRenderRoot) && Q.callback({
        values: { ...o },
        ...r,
        ...$
      });
    }
  }).unsubscribe, Pe = (Q) => (s.mount = !0, f = {
    ...f,
    ...Q.formState
  }, Ue({
    ...Q,
    formState: f
  })), Be = (Q, $ = {}) => {
    for (const z of Q ? No(Q) : l.mount)
      l.mount.delete(z), l.array.delete(z), $.keepValue || (Nt(i, z), Nt(o, z)), !$.keepError && Nt(r.errors, z), !$.keepDirty && Nt(r.dirtyFields, z), !$.keepTouched && Nt(r.touchedFields, z), !$.keepIsValidating && Nt(r.validatingFields, z), !n.shouldUnregister && !$.keepDefaultValue && Nt(a, z);
    h.state.next({
      values: Dt(o)
    }), h.state.next({
      ...r,
      ...$.keepDirty ? { isDirty: D() } : {}
    }), !$.keepIsValid && x();
  }, Le = ({ disabled: Q, name: $ }) => {
    (sr(Q) && s.mount || Q || l.disabled.has($)) && (Q ? l.disabled.add($) : l.disabled.delete($));
  }, Xe = (Q, $ = {}) => {
    let z = an(i, Q);
    const X = sr($.disabled) || sr(n.disabled);
    return at(i, Q, {
      ...z || {},
      _f: {
        ...z && z._f ? z._f : { ref: { name: Q } },
        name: Q,
        mount: !0,
        ...$
      }
    }), l.mount.add(Q), z ? Le({
      disabled: sr($.disabled) ? $.disabled : n.disabled,
      name: Q
    }) : w(Q, !0, $.value), {
      ...X ? { disabled: $.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!$.required,
        min: lo($.min),
        max: lo($.max),
        minLength: lo($.minLength),
        maxLength: lo($.maxLength),
        pattern: lo($.pattern)
      } : {},
      name: Q,
      onChange: ke,
      onBlur: ke,
      ref: (ae) => {
        if (ae) {
          Xe(Q, $), z = an(i, Q);
          const V = yt(ae.value) && ae.querySelectorAll && ae.querySelectorAll("input,select,textarea")[0] || ae, J = Aq(V), de = z._f.refs || [];
          if (J ? de.find((xe) => xe === V) : V === z._f.ref)
            return;
          at(i, Q, {
            _f: {
              ...z._f,
              ...J ? {
                refs: [
                  ...de.filter(_m),
                  V,
                  ...Array.isArray(an(a, Q)) ? [{}] : []
                ],
                ref: { type: V.type, name: Q }
              } : { ref: V }
            }
          }), w(Q, !1, void 0, V);
        } else
          z = an(i, Q, {}), z._f && (z._f.mount = !1), (n.shouldUnregister || $.shouldUnregister) && !(L1(l.array, Q) && s.action) && l.unMount.add(Q);
      }
    };
  }, Fe = () => n.shouldFocusError && jo(i, q, l.mount), Me = (Q) => {
    sr(Q) && (h.state.next({ disabled: Q }), jo(i, ($, z) => {
      const X = an(i, z);
      X && ($.disabled = X._f.disabled || Q, Array.isArray(X._f.refs) && X._f.refs.forEach((ae) => {
        ae.disabled = X._f.disabled || Q;
      }));
    }, 0, !1));
  }, nn = (Q, $) => async (z) => {
    let X;
    z && (z.preventDefault && z.preventDefault(), z.persist && z.persist());
    let ae = Dt(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: V, values: J } = await Y();
      r.errors = V, ae = J;
    } else
      await W(i);
    if (l.disabled.size)
      for (const V of l.disabled)
        at(ae, V, void 0);
    if (Nt(r.errors, "root"), Kt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await Q(ae, z);
      } catch (V) {
        X = V;
      }
    } else
      $ && await $({ ...r.errors }, z), Fe(), setTimeout(Fe);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Kt(r.errors) && !X,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), X)
      throw X;
  }, se = (Q, $ = {}) => {
    an(i, Q) && (yt($.defaultValue) ? ye(Q, Dt(an(a, Q))) : (ye(Q, $.defaultValue), at(a, Q, Dt($.defaultValue))), $.keepTouched || Nt(r.touchedFields, Q), $.keepDirty || (Nt(r.dirtyFields, Q), r.isDirty = $.defaultValue ? D(Q, Dt(an(a, Q))) : D()), $.keepError || (Nt(r.errors, Q), d.isValid && x()), h.state.next({ ...r }));
  }, le = (Q, $ = {}) => {
    const z = Q ? Dt(Q) : a, X = Dt(z), ae = Kt(Q), V = ae ? a : X;
    if ($.keepDefaultValues || (a = z), !$.keepValues) {
      if ($.keepDirtyValues) {
        const J = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(so(a, o))
        ]);
        for (const de of Array.from(J))
          an(r.dirtyFields, de) ? at(V, de, an(o, de)) : ye(de, an(V, de));
      } else {
        if (fg && yt(Q))
          for (const J of l.mount) {
            const de = an(i, J);
            if (de && de._f) {
              const xe = Array.isArray(de._f.refs) ? de._f.refs[0] : de._f.ref;
              if (pl(xe)) {
                const $e = xe.closest("form");
                if ($e) {
                  $e.reset();
                  break;
                }
              }
            }
          }
        for (const J of l.mount)
          ye(J, an(V, J));
      }
      o = Dt(V), h.array.next({
        values: { ...V }
      }), h.state.next({
        values: { ...V }
      });
    }
    l = {
      mount: $.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !d.isValid || !!$.keepIsValid || !!$.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: $.keepSubmitCount ? r.submitCount : 0,
      isDirty: ae ? !1 : $.keepDirty ? r.isDirty : !!($.keepDefaultValues && !di(Q, a)),
      isSubmitted: $.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: ae ? {} : $.keepDirtyValues ? $.keepDefaultValues && o ? so(a, o) : r.dirtyFields : $.keepDefaultValues && Q ? so(a, Q) : $.keepDirty ? r.dirtyFields : {},
      touchedFields: $.keepTouched ? r.touchedFields : {},
      errors: $.keepErrors ? r.errors : {},
      isSubmitSuccessful: $.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Se = (Q, $) => le(Fr(Q) ? Q(o) : Q, $), Ae = (Q, $ = {}) => {
    const z = an(i, Q), X = z && z._f;
    if (X) {
      const ae = X.refs ? X.refs[0] : X.ref;
      ae.focus && (ae.focus(), $.shouldSelect && Fr(ae.select) && ae.select());
    }
  }, Re = (Q) => {
    r = {
      ...r,
      ...Q
    };
  }, yn = {
    control: {
      register: Xe,
      unregister: Be,
      getFieldState: G,
      handleSubmit: nn,
      setError: sn,
      _subscribe: Ue,
      _runSchema: Y,
      _getWatch: M,
      _getDirty: D,
      _setValid: x,
      _setFieldArray: P,
      _setDisabledField: Le,
      _setErrors: I,
      _getFieldArray: Z,
      _reset: le,
      _resetDefaultValues: () => Fr(n.defaultValues) && n.defaultValues().then((Q) => {
        Se(Q, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: B,
      _disableForm: Me,
      _subjects: h,
      _proxyFormState: d,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(Q) {
        s = Q;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(Q) {
        l = Q;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(Q) {
        n = {
          ...n,
          ...Q
        };
      }
    },
    subscribe: Pe,
    trigger: _e,
    register: Xe,
    handleSubmit: nn,
    watch: Ie,
    setValue: ye,
    getValues: De,
    reset: Se,
    resetField: se,
    clearErrors: Ye,
    unregister: Be,
    setError: sn,
    setFocus: Ae,
    getFieldState: G
  };
  return {
    ...yn,
    formControl: yn
  };
}
function Jq(e = {}) {
  const n = qe.useRef(void 0), r = qe.useRef(void 0), [i, a] = qe.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Fr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: Fr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : Yq(e),
    formState: i
  }, e.formControl && e.defaultValues && !Fr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, qe.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), qe.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), qe.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), qe.useEffect(() => {
    e.values && !di(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), qe.useEffect(() => {
    e.errors && !Kt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), qe.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), qe.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = z1(i, o), n.current;
}
var bs = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function G1(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Sm = { exports: {} }, co = {}, DS;
function Qq() {
  if (DS) return co;
  DS = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return co.Fragment = r, co.jsx = s, co.jsxs = s, co;
}
var xs = {}, PS;
function Xq() {
  return PS || (PS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        P("error", t, m);
      }
    }
    function P(t, c, m) {
      {
        var y = x.ReactDebugCurrentFrame, F = y.getStackAddendum();
        F !== "" && (c += "%s", m = m.concat([F]));
        var T = m.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var E = !1, I = !1, w = !1, A = !1, H = !1, Y;
    Y = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ne(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || H || t === a || t === p || t === d || A || t === v || E || I || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function W(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var F = c.displayName || c.name || "";
      return F !== "" ? m + "(" + F + ")" : m;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function D(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var m = t;
            return B(m._context) + ".Provider";
          case u:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : D(t.type) || "Memo";
          case h: {
            var F = t, T = F._payload, S = F._init;
            try {
              return D(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var M = Object.assign, Z = 0, je, ge, ye, ke, q, _e, De;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function Ye() {
      {
        if (Z === 0) {
          je = console.log, ge = console.info, ye = console.warn, ke = console.error, q = console.group, _e = console.groupCollapsed, De = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function sn() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: M({}, t, {
              value: je
            }),
            info: M({}, t, {
              value: ge
            }),
            warn: M({}, t, {
              value: ye
            }),
            error: M({}, t, {
              value: ke
            }),
            group: M({}, t, {
              value: q
            }),
            groupCollapsed: M({}, t, {
              value: _e
            }),
            groupEnd: M({}, t, {
              value: De
            })
          });
        }
        Z < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = x.ReactCurrentDispatcher, Ue;
    function Pe(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (F) {
            var y = F.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Le;
    {
      var Xe = typeof WeakMap == "function" ? WeakMap : Map;
      Le = new Xe();
    }
    function Fe(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Le.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      Be = !0;
      var F = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ye();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (re) {
              y = re;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (re) {
              y = re;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            y = re;
          }
          t();
        }
      } catch (re) {
        if (re && y && typeof re.stack == "string") {
          for (var _ = re.stack.split(`
`), ee = y.stack.split(`
`), L = _.length - 1, U = ee.length - 1; L >= 1 && U >= 0 && _[L] !== ee[U]; )
            U--;
          for (; L >= 1 && U >= 0; L--, U--)
            if (_[L] !== ee[U]) {
              if (L !== 1 || U !== 1)
                do
                  if (L--, U--, U < 0 || _[L] !== ee[U]) {
                    var ce = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && ce.includes("<anonymous>") && (ce = ce.replace("<anonymous>", t.displayName)), typeof t == "function" && Le.set(t, ce), ce;
                  }
                while (L >= 1 && U >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = F;
      }
      var ze = t ? t.displayName || t.name : "", Oe = ze ? Pe(ze) : "";
      return typeof t == "function" && Le.set(t, Oe), Oe;
    }
    function Me(t, c, m) {
      return Fe(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Fe(t, nn(t));
      if (typeof t == "string")
        return Pe(t);
      switch (t) {
        case p:
          return Pe("Suspense");
        case d:
          return Pe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return Me(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, F = y._payload, T = y._init;
            try {
              return se(T(F), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Se = {}, Ae = x.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(m);
      } else
        Ae.setExtraStackFrame(null);
    }
    function yn(t, c, m, y, F) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + m + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              _ = t[S](c, S, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Re(F), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, S, typeof _), Re(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Re(F), g("Failed %s type: %s", m, _.message), Re(null));
          }
      }
    }
    var Q = Array.isArray;
    function $(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ae(t);
    }
    var J = x.ReactCurrentOwner, de = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, xe, $e;
    function tn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && J.current;
    }
    function pn(t, c) {
      {
        var m = function() {
          xe || (xe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function Fn(t, c) {
      {
        var m = function() {
          $e || ($e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, m, y, F, T, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: F
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, m, y, F) {
      {
        var T, S = {}, _ = null, ee = null;
        m !== void 0 && (V(m), _ = "" + m), gn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ee = c.ref, on(c));
        for (T in c)
          le.call(c, T) && !de.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (T in L)
            S[T] === void 0 && (S[T] = L[T]);
        }
        if (_ || ee) {
          var U = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, U), ee && Fn(S, U);
        }
        return xn(t, _, ee, F, y, J.current, S);
      }
    }
    var en = x.ReactCurrentOwner, vn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        vn.setExtraStackFrame(m);
      } else
        vn.setExtraStackFrame(null);
    }
    var un;
    un = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = D(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Nn = {};
    function Rn(t) {
      {
        var c = jn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function kn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Rn(c);
        if (Nn[m])
          return;
        Nn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + D(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Ve(null);
      }
    }
    function _n(t, c) {
      {
        if (typeof t != "object")
          return;
        if ($(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            dn(y) && kn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var F = N(t);
          if (typeof F == "function" && F !== t.entries)
            for (var T = F.call(t), S; !(S = T.next()).done; )
              dn(S.value) && kn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = D(c);
          yn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !un) {
          un = !0;
          var F = D(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", F || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, m, y, F, T) {
      {
        var S = ne(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = Bn();
          ee ? _ += ee : _ += jn();
          var L;
          t === null ? L = "null" : $(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (D(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var U = En(t, c, m, F, T);
        if (U == null)
          return U;
        if (S) {
          var ce = c.children;
          if (ce !== void 0)
            if (y)
              if ($(ce)) {
                for (var ze = 0; ze < ce.length; ze++)
                  _n(ce[ze], t);
                Object.freeze && Object.freeze(ce);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _n(ce, t);
        }
        if (le.call(c, "key")) {
          var Oe = D(t), re = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), mn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Oe + mn]) {
            var Dn = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Oe, Dn, Oe), Cn[Oe + mn] = !0;
          }
        }
        return t === i ? Ln(U) : An(U), U;
      }
    }
    function Vn(t, c, m) {
      return wn(t, c, m, !0);
    }
    function qn(t, c, m) {
      return wn(t, c, m, !1);
    }
    var zn = qn, Wn = Vn;
    xs.Fragment = i, xs.jsx = zn, xs.jsxs = Wn;
  })()), xs;
}
var RS;
function Zq() {
  return RS || (RS = 1, process.env.NODE_ENV === "production" ? Sm.exports = Qq() : Sm.exports = Xq()), Sm.exports;
}
var wo = Zq();
function e6(e) {
  return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var Nm, AS;
function yi() {
  if (AS) return Nm;
  AS = 1;
  var e = Array.isArray;
  return Nm = e, Nm;
}
var jm, LS;
function Y1() {
  if (LS) return jm;
  LS = 1;
  var e = typeof bs == "object" && bs && bs.Object === Object && bs;
  return jm = e, jm;
}
var wm, VS;
function Wr() {
  if (VS) return wm;
  VS = 1;
  var e = Y1(), n = typeof self == "object" && self && self.Object === Object && self, r = e || n || Function("return this")();
  return wm = r, wm;
}
var Cm, zS;
function Ho() {
  if (zS) return Cm;
  zS = 1;
  var e = Wr(), n = e.Symbol;
  return Cm = n, Cm;
}
var Im, US;
function n6() {
  if (US) return Im;
  US = 1;
  var e = Ho(), n = Object.prototype, r = n.hasOwnProperty, i = n.toString, a = e ? e.toStringTag : void 0;
  function o(s) {
    var l = r.call(s, a), u = s[a];
    try {
      s[a] = void 0;
      var p = !0;
    } catch {
    }
    var d = i.call(s);
    return p && (l ? s[a] = u : delete s[a]), d;
  }
  return Im = o, Im;
}
var Fm, MS;
function t6() {
  if (MS) return Fm;
  MS = 1;
  var e = Object.prototype, n = e.toString;
  function r(i) {
    return n.call(i);
  }
  return Fm = r, Fm;
}
var Em, BS;
function Ea() {
  if (BS) return Em;
  BS = 1;
  var e = Ho(), n = n6(), r = t6(), i = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(l) {
    return l == null ? l === void 0 ? a : i : o && o in Object(l) ? n(l) : r(l);
  }
  return Em = s, Em;
}
var $m, qS;
function Bi() {
  if (qS) return $m;
  qS = 1;
  function e(n) {
    return n != null && typeof n == "object";
  }
  return $m = e, $m;
}
var Tm, HS;
function kg() {
  if (HS) return Tm;
  HS = 1;
  var e = Ea(), n = Bi(), r = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || n(a) && e(a) == r;
  }
  return Tm = i, Tm;
}
var Om, WS;
function r6() {
  if (WS) return Om;
  WS = 1;
  var e = yi(), n = kg(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function a(o, s) {
    if (e(o))
      return !1;
    var l = typeof o;
    return l == "number" || l == "symbol" || l == "boolean" || o == null || n(o) ? !0 : i.test(o) || !r.test(o) || s != null && o in Object(s);
  }
  return Om = a, Om;
}
var Dm, KS;
function $a() {
  if (KS) return Dm;
  KS = 1;
  function e(n) {
    var r = typeof n;
    return n != null && (r == "object" || r == "function");
  }
  return Dm = e, Dm;
}
var Pm, GS;
function J1() {
  if (GS) return Pm;
  GS = 1;
  var e = Ea(), n = $a(), r = "[object AsyncFunction]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(l) {
    if (!n(l))
      return !1;
    var u = e(l);
    return u == i || u == a || u == r || u == o;
  }
  return Pm = s, Pm;
}
var Rm, YS;
function i6() {
  if (YS) return Rm;
  YS = 1;
  var e = Wr(), n = e["__core-js_shared__"];
  return Rm = n, Rm;
}
var Am, JS;
function a6() {
  if (JS) return Am;
  JS = 1;
  var e = i6(), n = (function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  })();
  function r(i) {
    return !!n && n in i;
  }
  return Am = r, Am;
}
var Lm, QS;
function Q1() {
  if (QS) return Lm;
  QS = 1;
  var e = Function.prototype, n = e.toString;
  function r(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return Lm = r, Lm;
}
var Vm, XS;
function o6() {
  if (XS) return Vm;
  XS = 1;
  var e = J1(), n = a6(), r = $a(), i = Q1(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, u = s.toString, p = l.hasOwnProperty, d = RegExp(
    "^" + u.call(p).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!r(h) || n(h))
      return !1;
    var v = e(h) ? d : o;
    return v.test(i(h));
  }
  return Vm = f, Vm;
}
var zm, ZS;
function s6() {
  if (ZS) return zm;
  ZS = 1;
  function e(n, r) {
    return n?.[r];
  }
  return zm = e, zm;
}
var Um, e0;
function qi() {
  if (e0) return Um;
  e0 = 1;
  var e = o6(), n = s6();
  function r(i, a) {
    var o = n(i, a);
    return e(o) ? o : void 0;
  }
  return Um = r, Um;
}
var Mm, n0;
function zl() {
  if (n0) return Mm;
  n0 = 1;
  var e = qi(), n = e(Object, "create");
  return Mm = n, Mm;
}
var Bm, t0;
function l6() {
  if (t0) return Bm;
  t0 = 1;
  var e = zl();
  function n() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Bm = n, Bm;
}
var qm, r0;
function c6() {
  if (r0) return qm;
  r0 = 1;
  function e(n) {
    var r = this.has(n) && delete this.__data__[n];
    return this.size -= r ? 1 : 0, r;
  }
  return qm = e, qm;
}
var Hm, i0;
function u6() {
  if (i0) return Hm;
  i0 = 1;
  var e = zl(), n = "__lodash_hash_undefined__", r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    var s = this.__data__;
    if (e) {
      var l = s[o];
      return l === n ? void 0 : l;
    }
    return i.call(s, o) ? s[o] : void 0;
  }
  return Hm = a, Hm;
}
var Wm, a0;
function d6() {
  if (a0) return Wm;
  a0 = 1;
  var e = zl(), n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : r.call(o, a);
  }
  return Wm = i, Wm;
}
var Km, o0;
function m6() {
  if (o0) return Km;
  o0 = 1;
  var e = zl(), n = "__lodash_hash_undefined__";
  function r(i, a) {
    var o = this.__data__;
    return this.size += this.has(i) ? 0 : 1, o[i] = e && a === void 0 ? n : a, this;
  }
  return Km = r, Km;
}
var Gm, s0;
function p6() {
  if (s0) return Gm;
  s0 = 1;
  var e = l6(), n = c6(), r = u6(), i = d6(), a = m6();
  function o(s) {
    var l = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++l < u; ) {
      var p = s[l];
      this.set(p[0], p[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Gm = o, Gm;
}
var Ym, l0;
function f6() {
  if (l0) return Ym;
  l0 = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return Ym = e, Ym;
}
var Jm, c0;
function X1() {
  if (c0) return Jm;
  c0 = 1;
  function e(n, r) {
    return n === r || n !== n && r !== r;
  }
  return Jm = e, Jm;
}
var Qm, u0;
function Ul() {
  if (u0) return Qm;
  u0 = 1;
  var e = X1();
  function n(r, i) {
    for (var a = r.length; a--; )
      if (e(r[a][0], i))
        return a;
    return -1;
  }
  return Qm = n, Qm;
}
var Xm, d0;
function h6() {
  if (d0) return Xm;
  d0 = 1;
  var e = Ul(), n = Array.prototype, r = n.splice;
  function i(a) {
    var o = this.__data__, s = e(o, a);
    if (s < 0)
      return !1;
    var l = o.length - 1;
    return s == l ? o.pop() : r.call(o, s, 1), --this.size, !0;
  }
  return Xm = i, Xm;
}
var Zm, m0;
function y6() {
  if (m0) return Zm;
  m0 = 1;
  var e = Ul();
  function n(r) {
    var i = this.__data__, a = e(i, r);
    return a < 0 ? void 0 : i[a][1];
  }
  return Zm = n, Zm;
}
var ep, p0;
function g6() {
  if (p0) return ep;
  p0 = 1;
  var e = Ul();
  function n(r) {
    return e(this.__data__, r) > -1;
  }
  return ep = n, ep;
}
var np, f0;
function v6() {
  if (f0) return np;
  f0 = 1;
  var e = Ul();
  function n(r, i) {
    var a = this.__data__, o = e(a, r);
    return o < 0 ? (++this.size, a.push([r, i])) : a[o][1] = i, this;
  }
  return np = n, np;
}
var tp, h0;
function Ml() {
  if (h0) return tp;
  h0 = 1;
  var e = f6(), n = h6(), r = y6(), i = g6(), a = v6();
  function o(s) {
    var l = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++l < u; ) {
      var p = s[l];
      this.set(p[0], p[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, tp = o, tp;
}
var rp, y0;
function bg() {
  if (y0) return rp;
  y0 = 1;
  var e = qi(), n = Wr(), r = e(n, "Map");
  return rp = r, rp;
}
var ip, g0;
function k6() {
  if (g0) return ip;
  g0 = 1;
  var e = p6(), n = Ml(), r = bg();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || n)(),
      string: new e()
    };
  }
  return ip = i, ip;
}
var ap, v0;
function b6() {
  if (v0) return ap;
  v0 = 1;
  function e(n) {
    var r = typeof n;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? n !== "__proto__" : n === null;
  }
  return ap = e, ap;
}
var op, k0;
function Bl() {
  if (k0) return op;
  k0 = 1;
  var e = b6();
  function n(r, i) {
    var a = r.__data__;
    return e(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
  }
  return op = n, op;
}
var sp, b0;
function x6() {
  if (b0) return sp;
  b0 = 1;
  var e = Bl();
  function n(r) {
    var i = e(this, r).delete(r);
    return this.size -= i ? 1 : 0, i;
  }
  return sp = n, sp;
}
var lp, x0;
function _6() {
  if (x0) return lp;
  x0 = 1;
  var e = Bl();
  function n(r) {
    return e(this, r).get(r);
  }
  return lp = n, lp;
}
var cp, _0;
function S6() {
  if (_0) return cp;
  _0 = 1;
  var e = Bl();
  function n(r) {
    return e(this, r).has(r);
  }
  return cp = n, cp;
}
var up, S0;
function N6() {
  if (S0) return up;
  S0 = 1;
  var e = Bl();
  function n(r, i) {
    var a = e(this, r), o = a.size;
    return a.set(r, i), this.size += a.size == o ? 0 : 1, this;
  }
  return up = n, up;
}
var dp, N0;
function Z1() {
  if (N0) return dp;
  N0 = 1;
  var e = k6(), n = x6(), r = _6(), i = S6(), a = N6();
  function o(s) {
    var l = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++l < u; ) {
      var p = s[l];
      this.set(p[0], p[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, dp = o, dp;
}
var mp, j0;
function j6() {
  if (j0) return mp;
  j0 = 1;
  var e = Z1(), n = "Expected a function";
  function r(i, a) {
    if (typeof i != "function" || a != null && typeof a != "function")
      throw new TypeError(n);
    var o = function() {
      var s = arguments, l = a ? a.apply(this, s) : s[0], u = o.cache;
      if (u.has(l))
        return u.get(l);
      var p = i.apply(this, s);
      return o.cache = u.set(l, p) || u, p;
    };
    return o.cache = new (r.Cache || e)(), o;
  }
  return r.Cache = e, mp = r, mp;
}
var pp, w0;
function w6() {
  if (w0) return pp;
  w0 = 1;
  var e = j6(), n = 500;
  function r(i) {
    var a = e(i, function(s) {
      return o.size === n && o.clear(), s;
    }), o = a.cache;
    return a;
  }
  return pp = r, pp;
}
var fp, C0;
function C6() {
  if (C0) return fp;
  C0 = 1;
  var e = w6(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, i = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(n, function(s, l, u, p) {
      o.push(u ? p.replace(r, "$1") : l || s);
    }), o;
  });
  return fp = i, fp;
}
var hp, I0;
function eI() {
  if (I0) return hp;
  I0 = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = Array(a); ++i < a; )
      o[i] = r(n[i], i, n);
    return o;
  }
  return hp = e, hp;
}
var yp, F0;
function I6() {
  if (F0) return yp;
  F0 = 1;
  var e = Ho(), n = eI(), r = yi(), i = kg(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function s(l) {
    if (typeof l == "string")
      return l;
    if (r(l))
      return n(l, s) + "";
    if (i(l))
      return o ? o.call(l) : "";
    var u = l + "";
    return u == "0" && 1 / l == -1 / 0 ? "-0" : u;
  }
  return yp = s, yp;
}
var gp, E0;
function F6() {
  if (E0) return gp;
  E0 = 1;
  var e = I6();
  function n(r) {
    return r == null ? "" : e(r);
  }
  return gp = n, gp;
}
var vp, $0;
function Ta() {
  if ($0) return vp;
  $0 = 1;
  var e = yi(), n = r6(), r = C6(), i = F6();
  function a(o, s) {
    return e(o) ? o : n(o, s) ? [o] : r(i(o));
  }
  return vp = a, vp;
}
var kp, T0;
function ql() {
  if (T0) return kp;
  T0 = 1;
  var e = kg();
  function n(r) {
    if (typeof r == "string" || e(r))
      return r;
    var i = r + "";
    return i == "0" && 1 / r == -1 / 0 ? "-0" : i;
  }
  return kp = n, kp;
}
var bp, O0;
function nI() {
  if (O0) return bp;
  O0 = 1;
  var e = Ta(), n = ql();
  function r(i, a) {
    a = e(a, i);
    for (var o = 0, s = a.length; i != null && o < s; )
      i = i[n(a[o++])];
    return o && o == s ? i : void 0;
  }
  return bp = r, bp;
}
var xp, D0;
function tI() {
  if (D0) return xp;
  D0 = 1;
  var e = qi(), n = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return xp = n, xp;
}
var _p, P0;
function rI() {
  if (P0) return _p;
  P0 = 1;
  var e = tI();
  function n(r, i, a) {
    i == "__proto__" && e ? e(r, i, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[i] = a;
  }
  return _p = n, _p;
}
var Sp, R0;
function xg() {
  if (R0) return Sp;
  R0 = 1;
  var e = rI(), n = X1(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o, s, l) {
    var u = o[s];
    (!(i.call(o, s) && n(u, l)) || l === void 0 && !(s in o)) && e(o, s, l);
  }
  return Sp = a, Sp;
}
var Np, A0;
function _g() {
  if (A0) return Np;
  A0 = 1;
  var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function r(i, a) {
    var o = typeof i;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < a;
  }
  return Np = r, Np;
}
var jp, L0;
function E6() {
  if (L0) return jp;
  L0 = 1;
  var e = xg(), n = Ta(), r = _g(), i = $a(), a = ql();
  function o(s, l, u, p) {
    if (!i(s))
      return s;
    l = n(l, s);
    for (var d = -1, f = l.length, h = f - 1, v = s; v != null && ++d < f; ) {
      var C = a(l[d]), j = u;
      if (C === "__proto__" || C === "constructor" || C === "prototype")
        return s;
      if (d != h) {
        var N = v[C];
        j = p ? p(N, C, v) : void 0, j === void 0 && (j = i(N) ? N : r(l[d + 1]) ? [] : {});
      }
      e(v, C, j), v = v[C];
    }
    return s;
  }
  return jp = o, jp;
}
var wp, V0;
function $6() {
  if (V0) return wp;
  V0 = 1;
  var e = nI(), n = E6(), r = Ta();
  function i(a, o, s) {
    for (var l = -1, u = o.length, p = {}; ++l < u; ) {
      var d = o[l], f = e(a, d);
      s(f, d) && n(p, r(d, a), f);
    }
    return p;
  }
  return wp = i, wp;
}
var Cp, z0;
function T6() {
  if (z0) return Cp;
  z0 = 1;
  function e(n, r) {
    return n != null && r in Object(n);
  }
  return Cp = e, Cp;
}
var Ip, U0;
function O6() {
  if (U0) return Ip;
  U0 = 1;
  var e = Ea(), n = Bi(), r = "[object Arguments]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Ip = i, Ip;
}
var Fp, M0;
function Sg() {
  if (M0) return Fp;
  M0 = 1;
  var e = O6(), n = Bi(), r = Object.prototype, i = r.hasOwnProperty, a = r.propertyIsEnumerable, o = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return n(s) && i.call(s, "callee") && !a.call(s, "callee");
  };
  return Fp = o, Fp;
}
var Ep, B0;
function Ng() {
  if (B0) return Ep;
  B0 = 1;
  var e = 9007199254740991;
  function n(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return Ep = n, Ep;
}
var $p, q0;
function D6() {
  if (q0) return $p;
  q0 = 1;
  var e = Ta(), n = Sg(), r = yi(), i = _g(), a = Ng(), o = ql();
  function s(l, u, p) {
    u = e(u, l);
    for (var d = -1, f = u.length, h = !1; ++d < f; ) {
      var v = o(u[d]);
      if (!(h = l != null && p(l, v)))
        break;
      l = l[v];
    }
    return h || ++d != f ? h : (f = l == null ? 0 : l.length, !!f && a(f) && i(v, f) && (r(l) || n(l)));
  }
  return $p = s, $p;
}
var Tp, H0;
function P6() {
  if (H0) return Tp;
  H0 = 1;
  var e = T6(), n = D6();
  function r(i, a) {
    return i != null && n(i, a, e);
  }
  return Tp = r, Tp;
}
var Op, W0;
function R6() {
  if (W0) return Op;
  W0 = 1;
  var e = $6(), n = P6();
  function r(i, a) {
    return e(i, a, function(o, s) {
      return n(i, s);
    });
  }
  return Op = r, Op;
}
var Dp, K0;
function jg() {
  if (K0) return Dp;
  K0 = 1;
  function e(n, r) {
    for (var i = -1, a = r.length, o = n.length; ++i < a; )
      n[o + i] = r[i];
    return n;
  }
  return Dp = e, Dp;
}
var Pp, G0;
function A6() {
  if (G0) return Pp;
  G0 = 1;
  var e = Ho(), n = Sg(), r = yi(), i = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return r(o) || n(o) || !!(i && o && o[i]);
  }
  return Pp = a, Pp;
}
var Rp, Y0;
function L6() {
  if (Y0) return Rp;
  Y0 = 1;
  var e = jg(), n = A6();
  function r(i, a, o, s, l) {
    var u = -1, p = i.length;
    for (o || (o = n), l || (l = []); ++u < p; ) {
      var d = i[u];
      a > 0 && o(d) ? a > 1 ? r(d, a - 1, o, s, l) : e(l, d) : s || (l[l.length] = d);
    }
    return l;
  }
  return Rp = r, Rp;
}
var Ap, J0;
function V6() {
  if (J0) return Ap;
  J0 = 1;
  var e = L6();
  function n(r) {
    var i = r == null ? 0 : r.length;
    return i ? e(r, 1) : [];
  }
  return Ap = n, Ap;
}
var Lp, Q0;
function z6() {
  if (Q0) return Lp;
  Q0 = 1;
  function e(n, r, i) {
    switch (i.length) {
      case 0:
        return n.call(r);
      case 1:
        return n.call(r, i[0]);
      case 2:
        return n.call(r, i[0], i[1]);
      case 3:
        return n.call(r, i[0], i[1], i[2]);
    }
    return n.apply(r, i);
  }
  return Lp = e, Lp;
}
var Vp, X0;
function U6() {
  if (X0) return Vp;
  X0 = 1;
  var e = z6(), n = Math.max;
  function r(i, a, o) {
    return a = n(a === void 0 ? i.length - 1 : a, 0), function() {
      for (var s = arguments, l = -1, u = n(s.length - a, 0), p = Array(u); ++l < u; )
        p[l] = s[a + l];
      l = -1;
      for (var d = Array(a + 1); ++l < a; )
        d[l] = s[l];
      return d[a] = o(p), e(i, this, d);
    };
  }
  return Vp = r, Vp;
}
var zp, Z0;
function M6() {
  if (Z0) return zp;
  Z0 = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  return zp = e, zp;
}
var Up, eN;
function iI() {
  if (eN) return Up;
  eN = 1;
  function e(n) {
    return n;
  }
  return Up = e, Up;
}
var Mp, nN;
function B6() {
  if (nN) return Mp;
  nN = 1;
  var e = M6(), n = tI(), r = iI(), i = n ? function(a, o) {
    return n(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : r;
  return Mp = i, Mp;
}
var Bp, tN;
function q6() {
  if (tN) return Bp;
  tN = 1;
  var e = 800, n = 16, r = Date.now;
  function i(a) {
    var o = 0, s = 0;
    return function() {
      var l = r(), u = n - (l - s);
      if (s = l, u > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return Bp = i, Bp;
}
var qp, rN;
function H6() {
  if (rN) return qp;
  rN = 1;
  var e = B6(), n = q6(), r = n(e);
  return qp = r, qp;
}
var Hp, iN;
function aI() {
  if (iN) return Hp;
  iN = 1;
  var e = V6(), n = U6(), r = H6();
  function i(a) {
    return r(n(a, void 0, e), a + "");
  }
  return Hp = i, Hp;
}
var Wp, aN;
function W6() {
  if (aN) return Wp;
  aN = 1;
  var e = R6(), n = aI(), r = n(function(i, a) {
    return i == null ? {} : e(i, a);
  });
  return Wp = r, Wp;
}
var K6 = W6();
const oI = /* @__PURE__ */ G1(K6), G6 = [
  "control",
  "defaultValue",
  "name",
  "rules",
  "shouldUnregister"
];
function sI(e) {
  const n = oI(e, G6);
  return {
    controller: Pq(n),
    controllerProps: n
  };
}
const Y6 = [
  "className",
  "description",
  "disabled",
  "helpIcon",
  "label",
  "noAlert",
  "noLabel",
  "style"
];
function J6(e) {
  const { controller: n, controllerProps: r } = sI(e), i = {
    ...oI(e, Y6),
    required: e6(r.rules?.required),
    meta: {
      touched: n.fieldState.isTouched,
      error: n.fieldState.error?.message,
      success: e.meta?.success,
      warning: e.meta?.warning
    },
    labelFor: r.name,
    noLabel: e.noLabel,
    noAlert: e.noAlert
  };
  return {
    controller: n,
    controllerProps: r,
    fieldWrapperProps: i
  };
}
var Kp, oN;
function Q6() {
  if (oN) return Kp;
  oN = 1;
  var e = Ml();
  function n() {
    this.__data__ = new e(), this.size = 0;
  }
  return Kp = n, Kp;
}
var Gp, sN;
function X6() {
  if (sN) return Gp;
  sN = 1;
  function e(n) {
    var r = this.__data__, i = r.delete(n);
    return this.size = r.size, i;
  }
  return Gp = e, Gp;
}
var Yp, lN;
function Z6() {
  if (lN) return Yp;
  lN = 1;
  function e(n) {
    return this.__data__.get(n);
  }
  return Yp = e, Yp;
}
var Jp, cN;
function eH() {
  if (cN) return Jp;
  cN = 1;
  function e(n) {
    return this.__data__.has(n);
  }
  return Jp = e, Jp;
}
var Qp, uN;
function nH() {
  if (uN) return Qp;
  uN = 1;
  var e = Ml(), n = bg(), r = Z1(), i = 200;
  function a(o, s) {
    var l = this.__data__;
    if (l instanceof e) {
      var u = l.__data__;
      if (!n || u.length < i - 1)
        return u.push([o, s]), this.size = ++l.size, this;
      l = this.__data__ = new r(u);
    }
    return l.set(o, s), this.size = l.size, this;
  }
  return Qp = a, Qp;
}
var Xp, dN;
function tH() {
  if (dN) return Xp;
  dN = 1;
  var e = Ml(), n = Q6(), r = X6(), i = Z6(), a = eH(), o = nH();
  function s(l) {
    var u = this.__data__ = new e(l);
    this.size = u.size;
  }
  return s.prototype.clear = n, s.prototype.delete = r, s.prototype.get = i, s.prototype.has = a, s.prototype.set = o, Xp = s, Xp;
}
var Zp, mN;
function rH() {
  if (mN) return Zp;
  mN = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length; ++i < a && r(n[i], i, n) !== !1; )
      ;
    return n;
  }
  return Zp = e, Zp;
}
var ef, pN;
function Wo() {
  if (pN) return ef;
  pN = 1;
  var e = xg(), n = rI();
  function r(i, a, o, s) {
    var l = !o;
    o || (o = {});
    for (var u = -1, p = a.length; ++u < p; ) {
      var d = a[u], f = s ? s(o[d], i[d], d, o, i) : void 0;
      f === void 0 && (f = i[d]), l ? n(o, d, f) : e(o, d, f);
    }
    return o;
  }
  return ef = r, ef;
}
var nf, fN;
function iH() {
  if (fN) return nf;
  fN = 1;
  function e(n, r) {
    for (var i = -1, a = Array(n); ++i < n; )
      a[i] = r(i);
    return a;
  }
  return nf = e, nf;
}
var Ms = { exports: {} }, tf, hN;
function aH() {
  if (hN) return tf;
  hN = 1;
  function e() {
    return !1;
  }
  return tf = e, tf;
}
Ms.exports;
var yN;
function lI() {
  return yN || (yN = 1, (function(e, n) {
    var r = Wr(), i = aH(), a = n && !n.nodeType && n, o = a && !0 && e && !e.nodeType && e, s = o && o.exports === a, l = s ? r.Buffer : void 0, u = l ? l.isBuffer : void 0, p = u || i;
    e.exports = p;
  })(Ms, Ms.exports)), Ms.exports;
}
var rf, gN;
function oH() {
  if (gN) return rf;
  gN = 1;
  var e = Ea(), n = Ng(), r = Bi(), i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", l = "[object Error]", u = "[object Function]", p = "[object Map]", d = "[object Number]", f = "[object Object]", h = "[object RegExp]", v = "[object Set]", C = "[object String]", j = "[object WeakMap]", N = "[object ArrayBuffer]", x = "[object DataView]", g = "[object Float32Array]", P = "[object Float64Array]", E = "[object Int8Array]", I = "[object Int16Array]", w = "[object Int32Array]", A = "[object Uint8Array]", H = "[object Uint8ClampedArray]", Y = "[object Uint16Array]", ne = "[object Uint32Array]", W = {};
  W[g] = W[P] = W[E] = W[I] = W[w] = W[A] = W[H] = W[Y] = W[ne] = !0, W[i] = W[a] = W[N] = W[o] = W[x] = W[s] = W[l] = W[u] = W[p] = W[d] = W[f] = W[h] = W[v] = W[C] = W[j] = !1;
  function B(D) {
    return r(D) && n(D.length) && !!W[e(D)];
  }
  return rf = B, rf;
}
var af, vN;
function wg() {
  if (vN) return af;
  vN = 1;
  function e(n) {
    return function(r) {
      return n(r);
    };
  }
  return af = e, af;
}
var Bs = { exports: {} };
Bs.exports;
var kN;
function Cg() {
  return kN || (kN = 1, (function(e, n) {
    var r = Y1(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o && r.process, l = (function() {
      try {
        var u = a && a.require && a.require("util").types;
        return u || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = l;
  })(Bs, Bs.exports)), Bs.exports;
}
var of, bN;
function sH() {
  if (bN) return of;
  bN = 1;
  var e = oH(), n = wg(), r = Cg(), i = r && r.isTypedArray, a = i ? n(i) : e;
  return of = a, of;
}
var sf, xN;
function cI() {
  if (xN) return sf;
  xN = 1;
  var e = iH(), n = Sg(), r = yi(), i = lI(), a = _g(), o = sH(), s = Object.prototype, l = s.hasOwnProperty;
  function u(p, d) {
    var f = r(p), h = !f && n(p), v = !f && !h && i(p), C = !f && !h && !v && o(p), j = f || h || v || C, N = j ? e(p.length, String) : [], x = N.length;
    for (var g in p)
      (d || l.call(p, g)) && !(j && // Safari 9 has enumerable `arguments.length` in strict mode.
      (g == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      v && (g == "offset" || g == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      C && (g == "buffer" || g == "byteLength" || g == "byteOffset") || // Skip index properties.
      a(g, x))) && N.push(g);
    return N;
  }
  return sf = u, sf;
}
var lf, _N;
function Ig() {
  if (_N) return lf;
  _N = 1;
  var e = Object.prototype;
  function n(r) {
    var i = r && r.constructor, a = typeof i == "function" && i.prototype || e;
    return r === a;
  }
  return lf = n, lf;
}
var cf, SN;
function uI() {
  if (SN) return cf;
  SN = 1;
  function e(n, r) {
    return function(i) {
      return n(r(i));
    };
  }
  return cf = e, cf;
}
var uf, NN;
function lH() {
  if (NN) return uf;
  NN = 1;
  var e = uI(), n = e(Object.keys, Object);
  return uf = n, uf;
}
var df, jN;
function cH() {
  if (jN) return df;
  jN = 1;
  var e = Ig(), n = lH(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return n(o);
    var s = [];
    for (var l in Object(o))
      i.call(o, l) && l != "constructor" && s.push(l);
    return s;
  }
  return df = a, df;
}
var mf, wN;
function dI() {
  if (wN) return mf;
  wN = 1;
  var e = J1(), n = Ng();
  function r(i) {
    return i != null && n(i.length) && !e(i);
  }
  return mf = r, mf;
}
var pf, CN;
function Fg() {
  if (CN) return pf;
  CN = 1;
  var e = cI(), n = cH(), r = dI();
  function i(a) {
    return r(a) ? e(a) : n(a);
  }
  return pf = i, pf;
}
var ff, IN;
function uH() {
  if (IN) return ff;
  IN = 1;
  var e = Wo(), n = Fg();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return ff = r, ff;
}
var hf, FN;
function dH() {
  if (FN) return hf;
  FN = 1;
  function e(n) {
    var r = [];
    if (n != null)
      for (var i in Object(n))
        r.push(i);
    return r;
  }
  return hf = e, hf;
}
var yf, EN;
function mH() {
  if (EN) return yf;
  EN = 1;
  var e = $a(), n = Ig(), r = dH(), i = Object.prototype, a = i.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return r(s);
    var l = n(s), u = [];
    for (var p in s)
      p == "constructor" && (l || !a.call(s, p)) || u.push(p);
    return u;
  }
  return yf = o, yf;
}
var gf, $N;
function Eg() {
  if ($N) return gf;
  $N = 1;
  var e = cI(), n = mH(), r = dI();
  function i(a) {
    return r(a) ? e(a, !0) : n(a);
  }
  return gf = i, gf;
}
var vf, TN;
function pH() {
  if (TN) return vf;
  TN = 1;
  var e = Wo(), n = Eg();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return vf = r, vf;
}
var qs = { exports: {} };
qs.exports;
var ON;
function fH() {
  return ON || (ON = 1, (function(e, n) {
    var r = Wr(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? r.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
    function u(p, d) {
      if (d)
        return p.slice();
      var f = p.length, h = l ? l(f) : new p.constructor(f);
      return p.copy(h), h;
    }
    e.exports = u;
  })(qs, qs.exports)), qs.exports;
}
var kf, DN;
function hH() {
  if (DN) return kf;
  DN = 1;
  function e(n, r) {
    var i = -1, a = n.length;
    for (r || (r = Array(a)); ++i < a; )
      r[i] = n[i];
    return r;
  }
  return kf = e, kf;
}
var bf, PN;
function yH() {
  if (PN) return bf;
  PN = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = 0, s = []; ++i < a; ) {
      var l = n[i];
      r(l, i, n) && (s[o++] = l);
    }
    return s;
  }
  return bf = e, bf;
}
var xf, RN;
function mI() {
  if (RN) return xf;
  RN = 1;
  function e() {
    return [];
  }
  return xf = e, xf;
}
var _f, AN;
function $g() {
  if (AN) return _f;
  AN = 1;
  var e = yH(), n = mI(), r = Object.prototype, i = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(l) {
      return i.call(s, l);
    }));
  } : n;
  return _f = o, _f;
}
var Sf, LN;
function gH() {
  if (LN) return Sf;
  LN = 1;
  var e = Wo(), n = $g();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return Sf = r, Sf;
}
var Nf, VN;
function Tg() {
  if (VN) return Nf;
  VN = 1;
  var e = uI(), n = e(Object.getPrototypeOf, Object);
  return Nf = n, Nf;
}
var jf, zN;
function pI() {
  if (zN) return jf;
  zN = 1;
  var e = jg(), n = Tg(), r = $g(), i = mI(), a = Object.getOwnPropertySymbols, o = a ? function(s) {
    for (var l = []; s; )
      e(l, r(s)), s = n(s);
    return l;
  } : i;
  return jf = o, jf;
}
var wf, UN;
function vH() {
  if (UN) return wf;
  UN = 1;
  var e = Wo(), n = pI();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return wf = r, wf;
}
var Cf, MN;
function fI() {
  if (MN) return Cf;
  MN = 1;
  var e = jg(), n = yi();
  function r(i, a, o) {
    var s = a(i);
    return n(i) ? s : e(s, o(i));
  }
  return Cf = r, Cf;
}
var If, BN;
function kH() {
  if (BN) return If;
  BN = 1;
  var e = fI(), n = $g(), r = Fg();
  function i(a) {
    return e(a, r, n);
  }
  return If = i, If;
}
var Ff, qN;
function hI() {
  if (qN) return Ff;
  qN = 1;
  var e = fI(), n = pI(), r = Eg();
  function i(a) {
    return e(a, r, n);
  }
  return Ff = i, Ff;
}
var Ef, HN;
function bH() {
  if (HN) return Ef;
  HN = 1;
  var e = qi(), n = Wr(), r = e(n, "DataView");
  return Ef = r, Ef;
}
var $f, WN;
function xH() {
  if (WN) return $f;
  WN = 1;
  var e = qi(), n = Wr(), r = e(n, "Promise");
  return $f = r, $f;
}
var Tf, KN;
function _H() {
  if (KN) return Tf;
  KN = 1;
  var e = qi(), n = Wr(), r = e(n, "Set");
  return Tf = r, Tf;
}
var Of, GN;
function SH() {
  if (GN) return Of;
  GN = 1;
  var e = qi(), n = Wr(), r = e(n, "WeakMap");
  return Of = r, Of;
}
var Df, YN;
function Og() {
  if (YN) return Df;
  YN = 1;
  var e = bH(), n = bg(), r = xH(), i = _H(), a = SH(), o = Ea(), s = Q1(), l = "[object Map]", u = "[object Object]", p = "[object Promise]", d = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", v = s(e), C = s(n), j = s(r), N = s(i), x = s(a), g = o;
  return (e && g(new e(new ArrayBuffer(1))) != h || n && g(new n()) != l || r && g(r.resolve()) != p || i && g(new i()) != d || a && g(new a()) != f) && (g = function(P) {
    var E = o(P), I = E == u ? P.constructor : void 0, w = I ? s(I) : "";
    if (w)
      switch (w) {
        case v:
          return h;
        case C:
          return l;
        case j:
          return p;
        case N:
          return d;
        case x:
          return f;
      }
    return E;
  }), Df = g, Df;
}
var Pf, JN;
function NH() {
  if (JN) return Pf;
  JN = 1;
  var e = Object.prototype, n = e.hasOwnProperty;
  function r(i) {
    var a = i.length, o = new i.constructor(a);
    return a && typeof i[0] == "string" && n.call(i, "index") && (o.index = i.index, o.input = i.input), o;
  }
  return Pf = r, Pf;
}
var Rf, QN;
function jH() {
  if (QN) return Rf;
  QN = 1;
  var e = Wr(), n = e.Uint8Array;
  return Rf = n, Rf;
}
var Af, XN;
function Dg() {
  if (XN) return Af;
  XN = 1;
  var e = jH();
  function n(r) {
    var i = new r.constructor(r.byteLength);
    return new e(i).set(new e(r)), i;
  }
  return Af = n, Af;
}
var Lf, ZN;
function wH() {
  if (ZN) return Lf;
  ZN = 1;
  var e = Dg();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return Lf = n, Lf;
}
var Vf, ej;
function CH() {
  if (ej) return Vf;
  ej = 1;
  var e = /\w*$/;
  function n(r) {
    var i = new r.constructor(r.source, e.exec(r));
    return i.lastIndex = r.lastIndex, i;
  }
  return Vf = n, Vf;
}
var zf, nj;
function IH() {
  if (nj) return zf;
  nj = 1;
  var e = Ho(), n = e ? e.prototype : void 0, r = n ? n.valueOf : void 0;
  function i(a) {
    return r ? Object(r.call(a)) : {};
  }
  return zf = i, zf;
}
var Uf, tj;
function FH() {
  if (tj) return Uf;
  tj = 1;
  var e = Dg();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return Uf = n, Uf;
}
var Mf, rj;
function EH() {
  if (rj) return Mf;
  rj = 1;
  var e = Dg(), n = wH(), r = CH(), i = IH(), a = FH(), o = "[object Boolean]", s = "[object Date]", l = "[object Map]", u = "[object Number]", p = "[object RegExp]", d = "[object Set]", f = "[object String]", h = "[object Symbol]", v = "[object ArrayBuffer]", C = "[object DataView]", j = "[object Float32Array]", N = "[object Float64Array]", x = "[object Int8Array]", g = "[object Int16Array]", P = "[object Int32Array]", E = "[object Uint8Array]", I = "[object Uint8ClampedArray]", w = "[object Uint16Array]", A = "[object Uint32Array]";
  function H(Y, ne, W) {
    var B = Y.constructor;
    switch (ne) {
      case v:
        return e(Y);
      case o:
      case s:
        return new B(+Y);
      case C:
        return n(Y, W);
      case j:
      case N:
      case x:
      case g:
      case P:
      case E:
      case I:
      case w:
      case A:
        return a(Y, W);
      case l:
        return new B();
      case u:
      case f:
        return new B(Y);
      case p:
        return r(Y);
      case d:
        return new B();
      case h:
        return i(Y);
    }
  }
  return Mf = H, Mf;
}
var Bf, ij;
function $H() {
  if (ij) return Bf;
  ij = 1;
  var e = $a(), n = Object.create, r = /* @__PURE__ */ (function() {
    function i() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (n)
        return n(a);
      i.prototype = a;
      var o = new i();
      return i.prototype = void 0, o;
    };
  })();
  return Bf = r, Bf;
}
var qf, aj;
function TH() {
  if (aj) return qf;
  aj = 1;
  var e = $H(), n = Tg(), r = Ig();
  function i(a) {
    return typeof a.constructor == "function" && !r(a) ? e(n(a)) : {};
  }
  return qf = i, qf;
}
var Hf, oj;
function OH() {
  if (oj) return Hf;
  oj = 1;
  var e = Og(), n = Bi(), r = "[object Map]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Hf = i, Hf;
}
var Wf, sj;
function DH() {
  if (sj) return Wf;
  sj = 1;
  var e = OH(), n = wg(), r = Cg(), i = r && r.isMap, a = i ? n(i) : e;
  return Wf = a, Wf;
}
var Kf, lj;
function PH() {
  if (lj) return Kf;
  lj = 1;
  var e = Og(), n = Bi(), r = "[object Set]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Kf = i, Kf;
}
var Gf, cj;
function RH() {
  if (cj) return Gf;
  cj = 1;
  var e = PH(), n = wg(), r = Cg(), i = r && r.isSet, a = i ? n(i) : e;
  return Gf = a, Gf;
}
var Yf, uj;
function AH() {
  if (uj) return Yf;
  uj = 1;
  var e = tH(), n = rH(), r = xg(), i = uH(), a = pH(), o = fH(), s = hH(), l = gH(), u = vH(), p = kH(), d = hI(), f = Og(), h = NH(), v = EH(), C = TH(), j = yi(), N = lI(), x = DH(), g = $a(), P = RH(), E = Fg(), I = Eg(), w = 1, A = 2, H = 4, Y = "[object Arguments]", ne = "[object Array]", W = "[object Boolean]", B = "[object Date]", D = "[object Error]", M = "[object Function]", Z = "[object GeneratorFunction]", je = "[object Map]", ge = "[object Number]", ye = "[object Object]", ke = "[object RegExp]", q = "[object Set]", _e = "[object String]", De = "[object Symbol]", G = "[object WeakMap]", Ye = "[object ArrayBuffer]", sn = "[object DataView]", Ie = "[object Float32Array]", Ue = "[object Float64Array]", Pe = "[object Int8Array]", Be = "[object Int16Array]", Le = "[object Int32Array]", Xe = "[object Uint8Array]", Fe = "[object Uint8ClampedArray]", Me = "[object Uint16Array]", nn = "[object Uint32Array]", se = {};
  se[Y] = se[ne] = se[Ye] = se[sn] = se[W] = se[B] = se[Ie] = se[Ue] = se[Pe] = se[Be] = se[Le] = se[je] = se[ge] = se[ye] = se[ke] = se[q] = se[_e] = se[De] = se[Xe] = se[Fe] = se[Me] = se[nn] = !0, se[D] = se[M] = se[G] = !1;
  function le(Se, Ae, Re, yn, Q, $) {
    var z, X = Ae & w, ae = Ae & A, V = Ae & H;
    if (Re && (z = Q ? Re(Se, yn, Q, $) : Re(Se)), z !== void 0)
      return z;
    if (!g(Se))
      return Se;
    var J = j(Se);
    if (J) {
      if (z = h(Se), !X)
        return s(Se, z);
    } else {
      var de = f(Se), xe = de == M || de == Z;
      if (N(Se))
        return o(Se, X);
      if (de == ye || de == Y || xe && !Q) {
        if (z = ae || xe ? {} : C(Se), !X)
          return ae ? u(Se, a(z, Se)) : l(Se, i(z, Se));
      } else {
        if (!se[de])
          return Q ? Se : {};
        z = v(Se, de, X);
      }
    }
    $ || ($ = new e());
    var $e = $.get(Se);
    if ($e)
      return $e;
    $.set(Se, z), P(Se) ? Se.forEach(function(on) {
      z.add(le(on, Ae, Re, on, Se, $));
    }) : x(Se) && Se.forEach(function(on, pn) {
      z.set(pn, le(on, Ae, Re, pn, Se, $));
    });
    var tn = V ? ae ? d : p : ae ? I : E, gn = J ? void 0 : tn(Se);
    return n(gn || Se, function(on, pn) {
      gn && (pn = on, on = Se[pn]), r(z, pn, le(on, Ae, Re, pn, Se, $));
    }), z;
  }
  return Yf = le, Yf;
}
var Jf, dj;
function LH() {
  if (dj) return Jf;
  dj = 1;
  function e(n) {
    var r = n == null ? 0 : n.length;
    return r ? n[r - 1] : void 0;
  }
  return Jf = e, Jf;
}
var Qf, mj;
function VH() {
  if (mj) return Qf;
  mj = 1;
  function e(n, r, i) {
    var a = -1, o = n.length;
    r < 0 && (r = -r > o ? 0 : o + r), i = i > o ? o : i, i < 0 && (i += o), o = r > i ? 0 : i - r >>> 0, r >>>= 0;
    for (var s = Array(o); ++a < o; )
      s[a] = n[a + r];
    return s;
  }
  return Qf = e, Qf;
}
var Xf, pj;
function zH() {
  if (pj) return Xf;
  pj = 1;
  var e = nI(), n = VH();
  function r(i, a) {
    return a.length < 2 ? i : e(i, n(a, 0, -1));
  }
  return Xf = r, Xf;
}
var Zf, fj;
function UH() {
  if (fj) return Zf;
  fj = 1;
  var e = Ta(), n = LH(), r = zH(), i = ql(), a = Object.prototype, o = a.hasOwnProperty;
  function s(l, u) {
    u = e(u, l);
    var p = -1, d = u.length;
    if (!d)
      return !0;
    for (; ++p < d; ) {
      var f = i(u[p]);
      if (f === "__proto__" && !o.call(l, "__proto__") || (f === "constructor" || f === "prototype") && p < d - 1)
        return !1;
    }
    var h = r(l, u);
    return h == null || delete h[i(n(u))];
  }
  return Zf = s, Zf;
}
var eh, hj;
function MH() {
  if (hj) return eh;
  hj = 1;
  var e = Ea(), n = Tg(), r = Bi(), i = "[object Object]", a = Function.prototype, o = Object.prototype, s = a.toString, l = o.hasOwnProperty, u = s.call(Object);
  function p(d) {
    if (!r(d) || e(d) != i)
      return !1;
    var f = n(d);
    if (f === null)
      return !0;
    var h = l.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && s.call(h) == u;
  }
  return eh = p, eh;
}
var nh, yj;
function BH() {
  if (yj) return nh;
  yj = 1;
  var e = MH();
  function n(r) {
    return e(r) ? void 0 : r;
  }
  return nh = n, nh;
}
var th, gj;
function qH() {
  if (gj) return th;
  gj = 1;
  var e = eI(), n = AH(), r = UH(), i = Ta(), a = Wo(), o = BH(), s = aI(), l = hI(), u = 1, p = 2, d = 4, f = s(function(h, v) {
    var C = {};
    if (h == null)
      return C;
    var j = !1;
    v = e(v, function(x) {
      return x = i(x, h), j || (j = x.length > 1), x;
    }), a(h, l(h), C), j && (C = n(C, u | p | d, o));
    for (var N = v.length; N--; )
      r(C, v[N]);
    return C;
  });
  return th = f, th;
}
qH();
var HH = iI();
const WH = /* @__PURE__ */ G1(HH), na = ({
  transformValue: e = WH,
  label: n,
  helpIcon: r,
  className: i,
  ...a
}) => {
  const {
    controller: { field: o },
    controllerProps: { name: s }
  } = sI(a);
  return /* @__PURE__ */ wo.jsxs(b, { gap: "200", alignItems: "center", className: i, children: [
    /* @__PURE__ */ wo.jsx(
      Ks,
      {
        ...o,
        id: s,
        checked: e(o.value),
        disabled: a.componentProps?.disabled,
        onChange: (l) => {
          a.componentProps?.onChange?.(l), o.onChange(e(l.target.checked));
        }
      }
    ),
    n && /* @__PURE__ */ wo.jsx(mw, { htmlFor: s, helpIcon: r, children: n })
  ] });
}, vj = (e) => {
  const { controller: n, controllerProps: r, fieldWrapperProps: i } = J6(e);
  return /* @__PURE__ */ wo.jsx(We, { ...i, children: /* @__PURE__ */ wo.jsx(
    mr,
    {
      ...e.componentProps,
      ...n.field,
      value: e.componentProps?.type === "number" && isNaN(n.field.value) ? "" : n.field.value ?? "",
      onBlur: (a) => {
        e.componentProps?.onBlur?.(a), n.field.onBlur();
      },
      onChange: (a) => {
        e.componentProps?.onChange?.(a), n.field.onChange(
          e.componentProps?.type === "number" ? a.target.valueAsNumber : a
        );
      },
      id: r.name,
      "aria-disabled": i.disabled,
      disabled: i.disabled,
      "aria-required": i.required,
      required: i.required,
      status: We.getStatus(i.meta)
    }
  ) });
}, ey = [
  {
    key: "rivoLoyaltyApiKey",
    defaultValue: "",
    secret: !0,
    type: "string"
  },
  {
    key: pg,
    defaultValue: "",
    secret: !1,
    type: "string"
  },
  {
    key: "rivoLoyaltyShowOrders",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyShowLoyalty",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyAdjustLoyaltyPoints",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyShowFavoriteProducts",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyShowPointsRedemptions",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  }
], kj = "RIVOLOYALTY", _s = "Rivo Loyalty", KH = {
  enabled: !1,
  name: "",
  rivoLoyaltyApiKey: "",
  [pg]: "",
  rivoLoyaltyShowOrders: !0,
  rivoLoyaltyShowLoyalty: !0,
  rivoLoyaltyAdjustLoyaltyPoints: !0,
  rivoLoyaltyShowFavoriteProducts: !0,
  rivoLoyaltyShowPointsRedemptions: !0
}, GH = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = Jq({
    mode: "onChange",
    defaultValues: KH
  }), {
    create: l,
    update: u,
    remove: p,
    isLoading: d,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = hr({
    integrationId: e,
    integrationType: kj,
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: C,
    error: j,
    isWidgetUnknown: N,
    refetch: x,
    widgetConfiguration: g
  } = yr({
    integrationId: e,
    fieldDefinitions: ey,
    form: s,
    onMisconfigured: v
  }), { renderConditions: P, setRenderConditions: E, renderConditionsForSubmit: I } = gr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), w = (H) => kr(H, {
    fieldDefinitions: ey,
    isCreationMode: o,
    create: l,
    update: u,
    renderConditions: I
  }), A = s.watch("name");
  return /* @__PURE__ */ ve.jsxs(
    vr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: w,
      error: j ?? f,
      onRetry: j ? x : void 0,
      isLoading: d || C,
      isWidgetUnknown: N,
      children: [
        h && /* @__PURE__ */ ve.jsx(br, { cause: h }),
        /* @__PURE__ */ ve.jsxs(tt, { children: [
          /* @__PURE__ */ ve.jsx(ie, { children: /* @__PURE__ */ ve.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ ve.jsx(
            na,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ve.jsx(ie, { span: 3, children: /* @__PURE__ */ ve.jsx(
            vj,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ve.jsx(ie, { span: 3 }),
          /* @__PURE__ */ ve.jsx(ie, { span: 3, children: /* @__PURE__ */ ve.jsx(
            vj,
            {
              name: "rivoLoyaltyShopifyApiHostName",
              label: "Shopify API host name",
              control: s.control,
              rules: {
                required: "Shopify API host name is required",
                validate: (H) => oy(H) ?? void 0
              },
              componentProps: {
                placeholder: 'Host name of your Shopify shop, e.g. "my-webshop.myshopify.com"',
                prefix: "https://"
              }
            }
          ) }),
          /* @__PURE__ */ ve.jsx(ie, { span: 3 }),
          /* @__PURE__ */ ve.jsx(ie, { span: 3, children: /* @__PURE__ */ ve.jsx(
            mi,
            {
              name: "rivoLoyaltyApiKey",
              label: "API key",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API key is required" },
              componentProps: {
                placeholder: "Insert your Rivo API key",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ve.jsx(ie, { span: 3 }),
          /* @__PURE__ */ ve.jsx(ie, { span: 3, children: /* @__PURE__ */ ve.jsx(We, { label: "Show orders overview", children: /* @__PURE__ */ ve.jsx(
            na,
            {
              name: "rivoLoyaltyShowOrders",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ve.jsx(ie, { span: 3 }),
          /* @__PURE__ */ ve.jsx(ie, { span: 3, children: /* @__PURE__ */ ve.jsx(We, { label: "Show loyalty", children: /* @__PURE__ */ ve.jsx(
            na,
            {
              name: "rivoLoyaltyShowLoyalty",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ve.jsx(ie, { span: 3 }),
          /* @__PURE__ */ ve.jsx(ie, { span: 3, children: /* @__PURE__ */ ve.jsx(We, { label: "Allow adjusting loyalty points", children: /* @__PURE__ */ ve.jsx(
            na,
            {
              name: "rivoLoyaltyAdjustLoyaltyPoints",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ve.jsx(ie, { span: 3 }),
          /* @__PURE__ */ ve.jsx(ie, { span: 3, children: /* @__PURE__ */ ve.jsx(We, { label: "Show favorite products", children: /* @__PURE__ */ ve.jsx(
            na,
            {
              name: "rivoLoyaltyShowFavoriteProducts",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ve.jsx(ie, { span: 3 }),
          /* @__PURE__ */ ve.jsx(ie, { span: 3, children: /* @__PURE__ */ ve.jsx(We, { label: "Show available rewards", children: /* @__PURE__ */ ve.jsx(
            na,
            {
              name: "rivoLoyaltyShowPointsRedemptions",
              control: s.control
            }
          ) }) }),
          a && P !== null && /* @__PURE__ */ ve.jsx(ie, { children: a({
            value: P,
            onChange: E,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ ve.jsx(
          xr,
          {
            integrationType: kj,
            integrationId: e,
            widgetName: A,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => p(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ ve.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ ve.jsx(
                he,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ ve.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ ve.jsxs(O.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  _s,
                  " integration, all links between Dixa and ",
                  _s,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ ve.jsxs(O.Paragraph, { children: [
                  "All data in ",
                  _s,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ ve.jsxs(O.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  _s,
                  " ",
                  'integration "',
                  A,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._banner_d9pot_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-400)}._list_d9pot_8{margin:var(--dixa-size-spacer-200) 0;padding-left:var(--dixa-size-spacer-500)}._list_d9pot_8 li{margin-bottom:var(--dixa-size-spacer-200)}._list_d9pot_8 li:last-child{margin-bottom:0}._list_alvh6_1{padding:0}._listItem_alvh6_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_alvh6_4:last-child{border-bottom:none}._listItemEdit_alvh6_11{cursor:pointer}._fullWidth_alvh6_15{width:100%}._boxWrapper_alvh6_19{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._modal_1vkwz_1{width:800px}._disabled_1vkwz_5 input{color:var(--dixa-typography-color-tertiary);background-color:var(--dixa-color-neutral-100);pointer-events:none}._wrapper_10fld_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300) var(--dixa-size-spacer-300) var(--dixa-size-spacer-250);background-color:var(--dixa-color-neutral-100)}._copyIcon_10fld_7{cursor:pointer;color:var(--dixa-typography-color-secondary)}._creationModal_pbe64_1{width:800px}._detailsModal_pbe64_5{width:600px}._percentageSuffix_pbe64_9{background-color:var(--dixa-color-neutral-100);padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-250)}._modal_11d6e_1{width:600px}._modalBody_11d6e_4{max-height:500px;overflow-y:auto}._codeContainer_11d6e_9{margin:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100) 0 0;padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._modal_1wlra_1{width:800px}._clickableIcon_33mqm_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._productTableHeader_6h6pl_1>tr>th{height:var(--dixa-size-spacer-300)}._productImage_6h6pl_5{width:50px;height:50px}._modal_1mprq_1{width:900px}._copyIcon_1dlzg_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._modal_21e62_1{max-width:900px}._modal_al73g_1{width:600px}._editIcon_1yp2k_1,._copyIcon_1yp2k_2,._icon_cddi1_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._link_cddi1_6{font-size:var(--dixa-typography-size-200)}._copyIcon_yc0fe_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._order_yc0fe_6{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_yc0fe_6:hover,._orderIsOpen_yc0fe_14{border-color:var(--dixa-color-neutral-400)}._orderHeader_yc0fe_17{cursor:pointer}._segmentName_1dkhk_1{overflow:hidden;white-space:nowrap}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var rh = { exports: {} }, uo = {}, bj;
function YH() {
  if (bj) return uo;
  bj = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return uo.Fragment = r, uo.jsx = s, uo.jsxs = s, uo;
}
var Ss = {}, xj;
function JH() {
  return xj || (xj = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        P("error", t, m);
      }
    }
    function P(t, c, m) {
      {
        var y = x.ReactDebugCurrentFrame, F = y.getStackAddendum();
        F !== "" && (c += "%s", m = m.concat([F]));
        var T = m.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var E = !1, I = !1, w = !1, A = !1, H = !1, Y;
    Y = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ne(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || H || t === a || t === p || t === d || A || t === v || E || I || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function W(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var F = c.displayName || c.name || "";
      return F !== "" ? m + "(" + F + ")" : m;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function D(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var m = t;
            return B(m._context) + ".Provider";
          case u:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : D(t.type) || "Memo";
          case h: {
            var F = t, T = F._payload, S = F._init;
            try {
              return D(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var M = Object.assign, Z = 0, je, ge, ye, ke, q, _e, De;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function Ye() {
      {
        if (Z === 0) {
          je = console.log, ge = console.info, ye = console.warn, ke = console.error, q = console.group, _e = console.groupCollapsed, De = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function sn() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: M({}, t, {
              value: je
            }),
            info: M({}, t, {
              value: ge
            }),
            warn: M({}, t, {
              value: ye
            }),
            error: M({}, t, {
              value: ke
            }),
            group: M({}, t, {
              value: q
            }),
            groupCollapsed: M({}, t, {
              value: _e
            }),
            groupEnd: M({}, t, {
              value: De
            })
          });
        }
        Z < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = x.ReactCurrentDispatcher, Ue;
    function Pe(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (F) {
            var y = F.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Le;
    {
      var Xe = typeof WeakMap == "function" ? WeakMap : Map;
      Le = new Xe();
    }
    function Fe(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Le.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      Be = !0;
      var F = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ye();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (re) {
              y = re;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (re) {
              y = re;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            y = re;
          }
          t();
        }
      } catch (re) {
        if (re && y && typeof re.stack == "string") {
          for (var _ = re.stack.split(`
`), ee = y.stack.split(`
`), L = _.length - 1, U = ee.length - 1; L >= 1 && U >= 0 && _[L] !== ee[U]; )
            U--;
          for (; L >= 1 && U >= 0; L--, U--)
            if (_[L] !== ee[U]) {
              if (L !== 1 || U !== 1)
                do
                  if (L--, U--, U < 0 || _[L] !== ee[U]) {
                    var ce = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && ce.includes("<anonymous>") && (ce = ce.replace("<anonymous>", t.displayName)), typeof t == "function" && Le.set(t, ce), ce;
                  }
                while (L >= 1 && U >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = F;
      }
      var ze = t ? t.displayName || t.name : "", Oe = ze ? Pe(ze) : "";
      return typeof t == "function" && Le.set(t, Oe), Oe;
    }
    function Me(t, c, m) {
      return Fe(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Fe(t, nn(t));
      if (typeof t == "string")
        return Pe(t);
      switch (t) {
        case p:
          return Pe("Suspense");
        case d:
          return Pe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return Me(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, F = y._payload, T = y._init;
            try {
              return se(T(F), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Se = {}, Ae = x.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(m);
      } else
        Ae.setExtraStackFrame(null);
    }
    function yn(t, c, m, y, F) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + m + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              _ = t[S](c, S, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Re(F), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, S, typeof _), Re(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Re(F), g("Failed %s type: %s", m, _.message), Re(null));
          }
      }
    }
    var Q = Array.isArray;
    function $(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ae(t);
    }
    var J = x.ReactCurrentOwner, de = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, xe, $e;
    function tn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && J.current;
    }
    function pn(t, c) {
      {
        var m = function() {
          xe || (xe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function Fn(t, c) {
      {
        var m = function() {
          $e || ($e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, m, y, F, T, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: F
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, m, y, F) {
      {
        var T, S = {}, _ = null, ee = null;
        m !== void 0 && (V(m), _ = "" + m), gn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ee = c.ref, on(c));
        for (T in c)
          le.call(c, T) && !de.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (T in L)
            S[T] === void 0 && (S[T] = L[T]);
        }
        if (_ || ee) {
          var U = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, U), ee && Fn(S, U);
        }
        return xn(t, _, ee, F, y, J.current, S);
      }
    }
    var en = x.ReactCurrentOwner, vn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        vn.setExtraStackFrame(m);
      } else
        vn.setExtraStackFrame(null);
    }
    var un;
    un = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = D(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Nn = {};
    function Rn(t) {
      {
        var c = jn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function kn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Rn(c);
        if (Nn[m])
          return;
        Nn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + D(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Ve(null);
      }
    }
    function _n(t, c) {
      {
        if (typeof t != "object")
          return;
        if ($(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            dn(y) && kn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var F = N(t);
          if (typeof F == "function" && F !== t.entries)
            for (var T = F.call(t), S; !(S = T.next()).done; )
              dn(S.value) && kn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = D(c);
          yn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !un) {
          un = !0;
          var F = D(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", F || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, m, y, F, T) {
      {
        var S = ne(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = Bn();
          ee ? _ += ee : _ += jn();
          var L;
          t === null ? L = "null" : $(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (D(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var U = En(t, c, m, F, T);
        if (U == null)
          return U;
        if (S) {
          var ce = c.children;
          if (ce !== void 0)
            if (y)
              if ($(ce)) {
                for (var ze = 0; ze < ce.length; ze++)
                  _n(ce[ze], t);
                Object.freeze && Object.freeze(ce);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _n(ce, t);
        }
        if (le.call(c, "key")) {
          var Oe = D(t), re = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), mn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Oe + mn]) {
            var Dn = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Oe, Dn, Oe), Cn[Oe + mn] = !0;
          }
        }
        return t === i ? Ln(U) : An(U), U;
      }
    }
    function Vn(t, c, m) {
      return wn(t, c, m, !0);
    }
    function qn(t, c, m) {
      return wn(t, c, m, !1);
    }
    var zn = qn, Wn = Vn;
    Ss.Fragment = i, Ss.jsx = zn, Ss.jsxs = Wn;
  })()), Ss;
}
var _j;
function QH() {
  return _j || (_j = 1, process.env.NODE_ENV === "production" ? rh.exports = YH() : rh.exports = JH()), rh.exports;
}
var k = QH();
const Sj = "__PairingContext__", XH = () => globalThis[Sj] ?? (() => {
  const e = dw({});
  return globalThis[Sj] = e, e;
})(), ZH = XH(), eW = () => cy(ZH), nW = "_banner_d9pot_1", tW = "_list_d9pot_8", Nj = {
  banner: nW,
  list: tW
}, jj = "https://apps.shopify.com/dixa-dashboard", rW = {
  install: {
    description: "Connect your Shopify store to Dixa with just a few clicks.",
    listHeading: "How it works:",
    listType: "ol",
    listItems: [
      'Click "Install Dixa app in Shopify" below to start the connection',
      "You'll be redirected to the Shopify App Store to install the Dixa app",
      "After installing, the connection is set up automatically",
      "Return to the Settings > Integrations overview to see your newly connected Shopify integration"
    ],
    buttonText: "Install Dixa app in Shopify",
    buttonVariant: "primary"
  },
  migration: {
    description: "This integration uses a legacy connection method. We recommend upgrading to the Dixa Shopify app for a simpler, more reliable connection that doesn't require manual credential management.",
    listHeading: "Benefits of upgrading:",
    listType: "ul",
    listItems: [
      "No need to manage Client ID and Client Secret",
      "Automatic token refresh handled by the app",
      "Easier setup for new stores"
    ],
    buttonText: "Upgrade via Shopify App Store",
    buttonVariant: "primary"
  }
}, yI = ({
  label: e,
  bannerVariant: n = "install"
}) => {
  const { initiateFromDixa: r } = eW(), [i, a] = ue(!1), [o, s] = ue(null), l = rW[n], u = async () => {
    if (n === "install" && r) {
      a(!0), s(null);
      try {
        const d = await r();
        window.open(
          d ?? jj,
          "_blank",
          "noopener,noreferrer"
        );
      } catch {
        s("Failed to start the connection. Please try again.");
      } finally {
        a(!1);
      }
      return;
    }
    window.open(jj, "_blank", "noopener,noreferrer");
  }, p = l.listType === "ol" ? "ol" : "ul";
  return /* @__PURE__ */ k.jsx(ie, { children: /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", className: Nj.banner, children: [
    /* @__PURE__ */ k.jsx(O.Heading, { variant: "heading-2", children: e }),
    /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ k.jsx(b, { children: /* @__PURE__ */ k.jsx(he, { size: 30, name: "shopify", color: "green.500" }) }),
      /* @__PURE__ */ k.jsx(O.Paragraph, { children: l.description })
    ] }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsx(O.Heading, { variant: "heading-3", children: l.listHeading }),
      /* @__PURE__ */ k.jsx(O.Paragraph, { as: "div", children: /* @__PURE__ */ k.jsx(p, { className: Nj.list, children: l.listItems.map((d, f) => /* @__PURE__ */ k.jsx("li", { children: d }, f)) }) })
    ] }),
    o && /* @__PURE__ */ k.jsx(O.Paragraph, { color: "danger", children: o }),
    /* @__PURE__ */ k.jsx(b, { margin: "200 0 0 0", children: /* @__PURE__ */ k.jsx(
      et,
      {
        onClick: u,
        icon: "external-link",
        variant: l.buttonVariant,
        disabled: i,
        children: i ? /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(hn, { size: 16 }),
          "Connecting…"
        ] }) : l.buttonText
      }
    ) })
  ] }) });
}, iW = (e) => /* @__PURE__ */ k.jsx(yI, { ...e, bannerVariant: "install" }), aW = (e) => /* @__PURE__ */ k.jsx(yI, { ...e, bannerVariant: "migration" }), oW = [
  {
    key: "shopifyClientId",
    label: "Client ID",
    placeholder: "Client ID from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "shopifyClientSecret",
    label: "Client Secret",
    placeholder: "Client Secret from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], sW = [
  {
    key: "apiAccessToken",
    label: "API Access Token",
    placeholder: "API access token from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], lW = [
  {
    key: "marketplaceInstallBanner",
    label: "Connect your Shopify store",
    secret: !1,
    type: "custom",
    component: iW
  }
], cW = [
  {
    key: "apiHostName",
    label: "Connected Shopify store",
    placeholder: "",
    required: !1,
    secret: !1,
    type: "input",
    prefix: "https://",
    readOnly: !0
  }
], wj = [
  {
    key: "migrationBanner",
    label: "Upgrade to simplified connection",
    secret: !1,
    type: "custom",
    component: aW,
    additionalProperties: { renderAboveForm: !0 }
  }
], gI = [
  {
    key: "displayRefundOrder",
    label: "Display the refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "displayPartialRefundOrder",
    label: "Displays the partial refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCancelOrder",
    label: "Displays the cancel order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableEditShippingAddress",
    label: 'Enable the "edit shipping address" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrdersOverview",
    label: "Displays short orders overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    // We keep the key name to the first version which only showed marketing
    // consent for email in order to not change the existing integration setting
    // for customers. The current version shows both email and phone marketing consent.
    key: "displayEmailMarketingConsent",
    label: "Displays the email and phone marketing consent status of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaySegmentMembership",
    label: "Displays the segment memberships of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodes",
    label: "Displays available discount codes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodeCreation",
    label: "Displays the discount code creation button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateOrder",
    label: "Displays the create order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateDraftOrder",
    label: "Displays the create draft order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDuplicateOrder",
    label: "Displays the duplicate order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], Cj = [
  {
    key: "apiHostName",
    label: "API host name",
    placeholder: 'Host name of your shop, e.g. "my-webshop.myshopify.com"',
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => oy(e)
  },
  ...gI
];
var aa = /* @__PURE__ */ ((e) => (e.Invalid = "INVALID", e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(aa || {}), Di = /* @__PURE__ */ ((e) => (e.ConfirmedOptIn = "CONFIRMED_OPT_IN", e.SingleOptIn = "SINGLE_OPT_IN", e.Unknown = "UNKNOWN", e))(Di || {}), Lr = /* @__PURE__ */ ((e) => (e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Redacted = "REDACTED", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(Lr || {}), vI = /* @__PURE__ */ ((e) => (e.All = "ALL", e))(vI || {}), wi = /* @__PURE__ */ ((e) => (e.Customer = "CUSTOMER", e.Declined = "DECLINED", e.Fraud = "FRAUD", e.Inventory = "INVENTORY", e.Other = "OTHER", e.Staff = "STAFF", e))(wi || {}), Zr = /* @__PURE__ */ ((e) => (e.Authorized = "AUTHORIZED", e.Expired = "EXPIRED", e.Paid = "PAID", e.PartiallyPaid = "PARTIALLY_PAID", e.PartiallyRefunded = "PARTIALLY_REFUNDED", e.Pending = "PENDING", e.Refunded = "REFUNDED", e.Voided = "VOIDED", e))(Zr || {}), Hs = /* @__PURE__ */ ((e) => (e.Fulfilled = "FULFILLED", e.Partial = "PARTIAL", e.Restocked = "RESTOCKED", e))(Hs || {}), kI = /* @__PURE__ */ ((e) => (e.Authorization = "AUTHORIZATION", e.Capture = "CAPTURE", e.Change = "CHANGE", e.EmvAuthorization = "EMV_AUTHORIZATION", e.Refund = "REFUND", e.Sale = "SALE", e.SuggestedRefund = "SUGGESTED_REFUND", e.Void = "VOID", e))(kI || {});
const uW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refundCreate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, dW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, mW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderCancel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "orderId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reason" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelReason" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelRefundMethodInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "restock" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "staffNote" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCancel" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "notifyCustomer" }, value: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } } }, { kind: "Argument", name: { kind: "Name", value: "orderId" }, value: { kind: "Variable", name: { kind: "Name", value: "orderId" } } }, { kind: "Argument", name: { kind: "Name", value: "reason" }, value: { kind: "Variable", name: { kind: "Name", value: "reason" } } }, { kind: "Argument", name: { kind: "Name", value: "refundMethod" }, value: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } } }, { kind: "Argument", name: { kind: "Name", value: "restock" }, value: { kind: "Variable", name: { kind: "Name", value: "restock" } } }, { kind: "Argument", name: { kind: "Name", value: "staffNote" }, value: { kind: "Variable", name: { kind: "Name", value: "staffNote" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "job" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "done" } }] } }, { kind: "Field", name: { kind: "Name", value: "orderCancelUserErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, pW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createCustomer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_CustomerInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "Field", name: { kind: "Name", value: "customer" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }] } }, { kind: "Field", name: { kind: "Name", value: "taxExempt" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] }, fW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "order" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOrderInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "options" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOptionsInput" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } }, { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, hW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDraftOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DraftOrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrder" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, yW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDiscountCode" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasicInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountCodeBasicCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "basicCodeDiscount" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNode" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "startsAt" } }, { kind: "Field", name: { kind: "Name", value: "endsAt" } }, { kind: "Field", name: { kind: "Name", value: "usageLimit" } }, { kind: "Field", name: { kind: "Name", value: "appliesOncePerCustomer" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, gW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refuncLineItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refund" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, vW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }] } }] } }] } }] } }] }, kW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "segments" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, bW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "customerSegmentMembership" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerSegmentMembership" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customerId" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "segmentIds" }, value: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "memberships" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segmentId" } }, { kind: "Field", name: { kind: "Name", value: "isMember" } }] } }] } }] } }] } }] }, xW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countriesInShippingZones" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countryCodes" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "customers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "numberOfOrders" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "verifiedEmail" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }] } }] } }] } }] } }] } }] } }] }, _W = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "sortKey" }, value: { kind: "EnumValue", value: "CREATED_AT" } }, { kind: "Argument", name: { kind: "Name", value: "reverse" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "cancelledAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "netPaymentSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedRefund" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "suggestFullRefund" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedTransactions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountNumber" } }, { kind: "Field", name: { kind: "Name", value: "gateway" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "parentTransaction" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingLines" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "discountedPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "fulfillments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "2" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "trackingInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "15" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "variantTitle" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "product" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountedUnitPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refunds" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalRefunded" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "250" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentTotalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] } }] } }] }, SW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "readDiscountCodes" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNodes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeApp" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBxgy" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeFreeShipping" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, NW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchProducts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "productCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "productCount" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "onlineStoreUrl" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "totalInventory" } }, { kind: "Field", name: { kind: "Name", value: "priceRangeV2" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "maxVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "minVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "media" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alt" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "mediaContentType" } }, { kind: "Field", name: { kind: "Name", value: "preview" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "altText" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, jW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "test" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "description" } }] } }] } }] } }] }, wW = {
  "\n  mutation refundCreate($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": uW,
  "\n  mutation orderUpdate($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          shippingAddress {\n            firstName\n            lastName\n            company\n            address1\n            address2\n            city\n            countryCodeV2\n            provinceCode\n            zip\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": dW,
  "\n  mutation orderCancel(\n    $notifyCustomer: Boolean\n    $orderId: ID!\n    $reason: Shopify_OrderCancelReason!\n    $refundMethod: Shopify_OrderCancelRefundMethodInput!\n    $restock: Boolean!\n    $staffNote: String!\n  ) {\n    Shopify {\n      orderCancel(\n        notifyCustomer: $notifyCustomer\n        orderId: $orderId\n        reason: $reason\n        refundMethod: $refundMethod\n        restock: $restock\n        staffNote: $staffNote\n      ) {\n        job {\n          id\n          done\n        }\n        orderCancelUserErrors {\n          code\n          field\n          message\n        }\n      }\n    }\n  }\n": mW,
  "\n  mutation createCustomer($input: Shopify_CustomerInput!) {\n    Shopify {\n      customerCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n        customer {\n          id\n          defaultEmailAddress {\n            emailAddress\n          }\n          defaultPhoneNumber {\n            phoneNumber\n            marketingState\n            marketingOptInLevel\n          }\n          taxExempt\n          firstName\n          lastName\n          amountSpent {\n            amount\n            currencyCode\n          }\n        }\n      }\n    }\n  }\n": pW,
  "\n  mutation createOrder(\n    $order: Shopify_OrderCreateOrderInput!\n    $options: Shopify_OrderCreateOptionsInput\n  ) {\n    Shopify {\n      orderCreate(order: $order, options: $options) {\n        order {\n          id\n          name\n          createdAt\n          displayFulfillmentStatus\n          displayFinancialStatus\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": fW,
  "\n  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {\n    Shopify {\n      draftOrderCreate(input: $input) {\n        draftOrder {\n          id\n          name\n          createdAt\n          tags\n          status\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": hW,
  "\n  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {\n    Shopify {\n      discountCodeBasicCreate(basicCodeDiscount: $input) {\n        codeDiscountNode {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeBasic {\n              codes(first: 1) {\n                nodes {\n                  code\n                }\n              }\n              title\n              status\n              startsAt\n              endsAt\n              usageLimit\n              appliesOncePerCustomer\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": yW,
  "\n  mutation refuncLineItems($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        refund {\n          id\n          totalRefundedSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": gW,
  "\n  mutation updateOrder($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          id\n          tags\n        }\n      }\n    }\n  }\n": vW,
  "\n  query segments($first: Int!) {\n    Shopify {\n      segments(first: $first) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n": kW,
  "\n  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {\n    Shopify {\n      customerSegmentMembership(\n        customerId: $customerId\n        segmentIds: $segmentIds\n      ) {\n        memberships {\n          segmentId\n          isMember\n        }\n      }\n    }\n  }\n": bW,
  "\n  query shopifyCustomerData($query: String!) {\n    Shopify {\n      shop {\n        countriesInShippingZones {\n          countryCodes\n        }\n      }\n\n      customers(first: 1, query: $query) {\n        edges {\n          node {\n            id\n            displayName\n            firstName\n            lastName\n            defaultEmailAddress {\n              emailAddress\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            defaultPhoneNumber {\n              phoneNumber\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            numberOfOrders\n            tags\n            verifiedEmail\n            amountSpent {\n              amount\n              currencyCode\n            }\n            defaultAddress {\n              firstName\n              lastName\n              address1\n              address2\n              city\n              country\n              zip\n              phone\n              provinceCode\n              countryCodeV2\n            }\n          }\n        }\n      }\n    }\n  }\n": xW,
  "\n  query shopifyCustomerOrders($query: String!) {\n    Shopify {\n      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {\n        edges {\n          node {\n            id\n            name\n            createdAt\n            displayFulfillmentStatus\n            displayFinancialStatus\n            cancelledAt\n            tags\n            netPaymentSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            totalRefundedSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            billingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            shippingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            suggestedRefund(suggestFullRefund: true) {\n              amountSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              suggestedTransactions {\n                accountNumber\n                gateway\n                kind\n                parentTransaction {\n                  id\n                }\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              refundLineItems {\n                lineItem {\n                  id\n                  quantity\n                }\n              }\n            }\n            shippingLines(first: 5) {\n              edges {\n                node {\n                  title\n                  code\n                  source\n                  discountedPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            fulfillments(first: 2) {\n              trackingInfo {\n                company\n                number\n                url\n              }\n            }\n            lineItems(first: 15) {\n              edges {\n                node {\n                  id\n                  title\n                  quantity\n                  variantTitle\n                  sku\n                  image {\n                    url\n                  }\n                  product {\n                    id\n                  }\n                  discountedUnitPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            refunds {\n              totalRefunded {\n                amount\n                currencyCode\n              }\n              refundLineItems(first: 250) {\n                edges {\n                  node {\n                    id\n                    quantity\n                    lineItem {\n                      id\n                      title\n                    }\n                  }\n                }\n              }\n            }\n            currentTotalPriceSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": _W,
  "\n  query readDiscountCodes($first: Int) {\n    Shopify {\n      codeDiscountNodes(first: $first) {\n        nodes {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeApp {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBasic {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBxgy {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeFreeShipping {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": SW,
  "\n  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {\n    Shopify {\n      products(first: $productCount, query: $query) {\n        nodes {\n          id\n          title\n          description\n          onlineStoreUrl\n          status\n          tags\n          title\n          totalInventory\n          priceRangeV2 {\n            maxVariantPrice {\n              amount\n              currencyCode\n            }\n            minVariantPrice {\n              amount\n              currencyCode\n            }\n          }\n          media(first: $mediaCount) {\n            nodes {\n              alt\n              id\n              status\n              mediaContentType\n              preview {\n                image {\n                  id\n                  altText\n                  url\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": NW,
  "\n  query test {\n    Shopify {\n      shop {\n        name\n        email\n        description\n      }\n    }\n  }\n": jW
};
function Sr(e) {
  return wW[e] ?? {};
}
const CW = Sr(
  /* GraphQL */
  `
  query shopifyCustomerData($query: String!) {
    Shopify {
      shop {
        countriesInShippingZones {
          countryCodes
        }
      }

      customers(first: 1, query: $query) {
        edges {
          node {
            id
            displayName
            firstName
            lastName
            defaultEmailAddress {
              emailAddress
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            defaultPhoneNumber {
              phoneNumber
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            numberOfOrders
            tags
            verifiedEmail
            amountSpent {
              amount
              currencyCode
            }
            defaultAddress {
              firstName
              lastName
              address1
              address2
              city
              country
              zip
              phone
              provinceCode
              countryCodeV2
            }
          }
        }
      }
    }
  }
`
), IW = Sr(
  /* GraphQL */
  `
  query shopifyCustomerOrders($query: String!) {
    Shopify {
      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {
        edges {
          node {
            id
            name
            createdAt
            displayFulfillmentStatus
            displayFinancialStatus
            cancelledAt
            tags
            netPaymentSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            totalRefundedSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            billingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            shippingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            suggestedRefund(suggestFullRefund: true) {
              amountSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              suggestedTransactions {
                accountNumber
                gateway
                kind
                parentTransaction {
                  id
                }
                amountSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
              }
              refundLineItems {
                lineItem {
                  id
                  quantity
                }
              }
            }
            shippingLines(first: 5) {
              edges {
                node {
                  title
                  code
                  source
                  discountedPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            fulfillments(first: 2) {
              trackingInfo {
                company
                number
                url
              }
            }
            lineItems(first: 15) {
              edges {
                node {
                  id
                  title
                  quantity
                  variantTitle
                  sku
                  image {
                    url
                  }
                  product {
                    id
                  }
                  discountedUnitPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            refunds {
              totalRefunded {
                amount
                currencyCode
              }
              refundLineItems(first: 250) {
                edges {
                  node {
                    id
                    quantity
                    lineItem {
                      id
                      title
                    }
                  }
                }
              }
            }
            currentTotalPriceSet {
              presentmentMoney {
                amount
                currencyCode
              }
              shopMoney {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  }
`
), FW = Sr(
  /* GraphQL */
  `
  query segments($first: Int!) {
    Shopify {
      segments(first: $first) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`
), EW = Sr(
  /* GraphQL */
  `
  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {
    Shopify {
      customerSegmentMembership(
        customerId: $customerId
        segmentIds: $segmentIds
      ) {
        memberships {
          segmentId
          isMember
        }
      }
    }
  }
`
), Pg = Sr(
  /* GraphQL */
  `
  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {
    Shopify {
      products(first: $productCount, query: $query) {
        nodes {
          id
          title
          description
          onlineStoreUrl
          status
          tags
          title
          totalInventory
          priceRangeV2 {
            maxVariantPrice {
              amount
              currencyCode
            }
            minVariantPrice {
              amount
              currencyCode
            }
          }
          media(first: $mediaCount) {
            nodes {
              alt
              id
              status
              mediaContentType
              preview {
                image {
                  id
                  altText
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`
), $W = Sr(
  /* GraphQL */
  `
  query readDiscountCodes($first: Int) {
    Shopify {
      codeDiscountNodes(first: $first) {
        nodes {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeApp {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBasic {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBxgy {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeFreeShipping {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }
          }
        }
      }
    }
  }
`
), TW = Sr(
  /* GraphQL */
  `
  mutation orderUpdate($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          shippingAddress {
            firstName
            lastName
            company
            address1
            address2
            city
            countryCodeV2
            provinceCode
            zip
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), OW = Sr(
  /* GraphQL */
  `
  mutation refundCreate($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        userErrors {
          field
          message
        }
      }
    }
  }
`
), DW = Sr(
  /* GraphQL */
  `
  mutation orderCancel(
    $notifyCustomer: Boolean
    $orderId: ID!
    $reason: Shopify_OrderCancelReason!
    $refundMethod: Shopify_OrderCancelRefundMethodInput!
    $restock: Boolean!
    $staffNote: String!
  ) {
    Shopify {
      orderCancel(
        notifyCustomer: $notifyCustomer
        orderId: $orderId
        reason: $reason
        refundMethod: $refundMethod
        restock: $restock
        staffNote: $staffNote
      ) {
        job {
          id
          done
        }
        orderCancelUserErrors {
          code
          field
          message
        }
      }
    }
  }
`
), PW = Sr(
  /* GraphQL */
  `
  mutation updateOrder($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          id
          tags
        }
      }
    }
  }
`
), RW = Sr(
  /* GraphQL */
  `
  mutation createCustomer($input: Shopify_CustomerInput!) {
    Shopify {
      customerCreate(input: $input) {
        userErrors {
          field
          message
        }
        customer {
          id
          defaultEmailAddress {
            emailAddress
          }
          defaultPhoneNumber {
            phoneNumber
            marketingState
            marketingOptInLevel
          }
          taxExempt
          firstName
          lastName
          amountSpent {
            amount
            currencyCode
          }
        }
      }
    }
  }
`
), AW = Sr(
  /* GraphQL */
  `
  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {
    Shopify {
      discountCodeBasicCreate(basicCodeDiscount: $input) {
        codeDiscountNode {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeBasic {
              codes(first: 1) {
                nodes {
                  code
                }
              }
              title
              status
              startsAt
              endsAt
              usageLimit
              appliesOncePerCustomer
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), bI = _l`
  mutation createOrder(
    $order: Shopify_OrderCreateOrderInput!
    $options: Shopify_OrderCreateOptionsInput
  ) {
    Shopify {
      orderCreate(order: $order, options: $options) {
        order {
          id
          name
          createdAt
          displayFulfillmentStatus
          displayFinancialStatus
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, LW = _l`
  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {
    Shopify {
      draftOrderCreate(input: $input) {
        draftOrder {
          id
          name
          createdAt
          tags
          status
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, VW = ({
  conversationContext: e,
  forcePhoneLookup: n
}) => {
  const { useQuery: r } = bn(), i = e.customer?.email, a = e.customer?.phone_number, o = i ? `email:"${i}"` : null, s = a ? `phone:"${a}"` : null, l = n ? s : o ?? s, {
    loading: u,
    error: p,
    data: d,
    refetch: f,
    networkStatus: h
  } = r(CW, {
    skip: !l,
    variables: {
      query: l
    },
    notifyOnNetworkStatusChange: !0
  });
  return {
    isCustomerLoading: u,
    customerError: p,
    customerData: d,
    refetchCustomer: f,
    customerNetworkStatus: h
  };
}, zW = () => {
  const { useLazyQuery: e } = bn(), [
    n,
    {
      loading: r,
      error: i,
      data: a,
      refetch: o
    }
  ] = e(IW);
  return {
    getCustomerOrders: n,
    isCustomerOrdersLoading: r,
    customerOrdersError: i,
    customerOrders: a,
    refetchCustomerOrders: o
  };
};
function Ur(e = !1, n) {
  const [r, i] = ue(e);
  return Je(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const UW = "_list_alvh6_1", MW = "_listItem_alvh6_4", BW = "_fullWidth_alvh6_15", qW = "_boxWrapper_alvh6_19", Mt = {
  list: UW,
  listItem: MW,
  fullWidth: BW,
  boxWrapper: qW
}, HW = "_modal_1vkwz_1", WW = "_disabled_1vkwz_5", ih = {
  modal: HW,
  disabled: WW
}, Ij = [
  {
    label: "Single Opt-In",
    description: "After providing their information, the customer receives marketing information without any intermediate steps.",
    value: Di.SingleOptIn
  },
  {
    label: "Confirmed Opt-In",
    description: "After providing their information, the customer receives a confirmation and is required to perform a intermediate step before receiving marketing information.",
    value: Di.ConfirmedOptIn
  },
  {
    label: "Unknown",
    description: "The customer receives marketing information but how they were opted in is unknown.",
    value: Di.Unknown
  }
], Fj = [
  {
    label: "Not Subscribed",
    description: "The customer hasn’t subscribed to SMS marketing.",
    value: Lr.NotSubscribed
  },
  {
    label: "Pending",
    description: "The customer is in the process of subscribing to SMS marketing.",
    value: Lr.Pending
  },
  {
    label: "Redacted",
    description: "The customer’s personal data is erased. This value is internally-set and read-only.",
    value: Lr.Redacted
  },
  {
    label: "Subscribed",
    description: "The customer is subscribed to SMS marketing.",
    value: Lr.Subscribed
  },
  {
    label: "Unsubscribed",
    description: "The customer isn’t currently subscribed to SMS marketing but was previously subscribed.",
    value: Lr.Unsubscribed
  }
], KW = ({
  conversationContext: e,
  isOpen: n,
  setIsOpen: r,
  isMutationLoading: i,
  setIsMutationLoading: a,
  refetchCustomer: o
}) => {
  const { track: s } = In(), { useMutation: l, showNotification: u } = bn(), [p, d] = ue(), [f, h] = ue(), [v, C] = Nx(!0), [j, N] = Nx(!0), x = !!p, g = e.customer?.email, P = e.customer?.phone_number, E = e.customer?.given_name, I = e.customer?.family_name, w = {
    email: g ?? "",
    phone: P ?? "",
    firstName: E ?? "",
    lastName: I ?? "",
    smsMarketingState: null,
    smsMarketingOptInLevel: null
  }, A = dt({
    defaultValues: w
  });
  Je(() => {
    f?.forEach((D) => {
      const M = D?.field?.[0];
      M && (A.setError(M, {
        type: "server",
        message: D.message
      }), A.setFocus(M));
    });
  }, [f, A]);
  const [H, { error: Y, reset: ne }] = l(RW, {
    onError: (D) => {
      d(D.message), a(!1), u({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: async (D) => {
      const M = D?.Shopify?.customerCreate?.userErrors || [];
      M.length > 0 ? (h(M), a(!1), u({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      })) : (setTimeout(async () => {
        await o(), a(!1);
      }, 3e3), u({
        title: "Success",
        text: "The customer creation was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), s("shopify:profile:created"), r(!1));
    }
  }), W = ft(
    (D) => {
      a(!0), d(void 0), H({
        variables: {
          input: {
            firstName: D.firstName,
            lastName: D.lastName,
            ...v && { email: D.email },
            ...j && { phone: D.phone },
            ...D.smsMarketingState && {
              smsMarketingConsent: {
                marketingState: D.smsMarketingState,
                marketingOptInLevel: D.smsMarketingOptInLevel
              }
            }
          }
        }
      });
    },
    [H, a, j, v]
  ), B = () => {
    r(!1), ne(), d(void 0), A.reset(w);
  };
  return /* @__PURE__ */ k.jsxs(Ct, { isOpen: n, onClose: B, className: ih.modal, children: [
    /* @__PURE__ */ k.jsx(It, { title: "Create new customer", onClose: B }),
    /* @__PURE__ */ k.jsx(Ft, { children: /* @__PURE__ */ k.jsxs(tt, { children: [
      /* @__PURE__ */ k.jsx(ie, { span: 3, children: /* @__PURE__ */ k.jsx(
        Gn,
        {
          label: "First name",
          name: "firstName",
          control: A.control,
          rules: {
            required: "First name is required"
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(ie, { span: 3, children: /* @__PURE__ */ k.jsx(
        Gn,
        {
          label: "Last name",
          name: "lastName",
          control: A.control,
          rules: {
            required: "Last name is required"
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(ie, { children: /* @__PURE__ */ k.jsx(
        Gn,
        {
          label: "Email",
          name: "email",
          control: A.control,
          rules: {
            required: v ? "Email is required" : void 0
          },
          componentProps: {
            className: ut({
              [ih.disabled]: !v
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ k.jsx(
                Ks,
                {
                  disabled: !j,
                  name: "hasEmail",
                  value: "email",
                  checked: v,
                  onChange: () => C()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(ie, { children: /* @__PURE__ */ k.jsx(
        Gn,
        {
          label: "Phone",
          name: "phone",
          control: A.control,
          rules: {
            required: j ? "Phone is required" : void 0
          },
          componentProps: {
            className: ut({
              [ih.disabled]: !j
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ k.jsx(
                Ks,
                {
                  disabled: !v,
                  name: "hasPhone",
                  value: "phone",
                  checked: j,
                  onChange: () => N()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(ie, { children: /* @__PURE__ */ k.jsx(
        fr,
        {
          control: A.control,
          label: "SMS marketing state",
          name: "smsMarketingState",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing state"
            }
          },
          componentProps: {
            placeholder: "Select a marketing state",
            equalityFn: (D, M) => D === M,
            getItemTitleByValue: (D) => {
              const M = Fj.find(
                (Z) => Z.value === D
              );
              return /* @__PURE__ */ k.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ k.jsx(O.Heading, { variant: "heading-3", children: M.label }),
                    /* @__PURE__ */ k.jsx(O.Paragraph, { color: "secondary", children: M.description })
                  ]
                }
              );
            }
          },
          children: Fj.map((D) => /* @__PURE__ */ k.jsx(pt.Item, { value: D.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ k.jsx(O.Heading, { variant: "heading-3", children: D.label }),
            /* @__PURE__ */ k.jsx(O.Paragraph, { color: "secondary", children: D.description })
          ] }) }, D.value))
        }
      ) }),
      /* @__PURE__ */ k.jsx(ie, { children: /* @__PURE__ */ k.jsx(
        fr,
        {
          control: A.control,
          label: "SMS marketing opt-in level",
          name: "smsMarketingOptInLevel",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing opt-in level"
            }
          },
          componentProps: {
            placeholder: "Select a marketing opt-in level",
            equalityFn: (D, M) => D === M,
            getItemTitleByValue: (D) => {
              const M = Ij.find(
                (Z) => Z.value === D
              );
              return /* @__PURE__ */ k.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ k.jsx(O.Heading, { variant: "heading-3", children: M.label }),
                    /* @__PURE__ */ k.jsx(O.Paragraph, { color: "secondary", children: M.description })
                  ]
                }
              );
            }
          },
          children: Ij.map((D) => /* @__PURE__ */ k.jsx(pt.Item, { value: D.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ k.jsx(O.Heading, { variant: "heading-3", children: D.label }),
            /* @__PURE__ */ k.jsx(O.Paragraph, { color: "secondary", children: D.description })
          ] }) }, D.value))
        }
      ) }),
      x && /* @__PURE__ */ k.jsx(ie, { children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(he, { name: "close-circle-filled", color: "red.500" }),
        /* @__PURE__ */ k.jsx(O.Paragraph, { children: p })
      ] }) })
    ] }) }),
    /* @__PURE__ */ k.jsx(
      Vt,
      {
        confirmProps: {
          disabled: !(A.formState.isValid && A.formState.isDirty),
          isLoading: i,
          loadingIndicator: /* @__PURE__ */ k.jsx(hn, { size: 16 })
        },
        confirmOnClick: A.handleSubmit(W),
        cancelOnClick: B,
        confirmName: Y ? "Close" : "Save",
        cancelName: Y ? void 0 : "Cancel"
      }
    )
  ] });
}, GW = ({
  conversationContext: e,
  refetchCustomer: n
}) => {
  const [r, i] = ue(!1), [a, o] = ue(!1);
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsx(
      et,
      {
        variant: "secondary",
        onClick: () => i(!0),
        isLoading: a,
        loadingIndicator: /* @__PURE__ */ k.jsx(hn, { size: 16 }),
        slotStart: /* @__PURE__ */ k.jsx(he, { size: 14, name: "user-plus", color: "green.500" }),
        className: Mt.fullWidth,
        children: "Create new Shopify profile"
      }
    ),
    /* @__PURE__ */ k.jsx(
      KW,
      {
        isOpen: r,
        setIsOpen: i,
        isMutationLoading: a,
        setIsMutationLoading: o,
        conversationContext: e,
        refetchCustomer: n
      }
    )
  ] });
}, Rg = (e) => {
  const n = e?.match(/shopify\/\w+\/(\d+)/);
  return n ? n[1] : null;
}, ny = "DD MMM YYYY @ HH:mm", YW = "_wrapper_10fld_1", JW = "_copyIcon_10fld_7", Ns = {
  wrapper: YW,
  copyIcon: JW
}, QW = ({
  customer: e,
  shopifyDomain: n,
  refresh: r,
  loading: i,
  networkStatus: a
}) => {
  const { isCopied: o, copy: s } = Ur(), { isCopied: l, copy: u } = Ur(), { track: p } = In();
  if (!e)
    return null;
  const {
    id: d,
    displayName: f,
    defaultEmailAddress: h,
    defaultPhoneNumber: v,
    tags: C = [],
    verifiedEmail: j
  } = e, N = h?.emailAddress, x = v?.phoneNumber, g = Rg(d), P = `https://${n}/admin/customers/${g ?? ""}`, E = i && a === rr.refetch, I = 14;
  return /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { className: Ns.wrapper, gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(O.Heading, { variant: "heading-3", children: f }),
        E ? /* @__PURE__ */ k.jsx(hn, { size: I }) : /* @__PURE__ */ k.jsx(Ze, { content: "Reload customer", children: /* @__PURE__ */ k.jsx(
          he,
          {
            size: I,
            name: "sync",
            onClick: () => {
              p("shopify:refreshed", { shopifyId: d }), r();
            },
            className: Ns.copyIcon
          }
        ) })
      ] }),
      N && /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(he, { size: I, name: "mail" }),
          /* @__PURE__ */ k.jsx(O.ExternalLink, { href: `mailto:${N}`, children: N }),
          /* @__PURE__ */ k.jsx(
            Ze,
            {
              content: j ? "Verified email" : "Email is not verified",
              children: /* @__PURE__ */ k.jsx(b, { alignItems: "center", children: /* @__PURE__ */ k.jsx(
                he,
                {
                  size: I,
                  color: j ? "green.500" : "red.500",
                  name: j ? "check-circle" : "exclamation"
                }
              ) })
            }
          )
        ] }),
        /* @__PURE__ */ k.jsx(Ze, { content: "Copy Email", children: /* @__PURE__ */ k.jsx(
          he,
          {
            size: I,
            name: o ? "done" : "copy",
            onClick: () => s(N),
            className: Ns.copyIcon
          }
        ) })
      ] }),
      x && /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(he, { size: I, name: "phone" }),
          /* @__PURE__ */ k.jsx(O.ExternalLink, { href: `tel:${x}`, children: x })
        ] }),
        /* @__PURE__ */ k.jsx(Ze, { content: "Copy phone number", children: /* @__PURE__ */ k.jsx(
          he,
          {
            size: I,
            name: l ? "done" : "copy",
            onClick: () => u(x),
            className: Ns.copyIcon
          }
        ) })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ k.jsx(he, { size: I, name: "external-link" }),
        /* @__PURE__ */ k.jsx(
          O.ExternalLink,
          {
            href: P,
            target: "_blank",
            rel: "noreferrer",
            children: "View customer in Shopify"
          }
        )
      ] })
    ] }),
    C.length > 0 && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
      /* @__PURE__ */ k.jsx(O.Heading, { variant: "heading-3", children: "Tags" }),
      /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: C.map((w) => /* @__PURE__ */ k.jsx(Yn, { children: w }, `${d}-${w}`)) })
    ] })
  ] });
}, XW = "_creationModal_pbe64_1", ZW = "_detailsModal_pbe64_5", e9 = "_percentageSuffix_pbe64_9", ah = {
  creationModal: XW,
  detailsModal: ZW,
  percentageSuffix: e9
}, n9 = () => {
  const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  return Array.from(
    { length: 12 },
    () => e.charAt(Math.floor(Math.random() * e.length))
  ).join("");
}, t9 = (e) => {
  const n = e.customerGetsOption === "percentage" ? e.customerGets / 100 : e.customerGets, r = (() => {
    switch (e.minimumRequirementOption) {
      case "quantity":
        return "greaterThanOrEqualToQuantity";
      case "subtotal":
        return "greaterThanOrEqualToSubtotal";
      default:
        return null;
    }
  })(), i = e.maximumUsage;
  return {
    code: e.code,
    title: e.title,
    usageLimit: i === "only-once" ? 1 : null,
    appliesOncePerCustomer: i === "once-per-customer",
    customerGets: {
      value: {
        [e.customerGetsOption]: e.customerGetsOption === "discountAmount" ? { amount: n } : n
      },
      items: {
        all: !0
      }
    },
    context: {
      all: vI.All
    },
    ...r && {
      minimumRequirement: {
        [e.minimumRequirementOption]: {
          [r]: e.minimumRequirementOption === "quantity" ? e.minimumRequirementValue?.toString() : e.minimumRequirementValue
        }
      }
    },
    startsAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}, Ej = [
  {
    label: "Percentage",
    description: "The percentage value of the discount.",
    value: "percentage"
  },
  {
    label: "Amount",
    description: "The value of the discount.",
    value: "discountAmount"
  }
], $j = [
  {
    label: "None",
    description: "No minimum requirements.",
    value: "none"
  },
  {
    label: "Quantity",
    description: "Minimum required quantity of items.",
    value: "quantity"
  },
  {
    label: "Subtotal",
    description: "Minimum required order subtotal.",
    value: "subtotal"
  }
], Tj = [
  {
    label: "No limit",
    value: "no-limit",
    description: "The discount code can be used unlimited times."
  },
  {
    label: "Only once",
    value: "only-once",
    description: "The discount code can only be used once."
  },
  {
    label: "Once per customer",
    value: "once-per-customer",
    description: "The discount code can be used once per customer."
  }
], r9 = ({
  codeDiscount: e
}) => {
  const n = e?.codes?.nodes?.[0]?.code, { isCopied: r, copy: i } = Jt(), a = e?.usageLimit ? `${e?.usageLimit} uses remaining` : "No limit";
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "400", children: [
    /* @__PURE__ */ k.jsxs(Qe, { children: [
      /* @__PURE__ */ k.jsx(Qe.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "1", children: "Title" }),
        /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "2", color: "secondary", children: e?.title })
      ] }) }),
      /* @__PURE__ */ k.jsx(Qe.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "1", children: "Status" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ k.jsx(
            he,
            {
              name: e?.status === "ACTIVE" ? "check-circle-filled" : "circle-filled",
              color: e?.status === "ACTIVE" ? "green.500" : "neutral.500"
            }
          ),
          /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "2", color: "secondary", children: e?.status })
        ] })
      ] }) }),
      /* @__PURE__ */ k.jsx(Qe.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "1", children: "Usage limit" }),
        /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "2", color: "secondary", children: a })
      ] }) }),
      /* @__PURE__ */ k.jsx(Qe.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "1", children: "Applies once per customer" }),
        /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "2", color: "secondary", children: e?.appliesOncePerCustomer ? "Yes" : "No" })
      ] }) }),
      /* @__PURE__ */ k.jsx(Qe.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "1", children: "Starts at" }),
        /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "2", color: "secondary", children: Jn(e?.startsAt).format(jt) })
      ] }) })
    ] }),
    /* @__PURE__ */ k.jsx(We, { label: "Discount code", children: /* @__PURE__ */ k.jsx(
      mr,
      {
        readOnly: !0,
        value: n,
        suffix: {
          type: "button",
          button: {
            icon: r ? "done" : "copy",
            onClick: () => {
              i(n);
            }
          }
        }
      }
    ) })
  ] });
}, i9 = "shopify-discount-code-form", Oj = {
  title: "",
  code: "",
  customerGets: void 0,
  customerGetsOption: "percentage",
  minimumRequirementOption: "none",
  minimumRequirementValue: void 0,
  maximumUsage: "only-once"
}, a9 = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { track: r } = In(), { useMutation: i, showNotification: a } = bn(), [o, s] = ue(
    []
  ), [l, u] = ue(), p = dt({
    mode: "all",
    defaultValues: Oj
  });
  Je(() => {
    o?.forEach((I) => {
      const w = I?.field?.[1];
      w && p.setError(w, {
        type: "server",
        message: I.message
      });
    });
  }, [o, p]);
  const d = !!l, f = p.watch("minimumRequirementOption"), h = p.watch("customerGetsOption"), v = Xn(() => {
    switch (f) {
      case "quantity":
        return "Minimum quantity";
      case "subtotal":
        return "Minimum subtotal";
      default:
        return "";
    }
  }, [f]), [
    C,
    {
      loading: j,
      error: N,
      reset: x
    }
  ] = i(AW, {
    onError: () => {
      a({
        title: "Something went wrong",
        text: "The discount code creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (I) => {
      const w = I?.Shopify?.discountCodeBasicCreate?.userErrors;
      if (w && w.length > 0)
        s(w);
      else {
        const A = I?.Shopify?.discountCodeBasicCreate?.codeDiscountNode?.codeDiscount;
        A && "codes" in A && u(A), a({
          title: "Success",
          text: "The discount code was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), r("shopify:discount:code:created"), s([]);
      }
    }
  }), g = () => {
    p.setValue("code", n9(), {
      shouldDirty: !0,
      shouldValidate: !0,
      shouldTouch: !0
    });
  }, P = (I) => {
    C({
      variables: {
        input: t9(I)
      }
    });
  }, E = () => {
    p.reset(Oj), s([]), x(), u(void 0), n(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    Ct,
    {
      isOpen: e,
      onClose: E,
      className: ut({
        [ah.creationModal]: !d,
        [ah.detailsModal]: d
      }),
      children: [
        /* @__PURE__ */ k.jsx(
          It,
          {
            title: d ? "Discount code details" : "Create new discount code",
            onClose: E
          }
        ),
        /* @__PURE__ */ k.jsxs(Ft, { children: [
          d && /* @__PURE__ */ k.jsx(r9, { codeDiscount: l }),
          !d && /* @__PURE__ */ k.jsxs("form", { noValidate: !0, id: i9, onSubmit: p.handleSubmit(P), children: [
            /* @__PURE__ */ k.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ k.jsx(
              bl,
              {
                variant: "info",
                description: /* @__PURE__ */ k.jsx(O.Paragraph, { children: "This code will be eligible for all customers." })
              }
            ) }),
            /* @__PURE__ */ k.jsxs(tt, { children: [
              /* @__PURE__ */ k.jsx(ie, { children: /* @__PURE__ */ k.jsx(
                Gn,
                {
                  label: "Title",
                  name: "title",
                  control: p.control,
                  rules: {
                    required: "Please enter a title"
                  },
                  componentProps: {
                    placeholder: "Enter a title"
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(ie, { span: 3, children: /* @__PURE__ */ k.jsx(
                fr,
                {
                  control: p.control,
                  label: "Discount type",
                  name: "customerGetsOption",
                  rules: {
                    required: "Please select a discount type"
                  },
                  componentProps: {
                    placeholder: "Select a discount type",
                    equalityFn: (I, w) => I === w,
                    onChange: () => {
                      p.setValue("customerGets", void 0), p.clearErrors("customerGets");
                    },
                    getItemTitleByValue: (I) => {
                      const w = Ej.find(
                        (A) => A.value === I
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(O.Heading, { variant: "heading-3", children: w?.label }) });
                    }
                  },
                  children: Ej.map((I) => /* @__PURE__ */ k.jsx(pt.Item, { value: I.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(O.Heading, { variant: "heading-3", children: I.label }),
                    /* @__PURE__ */ k.jsx(O.Paragraph, { color: "secondary", children: I.description })
                  ] }) }, I.value))
                }
              ) }),
              /* @__PURE__ */ k.jsx(ie, { span: 3, children: /* @__PURE__ */ k.jsx(
                Gn,
                {
                  label: "Discount value",
                  name: "customerGets",
                  control: p.control,
                  rules: {
                    required: "Please enter a value",
                    validate: (I) => {
                      if (I) {
                        if (h === "percentage" && (I < 0 || I > 100))
                          return "Percentage must be between 0 and 100";
                        if (h === "discountAmount" && I < 0)
                          return "Discount amount must be greater than 0";
                      }
                    }
                  },
                  componentProps: {
                    placeholder: "Enter a value",
                    type: "number",
                    ...h === "percentage" && {
                      suffix: {
                        type: "custom",
                        noWrap: !0,
                        value: /* @__PURE__ */ k.jsx(
                          b,
                          {
                            alignItems: "center",
                            className: ah.percentageSuffix,
                            children: "%"
                          }
                        )
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(ie, { children: /* @__PURE__ */ k.jsx(
                Gn,
                {
                  label: "Code",
                  name: "code",
                  control: p.control,
                  rules: {
                    required: "Please enter a code"
                  },
                  componentProps: {
                    placeholder: "Enter a code or click to the right to generate",
                    suffix: {
                      type: "button",
                      button: {
                        icon: "sync",
                        onClick: g
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(ie, { span: 3, children: /* @__PURE__ */ k.jsx(
                fr,
                {
                  control: p.control,
                  label: "Minimum purchase requirements",
                  name: "minimumRequirementOption",
                  rules: {
                    required: "Please select a minimum requirement option"
                  },
                  componentProps: {
                    placeholder: "Select a minimum purchase requirement",
                    equalityFn: (I, w) => I === w,
                    onChange: () => {
                      p.setValue("minimumRequirementValue", void 0), p.clearErrors("minimumRequirementValue");
                    },
                    getItemTitleByValue: (I) => {
                      const w = $j.find(
                        (A) => A.value === I
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(O.Heading, { variant: "heading-3", children: w?.label }) });
                    }
                  },
                  children: $j.map((I) => /* @__PURE__ */ k.jsx(pt.Item, { value: I.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(O.Heading, { variant: "heading-3", children: I.label }),
                    /* @__PURE__ */ k.jsx(O.Paragraph, { color: "secondary", children: I.description })
                  ] }) }, I.value))
                }
              ) }),
              /* @__PURE__ */ k.jsx(ie, { span: 3, children: /* @__PURE__ */ k.jsx(
                Gn,
                {
                  name: "minimumRequirementValue",
                  label: v,
                  control: p.control,
                  disabled: f === "none",
                  rules: {
                    required: {
                      value: f !== "none",
                      message: "Please enter a value"
                    },
                    validate: (I) => {
                      if (I && f !== "none" && I < 0)
                        return `Minimum ${f} must be greater than 0`;
                    }
                  },
                  componentProps: {
                    type: "number",
                    placeholder: "Enter a value"
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(ie, { children: /* @__PURE__ */ k.jsx(
                fr,
                {
                  name: "maximumUsage",
                  label: "Maximum usage",
                  control: p.control,
                  componentProps: {
                    placeholder: "Select a maximum usage",
                    equalityFn: (I, w) => I === w,
                    getItemTitleByValue: (I) => {
                      const w = Tj.find(
                        (A) => A.value === I
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(O.Heading, { variant: "heading-3", children: w?.label }) });
                    }
                  },
                  children: Tj.map((I) => /* @__PURE__ */ k.jsx(pt.Item, { value: I.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(O.Heading, { variant: "heading-3", children: I.label }),
                    /* @__PURE__ */ k.jsx(O.Paragraph, { color: "secondary", children: I.description })
                  ] }) }, I.value))
                }
              ) })
            ] })
          ] }),
          N && /* @__PURE__ */ k.jsx(Tn, { error: N })
        ] }),
        /* @__PURE__ */ k.jsx(
          Vt,
          {
            confirmProps: {
              disabled: !d && !(p.formState.isValid && p.formState.isDirty),
              isLoading: j,
              loadingIndicator: /* @__PURE__ */ k.jsx(hn, { size: 16 })
            },
            confirmName: d ? "Close" : "Save",
            confirmOnClick: d ? E : p.handleSubmit(P),
            cancelOnClick: d ? void 0 : E
          }
        )
      ]
    }
  );
}, o9 = ({ code: e }) => {
  const { isCopied: n, copy: r } = Ur();
  return /* @__PURE__ */ k.jsxs(
    b,
    {
      justifyContent: "space-between",
      alignItems: "center",
      gap: "200",
      width: "100%",
      children: [
        /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ k.jsx(he, { size: 12, name: "shopify", color: "green.500" }),
          /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "3", children: e })
        ] }),
        /* @__PURE__ */ k.jsx(
          ir,
          {
            icon: n ? "done" : "copy",
            onClick: () => r(e),
            variant: "secondary"
          }
        )
      ]
    }
  );
}, s9 = ({
  discountCode: e
}) => {
  const { codeDiscount: n } = e;
  if (!("codes" in n))
    return null;
  const r = "summary" in n, i = n?.codes?.nodes ?? [];
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
    /* @__PURE__ */ k.jsx(O.Heading, { variant: "heading-3", children: n.title }),
    r && /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "4", color: "tertiary", children: n.summary }),
    /* @__PURE__ */ k.jsx(Qe, { children: i.map((a) => /* @__PURE__ */ k.jsx(Qe.Item, { className: Mt.listItem, children: /* @__PURE__ */ k.jsx(o9, { code: a.code }, a.id) }, a.id)) })
  ] });
}, l9 = "_modal_11d6e_1", c9 = "_modalBody_11d6e_4", u9 = "_codeContainer_11d6e_9", oh = {
  modal: l9,
  modalBody: c9,
  codeContainer: u9
}, d9 = [50, 100, 250], xI = 50, m9 = {
  maxNumberOfCodesToDisplay: xI
}, p9 = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { useQuery: r } = bn(), [i, a] = ue(
    xI
  ), [o, s] = ue([]), l = o.length === 0, u = o.length > i, p = dt({
    mode: "all",
    defaultValues: m9
  }), { loading: d, error: f } = r($W, {
    variables: {
      first: i
    },
    onCompleted: (v) => {
      const C = v?.Shopify?.codeDiscountNodes?.nodes ?? [];
      C && C.length > 0 && s(C);
    }
  }), h = () => {
    n(!1);
  };
  return /* @__PURE__ */ k.jsxs(Ct, { isOpen: e, onClose: h, className: oh.modal, children: [
    /* @__PURE__ */ k.jsx(It, { title: "Discount codes", onClose: h }),
    /* @__PURE__ */ k.jsxs(Ft, { className: oh.modalBody, children: [
      u && /* @__PURE__ */ k.jsx(tt, { children: /* @__PURE__ */ k.jsx(ie, { span: 3, children: /* @__PURE__ */ k.jsx(
        fr,
        {
          control: p.control,
          label: "Number of codes to display",
          name: "maxNumberOfCodesToDisplay",
          componentProps: {
            placeholder: "Select a number of codes to display",
            onChange: (v) => {
              a(v.selectedValues[0]);
            },
            getItemTitleByValue: (v) => /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(O.Heading, { variant: "heading-3", children: v }) })
          },
          children: d9.map((v) => /* @__PURE__ */ k.jsx(pt.Item, { value: v, children: /* @__PURE__ */ k.jsx(O.Heading, { variant: "heading-3", children: v }) }, v))
        }
      ) }) }),
      d && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(hn, {}) }),
      f && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(O.Paragraph, { children: "Something went wrong while fetching discount codes." }) }),
      !d && l && /* @__PURE__ */ k.jsx(
        Gs,
        {
          title: "No discount codes found.",
          description: "There are no discount codes to display. You can create a new discount code with the 'Create new' button in our integration."
        }
      ),
      !d && !f && !l && o.map((v) => /* @__PURE__ */ k.jsx("div", { className: oh.codeContainer, children: /* @__PURE__ */ k.jsx(s9, { discountCode: v }) }, v.id))
    ] }),
    /* @__PURE__ */ k.jsx(Vt, { confirmName: "Close", confirmOnClick: h })
  ] });
}, f9 = ({
  displayDiscountCodeCreation: e
}) => {
  const [n, r] = ue(!1), [i, a] = ue(!1);
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsx(O.Heading, { variant: "heading-3", children: "Discount codes" }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", width: "100%", children: [
        /* @__PURE__ */ k.jsx(b, { flex: "1", children: /* @__PURE__ */ k.jsx(
          et,
          {
            variant: "secondary",
            icon: "gift",
            onClick: () => a(!0),
            style: { width: "100%" },
            children: "View discount codes"
          }
        ) }),
        e && /* @__PURE__ */ k.jsx(b, { flex: "1", children: /* @__PURE__ */ k.jsx(
          et,
          {
            variant: "secondary",
            icon: "plus",
            onClick: () => r(!0),
            style: { width: "100%" },
            children: "Create new"
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsx(
      p9,
      {
        isOpen: i,
        setIsOpen: a
      }
    ),
    /* @__PURE__ */ k.jsx(
      a9,
      {
        isOpen: n,
        setIsOpen: r
      }
    )
  ] });
}, h9 = ({
  customer: e
}) => {
  if (!e)
    return null;
  const { defaultEmailAddress: n, defaultPhoneNumber: r } = e, i = (h) => h ? sw(h.replaceAll("_", " ")) : "No state available", a = (h) => {
    switch (h) {
      case aa.Invalid:
      case aa.NotSubscribed:
      case Lr.NotSubscribed:
        return "red.500";
      case aa.Pending:
      case Lr.Pending:
      case aa.Unsubscribed:
      case Lr.Unsubscribed:
        return "orange.500";
      case aa.Subscribed:
      case Lr.Subscribed:
        return "green.500";
      default:
        return "neutral.500";
    }
  }, o = (h) => {
    switch (h) {
      case Di.SingleOptIn:
      case Di.ConfirmedOptIn:
        return "green.500";
      case Di.Unknown:
      default:
        return "neutral.200";
    }
  }, {
    marketingState: s,
    marketingUpdatedAt: l,
    marketingOptInLevel: u
  } = n ?? {}, {
    marketingState: p,
    marketingUpdatedAt: d,
    marketingOptInLevel: f
  } = r ?? {};
  return /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsx(O.Heading, { variant: "heading-3", children: "Marketing consent" }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(he, { name: "mail", color: "neutral.500" }),
        /* @__PURE__ */ k.jsx(O.Heading, { variant: "heading-4", children: "Email" })
      ] }),
      l && /* @__PURE__ */ k.jsx(Ze, { content: "Last updated at", children: /* @__PURE__ */ k.jsx(Mn, { size: "small", variant: "info", children: Jn(l).format(ny) }) }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(Ze, { content: "Opt-In state", children: /* @__PURE__ */ k.jsx(Yn, { color: o(u), children: i(u) }) }),
        /* @__PURE__ */ k.jsx(Ze, { content: "Marketing state", children: /* @__PURE__ */ k.jsx(Yn, { color: a(s), children: i(s) }) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(he, { name: "phone", color: "neutral.500" }),
        /* @__PURE__ */ k.jsx(O.Heading, { variant: "heading-4", children: "Phone" })
      ] }),
      d && /* @__PURE__ */ k.jsx(Ze, { content: "Last updated at", children: /* @__PURE__ */ k.jsx(Mn, { size: "small", variant: "info", children: Jn(d).format(ny) }) }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(Ze, { content: "Opt-In state", children: /* @__PURE__ */ k.jsx(Yn, { color: o(f), children: i(f) }) }),
        /* @__PURE__ */ k.jsx(Ze, { content: "Marketing state", children: /* @__PURE__ */ k.jsx(Yn, { color: a(p), children: i(p) }) })
      ] })
    ] })
  ] });
}, y9 = ({
  ordersData: e
}) => {
  const n = (r) => r?.fulfillments?.length > 0 ? r.fulfillments[0].trackingInfo : [];
  return e.map(({ node: r }) => ({
    id: r.id,
    name: r.name,
    createdAt: new Date(r.createdAt),
    cancelledAt: r.cancelledAt ? new Date(r.cancelledAt) : void 0,
    status: `${r.displayFulfillmentStatus?.toLowerCase()}, ${r.displayFinancialStatus?.toLowerCase()}${r.cancelledAt ? ", cancelled" : ""}`,
    displayFinancialStatus: r.displayFinancialStatus,
    currentTotalPriceSet: r.currentTotalPriceSet,
    value: r.netPaymentSet?.presentmentMoney?.amount,
    currencyCode: r.netPaymentSet?.presentmentMoney?.currencyCode,
    shippingAddress: r.shippingAddress,
    billingAddress: r.billingAddress,
    lineItems: r.lineItems?.edges?.map(({ node: i }) => i),
    suggestedRefund: {
      orderId: r.id,
      amount: r.suggestedRefund?.amountSet?.presentmentMoney?.amount,
      currency: r.suggestedRefund?.amountSet?.presentmentMoney?.currencyCode,
      notify: !0,
      refundLineItems: r.suggestedRefund?.refundLineItems.map(
        ({ lineItem: i }) => ({
          lineItemId: i.id,
          quantity: i.quantity
        })
      ),
      transactions: r.suggestedRefund?.suggestedTransactions?.map(
        ({ amountSet: i, gateway: a, parentTransaction: o }) => ({
          amount: i?.presentmentMoney?.amount || "0.00",
          gateway: a ?? "",
          kind: kI.Refund,
          orderId: r.id,
          parentId: o?.id
        })
      ),
      shipping: {
        fullRefund: !0
      }
    },
    trackingInfos: n(r),
    shippingLines: r.shippingLines?.edges?.map(({ node: i }) => i),
    tags: r.tags,
    refunds: r.refunds
  }));
}, Dj = [
  {
    value: Zr.Pending,
    label: "Pending",
    description: "The payment is pending"
  },
  {
    value: Zr.Authorized,
    label: "Authorized",
    description: "The payment has been authorized but not captured"
  },
  {
    value: Zr.Paid,
    label: "Paid",
    description: "The payment has been completed"
  },
  {
    value: Zr.PartiallyPaid,
    label: "Partially Paid",
    description: "The payment has been partially completed"
  },
  {
    value: Zr.Refunded,
    label: "Refunded",
    description: "The payment has been refunded"
  },
  {
    value: Zr.Voided,
    label: "Voided",
    description: "The payment has been voided"
  },
  {
    value: Zr.PartiallyRefunded,
    label: "Partially Refunded",
    description: "The payment has been partially refunded"
  }
], Pj = [
  {
    value: Hs.Fulfilled,
    label: "Fulfilled",
    description: "Every line item in the order has been fulfilled"
  },
  {
    value: Hs.Partial,
    label: "Partial",
    description: "At least one line item in the order has been fulfilled"
  },
  {
    value: Hs.Restocked,
    label: "Restocked",
    description: "Every line item in the order has been restocked and the order canceled"
  }
], _I = (e) => e.length === 0 ? "" : e.map((n) => `id:${n.split("/").pop()}`).join(" OR "), oa = (e) => g9(v9(e)), g9 = (e) => Object.fromEntries(
  Object.entries(e ?? {}).filter(([, n]) => n != null)
), v9 = (e) => {
  const n = e;
  if (typeof n == "object" && "countryCodeV2" in n) {
    const { countryCodeV2: r, ...i } = n;
    return {
      ...i,
      ...r && { countryCode: r }
    };
  }
  return e;
}, Si = ({
  control: e,
  name: n,
  label: r,
  placeholder: i,
  required: a = !1,
  apiUserError: o
}) => /* @__PURE__ */ k.jsx(
  xt,
  {
    name: n,
    control: e,
    rules: {
      required: a ? {
        value: !0,
        message: "This field is required"
      } : !1
    },
    render: ({ field: s, fieldState: l }) => /* @__PURE__ */ k.jsx(
      tr,
      {
        required: a,
        label: r,
        input: s,
        placeholder: i,
        meta: {
          warning: l?.error?.message,
          error: l?.error?.message || o?.[s.name]
        }
      }
    )
  }
), k9 = "_modal_1wlra_1", b9 = {
  modal: k9
};
function Rj(e) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      e.toUpperCase()
    ) ?? e;
  } catch {
    return e;
  }
}
const Aj = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], Lj = "shopify-shiping-address-form", x9 = ({
  title: e,
  address: n,
  isOpen: r,
  setIsOpen: i,
  orderId: a,
  shopifyId: o,
  shippingCountryCodes: s,
  onChange: l,
  refetchOrders: u
}) => {
  const { useMutation: p, showNotification: d } = bn(), { track: f } = In(), [h, v] = ue(!1), [C, j] = ue({}), N = !l, [
    x,
    { error: g, reset: P }
  ] = p(TW, {
    onError: () => {
      v(!1), d({
        title: "Something went wrong",
        text: "The address change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (W) => {
      v(!1);
      const B = W?.Shopify?.orderUpdate?.userErrors;
      if (B != null && B.length > 0) {
        const D = B.reduce(
          (M, Z) => {
            const je = Z.field;
            if (je == null || je.length === 0)
              return M;
            const ge = je[je.length - 1];
            return ge != null && (M[ge] = Z.message), M;
          },
          {}
        );
        j(D);
      } else
        d({
          title: "Success",
          text: "The address change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), u(), ne();
    }
  }), E = ft(
    () => ({
      firstName: n?.firstName || "",
      lastName: n?.lastName || "",
      company: n?.company || "",
      address1: n?.address1 || "",
      address2: n?.address2 || "",
      city: n?.city || "",
      countryCodeV2: Aj.find(
        (W) => W === n?.countryCodeV2
      ),
      provinceCode: n?.province || "",
      zip: n?.zip || ""
    }),
    [n]
  ), { control: I, handleSubmit: w, formState: A, reset: H } = dt({
    mode: "all",
    defaultValues: E()
  }), Y = w((W) => {
    if (N) {
      if (v(!0), !o || !a) {
        v(!1);
        return;
      }
      f("shopify:order:edit:shipping:address:modal:submitted", {
        shopifyId: o,
        orderId: a
      });
      const { countryCodeV2: B, ...D } = W, M = {
        ...D,
        countryCode: B
      };
      x({
        variables: {
          input: {
            id: a,
            shippingAddress: M
          }
        }
      });
    } else
      l(W), ne();
  });
  Je(() => {
    r && H(E());
  }, [r, n, H, E]);
  const ne = () => {
    H(E()), j({}), P(), i(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    Ct,
    {
      isOpen: r,
      onClose: ne,
      className: b9.modal,
      "data-testid": "edit-shipping-address-modal",
      children: [
        /* @__PURE__ */ k.jsx(It, { title: e, onClose: () => ne() }),
        /* @__PURE__ */ k.jsx(Ft, { children: /* @__PURE__ */ k.jsxs("form", { noValidate: !0, id: Lj, onSubmit: Y, children: [
          g && /* @__PURE__ */ k.jsx(Tn, { error: g }),
          /* @__PURE__ */ k.jsxs(tt, { children: [
            /* @__PURE__ */ k.jsx(ie, { span: 3, children: /* @__PURE__ */ k.jsx(
              Si,
              {
                required: !0,
                control: I,
                name: "firstName",
                label: "First name",
                placeholder: "Insert your first name",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ k.jsx(ie, { span: 3, children: /* @__PURE__ */ k.jsx(
              Si,
              {
                required: !0,
                control: I,
                name: "lastName",
                label: "Last name",
                placeholder: "Insert your last name",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ k.jsx(ie, { span: 6, children: /* @__PURE__ */ k.jsx(
              Si,
              {
                control: I,
                name: "company",
                label: "Company",
                placeholder: "Insert your company name"
              }
            ) }),
            /* @__PURE__ */ k.jsx(ie, { span: 6, children: /* @__PURE__ */ k.jsx(
              Si,
              {
                required: !0,
                control: I,
                name: "address1",
                label: "Address",
                placeholder: "Insert your address",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ k.jsx(ie, { span: 6, children: /* @__PURE__ */ k.jsx(
              Si,
              {
                control: I,
                name: "address2",
                label: "Additional address details",
                placeholder: "Insert more address details"
              }
            ) }),
            /* @__PURE__ */ k.jsx(ie, { span: 3, children: /* @__PURE__ */ k.jsx(
              Si,
              {
                required: !0,
                control: I,
                name: "zip",
                label: "Zip / postal code",
                placeholder: "Insert your zip / postal code",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ k.jsx(ie, { span: 3, children: /* @__PURE__ */ k.jsx(
              Si,
              {
                required: !0,
                control: I,
                name: "city",
                label: "City",
                placeholder: "Insert your city",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ k.jsx(ie, { span: 6, children: /* @__PURE__ */ k.jsx(
              fr,
              {
                name: "countryCodeV2",
                control: I,
                label: "Country",
                rules: {
                  required: {
                    value: !0,
                    message: "Please select a country"
                  }
                },
                componentProps: {
                  placeholder: "Select your country",
                  getItemTitleByValue: (W) => W ? Rj(W) : ""
                },
                children: Aj.filter((W) => s.includes(W)).map((W) => /* @__PURE__ */ k.jsx(pt.Item, { value: W, children: /* @__PURE__ */ k.jsx(O.Paragraph, { children: Rj(W) }) }, W))
              }
            ) })
          ] })
        ] }) }),
        /* @__PURE__ */ k.jsx(
          Vt,
          {
            confirmProps: {
              disabled: !(A.isValid && A.isDirty),
              type: "submit",
              form: Lj,
              isLoading: h,
              loadingIndicator: /* @__PURE__ */ k.jsx(hn, { size: 16 })
            },
            confirmOnClick: () => {
              g && ne();
            },
            cancelOnClick: () => {
              o && a && !g && f("shopify:order:edit:shipping:address:modal:canceled", {
                shopifyId: o,
                orderId: a
              }), ne();
            },
            confirmName: g ? "Close" : "Save",
            cancelName: g ? void 0 : "Cancel"
          }
        )
      ]
    }
  );
}, _9 = "_clickableIcon_33mqm_1", sh = {
  clickableIcon: _9
}, Vj = ({
  formFieldName: e,
  ...n
}) => {
  const r = Br(), { field: i } = Ey({
    control: r.control,
    name: e
  });
  return /* @__PURE__ */ k.jsx(
    ty,
    {
      enableEditAddress: !0,
      openByDefault: !0,
      onChange: i.onChange,
      ...n
    }
  );
}, ty = ({
  labelText: e,
  address: n,
  orderId: r,
  shopifyId: i,
  shippingCountryCodes: a,
  enableEditAddress: o,
  icon: s = "home",
  onChange: l,
  refetchOrders: u,
  openByDefault: p = !1
}) => {
  const [d, f] = ue(!1), [h, v] = ue(p), { isCopied: C, copy: j } = Ur(), { track: N } = In(), x = 14, g = o && (!!r || !!l), P = [n?.zip || "", n?.city || ""].filter(Boolean).join(" "), E = [n?.firstName || "", n?.lastName || ""].filter(Boolean).join(" "), I = n?.countryCodeV2 && JI(n.countryCodeV2), w = ft(() => [
    E,
    n?.company,
    n?.address1,
    n?.address2,
    P,
    n?.province,
    I
  ].filter(Boolean).join(`
`), [n, E, P, I]);
  if (!n)
    return null;
  const A = () => {
    i && r && N("shopify:order:edit:shipping:address:modal:opened", {
      shopifyId: i,
      orderId: r
    }), f(!0);
  };
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(he, { size: x, name: s, color: "green.500" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "row",
              onClick: () => v(!h),
              className: sh.clickableIcon,
              alignItems: "center",
              children: [
                /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "3", children: e }),
                /* @__PURE__ */ k.jsx(
                  he,
                  {
                    size: x,
                    name: h ? "angle-down" : "angle-right"
                  }
                )
              ]
            }
          ),
          h && /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
            E && /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "4", children: E }),
            n?.company && /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "4", children: n.company }),
            n?.address1 && /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "4", children: n.address1 }),
            n?.address2 && /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "4", children: n.address2 }),
            P && /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "4", children: P }),
            n?.province && /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "4", children: n.province }),
            I && /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "4", children: I })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        g && /* @__PURE__ */ k.jsx(Ze, { content: `Edit ${e.toLowerCase()}`, children: /* @__PURE__ */ k.jsx(
          he,
          {
            size: x,
            name: "pen",
            onClick: () => A(),
            className: sh.clickableIcon
          }
        ) }),
        /* @__PURE__ */ k.jsx(Ze, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ k.jsx(
          he,
          {
            size: x,
            name: C ? "done" : "copy",
            onClick: () => j(w()),
            className: sh.clickableIcon
          }
        ) })
      ] })
    ] }),
    g && /* @__PURE__ */ k.jsx(
      x9,
      {
        title: `Edit ${e}`,
        address: n,
        isOpen: d,
        setIsOpen: f,
        orderId: r,
        shopifyId: i,
        shippingCountryCodes: a,
        onChange: l,
        refetchOrders: u
      }
    )
  ] });
}, Ag = ({
  withAddresses: e = !0,
  selectedProductIds: n
}) => {
  const r = Br(), i = ca({ control: r.control, name: "lineItems" }), a = ca({
    control: r.control,
    name: "billingAddress"
  }), o = ca({
    control: r.control,
    name: "shippingAddress"
  }), s = Xn(() => n ? n.length === 0 ? [] : (i || []).filter(
    (p) => n.includes(p.id)
  ) : i, [i, n]), l = Xn(() => !s || s.length === 0 ? 0 : s.reduce((p, d) => {
    const f = d.priceRangeV2?.minVariantPrice?.amount || 0, h = d.quantity || 0;
    return p + f * h;
  }, 0), [s]), u = s?.[0]?.priceRangeV2?.minVariantPrice?.currencyCode || "";
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
    e && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
      /* @__PURE__ */ k.jsxs(O.Paragraph, { variant: "3", children: [
        a?.firstName,
        " ",
        a?.lastName
      ] }),
      /* @__PURE__ */ k.jsx(
        Vj,
        {
          formFieldName: "billingAddress",
          address: a,
          labelText: "Billing address",
          shippingCountryCodes: [],
          refetchOrders: () => Promise.resolve({})
        }
      ),
      /* @__PURE__ */ k.jsx(
        Vj,
        {
          formFieldName: "shippingAddress",
          address: o,
          labelText: "Shipping address",
          shippingCountryCodes: [],
          icon: "map-pin",
          refetchOrders: () => Promise.resolve({})
        }
      )
    ] }),
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "4", children: "Subtotal" }),
      /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "4", children: `${l.toFixed(2)} ${u}` })
    ] }),
    /* @__PURE__ */ k.jsx(O.Paragraph, { color: "tertiary", variant: "5", children: "Tax and shipping will be calculated by Shopify based on customer address and store settings." })
  ] });
}, S9 = "_productTableHeader_6h6pl_1", N9 = "_productImage_6h6pl_5", Co = {
  productTableHeader: S9,
  productImage: N9
}, Lg = (e) => e.media?.nodes?.[0]?.preview?.image?.url || null, j9 = ({
  product: e,
  index: n,
  onRemove: r
}) => {
  const i = Br(), a = e.priceRangeV2.minVariantPrice.amount, o = e.priceRangeV2.minVariantPrice.currencyCode, s = `lineItems.${n}.quantity`, l = i.watch(s), u = Lg(e);
  return /* @__PURE__ */ k.jsxs(ot.Tr, { children: [
    /* @__PURE__ */ k.jsx(ot.Td, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
      u && /* @__PURE__ */ k.jsx(
        xa,
        {
          src: u,
          alt: e.title,
          className: Co.productImage
        }
      ),
      /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "4", children: e.title })
    ] }) }),
    /* @__PURE__ */ k.jsx(ot.Td, { children: /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "4", children: e.totalInventory }) }),
    /* @__PURE__ */ k.jsx(ot.Td, { children: /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "4", children: `${a} ${o}` }) }),
    /* @__PURE__ */ k.jsx(ot.Td, { children: /* @__PURE__ */ k.jsx(
      Gn,
      {
        noLabel: !0,
        noAlert: !0,
        name: s,
        control: i.control,
        componentProps: {
          type: "number",
          min: 1,
          max: e.totalInventory,
          tabIndex: 0
        }
      },
      `${s}-${l}`
    ) }),
    /* @__PURE__ */ k.jsx(ot.Td, { children: /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "4", children: `${a * l} ${o}` }) }),
    /* @__PURE__ */ k.jsx(ot.Td, { children: /* @__PURE__ */ k.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ k.jsx(ir, { icon: "trash", variant: "secondary", onClick: r }) }) })
  ] });
}, w9 = 300, mo = 2, C9 = 25, I9 = ({
  onProductSelected: e
}) => {
  const { useLazyQuery: n, showNotification: r } = bn(), [i, a] = ue(""), [o, s] = ue([]), l = Br(), u = l.watch("selectedProductId"), [p, { loading: d, networkStatus: f }] = n(Pg, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (j) => {
      const N = j?.Shopify?.products?.nodes || [];
      s(
        N.filter((x) => !!x).sort((x, g) => x.title.localeCompare(g.title))
      );
    },
    onError: () => {
      s([]), r({
        title: "Something went wrong",
        text: "Could not search for products. Please try again.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  });
  zi(
    () => {
      i.trim().length >= mo && !d && f === rr.ready ? p({
        variables: {
          query: i.trim(),
          productCount: C9,
          mediaCount: 1
        }
      }) : i.trim().length < mo && s([]);
    },
    w9,
    [i]
  ), Je(() => {
    if (!u) return;
    const j = o.find(
      (N) => N.id === u
    );
    j && e(j), l.setValue("selectedProductId", void 0);
  }, [u, o, l, e]);
  const h = d && f !== rr.ready, v = i.trim().length >= mo, C = !o.length && !h && v;
  return /* @__PURE__ */ k.jsx(
    fr,
    {
      noAlert: !0,
      label: "Product selection",
      control: l.control,
      name: "selectedProductId",
      componentProps: {
        placeholder: `Search products (min. ${mo} characters)`,
        tabIndex: 0,
        getItemTitleByValue: (j) => {
          const N = o.find(
            (x) => x.id === j
          );
          return N ? /* @__PURE__ */ k.jsx(O.Paragraph, { children: N.title }) : null;
        },
        filter: {
          value: i,
          onChange: (j) => {
            a(j.target.value);
          }
        },
        onToggleDropdown: (j) => {
          !j && i !== "" && a("");
        }
      },
      children: /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
        h && /* @__PURE__ */ k.jsx(pt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(b, { justifyContent: "center", padding: "300", children: /* @__PURE__ */ k.jsx(hn, {}) }) }),
        !h && o.map((j) => {
          const N = j.totalInventory <= 0, x = Lg(j);
          return /* @__PURE__ */ k.jsx(
            pt.Item,
            {
              value: j.id,
              isDisabled: N,
              children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
                  x && /* @__PURE__ */ k.jsx(
                    xa,
                    {
                      src: x,
                      alt: j.title,
                      className: Co.productImage
                    }
                  ),
                  i ? /* @__PURE__ */ k.jsx(
                    fF,
                    {
                      text: j.title,
                      highlight: i
                    }
                  ) : /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "4", children: j.title })
                ] }),
                /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "5", children: N ? "Out of stock" : `${j.totalInventory} in stock` })
              ] })
            },
            j.id
          );
        }),
        C && /* @__PURE__ */ k.jsx(pt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(
          Gs,
          {
            title: "No products found",
            description: "Try changing your search criteria."
          }
        ) }),
        !v && !h && /* @__PURE__ */ k.jsx(pt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(
          Gs,
          {
            title: "Search for products",
            description: `Type at least ${mo} characters to search.`
          }
        ) })
      ] })
    }
  );
}, Vg = ({
  loading: e = !1,
  selectionMode: n = !1,
  hideDeleteButton: r = !1,
  hideProductSelect: i = !1,
  selectedProductIds: a = [],
  disabledProductIds: o = [],
  maxQuantities: s,
  onToggleSelect: l,
  onToggleSelectAll: u
}) => {
  const p = Br(), d = p.watch("lineItems"), f = !!d?.length, h = n && f ? d.filter(
    (N) => !o.includes(N?.id)
  ) : [], v = h.length > 0 && h.every(
    (N) => a.includes(N?.id)
  ), C = h.some(
    (N) => a.includes(N?.id)
  ) && !v, j = ft(
    (N) => {
      const x = p.getValues("lineItems"), g = x.findIndex(
        (P) => P?.id === N.id
      );
      if (g > -1) {
        const P = p.getValues(`lineItems.${g}.quantity`) || 0, E = [...x];
        E[g] = {
          ...E[g],
          quantity: P + 1
        }, p.setValue("lineItems", E);
      } else
        p.setValue("lineItems", [
          ...x,
          { ...N, quantity: 1 }
        ]);
    },
    [p]
  );
  return /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    !i && /* @__PURE__ */ k.jsx(I9, { onProductSelected: j }),
    !f && e && /* @__PURE__ */ k.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        padding: "300",
        className: Mt.boxWrapper,
        children: /* @__PURE__ */ k.jsx(hn, {})
      }
    ),
    !f && !e && /* @__PURE__ */ k.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        className: Mt.boxWrapper,
        children: /* @__PURE__ */ k.jsx(
          Gs,
          {
            title: "No products selected",
            description: "Select a product above for your new order"
          }
        )
      }
    ),
    f && /* @__PURE__ */ k.jsx(b, { margin: "300 0", children: /* @__PURE__ */ k.jsxs(
      ot,
      {
        hoverable: !0,
        framed: !1,
        headerWithBackground: !1,
        className: Co.productTable,
        children: [
          /* @__PURE__ */ k.jsx(ot.Thead, { className: Co.productTableHeader, children: /* @__PURE__ */ k.jsxs(ot.Tr, { children: [
            n && /* @__PURE__ */ k.jsx(ot.Th, { children: /* @__PURE__ */ k.jsx(
              Gg,
              {
                checked: v,
                indeterminate: C,
                onChange: () => u?.(!v)
              }
            ) }),
            /* @__PURE__ */ k.jsx(ot.Th, { children: "Product" }),
            /* @__PURE__ */ k.jsx(ot.Th, { children: "In stock" }),
            /* @__PURE__ */ k.jsx(ot.Th, { children: "Price" }),
            /* @__PURE__ */ k.jsx(ot.Th, { children: "Quantity" }),
            /* @__PURE__ */ k.jsx(ot.Th, { children: "Total" }),
            !r && /* @__PURE__ */ k.jsx(ot.Th, {})
          ] }) }),
          /* @__PURE__ */ k.jsx(ot.Tbody, { children: d?.map((N, x) => {
            if (!n)
              return /* @__PURE__ */ k.jsx(
                j9,
                {
                  product: N,
                  index: x,
                  onRemove: () => {
                    const B = d.filter(
                      (D, M) => M !== x
                    );
                    p.setValue("lineItems", B);
                  }
                },
                `${N?.id}-${x}`
              );
            const g = N, P = g.priceRangeV2.minVariantPrice.amount, E = g.priceRangeV2.minVariantPrice.currencyCode, I = `lineItems.${x}.quantity`, w = p.watch(I) || 0, A = P * w, H = Lg(g), Y = a.includes(g.id), ne = o.includes(g.id), W = s?.[g.id] ?? g.totalInventory;
            return /* @__PURE__ */ k.jsxs(
              ot.Tr,
              {
                style: ne ? { opacity: 0.5 } : void 0,
                children: [
                  /* @__PURE__ */ k.jsx(ot.Td, { children: /* @__PURE__ */ k.jsx(
                    Gg,
                    {
                      checked: Y,
                      disabled: ne,
                      onChange: () => l?.(g.id, !Y)
                    }
                  ) }),
                  /* @__PURE__ */ k.jsx(ot.Td, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
                    H && /* @__PURE__ */ k.jsx(
                      xa,
                      {
                        src: H,
                        alt: g.title,
                        className: Co.productImage
                      }
                    ),
                    /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", children: [
                      /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "4", children: g.title }),
                      ne && /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "5", children: "Already refunded" })
                    ] })
                  ] }) }),
                  /* @__PURE__ */ k.jsx(ot.Td, { children: /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "4", children: g.totalInventory }) }),
                  /* @__PURE__ */ k.jsx(ot.Td, { children: /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "4", children: `${P} ${E}` }) }),
                  /* @__PURE__ */ k.jsx(ot.Td, { children: /* @__PURE__ */ k.jsx(
                    Gn,
                    {
                      noLabel: !0,
                      noAlert: !0,
                      disabled: ne || W <= 1,
                      name: I,
                      control: p.control,
                      componentProps: {
                        type: "number",
                        min: 1,
                        max: W,
                        tabIndex: 0
                      }
                    },
                    `${I}-${p.watch(I)}`
                  ) }),
                  /* @__PURE__ */ k.jsx(ot.Td, { children: /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "4", children: `${A} ${E}` }) }),
                  !r && /* @__PURE__ */ k.jsx(ot.Td, { children: /* @__PURE__ */ k.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ k.jsx(
                    ir,
                    {
                      icon: "trash",
                      variant: "secondary",
                      onClick: () => {
                        const B = d.filter(
                          (D, M) => M !== x
                        );
                        p.setValue("lineItems", B), Y && l?.(g.id, !1);
                      }
                    }
                  ) }) })
                ]
              },
              `${g.id}-${x}`
            );
          }) })
        ]
      }
    ) })
  ] });
}, SI = ({
  previousOrderStatus: e
} = {}) => {
  const n = Br();
  return /* @__PURE__ */ k.jsx(
    fr,
    {
      label: "Payment Status",
      name: "financialStatus",
      control: n.control,
      rules: {
        required: {
          value: !0,
          message: "Please select a payment status"
        }
      },
      componentProps: {
        placeholder: "Select payment status",
        tabIndex: 0,
        getItemTitleByValue: (r) => {
          const i = Dj.find(
            (a) => a.value === r
          );
          return i ? /* @__PURE__ */ k.jsxs(
            b,
            {
              flexDirection: "row",
              gap: "200",
              alignItems: "center",
              margin: "0 0 100 0",
              children: [
                /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "4", children: i.label }),
                /* @__PURE__ */ k.jsxs(O.Paragraph, { variant: "5", color: "secondary", children: [
                  "(",
                  i.description,
                  ")"
                ] })
              ]
            }
          ) : null;
        }
      },
      children: Dj.map((r) => {
        const i = e && r.value === e;
        return /* @__PURE__ */ k.jsx(pt.Item, { value: r.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
          /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "4", children: r.label }),
            i && /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "5", color: "secondary", children: "(previous order status)" })
          ] }),
          /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "5", color: "secondary", children: r.description })
        ] }) }, r.value);
      })
    }
  );
}, NI = () => {
  const e = Br();
  return /* @__PURE__ */ k.jsx(
    fr,
    {
      label: "Fulfillment Status",
      helpIcon: {
        text: "Defaults to 'unfulfilled' if nothing is selected"
      },
      name: "fulfillmentStatus",
      control: e.control,
      componentProps: {
        clearable: !0,
        placeholder: "Select fulfillment status",
        tabIndex: 0,
        getItemTitleByValue: (n) => {
          const r = Pj.find(
            (i) => i.value === n
          );
          return r ? /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", margin: "0 0 100 0", children: [
            /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "4", children: r.label }),
            /* @__PURE__ */ k.jsxs(O.Paragraph, { variant: "5", color: "secondary", children: [
              "(",
              r.description,
              ")"
            ] })
          ] }) : null;
        }
      },
      children: Pj.map((n) => /* @__PURE__ */ k.jsx(pt.Item, { value: n.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "4", children: n.label }),
        /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "5", color: "secondary", children: n.description })
      ] }) }, n.value))
    }
  );
}, F9 = "_modal_1mprq_1", E9 = {
  modal: F9
}, lh = "create-shopify-order-form", $9 = ({
  isOpen: e,
  shopifyCustomer: n,
  displayCreateDraftOrder: r,
  setIsOpen: i,
  refetchCustomerOrders: a
}) => {
  const { useMutation: o, showNotification: s } = bn(), { track: l } = In(), [u, p] = ue(!1), [
    d,
    f
  ] = ue(!1), h = {
    firstName: n.defaultAddress?.firstName,
    lastName: n.defaultAddress?.lastName,
    address1: n.defaultAddress?.address1,
    address2: n.defaultAddress?.address2,
    city: n.defaultAddress?.city,
    zip: n.defaultAddress?.zip,
    countryCodeV2: n.defaultAddress?.countryCodeV2,
    phone: n.defaultAddress?.phone
  }, v = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: [],
    billingAddress: h,
    shippingAddress: h,
    financialStatus: Zr.Pending,
    fulfillmentStatus: void 0
  }, [C, j] = ue([]), N = dt({
    mode: "all",
    defaultValues: v
  }), x = N.watch("lineItems").length > 0, g = () => {
    N.reset(v), j([]), i(!1);
  };
  Je(() => {
    C.length > 0 && N.setValue("tags", C, { shouldDirty: !0 });
  }, [C, N]);
  const [P, { error: E }] = o(
    bI,
    {
      onError: () => {
        p(!1), s({
          title: "Something went wrong",
          text: "The order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:failed"), g();
      },
      onCompleted: () => {
        a(), p(!1), s({
          title: "Success",
          text: "The tags change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:succeeded"), g();
      }
    }
  ), [I, { error: w }] = o(
    LW,
    {
      onError: () => {
        f(!1), s({
          title: "Something went wrong",
          text: "The draft order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:draft:failed"), g();
      },
      onCompleted: () => {
        a(), f(!1), s({
          title: "Success",
          text: "The draft order creation was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:draft:succeeded"), g();
      }
    }
  ), A = (Y) => {
    const ne = Y.lineItems.map((D) => ({
      productId: D.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: D.priceRangeV2.maxVariantPrice.amount,
          currencyCode: D.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: D.quantity
    }));
    p(!0);
    const W = oa(Y?.billingAddress), B = oa(
      Y?.shippingAddress
    );
    P({
      variables: {
        order: {
          lineItems: ne,
          customer: {
            toAssociate: {
              id: n?.id
            }
          },
          note: Y.customNote,
          tags: Y.tags,
          financialStatus: Y.financialStatus,
          fulfillmentStatus: Y.fulfillmentStatus,
          shippingAddress: B,
          billingAddress: W
        }
      }
    });
  }, H = (Y) => {
    const ne = Y.lineItems.map((D) => ({
      title: D.title,
      requiresShipping: !0,
      originalUnitPriceWithCurrency: {
        amount: D.priceRangeV2.maxVariantPrice.amount,
        currencyCode: D.priceRangeV2.maxVariantPrice.currencyCode
      },
      quantity: D.quantity
    }));
    f(!0);
    const W = oa(Y?.billingAddress), B = oa(
      Y?.shippingAddress
    );
    I({
      variables: {
        input: {
          email: n.defaultEmailAddress?.emailAddress,
          note: Y.customNote,
          tags: Y.tags,
          lineItems: ne,
          shippingAddress: B,
          billingAddress: W
        }
      }
    });
  };
  return /* @__PURE__ */ k.jsxs(
    Ct,
    {
      isOpen: e,
      onClose: g,
      className: E9.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ k.jsx(It, { title: "Create new order", onClose: g }),
        /* @__PURE__ */ k.jsxs(Ft, { children: [
          /* @__PURE__ */ k.jsx(Fy, { ...N, children: /* @__PURE__ */ k.jsx("form", { id: lh, children: /* @__PURE__ */ k.jsxs(tt, { children: [
            /* @__PURE__ */ k.jsx(ie, { children: /* @__PURE__ */ k.jsx(Vg, {}) }),
            /* @__PURE__ */ k.jsx(ie, { children: /* @__PURE__ */ k.jsx(
              xt,
              {
                name: "tags",
                render: ({ fieldState: { error: Y } }) => /* @__PURE__ */ k.jsx(
                  We,
                  {
                    label: "Tags",
                    meta: {
                      error: Y?.message
                    },
                    children: /* @__PURE__ */ k.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (ne) => {
                          ne.key === "Enter" && (ne.preventDefault(), ne.stopPropagation());
                        },
                        children: /* @__PURE__ */ k.jsx(
                          kl,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: C,
                            onChange: (ne) => {
                              j(ne);
                            }
                          },
                          `tags-input-${e}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ k.jsx(ie, { span: 4, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ k.jsx(SI, {}),
              /* @__PURE__ */ k.jsx(NI, {}),
              /* @__PURE__ */ k.jsx(
                Gn,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ k.jsx(ie, { span: 2, children: /* @__PURE__ */ k.jsx(We, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Mt.boxWrapper,
                children: /* @__PURE__ */ k.jsx(Ag, {})
              }
            ) }) })
          ] }) }) }),
          (E || w) && /* @__PURE__ */ k.jsx(Tn, { error: E || w })
        ] }),
        /* @__PURE__ */ k.jsx(
          Vt,
          {
            confirmProps: {
              type: "submit",
              form: lh,
              disabled: !x || u,
              isLoading: u,
              loadingIndicator: /* @__PURE__ */ k.jsx(hn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: N.handleSubmit(A),
            ...r && {
              confirmSecondaryName: "Create draft order",
              confirmSecondaryOnClick: () => {
                N.handleSubmit(H)();
              },
              confirmSecondaryProps: {
                type: "submit",
                form: lh,
                disabled: !x || d,
                isLoading: d,
                loadingIndicator: /* @__PURE__ */ k.jsx(hn, { size: 16 }),
                tabIndex: 0
              }
            }
          }
        )
      ]
    }
  );
}, T9 = "_modal_al73g_1", O9 = {
  modal: T9
}, zj = [
  {
    label: "Customer",
    value: wi.Customer,
    description: "The customer wanted to cancel the order."
  },
  {
    label: "Declined",
    value: wi.Declined,
    description: "Payment was declined."
  },
  {
    label: "Fraud",
    value: wi.Fraud,
    description: "The order was fraudulent."
  },
  {
    label: "Inventory",
    value: wi.Inventory,
    description: "There was insufficient inventory."
  },
  {
    label: "Other",
    value: wi.Other,
    description: "The order was canceled for an unlisted reason."
  },
  {
    label: "Staff",
    value: wi.Staff,
    description: "Staff made an error."
  }
], D9 = ({
  orderId: e,
  isOpen: n,
  orderName: r,
  setIsOpen: i,
  isMutationLoading: a,
  setIsMutationLoading: o,
  refetchOrders: s
}) => {
  const { track: l } = In(), { useMutation: u, showNotification: p } = bn(), [d, f] = ue([]), h = d.length > 0, v = {
    orderId: e,
    reason: null,
    refundMethod: {
      originalPaymentMethodsRefund: !0
    },
    restock: !0,
    notifyCustomer: !1,
    staffNote: ""
  }, C = dt({
    defaultValues: v
  }), [j, { error: N, reset: x }] = u(DW, {
    onError: () => {
      o(!1), p({
        title: "Something went wrong",
        text: "Could not cancel the order.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async (E) => {
      const I = E.Shopify?.orderCancel?.orderCancelUserErrors || [];
      if (I.length > 0)
        o(!1), f(I), p({
          title: "Something went wrong",
          text: "Could not cancel the order.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      else {
        const w = E.Shopify?.orderCancel?.job?.done;
        setTimeout(async () => {
          await s().finally(() => o(!1));
        }, w ? 0 : 4e3), p({
          title: "Success",
          text: `${w ? "The order got cancelled" : "The order is being cancelled. It might take some time until it is reflected in the order details."}`,
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:cancelled"), i(!1);
      }
    }
  }), g = ft(
    (E) => {
      E.reason != null && (o(!0), j({
        variables: {
          orderId: E.orderId,
          reason: E.reason,
          refundMethod: E.refundMethod,
          restock: E.restock,
          notifyCustomer: E.notifyCustomer,
          staffNote: E.staffNote ?? ""
        }
      }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e]
  ), P = () => {
    i(!1), x(), f([]), C.reset(v);
  };
  return /* @__PURE__ */ k.jsxs(Ct, { isOpen: n, onClose: P, className: O9.modal, children: [
    /* @__PURE__ */ k.jsx(It, { title: `Cancel order ${r}`, onClose: P }),
    /* @__PURE__ */ k.jsx(Ft, { children: /* @__PURE__ */ k.jsxs(tt, { children: [
      /* @__PURE__ */ k.jsx(ie, { children: /* @__PURE__ */ k.jsx(
        fr,
        {
          control: C.control,
          label: "Reason",
          name: "reason",
          rules: {
            required: {
              value: !0,
              message: "Please select a reason"
            }
          },
          componentProps: {
            placeholder: "Select a reason",
            equalityFn: (E, I) => E === I,
            getItemTitleByValue: (E) => {
              if (!E)
                return "";
              const I = zj.find(
                (w) => w.value === E
              );
              return /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
                /* @__PURE__ */ k.jsx(O.Heading, { variant: "heading-3", children: I.label }),
                /* @__PURE__ */ k.jsx(O.Paragraph, { color: "secondary", children: I.description })
              ] });
            }
          },
          children: zj.map((E) => /* @__PURE__ */ k.jsx(pt.Item, { value: E.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            /* @__PURE__ */ k.jsx(O.Heading, { variant: "heading-3", children: E.label }),
            /* @__PURE__ */ k.jsx(O.Paragraph, { color: "secondary", children: E.description })
          ] }) }, E.value))
        }
      ) }),
      /* @__PURE__ */ k.jsx(ie, { children: /* @__PURE__ */ k.jsx(We, { label: "Refund order", children: /* @__PURE__ */ k.jsx(
        Sn,
        {
          control: C.control,
          name: "refundMethod.originalPaymentMethodsRefund"
        }
      ) }) }),
      /* @__PURE__ */ k.jsx(ie, { children: /* @__PURE__ */ k.jsx(We, { label: "Restock items", children: /* @__PURE__ */ k.jsx(Sn, { control: C.control, name: "restock" }) }) }),
      /* @__PURE__ */ k.jsx(ie, { children: /* @__PURE__ */ k.jsx(We, { label: "Notify the customer", children: /* @__PURE__ */ k.jsx(Sn, { control: C.control, name: "notifyCustomer" }) }) }),
      /* @__PURE__ */ k.jsx(ie, { children: /* @__PURE__ */ k.jsx(
        Gn,
        {
          name: "staffNote",
          label: "Staff note",
          control: C.control
        }
      ) }),
      h && /* @__PURE__ */ k.jsx(ie, { children: /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "column", children: d.map((E) => /* @__PURE__ */ k.jsxs(
        b,
        {
          flexDirection: "row",
          gap: "200",
          alignItems: "center",
          children: [
            /* @__PURE__ */ k.jsx(he, { name: "close-circle-filled", color: "red.500" }),
            /* @__PURE__ */ k.jsx(O.Heading, { variant: "heading-3", children: E.code }),
            /* @__PURE__ */ k.jsxs(O.Paragraph, { children: [
              "(",
              E.field?.join(","),
              ") ",
              E.message
            ] })
          ]
        },
        E.code
      )) }) })
    ] }) }),
    /* @__PURE__ */ k.jsx(
      Vt,
      {
        confirmProps: {
          disabled: !(C.formState.isValid && C.formState.isDirty),
          isLoading: a,
          loadingIndicator: /* @__PURE__ */ k.jsx(hn, { size: 16 })
        },
        confirmOnClick: C.handleSubmit(g),
        cancelOnClick: P,
        confirmName: N ? "Close" : "Cancel order",
        cancelName: N ? void 0 : "Cancel"
      }
    )
  ] });
}, P9 = ({
  orderId: e,
  orderName: n,
  refetchOrders: r,
  disabled: i
}) => {
  const [a, o] = ue(!1), [s, l] = ue(!1);
  return /* @__PURE__ */ k.jsxs(b, { width: "100%", children: [
    /* @__PURE__ */ k.jsx(
      et,
      {
        variant: "secondary",
        onClick: () => o(!0),
        isLoading: s,
        loadingIndicator: /* @__PURE__ */ k.jsx(hn, { size: 16 }),
        disabled: i,
        slotStart: /* @__PURE__ */ k.jsx(
          he,
          {
            size: 14,
            name: "close-circle-filled",
            color: "red.500"
          }
        ),
        className: Mt.fullWidth,
        children: "Cancel"
      }
    ),
    /* @__PURE__ */ k.jsx(
      D9,
      {
        orderId: e,
        orderName: n,
        isOpen: a,
        setIsOpen: o,
        isMutationLoading: s,
        setIsMutationLoading: l,
        refetchOrders: r
      }
    )
  ] });
}, R9 = "_modal_1mprq_1", A9 = {
  modal: R9
}, L9 = ({
  order: e,
  orderName: n,
  isOpen: r,
  shopifyId: i,
  setIsOpen: a,
  refetchOrders: o
}) => {
  const { useMutation: s, showNotification: l, useQuery: u } = bn(), { track: p } = In(), [d, f] = ue(!1), [h, v] = ue(e?.tags || []), C = "duplicate-shopify-order-form", j = (B) => ({
    firstName: B?.firstName,
    lastName: B?.lastName,
    company: B?.company,
    address1: B?.address1,
    address2: B?.address2,
    city: B?.city,
    provinceCode: B?.provinceCode,
    zip: B?.zip,
    countryCode: B?.countryCodeV2,
    phone: B?.phone
  }), N = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: e?.tags || [],
    billingAddress: j(
      e?.billingAddress ?? e?.shippingAddress
    ),
    shippingAddress: j(e?.shippingAddress),
    financialStatus: void 0,
    fulfillmentStatus: void 0
  }, x = dt({
    mode: "all",
    defaultValues: N
  }), g = x.watch("lineItems").length > 0, P = Xn(
    () => (e?.lineItems || []).map((B) => B.product?.id).filter((B) => !!B),
    [e]
  ), E = Xn(
    () => _I(P),
    [P]
  ), {
    data: I,
    loading: w,
    error: A
  } = u(Pg, {
    skip: !E,
    variables: {
      query: E,
      productCount: P.length,
      mediaCount: 1
    }
  });
  Je(() => {
    A && l({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [A, l]), Je(() => {
    if (!r || w || !I || x.getValues("lineItems")?.length)
      return;
    const B = I?.Shopify?.products?.nodes || [], D = [];
    e?.lineItems?.forEach((M) => {
      const Z = B.find(
        (je) => je.id === M.product?.id
      );
      Z && D.push({
        ...Z,
        quantity: M.quantity || 1,
        sku: M.sku,
        discountedUnitPrice: M.discountedUnitPriceSet?.shopMoney
      });
    }), D.length > 0 && x.setValue("lineItems", D, { shouldDirty: !0 });
  }, [r, I, w, e, x]), Je(() => {
    (h.length > 0 || (x.getValues("tags") || []).length > 0) && x.setValue("tags", h, { shouldDirty: !0 });
  }, [h, x]);
  const [H, { error: Y }] = s(
    bI,
    {
      onError: () => {
        f(!1), l({
          title: "Something went wrong",
          text: "The order duplication was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), p("shopify:order:duplicate:failed"), W();
      },
      onCompleted: () => {
        o(), f(!1), l({
          title: "Success",
          text: "The order was duplicated successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), p("shopify:order:duplicate:succeeded"), W();
      }
    }
  ), ne = (B) => {
    const D = B.lineItems.map((Z) => ({
      productId: Z.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: Z.discountedUnitPrice?.amount ?? Z.priceRangeV2.maxVariantPrice.amount,
          currencyCode: Z.discountedUnitPrice?.currencyCode ?? Z.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: Z.quantity,
      sku: Z.sku
    })), M = (e?.shippingLines ?? []).map(
      (Z) => ({
        title: Z.title,
        code: Z.code,
        source: Z.source,
        priceSet: {
          shopMoney: {
            amount: Z.discountedPriceSet?.shopMoney?.amount ?? "0.00",
            currencyCode: Z.discountedPriceSet?.shopMoney?.currencyCode ?? "USD"
          }
        }
      })
    );
    f(!0), H({
      variables: {
        order: {
          customer: {
            toAssociate: {
              id: i
            }
          },
          lineItems: D,
          shippingLines: M,
          note: B.customNote,
          tags: B.tags,
          financialStatus: B.financialStatus,
          fulfillmentStatus: B.fulfillmentStatus,
          shippingAddress: oa(B?.shippingAddress),
          billingAddress: oa(B?.billingAddress)
        }
      }
    });
  }, W = () => {
    x.reset(N), v(e?.tags || []), a(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    Ct,
    {
      isOpen: r,
      onClose: W,
      className: A9.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ k.jsx(It, { title: `Duplicate order ${n}`, onClose: W }),
        /* @__PURE__ */ k.jsxs(Ft, { children: [
          /* @__PURE__ */ k.jsx(Fy, { ...x, children: /* @__PURE__ */ k.jsx("form", { id: C, children: /* @__PURE__ */ k.jsxs(tt, { children: [
            /* @__PURE__ */ k.jsx(ie, { children: /* @__PURE__ */ k.jsx(Vg, { loading: w }) }),
            /* @__PURE__ */ k.jsx(ie, { children: /* @__PURE__ */ k.jsx(
              xt,
              {
                name: "tags",
                render: ({ fieldState: { error: B } }) => /* @__PURE__ */ k.jsx(
                  We,
                  {
                    label: "Tags",
                    meta: {
                      error: B?.message
                    },
                    children: /* @__PURE__ */ k.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (D) => {
                          D.key === "Enter" && (D.preventDefault(), D.stopPropagation());
                        },
                        children: /* @__PURE__ */ k.jsx(
                          kl,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: h,
                            onChange: (D) => {
                              v(D);
                            }
                          },
                          `tags-input-${r}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ k.jsx(ie, { span: 4, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ k.jsx(
                SI,
                {
                  previousOrderStatus: e?.displayFinancialStatus
                }
              ),
              /* @__PURE__ */ k.jsx(NI, {}),
              /* @__PURE__ */ k.jsx(
                Gn,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ k.jsx(ie, { span: 2, children: /* @__PURE__ */ k.jsx(We, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Mt.boxWrapper,
                children: /* @__PURE__ */ k.jsx(Ag, {})
              }
            ) }) })
          ] }) }) }),
          Y && /* @__PURE__ */ k.jsx(Tn, { error: Y })
        ] }),
        /* @__PURE__ */ k.jsx(
          Vt,
          {
            confirmProps: {
              type: "submit",
              form: C,
              disabled: !g || d || w,
              isLoading: d || w,
              loadingIndicator: /* @__PURE__ */ k.jsx(hn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: x.handleSubmit(ne)
          }
        )
      ]
    }
  );
}, V9 = "_copyIcon_1dlzg_1", z9 = {
  copyIcon: V9
}, U9 = ({
  orderId: e,
  lineItems: n,
  refundedQuantities: r = {}
}) => {
  const { isCopied: i, copy: a } = Ur();
  if (!n || n?.length === 0)
    return null;
  const o = Object.values(r).some(
    (l) => l > 0
  ), s = n.map(
    ({ title: l, quantity: u, variantTitle: p }) => p ? `${u}x ${l} (${p})` : `${u}x ${l}`
  ).join(`
`);
  return /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(
      b,
      {
        gap: "250",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        children: [
          /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "center", children: [
            /* @__PURE__ */ k.jsx(he, { size: 14, name: "shopify", color: "green.500" }),
            /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "3", children: "Line items" })
          ] }),
          /* @__PURE__ */ k.jsx(Ze, { content: "Copy line items", children: /* @__PURE__ */ k.jsx(
            he,
            {
              size: 14,
              name: i ? "done" : "copy",
              onClick: () => a(s),
              className: z9.copyIcon
            }
          ) })
        ]
      }
    ),
    o && /* @__PURE__ */ k.jsx(
      b,
      {
        gap: "100",
        flexDirection: "row",
        margin: "200 0 0",
        justifyContent: "center",
        children: /* @__PURE__ */ k.jsx(Yn, { color: "red.500", children: "Order has refunded items" })
      }
    ),
    /* @__PURE__ */ k.jsx(Qe, { children: n.map(({ id: l, title: u, quantity: p, variantTitle: d, image: f }) => {
      const h = r[l], v = h > 0, C = h > 1 ? `Refunded (${h} items)` : "Refunded";
      return /* @__PURE__ */ k.jsx(
        Qe.Item,
        {
          contentLeft: /* @__PURE__ */ k.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ k.jsx(O.Paragraph, { children: p }),
            /* @__PURE__ */ k.jsx(O.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ k.jsxs(O.Paragraph, { variant: "4", children: [
            u,
            " ",
            d && `(${d})`,
            v && /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "3", color: "red.500", children: C })
          ] }),
          contentRight: f?.url && /* @__PURE__ */ k.jsx(xa, { src: `${f?.url}&height=48`, alt: u })
        },
        `list-${e}-${l}`
      );
    }) })
  ] });
}, M9 = _l`
  mutation refuncLineItems($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        refund {
          id
          totalRefundedSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, B9 = (e) => {
  const n = [];
  return e.refunds.forEach((r) => {
    const i = r.refundLineItems.edges.filter(
      (a) => a.node.id !== null
    );
    i.length > 0 && n.push({
      ...r,
      refundLineItems: {
        ...r.refundLineItems,
        edges: i
      }
    });
  }), n;
}, jI = (e) => {
  const n = {}, r = B9(e);
  return e.lineItems?.forEach((i) => {
    n[i.id] = 0;
  }), r.forEach((i) => {
    i.refundLineItems.edges.forEach((a) => {
      const o = a.node;
      if (o.id !== null) {
        const s = o.lineItem.id;
        n[s] += o.quantity;
      }
    });
  }), n;
}, q9 = "_modal_21e62_1", H9 = {
  modal: q9
}, Uj = "partial-refund-shopify-order-form", W9 = ({
  order: e,
  orderName: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { useMutation: o, showNotification: s } = bn(), { track: l } = In(), { useQuery: u } = bn(), [p, d] = ue(!1), [f, h] = ue([]), v = Xn(
    () => e?.refunds ? jI(e) : {},
    [e]
  ), C = Xn(
    () => (e?.lineItems || []).filter((B) => (v[B.id] || 0) >= (B.quantity || 0)).map((B) => B.product?.id).filter((B) => !!B),
    [e, v]
  ), j = Xn(() => {
    const B = {};
    return (e?.lineItems || []).forEach((D) => {
      if (D.product?.id) {
        const M = v[D.id] || 0, Z = Math.max(
          0,
          (D.quantity || 0) - M
        );
        B[D.product.id] = Z;
      }
    }), B;
  }, [e, v]), N = Xn(
    () => (e?.lineItems || []).map((B) => B.product?.id).filter((B) => !!B),
    [e]
  ), x = Xn(
    () => _I(N),
    [N]
  ), {
    data: g,
    loading: P,
    error: E
  } = u(Pg, {
    skip: !x,
    variables: {
      query: x,
      productCount: N.length,
      mediaCount: 1
    }
  });
  Je(() => {
    E && s({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [E, s]);
  const I = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: ""
  }, w = dt({
    mode: "all",
    defaultValues: I
  }), A = f.length > 0, [H, { error: Y }] = o(
    M9,
    {
      onError: () => {
        s({
          title: "Something went wrong",
          text: "The partial refund was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:partial:refund:failed"), W();
      },
      onCompleted: () => {
        a(), s({
          title: "Success",
          text: "The partial refund was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:partial:refund:succeeded"), W();
      }
    }
  );
  Je(() => {
    if (!r || P || !g || w.getValues("lineItems")?.length)
      return;
    const B = g?.Shopify?.products?.nodes || [], D = [];
    e?.lineItems?.forEach((M) => {
      const Z = B.find(
        (je) => je.id === M.product?.id
      );
      if (Z) {
        const je = v[M.id] || 0, ge = (M.quantity || 1) - je;
        D.push({
          ...Z,
          quantity: ge > 0 ? ge : M.quantity || 1
        });
      }
    }), D.length > 0 && (w.setValue("lineItems", D, { shouldDirty: !0 }), h([]));
  }, [
    r,
    g,
    P,
    e,
    w,
    v
  ]);
  const ne = (B) => {
    d(!0);
    const D = (B.lineItems || []).filter(
      (M) => f.includes(M.id)
    ).map((M) => {
      const Z = e?.lineItems?.find(
        (ke) => ke.product?.id === M.id
      ), je = v[Z?.id || ""] || 0, ge = (Z?.quantity || 0) - je, ye = Math.max(
        0,
        Math.min(ge, M.quantity || 0)
      );
      return Z && ye > 0 ? { lineItemId: Z.id, quantity: ye } : void 0;
    }).filter((M) => !!M);
    H({
      variables: {
        input: {
          orderId: e.id,
          refundLineItems: D,
          note: B.customNote || void 0,
          notify: !0
        }
      }
    });
  }, W = () => {
    w.reset(I), d(!1), i(!1);
  };
  return /* @__PURE__ */ k.jsxs(Ct, { isOpen: r, onClose: W, className: H9.modal, children: [
    /* @__PURE__ */ k.jsx(It, { title: `Refund order ${n}`, onClose: W }),
    /* @__PURE__ */ k.jsxs(Ft, { children: [
      /* @__PURE__ */ k.jsx(Fy, { ...w, children: /* @__PURE__ */ k.jsx("form", { id: Uj, children: /* @__PURE__ */ k.jsxs(tt, { children: [
        /* @__PURE__ */ k.jsx(ie, { children: /* @__PURE__ */ k.jsx(
          Vg,
          {
            loading: P,
            selectionMode: !0,
            hideDeleteButton: !0,
            hideProductSelect: !0,
            selectedProductIds: f,
            disabledProductIds: C,
            maxQuantities: j,
            onToggleSelect: (B, D) => {
              h((M) => D ? Array.from(/* @__PURE__ */ new Set([...M, B])) : M.filter((Z) => Z !== B));
            },
            onToggleSelectAll: (B) => {
              const D = (w.getValues("lineItems") || []).map((M) => M.id).filter((M) => !C.includes(M));
              h(B ? D : []);
            }
          }
        ) }),
        /* @__PURE__ */ k.jsx(ie, { span: 4, children: /* @__PURE__ */ k.jsx(b, { flexDirection: "column", gap: "300", children: /* @__PURE__ */ k.jsx(
          Gn,
          {
            label: "Custom note",
            name: "customNote",
            componentProps: {
              placeholder: "Enter custom note (optional)",
              tabIndex: 0
            }
          }
        ) }) }),
        /* @__PURE__ */ k.jsx(ie, { span: 2, children: /* @__PURE__ */ k.jsx(We, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
          b,
          {
            flexDirection: "column",
            gap: "200",
            justifyContent: "end",
            className: Mt.boxWrapper,
            children: /* @__PURE__ */ k.jsx(
              Ag,
              {
                withAddresses: !1,
                selectedProductIds: f
              }
            )
          }
        ) }) })
      ] }) }) }),
      Y && /* @__PURE__ */ k.jsx(Tn, { error: Y })
    ] }),
    /* @__PURE__ */ k.jsx(
      Vt,
      {
        confirmProps: {
          type: "submit",
          form: Uj,
          disabled: !A || p || P,
          isLoading: p || P,
          loadingIndicator: /* @__PURE__ */ k.jsx(hn, { size: 16 }),
          tabIndex: 0
        },
        confirmName: "Refund selected",
        confirmOnClick: w.handleSubmit(ne)
      }
    )
  ] });
}, K9 = ({
  order: e,
  shopifyId: n,
  orderLink: r,
  refetchOrders: i
}) => {
  const { useMutation: a, showNotification: o, showModal: s } = bn(), { track: l } = In(), { suggestedRefund: u, currencyCode: p, id: d, name: f } = e, h = parseFloat(String(u?.amount)), v = !isNaN(h) && h > 0, [C] = a(OW, {
    onError: (x) => {
      setTimeout(() => N(x), 500);
    },
    onCompleted: (x) => {
      const g = x.Shopify?.refundCreate?.userErrors;
      g && g.length > 0 ? N(
        new yw({
          graphQLErrors: g.map((P) => ({
            message: P.message
          }))
        })
      ) : (o({
        title: "Order refunded",
        text: `You refunded order ${f}`,
        icon: "check-circle-filled",
        severity: "success"
      }), i());
    }
  }), j = ft(() => {
    l("shopify:order:refund:requested", { shopifyId: n, orderId: d });
    const { amount: x, ...g } = u;
    s(v ? {
      headline: `Refund Order ${f}?`,
      children: /* @__PURE__ */ k.jsxs(O.Paragraph, { children: [
        "You are about to refund ",
        x,
        " ",
        p,
        " to the customer. Are you sure you want to refund the order?"
      ] }),
      confirmLabel: "Confirm order refund",
      confirmVariant: "primary",
      cancelLabel: "Cancel",
      cancelVariant: "secondary",
      onConfirm: () => {
        l("shopify:order:refund:confirmed", { shopifyId: n, orderId: d }), C({
          variables: {
            input: g
          }
        });
      },
      onCancel: () => l("shopify:order:refund:canceled", { shopifyId: n, orderId: d })
    } : {
      headline: `Refund Order ${f}`,
      children: /* @__PURE__ */ k.jsx(O.Paragraph, { children: "No refund can be issued because no payment has been captured for this order. The order's financial status is currently pending." }),
      confirmLabel: "Close",
      confirmVariant: "secondary",
      onConfirm: () => {
      }
    });
  }, [
    n,
    d,
    f,
    p,
    u,
    v,
    s,
    C,
    l
  ]), N = ft(
    (x) => {
      s({
        headline: "Something went wrong",
        text: "It looks like something went wrong when trying to refund the order. Please create the refund in Shopify directly.",
        confirmLabel: "Close",
        children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", children: [
          /* @__PURE__ */ k.jsx(Tn, { error: x }),
          /* @__PURE__ */ k.jsx(
            At,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(r, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ k.jsx(he, { name: "external-link" }),
              children: "View order in Shopify"
            }
          )
        ] }),
        onConfirm: () => {
        }
      });
    },
    [r]
  );
  return /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
    et,
    {
      variant: "secondary",
      onClick: j,
      disabled: u?.refundLineItems?.length === 0 || !v,
      slotStart: /* @__PURE__ */ k.jsx(he, { size: 14, name: "undo" }),
      className: Mt.fullWidth,
      children: "Full refund"
    }
  ) });
}, G9 = "_modal_al73g_1", Y9 = {
  modal: G9
}, J9 = ({
  orderId: e,
  tags: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { track: o } = In(), { useMutation: s, showNotification: l } = bn(), [u, p] = ue(n), [d, f] = ue(!1), h = dt({
    defaultValues: {
      tags: n
    }
  });
  Je(() => {
    u && h.setValue("tags", u, { shouldDirty: !0 });
  }, [u]);
  const [v, { error: C, reset: j }] = s(PW, {
    onError: () => {
      f(!1), l({
        title: "Something went wrong",
        text: "The tags change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async () => {
      await a(), f(!1), l({
        title: "Success",
        text: "The tags change was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), o("shopify:order:tags:updated"), i(!1);
    }
  }), N = ft(
    (g) => {
      f(!0), v({
        variables: {
          input: {
            id: e,
            tags: g.tags
          }
        }
      }).then((P) => {
        const E = P.data?.Shopify?.orderUpdate?.order?.tags ?? g.tags;
        h.reset({ tags: E });
      });
    },
    [e, h, v]
  ), x = () => {
    i(!1), j();
  };
  return /* @__PURE__ */ k.jsxs(Ct, { isOpen: r, onClose: x, className: Y9.modal, children: [
    /* @__PURE__ */ k.jsx(It, { title: "Manage tags for order", onClose: x }),
    /* @__PURE__ */ k.jsxs(Ft, { children: [
      /* @__PURE__ */ k.jsx(tt, { children: /* @__PURE__ */ k.jsx(ie, { children: /* @__PURE__ */ k.jsx(
        xt,
        {
          control: h.control,
          name: "tags",
          render: ({ fieldState: { error: g } }) => /* @__PURE__ */ k.jsx(
            We,
            {
              label: "Tags",
              meta: {
                error: g?.message
              },
              children: /* @__PURE__ */ k.jsx(
                kl,
                {
                  placeholder: "Add tags here",
                  selectedTags: n,
                  onChange: (P) => p(P)
                }
              )
            }
          )
        }
      ) }) }),
      C && /* @__PURE__ */ k.jsx(Tn, { error: C })
    ] }),
    /* @__PURE__ */ k.jsx(
      Vt,
      {
        confirmProps: {
          disabled: !(h.formState.isValid && h.formState.isDirty),
          isLoading: d,
          loadingIndicator: /* @__PURE__ */ k.jsx(hn, { size: 16 })
        },
        confirmOnClick: h.handleSubmit(N),
        cancelOnClick: x,
        confirmName: C ? "Close" : "Save",
        cancelName: C ? void 0 : "Cancel"
      }
    )
  ] });
}, Q9 = "_editIcon_1yp2k_1", X9 = "_copyIcon_1yp2k_2", Mj = {
  editIcon: Q9,
  copyIcon: X9
}, Z9 = ({
  orderId: e,
  tags: n,
  refetchOrders: r
}) => {
  const [i, a] = ue(!1), { isCopied: o, copy: s } = Ur(), l = 14, u = n.length > 0;
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(he, { size: l, name: "tag", color: "green.500" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "3", children: "Tags" }),
          /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
            !u && /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "4", color: "tertiary", children: "No tags here yet" }),
            u && n.map((p, d) => /* @__PURE__ */ k.jsx(Mn, { size: "small", variant: "primary", children: p }, d))
          ] })
        ] })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(Ze, { content: "Edit tags", children: /* @__PURE__ */ k.jsx(
          he,
          {
            size: l,
            name: "pen",
            className: Mj.editIcon,
            onClick: () => a(!0)
          }
        ) }),
        u && /* @__PURE__ */ k.jsx(Ze, { content: "Copy tags", children: /* @__PURE__ */ k.jsx(
          he,
          {
            size: l,
            name: o ? "done" : "copy",
            className: Mj.copyIcon,
            onClick: () => s(n.join(", "))
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsx(
      J9,
      {
        orderId: e,
        tags: n,
        isOpen: i,
        setIsOpen: a,
        refetchOrders: r
      }
    )
  ] });
}, e7 = "_icon_cddi1_1", n7 = "_link_cddi1_6", Bj = {
  icon: e7,
  link: n7
}, t7 = ({ trackingInfo: e }) => {
  const { isCopied: n, copy: r } = Ur(), { company: i, number: a, url: o } = e;
  return /* @__PURE__ */ k.jsx(
    Qe.Item,
    {
      contentLeft: /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "3", children: a }),
      title: /* @__PURE__ */ k.jsx(
        O.ExternalLink,
        {
          href: o,
          target: "_blank",
          rel: "noreferrer",
          className: Bj.link,
          children: i
        }
      ),
      contentRight: a && /* @__PURE__ */ k.jsx(Ze, { content: "Copy tracking code", children: /* @__PURE__ */ k.jsx(
        he,
        {
          size: 14,
          name: n ? "done" : "copy",
          onClick: () => r(a.toString()),
          className: Bj.icon
        }
      ) })
    }
  );
}, r7 = ({
  trackingInfos: e
}) => !e || e?.length === 0 ? null : /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ k.jsx(he, { size: 14, name: "eye", color: "green.500" }),
    /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "3", children: "Tracking" })
  ] }),
  /* @__PURE__ */ k.jsx(Qe, { children: e.map((n) => /* @__PURE__ */ k.jsx(t7, { trackingInfo: n }, n.number)) })
] }), i7 = "_copyIcon_yc0fe_1", a7 = "_order_yc0fe_6", o7 = "_orderIsOpen_yc0fe_14", s7 = "_orderHeader_yc0fe_17", ta = {
  copyIcon: i7,
  order: a7,
  orderIsOpen: o7,
  orderHeader: s7
}, l7 = ({
  order: e,
  shopifyId: n,
  openByDefault: r,
  customerCountryCodes: i,
  enableEditShippingAddress: a,
  displayRefund: o,
  displayCancel: s,
  shopifyDomain: l,
  displayDuplicateOrder: u,
  displayPartialRefundOrder: p,
  refetchOrders: d
}) => {
  const { track: f } = In(), { isCopied: h, copy: v } = Ur(), { isCopied: C, copy: j } = Ur(), { isCopied: N, copy: x } = Ur(), [g, P] = ue(!1), [E, I] = ue(!1), [w, A] = ue(r), {
    id: H,
    name: Y,
    createdAt: ne,
    status: W,
    currentTotalPriceSet: B,
    currencyCode: D,
    lineItems: M,
    billingAddress: Z,
    shippingAddress: je,
    trackingInfos: ge,
    tags: ye
  } = e, ke = !!je, q = Rg(H), _e = `https://${l}/admin/orders/${q ?? ""}`, De = B?.shopMoney?.amount ?? 0, G = W.includes("cancelled"), Ye = new Intl.NumberFormat(void 0, {
    style: "currency",
    currency: D
  }).format(De), sn = e?.refunds ? jI(e) : {}, Ie = !!M?.length && M.every((Ue) => (sn[Ue.id] || 0) >= (Ue.quantity || 0));
  return /* @__PURE__ */ k.jsxs(
    b,
    {
      className: ut(ta.order, {
        [ta.orderIsOpen]: w
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ k.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: ta.orderHeader,
            onClick: () => A(!w),
            children: [
              /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
                ne && /* @__PURE__ */ k.jsx(b, { alignItems: "center", children: /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "4", children: Jn(ne).format(ny) }) }),
                /* @__PURE__ */ k.jsxs(O.Paragraph, { variant: "1", children: [
                  "Order ",
                  Y
                ] })
              ] }),
              /* @__PURE__ */ k.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: w ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        w && /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ k.jsx(he, { size: 14, name: "info", color: "green.500" }),
                  /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "3", children: "Order number" }),
                    /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "4", children: Y.replace("#", "") })
                  ] })
                ] }),
                /* @__PURE__ */ k.jsx(Ze, { content: "Copy order number", children: /* @__PURE__ */ k.jsx(
                  he,
                  {
                    size: 14,
                    name: h ? "done" : "copy",
                    onClick: () => v(Y.replace("#", "")),
                    className: ta.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ k.jsx(he, { size: 14, name: "activity", color: "green.500" }),
                  /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "3", children: "Order status" }),
                    /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "4", children: W })
                  ] })
                ] }),
                /* @__PURE__ */ k.jsx(Ze, { content: "Copy order status", children: /* @__PURE__ */ k.jsx(
                  he,
                  {
                    size: 14,
                    name: N ? "done" : "copy",
                    onClick: () => x(W),
                    className: ta.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ k.jsx(he, { size: 14, name: "chart-bar", color: "green.500" }),
                  /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "3", children: "Order value" }),
                    /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "4", children: Ye })
                  ] })
                ] }),
                /* @__PURE__ */ k.jsx(Ze, { content: "Copy order value", children: /* @__PURE__ */ k.jsx(
                  he,
                  {
                    size: 14,
                    name: C ? "done" : "copy",
                    onClick: () => j(De),
                    className: ta.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ k.jsx(
            Z9,
            {
              orderId: H,
              tags: ye,
              refetchOrders: d
            }
          ),
          /* @__PURE__ */ k.jsx(
            ty,
            {
              openByDefault: !ke,
              labelText: "Billing address",
              address: Z,
              shippingCountryCodes: i,
              refetchOrders: d
            }
          ),
          /* @__PURE__ */ k.jsx(
            ty,
            {
              openByDefault: ke,
              shopifyId: n,
              orderId: H,
              icon: "map-pin",
              labelText: "Shipping address",
              address: je,
              shippingCountryCodes: i,
              enableEditAddress: a,
              refetchOrders: d
            }
          ),
          /* @__PURE__ */ k.jsx(
            U9,
            {
              orderId: H,
              lineItems: M,
              refundedQuantities: sn
            }
          ),
          /* @__PURE__ */ k.jsx(r7, { trackingInfos: ge }),
          (o || p) && /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            o && /* @__PURE__ */ k.jsx(
              K9,
              {
                order: e,
                shopifyId: n,
                refetchOrders: d,
                orderLink: _e
              }
            ),
            p && /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
              et,
              {
                variant: "secondary",
                icon: "undo",
                onClick: () => I(!0),
                className: Mt.fullWidth,
                disabled: G || Ie,
                children: "Partial refund"
              }
            ) })
          ] }),
          (u || s) && /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            u && /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
              et,
              {
                variant: "secondary",
                icon: "plus",
                onClick: () => P(!0),
                className: Mt.fullWidth,
                children: "Duplicate"
              }
            ) }),
            s && /* @__PURE__ */ k.jsx(
              P9,
              {
                orderId: H,
                orderName: Y,
                disabled: G,
                refetchOrders: d
              }
            )
          ] }),
          /* @__PURE__ */ k.jsx(
            At,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(_e, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ k.jsx(he, { name: "external-link" }),
              onClick: () => f("shopify:view:order:clicked", {
                shopifyId: n,
                orderId: H
              }),
              children: "View order in Shopify"
            }
          )
        ] }),
        g && /* @__PURE__ */ k.jsx(
          L9,
          {
            order: e,
            shopifyId: n,
            orderName: Y,
            isOpen: g,
            setIsOpen: P,
            refetchOrders: d
          }
        ),
        E && /* @__PURE__ */ k.jsx(
          W9,
          {
            order: e,
            orderName: Y,
            isOpen: E,
            setIsOpen: I,
            refetchOrders: () => {
              d();
            }
          }
        )
      ]
    }
  );
}, c7 = ({
  customerCountryCodes: e,
  shopifyDomain: n,
  displayRefund: r,
  displayCancel: i,
  displayCreateOrder: a,
  displayCreateDraftOrder: o,
  displayDuplicateOrder: s,
  displayPartialRefundOrder: l,
  enableEditShippingAddress: u,
  shopifyCustomer: p
}) => {
  const { track: d } = In(), [f, h] = ue([]), [v, C] = ue(!1), j = Rg(p?.id), N = `https://${n}/admin/orders?customer_id=${j ?? ""}`, {
    getCustomerOrders: x,
    isCustomerOrdersLoading: g,
    customerOrdersError: P,
    customerOrders: E,
    refetchCustomerOrders: I
  } = zW();
  return Je(() => {
    !g && j && x({
      variables: {
        query: `customer_id:${j}`
      }
    });
  }, [j]), Je(() => {
    const w = E?.Shopify?.orders?.edges;
    w && h(y9({ ordersData: w }));
  }, [E]), p ? P ? /* @__PURE__ */ k.jsx(Tn, { error: P }) : /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ k.jsx(O.Heading, { variant: "heading-3", children: "Customer orders" }),
      !g && /* @__PURE__ */ k.jsx(Mn, { variant: "success", size: "small", children: f.length })
    ] }),
    a && /* @__PURE__ */ k.jsx(
      et,
      {
        variant: "secondary",
        icon: "plus",
        onClick: () => C(!0),
        children: "Create new order"
      }
    ),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      g && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(hn, {}) }),
      !g && f.length === 0 && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ k.jsx(O.Paragraph, { color: "tertiary", children: "No orders found" }) }),
      !g && f.length > 0 && /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "column", children: f.map((w, A) => /* @__PURE__ */ k.jsx(
        l7,
        {
          order: w,
          openByDefault: A === 0,
          shopifyId: p?.id,
          displayRefund: r,
          displayCancel: i,
          enableEditShippingAddress: u,
          customerCountryCodes: e,
          refetchOrders: I,
          shopifyDomain: n,
          displayDuplicateOrder: s,
          displayPartialRefundOrder: l
        },
        `${A}-${w.id}`
      )) }),
      /* @__PURE__ */ k.jsx(
        At,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(N, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ k.jsx(he, { name: "external-link" }),
          onClick: () => d("shopify:view:all:orders:clicked", {
            shopifyId: p?.id
          }),
          children: "View all orders in Shopify"
        }
      )
    ] }),
    a && /* @__PURE__ */ k.jsx(
      $9,
      {
        isOpen: v,
        setIsOpen: C,
        shopifyCustomer: p,
        refetchCustomerOrders: I,
        displayCreateDraftOrder: o
      }
    )
  ] }) : null;
}, u7 = ({
  totalOrders: e,
  amountSpent: n
}) => {
  const r = n?.amount ?? 0, i = n?.currencyCode ?? "", a = `${Number.parseFloat(r).toFixed(
    2
  )} ${i}`;
  return /* @__PURE__ */ k.jsx(k.Fragment, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsx(O.Heading, { variant: "heading-3", children: "Orders overview" }),
    /* @__PURE__ */ k.jsxs(Qe, { className: Mt.list, children: [
      /* @__PURE__ */ k.jsx(Qe.Text, { variant: "dense", className: Mt.listItem, children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "4", children: "Total orders" }),
        /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "4", children: e })
      ] }) }),
      /* @__PURE__ */ k.jsx(Qe.Text, { variant: "dense", className: Mt.listItem, children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "4", children: "Total revenue" }),
        /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] }) });
}, d7 = "_segmentName_1dkhk_1", m7 = {
  segmentName: d7
}, p7 = 100, js = 10, f7 = ({
  shopifyId: e
}) => {
  const { useQuery: n, useLazyQuery: r } = bn(), [i, a] = ue([]), [o, s] = ue(js), [l, u] = ue(!1), p = Xn(
    () => i.filter((j) => j.isMember).length,
    [i]
  ), { loading: d, error: f } = n(
    FW,
    {
      skip: !e,
      variables: {
        first: p7
      },
      onCompleted: (j) => {
        const N = j?.Shopify?.segments?.edges;
        if (N && N.length > 0) {
          const x = N.map(({ node: g }) => ({
            ...g,
            isMember: !1
          })).sort((g, P) => g.name.localeCompare(P.name));
          a(x), h({
            variables: {
              customerId: e,
              segmentIds: x.map((g) => g.id)
            }
          });
        }
      }
    }
  ), [
    h,
    { loading: v, error: C }
  ] = r(EW, {
    onCompleted: (j) => {
      const N = j?.Shopify?.customerSegmentMembership?.memberships;
      if (N && N.length > 0) {
        const x = i.map((g) => {
          const P = N.find(
            (E) => E.segmentId === g.id
          );
          return {
            ...g,
            ...P?.isMember && { isMember: P.isMember }
          };
        }).sort(
          (g, P) => g.isMember === P.isMember ? 0 : g.isMember ? -1 : 1
        );
        a(x);
      }
    }
  });
  return Je(() => {
    s(l ? i.length : js);
  }, [l]), e ? /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ k.jsx(O.Heading, { variant: "heading-3", children: "Segment membership" }),
      !d && /* @__PURE__ */ k.jsx(Mn, { variant: "success", size: "small", children: p })
    ] }),
    d && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(hn, {}) }),
    !d && i.length === 0 && /* @__PURE__ */ k.jsx(O.Paragraph, { color: "tertiary", margin: "200 0 300 0", align: "center", children: "No segments found" }),
    f && /* @__PURE__ */ k.jsx(Tn, { error: f }),
    C && /* @__PURE__ */ k.jsx(Tn, { error: C }),
    !d && i.length > 0 && /* @__PURE__ */ k.jsxs(Qe, { className: Mt.list, children: [
      i.slice(0, o).map(({ id: j, name: N, isMember: x }) => /* @__PURE__ */ k.jsx(Qe.Text, { className: Mt.listItem, children: /* @__PURE__ */ k.jsx(
        Ze,
        {
          content: `${x ? "Member of" : "Not a member of"} ${N}`,
          children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ k.jsx(O.Paragraph, { variant: "4", className: m7.segmentName, children: N }),
            v && /* @__PURE__ */ k.jsx(hn, { size: 12 }),
            !v && /* @__PURE__ */ k.jsx(b, { children: /* @__PURE__ */ k.jsx(
              he,
              {
                color: x ? "green.500" : "neutral.300",
                name: "shopify"
              }
            ) })
          ] })
        }
      ) }, j)),
      i.length > js && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "200 0 0", children: /* @__PURE__ */ k.jsx(
        et,
        {
          variant: "secondary",
          onClick: () => u(!l),
          icon: l ? "angle-up" : "angle-down",
          children: l ? "Show less" : `Show ${i.length - js} more`
        }
      ) })
    ] })
  ] }) : null;
}, h7 = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = ue(!1);
  Je(() => {
    i(!1);
  }, [
    e.customer?.phone_number,
    e.customer?.email
  ]);
  const {
    isCustomerLoading: a,
    customerError: o,
    customerData: s,
    refetchCustomer: l,
    customerNetworkStatus: u
  } = VW({ conversationContext: e, forcePhoneLookup: r }), [p, d] = ue(), [f, h] = ue(
    []
  ), v = n.apiHostName, C = n.displayRefundOrder ?? !1, j = n.displayCancelOrder ?? !1, N = n.enableEditShippingAddress ?? !1, x = n.displayEmailMarketingConsent ?? !1, g = n.displayOrdersOverview ?? !1, P = n.displaySegmentMembership ?? !1, E = n.displayDiscountCodeCreation ?? !1, I = n.displayDiscountCodes ?? !1, w = n.displayCreateOrder ?? !1, A = n.displayDuplicateOrder ?? !1, H = n.displayCreateDraftOrder ?? !1, Y = n.displayPartialRefundOrder ?? !1;
  if (Je(() => {
    const ne = s?.Shopify?.customers?.edges[0]?.node, W = !!e.customer?.phone_number && !!e.customer?.email;
    ne && !a ? (h(
      s?.Shopify?.shop?.countriesInShippingZones?.countryCodes || []
    ), d(ne)) : !ne && !a && W && !r ? i(!0) : d(void 0);
  }, [s, e]), !a && o)
    return /* @__PURE__ */ k.jsx(Tn, { error: o, retry: l });
  if (!a && !o && !p) {
    const ne = `https://${v}/admin/customers?search=${e.customer?.name || ""}`;
    return /* @__PURE__ */ k.jsxs(
      b,
      {
        margin: "200 0 300",
        gap: "300",
        flexDirection: "column",
        "data-testid": "widget-customer-not-found",
        children: [
          /* @__PURE__ */ k.jsx(O.Paragraph, { color: "secondary", children: "We cannot find the customer in Shopify." }),
          /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ k.jsx(
              GW,
              {
                refetchCustomer: l,
                conversationContext: e
              }
            ),
            /* @__PURE__ */ k.jsx(
              At,
              {
                variant: "secondary",
                style: {
                  color: "var(--dixa-typography-color-link)",
                  padding: "var(--dixa-size-spacer-100)"
                },
                navigate: () => window.open(ne, "_blank")?.focus(),
                slotStart: /* @__PURE__ */ k.jsx(he, { name: "external-link" }),
                children: "Search customers in Shopify"
              }
            )
          ] })
        ]
      }
    );
  }
  return a && u !== rr.refetch ? /* @__PURE__ */ k.jsx(b, { margin: "200 0 300", justifyContent: "center", children: /* @__PURE__ */ k.jsx(hn, {}) }) : /* @__PURE__ */ k.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ k.jsx(
          QW,
          {
            customer: p,
            shopifyDomain: v,
            refresh: l,
            loading: a,
            networkStatus: u
          }
        ),
        g && /* @__PURE__ */ k.jsx(
          u7,
          {
            totalOrders: p?.numberOfOrders,
            amountSpent: p?.amountSpent
          }
        ),
        P && /* @__PURE__ */ k.jsx(f7, { shopifyId: p?.id }),
        x && /* @__PURE__ */ k.jsx(h9, { customer: p }),
        I && /* @__PURE__ */ k.jsx(
          f9,
          {
            displayDiscountCodeCreation: E
          }
        ),
        /* @__PURE__ */ k.jsx(
          c7,
          {
            shopifyCustomer: p,
            shopifyDomain: v,
            displayRefund: C,
            displayCancel: j,
            displayCreateOrder: w,
            displayCreateDraftOrder: H,
            enableEditShippingAddress: N,
            customerCountryCodes: f,
            displayDuplicateOrder: A,
            displayPartialRefundOrder: Y
          }
        )
      ]
    }
  );
}, Tt = [];
for (let e = 0; e < 256; ++e)
  Tt.push((e + 256).toString(16).slice(1));
function y7(e, n = 0) {
  return (Tt[e[n + 0]] + Tt[e[n + 1]] + Tt[e[n + 2]] + Tt[e[n + 3]] + "-" + Tt[e[n + 4]] + Tt[e[n + 5]] + "-" + Tt[e[n + 6]] + Tt[e[n + 7]] + "-" + Tt[e[n + 8]] + Tt[e[n + 9]] + "-" + Tt[e[n + 10]] + Tt[e[n + 11]] + Tt[e[n + 12]] + Tt[e[n + 13]] + Tt[e[n + 14]] + Tt[e[n + 15]]).toLowerCase();
}
const g7 = new Uint8Array(16);
function v7() {
  return crypto.getRandomValues(g7);
}
function k7(e, n, r) {
  return crypto.randomUUID ? crypto.randomUUID() : b7(e);
}
function b7(e, n, r) {
  e = e || {};
  const i = e.random ?? e.rng?.() ?? v7();
  if (i.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, y7(i);
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._pointer_pn2q5_54{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_pn2q5_59{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_pn2q5_69{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_pn2q5_69:last-child{border-bottom:none}._modalBody_1clhs_1{width:400px}._wrapper_1ge6c_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_1ge6c_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._block_1ge6c_12{margin-bottom:var(--dixa-size-spacer-250)}._wrapper_yud4a_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._list_yud4a_7{padding:0}._listItem_yud4a_11{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItemTooltip_yud4a_15{cursor:pointer}._listItemTimestamp_yud4a_18{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._listItem_yud4a_11:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._list_zu4s7_1{padding:var(--dixa-size-spacer-100)}._listItem_zu4s7_4{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100)}._listSum_zu4s7_7{margin-top:var(--dixa-size-spacer-200);border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-400)}._transaction_1kr8d_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._transaction_1kr8d_1:hover,._transactionIsOpen_1kr8d_9{border-color:var(--dixa-color-neutral-400)}._transactionHeader_1kr8d_12{cursor:pointer}._transactionHeaderSubLine_1kr8d_15{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._transactionHeaderAlignItemRight_1kr8d_19{margin-left:auto;margin-right:var(--dixa-size-spacer-200)}._message_4z55u_54{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._message_4z55u_54:hover,._messageIsOpen_4z55u_62{border-color:var(--dixa-color-neutral-400)}._messageHeader_4z55u_66{cursor:pointer}._messageText_4z55u_70{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:auto}._messageText_4z55u_70::-webkit-scrollbar{width:7px;height:7px}._messageText_4z55u_70::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-000)}._messageText_4z55u_70::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:4px}._messageText_4z55u_70::-webkit-scrollbar-thumb:hover{background-color:var(--dixa-color-neutral-500)}._buttonLink_4z55u_93{color:var(--dixa-typography-color-link)}._order_19t4p_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_19t4p_1:hover,._orderIsOpen_19t4p_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_19t4p_12{cursor:pointer}._orderIconColor_19t4p_15{color:var(--dixa-color-green-500)}._delivery_1m9nb_1{word-break:break-all}._deliveryCode_1m9nb_4{font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-tertiary)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var ch = { exports: {} }, po = {}, qj;
function x7() {
  if (qj) return po;
  qj = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return po.Fragment = r, po.jsx = s, po.jsxs = s, po;
}
var ws = {}, Hj;
function _7() {
  return Hj || (Hj = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        P("error", t, m);
      }
    }
    function P(t, c, m) {
      {
        var y = x.ReactDebugCurrentFrame, F = y.getStackAddendum();
        F !== "" && (c += "%s", m = m.concat([F]));
        var T = m.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var E = !1, I = !1, w = !1, A = !1, H = !1, Y;
    Y = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ne(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || H || t === a || t === p || t === d || A || t === v || E || I || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function W(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var F = c.displayName || c.name || "";
      return F !== "" ? m + "(" + F + ")" : m;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function D(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var m = t;
            return B(m._context) + ".Provider";
          case u:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : D(t.type) || "Memo";
          case h: {
            var F = t, T = F._payload, S = F._init;
            try {
              return D(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var M = Object.assign, Z = 0, je, ge, ye, ke, q, _e, De;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function Ye() {
      {
        if (Z === 0) {
          je = console.log, ge = console.info, ye = console.warn, ke = console.error, q = console.group, _e = console.groupCollapsed, De = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function sn() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: M({}, t, {
              value: je
            }),
            info: M({}, t, {
              value: ge
            }),
            warn: M({}, t, {
              value: ye
            }),
            error: M({}, t, {
              value: ke
            }),
            group: M({}, t, {
              value: q
            }),
            groupCollapsed: M({}, t, {
              value: _e
            }),
            groupEnd: M({}, t, {
              value: De
            })
          });
        }
        Z < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = x.ReactCurrentDispatcher, Ue;
    function Pe(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (F) {
            var y = F.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Le;
    {
      var Xe = typeof WeakMap == "function" ? WeakMap : Map;
      Le = new Xe();
    }
    function Fe(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Le.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      Be = !0;
      var F = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ye();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (re) {
              y = re;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (re) {
              y = re;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            y = re;
          }
          t();
        }
      } catch (re) {
        if (re && y && typeof re.stack == "string") {
          for (var _ = re.stack.split(`
`), ee = y.stack.split(`
`), L = _.length - 1, U = ee.length - 1; L >= 1 && U >= 0 && _[L] !== ee[U]; )
            U--;
          for (; L >= 1 && U >= 0; L--, U--)
            if (_[L] !== ee[U]) {
              if (L !== 1 || U !== 1)
                do
                  if (L--, U--, U < 0 || _[L] !== ee[U]) {
                    var ce = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && ce.includes("<anonymous>") && (ce = ce.replace("<anonymous>", t.displayName)), typeof t == "function" && Le.set(t, ce), ce;
                  }
                while (L >= 1 && U >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = F;
      }
      var ze = t ? t.displayName || t.name : "", Oe = ze ? Pe(ze) : "";
      return typeof t == "function" && Le.set(t, Oe), Oe;
    }
    function Me(t, c, m) {
      return Fe(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Fe(t, nn(t));
      if (typeof t == "string")
        return Pe(t);
      switch (t) {
        case p:
          return Pe("Suspense");
        case d:
          return Pe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return Me(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, F = y._payload, T = y._init;
            try {
              return se(T(F), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Se = {}, Ae = x.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(m);
      } else
        Ae.setExtraStackFrame(null);
    }
    function yn(t, c, m, y, F) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + m + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              _ = t[S](c, S, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Re(F), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, S, typeof _), Re(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Re(F), g("Failed %s type: %s", m, _.message), Re(null));
          }
      }
    }
    var Q = Array.isArray;
    function $(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ae(t);
    }
    var J = x.ReactCurrentOwner, de = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, xe, $e;
    function tn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && J.current;
    }
    function pn(t, c) {
      {
        var m = function() {
          xe || (xe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function Fn(t, c) {
      {
        var m = function() {
          $e || ($e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, m, y, F, T, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: F
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, m, y, F) {
      {
        var T, S = {}, _ = null, ee = null;
        m !== void 0 && (V(m), _ = "" + m), gn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ee = c.ref, on(c));
        for (T in c)
          le.call(c, T) && !de.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (T in L)
            S[T] === void 0 && (S[T] = L[T]);
        }
        if (_ || ee) {
          var U = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, U), ee && Fn(S, U);
        }
        return xn(t, _, ee, F, y, J.current, S);
      }
    }
    var en = x.ReactCurrentOwner, vn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        vn.setExtraStackFrame(m);
      } else
        vn.setExtraStackFrame(null);
    }
    var un;
    un = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = D(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Nn = {};
    function Rn(t) {
      {
        var c = jn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function kn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Rn(c);
        if (Nn[m])
          return;
        Nn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + D(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Ve(null);
      }
    }
    function _n(t, c) {
      {
        if (typeof t != "object")
          return;
        if ($(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            dn(y) && kn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var F = N(t);
          if (typeof F == "function" && F !== t.entries)
            for (var T = F.call(t), S; !(S = T.next()).done; )
              dn(S.value) && kn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = D(c);
          yn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !un) {
          un = !0;
          var F = D(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", F || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, m, y, F, T) {
      {
        var S = ne(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = Bn();
          ee ? _ += ee : _ += jn();
          var L;
          t === null ? L = "null" : $(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (D(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var U = En(t, c, m, F, T);
        if (U == null)
          return U;
        if (S) {
          var ce = c.children;
          if (ce !== void 0)
            if (y)
              if ($(ce)) {
                for (var ze = 0; ze < ce.length; ze++)
                  _n(ce[ze], t);
                Object.freeze && Object.freeze(ce);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _n(ce, t);
        }
        if (le.call(c, "key")) {
          var Oe = D(t), re = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), mn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Oe + mn]) {
            var Dn = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Oe, Dn, Oe), Cn[Oe + mn] = !0;
          }
        }
        return t === i ? Ln(U) : An(U), U;
      }
    }
    function Vn(t, c, m) {
      return wn(t, c, m, !0);
    }
    function qn(t, c, m) {
      return wn(t, c, m, !1);
    }
    var zn = qn, Wn = Vn;
    ws.Fragment = i, ws.jsx = zn, ws.jsxs = Wn;
  })()), ws;
}
var Wj;
function S7() {
  return Wj || (Wj = 1, process.env.NODE_ENV === "production" ? ch.exports = x7() : ch.exports = _7()), ch.exports;
}
var R = S7(), wI = /* @__PURE__ */ ((e) => (e.Adjustment = "Adjustment", e.Automation = "Automation", e.BonusBalanceAdjustment = "BonusBalanceAdjustment", e.BonusPromotion = "BonusPromotion", e.BonusPromotionReturn = "BonusPromotionReturn", e.Manual = "Manual", e.PointTransactionCancellation = "PointTransactionCancellation", e.Purchase = "Purchase", e.ReceiptAdjustment = "ReceiptAdjustment", e.Return = "Return", e.RewardVoucher = "RewardVoucher", e.UpdateBalance = "UpdateBalance", e))(wI || {}), ry = /* @__PURE__ */ ((e) => (e.Addition = "Addition", e.Cancellation = "Cancellation", e.Deduction = "Deduction", e.Expiry = "Expiry", e))(ry || {});
const N7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePreferences" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_contactAttributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_ContactPatch" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }] } }] }, j7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_AddPointTransactionRequestModel_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointTransaction_AddPointTransacion" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] } }] }, w7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_GetContactById" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "meta" } }, { kind: "Field", name: { kind: "Name", value: "preferences" } }, { kind: "Field", name: { kind: "Name", value: "consents" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "comment" } }] } }] } }] } }] } }] }, C7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactOverviewById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactOverviewAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }] }] } }] } }] }, I7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactIdAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "mobilePhone" }, value: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ContactOverview_GetContactIdAsync_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_String_container" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "String" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ApiExceptionMultipleMatchesResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorCode" } }, { kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "requestId" } }, { kind: "Field", name: { kind: "Name", value: "messageDetails" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "multipleMatchesFound" } }] } }] } }] } }] } }] } }] } }] }, F7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getLatestMessagesByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactMessage_GetSmsMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetPostalMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetEmailMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }] } }] } }] }, E7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerTransactions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Transactions_GetTransactionsWithArticlesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "createdDate" } }, { kind: "Field", name: { kind: "Name", value: "transactionNumber" } }, { kind: "Field", name: { kind: "Name", value: "storeName" } }, { kind: "Field", name: { kind: "Name", value: "numberOfItems" } }, { kind: "Field", name: { kind: "Name", value: "netPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localNetPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localCurrency" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "localPrice" } }, { kind: "Field", name: { kind: "Name", value: "type" } }] } }] } }] } }] } }] } }] }, $7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrdersByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Orders_GetAllByContact" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderId" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "lastChangedAt" } }, { kind: "Field", name: { kind: "Name", value: "channel" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "externalStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "imageUri" } }, { kind: "Field", name: { kind: "Name", value: "targetUri" } }] } }] } }] } }] } }] } }] } }] } }] }, T7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointAccountV_GetPointAccounts" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_PointAccountModelV3" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "balance" } }] } }] } }] } }] } }] }, O7 = {
  "\n  mutation updatePreferences(\n    $contactId: Voyado_UUID!\n    $input: Voyado_contactAttributes_Input!\n  ) {\n    Voyado {\n      ContactsV_ContactPatch(contactId: $contactId, input: $input) {\n        id\n      }\n    }\n  }\n": N7,
  "\n  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {\n    Voyado {\n      PointTransaction_AddPointTransacion(input: $input)\n    }\n  }\n": j7,
  "\n  query getContactById($contactId: Voyado_UUID!) {\n    Voyado {\n      ContactsV_GetContactById(contactId: $contactId) {\n        id\n        attributes\n        meta\n        preferences\n        consents {\n          id\n          date\n          value\n          source\n          comment\n        }\n      }\n    }\n  }\n": w7,
  "\n  query getContactOverviewById($contactId: String!) {\n    Voyado {\n      ContactOverview_GetContactOverviewAsync(contactId: $contactId)\n    }\n  }\n": C7,
  "\n  query getContactId($email: String!, $mobilePhone: String!) {\n    Voyado {\n      ContactOverview_GetContactIdAsync(\n        email: $email\n        mobilePhone: $mobilePhone\n      ) {\n        ... on Voyado_ContactOverview_GetContactIdAsync_response {\n          ... on Voyado_String_container {\n            String\n          }\n          ... on Voyado_ApiExceptionMultipleMatchesResponse {\n            errorCode\n            message\n            requestId\n            messageDetails {\n              multipleMatchesFound\n            }\n          }\n        }\n      }\n    }\n  }\n": I7,
  "\n  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {\n    Voyado {\n      ContactMessage_GetSmsMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetPostalMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetEmailMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n    }\n  }\n": F7,
  "\n  query getCustomerTransactions(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Transactions_GetTransactionsWithArticlesByContactId(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        count\n        totalCount\n        items {\n          id\n          createdDate\n          transactionNumber\n          storeName\n          numberOfItems\n          netPriceSum\n          localNetPriceSum\n          localCurrency\n          lineItems {\n            quantity\n            article {\n              name\n            }\n            localPrice\n            type\n          }\n        }\n      }\n    }\n  }\n": E7,
  "\n  query getOrdersByContactId(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Orders_GetAllByContact(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        totalCount\n        items {\n          orderId\n          createdAt\n          lastChangedAt\n          channel\n          status\n          externalStatus\n          totalPrice\n          currencyCode\n          lineItems {\n            items {\n              id\n              quantity\n              totalPrice\n              article {\n                sku\n                name\n                description\n                imageUri\n                targetUri\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": $7,
  "\n  query getPoints($contactId: Voyado_UUID!) {\n    Voyado {\n      PointAccountV_GetPointAccounts(contactId: $contactId) {\n        ... on Voyado_PointAccountModelV3 {\n          id\n          balance\n        }\n      }\n    }\n  }\n": T7
};
function ri(e) {
  return O7[e] ?? {};
}
const D7 = ri(
  /* GraphQL */
  `
  query getContactById($contactId: Voyado_UUID!) {
    Voyado {
      ContactsV_GetContactById(contactId: $contactId) {
        id
        attributes
        meta
        preferences
        consents {
          id
          date
          value
          source
          comment
        }
      }
    }
  }
`
), P7 = ri(
  /* GraphQL */
  `
  query getContactOverviewById($contactId: String!) {
    Voyado {
      ContactOverview_GetContactOverviewAsync(contactId: $contactId)
    }
  }
`
), R7 = ri(
  /* GraphQL */
  `
  query getContactId($email: String!, $mobilePhone: String!) {
    Voyado {
      ContactOverview_GetContactIdAsync(
        email: $email
        mobilePhone: $mobilePhone
      ) {
        ... on Voyado_ContactOverview_GetContactIdAsync_response {
          ... on Voyado_String_container {
            String
          }
          ... on Voyado_ApiExceptionMultipleMatchesResponse {
            errorCode
            message
            requestId
            messageDetails {
              multipleMatchesFound
            }
          }
        }
      }
    }
  }
`
), A7 = ri(
  /* GraphQL */
  `
  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {
    Voyado {
      ContactMessage_GetSmsMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetPostalMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetEmailMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
    }
  }
`
), L7 = ri(
  /* GraphQL */
  `
  query getCustomerTransactions(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Transactions_GetTransactionsWithArticlesByContactId(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        count
        totalCount
        items {
          id
          createdDate
          transactionNumber
          storeName
          numberOfItems
          netPriceSum
          localNetPriceSum
          localCurrency
          lineItems {
            quantity
            article {
              name
            }
            localPrice
            type
          }
        }
      }
    }
  }
`
), V7 = ri(
  /* GraphQL */
  `
  query getOrdersByContactId(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Orders_GetAllByContact(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        totalCount
        items {
          orderId
          createdAt
          lastChangedAt
          channel
          status
          externalStatus
          totalPrice
          currencyCode
          lineItems {
            items {
              id
              quantity
              totalPrice
              article {
                sku
                name
                description
                imageUri
                targetUri
              }
            }
          }
        }
      }
    }
  }
`
), z7 = ri(
  /* GraphQL */
  `
  query getPoints($contactId: Voyado_UUID!) {
    Voyado {
      PointAccountV_GetPointAccounts(contactId: $contactId) {
        ... on Voyado_PointAccountModelV3 {
          id
          balance
        }
      }
    }
  }
`
), U7 = ri(
  /* GraphQL */
  `
  mutation updatePreferences(
    $contactId: Voyado_UUID!
    $input: Voyado_contactAttributes_Input!
  ) {
    Voyado {
      ContactsV_ContactPatch(contactId: $contactId, input: $input) {
        id
      }
    }
  }
`
), M7 = ri(
  /* GraphQL */
  `
  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {
    Voyado {
      PointTransaction_AddPointTransacion(input: $input)
    }
  }
`
), B7 = ({
  contactId: e
}) => {
  const { useQuery: n } = bn(), { track: r } = In(), [i, a] = ue(), [o, s] = ue(), [l, u] = ue(), {
    loading: p,
    error: d,
    data: f,
    refetch: h
  } = n(D7, {
    skip: !e,
    variables: { contactId: e }
  });
  return Je(() => {
    const v = f?.Voyado?.ContactsV_GetContactById;
    !p && v && typeof v == "object" && ("id" in v && r("voyado:profile:received", { hasProfile: !0 }), "attributes" in v && a(v.attributes), "preferences" in v && s(v.preferences), "consents" in v && u(
      v?.consents?.filter(
        (C) => C !== null
      ) || void 0
    )), !p && (!v || typeof v != "object") && r("voyado:profile:received", { hasProfile: !1 });
  }, [f?.Voyado, p]), Xn(
    () => ({
      isLoading: p,
      error: d,
      refetch: h,
      attributes: i,
      preferences: o,
      consents: l
    }),
    [d, i, o, l]
  );
};
function Ws(e = !1, n) {
  const [r, i] = ue(e);
  return Je(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const q7 = {
  count: 0,
  items: []
}, H7 = ({
  contactId: e
}) => {
  const { useQuery: n } = bn(), { track: r } = In(), [i, a] = ue(q7), {
    loading: o,
    error: s,
    data: l
  } = n(A7, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return Je(() => {
    if (!o && (l?.Voyado?.ContactMessage_GetSmsMessagesByContactId || l?.Voyado?.ContactMessage_GetPostalMessagesByContactId || l?.Voyado?.ContactMessage_GetEmailMessagesByContactId)) {
      const u = l?.Voyado?.ContactMessage_GetEmailMessagesByContactId, p = l?.Voyado?.ContactMessage_GetSmsMessagesByContactId, d = l?.Voyado?.ContactMessage_GetPostalMessagesByContactId, f = {
        count: (p?.count ?? 0) + (d?.count ?? 0) + (u?.count ?? 0),
        items: [
          ...p.items ?? [],
          ...u.items ?? [],
          ...d.items ?? []
        ]
      };
      a(f), r("voyado:messages:received", {
        emailsReceived: u.count ?? 0,
        smsReceived: p.count ?? 0,
        postalReceived: d.count ?? 0,
        total: f.count ?? 0
      });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    lastMessages: i
  };
}, W7 = {
  count: 0,
  totalCount: 0,
  items: []
}, K7 = ({
  contactId: e
}) => {
  const { useQuery: n } = bn(), { track: r } = In(), [i, a] = ue(
    W7
  ), {
    loading: o,
    error: s,
    data: l
  } = n(L7, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return Je(() => {
    const u = l?.Voyado?.Transactions_GetTransactionsWithArticlesByContactId;
    if (!o && u) {
      a(
        u
      );
      const { count: p } = u;
      p && r("voyado:transactions:received", { count: p });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    transactions: i
  };
}, G7 = ({
  conversationContext: e
}) => {
  const { useQuery: n } = bn(), [r, i] = ue(void 0), [a, o] = ue(!1), { customer: s } = e, l = !!s?.email || !!s?.phone_number, {
    loading: u,
    error: p,
    data: d,
    refetch: f
  } = n(R7, {
    skip: !l,
    variables: {
      email: s?.email ?? "",
      mobilePhone: s?.phone_number ?? ""
    }
  });
  return Je(() => {
    const h = d?.Voyado?.ContactOverview_GetContactIdAsync;
    h?.__typename === "Voyado_ApiExceptionMultipleMatchesResponse" && h?.messageDetails?.multipleMatchesFound && h?.messageDetails?.multipleMatchesFound.length > 0 && (o(!0), i(void 0)), h?.__typename === "Voyado_String_container" && h?.String && (o(!1), i(h.String));
  }, [d?.Voyado, u]), {
    isLoading: u,
    contactId: r,
    hasMultipleContacts: a,
    error: p,
    refetch: f
  };
}, Y7 = ({
  contactId: e,
  skip: n
}) => {
  const { useQuery: r } = bn(), [i, a] = ue(
    void 0
  ), {
    loading: o,
    error: s,
    data: l,
    refetch: u
  } = r(P7, {
    skip: !e || n,
    variables: { contactId: e }
  });
  return Je(() => {
    const p = l?.Voyado?.ContactOverview_GetContactOverviewAsync;
    if (!o && p && Object.hasOwn(p, "memberlevel")) {
      const d = p?.memberlevel;
      a({
        levelName: d?.levelName,
        remainingToUpgrade: d?.remainingToUpgrade,
        basedOnRewardPoints: d?.basedOnRewardPoints,
        levelId: d?.levelId,
        latestChange: d?.latestChange,
        expires: d?.expires
      });
    } else
      a(void 0);
  }, [l?.Voyado, o]), Xn(
    () => ({
      isLoading: o,
      error: s,
      memberLevel: i,
      refetch: u
    }),
    [o, s, i, u]
  );
}, J7 = "_pointer_pn2q5_54", Q7 = "_list_pn2q5_59", X7 = "_listItem_pn2q5_69", mt = {
  pointer: J7,
  list: Q7,
  listItem: X7
}, Z7 = "_modalBody_1clhs_1", eK = {
  modalBody: Z7
}, nK = ({
  isOpen: e,
  onClose: n,
  pointsAccount: r,
  setHasPointsBeenUpdated: i,
  refetchPointsQuery: a
}) => {
  const { useMutation: o, showNotification: s } = bn(), { track: l } = In(), u = r?.id, p = r?.balance ?? 0, d = {
    balance: p?.toString() ?? "0",
    description: "",
    transactionType: null
  }, { control: f, setValue: h, reset: v } = dt({
    defaultValues: d,
    mode: "onChange"
  }), C = ca({ control: f }), j = parseInt(C?.balance ?? "0", 10), N = p === j, x = N ? "Change the value to update the points" : "", g = j < 0, P = g ? "Points can not be negative" : "", E = C.description === "", I = E ? "Description can not be empty" : "";
  Je(() => {
    j > p ? h(
      "transactionType",
      ry.Addition
    ) : j < p && h(
      "transactionType",
      ry.Deduction
    );
  }, [p, j, h]);
  const [w, { loading: A, error: H, reset: Y }] = o(M7, {
    onCompleted: () => {
      s({
        title: "Success",
        text: "Points updated successfully",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), ne = () => {
    if (u) {
      const B = k7();
      w({
        variables: {
          input: {
            accountId: u,
            transactionId: B,
            amount: Math.abs(j - p),
            transactionType: C.transactionType,
            description: C.description,
            source: wI.UpdateBalance
          }
        }
      }).then(async (D) => {
        D?.errors ? l("voyado:update:points:failed") : (l("voyado:update:points:succeeded"), i(!0), await a(), W());
      }).catch(() => {
        l("voyado:update:points:failed");
      });
    }
  }, W = () => {
    v(d), Y(), n();
  };
  return /* @__PURE__ */ R.jsxs(
    Ct,
    {
      isOpen: e,
      onClose: W,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ R.jsx(It, { title: "Update points balance", onClose: W }),
        /* @__PURE__ */ R.jsxs(Ft, { className: eK.modalBody, children: [
          /* @__PURE__ */ R.jsxs(tt, { children: [
            /* @__PURE__ */ R.jsx(ie, { span: 6, children: /* @__PURE__ */ R.jsx(
              xt,
              {
                name: "balance",
                control: f,
                render: ({ field: B }) => /* @__PURE__ */ R.jsx(
                  tr,
                  {
                    label: "New points balance",
                    type: "number",
                    placeholder: "Insert new points",
                    min: 0,
                    max: 1e5,
                    meta: {
                      warning: x || P
                    },
                    input: {
                      ...B,
                      value: B.value.toString(),
                      onChange: (D) => B.onChange(D)
                    }
                  }
                )
              }
            ) }),
            /* @__PURE__ */ R.jsx(ie, { span: 6, children: /* @__PURE__ */ R.jsx(
              xt,
              {
                name: "description",
                control: f,
                render: ({ field: B }) => /* @__PURE__ */ R.jsx(
                  tr,
                  {
                    required: !0,
                    label: "Description",
                    placeholder: "Insert a description",
                    input: B,
                    meta: {
                      warning: I
                    }
                  }
                )
              }
            ) })
          ] }),
          H && /* @__PURE__ */ R.jsx(Tn, { error: H })
        ] }),
        /* @__PURE__ */ R.jsx(
          Vt,
          {
            confirmName: "Save",
            confirmOnClick: () => ne(),
            confirmProps: {
              isLoading: A,
              disabled: N || g || E,
              loadingIndicator: /* @__PURE__ */ R.jsx(hn, { size: 16 })
            },
            cancelOnClick: W
          }
        )
      ]
    }
  );
}, tK = "_wrapper_1ge6c_1", rK = "_block_1ge6c_12", Kj = {
  wrapper: tK,
  block: rK
}, iK = ({
  contactAttributes: e,
  contactId: n
}) => {
  const { useQuery: r } = bn(), { isCopied: i, copy: a } = Ws(), { isCopied: o, copy: s } = Ws(), { isCopied: l, copy: u } = Ws(), [p, d] = ue(!1), [f, h] = ue(), [v, C] = ue(!1), {
    loading: j,
    data: N,
    refetch: x
  } = r(z7, {
    variables: {
      contactId: n
    },
    skip: !n
  });
  Je(() => {
    if (N) {
      const Z = N?.Voyado?.PointAccountV_GetPointAccounts;
      Z && Z?.length > 0 && h(Z[0]);
    }
  }, [N]);
  const g = !!f?.id, P = f?.balance ?? 0;
  if (!e)
    return null;
  const {
    firstName: E,
    lastName: I,
    street: w,
    zipCode: A,
    city: H,
    country: Y,
    isRegistrationCompleted: ne,
    email: W,
    mobilePhone: B
  } = e, D = 14, M = `${E || ""} ${I || ""}`.trim() || "Anonymous";
  return /* @__PURE__ */ R.jsxs(b, { flexDirection: "column", className: Kj.wrapper, children: [
    /* @__PURE__ */ R.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: Kj.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ R.jsx(O.Heading, { variant: "heading-2", children: M }),
          j && /* @__PURE__ */ R.jsx(hn, { size: 12 }),
          g && !j && /* @__PURE__ */ R.jsxs(b, { gap: "100", alignItems: "center", children: [
            /* @__PURE__ */ R.jsxs(Mn, { size: "small", variant: "warning", children: [
              P,
              " points"
            ] }),
            /* @__PURE__ */ R.jsx(Ze, { content: "Update points balance", children: /* @__PURE__ */ R.jsx(
              he,
              {
                name: "pen",
                size: 12,
                onClick: () => d(!0),
                className: mt.pointer
              }
            ) }),
            v && /* @__PURE__ */ R.jsx(Ze, { content: "It might take a while until the updated points are available. Please refresh the integration by collapsing and expanding the widget in the sidebar.", children: /* @__PURE__ */ R.jsx(
              he,
              {
                name: "info",
                size: 12,
                className: mt.pointer
              }
            ) })
          ] })
        ]
      }
    ),
    (w || H || A || Y || B || W) && /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", children: [
      B && /* @__PURE__ */ R.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ R.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ R.jsx(he, { size: D, name: "phone" }),
          /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", children: B })
        ] }),
        /* @__PURE__ */ R.jsx(
          he,
          {
            size: D,
            name: o ? "done" : "copy",
            onClick: () => s(B),
            className: mt.pointer
          }
        )
      ] }),
      W && /* @__PURE__ */ R.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ R.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ R.jsx(he, { size: D, name: "mail" }),
          /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", children: W })
        ] }),
        /* @__PURE__ */ R.jsx(
          he,
          {
            size: D,
            name: i ? "done" : "copy",
            onClick: () => a(W),
            className: mt.pointer
          }
        )
      ] }),
      (w || H || A || Y) && /* @__PURE__ */ R.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ R.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ R.jsx(he, { size: D, name: "home" }),
          /* @__PURE__ */ R.jsxs(O.Paragraph, { variant: "4", color: "secondary", children: [
            /* @__PURE__ */ R.jsx(lt, { children: w }),
            /* @__PURE__ */ R.jsxs(lt, { children: [
              A,
              " ",
              H
            ] }),
            /* @__PURE__ */ R.jsx(lt, { children: Y })
          ] })
        ] }),
        /* @__PURE__ */ R.jsx(
          he,
          {
            size: D,
            name: l ? "done" : "copy",
            onClick: () => u(`${w}, ${A} ${H}, ${Y}`),
            className: mt.pointer
          }
        )
      ] }),
      /* @__PURE__ */ R.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ R.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ R.jsx(he, { size: D, name: "sign-in" }),
          /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", children: "Is registration completed" })
        ] }),
        /* @__PURE__ */ R.jsx(
          he,
          {
            name: ne ? "check-circle-filled" : "close-circle-filled",
            color: ne ? "green.500" : "neutral.500"
          }
        )
      ] })
    ] }),
    g && /* @__PURE__ */ R.jsx(
      nK,
      {
        isOpen: p,
        pointsAccount: f,
        onClose: () => d(!1),
        setHasPointsBeenUpdated: C,
        refetchPointsQuery: x
      }
    )
  ] });
}, aK = "_list_yud4a_7", oK = "_listItem_yud4a_11", sK = "_listItemTooltip_yud4a_15", lK = "_listItemTimestamp_yud4a_18", Cs = {
  list: aK,
  listItem: oK,
  listItemTooltip: sK,
  listItemTimestamp: lK
}, cK = ({
  contactConsents: e
}) => !e || e.length === 0 ? null : /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ R.jsx(O.Heading, { variant: "heading-3", children: "Consents" }),
  /* @__PURE__ */ R.jsx(Qe, { className: Cs.list, children: e.map((n, r) => /* @__PURE__ */ R.jsx(Qe.Text, { variant: "dense", className: Cs.listItem, children: /* @__PURE__ */ R.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ R.jsx(Ze, { content: n?.comment, children: /* @__PURE__ */ R.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: ut({
          [Cs.listItemTooltip]: n?.comment
        }),
        children: [
          /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", children: n.id }),
          /* @__PURE__ */ R.jsx(O.Paragraph, { className: Cs.listItemTimestamp, children: Jn(n.date).format(jt) }),
          n?.comment && /* @__PURE__ */ R.jsx(he, { name: "info", color: "neutral.400" })
        ]
      }
    ) }),
    /* @__PURE__ */ R.jsx(
      he,
      {
        name: n.value ? "check-circle-filled" : "close-circle-filled",
        color: n.value ? "green.500" : "red.500"
      }
    )
  ] }) }, r)) })
] }), uK = ({
  memberLevel: e
}) => {
  const n = e?.levelName ?? null, r = e?.remainingToUpgrade ?? null, i = e?.basedOnRewardPoints ?? null, a = e?.latestChange ? Jn(e.latestChange).format(jt) : null, o = e?.expires ? `${Jn(e.expires).fromNow()} (${Jn(e.expires).format(jt)})` : null, s = !n && !a && !r && !i && !o;
  return /* @__PURE__ */ R.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ R.jsxs(b, { alignItems: "center", gap: "100", children: [
      /* @__PURE__ */ R.jsx(O.Heading, { variant: "heading-3", children: "Member level" }),
      /* @__PURE__ */ R.jsx(Ze, { content: "Voyado updates the member level data in a nightly batch process", children: /* @__PURE__ */ R.jsx(
        he,
        {
          name: "question",
          size: 14,
          className: mt.pointer
        }
      ) })
    ] }),
    /* @__PURE__ */ R.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ R.jsxs(Qe, { className: mt.list, children: [
      s && /* @__PURE__ */ R.jsx(Qe.Text, { variant: "dense", className: mt.listItem, children: /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", color: "secondary", children: "No member level properties found" }) }),
      n && /* @__PURE__ */ R.jsx(Qe.Text, { variant: "dense", className: mt.listItem, children: /* @__PURE__ */ R.jsx(Ze, { content: "", children: /* @__PURE__ */ R.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", children: "Level" }),
        /* @__PURE__ */ R.jsx(Mn, { variant: "info", size: "small", children: e?.levelName ?? "" })
      ] }) }) }),
      i && /* @__PURE__ */ R.jsx(Qe.Text, { variant: "dense", className: mt.listItem, children: /* @__PURE__ */ R.jsx(Ze, { content: "Voyado updates the member level data once a day in a nightly job", children: /* @__PURE__ */ R.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", children: "Based on reward points" }),
        /* @__PURE__ */ R.jsx(Mn, { variant: "success", size: "small", children: i })
      ] }) }) }),
      r && /* @__PURE__ */ R.jsx(Qe.Text, { variant: "dense", className: mt.listItem, children: /* @__PURE__ */ R.jsx(Ze, { content: "", children: /* @__PURE__ */ R.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", children: "Remaining to upgrade" }),
        /* @__PURE__ */ R.jsx(Mn, { variant: "success", size: "small", children: r })
      ] }) }) }),
      a && /* @__PURE__ */ R.jsx(Qe.Text, { variant: "dense", className: mt.listItem, children: /* @__PURE__ */ R.jsx(Ze, { content: "", children: /* @__PURE__ */ R.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", children: "Latest change" }),
        /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "5", color: "secondary", children: a })
      ] }) }) }),
      o && /* @__PURE__ */ R.jsx(Qe.Text, { variant: "dense", className: mt.listItem, children: /* @__PURE__ */ R.jsx(Ze, { content: "", children: /* @__PURE__ */ R.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", children: "Expires" }),
        /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "5", color: "secondary", children: o })
      ] }) }) })
    ] }) })
  ] }) });
}, dK = "_tagHover_kzbzk_1", mK = "_channelUnsubscribed_kzbzk_6", Gj = {
  tagHover: dK,
  channelUnsubscribed: mK
}, uh = ({
  isSubscribed: e,
  channelName: n,
  channelIcon: r,
  contactId: i,
  contactPreferences: a,
  refetchContact: o
}) => {
  const { track: s } = In(), { useMutation: l } = bn(), [u, p] = ue(!1), [d, { loading: f }] = l(U7), h = async ({
    newPreference: C,
    isSubscribed: j,
    channelType: N
  }) => {
    p(!0), (await d({
      variables: {
        contactId: i,
        input: {
          preferences: {
            ...a,
            ...C
          }
        }
      }
    }))?.data?.Voyado.ContactsV_ContactPatch?.id ? j ? s("voyado:channel:unsubscribe:succeeded", { channel: N }) : s("voyado:channel:subscribe:succeeded", { channel: N }) : j ? s("voyado:channel:unsubscribe:failed", { channel: N }) : s("voyado:channel:subscribe:failed", { channel: N }), setTimeout(async () => {
      await o().finally(() => p(!1));
    }, 1e3);
  }, v = u || f;
  return /* @__PURE__ */ R.jsx(Ze, { content: e ? "Unsubscribe" : "Subscribe", children: /* @__PURE__ */ R.jsx(
    Yn,
    {
      className: Gj.tagHover,
      color: e ? "green.500" : "neutral.200",
      children: /* @__PURE__ */ R.jsxs(
        b,
        {
          "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
          gap: "200",
          alignItems: "center",
          className: ut({
            [Gj.channelUnsubscribed]: !e
          }),
          onClick: () => {
            e ? s("voyado:channel:unsubscribe:clicked", {
              channel: n.toUpperCase()
            }) : s("voyado:channel:subscribe:clicked", {
              channel: n.toUpperCase()
            }), h({
              newPreference: { [`accepts${n}`]: !e },
              isSubscribed: e,
              channelType: n.toUpperCase()
            });
          },
          children: [
            v ? /* @__PURE__ */ R.jsx(hn, { size: 16 }) : /* @__PURE__ */ R.jsx(he, { size: 16, name: r }),
            n
          ]
        }
      )
    }
  ) });
}, pK = ({
  contactPreferences: e,
  contactId: n,
  refetchContact: r
}) => {
  if (!e || !n)
    return null;
  const { acceptsEmail: i, acceptsPostal: a, acceptsSms: o } = e;
  return /* @__PURE__ */ R.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ R.jsx(O.Heading, { variant: "heading-3", children: "Subscriptions" }),
    /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "row", children: [
      /* @__PURE__ */ R.jsx(
        uh,
        {
          channelName: "Email",
          channelIcon: "mail",
          isSubscribed: i,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ R.jsx(
        uh,
        {
          channelName: "Sms",
          channelIcon: "sms",
          isSubscribed: o,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ R.jsx(
        uh,
        {
          channelName: "Postal",
          channelIcon: "paper-plane",
          isSubscribed: a,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      )
    ] })
  ] }) });
}, fK = ({
  contactId: e,
  settings: n
}) => {
  const {
    showCustomerAttributes: r,
    showPreferences: i,
    showAudiences: a,
    showConsents: o,
    showMemberLevel: s
  } = n, {
    isLoading: l,
    error: u,
    refetch: p,
    attributes: d,
    preferences: f,
    consents: h
  } = B7({ contactId: e }), {
    isLoading: v,
    error: C,
    memberLevel: j
  } = Y7({ contactId: e, skip: !s }), N = v || l, x = Xn(
    () => h?.filter(
      (g) => g !== null
    ),
    [h]
  );
  return u || C ? ba({
    errors: u?.graphQLErrors || C?.graphQLErrors || []
  }) ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ R.jsx(O.Paragraph, { color: "secondary", children: "No contact informations found" }) }) : /* @__PURE__ */ R.jsx(Tn, { error: u || C }) : !r && !i && !a && !o && !s ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ R.jsx(O.Paragraph, { color: "secondary", children: "All contact related features in the settings are disabled." }) }) : N ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ R.jsx(hn, {}) }) : /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
    r && /* @__PURE__ */ R.jsx(
      iK,
      {
        contactAttributes: d,
        contactId: e
      }
    ),
    s && /* @__PURE__ */ R.jsx(uK, { memberLevel: j }),
    i && /* @__PURE__ */ R.jsx(
      pK,
      {
        refetchContact: p,
        contactPreferences: f,
        contactId: e
      }
    ),
    o && /* @__PURE__ */ R.jsx(cK, { contactConsents: x })
  ] });
}, iy = (e, n) => `${e ? e.toFixed(2) : "0.00"} ${n}`, hK = "_list_zu4s7_1", yK = "_listItem_zu4s7_4", gK = "_listSum_zu4s7_7", Is = {
  list: hK,
  listItem: yK,
  listSum: gK
}, vK = ({
  lineItems: e,
  localCurrency: n,
  localNetPriceSum: r
}) => /* @__PURE__ */ R.jsxs(Qe, { className: Is.list, children: [
  e?.map(({ quantity: i, article: a, localPrice: o, type: s }, l) => /* @__PURE__ */ R.jsx(Qe.Text, { variant: "dense", className: Is.listItem, children: /* @__PURE__ */ R.jsx(Ze, { content: s, children: /* @__PURE__ */ R.jsxs(b, { justifyContent: "space-between", gap: "200", children: [
    /* @__PURE__ */ R.jsxs(b, { flex: "0 0 auto", gap: "200", children: [
      /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", children: i }),
      /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", children: "×" })
    ] }),
    /* @__PURE__ */ R.jsx(b, { flex: "auto", children: /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", children: a?.name }) }),
    o && n && /* @__PURE__ */ R.jsx(b, { flex: "0 0 auto", gap: "100", children: /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", children: iy(o, n) }) })
  ] }) }) }, l)),
  /* @__PURE__ */ R.jsx(
    Qe.Text,
    {
      variant: "dense",
      className: ut(Is.listItem, Is.listSum),
      children: /* @__PURE__ */ R.jsxs(b, { gap: "100", justifyContent: "space-between", children: [
        /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "3", children: "Sum" }),
        /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "3", children: iy(r, n) })
      ] })
    },
    "theSumOfItAll"
  )
] }), kK = "_transaction_1kr8d_1", bK = "_transactionIsOpen_1kr8d_9", xK = "_transactionHeader_1kr8d_12", _K = "_transactionHeaderSubLine_1kr8d_15", SK = "_transactionHeaderAlignItemRight_1kr8d_19", ra = {
  transaction: kK,
  transactionIsOpen: bK,
  transactionHeader: xK,
  transactionHeaderSubLine: _K,
  transactionHeaderAlignItemRight: SK
}, NK = ({
  transaction: e,
  openByDefault: n
}) => {
  const [r, i] = ue(n), {
    transactionNumber: a,
    createdDate: o,
    storeName: s,
    numberOfItems: l,
    storeType: u,
    lineItems: p,
    localCurrency: d,
    localNetPriceSum: f
  } = e, h = d ?? "", v = f ?? 0, C = p?.length ? p : [];
  return /* @__PURE__ */ R.jsxs(
    b,
    {
      className: ut(ra.transaction, {
        [ra.transactionIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ R.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: ra.transactionHeader,
            onClick: () => i(!r),
            "data-testid": "contact-transaction-header",
            children: [
              /* @__PURE__ */ R.jsxs(b, { style: { flexGrow: 1 }, children: [
                /* @__PURE__ */ R.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  o && /* @__PURE__ */ R.jsx(Mn, { size: "small", variant: "info", children: Jn(o).format(jt) }),
                  /* @__PURE__ */ R.jsxs(
                    O.Heading,
                    {
                      variant: "heading-4",
                      className: ra.transactionHeaderSubLine,
                      children: [
                        "ID: ",
                        a
                      ]
                    }
                  )
                ] }),
                /* @__PURE__ */ R.jsxs(
                  b,
                  {
                    flexDirection: "column",
                    gap: "100",
                    className: ra.transactionHeaderAlignItemRight,
                    children: [
                      /* @__PURE__ */ R.jsx(O.Heading, { variant: "heading-4", children: iy(v, h) }),
                      /* @__PURE__ */ R.jsxs(
                        O.Heading,
                        {
                          variant: "heading-4",
                          className: ra.transactionHeaderSubLine,
                          children: [
                            l,
                            " line ",
                            `${l === 1 ? "item" : "items"}`
                          ]
                        }
                      )
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ R.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ R.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              ) })
            ]
          }
        ),
        r && /* @__PURE__ */ R.jsxs(
          b,
          {
            gap: "300",
            flexDirection: "column",
            "data-testid": "contact-transaction-content",
            children: [
              /* @__PURE__ */ R.jsx(uy, {}),
              /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "column", children: [
                s && /* @__PURE__ */ R.jsx(O.Heading, { variant: "heading-2", children: s }),
                u && /* @__PURE__ */ R.jsx(Yn, { children: /* @__PURE__ */ R.jsx(b, { alignItems: "center", children: u }) }),
                /* @__PURE__ */ R.jsx(
                  vK,
                  {
                    lineItems: C,
                    localCurrency: h,
                    localNetPriceSum: v
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
}, jK = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    transactions: i
  } = K7({ contactId: e });
  if (!e)
    return null;
  const { items: a, totalCount: o } = i, s = o ?? 0;
  return r ? /* @__PURE__ */ R.jsx(Tn, { error: r }) : /* @__PURE__ */ R.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "column",
      "data-testid": "contact-transactions-wrapper",
      children: [
        /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
          /* @__PURE__ */ R.jsx(O.Heading, { variant: "heading-3", children: "Transactions" }),
          !n && s > 0 && /* @__PURE__ */ R.jsx(Mn, { size: "small", variant: "success", children: s })
        ] }),
        n ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ R.jsx(hn, {}) }) : /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
          s === 0 && /* @__PURE__ */ R.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", color: "secondary", children: "There are no transactions for this contact" }) }),
          s > 0 && a?.map((l, u) => /* @__PURE__ */ R.jsx(
            NK,
            {
              transaction: l,
              openByDefault: u === 0
            },
            u
          ))
        ] })
      ]
    }
  );
}, wK = "_message_4z55u_54", CK = "_messageIsOpen_4z55u_62", IK = "_messageHeader_4z55u_66", FK = "_messageText_4z55u_70", EK = "_buttonLink_4z55u_93", fo = {
  message: wK,
  messageIsOpen: CK,
  messageHeader: IK,
  messageText: FK,
  buttonLink: EK
}, dh = {
  status: {
    Delivered: "check-circle",
    Waiting: "clock",
    Hardbounce: "close-circle-filled",
    Softbounce: "close"
  },
  type: {
    EmailMessage: "mail",
    SmsMessage: "sms",
    PostalMessage: "paper-plane"
  },
  source: {
    Automation: "chat-bot",
    Manual: "user",
    System: "eye"
  }
}, mh = (e, n) => n && e in dh && n in dh[e] ? dh[e][n] : null, $K = ({
  message: e,
  openByDefault: n
}) => {
  const [r, i] = ue(n), { track: a } = In();
  if (!e)
    return null;
  const {
    name: o,
    sendDateTime: s,
    type: l,
    source: u,
    isTransactional: p,
    status: d,
    messageLink: f,
    messageText: h
  } = e, v = l ? mh("type", l) : null, C = u ? mh("source", u) : null, j = d ? mh("status", d) : null, N = l?.replace("Message", "");
  return /* @__PURE__ */ R.jsxs(
    b,
    {
      className: ut(fo.message, {
        [fo.messageIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ R.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: fo.messageHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ R.jsxs(b, { gap: "200", alignItems: "center", children: [
                  v && /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
                    /* @__PURE__ */ R.jsx(he, { name: v, size: 16 }),
                    " ",
                    N
                  ] }),
                  s && /* @__PURE__ */ R.jsx(Mn, { size: "small", variant: "info", children: Jn(s).format(jt) })
                ] }),
                o
              ] }),
              /* @__PURE__ */ R.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ R.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ R.jsx(uy, {}),
          /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
            j && /* @__PURE__ */ R.jsx(Yn, { children: /* @__PURE__ */ R.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ R.jsx(he, { name: j }),
              " ",
              d
            ] }) }),
            C && /* @__PURE__ */ R.jsx(Yn, { children: /* @__PURE__ */ R.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ R.jsx(he, { name: C }),
              " ",
              u
            ] }) }),
            p && /* @__PURE__ */ R.jsx(Yn, { children: /* @__PURE__ */ R.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ R.jsx(he, { name: "exchange" }),
              " Transactional"
            ] }) })
          ] }),
          /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", color: "secondary", children: "Message text" }),
            /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", className: fo.messageText, children: h })
          ] }),
          f && /* @__PURE__ */ R.jsx(
            At,
            {
              slotEnd: /* @__PURE__ */ R.jsx(he, { name: "external-link" }),
              variant: "tertiary",
              className: fo.buttonLink,
              navigate: () => {
                N && a("voyado:message:external-link:opened", {
                  channel: N.toUpperCase()
                }), window.open(f, "_blank")?.focus();
              },
              children: "Open message in new tab"
            }
          )
        ] })
      ]
    }
  );
}, TK = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    lastMessages: i
  } = H7({ contactId: e });
  if (!e)
    return null;
  if (r)
    return /* @__PURE__ */ R.jsx(Tn, { error: r });
  const { count: a, items: o } = i, s = (a && a) ?? 0, l = s > 0;
  return /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ R.jsx(O.Heading, { variant: "heading-3", children: "Last Messages" }),
      !n && l && /* @__PURE__ */ R.jsx(Mn, { variant: "success", size: "small", children: s })
    ] }),
    /* @__PURE__ */ R.jsx(b, { gap: "200", flexDirection: "column", children: n ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ R.jsx(hn, {}) }) : /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
      l && o?.map((u, p) => /* @__PURE__ */ R.jsx(
        $K,
        {
          message: u || void 0,
          openByDefault: p === 0
        },
        p
      )),
      !l && /* @__PURE__ */ R.jsx(b, { justifyContent: "center", margin: "200", children: /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", color: "secondary", children: "No messages available" }) })
    ] }) })
  ] });
}, Hl = ({
  value: e,
  currencyCode: n
}) => `${Number.parseFloat((e ?? 0).toString()).toFixed(2)} ${n ?? ""}`, Yj = ({
  labelText: e,
  address: n,
  icon: r = "home"
}) => {
  const { isCopied: i, copy: a } = Ws(), o = [n?.title, n?.firstname, n?.lastname].filter(Boolean).join(" "), s = ft(() => [
    o,
    n?.streetAddress,
    n?.streetAddress2,
    n?.postalCode,
    n?.region,
    n?.city,
    n?.country
  ].filter(Boolean).join(`
`), [n, o]);
  if (!n)
    return null;
  const l = 14;
  return /* @__PURE__ */ R.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ R.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ R.jsx(he, { size: l, name: r, color: "green.500" }),
      /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "3", children: e }),
        /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "column", children: [
          o && /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", children: o }),
          n?.streetAddress && /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", children: n.streetAddress }),
          n?.streetAddress2 && /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", children: n.streetAddress2 }),
          n?.postalCode && /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", children: n?.postalCode }),
          n?.region && /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", children: n.region }),
          n?.city && /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", children: n.city }),
          n?.country && /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", children: n.country })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ R.jsx(Ze, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ R.jsx(
      he,
      {
        size: l,
        name: i ? "done" : "copy",
        onClick: () => a(s()),
        className: mt.pointer
      }
    ) })
  ] });
}, OK = "_order_19t4p_1", DK = "_orderIsOpen_19t4p_9", PK = "_orderHeader_19t4p_12", RK = "_orderIconColor_19t4p_15", Rr = {
  order: OK,
  orderIsOpen: DK,
  orderHeader: PK,
  orderIconColor: RK
}, AK = "_delivery_1m9nb_1", LK = "_deliveryCode_1m9nb_4", ph = {
  delivery: AK,
  deliveryCode: LK
}, VK = ({
  delivery: e
}) => {
  const { isCopied: n, copy: r } = Jt();
  if (!e)
    return null;
  const { method: i, trackingNumber: a, trackingUri: o, deliveryDate: s } = e, l = 14;
  return /* @__PURE__ */ R.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ R.jsx(
      he,
      {
        size: l,
        name: "eye",
        className: Rr.orderIconColor
      }
    ),
    /* @__PURE__ */ R.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
      /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "3", children: "Delivery" }),
      /* @__PURE__ */ R.jsx(
        Ze,
        {
          content: /* @__PURE__ */ R.jsxs(O.Paragraph, { variant: "4", color: "inherit", children: [
            "Arrives: ",
            Jn(s).format(jt)
          ] }),
          children: /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "column", children: [
            o ? /* @__PURE__ */ R.jsx(
              O.ExternalLink,
              {
                href: o,
                target: "_blank",
                rel: "noreferrer",
                children: /* @__PURE__ */ R.jsxs(
                  b,
                  {
                    gap: "100",
                    alignItems: "center",
                    className: ph.delivery,
                    children: [
                      /* @__PURE__ */ R.jsx(he, { name: "external-link", size: l }),
                      i
                    ]
                  }
                )
              }
            ) : i,
            /* @__PURE__ */ R.jsx(
              O.Paragraph,
              {
                variant: "4",
                className: ut(ph.delivery, ph.deliveryCode),
                children: a
              }
            )
          ] })
        }
      )
    ] }),
    a && /* @__PURE__ */ R.jsx(Ze, { content: "Copy tracking code", children: /* @__PURE__ */ R.jsx(
      he,
      {
        size: l,
        name: n ? "done" : "copy",
        onClick: () => r(a.toString()),
        className: mt.pointer
      }
    ) })
  ] });
}, zK = ({
  fees: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ R.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ R.jsx(
        he,
        {
          size: 14,
          name: "file-text",
          className: Rr.orderIconColor
        }
      ),
      /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "3", children: "Fees" })
    ] }),
    /* @__PURE__ */ R.jsx(Qe, { className: mt.list, children: r?.map((i, a) => /* @__PURE__ */ R.jsx(Qe.Item, { className: mt.listItem, children: /* @__PURE__ */ R.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        children: [
          /* @__PURE__ */ R.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "5", children: i?.type }),
            /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", children: i?.description })
          ] }),
          /* @__PURE__ */ R.jsx(b, { flexDirection: "column", gap: "100", children: i?.taxes?.items?.map((o, s) => /* @__PURE__ */ R.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "column",
              className: mt.listItemAlignRight,
              children: [
                /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "5", children: `${o?.description} ${o?.percent}%` }),
                /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", children: Hl({ value: o?.amount, currencyCode: n }) })
              ]
            },
            `tax-${s}`
          )) })
        ]
      }
    ) }, `fees-${a}`)) })
  ] });
}, UK = ({
  lineItems: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ R.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ R.jsx(
        he,
        {
          size: 14,
          name: "tag",
          className: Rr.orderIconColor
        }
      ),
      /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "3", children: "Line items" })
    ] }),
    /* @__PURE__ */ R.jsx(Qe, { className: mt.list, children: r?.map((i) => /* @__PURE__ */ R.jsx(
      Qe.Item,
      {
        className: mt.listItem,
        contentLeft: /* @__PURE__ */ R.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", children: i?.quantity }),
          /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", children: "×" })
        ] }),
        title: /* @__PURE__ */ R.jsx(
          Ze,
          {
            content: /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "3", color: "inherit", children: i?.article?.sku }),
            children: /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", children: i?.article?.name }),
              /* @__PURE__ */ R.jsx(b, { children: /* @__PURE__ */ R.jsx(Mn, { size: "small", variant: "info", children: Hl({
                value: i?.totalPrice,
                currencyCode: n
              }) }) })
            ] })
          }
        ),
        contentRight: i?.article?.imageUri && /* @__PURE__ */ R.jsx(
          xa,
          {
            src: i?.article?.imageUri,
            alt: i?.article?.name,
            style: { height: "48px" }
          }
        )
      },
      `list-${i?.id}`
    )) })
  ] });
}, MK = ({
  payments: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ R.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ R.jsx(
        he,
        {
          size: 14,
          name: "credit-card",
          className: Rr.orderIconColor
        }
      ),
      /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "3", children: "Payment methods" })
    ] }),
    /* @__PURE__ */ R.jsx(Qe, { className: mt.list, children: r?.map((i, a) => /* @__PURE__ */ R.jsx(
      Qe.Item,
      {
        className: mt.listItem,
        children: /* @__PURE__ */ R.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            children: [
              /* @__PURE__ */ R.jsxs(b, { flexDirection: "column", gap: "100", children: [
                /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "5", children: i?.description }),
                /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", children: i?.method })
              ] }),
              /* @__PURE__ */ R.jsxs(
                b,
                {
                  gap: "100",
                  flexDirection: "column",
                  className: mt.listItemAlignRight,
                  children: [
                    /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "5", children: Jn(i?.paidAt).format(jt) }),
                    /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", children: Hl({ value: i?.amount, currencyCode: n }) })
                  ]
                }
              )
            ]
          }
        )
      },
      `payments-${a}`
    )) })
  ] });
}, BK = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = ue(n);
  if (!e)
    return null;
  const {
    orderId: a,
    status: o,
    externalStatus: s,
    currencyCode: l,
    channel: u,
    createdAt: p,
    lastChangedAt: d,
    lineItems: f,
    billingAddress: h,
    deliveryAddress: v,
    totalPrice: C
  } = e, j = 14;
  return /* @__PURE__ */ R.jsxs(
    b,
    {
      className: ut(Rr.order, {
        [Rr.orderIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ R.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Rr.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "column", children: [
                p && /* @__PURE__ */ R.jsx(b, { alignItems: "center", children: /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", children: Jn(p).format(jt) }) }),
                /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "1", children: a })
              ] }),
              /* @__PURE__ */ R.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ R.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ R.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ R.jsx(
              he,
              {
                size: j,
                name: "activity",
                className: Rr.orderIconColor
              }
            ),
            /* @__PURE__ */ R.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ R.jsxs(b, { gap: "100", alignItems: "center", flexWrap: "wrap", children: [
                o && /* @__PURE__ */ R.jsx(Ze, { content: "Internal status", children: /* @__PURE__ */ R.jsx(Mn, { size: "small", variant: "info", children: /* @__PURE__ */ R.jsx(R.Fragment, { children: o }) }) }),
                s && /* @__PURE__ */ R.jsx(Ze, { content: "External status", children: /* @__PURE__ */ R.jsx(Mn, { size: "small", variant: "info", children: /* @__PURE__ */ R.jsx(R.Fragment, { children: s }) }) }),
                /* @__PURE__ */ R.jsx(Ze, { content: "Last updated at", children: /* @__PURE__ */ R.jsx(O.Paragraph, { as: "span", variant: "5", children: Jn(d).format(jt) }) })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ R.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ R.jsx(
              he,
              {
                size: j,
                name: "chart-bar",
                className: Rr.orderIconColor
              }
            ),
            /* @__PURE__ */ R.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", children: Hl({
                value: C,
                currencyCode: l
              }) })
            ] })
          ] }),
          u && /* @__PURE__ */ R.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ R.jsx(
              he,
              {
                size: j,
                name: "channels",
                className: Rr.orderIconColor
              }
            ),
            /* @__PURE__ */ R.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "3", children: "Channel" }),
              /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", children: /* @__PURE__ */ R.jsx(Mn, { size: "small", variant: "info", children: /* @__PURE__ */ R.jsx(R.Fragment, { children: u }) }) })
            ] })
          ] }),
          /* @__PURE__ */ R.jsx(Yj, { labelText: "Billing address", address: h }),
          /* @__PURE__ */ R.jsx(
            Yj,
            {
              icon: "map-pin",
              labelText: "Delivery address",
              address: v
            }
          ),
          /* @__PURE__ */ R.jsx(VK, { delivery: e.delivery }),
          /* @__PURE__ */ R.jsx(UK, { lineItems: f, currencyCode: l }),
          /* @__PURE__ */ R.jsx(zK, { fees: e.fees, currencyCode: l }),
          /* @__PURE__ */ R.jsx(
            MK,
            {
              payments: e.payments,
              currencyCode: l
            }
          )
        ] })
      ]
    }
  );
}, qK = ({
  error: e,
  itemCount: n,
  children: r
}) => e ? n === 0 || ba({
  errors: e.graphQLErrors
}) ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", color: "secondary", children: "There are no orders for this contact" }) }) : /* @__PURE__ */ R.jsx(Tn, { error: e }) : /* @__PURE__ */ R.jsx(R.Fragment, { children: r }), HK = ({
  contactId: e
}) => {
  const { useQuery: n } = bn(), [r, i] = ue([]), { track: a } = In(), {
    loading: o,
    error: s,
    data: l
  } = n(V7, {
    skip: !e,
    variables: {
      contactId: e
    }
  });
  return Je(() => {
    if (l?.Voyado) {
      const u = l?.Voyado.Orders_GetAllByContact;
      if (!o && u?.items) {
        i(u.items);
        const { totalCount: p } = u;
        p && a("voyado:orders:received", { count: p });
      }
    }
  }, [l?.Voyado]), e ? /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 300 0", children: [
    /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ R.jsx(O.Heading, { variant: "heading-3", children: "Orders" }),
      r.length > 0 && /* @__PURE__ */ R.jsx(Mn, { size: "small", variant: "success", children: r.length })
    ] }),
    o ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ R.jsx(hn, {}) }) : /* @__PURE__ */ R.jsx(qK, { error: s, itemCount: r.length, children: r.map((u, p) => /* @__PURE__ */ R.jsx(
      BK,
      {
        order: u,
        openByDefault: p === 0
      },
      p
    )) })
  ] }) : null;
}, WK = ({
  conversationContext: e,
  settings: n
}) => {
  const { isLoading: r, contactId: i, hasMultipleContacts: a, error: o } = G7({
    conversationContext: e
  }), s = !e?.customer?.email && !e?.customer?.phone_number, l = !!i, {
    showCustomerAttributes: u,
    showPreferences: p,
    showAudiences: d,
    showConsents: f,
    showLastMessages: h,
    showCustomerTransactions: v,
    showOrders: C
  } = n;
  return s ? /* @__PURE__ */ R.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "widget-no-contact-message",
      children: /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
    }
  ) : a ? /* @__PURE__ */ R.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "multiple-contacts-found-message",
      children: /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", color: "secondary", children: "We found multiple profile IDs that match your email or phone number. To display customer informations, we need a unique profile id. Please make sure that the customers data is normalized." })
    }
  ) : o ? ba({
    errors: o.graphQLErrors
  }) ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", color: "secondary", children: "No profile found" }) }) : /* @__PURE__ */ R.jsx(Tn, { error: o }) : !u && !p && !d && !f && !h && !v ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." }) }) : r ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ R.jsx(hn, {}) }) : /* @__PURE__ */ R.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ R.jsx(fK, { contactId: i, settings: n }),
        h && /* @__PURE__ */ R.jsx(TK, { contactId: i }),
        v && /* @__PURE__ */ R.jsx(jK, { contactId: i }),
        C && /* @__PURE__ */ R.jsx(HK, { contactId: i }),
        !l && /* @__PURE__ */ R.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ R.jsx(O.Paragraph, { variant: "4", color: "secondary", children: "No contact found." }) })
      ]
    }
  );
}, ay = [
  {
    key: "voyadoApiKey",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "apiHostName",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "showCustomerAttributes",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showPreferences",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showAudiences",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showConsents",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showLastMessages",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showCustomerTransactions",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showOrders",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showMemberLevel",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], KK = {
  enabled: !1,
  name: "",
  voyadoApiKey: "",
  apiHostName: "",
  showCustomerAttributes: !0,
  showPreferences: !0,
  showAudiences: !0,
  showConsents: !0,
  showLastMessages: !0,
  showCustomerTransactions: !0,
  showOrders: !0,
  showMemberLevel: !0
}, GK = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = dt({
    mode: "onChange",
    defaultValues: KK
  }), {
    create: l,
    update: u,
    remove: p,
    isLoading: d,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = hr({
    integrationId: e,
    integrationType: "VOYADO",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: C,
    error: j,
    isWidgetUnknown: N,
    refetch: x,
    widgetConfiguration: g
  } = yr({
    integrationId: e,
    fieldDefinitions: ay,
    form: s,
    onMisconfigured: v
  }), { renderConditions: P, setRenderConditions: E, renderConditionsForSubmit: I } = gr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), w = (H) => kr(H, {
    fieldDefinitions: ay,
    isCreationMode: o,
    create: l,
    update: u,
    renderConditions: I
  }), A = s.watch("name");
  return /* @__PURE__ */ R.jsxs(
    vr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: w,
      error: j ?? f,
      onRetry: j ? x : void 0,
      isLoading: d || C,
      isWidgetUnknown: N,
      children: [
        h && /* @__PURE__ */ R.jsx(br, { cause: h }),
        /* @__PURE__ */ R.jsxs(tt, { children: [
          /* @__PURE__ */ R.jsx(ie, { children: /* @__PURE__ */ R.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ R.jsx(
            Sn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(ie, { span: 3, children: /* @__PURE__ */ R.jsx(
            Gn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ R.jsx(ie, { span: 3 }),
          /* @__PURE__ */ R.jsx(ie, { span: 3, children: /* @__PURE__ */ R.jsx(
            mi,
            {
              name: "voyadoApiKey",
              label: "API key",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API key is required" },
              componentProps: {
                placeholder: "API key from Voyado",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ R.jsx(ie, { span: 3 }),
          /* @__PURE__ */ R.jsx(ie, { span: 3, children: /* @__PURE__ */ R.jsx(
            Gn,
            {
              name: "apiHostName",
              label: "API URL",
              control: s.control,
              rules: { required: "API URL is required" },
              componentProps: {
                placeholder: "The URL of the Voyado API",
                autoComplete: "off",
                prefix: "https://"
              }
            }
          ) }),
          /* @__PURE__ */ R.jsx(ie, { span: 3 }),
          /* @__PURE__ */ R.jsx(ie, { span: 3, children: /* @__PURE__ */ R.jsx(We, { label: "Show the customer attributes", children: /* @__PURE__ */ R.jsx(
            Sn,
            {
              name: "showCustomerAttributes",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(ie, { span: 3 }),
          /* @__PURE__ */ R.jsx(ie, { span: 3, children: /* @__PURE__ */ R.jsx(We, { label: "Show preferences", children: /* @__PURE__ */ R.jsx(
            Sn,
            {
              name: "showPreferences",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(ie, { span: 3 }),
          /* @__PURE__ */ R.jsx(ie, { span: 3, children: /* @__PURE__ */ R.jsx(We, { label: "Show audiences", children: /* @__PURE__ */ R.jsx(
            Sn,
            {
              name: "showAudiences",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(ie, { span: 3 }),
          /* @__PURE__ */ R.jsx(ie, { span: 3, children: /* @__PURE__ */ R.jsx(We, { label: "Show consents", children: /* @__PURE__ */ R.jsx(
            Sn,
            {
              name: "showConsents",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(ie, { span: 3 }),
          /* @__PURE__ */ R.jsx(ie, { span: 3, children: /* @__PURE__ */ R.jsx(We, { label: "Show the last 5 messages", children: /* @__PURE__ */ R.jsx(
            Sn,
            {
              name: "showLastMessages",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(ie, { span: 3 }),
          /* @__PURE__ */ R.jsx(ie, { span: 3, children: /* @__PURE__ */ R.jsx(We, { label: "Show customer transactions", children: /* @__PURE__ */ R.jsx(
            Sn,
            {
              name: "showCustomerTransactions",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(ie, { span: 3 }),
          /* @__PURE__ */ R.jsx(ie, { span: 3, children: /* @__PURE__ */ R.jsx(We, { label: "Show orders by contact", children: /* @__PURE__ */ R.jsx(
            Sn,
            {
              name: "showOrders",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(ie, { span: 3 }),
          /* @__PURE__ */ R.jsx(ie, { span: 3, children: /* @__PURE__ */ R.jsx(We, { label: "Show member level", children: /* @__PURE__ */ R.jsx(
            Sn,
            {
              name: "showMemberLevel",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(ie, { span: 3 }),
          a && P !== null && /* @__PURE__ */ R.jsx(ie, { children: a({
            value: P,
            onChange: E,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ R.jsx(
          xr,
          {
            integrationType: "VOYADO",
            integrationId: e,
            widgetName: A,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => p()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._copyIcon_1pfts_54{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_1pfts_59{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_1pfts_69{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_1pfts_69:last-child{box-shadow:none}._listItemHighlighted_1pfts_78{border-left:8px solid var(--dixa-color-orange-300)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._settingsWrapper_1ycvy_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);margin-bottom:var(--dixa-size-spacer-300)}._settingsWrapperHeader_1ycvy_6{cursor:pointer;padding:var(--dixa-size-spacer-300)}._settingsWrapperContent_1ycvy_10{border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);padding:var(--dixa-size-spacer-300);line-height:var(--dixa-typography-line-height-400)}._settingsWrapperContent_1ycvy_10 ol{margin-bottom:0}._settingsWrapperContentCode_1ycvy_18{background-color:var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);font-family:var(--dixa-typography-family-code);font-size:var(--dixa-typography-size-200)}._settingsWrapperContentCURL_1ycvy_26{overflow:auto;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-300);font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-secondary);background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var fh = { exports: {} }, ho = {}, Jj;
function YK() {
  if (Jj) return ho;
  Jj = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ho.Fragment = r, ho.jsx = s, ho.jsxs = s, ho;
}
var Fs = {}, Qj;
function JK() {
  return Qj || (Qj = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), v = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        P("error", t, m);
      }
    }
    function P(t, c, m) {
      {
        var y = x.ReactDebugCurrentFrame, F = y.getStackAddendum();
        F !== "" && (c += "%s", m = m.concat([F]));
        var T = m.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var E = !1, I = !1, w = !1, A = !1, H = !1, Y;
    Y = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ne(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || H || t === a || t === p || t === d || A || t === v || E || I || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function W(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var F = c.displayName || c.name || "";
      return F !== "" ? m + "(" + F + ")" : m;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function D(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var m = t;
            return B(m._context) + ".Provider";
          case u:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : D(t.type) || "Memo";
          case h: {
            var F = t, T = F._payload, S = F._init;
            try {
              return D(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var M = Object.assign, Z = 0, je, ge, ye, ke, q, _e, De;
    function G() {
    }
    G.__reactDisabledLog = !0;
    function Ye() {
      {
        if (Z === 0) {
          je = console.log, ge = console.info, ye = console.warn, ke = console.error, q = console.group, _e = console.groupCollapsed, De = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: G,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function sn() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: M({}, t, {
              value: je
            }),
            info: M({}, t, {
              value: ge
            }),
            warn: M({}, t, {
              value: ye
            }),
            error: M({}, t, {
              value: ke
            }),
            group: M({}, t, {
              value: q
            }),
            groupCollapsed: M({}, t, {
              value: _e
            }),
            groupEnd: M({}, t, {
              value: De
            })
          });
        }
        Z < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = x.ReactCurrentDispatcher, Ue;
    function Pe(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (F) {
            var y = F.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Le;
    {
      var Xe = typeof WeakMap == "function" ? WeakMap : Map;
      Le = new Xe();
    }
    function Fe(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Le.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      Be = !0;
      var F = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ye();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (re) {
              y = re;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (re) {
              y = re;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            y = re;
          }
          t();
        }
      } catch (re) {
        if (re && y && typeof re.stack == "string") {
          for (var _ = re.stack.split(`
`), ee = y.stack.split(`
`), L = _.length - 1, U = ee.length - 1; L >= 1 && U >= 0 && _[L] !== ee[U]; )
            U--;
          for (; L >= 1 && U >= 0; L--, U--)
            if (_[L] !== ee[U]) {
              if (L !== 1 || U !== 1)
                do
                  if (L--, U--, U < 0 || _[L] !== ee[U]) {
                    var ce = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && ce.includes("<anonymous>") && (ce = ce.replace("<anonymous>", t.displayName)), typeof t == "function" && Le.set(t, ce), ce;
                  }
                while (L >= 1 && U >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = F;
      }
      var ze = t ? t.displayName || t.name : "", Oe = ze ? Pe(ze) : "";
      return typeof t == "function" && Le.set(t, Oe), Oe;
    }
    function Me(t, c, m) {
      return Fe(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Fe(t, nn(t));
      if (typeof t == "string")
        return Pe(t);
      switch (t) {
        case p:
          return Pe("Suspense");
        case d:
          return Pe("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return Me(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, F = y._payload, T = y._init;
            try {
              return se(T(F), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Se = {}, Ae = x.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(m);
      } else
        Ae.setExtraStackFrame(null);
    }
    function yn(t, c, m, y, F) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ee = Error((y || "React class") + ": " + m + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              _ = t[S](c, S, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Re(F), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, S, typeof _), Re(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Re(F), g("Failed %s type: %s", m, _.message), Re(null));
          }
      }
    }
    var Q = Array.isArray;
    function $(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ae(t);
    }
    var J = x.ReactCurrentOwner, de = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, xe, $e;
    function tn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function gn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && J.current;
    }
    function pn(t, c) {
      {
        var m = function() {
          xe || (xe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function Fn(t, c) {
      {
        var m = function() {
          $e || ($e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var xn = function(t, c, m, y, F, T, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: F
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, m, y, F) {
      {
        var T, S = {}, _ = null, ee = null;
        m !== void 0 && (V(m), _ = "" + m), gn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ee = c.ref, on(c));
        for (T in c)
          le.call(c, T) && !de.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (T in L)
            S[T] === void 0 && (S[T] = L[T]);
        }
        if (_ || ee) {
          var U = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, U), ee && Fn(S, U);
        }
        return xn(t, _, ee, F, y, J.current, S);
      }
    }
    var en = x.ReactCurrentOwner, vn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        vn.setExtraStackFrame(m);
      } else
        vn.setExtraStackFrame(null);
    }
    var un;
    un = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = D(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Nn = {};
    function Rn(t) {
      {
        var c = jn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function kn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Rn(c);
        if (Nn[m])
          return;
        Nn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + D(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Ve(null);
      }
    }
    function _n(t, c) {
      {
        if (typeof t != "object")
          return;
        if ($(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            dn(y) && kn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var F = N(t);
          if (typeof F == "function" && F !== t.entries)
            for (var T = F.call(t), S; !(S = T.next()).done; )
              dn(S.value) && kn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = D(c);
          yn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !un) {
          un = !0;
          var F = D(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", F || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, m, y, F, T) {
      {
        var S = ne(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = Bn();
          ee ? _ += ee : _ += jn();
          var L;
          t === null ? L = "null" : $(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (D(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var U = En(t, c, m, F, T);
        if (U == null)
          return U;
        if (S) {
          var ce = c.children;
          if (ce !== void 0)
            if (y)
              if ($(ce)) {
                for (var ze = 0; ze < ce.length; ze++)
                  _n(ce[ze], t);
                Object.freeze && Object.freeze(ce);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _n(ce, t);
        }
        if (le.call(c, "key")) {
          var Oe = D(t), re = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), mn = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Oe + mn]) {
            var Dn = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Oe, Dn, Oe), Cn[Oe + mn] = !0;
          }
        }
        return t === i ? Ln(U) : An(U), U;
      }
    }
    function Vn(t, c, m) {
      return wn(t, c, m, !0);
    }
    function qn(t, c, m) {
      return wn(t, c, m, !1);
    }
    var zn = qn, Wn = Vn;
    Fs.Fragment = i, Fs.jsx = zn, Fs.jsxs = Wn;
  })()), Fs;
}
var Xj;
function QK() {
  return Xj || (Xj = 1, process.env.NODE_ENV === "production" ? fh.exports = YK() : fh.exports = JK()), fh.exports;
}
var Ne = QK();
const XK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phone" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "externalIds" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "storeId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "expand" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Yotpo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "phone_number" }, value: { kind: "Variable", name: { kind: "Name", value: "phone" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "external_ids" }, value: { kind: "Variable", name: { kind: "Name", value: "externalIds" } } }, { kind: "Argument", name: { kind: "Name", value: "store_id" }, value: { kind: "Variable", name: { kind: "Name", value: "storeId" } } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "Variable", name: { kind: "Name", value: "expand" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone_number" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "gender" } }, { kind: "Field", name: { kind: "Name", value: "account_created_at" } }, { kind: "Field", name: { kind: "Name", value: "account_updated_at" } }, { kind: "Field", name: { kind: "Name", value: "default_language" } }, { kind: "Field", name: { kind: "Name", value: "dafault_currency" } }, { kind: "Field", name: { kind: "Name", value: "lists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "since" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_ugc" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "total_reviews" } }, { kind: "Field", name: { kind: "Name", value: "avg_product_rating" } }, { kind: "Field", name: { kind: "Name", value: "avg_site_rating" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_rating" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_product" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_site" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_sentiment" } }, { kind: "Field", name: { kind: "Name", value: "top_topics" } }, { kind: "Field", name: { kind: "Name", value: "last_star_rating" } }, { kind: "Field", name: { kind: "Name", value: "last_review_date" } }, { kind: "Field", name: { kind: "Name", value: "last_sentiment" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_loyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "points_earned" } }, { kind: "Field", name: { kind: "Name", value: "points_balance" } }, { kind: "Field", name: { kind: "Name", value: "last_seen_at" } }, { kind: "Field", name: { kind: "Name", value: "total_redemptions" } }, { kind: "Field", name: { kind: "Name", value: "total_points_redeemed" } }, { kind: "Field", name: { kind: "Name", value: "vip_tier_name" } }, { kind: "Field", name: { kind: "Name", value: "successful_referrals" } }, { kind: "Field", name: { kind: "Name", value: "referrals_made_and_clicked" } }, { kind: "Field", name: { kind: "Name", value: "is_referred_by_other_customer" } }, { kind: "Field", name: { kind: "Name", value: "points_expire_date" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_amount" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_customer_currency" } }, { kind: "Field", name: { kind: "Name", value: "is_opt_in" } }, { kind: "Field", name: { kind: "Name", value: "opt_in_date" } }, { kind: "Field", name: { kind: "Name", value: "opt_out_date" } }, { kind: "Field", name: { kind: "Name", value: "has_store_account" } }, { kind: "Field", name: { kind: "Name", value: "referred_by_customer" } }, { kind: "Field", name: { kind: "Name", value: "vip_entry_date" } }, { kind: "Field", name: { kind: "Name", value: "vip_expiration_date" } }, { kind: "Field", name: { kind: "Name", value: "next_points_expire_on" } }, { kind: "Field", name: { kind: "Name", value: "next_points_expire_amount" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "active_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "paused_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "failed_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "expired_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, ZK = {
  "\n  query getCustomerDetails(\n    $email: String\n    $phone: String\n    $limit: Int\n    $externalIds: String\n    $storeId: String!\n    $expand: String\n  ) {\n    Yotpo {\n      getCustomers(\n        email: $email\n        phone_number: $phone\n        limit: $limit\n        external_ids: $externalIds\n        store_id: $storeId\n        expand: $expand\n      ) {\n        ... on Yotpo_getCustomers_response {\n          ... on Yotpo_Customers {\n            customers {\n              external_id\n              email\n              phone_number\n              first_name\n              last_name\n              gender\n              account_created_at\n              account_updated_at\n              default_language\n              dafault_currency\n              lists {\n                id\n                since\n              }\n              yotpo_ugc {\n                total_reviews\n                avg_product_rating\n                avg_site_rating\n                total_avg_rating\n                sentiment_avg_product\n                sentiment_avg_site\n                total_avg_sentiment\n                top_topics\n                last_star_rating\n                last_review_date\n                last_sentiment\n              }\n              yotpo_loyalty {\n                points_earned\n                points_balance\n                last_seen_at\n                total_redemptions\n                total_points_redeemed\n                vip_tier_name\n                successful_referrals\n                referrals_made_and_clicked\n                is_referred_by_other_customer\n                points_expire_date\n                credit_balance_amount\n                credit_balance_customer_currency\n                is_opt_in\n                opt_in_date\n                opt_out_date\n                has_store_account\n                referred_by_customer\n                vip_entry_date\n                vip_expiration_date\n                next_points_expire_on\n                next_points_expire_amount\n              }\n              yotpo_subscriptions {\n                active_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                paused_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                failed_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                expired_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                canceled_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": XK
};
function eG(e) {
  return ZK[e] ?? {};
}
const nG = eG(
  /* GraphQL */
  `
  query getCustomerDetails(
    $email: String
    $phone: String
    $limit: Int
    $externalIds: String
    $storeId: String!
    $expand: String
  ) {
    Yotpo {
      getCustomers(
        email: $email
        phone_number: $phone
        limit: $limit
        external_ids: $externalIds
        store_id: $storeId
        expand: $expand
      ) {
        ... on Yotpo_getCustomers_response {
          ... on Yotpo_Customers {
            customers {
              external_id
              email
              phone_number
              first_name
              last_name
              gender
              account_created_at
              account_updated_at
              default_language
              dafault_currency
              lists {
                id
                since
              }
              yotpo_ugc {
                total_reviews
                avg_product_rating
                avg_site_rating
                total_avg_rating
                sentiment_avg_product
                sentiment_avg_site
                total_avg_sentiment
                top_topics
                last_star_rating
                last_review_date
                last_sentiment
              }
              yotpo_loyalty {
                points_earned
                points_balance
                last_seen_at
                total_redemptions
                total_points_redeemed
                vip_tier_name
                successful_referrals
                referrals_made_and_clicked
                is_referred_by_other_customer
                points_expire_date
                credit_balance_amount
                credit_balance_customer_currency
                is_opt_in
                opt_in_date
                opt_out_date
                has_store_account
                referred_by_customer
                vip_entry_date
                vip_expiration_date
                next_points_expire_on
                next_points_expire_amount
              }
              yotpo_subscriptions {
                active_subscriptions {
                  externalProductId
                  externalVariantId
                }
                paused_subscriptions {
                  externalProductId
                  externalVariantId
                }
                failed_subscriptions {
                  externalProductId
                  externalVariantId
                }
                expired_subscriptions {
                  externalProductId
                  externalVariantId
                }
                canceled_subscriptions {
                  externalProductId
                  externalVariantId
                }
              }
            }
          }
        }
      }
    }
  }
`
), tG = "_copyIcon_1pfts_54", rG = "_list_1pfts_59", iG = "_listItem_1pfts_69", aG = "_listItemHighlighted_1pfts_78", ka = {
  copyIcon: tG,
  list: rG,
  listItem: iG,
  listItemHighlighted: aG
}, oG = "_wrapper_1xucg_1", sG = "_externalLink_1xucg_7", hh = {
  wrapper: oG,
  externalLink: sG
}, lG = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = Jt(), { isCopied: i, copy: a } = Jt();
  if (!e)
    return null;
  const {
    first_name: o,
    last_name: s,
    email: l,
    phone_number: u,
    account_created_at: p
  } = e, d = 14, f = `${o || ""} ${s || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ Ne.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Ne.jsxs(b, { className: hh.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ne.jsx(
      b,
      {
        justifyContent: "space-between",
        className: hh.block,
        alignItems: "center",
        children: /* @__PURE__ */ Ne.jsx(O.Heading, { variant: "heading-2", children: f })
      }
    ),
    p && /* @__PURE__ */ Ne.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ Ne.jsx(O.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ Ne.jsx(O.Paragraph, { variant: "4", children: Jn(p).format(jt) })
    ] }),
    l && /* @__PURE__ */ Ne.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ne.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ne.jsx(he, { size: d, name: "mail" }),
        /* @__PURE__ */ Ne.jsx("span", { className: hh.externalLink, children: l })
      ] }),
      /* @__PURE__ */ Ne.jsx(Ze, { content: "Copy email", children: /* @__PURE__ */ Ne.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Ne.jsx(
        he,
        {
          size: d,
          name: n ? "done" : "copy",
          onClick: () => r(l),
          className: ka.copyIcon
        }
      ) }) })
    ] }),
    u && /* @__PURE__ */ Ne.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ne.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ne.jsx(he, { size: d, name: "phone" }),
        /* @__PURE__ */ Ne.jsx(O.Paragraph, { variant: "4", children: u })
      ] }),
      /* @__PURE__ */ Ne.jsx(Ze, { content: "Copy phone number", children: /* @__PURE__ */ Ne.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Ne.jsx(
        he,
        {
          size: d,
          name: i ? "done" : "copy",
          onClick: () => a(u),
          className: ka.copyIcon
        }
      ) }) })
    ] })
  ] }) });
}, Zn = ({
  description: e,
  content: n,
  tooltip: r,
  isHighlighted: i = !1
}) => {
  if (n == null)
    return null;
  const a = uw(n);
  return /* @__PURE__ */ Ne.jsx(
    Qe.Text,
    {
      variant: "dense",
      className: ut(ka.listItem, {
        [ka.listItemHighlighted]: i
      }),
      children: /* @__PURE__ */ Ne.jsx(Ze, { content: r, children: /* @__PURE__ */ Ne.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ Ne.jsx(O.Paragraph, { variant: "4", children: e }),
        a ? n : Pi(n)
      ] }) })
    }
  );
}, cG = ({
  loyalty: e
}) => /* @__PURE__ */ Ne.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ Ne.jsx(O.Heading, { variant: "heading-3", children: "Loyalty" }),
  !e && /* @__PURE__ */ Ne.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Ne.jsx(O.Paragraph, { variant: "4", color: "secondary", children: "No loyalty data available" }) }),
  e && /* @__PURE__ */ Ne.jsxs(Qe, { className: ka.list, children: [
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        isHighlighted: !0,
        description: "Successful referrals",
        tooltip: "The total number of successful referrals made by the customer.",
        content: e.successful_referrals
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        isHighlighted: !0,
        description: "Referrals made and clicked",
        tooltip: "The total number of referrals made by the customer and clicked on by others.",
        content: e.referrals_made_and_clicked
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Points earned",
        tooltip: "The total number of loyalty points earned by the customer.",
        content: e.points_earned
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Points balance",
        tooltip: "The current balance of loyalty points for the customer.",
        content: e.points_balance
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Last seen",
        tooltip: "The timestamp when the customer was last seen or engaged with the loyalty program.",
        content: e.last_seen_at
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Total redemptions",
        tooltip: "The total number of times the customer has redeemed loyalty points.",
        content: e.total_redemptions
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Total points redeemed",
        tooltip: "The total number of loyalty points redeemed by the customer.",
        content: e.total_points_redeemed
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "VIP tier",
        tooltip: "The name of the customer's current VIP tier status.",
        content: e.vip_tier_name
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Referred by other customer",
        tooltip: "Indicates whether the customer was referred by another customer.",
        content: e.is_referred_by_other_customer
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Points expiry date",
        tooltip: "The timestamp when the customer's loyalty points are set to expire.",
        content: e.next_points_expire_on || e.points_expire_date
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Points expiry amount",
        tooltip: "The number of points that are about to expire",
        content: e.next_points_expire_amount
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Credit balance amount",
        tooltip: "The amount of store credit available to the customer in the default currency of the store.",
        content: e.credit_balance_amount
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Credit balance customer currency",
        tooltip: "The store credit amount in the customer's preferred currency.",
        content: e.credit_balance_customer_currency
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Opt in",
        tooltip: "Indicates whether the customer has opted into the loyalty program.",
        content: e.is_opt_in
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Opt in date",
        tooltip: "The timestamp for when the customer opted into the loyalty program.",
        content: e.opt_in_date
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Opt out date",
        tooltip: "The timestamp for when the customer opted out of the loyalty program.",
        content: e.opt_out_date
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Has store account",
        tooltip: "Indicates whether the customer has a store account.",
        content: e.has_store_account
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Referred by customer",
        tooltip: "The email address of the customer who referred this customer to the loyalty program.",
        content: e.referred_by_customer
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "VIP entry date",
        tooltip: "The timestamp for when the customer entered the VIP tier.",
        content: e.vip_entry_date
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "VIP expiration date",
        tooltip: "The timestamp for when the customer's VIP tier membership is set to expire.",
        content: e.vip_expiration_date
      }
    )
  ] })
] }), uG = 0.8, dG = 0.4, Zj = (e) => {
  if (e != null)
    return e >= uG ? /* @__PURE__ */ Ne.jsx(Mn, { variant: "success", size: "small", children: "Positive" }) : e <= dG ? /* @__PURE__ */ Ne.jsx(Mn, { variant: "error", size: "small", children: "Negative" }) : /* @__PURE__ */ Ne.jsx(Mn, { variant: "warning", size: "small", children: "Neutral" });
}, mG = ({
  userGeneratedContent: e
}) => /* @__PURE__ */ Ne.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ Ne.jsx(O.Heading, { variant: "heading-3", children: "User generated content" }),
  !e && /* @__PURE__ */ Ne.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Ne.jsx(O.Paragraph, { variant: "4", color: "secondary", children: "No user generated content available" }) }),
  e && /* @__PURE__ */ Ne.jsxs(Qe, { className: ka.list, children: [
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        isHighlighted: !0,
        description: "Total reviews",
        tooltip: "The total number of reviews submitted by the customer.",
        content: e.total_reviews
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        isHighlighted: !0,
        description: "Total average rating",
        tooltip: "The total average rating given by the customer (combining products and site/store ratings).",
        content: e.total_avg_rating?.toFixed(2)
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        isHighlighted: !0,
        description: "Total average sentiment score",
        tooltip: "The total average sentiment score given by the customer (combining products and site/store scores).",
        content: Zj(e.total_avg_sentiment)
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Average product rating",
        tooltip: "The average product rating given by the customer.",
        content: e.avg_product_rating
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Average site rating",
        tooltip: "The average rating of the site/store given by the customer.",
        content: e.avg_site_rating?.toFixed(2)
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Last sentiment",
        tooltip: "The sentiment score of the customer's last review.",
        content: Zj(e.last_sentiment)
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Last star rating",
        tooltip: "The star rating of the customer's last review.",
        content: e.last_star_rating
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Last review date",
        tooltip: "The timestamp for when the customer last submitted a review.",
        content: Jn(e.last_review_date).format(
          jt
        )
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Topics",
        tooltip: "An list of top topics (themes) mentioned in all of the customer's reviews.",
        content: /* @__PURE__ */ Ne.jsx(
          b,
          {
            gap: "100",
            width: "80%",
            flexWrap: "wrap",
            justifyContent: "flex-end",
            children: e.top_topics?.map((n, r) => /* @__PURE__ */ Ne.jsx(Mn, { variant: "info", size: "small", children: /* @__PURE__ */ Ne.jsx(Ne.Fragment, { children: n }) }, r))
          }
        )
      }
    )
  ] })
] }), pG = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = bn(), { track: i } = In(), [a, o] = ue(), [s, l] = ue(!1), u = e?.customer?.email, p = e?.customer?.phone_number, d = !u && !p, f = n?.yotpoStoreId, h = n?.showCustomerDetails ?? !1, v = n?.showUserGeneratedContent ?? !1, C = n?.displayLoyalty ?? !1, j = n?.displaySubscriptions ?? !1, N = !f, x = !h && !v && !C && !j, {
    loading: g,
    error: P,
    data: E
  } = r(nG, {
    skip: d || N,
    variables: {
      ...u && { email: u },
      ...!u && p && { phone: p },
      storeId: f,
      expand: "all"
    }
  });
  if (Je(() => {
    const I = E?.Yotpo?.getCustomers?.customers?.[0];
    I ? (o(I), l(!1), i("yotpo:customer:received")) : l(!0);
  }, [E?.Yotpo, g]), N)
    return /* @__PURE__ */ Ne.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Ne.jsx(
      Tn,
      {
        error: new yw({
          graphQLErrors: [
            {
              message: "Integration needs to be re-/authorized in the settings."
            }
          ]
        }),
        hideCopyButton: !0
      }
    ) });
  if (d)
    return /* @__PURE__ */ Ne.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-contact-message",
        children: /* @__PURE__ */ Ne.jsx(O.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
      }
    );
  if (x)
    return /* @__PURE__ */ Ne.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-features",
        children: /* @__PURE__ */ Ne.jsx(O.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." })
      }
    );
  if (g)
    return /* @__PURE__ */ Ne.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Ne.jsx(hn, {}) });
  if (s)
    return /* @__PURE__ */ Ne.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Ne.jsx(O.Paragraph, { variant: "4", color: "secondary", children: "No customer profile found." }) });
  if (P) {
    const I = P.graphQLErrors;
    return gl({ errors: I }) ? /* @__PURE__ */ Ne.jsx(
      O.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : vl({ errors: I }) ? /* @__PURE__ */ Ne.jsx(
      O.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Yotpo. Please contact your administrator."
      }
    ) : /* @__PURE__ */ Ne.jsx(Tn, { error: P });
  }
  return /* @__PURE__ */ Ne.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ Ne.jsx(lG, { customerDetails: a }),
        v && /* @__PURE__ */ Ne.jsx(
          mG,
          {
            userGeneratedContent: a?.yotpo_ugc
          }
        ),
        C && /* @__PURE__ */ Ne.jsx(cG, { loyalty: a?.yotpo_loyalty })
      ]
    }
  );
}, fG = "_settingsWrapper_1ycvy_1", hG = "_settingsWrapperHeader_1ycvy_6", yG = "_settingsWrapperContent_1ycvy_10", gG = "_settingsWrapperContentCode_1ycvy_18", vG = "_settingsWrapperContentCURL_1ycvy_26", yo = {
  settingsWrapper: fG,
  settingsWrapperHeader: hG,
  settingsWrapperContent: yG,
  settingsWrapperContentCode: gG,
  settingsWrapperContentCURL: vG
}, CI = ({
  handleChangeText: e
}) => {
  const [n, r] = ue(!1), { isCopied: i, copy: a } = Jt(), { control: o } = dt({
    defaultValues: {
      storeId: "",
      secret: ""
    },
    mode: "onChange"
  }), s = ca({
    control: o
  }), l = s.storeId !== "" && s.secret !== "", u = ft(() => {
    const p = s.storeId, d = s.secret;
    return `curl --request POST \\
  --url https://api.yotpo.com/core/v3/stores/${p || "store_id"}/access_tokens \\
  --header 'Content-Type: application/json' \\
  --header 'accept: application/json'${d ? ` \\
  --data '{"secret":"${d}"}'` : ""}`;
  }, [s.storeId, s.secret]);
  return /* @__PURE__ */ Ne.jsx(Ne.Fragment, { children: /* @__PURE__ */ Ne.jsx(ie, { span: 6, children: /* @__PURE__ */ Ne.jsxs(b, { flexDirection: "column", className: yo.settingsWrapper, children: [
    /* @__PURE__ */ Ne.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: yo.settingsWrapperHeader,
        onClick: () => r(!n),
        children: [
          /* @__PURE__ */ Ne.jsx(O.Heading, { variant: "heading-3", children: "How to get the Yotpo access token" }),
          /* @__PURE__ */ Ne.jsx(he, { name: n ? "angle-down" : "angle-right" })
        ]
      }
    ),
    n && /* @__PURE__ */ Ne.jsxs(
      b,
      {
        flexDirection: "column",
        className: yo.settingsWrapperContent,
        children: [
          /* @__PURE__ */ Ne.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ Ne.jsx(
            bl,
            {
              variant: "announcement",
              headline: "In order to get the Yotpo access token, you have to follow the steps below",
              description: /* @__PURE__ */ Ne.jsxs("ol", { children: [
                /* @__PURE__ */ Ne.jsx("li", { children: "Insert the Yotpo store ID and secret below in the input fields" }),
                /* @__PURE__ */ Ne.jsx("li", { children: "Once the fields are filled in, the CURL command will appear below and you can copy and run it in your terminal" }),
                /* @__PURE__ */ Ne.jsxs("li", { children: [
                  "The response should look like this",
                  " ",
                  /* @__PURE__ */ Ne.jsx("span", { className: yo.settingsWrapperContentCode, children: '{ "access_token": "this-is-your-token" }' })
                ] }),
                /* @__PURE__ */ Ne.jsxs("li", { children: [
                  "Copy the token without quotes and paste it in the",
                  " ",
                  /* @__PURE__ */ Ne.jsx("i", { children: "Yotpo access token" }),
                  " input field below"
                ] }),
                /* @__PURE__ */ Ne.jsx("li", { children: "Click the save button" })
              ] })
            }
          ) }),
          /* @__PURE__ */ Ne.jsx(
            xt,
            {
              name: "storeId",
              control: o,
              render: ({ field: p }) => /* @__PURE__ */ Ne.jsx(
                tr,
                {
                  label: "Yotpo store ID",
                  placeholder: "Please insert the store ID",
                  input: {
                    ...p,
                    onChange: (d) => {
                      p.onChange(d), e({
                        target: {
                          name: "yotpoStoreId",
                          value: d?.target.value ?? ""
                        }
                      });
                    }
                  }
                }
              )
            }
          ),
          /* @__PURE__ */ Ne.jsx(
            xt,
            {
              name: "secret",
              control: o,
              render: ({ field: p }) => /* @__PURE__ */ Ne.jsx(
                tr,
                {
                  label: "Yotpo secret",
                  placeholder: "Please insert the secret",
                  input: p
                }
              )
            }
          ),
          l && /* @__PURE__ */ Ne.jsxs(Ne.Fragment, { children: [
            /* @__PURE__ */ Ne.jsx(We, { label: "Generated CURL command", noAlert: !0, children: /* @__PURE__ */ Ne.jsx(
              b,
              {
                as: "pre",
                gap: "200",
                margin: "100 0 250",
                className: yo.settingsWrapperContentCURL,
                children: u()
              }
            ) }),
            /* @__PURE__ */ Ne.jsx(b, { alignContent: "start", children: /* @__PURE__ */ Ne.jsx(
              Ze,
              {
                content: i ? "Copied!" : "Copy CURL command",
                children: /* @__PURE__ */ Ne.jsx(
                  et,
                  {
                    variant: "secondary",
                    icon: i ? "check-circle" : "copy",
                    onClick: () => a(u()),
                    children: "Copy CURL"
                  }
                )
              }
            ) })
          ] })
        ]
      }
    )
  ] }) }) });
}, yl = [
  // The store id is populated by the OAuth flow, not edited in the form. It is
  // kept here so the runtime widget render can resolve it and so it round-trips
  // on update.
  {
    key: "yotpoStoreId",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  // Secret, only written when editing a legacy token-authenticated widget.
  // Excluded from the read path; omitted from the update payload unless the
  // user re-enters it (preserving the stored value).
  {
    key: "yotpoAccessToken",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "showCustomerDetails",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showUserGeneratedContent",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayLoyalty",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], kG = [
  /**
   * The store ID will be fetched through the OAuth flow, so there's no real
   * reason to show it
   */
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: "",
    readOnly: !0,
    required: !1,
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: pi
  }
], bG = [
  {
    key: "accessTokenComponent",
    label: "Retrieve Yotpo access token",
    secret: !1,
    type: "custom",
    component: CI
  },
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: 'See "How to get the Yotpo access token" above.',
    readOnly: !0,
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "yotpoAccessToken",
    label: "Yotpo access token",
    placeholder: "Insert the Yotpo access token",
    required: !0,
    secret: !0,
    type: "input"
  }
], yh = "YOTPO", xG = {
  enabled: !1,
  name: "",
  ...sy(
    [],
    yl
  )
}, _G = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = dt({
    mode: "onChange",
    defaultValues: xG
  }), {
    create: u,
    update: p,
    remove: d,
    isLoading: f,
    error: h,
    misconfigurationCause: v,
    setMisconfigurationCause: C
  } = hr({
    integrationId: e,
    integrationType: yh,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: j,
    error: N,
    isWidgetUnknown: x,
    refetch: g,
    widgetConfiguration: P
  } = yr({
    integrationId: e,
    fieldDefinitions: yl,
    form: l,
    onMisconfigured: C
  }), { renderConditions: E, setRenderConditions: I, renderConditionsForSubmit: w } = gr({
    integrationId: e,
    widgetConfiguration: P,
    renderConditionsEditor: o
  }), A = s || !!P?.additionalProperties?.isUsingOAuth, H = (ne) => kr(ne, {
    fieldDefinitions: yl,
    isCreationMode: s,
    create: u,
    update: p,
    renderConditions: w
  }), Y = l.watch("name");
  return /* @__PURE__ */ Ne.jsxs(
    vr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: H,
      error: N ?? h,
      onRetry: N ? g : void 0,
      isLoading: f || j,
      isWidgetUnknown: x,
      children: [
        v && /* @__PURE__ */ Ne.jsx(br, { cause: v }),
        /* @__PURE__ */ Ne.jsxs(tt, { children: [
          /* @__PURE__ */ Ne.jsx(ie, { children: /* @__PURE__ */ Ne.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Ne.jsx(
            Sn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ Ne.jsx(ie, { span: 3, children: /* @__PURE__ */ Ne.jsx(
            Gn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Ne.jsx(ie, { span: 3 }),
          !A && /* @__PURE__ */ Ne.jsxs(Ne.Fragment, { children: [
            /* @__PURE__ */ Ne.jsx(
              CI,
              {
                handleChangeText: (ne) => l.setValue("yotpoStoreId", ne?.target.value ?? "")
              }
            ),
            /* @__PURE__ */ Ne.jsx(ie, { span: 3, children: /* @__PURE__ */ Ne.jsx(
              Gn,
              {
                name: "yotpoStoreId",
                label: "Yotpo store ID",
                control: l.control,
                rules: { required: "Yotpo store ID is required" },
                componentProps: {
                  placeholder: 'See "How to get the Yotpo access token" above.',
                  readOnly: !0,
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ Ne.jsx(ie, { span: 3 }),
            /* @__PURE__ */ Ne.jsx(ie, { span: 3, children: /* @__PURE__ */ Ne.jsx(
              mi,
              {
                name: "yotpoAccessToken",
                label: "Yotpo access token",
                control: l.control,
                isCreationMode: s,
                rules: { required: "Yotpo access token is required" },
                componentProps: {
                  placeholder: "Insert the Yotpo access token",
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ Ne.jsx(ie, { span: 3 })
          ] }),
          /* @__PURE__ */ Ne.jsx(ie, { span: 3, children: /* @__PURE__ */ Ne.jsx(We, { label: "Show customer details", children: /* @__PURE__ */ Ne.jsx(
            Sn,
            {
              name: "showCustomerDetails",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ Ne.jsx(ie, { span: 3 }),
          /* @__PURE__ */ Ne.jsx(ie, { span: 3, children: /* @__PURE__ */ Ne.jsx(We, { label: "Show user generated content", children: /* @__PURE__ */ Ne.jsx(
            Sn,
            {
              name: "showUserGeneratedContent",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ Ne.jsx(ie, { span: 3 }),
          /* @__PURE__ */ Ne.jsx(ie, { span: 3, children: /* @__PURE__ */ Ne.jsx(We, { label: "Show loyalty data", children: /* @__PURE__ */ Ne.jsx(
            Sn,
            {
              name: "displayLoyalty",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ Ne.jsx(ie, { span: 3 }),
          A && !s && e && /* @__PURE__ */ Ne.jsx(
            pi,
            {
              configuration: n,
              integrationId: e,
              integrationType: yh,
              label: "Authorize with OAuth"
            }
          ),
          o && E !== null && /* @__PURE__ */ Ne.jsx(ie, { children: o({
            value: E,
            onChange: I,
            configurationKey: P?.id
          }) })
        ] }),
        /* @__PURE__ */ Ne.jsx(
          xr,
          {
            integrationType: yh,
            integrationId: e,
            widgetName: Y,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => d()
          }
        )
      ]
    }
  );
}, SG = (e) => {
  switch (e) {
    case "input":
    case "hidden":
      return "";
    case "switch":
      return !1;
    default:
      return;
  }
}, NG = (e, n) => {
  switch (n) {
    case "input":
    case "hidden":
    case "select":
      return e;
    case "switch":
      return e === "true" ? !0 : e === "false" ? !1 : void 0;
    default:
      return;
  }
}, jG = ({
  hasShopifyOAuth: e = !1,
  isShopifyMarketplaceApp: n = !1,
  isCreationMode: r = !1
}) => r ? {
  authSettings: lW,
  featureSettings: []
} : n ? {
  authSettings: cW,
  featureSettings: [...gI]
} : e ? {
  authSettings: [
    ...wj,
    ...oW
  ],
  featureSettings: [...Cj]
} : {
  authSettings: [
    ...wj,
    ...sW
  ],
  featureSettings: [...Cj]
}, II = (e, n) => ({
  hasOAuth: r = !1,
  isCreationMode: i = !1
}) => r || i ? e : n, wG = II(
  kG,
  bG
), CG = II(
  sV,
  lV
), FI = ({
  key: e,
  configuration: n,
  settingType: r,
  settingDefault: i
}) => {
  const a = n?.find(
    (l) => l.key === e
  ), o = NG(a?.value, r), s = i !== void 0 ? i : SG(
    r
  );
  return o !== void 0 ? o : s;
}, zg = (e = {
  SHOPIFY: {},
  YOTPO: {},
  KLAVIYO: {}
}) => {
  const { SHOPIFY: n, YOTPO: r, KLAVIYO: i } = e, {
    authSettings: a,
    featureSettings: o
  } = jG(n), s = wG(r), l = CG(i);
  return {
    SHOPIFY: {
      widget: h7,
      icon: "shopify",
      iconColors: {
        contentColor: "rgb(148, 190, 69)",
        backgroundColor: "rgba(148, 190, 69, 0.1)"
      },
      settingsConfiguration: [
        ...a,
        ...o
      ]
    },
    JIRA: {
      widget: F2,
      icon: "jira",
      iconColors: {
        contentColor: "rgb(38, 132, 255)",
        backgroundColor: "rgba(38, 132, 255, 0.075)"
      },
      fieldDefinitions: Eh,
      WidgetSettings: T2
    },
    GITHUB: {
      widget: $R,
      icon: "github",
      iconColors: {
        contentColor: "rgb(87, 96, 106)",
        backgroundColor: "rgba(221, 244, 255, 0.75)"
      },
      fieldDefinitions: Ch,
      WidgetSettings: OR
    },
    MIUROS: {
      widget: yB,
      icon: "miuros",
      iconColors: {
        contentColor: "rgb(246, 135, 179)",
        backgroundColor: "rgba(246, 135, 179, 0.15)"
      },
      fieldDefinitions: Yh,
      WidgetSettings: vB
    },
    KLAVIYO: {
      widget: nV,
      icon: "klaviyo",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: ol,
      WidgetSettings: uV,
      // Kept for backwards compatibility with the older declarative
      // configuration types. The active settings UI is `WidgetSettings`.
      settingsConfiguration: [...l]
    },
    LINEAR: {
      widget: PM,
      icon: "linear",
      iconColors: {
        contentColor: "rgb(94, 106, 210)",
        backgroundColor: "rgba(94, 106, 210, 0.15)"
      },
      fieldDefinitions: Hh,
      WidgetSettings: AM
    },
    VOYADO: {
      widget: WK,
      icon: "voyado",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: ay,
      WidgetSettings: GK
    },
    LOYALTYLION: {
      widget: f5,
      icon: "loyaltylion",
      iconColors: {
        contentColor: "rgb(36, 31, 79)",
        backgroundColor: "rgba(36, 31, 79, 0.075)"
      },
      fieldDefinitions: Wh,
      WidgetSettings: y5
    },
    RECHARGE: {
      widget: BB,
      icon: "recharge",
      iconColors: {
        contentColor: "rgb(57, 1, 241)",
        backgroundColor: "rgba(57, 1, 241, 0.075)"
      },
      fieldDefinitions: Xh,
      WidgetSettings: HB
    },
    BRAZE: {
      widget: iP,
      icon: "braze",
      iconColors: {
        contentColor: "rgb(48, 2, 102)",
        backgroundColor: "rgba(48, 2, 102, 0.075)"
      },
      fieldDefinitions: rl,
      WidgetSettings: oP
    },
    YOTPO: {
      widget: pG,
      icon: "yotpo",
      iconColors: {
        contentColor: "rgb(0, 66, 228)",
        backgroundColor: "rgba(0, 66, 228, 0.075)"
      },
      fieldDefinitions: yl,
      WidgetSettings: _G,
      // Kept for backwards compatibility with the older declarative
      // configuration types. The active settings UI is `WidgetSettings`.
      settingsConfiguration: [...s]
    },
    INGRID: {
      widget: oA,
      icon: "ingrid",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: Ih,
      WidgetSettings: lA
    },
    RIVOLOYALTY: {
      widget: Fq,
      icon: "rivoloyalty",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: ey,
      WidgetSettings: GH
    }
  };
}, IG = (e, n) => {
  const r = n.find(
    (i) => i.key === e.key
  )?.value;
  return e.type === "boolean" ? QI(r, e.defaultValue) : XI(r, e.defaultValue);
}, FG = (e, n) => e.map((r) => ({
  key: r.key,
  value: IG(r, n)
})), EG = (e, n) => e.map(({ key: r, type: i, defaultValue: a }) => ({
  key: r,
  value: FI({
    key: r,
    configuration: n,
    settingType: i,
    settingDefault: a
  })
})), $G = ({ fieldDefinitions: e, settingsConfiguration: n }, r) => e ? FG(
  e.filter(({ secret: i }) => !i),
  r
) : EG(
  (n ?? []).filter(({ secret: i }) => !i),
  r
), TG = (e) => {
  const n = zg();
  return e.map(
    ({
      id: r,
      type: i,
      name: a,
      settings: o,
      misconfigured: s,
      renderConditions: l,
      integrationKey: u
    }) => {
      const d = n[i];
      return {
        id: r,
        type: i,
        name: a,
        settings: $G(d, o),
        misconfigured: s,
        renderConditions: l,
        icon: d.icon,
        iconColors: d.iconColors,
        widget: d.widget,
        integrationKey: u
      };
    }
  );
}, I8 = ({
  widgets: e,
  configuration: n,
  conversationContext: r,
  showNotification: i,
  onToggleFn: a,
  isOpenFn: o,
  isMinimized: s,
  renderVisibilityToggleElement: l,
  renderDragElement: u,
  renderConditionMatchedIndicator: p,
  widgetAnnotations: d
}) => {
  const f = Ei(
    {}
  ), h = (w) => (f.current[w] || (f.current[w] = { current: null }), f.current[w]), { track: v } = In(), C = Xn(
    () => TG(e),
    [e]
  ), j = {
    headline: "",
    text: "",
    onConfirm: () => I(),
    confirmLabel: "Confirm",
    confirmVariant: "primary"
  }, [N, x] = ue(j), [g, P] = ue(!1), E = (w) => {
    P(!0), x(w);
  }, I = () => {
    P(!1), x(j);
  };
  return /* @__PURE__ */ Ke.jsxs(Ke.Fragment, { children: [
    C.map(
      ({
        id: w,
        name: A,
        type: H,
        widget: Y,
        settings: ne,
        misconfigured: W,
        renderConditions: B,
        icon: D,
        iconColors: M,
        integrationKey: Z
      }, je) => {
        const ge = `partner-integration-${H}`, ye = d?.get(w) === !1, ke = /* @__PURE__ */ Ke.jsx(dy, { icon: D, color: M }), q = ne?.reduce(
          (_e, De) => (_e[De.key] = De.value, _e),
          {}
        );
        return s ? /* @__PURE__ */ Ke.jsx("div", { className: "icon-holder", children: ke }, `partner-icon-${w}`) : /* @__PURE__ */ Ke.jsxs(
          pr,
          {
            onToggle: () => {
              v(
                o(Z) ? "widget:collapse:closed" : "widget:collapse:opened",
                {
                  widgetId: w,
                  widgetType: H.toLowerCase()
                }
              ), a(Z);
            },
            isOpen: o(Z),
            className: ge,
            containerRef: (_e) => {
              h(Z).current = _e;
            },
            children: [
              /* @__PURE__ */ Ke.jsx(
                pr.Header,
                {
                  className: ut({
                    [vT.unmatchedHeader]: ye
                  }),
                  wrap: "normal",
                  avatar: ke,
                  slotBeforeTitle: u?.(
                    Z,
                    je,
                    h(Z)
                  ),
                  slotAfterTitle: /* @__PURE__ */ Ke.jsx(Ke.Fragment, { children: l?.(Z) }),
                  children: /* @__PURE__ */ Ke.jsxs(b, { alignItems: "center", flexDirection: "row", gap: "200", children: [
                    A,
                    p?.(
                      B ?? [],
                      w
                    )
                  ] })
                }
              ),
              /* @__PURE__ */ Ke.jsx(pr.Content, { children: W ? /* @__PURE__ */ Ke.jsx(Tn, { isMisconfigured: !0 }) : /* @__PURE__ */ Ke.jsx(
                pw.Provider,
                {
                  value: {
                    onError: (_e, De) => console.warn(
                      `Something went wrong with a partner widget of type '${H}' and id '${w}'`,
                      _e,
                      De
                    )
                  },
                  children: /* @__PURE__ */ Ke.jsx(
                    Yw,
                    {
                      integrationId: w,
                      type: H,
                      configuration: n,
                      showNotification: i,
                      showModal: E,
                      children: sF(Y, {
                        conversationContext: r,
                        settings: q
                      })
                    }
                  )
                }
              ) })
            ]
          },
          Z
        );
      }
    ),
    /* @__PURE__ */ Ke.jsx(
      cw,
      {
        isOpen: g,
        setIsOpen: P,
        headline: N.headline,
        text: N.text,
        confirmLabel: N.confirmLabel,
        confirmVariant: N.confirmVariant,
        cancelLabel: N.cancelLabel,
        cancelVariant: N.cancelVariant,
        onConfirm: N.onConfirm ? () => {
          try {
            N.onConfirm && N.onConfirm();
          } finally {
            P(!1), x(j);
          }
        } : void 0,
        onCancel: N.onCancel ? () => {
          try {
            N.onCancel && N.onCancel();
          } finally {
            P(!1), x(j);
          }
        } : void 0,
        children: N.children
      }
    )
  ] });
}, OG = _l`
  query getWidgetConfigurations {
    Management {
      widgetConfigurations {
        id
        type
        enabled
        name
        misconfigured
        renderConditions
        settings {
          key
          value
        }
      }
    }
  }
`;
function F8(e, { skip: n = !1 } = {}) {
  const [r, i] = ue([]), [a, o] = ue(!1);
  return Je(() => {
    if (n) {
      o(!1);
      return;
    }
    let s = !1;
    return o(!0), Gw(e).query({
      query: OG
    }).then(({ data: l }) => {
      s || (i(
        (l?.Management?.widgetConfigurations ?? []).filter(
          (u) => u != null
        ).map((u) => ({
          ...u,
          integrationKey: `partner-integration-${u.id}`
        }))
      ), o(!1));
    }).catch(() => {
      s || o(!1);
    }), () => {
      s = !0;
    };
  }, [e, n]), {
    isLoading: a,
    widgets: r
  };
}
const DG = ({
  widgetConfiguration: e
}) => {
  const n = Xn(() => (e?.additionalProperties ?? {}).isUsingOAuth ?? !1, [e]), r = Xn(() => (e?.additionalProperties ?? {}).tokenSource === "marketplace_app", [e]);
  return {
    hasShopifyWidgetOAuth: n,
    isShopifyMarketplaceApp: r,
    initialValuesForShopify: []
  };
}, PG = "FULL_ACCESS", RG = "2", AG = ({
  type: e,
  baseUrl: n
}) => {
  const r = `${e}-partner-widget-${Date.now().toString()}`, i = n.replace("partner-integrations", "api"), a = () => {
    let l;
    try {
      l = JSON.parse(localStorage.authData);
    } catch {
    }
    return l?.access_token || "";
  };
  return {
    deleteDixaApiToken: (l) => fetch(`${i}/v1/auth/api-tokens/${l}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      }
    }).then((u) => u.json()),
    createDixaApiToken: () => fetch(`${i}/v1/auth/api-tokens-v2`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      },
      body: JSON.stringify({
        name: r,
        scopes: [PG],
        version: RG
      })
    }).then((l) => l.json())
  };
}, LG = "dixaApiToken", Ug = "dixaApiTokenId", EI = "dixaApiTokenName", ew = (e) => [Ug, EI].every(
  (r) => e.find((i) => i?.key === r)
);
function VG({
  token: e,
  settings: n
}) {
  if (n.length === 0)
    return [];
  const r = zG(e), i = (o, s) => o?.find((l) => l?.key === s);
  return n.map((o) => {
    const s = o && i(r, o.key);
    return i(n, o?.key) && s ? s : o;
  });
}
const zG = (e) => [
  {
    key: LG,
    value: e.value,
    secret: !0
  },
  {
    key: Ug,
    value: e.id,
    secret: !1
  },
  {
    key: EI,
    value: e.name,
    secret: !1
  }
], UG = "_wrapper_1lmim_1", MG = "_wrapperBox_1lmim_4", BG = "_wrapperBoxErrorBorder_1lmim_9", gh = {
  wrapper: UG,
  wrapperBox: MG,
  wrapperBoxErrorBorder: BG
}, qG = ({
  required: e,
  readOnly: n,
  isSecret: r,
  isCreationMode: i,
  label: a,
  settings: o,
  widgetSettingsKey: s,
  meta: l,
  handleEditSecret: u,
  handleChangeText: p
}) => {
  const f = o?.find(
    (P) => P.type === "basicAuthInput"
  )?.additionalProperties, { username: h, password: v } = f, C = `Insert your ${h.label.toLowerCase()}`, j = `Insert your ${v.label.toLowerCase()}`, [N, x] = ue({
    username: "",
    password: ""
  }), g = ft(
    (P) => {
      p({
        target: {
          name: s,
          value: P
        }
      });
    },
    [s, p]
  );
  return Je(() => {
    g(
      N.username !== "" && N.password !== "" ? window.btoa(`${N.username}:${N.password}`) : ""
    );
  }, [N]), /* @__PURE__ */ Ke.jsx(
    We,
    {
      required: e,
      label: a,
      meta: l,
      className: gh.wrapper,
      children: /* @__PURE__ */ Ke.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          className: ut(gh.wrapperBox, {
            [gh.wrapperBoxErrorBorder]: !!l?.error
          }),
          children: [
            /* @__PURE__ */ Ke.jsx(
              tr,
              {
                noAlert: !0,
                required: e,
                label: h.label,
                readOnly: n,
                placeholder: C,
                input: {
                  name: s,
                  value: N.username,
                  onChange: (P) => x({
                    username: P?.target.value ?? "",
                    password: N.password
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => u(!1, s)
                    }
                  }
                }
              }
            ),
            /* @__PURE__ */ Ke.jsx(
              tr,
              {
                noAlert: !0,
                required: e,
                label: v.label,
                readOnly: n,
                placeholder: j,
                input: {
                  name: s,
                  value: N.password,
                  onChange: (P) => x({
                    username: N.username,
                    password: P?.target.value ?? ""
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => u(!1, s)
                    }
                  }
                }
              }
            )
          ]
        }
      )
    }
  );
};
function nw({
  isSecret: e,
  widgetSettingsKey: n,
  label: r,
  required: i,
  readOnly: a,
  placeholder: o,
  handleChangeText: s,
  handleChangeBoolean: l,
  handleChangeSelect: u,
  handleEditSecret: p,
  getValueByKey: d,
  isEditingField: f,
  errors: h,
  type: v,
  isCreationMode: C,
  prefix: j,
  integrationId: N,
  integrationType: x,
  configuration: g,
  settings: P,
  otherProps: E
}) {
  const I = v === "custom" && E?.component, w = d(n)?.value;
  return I ? /* @__PURE__ */ Ke.jsx(
    I,
    {
      configuration: g,
      integrationId: N,
      integrationType: x,
      label: r,
      settings: P,
      getValueByKey: d,
      widgetSettingsKey: n,
      handleChangeSelect: u,
      handleChangeText: s,
      handleChangeBoolean: l
    }
  ) : /* @__PURE__ */ Ke.jsxs(Ke.Fragment, { children: [
    /* @__PURE__ */ Ke.jsx(ie, { span: 3, children: /* @__PURE__ */ Ke.jsx(
      HG,
      {
        widgetSettingsKey: n,
        label: r,
        isEditingField: f,
        handleEditSecret: p,
        isCreationMode: C,
        children: v === "input" ? /* @__PURE__ */ Ke.jsx(
          tr,
          {
            required: i,
            readOnly: a,
            label: r,
            placeholder: o,
            input: {
              name: n,
              value: w,
              onChange: s
            },
            meta: { error: h[n] },
            prefix: j,
            ...e && !C && {
              prefix: {
                type: "button",
                button: {
                  icon: "close",
                  onClick: () => p(!1, n)
                }
              }
            }
          }
        ) : v === "basicAuthInput" ? /* @__PURE__ */ Ke.jsx(
          qG,
          {
            required: i,
            readOnly: a,
            isSecret: e,
            isCreationMode: C,
            label: r,
            widgetSettingsKey: n,
            settings: P,
            meta: { error: h[n] },
            handleEditSecret: p,
            handleChangeText: s
          }
        ) : v === "switch" ? /* @__PURE__ */ Ke.jsx(We, { label: r, children: /* @__PURE__ */ Ke.jsx(
          xl,
          {
            input: {
              name: n,
              value: "",
              checked: w,
              onChange: l
            }
          }
        ) }) : v === "select" ? /* @__PURE__ */ Ke.jsx(We, { label: r, children: /* @__PURE__ */ Ke.jsx(
          ei,
          {
            required: i,
            clearable: !0,
            placeholder: o,
            readOnly: a,
            onChange: (A) => u(n, A),
            getItemTitleByValue: (A) => A ? /* @__PURE__ */ Ke.jsx(O.Paragraph, { children: A.label }) : /* @__PURE__ */ Ke.jsx(Ke.Fragment, {}),
            value: w ? [
              {
                label: (E?.selectItems || []).find(
                  (A) => A.value === w
                )?.label,
                value: w
              }
            ] : [],
            equalityFn: (A, H) => A.value === H.value,
            children: (E?.selectItems || []).map((A) => /* @__PURE__ */ Ke.jsx(pt.Item, { value: A, children: A.label }, A.value))
          }
        ) }) : /* @__PURE__ */ Ke.jsx(Ke.Fragment, {})
      }
    ) }),
    /* @__PURE__ */ Ke.jsx(ie, { span: 3 })
  ] });
}
function HG({
  widgetSettingsKey: e,
  label: n,
  isEditingField: r,
  handleEditSecret: i,
  children: a,
  isCreationMode: o
}) {
  return r || o ? a : /* @__PURE__ */ Ke.jsx(We, { label: n, children: /* @__PURE__ */ Ke.jsxs(
    et,
    {
      "data-testid": `secret-field-button-${e}`,
      variant: "secondary",
      icon: "pen",
      onClick: () => i(!0, e),
      children: [
        "Update ",
        n
      ]
    }
  ) });
}
const Io = "partner-integrations-widget-name-form-field", tw = ({
  settingsFromBackend: e,
  settingsConfiguration: n,
  creating: r = !1
}) => n.filter(({ type: i }) => i !== "custom").map(
  ({
    key: i,
    required: a,
    secret: o,
    type: s,
    defaultValue: l,
    customValidation: u
  }) => ({
    key: i,
    value: FI({
      key: i,
      configuration: e,
      settingType: s,
      settingDefault: l
    }),
    required: a,
    secret: o,
    // The property `isEditing` is used in order to show/hide the input field in
    // case it is a secret setting. However, when we create a widget we _always_
    // want to show the input field because it will be the first time that the user
    // enters a value for it.
    //
    // We have two scenarios here:
    // 1) When initializing
    //   - the setting is secret=true so we set isEditing=false and hide the input.
    //   - the setting is secret=false, so we set isEditing=true and show the input.
    // 2) We create a widget (creating=true), so we set isEditing=true in
    //    order to show the input.
    isEditing: r ? !0 : !o,
    type: s,
    ...u && { customValidation: u }
  })
), WG = ({
  initialValues: e,
  onSubmit: n
}) => {
  const [r, i] = ue(
    e || {
      enabled: !1,
      name: "",
      settings: []
    }
  ), [a, o] = ue({}), s = (E) => i(E), l = (E) => !E || E === "", u = (E) => {
    const { [E]: I, ...w } = a;
    o(w);
  }, p = (E) => ({
    ...E,
    settings: E.settings.filter(({ isEditing: I }) => I).map(({ key: I, value: w, secret: A }) => ({
      key: I,
      value: w,
      secret: A
    }))
  }), d = {
    input: "This can not be empty",
    basicAuthInput: "Please insert a value for both fields"
  }, f = (E) => {
    if (!E)
      return;
    const {
      target: { name: I, value: w }
    } = E;
    a[I] && !l(w) && u(I), i({
      ...r,
      settings: r.settings.map(
        (A) => A.key === I ? { ...A, value: w } : A
      )
    });
  }, h = (E) => {
    if (!E)
      return;
    const {
      target: { name: I, checked: w }
    } = E;
    i({
      ...r,
      settings: r.settings.map(
        (A) => A.key === I ? { ...A, value: w } : A
      )
    });
  }, v = (E, I) => {
    if (!I)
      return;
    const { selectedValues: w } = I, A = w?.[0];
    if (A) {
      const H = r.settings.map(
        (Y) => Y.key === E ? { ...Y, value: A?.value } : Y
      );
      i({
        ...r,
        settings: H
      });
    } else {
      const H = r.settings.filter(
        (Y) => Y.key !== E
      );
      i({
        ...r,
        settings: H
      });
    }
  }, C = (E) => {
    i({
      ...r,
      enabled: E
    });
  }, j = (E) => {
    if (!E)
      return;
    const {
      target: { value: I }
    } = E;
    a[Io] && !l(I) && u(Io), i({
      ...r,
      name: I
    });
  }, N = (E, I) => {
    const { settings: w } = r, A = w.map((H) => H.key === I ? {
      ...H,
      isEditing: E,
      ...!E && { value: "" }
    } : H);
    a[I] && !E && u(I), i({
      ...r,
      settings: A
    });
  }, x = (E) => r.settings.find(
    (I) => I.key === E
  ), g = async (E) => {
    E.preventDefault(), P() && n(p(r));
  }, P = () => {
    const E = {}, { name: I, settings: w } = r;
    return l(I) && (E[Io] = d.input), w.forEach(
      ({ key: A, value: H, required: Y, isEditing: ne, type: W, customValidation: B }) => {
        if (Y && ne)
          if (B) {
            const D = B(H);
            typeof D == "string" && (E[A] = D);
          } else
            typeof H == "string" && l(H) && (E[A] = d[W]);
      }
    ), o(E), !Object.keys(E)?.length;
  };
  return {
    formData: r,
    errors: a,
    handleIsEnabled: C,
    handleChangeText: f,
    handleChangeBoolean: h,
    handleChangeSelect: v,
    handleEditSecret: N,
    handleChangeName: j,
    handleSubmit: g,
    getSettingValueByKey: x,
    initializeFormData: s,
    validate: P
  };
}, KG = [
  "GITHUB",
  "JIRA",
  "LINEAR"
], rw = "The configuration of the integration is not correct. Please check the settings.", GG = (e) => {
  const n = zg()[e.type]?.WidgetSettings;
  return n ? /* @__PURE__ */ Ke.jsx(n, { ...e }) : /* @__PURE__ */ Ke.jsx(YG, { ...e });
}, YG = ({
  integrationId: e,
  type: n,
  handleRedirect: r,
  showNotification: i,
  configuration: a,
  automationCouplingState: o,
  renderConditionsEditor: s
}) => {
  const { track: l } = In(), { deleteDixaApiToken: u, createDixaApiToken: p } = AG({
    type: n,
    baseUrl: a.baseUrl
  }), f = NF().pathname.match(
    /^\/settings\/integrations\/partner-widget\/[a-zA-Z0-9]*\/create$/
  ), h = !e && !!n && !!f, v = KG.includes(n), [C, j] = ue(), [N, x] = ue(!1), [g, P] = ue(!1), [E, I] = ue(!1), [w, A] = ue(null), [H, Y] = ue(), [ne, W] = ue(h ? [] : null);
  Je(() => {
    W(h ? [] : null);
  }, [e, h]), Je(() => {
    H && ne === null && W(H.renderConditions ?? []);
  }, [H, ne]);
  const { isInboundOAuth: B } = ZI(), D = B && h ? "Submit & Authorize" : "Submit", {
    hasShopifyWidgetOAuth: M,
    isShopifyMarketplaceApp: Z,
    initialValuesForShopify: je
  } = DG({
    featureFlags: a.featureFlags,
    widgetConfiguration: H
  }), ge = n === "YOTPO" && !!H?.additionalProperties?.isUsingOAuth, ye = n === "KLAVIYO" && !!H?.additionalProperties?.isUsingOAuth, ke = h && n === "SHOPIFY", De = zg({
    SHOPIFY: {
      hasShopifyOAuth: M,
      isShopifyMarketplaceApp: Z,
      isCreationMode: h
    },
    YOTPO: {
      hasOAuth: ge,
      isCreationMode: h
    },
    KLAVIYO: {
      hasOAuth: ye,
      isCreationMode: h
    }
  })[n].settingsConfiguration ?? [], G = De.filter(({ type: X }) => X !== "hidden").filter(({ hideOnCreate: X }) => h ? !X : !0), Ye = G.filter(
    ({ additionalProperties: X }) => X?.renderAboveForm === !0
  ), sn = G.filter(
    ({ additionalProperties: X }) => X?.renderAboveForm !== !0
  ), {
    error: Ie,
    loading: Ue,
    refetch: Pe
  } = xF(eF, {
    variables: {
      id: e
    },
    // skip wants either `true` to literally skip the query,
    // or `undefined` to run the query. A simple `false` will
    // still run the query, therefore checking here for the
    // negated `integrationId` instead.
    skip: !e,
    onCompleted: (X) => {
      if (Object.keys(X).length === 0)
        I(!0);
      else {
        I(!1);
        const ae = X?.Management?.widgetConfigurations?.[0];
        ae && Y({
          ...ae,
          // Not needed here, just to satisfy the type
          integrationKey: `partner-integration-${ae.id}`,
          additionalProperties: ae.additionalProperties ?? void 0
        });
      }
    }
  }), [Be, { error: Le }] = Yg(
    h ? nF : tF,
    {
      onError: (X) => {
        j(X), x(!1), i({
          title: "Something went wrong",
          text: `The ${h ? "creation" : "update"} of the widget was not successful.`,
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (X) => {
        if (x(!1), Object.keys(X).length !== 0) {
          if (h && r(
            X.Management?.createWidgetConfiguration?.id
          ), !h) {
            const V = X.Management?.updateWidgetConfiguration;
            V?.misconfigured ? A(
              V.misconfigurationCause ?? rw
            ) : A(null);
          }
          if ((h || s) && ne) {
            const ae = (H?.renderConditions?.length ?? 0) > 0;
            rF(
              l,
              h,
              ne,
              ae
            );
          }
          i({
            title: `${h ? "Creating" : "Updating"} was successful`,
            text: `${h ? "Creating" : "Updating"} the widget was successful.`,
            icon: "check-circle-filled",
            severity: "success"
          });
        } else
          i({
            title: "Something went wrong",
            text: `The ${h ? "creation" : "update"} of the widget was not successful.`,
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
      }
    }
  ), [Xe] = Yg(iF, {
    onError: (X) => {
      j(X), x(!1), i({
        title: "Something went wrong",
        text: "The deletion of the widget was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: () => {
      x(!1), r(), i({
        title: "Deletion was successful",
        text: "The deletion of the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), {
    formData: Fe,
    handleIsEnabled: Me,
    errors: nn,
    handleChangeText: se,
    handleChangeBoolean: le,
    handleChangeSelect: Se,
    handleEditSecret: Ae,
    handleChangeName: Re,
    handleSubmit: yn,
    getSettingValueByKey: Q,
    initializeFormData: $
  } = WG({
    onSubmit: async (X) => {
      h ? l("settings:create:submitted", { widgetType: n }) : e && l("settings:view:change:submitted", {
        widgetId: e,
        widgetType: n
      }), x(!0);
      const ae = X.settings.map(
        (xe) => typeof xe.value == "boolean" ? { ...xe, value: xe.value.toString() } : xe
      ), V = ew(ae) && h;
      let J = [];
      if (V) {
        const xe = await p().catch(
          ($e) => {
            x(!1), console.warn("API-Token (creation) error resonse", $e), i({
              title: "Something went wrong",
              text: "The creation of the API-Token was not successful and therefore the widget creation was aborted. Please try again later.",
              icon: "exclamation-triangle-filled",
              severity: "warning"
            });
          }
        );
        xe?.data && (J = VG({
          token: xe.data,
          settings: ae
        }));
      }
      const de = {
        ...X,
        settings: [
          ...J.length > 0 ? J : ae
        ]
      };
      (V && J.length > 1 || !V && J.length === 0) && (Be({
        variables: {
          ...!h && { id: e },
          ...h && { type: n },
          ...de,
          ...(h || !!s) && ne !== null && { renderConditions: ne }
        }
      }), ae.forEach(
        ($e) => $e.secret && Ae(!1, $e.key)
      ));
    },
    ...h && {
      initialValues: {
        enabled: !1,
        name: "",
        settings: tw({
          settingsFromBackend: je,
          settingsConfiguration: De,
          creating: !0
        })
      }
    }
  });
  Je(() => {
    if (H) {
      const X = tw({
        settingsFromBackend: H.settings,
        settingsConfiguration: De
      });
      $({
        enabled: !!H.enabled,
        name: H.name,
        settings: X
      }), H.misconfigured ? A(
        H?.misconfigurationCause ?? rw
      ) : A(null);
    }
  }, [H]);
  const z = Xn(() => o ? !o.isCoupled : !0, [o]);
  return Ie || Le || C ? /* @__PURE__ */ Ke.jsx(
    Tn,
    {
      error: Ie || C,
      retry: Ie ? Pe : void 0
    }
  ) : N || Ue ? /* @__PURE__ */ Ke.jsx(hn, { "data-testid": "widget-settings-loading" }) : E ? /* @__PURE__ */ Ke.jsxs(O.Paragraph, { children: [
    "A widget with the id ",
    /* @__PURE__ */ Ke.jsx(Yn, { children: e }),
    " does not exist."
  ] }) : /* @__PURE__ */ Ke.jsxs("form", { children: [
    w && /* @__PURE__ */ Ke.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ Ke.jsx(
      bl,
      {
        variant: "fail",
        headline: "This integration is misconfigured",
        description: /* @__PURE__ */ Ke.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ Ke.jsx(O.Paragraph, { children: w }),
          /* @__PURE__ */ Ke.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ Ke.jsx(O.Heading, { variant: "heading-3", children: "Additional information" }),
            /* @__PURE__ */ Ke.jsx(O.Paragraph, { children: "While the integration is in a misconfigured state, its content is not shown in the sidebar. Instead, we show a message that hints the agent to get in touch with the administrator." })
          ] })
        ] })
      }
    ) }),
    /* @__PURE__ */ Ke.jsxs(
      tt,
      {
        "data-testid": `widget-settings-form-${e ?? "create-new"}`,
        children: [
          Ye.map(
            ({ key: X, label: ae, ...V }) => /* @__PURE__ */ Ke.jsx(
              nw,
              {
                widgetSettingsKey: X,
                isEditingField: !1,
                handleEditSecret: () => {
                },
                handleChangeText: () => {
                },
                handleChangeBoolean: () => {
                },
                handleChangeSelect: () => {
                },
                getValueByKey: Q,
                isSecret: !1,
                label: ae,
                placeholder: "",
                required: !1,
                errors: nn,
                type: "custom",
                isCreationMode: h,
                integrationId: e,
                integrationType: n,
                configuration: a,
                settings: De,
                otherProps: V
              },
              X
            )
          ),
          !ke && /* @__PURE__ */ Ke.jsxs(Ke.Fragment, { children: [
            /* @__PURE__ */ Ke.jsx(ie, { children: /* @__PURE__ */ Ke.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Ke.jsx(
              xl,
              {
                input: {
                  name: "enabled",
                  checked: Fe.enabled,
                  value: "dummy",
                  onChange: (X) => Me(X.target.checked)
                }
              }
            ) }) }),
            /* @__PURE__ */ Ke.jsx(ie, { span: 3, children: /* @__PURE__ */ Ke.jsx(
              tr,
              {
                required: !0,
                label: "Widget name",
                placeholder: "Insert the name of the widget",
                input: {
                  name: Io,
                  value: Fe.name,
                  onChange: Re
                },
                meta: {
                  error: nn[Io]
                }
              }
            ) }),
            /* @__PURE__ */ Ke.jsx(ie, { span: 3 })
          ] }),
          !ke && s && ne !== null && /* @__PURE__ */ Ke.jsx(ie, { children: s({
            value: ne,
            onChange: W,
            configurationKey: H?.id
          }) }),
          sn?.map(
            ({
              key: X,
              secret: ae,
              label: V,
              placeholder: J = "",
              required: de = !1,
              type: xe,
              prefix: $e,
              readOnly: tn,
              ...gn
            }) => {
              const { settings: on } = Fe, pn = on.find(
                (Fn) => Fn.key === X
              );
              return /* @__PURE__ */ Ke.jsx(lF, { children: /* @__PURE__ */ Ke.jsx(
                nw,
                {
                  widgetSettingsKey: X,
                  isEditingField: !!pn?.isEditing,
                  handleEditSecret: Ae,
                  handleChangeText: se,
                  handleChangeBoolean: le,
                  handleChangeSelect: Se,
                  getValueByKey: Q,
                  isSecret: ae,
                  label: V,
                  placeholder: J,
                  required: de,
                  errors: nn,
                  type: xe,
                  isCreationMode: h,
                  prefix: $e,
                  integrationId: e,
                  integrationType: n,
                  configuration: a,
                  readOnly: tn,
                  settings: De,
                  otherProps: gn
                }
              ) }, X);
            }
          )
        ]
      }
    ),
    !ke && /* @__PURE__ */ Ke.jsxs(b, { margin: "300 0 0 0", children: [
      /* @__PURE__ */ Ke.jsx(et, { onClick: yn, children: D }),
      !h && /* @__PURE__ */ Ke.jsx(
        Ze,
        {
          content: "The widget is used in automations",
          disabled: z,
          children: /* @__PURE__ */ Ke.jsx(
            et,
            {
              style: { marginLeft: 20 },
              icon: "trash",
              variant: "secondary",
              onClick: () => {
                e && l("settings:view:delete:requested", {
                  widgetId: e,
                  widgetType: n
                }), P(!0);
              },
              disabled: !z,
              isLoading: o?.isLoading,
              children: "Delete"
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ Ke.jsx(
      cw,
      {
        isOpen: g,
        setIsOpen: P,
        confirmVariant: v ? "danger" : "primary",
        confirmLabel: "Yes",
        cancelLabel: "No",
        onCancel: () => {
          e && l("settings:view:delete:canceled", {
            widgetId: e,
            widgetType: n
          });
        },
        onConfirm: () => {
          if (e && l("settings:view:delete:confirmed", {
            widgetId: e,
            widgetType: n
          }), ew(Fe.settings)) {
            const X = Fe.settings.find(
              ({ key: ae }) => ae === Ug
            )?.value;
            X && u(X).catch((ae) => {
              console.warn("API-Token (deletion) error response", ae), i({
                title: "Something went wrong",
                text: "The deletion of the API-Token was not successful. Please have a look in Settings > Integrations > Api-Tokens to find your token and remove it manually.",
                icon: "exclamation-triangle-filled",
                severity: "warning"
              });
            });
          }
          Xe({
            variables: {
              id: e
            }
          });
        },
        children: /* @__PURE__ */ Ke.jsx(b, { children: v ? /* @__PURE__ */ Ke.jsxs(b, { gap: "400", children: [
          /* @__PURE__ */ Ke.jsx(
            he,
            {
              size: 24,
              name: "exclamation-triangle-filled",
              color: "red.500"
            }
          ),
          /* @__PURE__ */ Ke.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ Ke.jsxs(O.Heading, { withMarginBottom: !0, children: [
              "By deleting the ",
              n,
              " integration, all links between Dixa and ",
              n,
              " are also deleted."
            ] }),
            /* @__PURE__ */ Ke.jsxs(O.Paragraph, { children: [
              "All data in ",
              n,
              " stays untouched."
            ] }),
            /* @__PURE__ */ Ke.jsxs(O.Paragraph, { children: [
              "Are you sure you want to delete the ",
              n,
              " ",
              'integration "',
              Fe.name,
              '"?'
            ] })
          ] })
        ] }) : /* @__PURE__ */ Ke.jsxs(Ke.Fragment, { children: [
          "Are you sure you want to delete the ",
          n,
          ' integration "',
          Fe.name,
          '"?'
        ] }) })
      }
    )
  ] });
}, E8 = ({
  configuration: e,
  integrationId: n,
  type: r,
  handleRedirect: i,
  showNotification: a,
  automationCouplingState: o,
  renderConditionsEditor: s
}) => /* @__PURE__ */ Ke.jsx(
  pw.Provider,
  {
    value: {
      onError: (l, u) => console.warn(
        `Something went wrong with the partner widget settings of type ${r} and id ${n}`,
        l,
        u
      )
    },
    children: /* @__PURE__ */ Ke.jsx(
      Yw,
      {
        integrationId: n,
        type: r,
        configuration: e,
        showNotification: a,
        children: /* @__PURE__ */ Ke.jsx(
          GG,
          {
            configuration: e,
            integrationId: n,
            type: r,
            handleRedirect: i,
            showNotification: a,
            automationCouplingState: o,
            renderConditionsEditor: s
          }
        )
      }
    )
  }
), iw = "__PairingContext__", $I = globalThis[iw] ?? (() => {
  const e = dw({});
  return globalThis[iw] = e, e;
})(), $8 = () => cy($I), T8 = ({
  value: e,
  children: n
}) => /* @__PURE__ */ Ke.jsx($I.Provider, { value: e, children: n });
var Es = { exports: {} }, aw;
function JG() {
  if (aw) return Es.exports;
  aw = 1;
  var e = typeof Reflect == "object" ? Reflect : null, n = e && typeof e.apply == "function" ? e.apply : function(I, w, A) {
    return Function.prototype.apply.call(I, w, A);
  }, r;
  e && typeof e.ownKeys == "function" ? r = e.ownKeys : Object.getOwnPropertySymbols ? r = function(I) {
    return Object.getOwnPropertyNames(I).concat(Object.getOwnPropertySymbols(I));
  } : r = function(I) {
    return Object.getOwnPropertyNames(I);
  };
  function i(E) {
    console && console.warn && console.warn(E);
  }
  var a = Number.isNaN || function(I) {
    return I !== I;
  };
  function o() {
    o.init.call(this);
  }
  Es.exports = o, Es.exports.once = x, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._eventsCount = 0, o.prototype._maxListeners = void 0;
  var s = 10;
  function l(E) {
    if (typeof E != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof E);
  }
  Object.defineProperty(o, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return s;
    },
    set: function(E) {
      if (typeof E != "number" || E < 0 || a(E))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + E + ".");
      s = E;
    }
  }), o.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, o.prototype.setMaxListeners = function(I) {
    if (typeof I != "number" || I < 0 || a(I))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + I + ".");
    return this._maxListeners = I, this;
  };
  function u(E) {
    return E._maxListeners === void 0 ? o.defaultMaxListeners : E._maxListeners;
  }
  o.prototype.getMaxListeners = function() {
    return u(this);
  }, o.prototype.emit = function(I) {
    for (var w = [], A = 1; A < arguments.length; A++) w.push(arguments[A]);
    var H = I === "error", Y = this._events;
    if (Y !== void 0)
      H = H && Y.error === void 0;
    else if (!H)
      return !1;
    if (H) {
      var ne;
      if (w.length > 0 && (ne = w[0]), ne instanceof Error)
        throw ne;
      var W = new Error("Unhandled error." + (ne ? " (" + ne.message + ")" : ""));
      throw W.context = ne, W;
    }
    var B = Y[I];
    if (B === void 0)
      return !1;
    if (typeof B == "function")
      n(B, this, w);
    else
      for (var D = B.length, M = C(B, D), A = 0; A < D; ++A)
        n(M[A], this, w);
    return !0;
  };
  function p(E, I, w, A) {
    var H, Y, ne;
    if (l(w), Y = E._events, Y === void 0 ? (Y = E._events = /* @__PURE__ */ Object.create(null), E._eventsCount = 0) : (Y.newListener !== void 0 && (E.emit(
      "newListener",
      I,
      w.listener ? w.listener : w
    ), Y = E._events), ne = Y[I]), ne === void 0)
      ne = Y[I] = w, ++E._eventsCount;
    else if (typeof ne == "function" ? ne = Y[I] = A ? [w, ne] : [ne, w] : A ? ne.unshift(w) : ne.push(w), H = u(E), H > 0 && ne.length > H && !ne.warned) {
      ne.warned = !0;
      var W = new Error("Possible EventEmitter memory leak detected. " + ne.length + " " + String(I) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      W.name = "MaxListenersExceededWarning", W.emitter = E, W.type = I, W.count = ne.length, i(W);
    }
    return E;
  }
  o.prototype.addListener = function(I, w) {
    return p(this, I, w, !1);
  }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(I, w) {
    return p(this, I, w, !0);
  };
  function d() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function f(E, I, w) {
    var A = { fired: !1, wrapFn: void 0, target: E, type: I, listener: w }, H = d.bind(A);
    return H.listener = w, A.wrapFn = H, H;
  }
  o.prototype.once = function(I, w) {
    return l(w), this.on(I, f(this, I, w)), this;
  }, o.prototype.prependOnceListener = function(I, w) {
    return l(w), this.prependListener(I, f(this, I, w)), this;
  }, o.prototype.removeListener = function(I, w) {
    var A, H, Y, ne, W;
    if (l(w), H = this._events, H === void 0)
      return this;
    if (A = H[I], A === void 0)
      return this;
    if (A === w || A.listener === w)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete H[I], H.removeListener && this.emit("removeListener", I, A.listener || w));
    else if (typeof A != "function") {
      for (Y = -1, ne = A.length - 1; ne >= 0; ne--)
        if (A[ne] === w || A[ne].listener === w) {
          W = A[ne].listener, Y = ne;
          break;
        }
      if (Y < 0)
        return this;
      Y === 0 ? A.shift() : j(A, Y), A.length === 1 && (H[I] = A[0]), H.removeListener !== void 0 && this.emit("removeListener", I, W || w);
    }
    return this;
  }, o.prototype.off = o.prototype.removeListener, o.prototype.removeAllListeners = function(I) {
    var w, A, H;
    if (A = this._events, A === void 0)
      return this;
    if (A.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : A[I] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete A[I]), this;
    if (arguments.length === 0) {
      var Y = Object.keys(A), ne;
      for (H = 0; H < Y.length; ++H)
        ne = Y[H], ne !== "removeListener" && this.removeAllListeners(ne);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (w = A[I], typeof w == "function")
      this.removeListener(I, w);
    else if (w !== void 0)
      for (H = w.length - 1; H >= 0; H--)
        this.removeListener(I, w[H]);
    return this;
  };
  function h(E, I, w) {
    var A = E._events;
    if (A === void 0)
      return [];
    var H = A[I];
    return H === void 0 ? [] : typeof H == "function" ? w ? [H.listener || H] : [H] : w ? N(H) : C(H, H.length);
  }
  o.prototype.listeners = function(I) {
    return h(this, I, !0);
  }, o.prototype.rawListeners = function(I) {
    return h(this, I, !1);
  }, o.listenerCount = function(E, I) {
    return typeof E.listenerCount == "function" ? E.listenerCount(I) : v.call(E, I);
  }, o.prototype.listenerCount = v;
  function v(E) {
    var I = this._events;
    if (I !== void 0) {
      var w = I[E];
      if (typeof w == "function")
        return 1;
      if (w !== void 0)
        return w.length;
    }
    return 0;
  }
  o.prototype.eventNames = function() {
    return this._eventsCount > 0 ? r(this._events) : [];
  };
  function C(E, I) {
    for (var w = new Array(I), A = 0; A < I; ++A)
      w[A] = E[A];
    return w;
  }
  function j(E, I) {
    for (; I + 1 < E.length; I++)
      E[I] = E[I + 1];
    E.pop();
  }
  function N(E) {
    for (var I = new Array(E.length), w = 0; w < I.length; ++w)
      I[w] = E[w].listener || E[w];
    return I;
  }
  function x(E, I) {
    return new Promise(function(w, A) {
      function H(ne) {
        E.removeListener(I, Y), A(ne);
      }
      function Y() {
        typeof E.removeListener == "function" && E.removeListener("error", H), w([].slice.call(arguments));
      }
      P(E, I, Y, { once: !0 }), I !== "error" && g(E, H, { once: !0 });
    });
  }
  function g(E, I, w) {
    typeof E.on == "function" && P(E, "error", I, w);
  }
  function P(E, I, w, A) {
    if (typeof E.on == "function")
      A.once ? E.once(I, w) : E.on(I, w);
    else if (typeof E.addEventListener == "function")
      E.addEventListener(I, function H(Y) {
        A.once && E.removeEventListener(I, H), w(Y);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof E);
  }
  return Es.exports;
}
var QG = JG();
function O8() {
  const e = new QG.EventEmitter();
  return e && typeof window < "u" ? window._partner = {
    events: e
  } : console.warn(
    "Initialization of partner-integration events was not successfull."
  ), e;
}
export {
  pT as GraphQLClientProvider,
  $I as PairingContext,
  T8 as PairingProvider,
  I8 as PartnerIntegrations,
  E8 as PartnerIntegrationsSettings,
  zg as getWidgetDefinitions,
  O8 as initializePartnerEventEmitter,
  $8 as usePairing,
  F8 as usePartnerIntegrationWidgetConfigurations,
  DG as useShopifyConfiguration
};
